/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/ 		if(executeModules) {
/******/ 			for(i=0; i < executeModules.length; i++) {
/******/ 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
/******/ 			}
/******/ 		}
/******/ 		return result;
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		88: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + ({"0":"base_polyfills","1":"extra_polyfills","2":"features/compose","3":"modals/onboarding_modal","4":"emoji_picker","5":"features/notifications","6":"features/account_timeline","7":"features/home_timeline","8":"features/public_timeline","9":"features/community_timeline","10":"features/pinned_statuses","11":"features/domain_blocks","12":"features/following","13":"features/followers","14":"features/favourited_statuses","15":"features/list_timeline","16":"features/account_gallery","17":"features/hashtag_timeline","18":"features/direct_timeline","19":"features/status","20":"features/lists","21":"modals/report_modal","22":"features/getting_started","23":"features/follow_requests","24":"features/mutes","25":"features/blocks","26":"features/reblogs","27":"features/favourites","28":"features/keyboard_shortcuts","29":"modals/mute_modal","30":"features/generic_not_found","31":"features/list_editor","32":"modals/embed_modal","33":"status/media_gallery","34":"containers/media_container","35":"share","36":"application","37":"about","38":"locale_zh-TW","39":"locale_zh-HK","40":"locale_zh-CN","41":"locale_uk","42":"locale_tr","43":"locale_th","44":"locale_te","45":"locale_sv","46":"locale_sr","47":"locale_sr-Latn","48":"locale_sl","49":"locale_sk","50":"locale_ru","51":"locale_pt","52":"locale_pt-BR","53":"locale_pl","54":"locale_oc","55":"locale_no","56":"locale_nl","57":"locale_ko","58":"locale_ja","59":"locale_it","60":"locale_io","61":"locale_id","62":"locale_hy","63":"locale_hu","64":"locale_hr","65":"locale_he","66":"locale_gl","67":"locale_fr","68":"locale_fi","69":"locale_fa","70":"locale_eu","71":"locale_es","72":"locale_eo","73":"locale_en","74":"locale_el","75":"locale_de","76":"locale_da","77":"locale_cs","78":"locale_co","79":"locale_ca","80":"locale_bg","81":"locale_ar","82":"mailer","83":"mastodon-light","84":"contrast","85":"default","86":"public","87":"admin"}[chunkId]||chunkId) + "-" + {"0":"1cba6cb19c84a8c6e0b1","1":"fd43ca5bcd7f12061d47","2":"d1207f3c0bd5973636e1","3":"a37d357cf490546d5ad2","4":"12d1a845916e915f2d67","5":"9f8194ee4729a21c6218","6":"88322427d1c091e37006","7":"3c7653fef427f3f5de88","8":"7c7577660e9182bb5ece","9":"8aae3e042bb48eae6eba","10":"54cfb95f055fbd065f1e","11":"c4ed401371fec7d353cd","12":"94c201d384b59549b506","13":"f1a9bc1cd2fea1b6dfc1","14":"6bbea6e531f3c4c1c162","15":"66145752ff619a6ba13b","16":"6981aaeaec6a77458b4e","17":"2da476e54abb11513dec","18":"bd75fcb1d8793615e515","19":"3cfe57c431dfb97e75fd","20":"225ada6aed14b811d8dd","21":"8857224876e5b8fa361a","22":"2487031d88c086e6d3e5","23":"e99ef99f69d8d9a17d7f","24":"0632f3425a0c45038338","25":"38499fbaf703cb5a351d","26":"da75d911e8e086582ca9","27":"b503622ca33cbd378c35","28":"1309a60cf529fee5814d","29":"f2b42a1a004562ae58e4","30":"6e0bd433ebb477c9cd84","31":"fe5b0cb18f3be49f5b8c","32":"dd0777e1f263126ec665","33":"5bc5f8067cd2503e51ed","34":"817b2d797a5301b3762b","35":"5724a0b5d5770c2080ae","36":"5d5a5151cb8d3f9af967","37":"92f990fe8416763cbe3d","38":"08a4eef8a25ea4f2d701","39":"c4741e2fbbe900f7eb08","40":"be43edfed804b5db1ca5","41":"f8ce2cb6770260cda47c","42":"af7a6e3a8713ddc04bbf","43":"fa265a0f65a4259a7e2b","44":"af8b7626a7f36aa15fef","45":"a7f00ba7b906b5b81ac2","46":"6351bad02de9683c8438","47":"912c126b71b49b0ba035","48":"d484fe5f11f31b9bbf9f","49":"e1b0ec58b060c7184629","50":"b2da7c5cb8d178fb44c0","51":"8ce9c0e782467b2e27ea","52":"cf1ba8c7c14c538bd894","53":"69379610f52a0025da1d","54":"873b9ec41a8aa911a783","55":"97b4b6addcc5651743ab","56":"300f106ed1be993986f8","57":"7004eb0c6470fe0b9a44","58":"fa64c35671638e211174","59":"0da72777ffdadb766906","60":"bc95b8fba0fbd2f37d73","61":"ce1803f6b553e7027e10","62":"43ff126d9962aa60e08e","63":"441f3246749c7cf9ad21","64":"d0897c31b7efa42c2378","65":"ba4ec24a668f568b5492","66":"13c527b6f2197ecc2874","67":"eae36bf5f399aa15115f","68":"e0d16c4c769f88f7373e","69":"8a4c73ea87540a6c8049","70":"3fd43ab1e47f62afb091","71":"ed6d7edf951a53d68049","72":"f270def1a6994b2566dd","73":"3dca0d50c6194d6622c5","74":"db4e26b5398453d36b4d","75":"5bafffe358eb8e53d3bd","76":"b158cffee421324d9d9d","77":"de74f7b7d88aa6d85655","78":"5159eaabbfecfb38ff55","79":"ce855cb0b0f7115b159d","80":"6637f80b09e6b99381e2","81":"6295860eb3b1ff428b7a","82":"796de9a490dd54862981","83":"038a42a400291c756d2e","84":"6065ade517efb390308d","85":"22d2d63c226b3781b486","86":"472228f2442a8b4c1f2c","87":"612610f8387eba9f865e"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/packs/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 691);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(375);
} else {
  module.exports = require('./cjs/react.development.js');
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _for = __webpack_require__(343);

var _for2 = _interopRequireDefault(_for);

var _symbol = __webpack_require__(178);

var _symbol2 = _interopRequireDefault(_symbol);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function () {
  var REACT_ELEMENT_TYPE = typeof _symbol2.default === "function" && _for2.default && (0, _for2.default)("react.element") || 0xeac7;
  return function createRawReactElement(type, props, key, children) {
    var defaultProps = type && type.defaultProps;
    var childrenLength = arguments.length - 3;

    if (!props && childrenLength !== 0) {
      props = {};
    }

    if (props && defaultProps) {
      for (var propName in defaultProps) {
        if (props[propName] === void 0) {
          props[propName] = defaultProps[propName];
        }
      }
    } else if (!props) {
      props = defaultProps || {};
    }

    if (childrenLength === 1) {
      props.children = children;
    } else if (childrenLength > 1) {
      var childArray = Array(childrenLength);

      for (var i = 0; i < childrenLength; i++) {
        childArray[i] = arguments[i + 3];
      }

      props.children = childArray;
    }

    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type: type,
      key: key === undefined ? null : '' + key,
      ref: null,
      props: props,
      _owner: null
    };
  };
}();

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(29);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(368);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(372);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(29);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function (object) {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(384)();
}

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["setLocale"] = setLocale;
/* harmony export (immutable) */ __webpack_exports__["getLocale"] = getLocale;
var theLocale = void 0;

function setLocale(locale) {
  theLocale = locale;
}

function getLocale() {
  return theLocale;
}

/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (global, factory) {
   true ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.Immutable = factory();
})(this, function () {
  'use strict';
  var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
    return isIterable(value) ? value : Seq(value);
  }

  createClass(KeyedIterable, Iterable);
  function KeyedIterable(value) {
    return isKeyed(value) ? value : KeyedSeq(value);
  }

  createClass(IndexedIterable, Iterable);
  function IndexedIterable(value) {
    return isIndexed(value) ? value : IndexedSeq(value);
  }

  createClass(SetIterable, Iterable);
  function SetIterable(value) {
    return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
  }

  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;

  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || size !== undefined && begin <= -size) && (end === undefined || size !== undefined && end >= size);
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ? defaultIndex : index < 0 ? Math.max(0, size + index) : size === undefined ? index : Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;

  function Iterator(next) {
    this.next = next;
  }

  Iterator.prototype.toString = function () {
    return '[Iterator]';
  };

  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect = Iterator.prototype.toSource = function () {
    return this.toString();
  };
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };

  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? iteratorResult.value = value : iteratorResult = {
      value: value, done: false
    };
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || iterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
  function Seq(value) {
    return value === null || value === undefined ? emptySequence() : isIterable(value) ? value.toSeq() : seqFromValue(value);
  }

  Seq.of = function () /*...values*/{
    return Seq(arguments);
  };

  Seq.prototype.toSeq = function () {
    return this;
  };

  Seq.prototype.toString = function () {
    return this.__toString('Seq {', '}');
  };

  Seq.prototype.cacheResult = function () {
    if (!this._cache && this.__iterateUncached) {
      this._cache = this.entrySeq().toArray();
      this.size = this._cache.length;
    }
    return this;
  };

  // abstract __iterateUncached(fn, reverse)

  Seq.prototype.__iterate = function (fn, reverse) {
    return seqIterate(this, fn, reverse, true);
  };

  // abstract __iteratorUncached(type, reverse)

  Seq.prototype.__iterator = function (type, reverse) {
    return seqIterator(this, type, reverse, true);
  };

  createClass(KeyedSeq, Seq);
  function KeyedSeq(value) {
    return value === null || value === undefined ? emptySequence().toKeyedSeq() : isIterable(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : keyedSeqFromValue(value);
  }

  KeyedSeq.prototype.toKeyedSeq = function () {
    return this;
  };

  createClass(IndexedSeq, Seq);
  function IndexedSeq(value) {
    return value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
  }

  IndexedSeq.of = function () /*...values*/{
    return IndexedSeq(arguments);
  };

  IndexedSeq.prototype.toIndexedSeq = function () {
    return this;
  };

  IndexedSeq.prototype.toString = function () {
    return this.__toString('Seq [', ']');
  };

  IndexedSeq.prototype.__iterate = function (fn, reverse) {
    return seqIterate(this, fn, reverse, false);
  };

  IndexedSeq.prototype.__iterator = function (type, reverse) {
    return seqIterator(this, type, reverse, false);
  };

  createClass(SetSeq, Seq);
  function SetSeq(value) {
    return (value === null || value === undefined ? emptySequence() : !isIterable(value) ? indexedSeqFromValue(value) : isKeyed(value) ? value.entrySeq() : value).toSetSeq();
  }

  SetSeq.of = function () /*...values*/{
    return SetSeq(arguments);
  };

  SetSeq.prototype.toSetSeq = function () {
    return this;
  };

  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;

  createClass(ArraySeq, IndexedSeq);
  function ArraySeq(array) {
    this._array = array;
    this.size = array.length;
  }

  ArraySeq.prototype.get = function (index, notSetValue) {
    return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
  };

  ArraySeq.prototype.__iterate = function (fn, reverse) {
    var array = this._array;
    var maxIndex = array.length - 1;
    for (var ii = 0; ii <= maxIndex; ii++) {
      if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
        return ii + 1;
      }
    }
    return ii;
  };

  ArraySeq.prototype.__iterator = function (type, reverse) {
    var array = this._array;
    var maxIndex = array.length - 1;
    var ii = 0;
    return new Iterator(function () {
      return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++]);
    });
  };

  createClass(ObjectSeq, KeyedSeq);
  function ObjectSeq(object) {
    var keys = Object.keys(object);
    this._object = object;
    this._keys = keys;
    this.size = keys.length;
  }

  ObjectSeq.prototype.get = function (key, notSetValue) {
    if (notSetValue !== undefined && !this.has(key)) {
      return notSetValue;
    }
    return this._object[key];
  };

  ObjectSeq.prototype.has = function (key) {
    return this._object.hasOwnProperty(key);
  };

  ObjectSeq.prototype.__iterate = function (fn, reverse) {
    var object = this._object;
    var keys = this._keys;
    var maxIndex = keys.length - 1;
    for (var ii = 0; ii <= maxIndex; ii++) {
      var key = keys[reverse ? maxIndex - ii : ii];
      if (fn(object[key], key, this) === false) {
        return ii + 1;
      }
    }
    return ii;
  };

  ObjectSeq.prototype.__iterator = function (type, reverse) {
    var object = this._object;
    var keys = this._keys;
    var maxIndex = keys.length - 1;
    var ii = 0;
    return new Iterator(function () {
      var key = keys[reverse ? maxIndex - ii : ii];
      return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, key, object[key]);
    });
  };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;

  createClass(IterableSeq, IndexedSeq);
  function IterableSeq(iterable) {
    this._iterable = iterable;
    this.size = iterable.length || iterable.size;
  }

  IterableSeq.prototype.__iterateUncached = function (fn, reverse) {
    if (reverse) {
      return this.cacheResult().__iterate(fn, reverse);
    }
    var iterable = this._iterable;
    var iterator = getIterator(iterable);
    var iterations = 0;
    if (isIterator(iterator)) {
      var step;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
    }
    return iterations;
  };

  IterableSeq.prototype.__iteratorUncached = function (type, reverse) {
    if (reverse) {
      return this.cacheResult().__iterator(type, reverse);
    }
    var iterable = this._iterable;
    var iterator = getIterator(iterable);
    if (!isIterator(iterator)) {
      return new Iterator(iteratorDone);
    }
    var iterations = 0;
    return new Iterator(function () {
      var step = iterator.next();
      return step.done ? step : iteratorValue(type, iterations++, step.value);
    });
  };

  createClass(IteratorSeq, IndexedSeq);
  function IteratorSeq(iterator) {
    this._iterator = iterator;
    this._iteratorCache = [];
  }

  IteratorSeq.prototype.__iterateUncached = function (fn, reverse) {
    if (reverse) {
      return this.cacheResult().__iterate(fn, reverse);
    }
    var iterator = this._iterator;
    var cache = this._iteratorCache;
    var iterations = 0;
    while (iterations < cache.length) {
      if (fn(cache[iterations], iterations++, this) === false) {
        return iterations;
      }
    }
    var step;
    while (!(step = iterator.next()).done) {
      var val = step.value;
      cache[iterations] = val;
      if (fn(val, iterations++, this) === false) {
        break;
      }
    }
    return iterations;
  };

  IteratorSeq.prototype.__iteratorUncached = function (type, reverse) {
    if (reverse) {
      return this.cacheResult().__iterator(type, reverse);
    }
    var iterator = this._iterator;
    var cache = this._iteratorCache;
    var iterations = 0;
    return new Iterator(function () {
      if (iterations >= cache.length) {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        cache[iterations] = step.value;
      }
      return iteratorValue(type, iterations, cache[iterations++]);
    });
  };

  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq = Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() : isIterator(value) ? new IteratorSeq(value).fromEntrySeq() : hasIterator(value) ? new IterableSeq(value).fromEntrySeq() : typeof value === 'object' ? new ObjectSeq(value) : undefined;
    if (!seq) {
      throw new TypeError('Expected Array or iterable object of [k, v] entries, ' + 'or keyed object: ' + value);
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError('Expected Array or iterable object of values: ' + value);
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) || typeof value === 'object' && new ObjectSeq(value);
    if (!seq) {
      throw new TypeError('Expected Array or iterable object of values, or keyed object: ' + value);
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return isArrayLike(value) ? new ArraySeq(value) : isIterator(value) ? new IteratorSeq(value) : hasIterator(value) ? new IterableSeq(value) : undefined;
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function () {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ? iteratorDone() : iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ? fromJSWith(converter, json, '', { '': json }) : fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function (v, k) {
        return fromJSWith(converter, v, k, json);
      }));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function (v, k) {
        return fromJSWith(converter, v, k, json);
      }));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || valueA !== valueA && valueB !== valueB) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' && typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || valueA !== valueA && valueB !== valueB) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' && typeof valueB.equals === 'function' && valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (!isIterable(b) || a.size !== undefined && b.size !== undefined && a.size !== b.size || a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || isOrdered(a) !== isOrdered(b)) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function (v, k) {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function (v, k) {
      if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

  function Repeat(value, times) {
    if (!(this instanceof Repeat)) {
      return new Repeat(value, times);
    }
    this._value = value;
    this.size = times === undefined ? Infinity : Math.max(0, times);
    if (this.size === 0) {
      if (EMPTY_REPEAT) {
        return EMPTY_REPEAT;
      }
      EMPTY_REPEAT = this;
    }
  }

  Repeat.prototype.toString = function () {
    if (this.size === 0) {
      return 'Repeat []';
    }
    return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
  };

  Repeat.prototype.get = function (index, notSetValue) {
    return this.has(index) ? this._value : notSetValue;
  };

  Repeat.prototype.includes = function (searchValue) {
    return is(this._value, searchValue);
  };

  Repeat.prototype.slice = function (begin, end) {
    var size = this.size;
    return wholeSlice(begin, end, size) ? this : new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
  };

  Repeat.prototype.reverse = function () {
    return this;
  };

  Repeat.prototype.indexOf = function (searchValue) {
    if (is(this._value, searchValue)) {
      return 0;
    }
    return -1;
  };

  Repeat.prototype.lastIndexOf = function (searchValue) {
    if (is(this._value, searchValue)) {
      return this.size;
    }
    return -1;
  };

  Repeat.prototype.__iterate = function (fn, reverse) {
    for (var ii = 0; ii < this.size; ii++) {
      if (fn(this._value, ii, this) === false) {
        return ii + 1;
      }
    }
    return ii;
  };

  Repeat.prototype.__iterator = function (type, reverse) {
    var this$0 = this;
    var ii = 0;
    return new Iterator(function () {
      return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone();
    });
  };

  Repeat.prototype.equals = function (other) {
    return other instanceof Repeat ? is(this._value, other._value) : deepEqual(other);
  };

  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

  function Range(start, end, step) {
    if (!(this instanceof Range)) {
      return new Range(start, end, step);
    }
    invariant(step !== 0, 'Cannot step a Range by 0');
    start = start || 0;
    if (end === undefined) {
      end = Infinity;
    }
    step = step === undefined ? 1 : Math.abs(step);
    if (end < start) {
      step = -step;
    }
    this._start = start;
    this._end = end;
    this._step = step;
    this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
    if (this.size === 0) {
      if (EMPTY_RANGE) {
        return EMPTY_RANGE;
      }
      EMPTY_RANGE = this;
    }
  }

  Range.prototype.toString = function () {
    if (this.size === 0) {
      return 'Range []';
    }
    return 'Range [ ' + this._start + '...' + this._end + (this._step !== 1 ? ' by ' + this._step : '') + ' ]';
  };

  Range.prototype.get = function (index, notSetValue) {
    return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
  };

  Range.prototype.includes = function (searchValue) {
    var possibleIndex = (searchValue - this._start) / this._step;
    return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
  };

  Range.prototype.slice = function (begin, end) {
    if (wholeSlice(begin, end, this.size)) {
      return this;
    }
    begin = resolveBegin(begin, this.size);
    end = resolveEnd(end, this.size);
    if (end <= begin) {
      return new Range(0, 0);
    }
    return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
  };

  Range.prototype.indexOf = function (searchValue) {
    var offsetValue = searchValue - this._start;
    if (offsetValue % this._step === 0) {
      var index = offsetValue / this._step;
      if (index >= 0 && index < this.size) {
        return index;
      }
    }
    return -1;
  };

  Range.prototype.lastIndexOf = function (searchValue) {
    return this.indexOf(searchValue);
  };

  Range.prototype.__iterate = function (fn, reverse) {
    var maxIndex = this.size - 1;
    var step = this._step;
    var value = reverse ? this._start + maxIndex * step : this._start;
    for (var ii = 0; ii <= maxIndex; ii++) {
      if (fn(value, ii, this) === false) {
        return ii + 1;
      }
      value += reverse ? -step : step;
    }
    return ii;
  };

  Range.prototype.__iterator = function (type, reverse) {
    var maxIndex = this.size - 1;
    var step = this._step;
    var value = reverse ? this._start + maxIndex * step : this._start;
    var ii = 0;
    return new Iterator(function () {
      var v = value;
      value += reverse ? -step : step;
      return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
    });
  };

  Range.prototype.equals = function (other) {
    return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual(this, other);
  };

  var EMPTY_RANGE;

  createClass(Collection, Iterable);
  function Collection() {
    throw TypeError('Abstract');
  }

  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}

  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul = typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ? Math.imul : function imul(a, b) {
    a = a | 0; // int
    b = b | 0; // int
    var c = a & 0xffff;
    var d = b & 0xffff;
    // Shift by 0 fixes the sign on the high part.
    return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0; // int
  };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return i32 >>> 1 & 0x40000000 | i32 & 0xBFFFFFFF;
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      if (o !== o || o === Infinity) {
        return 0;
      }
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function () {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = function () {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }();

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1:
          // Element
          return node.uniqueID;
        case 9:
          // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(size !== Infinity, 'Cannot perform this action with an infinite size.');
  }

  createClass(Map, KeyedCollection);

  // @pragma Construction

  function Map(value) {
    return value === null || value === undefined ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function (map) {
      var iter = KeyedIterable(value);
      assertNotInfinite(iter.size);
      iter.forEach(function (v, k) {
        return map.set(k, v);
      });
    });
  }

  Map.of = function () {
    var keyValues = SLICE$0.call(arguments, 0);
    return emptyMap().withMutations(function (map) {
      for (var i = 0; i < keyValues.length; i += 2) {
        if (i + 1 >= keyValues.length) {
          throw new Error('Missing value for key: ' + keyValues[i]);
        }
        map.set(keyValues[i], keyValues[i + 1]);
      }
    });
  };

  Map.prototype.toString = function () {
    return this.__toString('Map {', '}');
  };

  // @pragma Access

  Map.prototype.get = function (k, notSetValue) {
    return this._root ? this._root.get(0, undefined, k, notSetValue) : notSetValue;
  };

  // @pragma Modification

  Map.prototype.set = function (k, v) {
    return updateMap(this, k, v);
  };

  Map.prototype.setIn = function (keyPath, v) {
    return this.updateIn(keyPath, NOT_SET, function () {
      return v;
    });
  };

  Map.prototype.remove = function (k) {
    return updateMap(this, k, NOT_SET);
  };

  Map.prototype.deleteIn = function (keyPath) {
    return this.updateIn(keyPath, function () {
      return NOT_SET;
    });
  };

  Map.prototype.update = function (k, notSetValue, updater) {
    return arguments.length === 1 ? k(this) : this.updateIn([k], notSetValue, updater);
  };

  Map.prototype.updateIn = function (keyPath, notSetValue, updater) {
    if (!updater) {
      updater = notSetValue;
      notSetValue = undefined;
    }
    var updatedValue = updateInDeepMap(this, forceIterator(keyPath), notSetValue, updater);
    return updatedValue === NOT_SET ? undefined : updatedValue;
  };

  Map.prototype.clear = function () {
    if (this.size === 0) {
      return this;
    }
    if (this.__ownerID) {
      this.size = 0;
      this._root = null;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return emptyMap();
  };

  // @pragma Composition

  Map.prototype.merge = function () /*...iters*/{
    return mergeIntoMapWith(this, undefined, arguments);
  };

  Map.prototype.mergeWith = function (merger) {
    var iters = SLICE$0.call(arguments, 1);
    return mergeIntoMapWith(this, merger, iters);
  };

  Map.prototype.mergeIn = function (keyPath) {
    var iters = SLICE$0.call(arguments, 1);
    return this.updateIn(keyPath, emptyMap(), function (m) {
      return typeof m.merge === 'function' ? m.merge.apply(m, iters) : iters[iters.length - 1];
    });
  };

  Map.prototype.mergeDeep = function () /*...iters*/{
    return mergeIntoMapWith(this, deepMerger, arguments);
  };

  Map.prototype.mergeDeepWith = function (merger) {
    var iters = SLICE$0.call(arguments, 1);
    return mergeIntoMapWith(this, deepMergerWith(merger), iters);
  };

  Map.prototype.mergeDeepIn = function (keyPath) {
    var iters = SLICE$0.call(arguments, 1);
    return this.updateIn(keyPath, emptyMap(), function (m) {
      return typeof m.mergeDeep === 'function' ? m.mergeDeep.apply(m, iters) : iters[iters.length - 1];
    });
  };

  Map.prototype.sort = function (comparator) {
    // Late binding
    return OrderedMap(sortFactory(this, comparator));
  };

  Map.prototype.sortBy = function (mapper, comparator) {
    // Late binding
    return OrderedMap(sortFactory(this, comparator, mapper));
  };

  // @pragma Mutability

  Map.prototype.withMutations = function (fn) {
    var mutable = this.asMutable();
    fn(mutable);
    return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
  };

  Map.prototype.asMutable = function () {
    return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
  };

  Map.prototype.asImmutable = function () {
    return this.__ensureOwner();
  };

  Map.prototype.wasAltered = function () {
    return this.__altered;
  };

  Map.prototype.__iterator = function (type, reverse) {
    return new MapIterator(this, type, reverse);
  };

  Map.prototype.__iterate = function (fn, reverse) {
    var this$0 = this;
    var iterations = 0;
    this._root && this._root.iterate(function (entry) {
      iterations++;
      return fn(entry[1], entry[0], this$0);
    }, reverse);
    return iterations;
  };

  Map.prototype.__ensureOwner = function (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    if (!ownerID) {
      this.__ownerID = ownerID;
      this.__altered = false;
      return this;
    }
    return makeMap(this.size, this._root, ownerID, this.__hash);
  };

  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;

  // #pragma Trie Nodes


  function ArrayMapNode(ownerID, entries) {
    this.ownerID = ownerID;
    this.entries = entries;
  }

  ArrayMapNode.prototype.get = function (shift, keyHash, key, notSetValue) {
    var entries = this.entries;
    for (var ii = 0, len = entries.length; ii < len; ii++) {
      if (is(key, entries[ii][0])) {
        return entries[ii][1];
      }
    }
    return notSetValue;
  };

  ArrayMapNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === NOT_SET;

    var entries = this.entries;
    var idx = 0;
    for (var len = entries.length; idx < len; idx++) {
      if (is(key, entries[idx][0])) {
        break;
      }
    }
    var exists = idx < len;

    if (exists ? entries[idx][1] === value : removed) {
      return this;
    }

    SetRef(didAlter);
    (removed || !exists) && SetRef(didChangeSize);

    if (removed && entries.length === 1) {
      return; // undefined
    }

    if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
      return createNodes(ownerID, entries, key, value);
    }

    var isEditable = ownerID && ownerID === this.ownerID;
    var newEntries = isEditable ? entries : arrCopy(entries);

    if (exists) {
      if (removed) {
        idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
      } else {
        newEntries[idx] = [key, value];
      }
    } else {
      newEntries.push([key, value]);
    }

    if (isEditable) {
      this.entries = newEntries;
      return this;
    }

    return new ArrayMapNode(ownerID, newEntries);
  };

  function BitmapIndexedNode(ownerID, bitmap, nodes) {
    this.ownerID = ownerID;
    this.bitmap = bitmap;
    this.nodes = nodes;
  }

  BitmapIndexedNode.prototype.get = function (shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) {
      keyHash = hash(key);
    }
    var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
    var bitmap = this.bitmap;
    return (bitmap & bit) === 0 ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
  };

  BitmapIndexedNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) {
      keyHash = hash(key);
    }
    var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var bit = 1 << keyHashFrag;
    var bitmap = this.bitmap;
    var exists = (bitmap & bit) !== 0;

    if (!exists && value === NOT_SET) {
      return this;
    }

    var idx = popCount(bitmap & bit - 1);
    var nodes = this.nodes;
    var node = exists ? nodes[idx] : undefined;
    var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

    if (newNode === node) {
      return this;
    }

    if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
      return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
    }

    if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
      return nodes[idx ^ 1];
    }

    if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
      return newNode;
    }

    var isEditable = ownerID && ownerID === this.ownerID;
    var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
    var newNodes = exists ? newNode ? setIn(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);

    if (isEditable) {
      this.bitmap = newBitmap;
      this.nodes = newNodes;
      return this;
    }

    return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
  };

  function HashArrayMapNode(ownerID, count, nodes) {
    this.ownerID = ownerID;
    this.count = count;
    this.nodes = nodes;
  }

  HashArrayMapNode.prototype.get = function (shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) {
      keyHash = hash(key);
    }
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var node = this.nodes[idx];
    return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
  };

  HashArrayMapNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) {
      keyHash = hash(key);
    }
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var removed = value === NOT_SET;
    var nodes = this.nodes;
    var node = nodes[idx];

    if (removed && !node) {
      return this;
    }

    var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
    if (newNode === node) {
      return this;
    }

    var newCount = this.count;
    if (!node) {
      newCount++;
    } else if (!newNode) {
      newCount--;
      if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
        return packNodes(ownerID, nodes, newCount, idx);
      }
    }

    var isEditable = ownerID && ownerID === this.ownerID;
    var newNodes = setIn(nodes, idx, newNode, isEditable);

    if (isEditable) {
      this.count = newCount;
      this.nodes = newNodes;
      return this;
    }

    return new HashArrayMapNode(ownerID, newCount, newNodes);
  };

  function HashCollisionNode(ownerID, keyHash, entries) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entries = entries;
  }

  HashCollisionNode.prototype.get = function (shift, keyHash, key, notSetValue) {
    var entries = this.entries;
    for (var ii = 0, len = entries.length; ii < len; ii++) {
      if (is(key, entries[ii][0])) {
        return entries[ii][1];
      }
    }
    return notSetValue;
  };

  HashCollisionNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) {
      keyHash = hash(key);
    }

    var removed = value === NOT_SET;

    if (keyHash !== this.keyHash) {
      if (removed) {
        return this;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
    }

    var entries = this.entries;
    var idx = 0;
    for (var len = entries.length; idx < len; idx++) {
      if (is(key, entries[idx][0])) {
        break;
      }
    }
    var exists = idx < len;

    if (exists ? entries[idx][1] === value : removed) {
      return this;
    }

    SetRef(didAlter);
    (removed || !exists) && SetRef(didChangeSize);

    if (removed && len === 2) {
      return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
    }

    var isEditable = ownerID && ownerID === this.ownerID;
    var newEntries = isEditable ? entries : arrCopy(entries);

    if (exists) {
      if (removed) {
        idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
      } else {
        newEntries[idx] = [key, value];
      }
    } else {
      newEntries.push([key, value]);
    }

    if (isEditable) {
      this.entries = newEntries;
      return this;
    }

    return new HashCollisionNode(ownerID, this.keyHash, newEntries);
  };

  function ValueNode(ownerID, keyHash, entry) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entry = entry;
  }

  ValueNode.prototype.get = function (shift, keyHash, key, notSetValue) {
    return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
  };

  ValueNode.prototype.update = function (ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === NOT_SET;
    var keyMatch = is(key, this.entry[0]);
    if (keyMatch ? value === this.entry[1] : removed) {
      return this;
    }

    SetRef(didAlter);

    if (removed) {
      SetRef(didChangeSize);
      return; // undefined
    }

    if (keyMatch) {
      if (ownerID && ownerID === this.ownerID) {
        this.entry[1] = value;
        return this;
      }
      return new ValueNode(ownerID, this.keyHash, [key, value]);
    }

    SetRef(didChangeSize);
    return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
  };

  // #pragma Iterators

  ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  };

  BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  };

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  };

  createClass(MapIterator, Iterator);

  function MapIterator(map, type, reverse) {
    this._type = type;
    this._reverse = reverse;
    this._stack = map._root && mapIteratorFrame(map._root);
  }

  MapIterator.prototype.next = function () {
    var type = this._type;
    var stack = this._stack;
    while (stack) {
      var node = stack.node;
      var index = stack.index++;
      var maxIndex;
      if (node.entry) {
        if (index === 0) {
          return mapIteratorValue(type, node.entry);
        }
      } else if (node.entries) {
        maxIndex = node.entries.length - 1;
        if (index <= maxIndex) {
          return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
        }
      } else {
        maxIndex = node.nodes.length - 1;
        if (index <= maxIndex) {
          var subNode = node.nodes[this._reverse ? maxIndex - index : index];
          if (subNode) {
            if (subNode.entry) {
              return mapIteratorValue(type, subNode.entry);
            }
            stack = this._stack = mapIteratorFrame(subNode, stack);
          }
          continue;
        }
      }
      stack = this._stack = this._stack.__prev;
    }
    return iteratorDone();
  };

  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ? [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] : (newNode = new ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function (v) {
          return fromJS(v);
        });
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ? existing.mergeDeep(value) : is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function (existing, value, key) {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function (x) {
      return x.size !== 0;
    });
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function (collection) {
      var mergeIntoMap = merger ? function (value, key) {
        collection.update(key, NOT_SET, function (existing) {
          return existing === NOT_SET ? value : merger(existing, value, key);
        });
      } : function (value, key) {
        collection.set(key, value);
      };
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(isNotSet || existing && existing.set, 'invalid keyPath');
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(nextExisting, keyPathIter, notSetValue, updater);
    return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? existing.remove(key) : (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - (x >> 1 & 0x55555555);
    x = (x & 0x33333333) + (x >> 2 & 0x33333333);
    x = x + (x >> 4) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

  // @pragma Construction

  function List(value) {
    var empty = emptyList();
    if (value === null || value === undefined) {
      return empty;
    }
    if (isList(value)) {
      return value;
    }
    var iter = IndexedIterable(value);
    var size = iter.size;
    if (size === 0) {
      return empty;
    }
    assertNotInfinite(size);
    if (size > 0 && size < SIZE) {
      return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
    }
    return empty.withMutations(function (list) {
      list.setSize(size);
      iter.forEach(function (v, i) {
        return list.set(i, v);
      });
    });
  }

  List.of = function () /*...values*/{
    return this(arguments);
  };

  List.prototype.toString = function () {
    return this.__toString('List [', ']');
  };

  // @pragma Access

  List.prototype.get = function (index, notSetValue) {
    index = wrapIndex(this, index);
    if (index >= 0 && index < this.size) {
      index += this._origin;
      var node = listNodeFor(this, index);
      return node && node.array[index & MASK];
    }
    return notSetValue;
  };

  // @pragma Modification

  List.prototype.set = function (index, value) {
    return updateList(this, index, value);
  };

  List.prototype.remove = function (index) {
    return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
  };

  List.prototype.insert = function (index, value) {
    return this.splice(index, 0, value);
  };

  List.prototype.clear = function () {
    if (this.size === 0) {
      return this;
    }
    if (this.__ownerID) {
      this.size = this._origin = this._capacity = 0;
      this._level = SHIFT;
      this._root = this._tail = null;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return emptyList();
  };

  List.prototype.push = function () /*...values*/{
    var values = arguments;
    var oldSize = this.size;
    return this.withMutations(function (list) {
      setListBounds(list, 0, oldSize + values.length);
      for (var ii = 0; ii < values.length; ii++) {
        list.set(oldSize + ii, values[ii]);
      }
    });
  };

  List.prototype.pop = function () {
    return setListBounds(this, 0, -1);
  };

  List.prototype.unshift = function () /*...values*/{
    var values = arguments;
    return this.withMutations(function (list) {
      setListBounds(list, -values.length);
      for (var ii = 0; ii < values.length; ii++) {
        list.set(ii, values[ii]);
      }
    });
  };

  List.prototype.shift = function () {
    return setListBounds(this, 1);
  };

  // @pragma Composition

  List.prototype.merge = function () /*...iters*/{
    return mergeIntoListWith(this, undefined, arguments);
  };

  List.prototype.mergeWith = function (merger) {
    var iters = SLICE$0.call(arguments, 1);
    return mergeIntoListWith(this, merger, iters);
  };

  List.prototype.mergeDeep = function () /*...iters*/{
    return mergeIntoListWith(this, deepMerger, arguments);
  };

  List.prototype.mergeDeepWith = function (merger) {
    var iters = SLICE$0.call(arguments, 1);
    return mergeIntoListWith(this, deepMergerWith(merger), iters);
  };

  List.prototype.setSize = function (size) {
    return setListBounds(this, 0, size);
  };

  // @pragma Iteration

  List.prototype.slice = function (begin, end) {
    var size = this.size;
    if (wholeSlice(begin, end, size)) {
      return this;
    }
    return setListBounds(this, resolveBegin(begin, size), resolveEnd(end, size));
  };

  List.prototype.__iterator = function (type, reverse) {
    var index = 0;
    var values = iterateList(this, reverse);
    return new Iterator(function () {
      var value = values();
      return value === DONE ? iteratorDone() : iteratorValue(type, index++, value);
    });
  };

  List.prototype.__iterate = function (fn, reverse) {
    var index = 0;
    var values = iterateList(this, reverse);
    var value;
    while ((value = values()) !== DONE) {
      if (fn(value, index++, this) === false) {
        break;
      }
    }
    return index;
  };

  List.prototype.__ensureOwner = function (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    if (!ownerID) {
      this.__ownerID = ownerID;
      return this;
    }
    return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
  };

  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn = ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;

  function VNode(array, ownerID) {
    this.array = array;
    this.ownerID = ownerID;
  }

  // TODO: seems like these methods are very similar

  VNode.prototype.removeBefore = function (ownerID, level, index) {
    if (index === level ? 1 << level : 0 || this.array.length === 0) {
      return this;
    }
    var originIndex = index >>> level & MASK;
    if (originIndex >= this.array.length) {
      return new VNode([], ownerID);
    }
    var removingFirst = originIndex === 0;
    var newChild;
    if (level > 0) {
      var oldChild = this.array[originIndex];
      newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
      if (newChild === oldChild && removingFirst) {
        return this;
      }
    }
    if (removingFirst && !newChild) {
      return this;
    }
    var editable = editableVNode(this, ownerID);
    if (!removingFirst) {
      for (var ii = 0; ii < originIndex; ii++) {
        editable.array[ii] = undefined;
      }
    }
    if (newChild) {
      editable.array[originIndex] = newChild;
    }
    return editable;
  };

  VNode.prototype.removeAfter = function (ownerID, level, index) {
    if (index === (level ? 1 << level : 0) || this.array.length === 0) {
      return this;
    }
    var sizeIndex = index - 1 >>> level & MASK;
    if (sizeIndex >= this.array.length) {
      return this;
    }

    var newChild;
    if (level > 0) {
      var oldChild = this.array[sizeIndex];
      newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
      if (newChild === oldChild && sizeIndex === this.array.length - 1) {
        return this;
      }
    }

    var editable = editableVNode(this, ownerID);
    editable.array.splice(sizeIndex + 1);
    if (newChild) {
      editable.array[sizeIndex] = newChild;
    }
    return editable;
  };

  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function () {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : left - offset >> level;
      var to = (right - offset >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function () {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(array && array[idx], level - SHIFT, offset + (idx << level));
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function (list) {
        index < 0 ? setListBounds(list, index).set(0, value) : setListBounds(list, 0, index + 1).set(index, value);
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = index >>> level & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << list._level + SHIFT) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[rawIndex >>> level & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << newLevel + SHIFT) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = oldTailOffset >>> level & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

      // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = newOrigin >>> newLevel & MASK;
        if (beginIndex !== newTailOffset >>> newLevel & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function (v) {
          return fromJS(v);
        });
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
  }

  createClass(OrderedMap, Map);

  // @pragma Construction

  function OrderedMap(value) {
    return value === null || value === undefined ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function (map) {
      var iter = KeyedIterable(value);
      assertNotInfinite(iter.size);
      iter.forEach(function (v, k) {
        return map.set(k, v);
      });
    });
  }

  OrderedMap.of = function () /*...values*/{
    return this(arguments);
  };

  OrderedMap.prototype.toString = function () {
    return this.__toString('OrderedMap {', '}');
  };

  // @pragma Access

  OrderedMap.prototype.get = function (k, notSetValue) {
    var index = this._map.get(k);
    return index !== undefined ? this._list.get(index)[1] : notSetValue;
  };

  // @pragma Modification

  OrderedMap.prototype.clear = function () {
    if (this.size === 0) {
      return this;
    }
    if (this.__ownerID) {
      this.size = 0;
      this._map.clear();
      this._list.clear();
      return this;
    }
    return emptyOrderedMap();
  };

  OrderedMap.prototype.set = function (k, v) {
    return updateOrderedMap(this, k, v);
  };

  OrderedMap.prototype.remove = function (k) {
    return updateOrderedMap(this, k, NOT_SET);
  };

  OrderedMap.prototype.wasAltered = function () {
    return this._map.wasAltered() || this._list.wasAltered();
  };

  OrderedMap.prototype.__iterate = function (fn, reverse) {
    var this$0 = this;
    return this._list.__iterate(function (entry) {
      return entry && fn(entry[1], entry[0], this$0);
    }, reverse);
  };

  OrderedMap.prototype.__iterator = function (type, reverse) {
    return this._list.fromEntrySeq().__iterator(type, reverse);
  };

  OrderedMap.prototype.__ensureOwner = function (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    var newMap = this._map.__ensureOwner(ownerID);
    var newList = this._list.__ensureOwner(ownerID);
    if (!ownerID) {
      this.__ownerID = ownerID;
      this._map = newMap;
      this._list = newList;
      return this;
    }
    return makeOrderedMap(newMap, newList, ownerID, this.__hash);
  };

  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;

  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) {
      // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function (entry, idx) {
          return entry !== undefined && i !== idx;
        });
        newMap = newList.toKeyedSeq().map(function (entry) {
          return entry[0];
        }).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
  function ToKeyedSequence(indexed, useKeys) {
    this._iter = indexed;
    this._useKeys = useKeys;
    this.size = indexed.size;
  }

  ToKeyedSequence.prototype.get = function (key, notSetValue) {
    return this._iter.get(key, notSetValue);
  };

  ToKeyedSequence.prototype.has = function (key) {
    return this._iter.has(key);
  };

  ToKeyedSequence.prototype.valueSeq = function () {
    return this._iter.valueSeq();
  };

  ToKeyedSequence.prototype.reverse = function () {
    var this$0 = this;
    var reversedSequence = reverseFactory(this, true);
    if (!this._useKeys) {
      reversedSequence.valueSeq = function () {
        return this$0._iter.toSeq().reverse();
      };
    }
    return reversedSequence;
  };

  ToKeyedSequence.prototype.map = function (mapper, context) {
    var this$0 = this;
    var mappedSequence = mapFactory(this, mapper, context);
    if (!this._useKeys) {
      mappedSequence.valueSeq = function () {
        return this$0._iter.toSeq().map(mapper, context);
      };
    }
    return mappedSequence;
  };

  ToKeyedSequence.prototype.__iterate = function (fn, reverse) {
    var this$0 = this;
    var ii;
    return this._iter.__iterate(this._useKeys ? function (v, k) {
      return fn(v, k, this$0);
    } : (ii = reverse ? resolveSize(this) : 0, function (v) {
      return fn(v, reverse ? --ii : ii++, this$0);
    }), reverse);
  };

  ToKeyedSequence.prototype.__iterator = function (type, reverse) {
    if (this._useKeys) {
      return this._iter.__iterator(type, reverse);
    }
    var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
    var ii = reverse ? resolveSize(this) : 0;
    return new Iterator(function () {
      var step = iterator.next();
      return step.done ? step : iteratorValue(type, reverse ? --ii : ii++, step.value, step);
    });
  };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;

  createClass(ToIndexedSequence, IndexedSeq);
  function ToIndexedSequence(iter) {
    this._iter = iter;
    this.size = iter.size;
  }

  ToIndexedSequence.prototype.includes = function (value) {
    return this._iter.includes(value);
  };

  ToIndexedSequence.prototype.__iterate = function (fn, reverse) {
    var this$0 = this;
    var iterations = 0;
    return this._iter.__iterate(function (v) {
      return fn(v, iterations++, this$0);
    }, reverse);
  };

  ToIndexedSequence.prototype.__iterator = function (type, reverse) {
    var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
    var iterations = 0;
    return new Iterator(function () {
      var step = iterator.next();
      return step.done ? step : iteratorValue(type, iterations++, step.value, step);
    });
  };

  createClass(ToSetSequence, SetSeq);
  function ToSetSequence(iter) {
    this._iter = iter;
    this.size = iter.size;
  }

  ToSetSequence.prototype.has = function (key) {
    return this._iter.includes(key);
  };

  ToSetSequence.prototype.__iterate = function (fn, reverse) {
    var this$0 = this;
    return this._iter.__iterate(function (v) {
      return fn(v, v, this$0);
    }, reverse);
  };

  ToSetSequence.prototype.__iterator = function (type, reverse) {
    var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
    return new Iterator(function () {
      var step = iterator.next();
      return step.done ? step : iteratorValue(type, step.value, step.value, step);
    });
  };

  createClass(FromEntriesSequence, KeyedSeq);
  function FromEntriesSequence(entries) {
    this._iter = entries;
    this.size = entries.size;
  }

  FromEntriesSequence.prototype.entrySeq = function () {
    return this._iter.toSeq();
  };

  FromEntriesSequence.prototype.__iterate = function (fn, reverse) {
    var this$0 = this;
    return this._iter.__iterate(function (entry) {
      // Check if entry exists first so array access doesn't throw for holes
      // in the parent iteration.
      if (entry) {
        validateEntry(entry);
        var indexedIterable = isIterable(entry);
        return fn(indexedIterable ? entry.get(1) : entry[1], indexedIterable ? entry.get(0) : entry[0], this$0);
      }
    }, reverse);
  };

  FromEntriesSequence.prototype.__iterator = function (type, reverse) {
    var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
    return new Iterator(function () {
      while (true) {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return iteratorValue(type, indexedIterable ? entry.get(0) : entry[0], indexedIterable ? entry.get(1) : entry[1], step);
        }
      }
    });
  };

  ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough;

  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function () {
      return iterable;
    };
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function () {
        return iterable.reverse();
      };
      return reversedSequence;
    };
    flipSequence.has = function (key) {
      return iterable.includes(key);
    };
    flipSequence.includes = function (key) {
      return iterable.has(key);
    };
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {
      var this$0 = this;
      return iterable.__iterate(function (v, k) {
        return fn(k, v, this$0) !== false;
      }, reverse);
    };
    flipSequence.__iteratorUncached = function (type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function () {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES, reverse);
    };
    return flipSequence;
  }

  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function (key) {
      return iterable.has(key);
    };
    mappedSequence.get = function (key, notSetValue) {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ? notSetValue : mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {
      var this$0 = this;
      return iterable.__iterate(function (v, k, c) {
        return fn(mapper.call(context, v, k, c), k, this$0) !== false;
      }, reverse);
    };
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function () {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(type, key, mapper.call(context, entry[1], key, iterable), step);
      });
    };
    return mappedSequence;
  }

  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function () {
      return iterable;
    };
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function () {
          return iterable.flip();
        };
        return flipSequence;
      };
    }
    reversedSequence.get = function (key, notSetValue) {
      return iterable.get(useKeys ? key : -1 - key, notSetValue);
    };
    reversedSequence.has = function (key) {
      return iterable.has(useKeys ? key : -1 - key);
    };
    reversedSequence.includes = function (value) {
      return iterable.includes(value);
    };
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {
      var this$0 = this;
      return iterable.__iterate(function (v, k) {
        return fn(v, k, this$0);
      }, !reverse);
    };
    reversedSequence.__iterator = function (type, reverse) {
      return iterable.__iterator(type, !reverse);
    };
    return reversedSequence;
  }

  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function (key) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function (key, notSetValue) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ? v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {
      var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function (v, k, c) {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function () {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    };
    return filterSequence;
  }

  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function (v, k) {
      groups.update(grouper.call(context, v, k, iterable), 0, function (a) {
        return a + 1;
      });
    });
    return groups.asImmutable();
  }

  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function (v, k) {
      groups.update(grouper.call(context, v, k, iterable), function (a) {
        return a = a || [], a.push(isKeyedIter ? [k, v] : v), a;
      });
    });
    var coerce = iterableClass(iterable);
    return groups.map(function (arr) {
      return reify(iterable, coerce(arr));
    });
  }

  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      if (end === Infinity) {
        end = originalSize;
      } else {
        end = end | 0;
      }
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ? iterable.get(index + resolvedBegin, notSetValue) : notSetValue;
      };
    }

    sliceSeq.__iterateUncached = function (fn, reverse) {
      var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function (v, k) {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false && iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function (type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function () {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    };

    return sliceSeq;
  }

  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function (fn, reverse) {
      var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function (v, k, c) {
        return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0);
      });
      return iterations;
    };
    takeSequence.__iteratorUncached = function (type, reverse) {
      var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function () {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }

  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {
      var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function (v, k, c) {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function (type, reverse) {
      var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function () {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }

  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function (v) {
      if (!isIterable(v)) {
        v = isKeyedIterable ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function (v) {
      return v.size !== 0;
    });

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable || isKeyedIterable && isKeyed(singleton) || isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(function (sum, seq) {
      if (sum !== undefined) {
        var size = seq.size;
        if (size !== undefined) {
          return sum + size;
        }
      }
    }, 0);
    return concatSeq;
  }

  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function (fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {
        var this$0 = this;
        iter.__iterate(function (v, k) {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    };
    flatSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function () {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    };
    return flatSequence;
  }

  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(function (v, k) {
      return coerce(mapper.call(context, v, k, iterable));
    }).flatten(true);
  }

  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 - 1;
    interposedSequence.__iterateUncached = function (fn, reverse) {
      var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function (v, k) {
        return (!iterations || fn(separator, iterations++, this$0) !== false) && fn(v, iterations++, this$0) !== false;
      }, reverse);
      return iterations;
    };
    interposedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function () {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ? iteratorValue(type, iterations++, separator) : iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }

  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(function (v, k) {
      return [k, v, index++, mapper ? mapper(v, k, iterable) : v];
    }).toArray();
    entries.sort(function (a, b) {
      return comparator(a[3], b[3]) || a[2] - b[2];
    }).forEach(isKeyedIterable ? function (v, i) {
      entries[i].length = 2;
    } : function (v, i) {
      entries[i] = v[1];
    });
    return isKeyedIterable ? KeyedSeq(entries) : isIndexed(iterable) ? IndexedSeq(entries) : SetSeq(entries);
  }

  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq().map(function (v, k) {
        return [v, mapper(v, k, iterable)];
      }).reduce(function (a, b) {
        return maxCompare(comparator, a[1], b[1]) ? b : a;
      });
      return entry && entry[0];
    } else {
      return iterable.reduce(function (a, b) {
        return maxCompare(comparator, a, b) ? b : a;
      });
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return comp === 0 && b !== a && (b === undefined || b === null || b !== b) || comp > 0;
  }

  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function (i) {
      return i.size;
    }).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function (fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function (type, reverse) {
      var iterators = iters.map(function (i) {
        return i = Iterable(i), getIterator(reverse ? i.reverse() : i);
      });
      var iterations = 0;
      var isDone = false;
      return new Iterator(function () {
        var steps;
        if (!isDone) {
          steps = iterators.map(function (i) {
            return i.next();
          });
          isDone = steps.some(function (s) {
            return s.done;
          });
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(type, iterations++, zipper.apply(null, steps.map(function (s) {
          return s.value;
        })));
      });
    };
    return zipSequence;
  }

  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable : isIndexed(iterable) ? IndexedIterable : SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create((isKeyed(iterable) ? KeyedSeq : isIndexed(iterable) ? IndexedSeq : SetSeq).prototype);
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

  function Record(defaultValues, name) {
    var hasInitialized;

    var RecordType = function Record(values) {
      if (values instanceof RecordType) {
        return values;
      }
      if (!(this instanceof RecordType)) {
        return new RecordType(values);
      }
      if (!hasInitialized) {
        hasInitialized = true;
        var keys = Object.keys(defaultValues);
        setProps(RecordTypePrototype, keys);
        RecordTypePrototype.size = keys.length;
        RecordTypePrototype._name = name;
        RecordTypePrototype._keys = keys;
        RecordTypePrototype._defaultValues = defaultValues;
      }
      this._map = Map(values);
    };

    var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
    RecordTypePrototype.constructor = RecordType;

    return RecordType;
  }

  Record.prototype.toString = function () {
    return this.__toString(recordName(this) + ' {', '}');
  };

  // @pragma Access

  Record.prototype.has = function (k) {
    return this._defaultValues.hasOwnProperty(k);
  };

  Record.prototype.get = function (k, notSetValue) {
    if (!this.has(k)) {
      return notSetValue;
    }
    var defaultVal = this._defaultValues[k];
    return this._map ? this._map.get(k, defaultVal) : defaultVal;
  };

  // @pragma Modification

  Record.prototype.clear = function () {
    if (this.__ownerID) {
      this._map && this._map.clear();
      return this;
    }
    var RecordType = this.constructor;
    return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
  };

  Record.prototype.set = function (k, v) {
    if (!this.has(k)) {
      throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
    }
    if (this._map && !this._map.has(k)) {
      var defaultVal = this._defaultValues[k];
      if (v === defaultVal) {
        return this;
      }
    }
    var newMap = this._map && this._map.set(k, v);
    if (this.__ownerID || newMap === this._map) {
      return this;
    }
    return makeRecord(this, newMap);
  };

  Record.prototype.remove = function (k) {
    if (!this.has(k)) {
      return this;
    }
    var newMap = this._map && this._map.remove(k);
    if (this.__ownerID || newMap === this._map) {
      return this;
    }
    return makeRecord(this, newMap);
  };

  Record.prototype.wasAltered = function () {
    return this._map.wasAltered();
  };

  Record.prototype.__iterator = function (type, reverse) {
    var this$0 = this;
    return KeyedIterable(this._defaultValues).map(function (_, k) {
      return this$0.get(k);
    }).__iterator(type, reverse);
  };

  Record.prototype.__iterate = function (fn, reverse) {
    var this$0 = this;
    return KeyedIterable(this._defaultValues).map(function (_, k) {
      return this$0.get(k);
    }).__iterate(fn, reverse);
  };

  Record.prototype.__ensureOwner = function (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    var newMap = this._map && this._map.__ensureOwner(ownerID);
    if (!ownerID) {
      this.__ownerID = ownerID;
      this._map = newMap;
      return this;
    }
    return makeRecord(this, newMap, ownerID);
  };

  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn = RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;

  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function () {
        return this.get(name);
      },
      set: function (value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

  // @pragma Construction

  function Set(value) {
    return value === null || value === undefined ? emptySet() : isSet(value) && !isOrdered(value) ? value : emptySet().withMutations(function (set) {
      var iter = SetIterable(value);
      assertNotInfinite(iter.size);
      iter.forEach(function (v) {
        return set.add(v);
      });
    });
  }

  Set.of = function () /*...values*/{
    return this(arguments);
  };

  Set.fromKeys = function (value) {
    return this(KeyedIterable(value).keySeq());
  };

  Set.prototype.toString = function () {
    return this.__toString('Set {', '}');
  };

  // @pragma Access

  Set.prototype.has = function (value) {
    return this._map.has(value);
  };

  // @pragma Modification

  Set.prototype.add = function (value) {
    return updateSet(this, this._map.set(value, true));
  };

  Set.prototype.remove = function (value) {
    return updateSet(this, this._map.remove(value));
  };

  Set.prototype.clear = function () {
    return updateSet(this, this._map.clear());
  };

  // @pragma Composition

  Set.prototype.union = function () {
    var iters = SLICE$0.call(arguments, 0);
    iters = iters.filter(function (x) {
      return x.size !== 0;
    });
    if (iters.length === 0) {
      return this;
    }
    if (this.size === 0 && !this.__ownerID && iters.length === 1) {
      return this.constructor(iters[0]);
    }
    return this.withMutations(function (set) {
      for (var ii = 0; ii < iters.length; ii++) {
        SetIterable(iters[ii]).forEach(function (value) {
          return set.add(value);
        });
      }
    });
  };

  Set.prototype.intersect = function () {
    var iters = SLICE$0.call(arguments, 0);
    if (iters.length === 0) {
      return this;
    }
    iters = iters.map(function (iter) {
      return SetIterable(iter);
    });
    var originalSet = this;
    return this.withMutations(function (set) {
      originalSet.forEach(function (value) {
        if (!iters.every(function (iter) {
          return iter.includes(value);
        })) {
          set.remove(value);
        }
      });
    });
  };

  Set.prototype.subtract = function () {
    var iters = SLICE$0.call(arguments, 0);
    if (iters.length === 0) {
      return this;
    }
    iters = iters.map(function (iter) {
      return SetIterable(iter);
    });
    var originalSet = this;
    return this.withMutations(function (set) {
      originalSet.forEach(function (value) {
        if (iters.some(function (iter) {
          return iter.includes(value);
        })) {
          set.remove(value);
        }
      });
    });
  };

  Set.prototype.merge = function () {
    return this.union.apply(this, arguments);
  };

  Set.prototype.mergeWith = function (merger) {
    var iters = SLICE$0.call(arguments, 1);
    return this.union.apply(this, iters);
  };

  Set.prototype.sort = function (comparator) {
    // Late binding
    return OrderedSet(sortFactory(this, comparator));
  };

  Set.prototype.sortBy = function (mapper, comparator) {
    // Late binding
    return OrderedSet(sortFactory(this, comparator, mapper));
  };

  Set.prototype.wasAltered = function () {
    return this._map.wasAltered();
  };

  Set.prototype.__iterate = function (fn, reverse) {
    var this$0 = this;
    return this._map.__iterate(function (_, k) {
      return fn(k, k, this$0);
    }, reverse);
  };

  Set.prototype.__iterator = function (type, reverse) {
    return this._map.map(function (_, k) {
      return k;
    }).__iterator(type, reverse);
  };

  Set.prototype.__ensureOwner = function (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    var newMap = this._map.__ensureOwner(ownerID);
    if (!ownerID) {
      this.__ownerID = ownerID;
      this._map = newMap;
      return this;
    }
    return this.__make(newMap, ownerID);
  };

  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

  // @pragma Construction

  function OrderedSet(value) {
    return value === null || value === undefined ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function (set) {
      var iter = SetIterable(value);
      assertNotInfinite(iter.size);
      iter.forEach(function (v) {
        return set.add(v);
      });
    });
  }

  OrderedSet.of = function () /*...values*/{
    return this(arguments);
  };

  OrderedSet.fromKeys = function (value) {
    return this(KeyedIterable(value).keySeq());
  };

  OrderedSet.prototype.toString = function () {
    return this.__toString('OrderedSet {', '}');
  };

  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

  // @pragma Construction

  function Stack(value) {
    return value === null || value === undefined ? emptyStack() : isStack(value) ? value : emptyStack().unshiftAll(value);
  }

  Stack.of = function () /*...values*/{
    return this(arguments);
  };

  Stack.prototype.toString = function () {
    return this.__toString('Stack [', ']');
  };

  // @pragma Access

  Stack.prototype.get = function (index, notSetValue) {
    var head = this._head;
    index = wrapIndex(this, index);
    while (head && index--) {
      head = head.next;
    }
    return head ? head.value : notSetValue;
  };

  Stack.prototype.peek = function () {
    return this._head && this._head.value;
  };

  // @pragma Modification

  Stack.prototype.push = function () /*...values*/{
    if (arguments.length === 0) {
      return this;
    }
    var newSize = this.size + arguments.length;
    var head = this._head;
    for (var ii = arguments.length - 1; ii >= 0; ii--) {
      head = {
        value: arguments[ii],
        next: head
      };
    }
    if (this.__ownerID) {
      this.size = newSize;
      this._head = head;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return makeStack(newSize, head);
  };

  Stack.prototype.pushAll = function (iter) {
    iter = IndexedIterable(iter);
    if (iter.size === 0) {
      return this;
    }
    assertNotInfinite(iter.size);
    var newSize = this.size;
    var head = this._head;
    iter.reverse().forEach(function (value) {
      newSize++;
      head = {
        value: value,
        next: head
      };
    });
    if (this.__ownerID) {
      this.size = newSize;
      this._head = head;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return makeStack(newSize, head);
  };

  Stack.prototype.pop = function () {
    return this.slice(1);
  };

  Stack.prototype.unshift = function () /*...values*/{
    return this.push.apply(this, arguments);
  };

  Stack.prototype.unshiftAll = function (iter) {
    return this.pushAll(iter);
  };

  Stack.prototype.shift = function () {
    return this.pop.apply(this, arguments);
  };

  Stack.prototype.clear = function () {
    if (this.size === 0) {
      return this;
    }
    if (this.__ownerID) {
      this.size = 0;
      this._head = undefined;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return emptyStack();
  };

  Stack.prototype.slice = function (begin, end) {
    if (wholeSlice(begin, end, this.size)) {
      return this;
    }
    var resolvedBegin = resolveBegin(begin, this.size);
    var resolvedEnd = resolveEnd(end, this.size);
    if (resolvedEnd !== this.size) {
      // super.slice(begin, end);
      return IndexedCollection.prototype.slice.call(this, begin, end);
    }
    var newSize = this.size - resolvedBegin;
    var head = this._head;
    while (resolvedBegin--) {
      head = head.next;
    }
    if (this.__ownerID) {
      this.size = newSize;
      this._head = head;
      this.__hash = undefined;
      this.__altered = true;
      return this;
    }
    return makeStack(newSize, head);
  };

  // @pragma Mutability

  Stack.prototype.__ensureOwner = function (ownerID) {
    if (ownerID === this.__ownerID) {
      return this;
    }
    if (!ownerID) {
      this.__ownerID = ownerID;
      this.__altered = false;
      return this;
    }
    return makeStack(this.size, this._head, ownerID, this.__hash);
  };

  // @pragma Iteration

  Stack.prototype.__iterate = function (fn, reverse) {
    if (reverse) {
      return this.reverse().__iterate(fn);
    }
    var iterations = 0;
    var node = this._head;
    while (node) {
      if (fn(node.value, iterations++, this) === false) {
        break;
      }
      node = node.next;
    }
    return iterations;
  };

  Stack.prototype.__iterator = function (type, reverse) {
    if (reverse) {
      return this.reverse().__iterator(type);
    }
    var iterations = 0;
    var node = this._head;
    return new Iterator(function () {
      if (node) {
        var value = node.value;
        node = node.next;
        return iteratorValue(type, iterations++, value);
      }
      return iteratorDone();
    });
  };

  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;

  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function (key) {
      ctor.prototype[key] = methods[key];
    };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function () {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function (v, i) {
        array[i] = v;
      });
      return array;
    },

    toIndexedSeq: function () {
      return new ToIndexedSequence(this);
    },

    toJS: function () {
      return this.toSeq().map(function (value) {
        return value && typeof value.toJS === 'function' ? value.toJS() : value;
      }).__toJS();
    },

    toJSON: function () {
      return this.toSeq().map(function (value) {
        return value && typeof value.toJSON === 'function' ? value.toJSON() : value;
      }).__toJS();
    },

    toKeyedSeq: function () {
      return new ToKeyedSequence(this, true);
    },

    toMap: function () {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function () {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function (v, k) {
        object[k] = v;
      });
      return object;
    },

    toOrderedMap: function () {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function () {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function () {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function () {
      return new ToSetSequence(this);
    },

    toSeq: function () {
      return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
    },

    toStack: function () {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function () {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },

    // ### Common JavaScript methods and properties

    toString: function () {
      return '[Iterable]';
    },

    __toString: function (head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },

    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function () {
      var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function (searchValue) {
      return this.some(function (value) {
        return is(value, searchValue);
      });
    },

    entries: function () {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function (predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function (v, k, c) {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function (predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function (predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    forEach: function (sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function (separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function (v) {
        isFirst ? isFirst = false : joined += separator;
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function () {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function (mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function (reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function (v, k, c) {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function (reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function () {
      return reify(this, reverseFactory(this, true));
    },

    slice: function (begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function (predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function (comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function () {
      return this.__iterator(ITERATE_VALUES);
    },

    // ### More sequential methods

    butLast: function () {
      return this.slice(0, -1);
    },

    isEmpty: function () {
      return this.size !== undefined ? this.size === 0 : !this.some(function () {
        return true;
      });
    },

    count: function (predicate, context) {
      return ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
    },

    countBy: function (grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function (other) {
      return deepEqual(this, other);
    },

    entrySeq: function () {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function () {
        return iterable.toSeq();
      };
      return entriesSequence;
    },

    filterNot: function (predicate, context) {
      return this.filter(not(predicate), context);
    },

    findEntry: function (predicate, context, notSetValue) {
      var found = notSetValue;
      this.__iterate(function (v, k, c) {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findKey: function (predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLast: function (predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    findLastEntry: function (predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },

    findLastKey: function (predicate, context) {
      return this.toKeyedSeq().reverse().findKey(predicate, context);
    },

    first: function () {
      return this.find(returnTrue);
    },

    flatMap: function (mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function (depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function () {
      return new FromEntriesSequence(this);
    },

    get: function (searchKey, notSetValue) {
      return this.find(function (_, key) {
        return is(key, searchKey);
      }, undefined, notSetValue);
    },

    getIn: function (searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function (grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function (searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function (searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function (iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function (value) {
        return iter.includes(value);
      });
    },

    isSuperset: function (iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keyOf: function (searchValue) {
      return this.findKey(function (value) {
        return is(value, searchValue);
      });
    },

    keySeq: function () {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function () {
      return this.toSeq().reverse().first();
    },

    lastKeyOf: function (searchValue) {
      return this.toKeyedSeq().reverse().keyOf(searchValue);
    },

    max: function (comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function (mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function (comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function (mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function () {
      return this.slice(1);
    },

    skip: function (amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function (amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function (predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function (predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function (mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function (amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function (amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function (predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function (predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function () {
      return this.toIndexedSeq();
    },

    // ### Hashable Object

    hashCode: function () {
      return this.__hash || (this.__hash = hashIterable(this));
    }

    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect = IterablePrototype.toSource = function () {
    return this.toString();
  };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function () {
      return reify(this, flipFactory(this));
    },

    mapEntries: function (mapper, context) {
      var this$0 = this;
      var iterations = 0;
      return reify(this, this.toSeq().map(function (v, k) {
        return mapper.call(context, [k, v], iterations++, this$0);
      }).fromEntrySeq());
    },

    mapKeys: function (mapper, context) {
      var this$0 = this;
      return reify(this, this.toSeq().flip().map(function (k, v) {
        return mapper.call(context, k, v, this$0);
      }).flip());
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function (v, k) {
    return JSON.stringify(k) + ': ' + quoteString(v);
  };

  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function () {
      return new ToKeyedSequence(this, false);
    },

    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function (predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function (predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function (searchValue) {
      var key = this.keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function (searchValue) {
      var key = this.lastKeyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    reverse: function () {
      return reify(this, reverseFactory(this, false));
    },

    slice: function (begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function (index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || numArgs === 2 && !removeNum) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(this, numArgs === 1 ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum)));
    },

    // ### More collection methods

    findLastIndex: function (predicate, context) {
      var entry = this.findLastEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    first: function () {
      return this.get(0);
    },

    flatten: function (depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function (index, notSetValue) {
      index = wrapIndex(this, index);
      return index < 0 || this.size === Infinity || this.size !== undefined && index > this.size ? notSetValue : this.find(function (_, key) {
        return key === index;
      }, undefined, notSetValue);
    },

    has: function (index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ? this.size === Infinity || index < this.size : this.indexOf(index) !== -1);
    },

    interpose: function (separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function () /*...iterables*/{
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    keySeq: function () {
      return Range(0, this.size);
    },

    last: function () {
      return this.get(-1);
    },

    skipWhile: function (predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function () /*, ...iterables */{
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function (zipper /*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;

  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function (value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function (value) {
      return this.has(value);
    },

    // ### More sequential methods

    keySeq: function () {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;
  SetIterable.prototype.contains = SetIterable.prototype.includes;

  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);

  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function () {
      return !predicate.apply(this, arguments);
    };
  }

  function neg(predicate) {
    return function () {
      return -predicate.apply(this, arguments);
    };
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : String(value);
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(keyed ? ordered ? function (v, k) {
      h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
    } : function (v, k) {
      h = h + hashMerge(hash(v), hash(k)) | 0;
    } : ordered ? function (v) {
      h = 31 * h + hash(v) | 0;
    } : function (v) {
      h = h + hash(v) | 0;
    });
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(387);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Provider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "connect", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });






/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2016 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(null, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getLinks; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ready__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__link_header__ = __webpack_require__(439);




var getLinks = function getLinks(response) {
  var value = response.headers.link;

  if (!value) {
    return { refs: [] };
  }

  return __WEBPACK_IMPORTED_MODULE_2__link_header__["a" /* default */].parse(value);
};

var csrfHeader = {};
function setCSRFHeader() {
  var csrfToken = document.querySelector('meta[name=csrf-token]').content;
  csrfHeader['X-CSRF-Token'] = csrfToken;
}
Object(__WEBPACK_IMPORTED_MODULE_1__ready__["default"])(setCSRFHeader);

/* harmony default export */ __webpack_exports__["a"] = (function (getState) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    headers: Object.assign(csrfHeader, getState ? {
      'Authorization': 'Bearer ' + getState().getIn(['meta', 'access_token'], '')
    } : {}),

    transformResponse: [function (data) {
      try {
        return JSON.parse(data);
      } catch (Exception) {
        return data;
      }
    }]
  });
});

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(exports, __webpack_require__(0), __webpack_require__(8)) : typeof define === 'function' && define.amd ? define(['exports', 'react', 'immutable'], factory) : factory(global.window = global.window || {}, global.React, global.Immutable);
})(this, function (exports, React, immutable) {
  'use strict';

  React = React && 'default' in React ? React['default'] : React;

  var _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }return target;
  };

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
      }
    }return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _possibleConstructorReturn(self, call) {
    if (!self) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }return call && (typeof call === "object" || typeof call === "function") ? call : self;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
  }

  /*
    Copyright (C) 2017 Piotr Tomasz Monarski.
    Licensed under the MIT License (MIT), see
    https://github.com/Monar/react-immutable-pure-component
  */

  var ImmutablePureComponent = function (_React$Component) {
    _inherits(ImmutablePureComponent, _React$Component);

    function ImmutablePureComponent() {
      _classCallCheck(this, ImmutablePureComponent);

      return _possibleConstructorReturn(this, (ImmutablePureComponent.__proto__ || Object.getPrototypeOf(ImmutablePureComponent)).apply(this, arguments));
    }

    _createClass(ImmutablePureComponent, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;

        var nextState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        var state = this.state || {};

        return !(this.updateOnProps || Object.keys(_extends({}, nextProps, this.props))).every(function (p) {
          return immutable.is(nextProps[p], _this2.props[p]);
        }) || !(this.updateOnStates || Object.keys(_extends({}, nextState, state))).every(function (s) {
          return immutable.is(nextState[s], state[s]);
        });
      }
    }]);

    return ImmutablePureComponent;
  }(React.Component);

  exports.ImmutablePureComponent = ImmutablePureComponent;
  exports['default'] = ImmutablePureComponent;

  Object.defineProperty(exports, '__esModule', { value: true });
});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * This is a straight rip-off of the React.js ReactPropTypes.js proptype validators,
 * modified to make it possible to validate Immutable.js data.
 *     ImmutableTypes.listOf is patterned after React.PropTypes.arrayOf, but for Immutable.List
 *     ImmutableTypes.shape  is based on React.PropTypes.shape, but for any Immutable.Iterable
 */


var Immutable = __webpack_require__(8);

var ANONYMOUS = "<<anonymous>>";

var ImmutablePropTypes = {
  listOf: createListOfTypeChecker,
  mapOf: createMapOfTypeChecker,
  orderedMapOf: createOrderedMapOfTypeChecker,
  setOf: createSetOfTypeChecker,
  orderedSetOf: createOrderedSetOfTypeChecker,
  stackOf: createStackOfTypeChecker,
  iterableOf: createIterableOfTypeChecker,
  recordOf: createRecordOfTypeChecker,
  shape: createShapeChecker,
  contains: createShapeChecker,
  mapContains: createMapContainsChecker,
  // Primitive Types
  list: createImmutableTypeChecker("List", Immutable.List.isList),
  map: createImmutableTypeChecker("Map", Immutable.Map.isMap),
  orderedMap: createImmutableTypeChecker("OrderedMap", Immutable.OrderedMap.isOrderedMap),
  set: createImmutableTypeChecker("Set", Immutable.Set.isSet),
  orderedSet: createImmutableTypeChecker("OrderedSet", Immutable.OrderedSet.isOrderedSet),
  stack: createImmutableTypeChecker("Stack", Immutable.Stack.isStack),
  seq: createImmutableTypeChecker("Seq", Immutable.Seq.isSeq),
  record: createImmutableTypeChecker("Record", function (isRecord) {
    return isRecord instanceof Immutable.Record;
  }),
  iterable: createImmutableTypeChecker("Iterable", Immutable.Iterable.isIterable)
};

function getPropType(propValue) {
  var propType = typeof propValue;
  if (Array.isArray(propValue)) {
    return "array";
  }
  if (propValue instanceof RegExp) {
    // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
  }
  if (propValue instanceof Immutable.Iterable) {
    return "Immutable." + propValue.toSource().split(" ")[0];
  }
  return propType;
}

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      rest[_key - 6] = arguments[_key];
    }

    propFullName = propFullName || propName;
    componentName = componentName || ANONYMOUS;
    if (props[propName] == null) {
      var locationName = location;
      if (isRequired) {
        return new Error("Required " + locationName + " `" + propFullName + "` was not specified in " + ("`" + componentName + "`."));
      }
    } else {
      return validate.apply(undefined, [props, propName, componentName, location, propFullName].concat(rest));
    }
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

function createImmutableTypeChecker(immutableClassName, immutableClassTypeValidator) {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    if (!immutableClassTypeValidator(propValue)) {
      var propType = getPropType(propValue);
      return new Error("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `" + immutableClassName + "`."));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createIterableTypeChecker(typeChecker, immutableClassName, immutableClassTypeValidator) {

  function validate(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];
    if (!immutableClassTypeValidator(propValue)) {
      var locationName = location;
      var propType = getPropType(propValue);
      return new Error("Invalid " + locationName + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an Immutable.js " + immutableClassName + "."));
    }

    if (typeof typeChecker !== "function") {
      return new Error("Invalid typeChecker supplied to `" + componentName + "` " + ("for propType `" + propFullName + "`, expected a function."));
    }

    var propValues = propValue.toArray();
    for (var i = 0, len = propValues.length; i < len; i++) {
      var error = typeChecker.apply(undefined, [propValues, i, componentName, location, "" + propFullName + "[" + i + "]"].concat(rest));
      if (error instanceof Error) {
        return error;
      }
    }
  }
  return createChainableTypeChecker(validate);
}

function createKeysTypeChecker(typeChecker) {

  function validate(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];
    if (typeof typeChecker !== "function") {
      return new Error("Invalid keysTypeChecker (optional second argument) supplied to `" + componentName + "` " + ("for propType `" + propFullName + "`, expected a function."));
    }

    var keys = propValue.keySeq().toArray();
    for (var i = 0, len = keys.length; i < len; i++) {
      var error = typeChecker.apply(undefined, [keys, i, componentName, location, "" + propFullName + " -> key(" + keys[i] + ")"].concat(rest));
      if (error instanceof Error) {
        return error;
      }
    }
  }
  return createChainableTypeChecker(validate);
}

function createListOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "List", Immutable.List.isList);
}

function createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, immutableClassName, immutableClassTypeValidator) {
  function validate() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return createIterableTypeChecker(valuesTypeChecker, immutableClassName, immutableClassTypeValidator).apply(undefined, args) || keysTypeChecker && createKeysTypeChecker(keysTypeChecker).apply(undefined, args);
  }

  return createChainableTypeChecker(validate);
}

function createMapOfTypeChecker(valuesTypeChecker, keysTypeChecker) {
  return createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, "Map", Immutable.Map.isMap);
}

function createOrderedMapOfTypeChecker(valuesTypeChecker, keysTypeChecker) {
  return createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, "OrderedMap", Immutable.OrderedMap.isOrderedMap);
}

function createSetOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "Set", Immutable.Set.isSet);
}

function createOrderedSetOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "OrderedSet", Immutable.OrderedSet.isOrderedSet);
}

function createStackOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "Stack", Immutable.Stack.isStack);
}

function createIterableOfTypeChecker(typeChecker) {
  return createIterableTypeChecker(typeChecker, "Iterable", Immutable.Iterable.isIterable);
}

function createRecordOfTypeChecker(recordKeys) {
  function validate(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];
    if (!(propValue instanceof Immutable.Record)) {
      var propType = getPropType(propValue);
      var locationName = location;
      return new Error("Invalid " + locationName + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected an Immutable.js Record."));
    }
    for (var key in recordKeys) {
      var checker = recordKeys[key];
      if (!checker) {
        continue;
      }
      var mutablePropValue = propValue.toObject();
      var error = checker.apply(undefined, [mutablePropValue, key, componentName, location, "" + propFullName + "." + key].concat(rest));
      if (error) {
        return error;
      }
    }
  }
  return createChainableTypeChecker(validate);
}

// there is some irony in the fact that shapeTypes is a standard hash and not an immutable collection
function createShapeTypeChecker(shapeTypes) {
  var immutableClassName = arguments[1] === undefined ? "Iterable" : arguments[1];
  var immutableClassTypeValidator = arguments[2] === undefined ? Immutable.Iterable.isIterable : arguments[2];

  function validate(props, propName, componentName, location, propFullName) {
    for (var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    var propValue = props[propName];
    if (!immutableClassTypeValidator(propValue)) {
      var propType = getPropType(propValue);
      var locationName = location;
      return new Error("Invalid " + locationName + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected an Immutable.js " + immutableClassName + "."));
    }
    var mutablePropValue = propValue.toObject();
    for (var key in shapeTypes) {
      var checker = shapeTypes[key];
      if (!checker) {
        continue;
      }
      var error = checker.apply(undefined, [mutablePropValue, key, componentName, location, "" + propFullName + "." + key].concat(rest));
      if (error) {
        return error;
      }
    }
  }
  return createChainableTypeChecker(validate);
}

function createShapeChecker(shapeTypes) {
  return createShapeTypeChecker(shapeTypes);
}

function createMapContainsChecker(shapeTypes) {
  return createShapeTypeChecker(shapeTypes, "Map", Immutable.Map.isMap);
}

module.exports = ImmutablePropTypes;

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return reduceMotion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return autoPlayGif; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return displaySensitiveMedia; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return unfollowModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return boostModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deleteModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return me; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return searchEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return invitesEnabled; });
var element = document.getElementById('initial-state');
var initialState = element && JSON.parse(element.textContent);

var getMeta = function getMeta(prop) {
  return initialState && initialState.meta && initialState.meta[prop];
};

var reduceMotion = getMeta('reduce_motion');
var autoPlayGif = getMeta('auto_play_gif');
var displaySensitiveMedia = getMeta('display_sensitive_media');
var unfollowModal = getMeta('unfollow_modal');
var boostModal = getMeta('boost_modal');
var deleteModal = getMeta('delete_modal');
var me = getMeta('me');
var searchEnabled = getMeta('search_enabled');
var invitesEnabled = getMeta('invites_enabled');

/* harmony default export */ __webpack_exports__["c"] = (initialState);

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACCOUNT_IMPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCOUNTS_IMPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STATUS_IMPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STATUSES_IMPORT; });
/* harmony export (immutable) */ __webpack_exports__["e"] = importAccount;
/* unused harmony export importAccounts */
/* harmony export (immutable) */ __webpack_exports__["j"] = importStatus;
/* unused harmony export importStatuses */
/* harmony export (immutable) */ __webpack_exports__["f"] = importFetchedAccount;
/* harmony export (immutable) */ __webpack_exports__["g"] = importFetchedAccounts;
/* harmony export (immutable) */ __webpack_exports__["h"] = importFetchedStatus;
/* harmony export (immutable) */ __webpack_exports__["i"] = importFetchedStatuses;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__normalizer__ = __webpack_require__(417);
// import { autoPlayGif } from '../../initial_state';
// import { putAccounts, putStatuses } from '../../storage/modifier';


var ACCOUNT_IMPORT = 'ACCOUNT_IMPORT';
var ACCOUNTS_IMPORT = 'ACCOUNTS_IMPORT';
var STATUS_IMPORT = 'STATUS_IMPORT';
var STATUSES_IMPORT = 'STATUSES_IMPORT';

function pushUnique(array, object) {
  if (array.every(function (element) {
    return element.id !== object.id;
  })) {
    array.push(object);
  }
}

function importAccount(account) {
  return { type: ACCOUNT_IMPORT, account: account };
}

function importAccounts(accounts) {
  return { type: ACCOUNTS_IMPORT, accounts: accounts };
}

function importStatus(status) {
  return { type: STATUS_IMPORT, status: status };
}

function importStatuses(statuses) {
  return { type: STATUSES_IMPORT, statuses: statuses };
}

function importFetchedAccount(account) {
  return importFetchedAccounts([account]);
}

function importFetchedAccounts(accounts) {
  var normalAccounts = [];

  function processAccount(account) {
    pushUnique(normalAccounts, Object(__WEBPACK_IMPORTED_MODULE_0__normalizer__["a" /* normalizeAccount */])(account));

    if (account.moved) {
      processAccount(account.moved);
    }
  }

  accounts.forEach(processAccount);
  //putAccounts(normalAccounts, !autoPlayGif);

  return importAccounts(normalAccounts);
}

function importFetchedStatus(status) {
  return importFetchedStatuses([status]);
}

function importFetchedStatuses(statuses) {
  return function (dispatch, getState) {
    var accounts = [];
    var normalStatuses = [];

    function processStatus(status) {
      pushUnique(normalStatuses, Object(__WEBPACK_IMPORTED_MODULE_0__normalizer__["b" /* normalizeStatus */])(status, getState().getIn(['statuses', status.id])));
      pushUnique(accounts, status.account);

      if (status.reblog && status.reblog.id) {
        processStatus(status.reblog);
      }
    }

    statuses.forEach(processStatus);
    //putStatuses(normalStatuses);

    dispatch(importFetchedAccounts(accounts));
    dispatch(importStatuses(normalStatuses));
  };
}

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function () {};

if (false) {
  warning = function (condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.length < 10 || /^[s\W]*$/.test(format)) {
      throw new Error('The warning format should be able to uniquely identify this ' + 'warning. Please, use a more descriptive format than: ' + format);
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' + format.replace(/%s/g, function () {
        return args[argIndex++];
      });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    }
  };
}

module.exports = warning;

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COMPOSE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return COMPOSE_SUBMIT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return COMPOSE_SUBMIT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return COMPOSE_SUBMIT_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return COMPOSE_REPLY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return COMPOSE_REPLY_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COMPOSE_DIRECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return COMPOSE_MENTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return COMPOSE_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return COMPOSE_UPLOAD_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return COMPOSE_UPLOAD_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return COMPOSE_UPLOAD_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return COMPOSE_UPLOAD_PROGRESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return COMPOSE_UPLOAD_UNDO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return COMPOSE_SUGGESTIONS_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return COMPOSE_SUGGESTIONS_READY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return COMPOSE_SUGGESTION_SELECT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return COMPOSE_SUGGESTION_TAGS_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return COMPOSE_TAG_HISTORY_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return COMPOSE_MOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return COMPOSE_UNMOUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return COMPOSE_SENSITIVITY_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return COMPOSE_SPOILERNESS_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return COMPOSE_SPOILER_TEXT_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return COMPOSE_VISIBILITY_CHANGE; });
/* unused harmony export COMPOSE_LISTABILITY_CHANGE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COMPOSE_COMPOSING_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COMPOSE_EMOJI_INSERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return COMPOSE_UPLOAD_CHANGE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return COMPOSE_UPLOAD_CHANGE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return COMPOSE_UPLOAD_CHANGE_FAIL; });
/* harmony export (immutable) */ __webpack_exports__["F"] = changeCompose;
/* harmony export (immutable) */ __webpack_exports__["T"] = replyCompose;
/* harmony export (immutable) */ __webpack_exports__["E"] = cancelReplyCompose;
/* harmony export (immutable) */ __webpack_exports__["U"] = resetCompose;
/* harmony export (immutable) */ __webpack_exports__["R"] = mentionCompose;
/* harmony export (immutable) */ __webpack_exports__["N"] = directCompose;
/* harmony export (immutable) */ __webpack_exports__["W"] = submitCompose;
/* unused harmony export submitComposeRequest */
/* unused harmony export submitComposeSuccess */
/* unused harmony export submitComposeFail */
/* harmony export (immutable) */ __webpack_exports__["Z"] = uploadCompose;
/* harmony export (immutable) */ __webpack_exports__["L"] = changeUploadCompose;
/* unused harmony export changeUploadComposeRequest */
/* unused harmony export changeUploadComposeSuccess */
/* unused harmony export changeUploadComposeFail */
/* unused harmony export uploadComposeRequest */
/* unused harmony export uploadComposeProgress */
/* unused harmony export uploadComposeSuccess */
/* unused harmony export uploadComposeFail */
/* harmony export (immutable) */ __webpack_exports__["X"] = undoUploadCompose;
/* harmony export (immutable) */ __webpack_exports__["M"] = clearComposeSuggestions;
/* harmony export (immutable) */ __webpack_exports__["O"] = fetchComposeSuggestions;
/* unused harmony export readyComposeSuggestionsEmojis */
/* unused harmony export readyComposeSuggestionsAccounts */
/* harmony export (immutable) */ __webpack_exports__["V"] = selectComposeSuggestion;
/* unused harmony export updateSuggestionTags */
/* unused harmony export updateTagHistory */
/* harmony export (immutable) */ __webpack_exports__["P"] = hydrateCompose;
/* harmony export (immutable) */ __webpack_exports__["S"] = mountCompose;
/* harmony export (immutable) */ __webpack_exports__["Y"] = unmountCompose;
/* harmony export (immutable) */ __webpack_exports__["G"] = changeComposeSensitivity;
/* harmony export (immutable) */ __webpack_exports__["I"] = changeComposeSpoilerness;
/* harmony export (immutable) */ __webpack_exports__["H"] = changeComposeSpoilerText;
/* harmony export (immutable) */ __webpack_exports__["J"] = changeComposeVisibility;
/* harmony export (immutable) */ __webpack_exports__["Q"] = insertEmojiCompose;
/* harmony export (immutable) */ __webpack_exports__["K"] = changeComposing;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__features_emoji_emoji_mart_search_light__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__settings__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__emojis__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_resize_image__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__importer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__timelines__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__alerts__ = __webpack_require__(33);













var cancelFetchComposeSuggestionsAccounts = void 0;

var COMPOSE_CHANGE = 'COMPOSE_CHANGE';
var COMPOSE_SUBMIT_REQUEST = 'COMPOSE_SUBMIT_REQUEST';
var COMPOSE_SUBMIT_SUCCESS = 'COMPOSE_SUBMIT_SUCCESS';
var COMPOSE_SUBMIT_FAIL = 'COMPOSE_SUBMIT_FAIL';
var COMPOSE_REPLY = 'COMPOSE_REPLY';
var COMPOSE_REPLY_CANCEL = 'COMPOSE_REPLY_CANCEL';
var COMPOSE_DIRECT = 'COMPOSE_DIRECT';
var COMPOSE_MENTION = 'COMPOSE_MENTION';
var COMPOSE_RESET = 'COMPOSE_RESET';
var COMPOSE_UPLOAD_REQUEST = 'COMPOSE_UPLOAD_REQUEST';
var COMPOSE_UPLOAD_SUCCESS = 'COMPOSE_UPLOAD_SUCCESS';
var COMPOSE_UPLOAD_FAIL = 'COMPOSE_UPLOAD_FAIL';
var COMPOSE_UPLOAD_PROGRESS = 'COMPOSE_UPLOAD_PROGRESS';
var COMPOSE_UPLOAD_UNDO = 'COMPOSE_UPLOAD_UNDO';

var COMPOSE_SUGGESTIONS_CLEAR = 'COMPOSE_SUGGESTIONS_CLEAR';
var COMPOSE_SUGGESTIONS_READY = 'COMPOSE_SUGGESTIONS_READY';
var COMPOSE_SUGGESTION_SELECT = 'COMPOSE_SUGGESTION_SELECT';
var COMPOSE_SUGGESTION_TAGS_UPDATE = 'COMPOSE_SUGGESTION_TAGS_UPDATE';

var COMPOSE_TAG_HISTORY_UPDATE = 'COMPOSE_TAG_HISTORY_UPDATE';

var COMPOSE_MOUNT = 'COMPOSE_MOUNT';
var COMPOSE_UNMOUNT = 'COMPOSE_UNMOUNT';

var COMPOSE_SENSITIVITY_CHANGE = 'COMPOSE_SENSITIVITY_CHANGE';
var COMPOSE_SPOILERNESS_CHANGE = 'COMPOSE_SPOILERNESS_CHANGE';
var COMPOSE_SPOILER_TEXT_CHANGE = 'COMPOSE_SPOILER_TEXT_CHANGE';
var COMPOSE_VISIBILITY_CHANGE = 'COMPOSE_VISIBILITY_CHANGE';
var COMPOSE_LISTABILITY_CHANGE = 'COMPOSE_LISTABILITY_CHANGE';
var COMPOSE_COMPOSING_CHANGE = 'COMPOSE_COMPOSING_CHANGE';

var COMPOSE_EMOJI_INSERT = 'COMPOSE_EMOJI_INSERT';

var COMPOSE_UPLOAD_CHANGE_REQUEST = 'COMPOSE_UPLOAD_UPDATE_REQUEST';
var COMPOSE_UPLOAD_CHANGE_SUCCESS = 'COMPOSE_UPLOAD_UPDATE_SUCCESS';
var COMPOSE_UPLOAD_CHANGE_FAIL = 'COMPOSE_UPLOAD_UPDATE_FAIL';

function changeCompose(text) {
  return {
    type: COMPOSE_CHANGE,
    text: text
  };
};

function replyCompose(status, router) {
  return function (dispatch, getState) {
    dispatch({
      type: COMPOSE_REPLY,
      status: status
    });

    if (!getState().getIn(['compose', 'mounted'])) {
      router.push('/statuses/new');
    }
  };
};

function cancelReplyCompose() {
  return {
    type: COMPOSE_REPLY_CANCEL
  };
};

function resetCompose() {
  return {
    type: COMPOSE_RESET
  };
};

function mentionCompose(account, router) {
  return function (dispatch, getState) {
    dispatch({
      type: COMPOSE_MENTION,
      account: account
    });

    if (!getState().getIn(['compose', 'mounted'])) {
      router.push('/statuses/new');
    }
  };
};

function directCompose(account, router) {
  return function (dispatch, getState) {
    dispatch({
      type: COMPOSE_DIRECT,
      account: account
    });

    if (!getState().getIn(['compose', 'mounted'])) {
      router.push('/statuses/new');
    }
  };
};

function submitCompose() {
  return function (dispatch, getState) {
    var status = getState().getIn(['compose', 'text'], '');
    var media = getState().getIn(['compose', 'media_attachments']);

    if ((!status || !status.length) && media.size === 0) {
      return;
    }

    dispatch(submitComposeRequest());

    Object(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */])(getState).post('/api/v1/statuses', {
      status: status,
      in_reply_to_id: getState().getIn(['compose', 'in_reply_to'], null),
      media_ids: media.map(function (item) {
        return item.get('id');
      }),
      sensitive: getState().getIn(['compose', 'sensitive']),
      spoiler_text: getState().getIn(['compose', 'spoiler_text'], ''),
      visibility: getState().getIn(['compose', 'privacy'])
    }, {
      headers: {
        'Idempotency-Key': getState().getIn(['compose', 'idempotencyKey'])
      }
    }).then(function (response) {
      dispatch(insertIntoTagHistory(response.data.tags));
      dispatch(submitComposeSuccess(Object.assign({}, response.data)));

      // To make the app more responsive, immediately get the status into the columns

      var insertIfOnline = function insertIfOnline(timelineId) {
        if (getState().getIn(['timelines', timelineId, 'items', 0]) !== null) {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_9__timelines__["t" /* updateTimeline */])(timelineId, Object.assign({}, response.data)));
        }
      };

      insertIfOnline('home');

      if (response.data.in_reply_to_id === null && response.data.visibility === 'public') {
        insertIfOnline('community');
        insertIfOnline('public');
      } else if (response.data.visibility === 'direct') {
        insertIfOnline('direct');
      }
    }).catch(function (error) {
      dispatch(submitComposeFail(error));
    });
  };
};

function submitComposeRequest() {
  return {
    type: COMPOSE_SUBMIT_REQUEST
  };
};

function submitComposeSuccess(status) {
  return {
    type: COMPOSE_SUBMIT_SUCCESS,
    status: status
  };
};

function submitComposeFail(error) {
  return {
    type: COMPOSE_SUBMIT_FAIL,
    error: error
  };
};

function uploadCompose(files) {
  return function (dispatch, getState) {
    if (getState().getIn(['compose', 'media_attachments']).size > 3) {
      return;
    }

    dispatch(uploadComposeRequest());

    Object(__WEBPACK_IMPORTED_MODULE_7__utils_resize_image__["a" /* default */])(files[0]).then(function (file) {
      var data = new FormData();
      data.append('file', file);

      return Object(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */])(getState).post('/api/v1/media', data, {
        onUploadProgress: function onUploadProgress(_ref) {
          var loaded = _ref.loaded,
              total = _ref.total;
          return dispatch(uploadComposeProgress(loaded, total));
        }
      }).then(function (_ref2) {
        var data = _ref2.data;
        return dispatch(uploadComposeSuccess(data));
      });
    }).catch(function (error) {
      return dispatch(uploadComposeFail(error));
    });
  };
};

function changeUploadCompose(id, params) {
  return function (dispatch, getState) {
    dispatch(changeUploadComposeRequest());

    Object(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */])(getState).put('/api/v1/media/' + id, params).then(function (response) {
      dispatch(changeUploadComposeSuccess(response.data));
    }).catch(function (error) {
      dispatch(changeUploadComposeFail(id, error));
    });
  };
};

function changeUploadComposeRequest() {
  return {
    type: COMPOSE_UPLOAD_CHANGE_REQUEST,
    skipLoading: true
  };
};
function changeUploadComposeSuccess(media) {
  return {
    type: COMPOSE_UPLOAD_CHANGE_SUCCESS,
    media: media,
    skipLoading: true
  };
};

function changeUploadComposeFail(error) {
  return {
    type: COMPOSE_UPLOAD_CHANGE_FAIL,
    error: error,
    skipLoading: true
  };
};

function uploadComposeRequest() {
  return {
    type: COMPOSE_UPLOAD_REQUEST,
    skipLoading: true
  };
};

function uploadComposeProgress(loaded, total) {
  return {
    type: COMPOSE_UPLOAD_PROGRESS,
    loaded: loaded,
    total: total
  };
};

function uploadComposeSuccess(media) {
  return {
    type: COMPOSE_UPLOAD_SUCCESS,
    media: media,
    skipLoading: true
  };
};

function uploadComposeFail(error) {
  return {
    type: COMPOSE_UPLOAD_FAIL,
    error: error,
    skipLoading: true
  };
};

function undoUploadCompose(media_id) {
  return {
    type: COMPOSE_UPLOAD_UNDO,
    media_id: media_id
  };
};

function clearComposeSuggestions() {
  if (cancelFetchComposeSuggestionsAccounts) {
    cancelFetchComposeSuggestionsAccounts();
  }
  return {
    type: COMPOSE_SUGGESTIONS_CLEAR
  };
};

var fetchComposeSuggestionsAccounts = __WEBPACK_IMPORTED_MODULE_1_lodash_throttle___default()(function (dispatch, getState, token) {
  if (cancelFetchComposeSuggestionsAccounts) {
    cancelFetchComposeSuggestionsAccounts();
  }
  Object(__WEBPACK_IMPORTED_MODULE_2__api__["a" /* default */])(getState).get('/api/v1/accounts/search', {
    cancelToken: new __WEBPACK_IMPORTED_MODULE_3_axios__["CancelToken"](function (cancel) {
      cancelFetchComposeSuggestionsAccounts = cancel;
    }),
    params: {
      q: token.slice(1),
      resolve: false,
      limit: 4
    }
  }).then(function (response) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_8__importer__["g" /* importFetchedAccounts */])(response.data));
    dispatch(readyComposeSuggestionsAccounts(token, response.data));
  }).catch(function (error) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_3_axios__["isCancel"])(error)) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__alerts__["e" /* showAlertForError */])(error));
    }
  });
}, 200, { leading: true, trailing: true });

var fetchComposeSuggestionsEmojis = function fetchComposeSuggestionsEmojis(dispatch, getState, token) {
  var results = Object(__WEBPACK_IMPORTED_MODULE_4__features_emoji_emoji_mart_search_light__["a" /* search */])(token.replace(':', ''), { maxResults: 5 });
  dispatch(readyComposeSuggestionsEmojis(token, results));
};

var fetchComposeSuggestionsTags = function fetchComposeSuggestionsTags(dispatch, getState, token) {
  dispatch(updateSuggestionTags(token));
};

function fetchComposeSuggestions(token) {
  return function (dispatch, getState) {
    switch (token[0]) {
      case ':':
        fetchComposeSuggestionsEmojis(dispatch, getState, token);
        break;
      case '#':
        fetchComposeSuggestionsTags(dispatch, getState, token);
        break;
      default:
        fetchComposeSuggestionsAccounts(dispatch, getState, token);
        break;
    }
  };
};

function readyComposeSuggestionsEmojis(token, emojis) {
  return {
    type: COMPOSE_SUGGESTIONS_READY,
    token: token,
    emojis: emojis
  };
};

function readyComposeSuggestionsAccounts(token, accounts) {
  return {
    type: COMPOSE_SUGGESTIONS_READY,
    token: token,
    accounts: accounts
  };
};

function selectComposeSuggestion(position, token, suggestion) {
  return function (dispatch, getState) {
    var completion = void 0,
        startPosition = void 0;

    if ((typeof suggestion === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(suggestion)) === 'object' && suggestion.id) {
      completion = suggestion.native || suggestion.colons;
      startPosition = position - 1;

      dispatch(Object(__WEBPACK_IMPORTED_MODULE_6__emojis__["b" /* useEmoji */])(suggestion));
    } else if (suggestion[0] === '#') {
      completion = suggestion;
      startPosition = position - 1;
    } else {
      completion = getState().getIn(['accounts', suggestion, 'acct']);
      startPosition = position;
    }

    dispatch({
      type: COMPOSE_SUGGESTION_SELECT,
      position: startPosition,
      token: token,
      completion: completion
    });
  };
};

function updateSuggestionTags(token) {
  return {
    type: COMPOSE_SUGGESTION_TAGS_UPDATE,
    token: token
  };
}

function updateTagHistory(tags) {
  return {
    type: COMPOSE_TAG_HISTORY_UPDATE,
    tags: tags
  };
}

function hydrateCompose() {
  return function (dispatch, getState) {
    var me = getState().getIn(['meta', 'me']);
    var history = __WEBPACK_IMPORTED_MODULE_5__settings__["b" /* tagHistory */].get(me);

    if (history !== null) {
      dispatch(updateTagHistory(history));
    }
  };
}

function insertIntoTagHistory(tags) {
  return function (dispatch, getState) {
    var state = getState();
    var oldHistory = state.getIn(['compose', 'tagHistory']);
    var me = state.getIn(['meta', 'me']);
    var names = tags.map(function (_ref3) {
      var name = _ref3.name;
      return name;
    });
    var intersectedOldHistory = oldHistory.filter(function (name) {
      return !names.includes(name);
    });

    names.push.apply(names, intersectedOldHistory.toJS());

    var newHistory = names.slice(0, 1000);

    __WEBPACK_IMPORTED_MODULE_5__settings__["b" /* tagHistory */].set(me, newHistory);
    dispatch(updateTagHistory(newHistory));
  };
}

function mountCompose() {
  return {
    type: COMPOSE_MOUNT
  };
};

function unmountCompose() {
  return {
    type: COMPOSE_UNMOUNT
  };
};

function changeComposeSensitivity() {
  return {
    type: COMPOSE_SENSITIVITY_CHANGE
  };
};

function changeComposeSpoilerness() {
  return {
    type: COMPOSE_SPOILERNESS_CHANGE
  };
};

function changeComposeSpoilerText(text) {
  return {
    type: COMPOSE_SPOILER_TEXT_CHANGE,
    text: text
  };
};

function changeComposeVisibility(value) {
  return {
    type: COMPOSE_VISIBILITY_CHANGE,
    value: value
  };
};

function insertEmojiCompose(position, emoji, needsSpace) {
  return {
    type: COMPOSE_EMOJI_INSERT,
    position: position,
    emoji: emoji,
    needsSpace: needsSpace
  };
};

function changeComposing(value) {
  return {
    type: COMPOSE_COMPOSING_CHANGE,
    value: value
  };
}

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function (condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TIMELINE_UPDATE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TIMELINE_DELETE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TIMELINE_EXPAND_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TIMELINE_EXPAND_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TIMELINE_EXPAND_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TIMELINE_SCROLL_TOP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TIMELINE_DISCONNECT; });
/* harmony export (immutable) */ __webpack_exports__["t"] = updateTimeline;
/* harmony export (immutable) */ __webpack_exports__["h"] = deleteFromTimelines;
/* unused harmony export expandTimeline */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return expandHomeTimeline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return expandPublicTimeline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return expandCommunityTimeline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return expandDirectTimeline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return expandAccountTimeline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return expandAccountFeaturedTimeline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return expandAccountMediaTimeline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return expandHashtagTimeline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return expandListTimeline; });
/* unused harmony export expandTimelineRequest */
/* unused harmony export expandTimelineSuccess */
/* unused harmony export expandTimelineFail */
/* harmony export (immutable) */ __webpack_exports__["s"] = scrollTopTimeline;
/* harmony export (immutable) */ __webpack_exports__["i"] = disconnectTimeline;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__importer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);




var TIMELINE_UPDATE = 'TIMELINE_UPDATE';
var TIMELINE_DELETE = 'TIMELINE_DELETE';

var TIMELINE_EXPAND_REQUEST = 'TIMELINE_EXPAND_REQUEST';
var TIMELINE_EXPAND_SUCCESS = 'TIMELINE_EXPAND_SUCCESS';
var TIMELINE_EXPAND_FAIL = 'TIMELINE_EXPAND_FAIL';

var TIMELINE_SCROLL_TOP = 'TIMELINE_SCROLL_TOP';

var TIMELINE_DISCONNECT = 'TIMELINE_DISCONNECT';

function updateTimeline(timeline, status) {
  return function (dispatch, getState) {
    var references = status.reblog ? getState().get('statuses').filter(function (item, itemId) {
      return itemId === status.reblog.id || item.get('reblog') === status.reblog.id;
    }).map(function (_, itemId) {
      return itemId;
    }) : [];

    dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__importer__["h" /* importFetchedStatus */])(status));

    dispatch({
      type: TIMELINE_UPDATE,
      timeline: timeline,
      status: status,
      references: references
    });
  };
};

function deleteFromTimelines(id) {
  return function (dispatch, getState) {
    var accountId = getState().getIn(['statuses', id, 'account']);
    var references = getState().get('statuses').filter(function (status) {
      return status.get('reblog') === id;
    }).map(function (status) {
      return [status.get('id'), status.get('account')];
    });
    var reblogOf = getState().getIn(['statuses', id, 'reblog'], null);

    dispatch({
      type: TIMELINE_DELETE,
      id: id,
      accountId: accountId,
      references: references,
      reblogOf: reblogOf
    });
  };
};

var noOp = function noOp() {};

function expandTimeline(timelineId, path) {
  var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var done = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : noOp;

  return function (dispatch, getState) {
    var timeline = getState().getIn(['timelines', timelineId], Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());

    if (timeline.get('isLoading')) {
      done();
      return;
    }

    if (!params.max_id && timeline.get('items', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])()).size > 0) {
      params.since_id = timeline.getIn(['items', 0]);
    }

    dispatch(expandTimelineRequest(timelineId));

    Object(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */])(getState).get(path, { params: params }).then(function (response) {
      var next = Object(__WEBPACK_IMPORTED_MODULE_1__api__["b" /* getLinks */])(response).refs.find(function (link) {
        return link.rel === 'next';
      });
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__importer__["i" /* importFetchedStatuses */])(response.data));
      dispatch(expandTimelineSuccess(timelineId, response.data, next ? next.uri : null, response.code === 206));
      done();
    }).catch(function (error) {
      dispatch(expandTimelineFail(timelineId, error));
      done();
    });
  };
};

var expandHomeTimeline = function expandHomeTimeline() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      maxId = _ref.maxId;

  var done = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noOp;
  return expandTimeline('home', '/api/v1/timelines/home', { max_id: maxId }, done);
};
var expandPublicTimeline = function expandPublicTimeline() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      maxId = _ref2.maxId,
      onlyMedia = _ref2.onlyMedia;

  var done = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noOp;
  return expandTimeline('public' + (onlyMedia ? ':media' : ''), '/api/v1/timelines/public', { max_id: maxId, only_media: !!onlyMedia }, done);
};
var expandCommunityTimeline = function expandCommunityTimeline() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      maxId = _ref3.maxId,
      onlyMedia = _ref3.onlyMedia;

  var done = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noOp;
  return expandTimeline('community' + (onlyMedia ? ':media' : ''), '/api/v1/timelines/public', { local: true, max_id: maxId, only_media: !!onlyMedia }, done);
};
var expandDirectTimeline = function expandDirectTimeline() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      maxId = _ref4.maxId;

  var done = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noOp;
  return expandTimeline('direct', '/api/v1/timelines/direct', { max_id: maxId }, done);
};
var expandAccountTimeline = function expandAccountTimeline(accountId) {
  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      maxId = _ref5.maxId,
      withReplies = _ref5.withReplies;

  return expandTimeline('account:' + accountId + (withReplies ? ':with_replies' : ''), '/api/v1/accounts/' + accountId + '/statuses', { exclude_replies: !withReplies, max_id: maxId });
};
var expandAccountFeaturedTimeline = function expandAccountFeaturedTimeline(accountId) {
  return expandTimeline('account:' + accountId + ':pinned', '/api/v1/accounts/' + accountId + '/statuses', { pinned: true });
};
var expandAccountMediaTimeline = function expandAccountMediaTimeline(accountId) {
  var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      maxId = _ref6.maxId;

  return expandTimeline('account:' + accountId + ':media', '/api/v1/accounts/' + accountId + '/statuses', { max_id: maxId, only_media: true });
};
var expandHashtagTimeline = function expandHashtagTimeline(hashtag) {
  var _ref7 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      maxId = _ref7.maxId;

  var done = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noOp;
  return expandTimeline('hashtag:' + hashtag, '/api/v1/timelines/tag/' + hashtag, { max_id: maxId }, done);
};
var expandListTimeline = function expandListTimeline(id) {
  var _ref8 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      maxId = _ref8.maxId;

  var done = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : noOp;
  return expandTimeline('list:' + id, '/api/v1/timelines/list/' + id, { max_id: maxId }, done);
};

function expandTimelineRequest(timeline) {
  return {
    type: TIMELINE_EXPAND_REQUEST,
    timeline: timeline
  };
};

function expandTimelineSuccess(timeline, statuses, next, partial) {
  return {
    type: TIMELINE_EXPAND_SUCCESS,
    timeline: timeline,
    statuses: statuses,
    next: next,
    partial: partial
  };
};

function expandTimelineFail(timeline, error) {
  return {
    type: TIMELINE_EXPAND_FAIL,
    timeline: timeline,
    error: error
  };
};

function scrollTopTimeline(timeline, top) {
  return {
    type: TIMELINE_SCROLL_TOP,
    timeline: timeline,
    top: top
  };
};

function disconnectTimeline(timeline) {
  return {
    type: TIMELINE_DISCONNECT,
    timeline: timeline
  };
};

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(376);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(195);
var isBuffer = __webpack_require__(422);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return typeof FormData !== 'undefined' && val instanceof FormData;
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
    result = ArrayBuffer.isView(val);
  } else {
    result = val && val.buffer && val.buffer instanceof ArrayBuffer;
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return typeof window !== 'undefined' && typeof document !== 'undefined';
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object' && !isArray(obj)) {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge() /* obj1, obj2, obj3, ... */{
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ACCOUNT_FETCH_REQUEST */
/* unused harmony export ACCOUNT_FETCH_SUCCESS */
/* unused harmony export ACCOUNT_FETCH_FAIL */
/* unused harmony export ACCOUNT_FOLLOW_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACCOUNT_FOLLOW_SUCCESS; });
/* unused harmony export ACCOUNT_FOLLOW_FAIL */
/* unused harmony export ACCOUNT_UNFOLLOW_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ACCOUNT_UNFOLLOW_SUCCESS; });
/* unused harmony export ACCOUNT_UNFOLLOW_FAIL */
/* unused harmony export ACCOUNT_BLOCK_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACCOUNT_BLOCK_SUCCESS; });
/* unused harmony export ACCOUNT_BLOCK_FAIL */
/* unused harmony export ACCOUNT_UNBLOCK_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ACCOUNT_UNBLOCK_SUCCESS; });
/* unused harmony export ACCOUNT_UNBLOCK_FAIL */
/* unused harmony export ACCOUNT_MUTE_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ACCOUNT_MUTE_SUCCESS; });
/* unused harmony export ACCOUNT_MUTE_FAIL */
/* unused harmony export ACCOUNT_UNMUTE_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ACCOUNT_UNMUTE_SUCCESS; });
/* unused harmony export ACCOUNT_UNMUTE_FAIL */
/* unused harmony export FOLLOWERS_FETCH_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return FOLLOWERS_FETCH_SUCCESS; });
/* unused harmony export FOLLOWERS_FETCH_FAIL */
/* unused harmony export FOLLOWERS_EXPAND_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return FOLLOWERS_EXPAND_SUCCESS; });
/* unused harmony export FOLLOWERS_EXPAND_FAIL */
/* unused harmony export FOLLOWING_FETCH_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return FOLLOWING_FETCH_SUCCESS; });
/* unused harmony export FOLLOWING_FETCH_FAIL */
/* unused harmony export FOLLOWING_EXPAND_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return FOLLOWING_EXPAND_SUCCESS; });
/* unused harmony export FOLLOWING_EXPAND_FAIL */
/* unused harmony export RELATIONSHIPS_FETCH_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return RELATIONSHIPS_FETCH_SUCCESS; });
/* unused harmony export RELATIONSHIPS_FETCH_FAIL */
/* unused harmony export FOLLOW_REQUESTS_FETCH_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return FOLLOW_REQUESTS_FETCH_SUCCESS; });
/* unused harmony export FOLLOW_REQUESTS_FETCH_FAIL */
/* unused harmony export FOLLOW_REQUESTS_EXPAND_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return FOLLOW_REQUESTS_EXPAND_SUCCESS; });
/* unused harmony export FOLLOW_REQUESTS_EXPAND_FAIL */
/* unused harmony export FOLLOW_REQUEST_AUTHORIZE_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return FOLLOW_REQUEST_AUTHORIZE_SUCCESS; });
/* unused harmony export FOLLOW_REQUEST_AUTHORIZE_FAIL */
/* unused harmony export FOLLOW_REQUEST_REJECT_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return FOLLOW_REQUEST_REJECT_SUCCESS; });
/* unused harmony export FOLLOW_REQUEST_REJECT_FAIL */
/* harmony export (immutable) */ __webpack_exports__["u"] = fetchAccount;
/* unused harmony export fetchAccountRequest */
/* unused harmony export fetchAccountSuccess */
/* unused harmony export fetchAccountFail */
/* harmony export (immutable) */ __webpack_exports__["z"] = followAccount;
/* harmony export (immutable) */ __webpack_exports__["D"] = unfollowAccount;
/* unused harmony export followAccountRequest */
/* unused harmony export followAccountSuccess */
/* unused harmony export followAccountFail */
/* unused harmony export unfollowAccountRequest */
/* unused harmony export unfollowAccountSuccess */
/* unused harmony export unfollowAccountFail */
/* harmony export (immutable) */ __webpack_exports__["q"] = blockAccount;
/* harmony export (immutable) */ __webpack_exports__["C"] = unblockAccount;
/* unused harmony export blockAccountRequest */
/* unused harmony export blockAccountSuccess */
/* unused harmony export blockAccountFail */
/* unused harmony export unblockAccountRequest */
/* unused harmony export unblockAccountSuccess */
/* unused harmony export unblockAccountFail */
/* harmony export (immutable) */ __webpack_exports__["A"] = muteAccount;
/* harmony export (immutable) */ __webpack_exports__["E"] = unmuteAccount;
/* unused harmony export muteAccountRequest */
/* unused harmony export muteAccountSuccess */
/* unused harmony export muteAccountFail */
/* unused harmony export unmuteAccountRequest */
/* unused harmony export unmuteAccountSuccess */
/* unused harmony export unmuteAccountFail */
/* harmony export (immutable) */ __webpack_exports__["w"] = fetchFollowers;
/* unused harmony export fetchFollowersRequest */
/* unused harmony export fetchFollowersSuccess */
/* unused harmony export fetchFollowersFail */
/* harmony export (immutable) */ __webpack_exports__["s"] = expandFollowers;
/* unused harmony export expandFollowersRequest */
/* unused harmony export expandFollowersSuccess */
/* unused harmony export expandFollowersFail */
/* harmony export (immutable) */ __webpack_exports__["x"] = fetchFollowing;
/* unused harmony export fetchFollowingRequest */
/* unused harmony export fetchFollowingSuccess */
/* unused harmony export fetchFollowingFail */
/* harmony export (immutable) */ __webpack_exports__["t"] = expandFollowing;
/* unused harmony export expandFollowingRequest */
/* unused harmony export expandFollowingSuccess */
/* unused harmony export expandFollowingFail */
/* harmony export (immutable) */ __webpack_exports__["y"] = fetchRelationships;
/* unused harmony export fetchRelationshipsRequest */
/* unused harmony export fetchRelationshipsSuccess */
/* unused harmony export fetchRelationshipsFail */
/* harmony export (immutable) */ __webpack_exports__["v"] = fetchFollowRequests;
/* unused harmony export fetchFollowRequestsRequest */
/* unused harmony export fetchFollowRequestsSuccess */
/* unused harmony export fetchFollowRequestsFail */
/* harmony export (immutable) */ __webpack_exports__["r"] = expandFollowRequests;
/* unused harmony export expandFollowRequestsRequest */
/* unused harmony export expandFollowRequestsSuccess */
/* unused harmony export expandFollowRequestsFail */
/* harmony export (immutable) */ __webpack_exports__["p"] = authorizeFollowRequest;
/* unused harmony export authorizeFollowRequestRequest */
/* unused harmony export authorizeFollowRequestSuccess */
/* unused harmony export authorizeFollowRequestFail */
/* harmony export (immutable) */ __webpack_exports__["B"] = rejectFollowRequest;
/* unused harmony export rejectFollowRequestRequest */
/* unused harmony export rejectFollowRequestSuccess */
/* unused harmony export rejectFollowRequestFail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__storage_db__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__importer__ = __webpack_require__(15);




var ACCOUNT_FETCH_REQUEST = 'ACCOUNT_FETCH_REQUEST';
var ACCOUNT_FETCH_SUCCESS = 'ACCOUNT_FETCH_SUCCESS';
var ACCOUNT_FETCH_FAIL = 'ACCOUNT_FETCH_FAIL';

var ACCOUNT_FOLLOW_REQUEST = 'ACCOUNT_FOLLOW_REQUEST';
var ACCOUNT_FOLLOW_SUCCESS = 'ACCOUNT_FOLLOW_SUCCESS';
var ACCOUNT_FOLLOW_FAIL = 'ACCOUNT_FOLLOW_FAIL';

var ACCOUNT_UNFOLLOW_REQUEST = 'ACCOUNT_UNFOLLOW_REQUEST';
var ACCOUNT_UNFOLLOW_SUCCESS = 'ACCOUNT_UNFOLLOW_SUCCESS';
var ACCOUNT_UNFOLLOW_FAIL = 'ACCOUNT_UNFOLLOW_FAIL';

var ACCOUNT_BLOCK_REQUEST = 'ACCOUNT_BLOCK_REQUEST';
var ACCOUNT_BLOCK_SUCCESS = 'ACCOUNT_BLOCK_SUCCESS';
var ACCOUNT_BLOCK_FAIL = 'ACCOUNT_BLOCK_FAIL';

var ACCOUNT_UNBLOCK_REQUEST = 'ACCOUNT_UNBLOCK_REQUEST';
var ACCOUNT_UNBLOCK_SUCCESS = 'ACCOUNT_UNBLOCK_SUCCESS';
var ACCOUNT_UNBLOCK_FAIL = 'ACCOUNT_UNBLOCK_FAIL';

var ACCOUNT_MUTE_REQUEST = 'ACCOUNT_MUTE_REQUEST';
var ACCOUNT_MUTE_SUCCESS = 'ACCOUNT_MUTE_SUCCESS';
var ACCOUNT_MUTE_FAIL = 'ACCOUNT_MUTE_FAIL';

var ACCOUNT_UNMUTE_REQUEST = 'ACCOUNT_UNMUTE_REQUEST';
var ACCOUNT_UNMUTE_SUCCESS = 'ACCOUNT_UNMUTE_SUCCESS';
var ACCOUNT_UNMUTE_FAIL = 'ACCOUNT_UNMUTE_FAIL';

var FOLLOWERS_FETCH_REQUEST = 'FOLLOWERS_FETCH_REQUEST';
var FOLLOWERS_FETCH_SUCCESS = 'FOLLOWERS_FETCH_SUCCESS';
var FOLLOWERS_FETCH_FAIL = 'FOLLOWERS_FETCH_FAIL';

var FOLLOWERS_EXPAND_REQUEST = 'FOLLOWERS_EXPAND_REQUEST';
var FOLLOWERS_EXPAND_SUCCESS = 'FOLLOWERS_EXPAND_SUCCESS';
var FOLLOWERS_EXPAND_FAIL = 'FOLLOWERS_EXPAND_FAIL';

var FOLLOWING_FETCH_REQUEST = 'FOLLOWING_FETCH_REQUEST';
var FOLLOWING_FETCH_SUCCESS = 'FOLLOWING_FETCH_SUCCESS';
var FOLLOWING_FETCH_FAIL = 'FOLLOWING_FETCH_FAIL';

var FOLLOWING_EXPAND_REQUEST = 'FOLLOWING_EXPAND_REQUEST';
var FOLLOWING_EXPAND_SUCCESS = 'FOLLOWING_EXPAND_SUCCESS';
var FOLLOWING_EXPAND_FAIL = 'FOLLOWING_EXPAND_FAIL';

var RELATIONSHIPS_FETCH_REQUEST = 'RELATIONSHIPS_FETCH_REQUEST';
var RELATIONSHIPS_FETCH_SUCCESS = 'RELATIONSHIPS_FETCH_SUCCESS';
var RELATIONSHIPS_FETCH_FAIL = 'RELATIONSHIPS_FETCH_FAIL';

var FOLLOW_REQUESTS_FETCH_REQUEST = 'FOLLOW_REQUESTS_FETCH_REQUEST';
var FOLLOW_REQUESTS_FETCH_SUCCESS = 'FOLLOW_REQUESTS_FETCH_SUCCESS';
var FOLLOW_REQUESTS_FETCH_FAIL = 'FOLLOW_REQUESTS_FETCH_FAIL';

var FOLLOW_REQUESTS_EXPAND_REQUEST = 'FOLLOW_REQUESTS_EXPAND_REQUEST';
var FOLLOW_REQUESTS_EXPAND_SUCCESS = 'FOLLOW_REQUESTS_EXPAND_SUCCESS';
var FOLLOW_REQUESTS_EXPAND_FAIL = 'FOLLOW_REQUESTS_EXPAND_FAIL';

var FOLLOW_REQUEST_AUTHORIZE_REQUEST = 'FOLLOW_REQUEST_AUTHORIZE_REQUEST';
var FOLLOW_REQUEST_AUTHORIZE_SUCCESS = 'FOLLOW_REQUEST_AUTHORIZE_SUCCESS';
var FOLLOW_REQUEST_AUTHORIZE_FAIL = 'FOLLOW_REQUEST_AUTHORIZE_FAIL';

var FOLLOW_REQUEST_REJECT_REQUEST = 'FOLLOW_REQUEST_REJECT_REQUEST';
var FOLLOW_REQUEST_REJECT_SUCCESS = 'FOLLOW_REQUEST_REJECT_SUCCESS';
var FOLLOW_REQUEST_REJECT_FAIL = 'FOLLOW_REQUEST_REJECT_FAIL';

function getFromDB(dispatch, getState, index, id) {
  return new Promise(function (resolve, reject) {
    var request = index.get(id);

    request.onerror = reject;

    request.onsuccess = function () {
      if (!request.result) {
        reject();
        return;
      }

      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__importer__["e" /* importAccount */])(request.result));
      resolve(request.result.moved && getFromDB(dispatch, getState, index, request.result.moved));
    };
  });
}

function fetchAccount(id) {
  return function (dispatch, getState) {
    dispatch(fetchRelationships([id]));

    if (getState().getIn(['accounts', id], null) !== null) {
      return;
    }

    dispatch(fetchAccountRequest(id));

    Object(__WEBPACK_IMPORTED_MODULE_1__storage_db__["a" /* default */])().then(function (db) {
      return getFromDB(dispatch, getState, db.transaction('accounts', 'read').objectStore('accounts').index('id'), id).then(function () {
        return db.close();
      }, function (error) {
        db.close();
        throw error;
      });
    }).catch(function () {
      return Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get('/api/v1/accounts/' + id).then(function (response) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__importer__["f" /* importFetchedAccount */])(response.data));
      });
    }).then(function () {
      dispatch(fetchAccountSuccess());
    }).catch(function (error) {
      dispatch(fetchAccountFail(id, error));
    });
  };
};

function fetchAccountRequest(id) {
  return {
    type: ACCOUNT_FETCH_REQUEST,
    id: id
  };
};

function fetchAccountSuccess() {
  return {
    type: ACCOUNT_FETCH_SUCCESS
  };
};

function fetchAccountFail(id, error) {
  return {
    type: ACCOUNT_FETCH_FAIL,
    id: id,
    error: error,
    skipAlert: true
  };
};

function followAccount(id) {
  var reblogs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  return function (dispatch, getState) {
    var alreadyFollowing = getState().getIn(['relationships', id, 'following']);
    dispatch(followAccountRequest(id));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).post('/api/v1/accounts/' + id + '/follow', { reblogs: reblogs }).then(function (response) {
      dispatch(followAccountSuccess(response.data, alreadyFollowing));
    }).catch(function (error) {
      dispatch(followAccountFail(error));
    });
  };
};

function unfollowAccount(id) {
  return function (dispatch, getState) {
    dispatch(unfollowAccountRequest(id));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).post('/api/v1/accounts/' + id + '/unfollow').then(function (response) {
      dispatch(unfollowAccountSuccess(response.data, getState().get('statuses')));
    }).catch(function (error) {
      dispatch(unfollowAccountFail(error));
    });
  };
};

function followAccountRequest(id) {
  return {
    type: ACCOUNT_FOLLOW_REQUEST,
    id: id
  };
};

function followAccountSuccess(relationship, alreadyFollowing) {
  return {
    type: ACCOUNT_FOLLOW_SUCCESS,
    relationship: relationship,
    alreadyFollowing: alreadyFollowing
  };
};

function followAccountFail(error) {
  return {
    type: ACCOUNT_FOLLOW_FAIL,
    error: error
  };
};

function unfollowAccountRequest(id) {
  return {
    type: ACCOUNT_UNFOLLOW_REQUEST,
    id: id
  };
};

function unfollowAccountSuccess(relationship, statuses) {
  return {
    type: ACCOUNT_UNFOLLOW_SUCCESS,
    relationship: relationship,
    statuses: statuses
  };
};

function unfollowAccountFail(error) {
  return {
    type: ACCOUNT_UNFOLLOW_FAIL,
    error: error
  };
};

function blockAccount(id) {
  return function (dispatch, getState) {
    dispatch(blockAccountRequest(id));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).post('/api/v1/accounts/' + id + '/block').then(function (response) {
      // Pass in entire statuses map so we can use it to filter stuff in different parts of the reducers
      dispatch(blockAccountSuccess(response.data, getState().get('statuses')));
    }).catch(function (error) {
      dispatch(blockAccountFail(id, error));
    });
  };
};

function unblockAccount(id) {
  return function (dispatch, getState) {
    dispatch(unblockAccountRequest(id));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).post('/api/v1/accounts/' + id + '/unblock').then(function (response) {
      dispatch(unblockAccountSuccess(response.data));
    }).catch(function (error) {
      dispatch(unblockAccountFail(id, error));
    });
  };
};

function blockAccountRequest(id) {
  return {
    type: ACCOUNT_BLOCK_REQUEST,
    id: id
  };
};

function blockAccountSuccess(relationship, statuses) {
  return {
    type: ACCOUNT_BLOCK_SUCCESS,
    relationship: relationship,
    statuses: statuses
  };
};

function blockAccountFail(error) {
  return {
    type: ACCOUNT_BLOCK_FAIL,
    error: error
  };
};

function unblockAccountRequest(id) {
  return {
    type: ACCOUNT_UNBLOCK_REQUEST,
    id: id
  };
};

function unblockAccountSuccess(relationship) {
  return {
    type: ACCOUNT_UNBLOCK_SUCCESS,
    relationship: relationship
  };
};

function unblockAccountFail(error) {
  return {
    type: ACCOUNT_UNBLOCK_FAIL,
    error: error
  };
};

function muteAccount(id, notifications) {
  return function (dispatch, getState) {
    dispatch(muteAccountRequest(id));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).post('/api/v1/accounts/' + id + '/mute', { notifications: notifications }).then(function (response) {
      // Pass in entire statuses map so we can use it to filter stuff in different parts of the reducers
      dispatch(muteAccountSuccess(response.data, getState().get('statuses')));
    }).catch(function (error) {
      dispatch(muteAccountFail(id, error));
    });
  };
};

function unmuteAccount(id) {
  return function (dispatch, getState) {
    dispatch(unmuteAccountRequest(id));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).post('/api/v1/accounts/' + id + '/unmute').then(function (response) {
      dispatch(unmuteAccountSuccess(response.data));
    }).catch(function (error) {
      dispatch(unmuteAccountFail(id, error));
    });
  };
};

function muteAccountRequest(id) {
  return {
    type: ACCOUNT_MUTE_REQUEST,
    id: id
  };
};

function muteAccountSuccess(relationship, statuses) {
  return {
    type: ACCOUNT_MUTE_SUCCESS,
    relationship: relationship,
    statuses: statuses
  };
};

function muteAccountFail(error) {
  return {
    type: ACCOUNT_MUTE_FAIL,
    error: error
  };
};

function unmuteAccountRequest(id) {
  return {
    type: ACCOUNT_UNMUTE_REQUEST,
    id: id
  };
};

function unmuteAccountSuccess(relationship) {
  return {
    type: ACCOUNT_UNMUTE_SUCCESS,
    relationship: relationship
  };
};

function unmuteAccountFail(error) {
  return {
    type: ACCOUNT_UNMUTE_FAIL,
    error: error
  };
};

function fetchFollowers(id) {
  return function (dispatch, getState) {
    dispatch(fetchFollowersRequest(id));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get('/api/v1/accounts/' + id + '/followers').then(function (response) {
      var next = Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* getLinks */])(response).refs.find(function (link) {
        return link.rel === 'next';
      });

      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__importer__["g" /* importFetchedAccounts */])(response.data));
      dispatch(fetchFollowersSuccess(id, response.data, next ? next.uri : null));
      dispatch(fetchRelationships(response.data.map(function (item) {
        return item.id;
      })));
    }).catch(function (error) {
      dispatch(fetchFollowersFail(id, error));
    });
  };
};

function fetchFollowersRequest(id) {
  return {
    type: FOLLOWERS_FETCH_REQUEST,
    id: id
  };
};

function fetchFollowersSuccess(id, accounts, next) {
  return {
    type: FOLLOWERS_FETCH_SUCCESS,
    id: id,
    accounts: accounts,
    next: next
  };
};

function fetchFollowersFail(id, error) {
  return {
    type: FOLLOWERS_FETCH_FAIL,
    id: id,
    error: error
  };
};

function expandFollowers(id) {
  return function (dispatch, getState) {
    var url = getState().getIn(['user_lists', 'followers', id, 'next']);

    if (url === null) {
      return;
    }

    dispatch(expandFollowersRequest(id));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get(url).then(function (response) {
      var next = Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* getLinks */])(response).refs.find(function (link) {
        return link.rel === 'next';
      });

      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__importer__["g" /* importFetchedAccounts */])(response.data));
      dispatch(expandFollowersSuccess(id, response.data, next ? next.uri : null));
      dispatch(fetchRelationships(response.data.map(function (item) {
        return item.id;
      })));
    }).catch(function (error) {
      dispatch(expandFollowersFail(id, error));
    });
  };
};

function expandFollowersRequest(id) {
  return {
    type: FOLLOWERS_EXPAND_REQUEST,
    id: id
  };
};

function expandFollowersSuccess(id, accounts, next) {
  return {
    type: FOLLOWERS_EXPAND_SUCCESS,
    id: id,
    accounts: accounts,
    next: next
  };
};

function expandFollowersFail(id, error) {
  return {
    type: FOLLOWERS_EXPAND_FAIL,
    id: id,
    error: error
  };
};

function fetchFollowing(id) {
  return function (dispatch, getState) {
    dispatch(fetchFollowingRequest(id));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get('/api/v1/accounts/' + id + '/following').then(function (response) {
      var next = Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* getLinks */])(response).refs.find(function (link) {
        return link.rel === 'next';
      });

      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__importer__["g" /* importFetchedAccounts */])(response.data));
      dispatch(fetchFollowingSuccess(id, response.data, next ? next.uri : null));
      dispatch(fetchRelationships(response.data.map(function (item) {
        return item.id;
      })));
    }).catch(function (error) {
      dispatch(fetchFollowingFail(id, error));
    });
  };
};

function fetchFollowingRequest(id) {
  return {
    type: FOLLOWING_FETCH_REQUEST,
    id: id
  };
};

function fetchFollowingSuccess(id, accounts, next) {
  return {
    type: FOLLOWING_FETCH_SUCCESS,
    id: id,
    accounts: accounts,
    next: next
  };
};

function fetchFollowingFail(id, error) {
  return {
    type: FOLLOWING_FETCH_FAIL,
    id: id,
    error: error
  };
};

function expandFollowing(id) {
  return function (dispatch, getState) {
    var url = getState().getIn(['user_lists', 'following', id, 'next']);

    if (url === null) {
      return;
    }

    dispatch(expandFollowingRequest(id));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get(url).then(function (response) {
      var next = Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* getLinks */])(response).refs.find(function (link) {
        return link.rel === 'next';
      });

      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__importer__["g" /* importFetchedAccounts */])(response.data));
      dispatch(expandFollowingSuccess(id, response.data, next ? next.uri : null));
      dispatch(fetchRelationships(response.data.map(function (item) {
        return item.id;
      })));
    }).catch(function (error) {
      dispatch(expandFollowingFail(id, error));
    });
  };
};

function expandFollowingRequest(id) {
  return {
    type: FOLLOWING_EXPAND_REQUEST,
    id: id
  };
};

function expandFollowingSuccess(id, accounts, next) {
  return {
    type: FOLLOWING_EXPAND_SUCCESS,
    id: id,
    accounts: accounts,
    next: next
  };
};

function expandFollowingFail(id, error) {
  return {
    type: FOLLOWING_EXPAND_FAIL,
    id: id,
    error: error
  };
};

function fetchRelationships(accountIds) {
  return function (dispatch, getState) {
    var loadedRelationships = getState().get('relationships');
    var newAccountIds = accountIds.filter(function (id) {
      return loadedRelationships.get(id, null) === null;
    });

    if (newAccountIds.length === 0) {
      return;
    }

    dispatch(fetchRelationshipsRequest(newAccountIds));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get('/api/v1/accounts/relationships?' + newAccountIds.map(function (id) {
      return 'id[]=' + id;
    }).join('&')).then(function (response) {
      dispatch(fetchRelationshipsSuccess(response.data));
    }).catch(function (error) {
      dispatch(fetchRelationshipsFail(error));
    });
  };
};

function fetchRelationshipsRequest(ids) {
  return {
    type: RELATIONSHIPS_FETCH_REQUEST,
    ids: ids,
    skipLoading: true
  };
};

function fetchRelationshipsSuccess(relationships) {
  return {
    type: RELATIONSHIPS_FETCH_SUCCESS,
    relationships: relationships,
    skipLoading: true
  };
};

function fetchRelationshipsFail(error) {
  return {
    type: RELATIONSHIPS_FETCH_FAIL,
    error: error,
    skipLoading: true
  };
};

function fetchFollowRequests() {
  return function (dispatch, getState) {
    dispatch(fetchFollowRequestsRequest());

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get('/api/v1/follow_requests').then(function (response) {
      var next = Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* getLinks */])(response).refs.find(function (link) {
        return link.rel === 'next';
      });
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__importer__["g" /* importFetchedAccounts */])(response.data));
      dispatch(fetchFollowRequestsSuccess(response.data, next ? next.uri : null));
    }).catch(function (error) {
      return dispatch(fetchFollowRequestsFail(error));
    });
  };
};

function fetchFollowRequestsRequest() {
  return {
    type: FOLLOW_REQUESTS_FETCH_REQUEST
  };
};

function fetchFollowRequestsSuccess(accounts, next) {
  return {
    type: FOLLOW_REQUESTS_FETCH_SUCCESS,
    accounts: accounts,
    next: next
  };
};

function fetchFollowRequestsFail(error) {
  return {
    type: FOLLOW_REQUESTS_FETCH_FAIL,
    error: error
  };
};

function expandFollowRequests() {
  return function (dispatch, getState) {
    var url = getState().getIn(['user_lists', 'follow_requests', 'next']);

    if (url === null) {
      return;
    }

    dispatch(expandFollowRequestsRequest());

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get(url).then(function (response) {
      var next = Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* getLinks */])(response).refs.find(function (link) {
        return link.rel === 'next';
      });
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__importer__["g" /* importFetchedAccounts */])(response.data));
      dispatch(expandFollowRequestsSuccess(response.data, next ? next.uri : null));
    }).catch(function (error) {
      return dispatch(expandFollowRequestsFail(error));
    });
  };
};

function expandFollowRequestsRequest() {
  return {
    type: FOLLOW_REQUESTS_EXPAND_REQUEST
  };
};

function expandFollowRequestsSuccess(accounts, next) {
  return {
    type: FOLLOW_REQUESTS_EXPAND_SUCCESS,
    accounts: accounts,
    next: next
  };
};

function expandFollowRequestsFail(error) {
  return {
    type: FOLLOW_REQUESTS_EXPAND_FAIL,
    error: error
  };
};

function authorizeFollowRequest(id) {
  return function (dispatch, getState) {
    dispatch(authorizeFollowRequestRequest(id));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).post('/api/v1/follow_requests/' + id + '/authorize').then(function () {
      return dispatch(authorizeFollowRequestSuccess(id));
    }).catch(function (error) {
      return dispatch(authorizeFollowRequestFail(id, error));
    });
  };
};

function authorizeFollowRequestRequest(id) {
  return {
    type: FOLLOW_REQUEST_AUTHORIZE_REQUEST,
    id: id
  };
};

function authorizeFollowRequestSuccess(id) {
  return {
    type: FOLLOW_REQUEST_AUTHORIZE_SUCCESS,
    id: id
  };
};

function authorizeFollowRequestFail(id, error) {
  return {
    type: FOLLOW_REQUEST_AUTHORIZE_FAIL,
    id: id,
    error: error
  };
};

function rejectFollowRequest(id) {
  return function (dispatch, getState) {
    dispatch(rejectFollowRequestRequest(id));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).post('/api/v1/follow_requests/' + id + '/reject').then(function () {
      return dispatch(rejectFollowRequestSuccess(id));
    }).catch(function (error) {
      return dispatch(rejectFollowRequestFail(id, error));
    });
  };
};

function rejectFollowRequestRequest(id) {
  return {
    type: FOLLOW_REQUEST_REJECT_REQUEST,
    id: id
  };
};

function rejectFollowRequestSuccess(id) {
  return {
    type: FOLLOW_REQUEST_REJECT_SUCCESS,
    id: id
  };
};

function rejectFollowRequestFail(id, error) {
  return {
    type: FOLLOW_REQUEST_REJECT_FAIL,
    id: id,
    error: error
  };
};

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IconButton; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__features_ui_util_optional_motion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_motion_lib_spring__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_motion_lib_spring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_motion_lib_spring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);





var _class, _temp2;







var IconButton = (_temp2 = _class = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(IconButton, _React$PureComponent);

  function IconButton() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, IconButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.handleClick = function (e) {
      e.preventDefault();

      if (!_this.props.disabled) {
        _this.props.onClick(e);
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  IconButton.prototype.render = function render() {
    var _this2 = this;

    var style = Object.assign({
      fontSize: this.props.size + 'px',
      width: this.props.size * 1.28571429 + 'px',
      height: this.props.size * 1.28571429 + 'px',
      lineHeight: this.props.size + 'px'
    }, this.props.style, this.props.active ? this.props.activeStyle : {});

    var _props = this.props,
        active = _props.active,
        animate = _props.animate,
        className = _props.className,
        disabled = _props.disabled,
        expanded = _props.expanded,
        icon = _props.icon,
        inverted = _props.inverted,
        overlay = _props.overlay,
        pressed = _props.pressed,
        tabIndex = _props.tabIndex,
        title = _props.title;


    var classes = __WEBPACK_IMPORTED_MODULE_7_classnames___default()(className, 'icon-button', {
      active: active,
      disabled: disabled,
      inverted: inverted,
      overlayed: overlay
    });

    if (!animate) {
      // Perf optimization: avoid unnecessary <Motion> components unless
      // we actually need to animate.
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
        'aria-label': title,
        'aria-pressed': pressed,
        'aria-expanded': expanded,
        title: title,
        className: classes,
        onClick: this.handleClick,
        style: style,
        tabIndex: tabIndex
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
        className: 'fa fa-fw fa-' + icon,
        'aria-hidden': 'true'
      }));
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_5__features_ui_util_optional_motion__["a" /* default */], {
      defaultStyle: { rotate: active ? -360 : 0 },
      style: { rotate: animate ? __WEBPACK_IMPORTED_MODULE_6_react_motion_lib_spring___default()(active ? -360 : 0, { stiffness: 120, damping: 7 }) : 0 }
    }, void 0, function (_ref) {
      var rotate = _ref.rotate;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
        'aria-label': title,
        'aria-pressed': pressed,
        'aria-expanded': expanded,
        title: title,
        className: classes,
        onClick: _this2.handleClick,
        style: style,
        tabIndex: tabIndex
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
        style: { transform: 'rotate(' + rotate + 'deg)' },
        className: 'fa fa-fw fa-' + icon,
        'aria-hidden': 'true'
      }));
    });
  };

  return IconButton;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent), _class.defaultProps = {
  size: 18,
  active: false,
  disabled: false,
  animate: false,
  overlay: false,
  tabIndex: '0'
}, _temp2);


/***/ }),
/* 24 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.5.1' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(201);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MODAL_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MODAL_CLOSE; });
/* harmony export (immutable) */ __webpack_exports__["d"] = openModal;
/* harmony export (immutable) */ __webpack_exports__["c"] = closeModal;
var MODAL_OPEN = 'MODAL_OPEN';
var MODAL_CLOSE = 'MODAL_CLOSE';

function openModal(type, props) {
  return {
    type: MODAL_OPEN,
    modalType: type,
    modalProps: props
  };
};

function closeModal() {
  return {
    type: MODAL_CLOSE
  };
};

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__initial_state__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__reduced_motion__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_motion_lib_Motion__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_motion_lib_Motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_motion_lib_Motion__);




/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__initial_state__["h" /* reduceMotion */] ? __WEBPACK_IMPORTED_MODULE_1__reduced_motion__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_2_react_motion_lib_Motion___default.a);

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

exports['default'] = spring;

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var _presets = __webpack_require__(515);

var _presets2 = _interopRequireDefault(_presets);

var defaultConfig = _extends({}, _presets2['default'].noWobble, {
  precision: 0.01
});

function spring(val, config) {
  return _extends({}, defaultConfig, config, { val: val });
}

module.exports = exports['default'];

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(359);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(178);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj;
};

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self
// eslint-disable-next-line no-new-func
: Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STORE_HYDRATE; });
/* unused harmony export STORE_HYDRATE_LAZY */
/* harmony export (immutable) */ __webpack_exports__["b"] = hydrateStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__importer__ = __webpack_require__(15);




var STORE_HYDRATE = 'STORE_HYDRATE';
var STORE_HYDRATE_LAZY = 'STORE_HYDRATE_LAZY';

var convertState = function convertState(rawState) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(rawState, function (k, v) {
    return __WEBPACK_IMPORTED_MODULE_0_immutable__["Iterable"].isIndexed(v) ? v.toList() : v.toMap();
  });
};

function hydrateStore(rawState) {
  return function (dispatch) {
    var state = convertState(rawState);

    dispatch({
      type: STORE_HYDRATE,
      state: state
    });

    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__compose__["P" /* hydrateCompose */])());
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__importer__["g" /* importFetchedAccounts */])(Object.values(rawState.accounts)));
  };
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(40),
    now = __webpack_require__(445),
    toNumber = __webpack_require__(446);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ALERT_SHOW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ALERT_DISMISS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ALERT_CLEAR; });
/* harmony export (immutable) */ __webpack_exports__["d"] = dismissAlert;
/* unused harmony export clearAlert */
/* unused harmony export showAlert */
/* harmony export (immutable) */ __webpack_exports__["e"] = showAlertForError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_intl__ = __webpack_require__(7);


var messages = Object(__WEBPACK_IMPORTED_MODULE_0_react_intl__["f" /* defineMessages */])({
  unexpectedTitle: {
    'id': 'alert.unexpected.title',
    'defaultMessage': 'Oops!'
  },
  unexpectedMessage: {
    'id': 'alert.unexpected.message',
    'defaultMessage': 'An unexpected error occurred.'
  }
});

var ALERT_SHOW = 'ALERT_SHOW';
var ALERT_DISMISS = 'ALERT_DISMISS';
var ALERT_CLEAR = 'ALERT_CLEAR';

function dismissAlert(alert) {
  return {
    type: ALERT_DISMISS,
    alert: alert
  };
};

function clearAlert() {
  return {
    type: ALERT_CLEAR
  };
};

function showAlert(title, message) {
  return {
    type: ALERT_SHOW,
    title: title,
    message: message
  };
};

function showAlertForError(error) {
  if (error.response) {
    var _error$response = error.response,
        data = _error$response.data,
        status = _error$response.status,
        statusText = _error$response.statusText;


    var message = statusText;
    var title = '' + status;

    if (data.error) {
      message = data.error;
    }

    return showAlert(title, message);
  } else {
    console.error(error);
    return showAlert(messages.unexpectedTitle, messages.unexpectedMessage);
  }
}

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(502);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 35 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
})();
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }
}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while (len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) {
    return [];
};

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () {
    return '/';
};
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function () {
    return 0;
};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(46)(function () {
  return Object.defineProperty({}, 'a', { get: function () {
      return 7;
    } }).a != 7;
});

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(30);
var core = __webpack_require__(24);
var ctx = __webpack_require__(169);
var hide = __webpack_require__(47);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && key in exports) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0:
              return new C();
            case 1:
              return new C(a);
            case 2:
              return new C(a, b);
          }return new C(a, b, c);
        }return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
      // make static versions for prototype methods
    }(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1; // forced
$export.G = 2; // global
$export.S = 4; // static
$export.P = 8; // proto
$export.B = 16; // bind
$export.W = 32; // wrap
$export.U = 64; // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(61);
var IE8_DOM_DEFINE = __webpack_require__(170);
var toPrimitive = __webpack_require__(109);
var dP = Object.defineProperty;

exports.f = __webpack_require__(37) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) {/* empty */}
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 40 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(558),
    getValue = __webpack_require__(561);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var formatRegExp = /%[sdj%]/g;
exports.format = function (f) {
  if (!isString(f)) {
    var objects = [];
    for (var i = 0; i < arguments.length; i++) {
      objects.push(inspect(arguments[i]));
    }
    return objects.join(' ');
  }

  var i = 1;
  var args = arguments;
  var len = args.length;
  var str = String(f).replace(formatRegExp, function (x) {
    if (x === '%%') return '%';
    if (i >= len) return x;
    switch (x) {
      case '%s':
        return String(args[i++]);
      case '%d':
        return Number(args[i++]);
      case '%j':
        try {
          return JSON.stringify(args[i++]);
        } catch (_) {
          return '[Circular]';
        }
      default:
        return x;
    }
  });
  for (var x = args[i]; i < len; x = args[++i]) {
    if (isNull(x) || !isObject(x)) {
      str += ' ' + x;
    } else {
      str += ' ' + inspect(x);
    }
  }
  return str;
};

// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
exports.deprecate = function (fn, msg) {
  // Allow for deprecating things in the process of starting up.
  if (isUndefined(global.process)) {
    return function () {
      return exports.deprecate(fn, msg).apply(this, arguments);
    };
  }

  if (process.noDeprecation === true) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (process.throwDeprecation) {
        throw new Error(msg);
      } else if (process.traceDeprecation) {
        console.trace(msg);
      } else {
        console.error(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
};

var debugs = {};
var debugEnviron;
exports.debuglog = function (set) {
  if (isUndefined(debugEnviron)) debugEnviron = process.env.NODE_DEBUG || '';
  set = set.toUpperCase();
  if (!debugs[set]) {
    if (new RegExp('\\b' + set + '\\b', 'i').test(debugEnviron)) {
      var pid = process.pid;
      debugs[set] = function () {
        var msg = exports.format.apply(exports, arguments);
        console.error('%s %d: %s', set, pid, msg);
      };
    } else {
      debugs[set] = function () {};
    }
  }
  return debugs[set];
};

/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */
/* legacy: obj, showHidden, depth, colors*/
function inspect(obj, opts) {
  // default options
  var ctx = {
    seen: [],
    stylize: stylizeNoColor
  };
  // legacy...
  if (arguments.length >= 3) ctx.depth = arguments[2];
  if (arguments.length >= 4) ctx.colors = arguments[3];
  if (isBoolean(opts)) {
    // legacy...
    ctx.showHidden = opts;
  } else if (opts) {
    // got an "options" object
    exports._extend(ctx, opts);
  }
  // set default options
  if (isUndefined(ctx.showHidden)) ctx.showHidden = false;
  if (isUndefined(ctx.depth)) ctx.depth = 2;
  if (isUndefined(ctx.colors)) ctx.colors = false;
  if (isUndefined(ctx.customInspect)) ctx.customInspect = true;
  if (ctx.colors) ctx.stylize = stylizeWithColor;
  return formatValue(ctx, obj, ctx.depth);
}
exports.inspect = inspect;

// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
inspect.colors = {
  'bold': [1, 22],
  'italic': [3, 23],
  'underline': [4, 24],
  'inverse': [7, 27],
  'white': [37, 39],
  'grey': [90, 39],
  'black': [30, 39],
  'blue': [34, 39],
  'cyan': [36, 39],
  'green': [32, 39],
  'magenta': [35, 39],
  'red': [31, 39],
  'yellow': [33, 39]
};

// Don't use 'blue' not visible on cmd.exe
inspect.styles = {
  'special': 'cyan',
  'number': 'yellow',
  'boolean': 'yellow',
  'undefined': 'grey',
  'null': 'bold',
  'string': 'green',
  'date': 'magenta',
  // "name": intentionally not styling
  'regexp': 'red'
};

function stylizeWithColor(str, styleType) {
  var style = inspect.styles[styleType];

  if (style) {
    return '\u001b[' + inspect.colors[style][0] + 'm' + str + '\u001b[' + inspect.colors[style][1] + 'm';
  } else {
    return str;
  }
}

function stylizeNoColor(str, styleType) {
  return str;
}

function arrayToHash(array) {
  var hash = {};

  array.forEach(function (val, idx) {
    hash[val] = true;
  });

  return hash;
}

function formatValue(ctx, value, recurseTimes) {
  // Provide a hook for user-specified inspect functions.
  // Check that value is an object with an inspect function on it
  if (ctx.customInspect && value && isFunction(value.inspect) &&
  // Filter out the util module, it's inspect function is special
  value.inspect !== exports.inspect &&
  // Also filter out any prototype objects using the circular check.
  !(value.constructor && value.constructor.prototype === value)) {
    var ret = value.inspect(recurseTimes, ctx);
    if (!isString(ret)) {
      ret = formatValue(ctx, ret, recurseTimes);
    }
    return ret;
  }

  // Primitive types cannot have properties
  var primitive = formatPrimitive(ctx, value);
  if (primitive) {
    return primitive;
  }

  // Look up the keys of the object.
  var keys = Object.keys(value);
  var visibleKeys = arrayToHash(keys);

  if (ctx.showHidden) {
    keys = Object.getOwnPropertyNames(value);
  }

  // IE doesn't make error fields non-enumerable
  // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
  if (isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) {
    return formatError(value);
  }

  // Some type of object without properties can be shortcutted.
  if (keys.length === 0) {
    if (isFunction(value)) {
      var name = value.name ? ': ' + value.name : '';
      return ctx.stylize('[Function' + name + ']', 'special');
    }
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    }
    if (isDate(value)) {
      return ctx.stylize(Date.prototype.toString.call(value), 'date');
    }
    if (isError(value)) {
      return formatError(value);
    }
  }

  var base = '',
      array = false,
      braces = ['{', '}'];

  // Make Array say that they are Array
  if (isArray(value)) {
    array = true;
    braces = ['[', ']'];
  }

  // Make functions say that they are functions
  if (isFunction(value)) {
    var n = value.name ? ': ' + value.name : '';
    base = ' [Function' + n + ']';
  }

  // Make RegExps say that they are RegExps
  if (isRegExp(value)) {
    base = ' ' + RegExp.prototype.toString.call(value);
  }

  // Make dates with properties first say the date
  if (isDate(value)) {
    base = ' ' + Date.prototype.toUTCString.call(value);
  }

  // Make error with message first say the error
  if (isError(value)) {
    base = ' ' + formatError(value);
  }

  if (keys.length === 0 && (!array || value.length == 0)) {
    return braces[0] + base + braces[1];
  }

  if (recurseTimes < 0) {
    if (isRegExp(value)) {
      return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
    } else {
      return ctx.stylize('[Object]', 'special');
    }
  }

  ctx.seen.push(value);

  var output;
  if (array) {
    output = formatArray(ctx, value, recurseTimes, visibleKeys, keys);
  } else {
    output = keys.map(function (key) {
      return formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
  }

  ctx.seen.pop();

  return reduceToSingleString(output, base, braces);
}

function formatPrimitive(ctx, value) {
  if (isUndefined(value)) return ctx.stylize('undefined', 'undefined');
  if (isString(value)) {
    var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
    return ctx.stylize(simple, 'string');
  }
  if (isNumber(value)) return ctx.stylize('' + value, 'number');
  if (isBoolean(value)) return ctx.stylize('' + value, 'boolean');
  // For some reason typeof null is "object", so special case here.
  if (isNull(value)) return ctx.stylize('null', 'null');
}

function formatError(value) {
  return '[' + Error.prototype.toString.call(value) + ']';
}

function formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
  var output = [];
  for (var i = 0, l = value.length; i < l; ++i) {
    if (hasOwnProperty(value, String(i))) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    } else {
      output.push('');
    }
  }
  keys.forEach(function (key) {
    if (!key.match(/^\d+$/)) {
      output.push(formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    }
  });
  return output;
}

function formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
  var name, str, desc;
  desc = Object.getOwnPropertyDescriptor(value, key) || { value: value[key] };
  if (desc.get) {
    if (desc.set) {
      str = ctx.stylize('[Getter/Setter]', 'special');
    } else {
      str = ctx.stylize('[Getter]', 'special');
    }
  } else {
    if (desc.set) {
      str = ctx.stylize('[Setter]', 'special');
    }
  }
  if (!hasOwnProperty(visibleKeys, key)) {
    name = '[' + key + ']';
  }
  if (!str) {
    if (ctx.seen.indexOf(desc.value) < 0) {
      if (isNull(recurseTimes)) {
        str = formatValue(ctx, desc.value, null);
      } else {
        str = formatValue(ctx, desc.value, recurseTimes - 1);
      }
      if (str.indexOf('\n') > -1) {
        if (array) {
          str = str.split('\n').map(function (line) {
            return '  ' + line;
          }).join('\n').substr(2);
        } else {
          str = '\n' + str.split('\n').map(function (line) {
            return '   ' + line;
          }).join('\n');
        }
      }
    } else {
      str = ctx.stylize('[Circular]', 'special');
    }
  }
  if (isUndefined(name)) {
    if (array && key.match(/^\d+$/)) {
      return str;
    }
    name = JSON.stringify('' + key);
    if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
      name = name.substr(1, name.length - 2);
      name = ctx.stylize(name, 'name');
    } else {
      name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
      name = ctx.stylize(name, 'string');
    }
  }

  return name + ': ' + str;
}

function reduceToSingleString(output, base, braces) {
  var numLinesEst = 0;
  var length = output.reduce(function (prev, cur) {
    numLinesEst++;
    if (cur.indexOf('\n') >= 0) numLinesEst++;
    return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
  }, 0);

  if (length > 60) {
    return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
  }

  return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function isArray(ar) {
  return Array.isArray(ar);
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return isObject(re) && objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return isObject(d) && objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return isObject(e) && (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
  typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = __webpack_require__(645);

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

function pad(n) {
  return n < 10 ? '0' + n.toString(10) : n.toString(10);
}

var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// 26 Feb 16:19:34
function timestamp() {
  var d = new Date();
  var time = [pad(d.getHours()), pad(d.getMinutes()), pad(d.getSeconds())].join(':');
  return [d.getDate(), months[d.getMonth()], time].join(' ');
}

// log is just a thin wrapper to console.log that prepends a timestamp
exports.log = function () {
  console.log('%s - %s', timestamp(), exports.format.apply(exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */
exports.inherits = __webpack_require__(646);

exports._extend = function (origin, add) {
  // Don't do anything if add isn't an object
  if (!add || !isObject(add)) return origin;

  var keys = Object.keys(add);
  var i = keys.length;
  while (i--) {
    origin[keys[i]] = add[keys[i]];
  }
  return origin;
};

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57), __webpack_require__(35)))

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isMobile;
/* harmony export (immutable) */ __webpack_exports__["c"] = isUserTouching;
/* harmony export (immutable) */ __webpack_exports__["a"] = isIOS;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_detect_passive_events__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_detect_passive_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_detect_passive_events__);


var LAYOUT_BREAKPOINT = 630;

function isMobile(width) {
  return width <= LAYOUT_BREAKPOINT;
};

var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

var userTouching = false;
var listenerOptions = __WEBPACK_IMPORTED_MODULE_0_detect_passive_events___default.a.hasSupport ? { passive: true } : false;

function touchListener() {
  userTouching = true;
  window.removeEventListener('touchstart', touchListener, listenerOptions);
}

window.addEventListener('touchstart', touchListener, listenerOptions);

function isUserTouching() {
  return userTouching;
}

function isIOS() {
  return iOS;
};

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(533);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(536);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(223);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(537);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(539);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(542);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(544);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(225);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(143);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(547);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(549);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(551);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(552);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_12__withRouter__["a"]; });



























/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// adapted from https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
var detectPassiveEvents = {
  update: function update() {
    if (typeof window !== 'undefined' && typeof window.addEventListener === 'function') {
      var passive = false;
      var options = Object.defineProperty({}, 'passive', {
        get: function get() {
          passive = true;
        }
      });
      // note: have to set and remove a no-op listener instead of null
      // (which was used previously), becasue Edge v15 throws an error
      // when providing a null callback.
      // https://github.com/rafrex/detect-passive-events/pull/3
      var noop = function noop() {};
      window.addEventListener('testPassiveEventSupport', noop, options);
      window.removeEventListener('testPassiveEventSupport', noop, options);
      detectPassiveEvents.hasSupport = passive;
    }
  }
};

detectPassiveEvents.update();
exports.default = detectPassiveEvents;

/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(39);
var createDesc = __webpack_require__(79);
module.exports = __webpack_require__(37) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(110)('wks');
var uid = __webpack_require__(80);
var Symbol = __webpack_require__(30).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] = USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(174);
var defined = __webpack_require__(115);
module.exports = function (it) {
  return IObject(defined(it));
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(131),
    getRawTag = __webpack_require__(448),
    objectToString = __webpack_require__(449);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
    if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}

module.exports = baseGetTag;

/***/ }),
/* 51 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return stripLeadingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return stripBasename; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return stripTrailingSlash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return parsePath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createPath; });
var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var stripLeadingSlash = function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
};

var hasBasename = function hasBasename(path, prefix) {
  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
};

var stripBasename = function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
};

var stripTrailingSlash = function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
};

var parsePath = function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var createPath = function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = pathname || '/';

  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;

  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;

  return path;
};

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return makeGetAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return regexFromFilters; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return makeGetStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAlerts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return makeGetNotification; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAccountGallery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_reselect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_reselect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);



var getAccountBase = function getAccountBase(state, id) {
  return state.getIn(['accounts', id], null);
};
var getAccountCounters = function getAccountCounters(state, id) {
  return state.getIn(['accounts_counters', id], null);
};
var getAccountRelationship = function getAccountRelationship(state, id) {
  return state.getIn(['relationships', id], null);
};
var getAccountMoved = function getAccountMoved(state, id) {
  return state.getIn(['accounts', state.getIn(['accounts', id, 'moved'])]);
};

var makeGetAccount = function makeGetAccount() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getAccountBase, getAccountCounters, getAccountRelationship, getAccountMoved], function (base, counters, relationship, moved) {
    if (base === null) {
      return null;
    }

    return base.merge(counters).withMutations(function (map) {
      map.set('relationship', relationship);
      map.set('moved', moved);
    });
  });
};

var toServerSideType = function toServerSideType(columnType) {
  switch (columnType) {
    case 'home':
    case 'notifications':
    case 'public':
    case 'thread':
      return columnType;
    default:
      if (columnType.indexOf('list:') > -1) {
        return 'home';
      } else {
        return 'public'; // community, account, hashtag
      }
  }
};

var getFilters = function getFilters(state, _ref) {
  var contextType = _ref.contextType;
  return state.get('filters', Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])()).filter(function (filter) {
    return contextType && filter.get('context').includes(toServerSideType(contextType)) && (filter.get('expires_at') === null || Date.parse(filter.get('expires_at')) > new Date());
  });
};

var escapeRegExp = function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}; // $& means the whole matched string

var regexFromFilters = function regexFromFilters(filters) {
  if (filters.size === 0) {
    return null;
  }

  return new RegExp(filters.map(function (filter) {
    var expr = escapeRegExp(filter.get('phrase'));

    if (filter.get('whole_word')) {
      if (/^[\w]/.test(expr)) {
        expr = '\\b' + expr;
      }

      if (/[\w]$/.test(expr)) {
        expr = expr + '\\b';
      }
    }

    return expr;
  }).join('|'), 'i');
};

var makeGetStatus = function makeGetStatus() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state, _ref2) {
    var id = _ref2.id;
    return state.getIn(['statuses', id]);
  }, function (state, _ref3) {
    var id = _ref3.id;
    return state.getIn(['statuses', state.getIn(['statuses', id, 'reblog'])]);
  }, function (state, _ref4) {
    var id = _ref4.id;
    return state.getIn(['accounts', state.getIn(['statuses', id, 'account'])]);
  }, function (state, _ref5) {
    var id = _ref5.id;
    return state.getIn(['accounts', state.getIn(['statuses', state.getIn(['statuses', id, 'reblog']), 'account'])]);
  }, getFilters], function (statusBase, statusReblog, accountBase, accountReblog, filters) {
    if (!statusBase) {
      return null;
    }

    if (statusReblog) {
      statusReblog = statusReblog.set('account', accountReblog);
    } else {
      statusReblog = null;
    }

    var regex = regexFromFilters(filters);
    var filtered = regex && regex.test(statusBase.get('reblog') ? statusReblog.get('search_index') : statusBase.get('search_index'));

    return statusBase.withMutations(function (map) {
      map.set('reblog', statusReblog);
      map.set('account', accountBase);
      map.set('filtered', filtered);
    });
  });
};

var getAlertsBase = function getAlertsBase(state) {
  return state.get('alerts');
};

var getAlerts = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([getAlertsBase], function (base) {
  var arr = [];

  base.forEach(function (item) {
    arr.push({
      message: item.get('message'),
      title: item.get('title'),
      key: item.get('key'),
      dismissAfter: 5000,
      barStyle: {
        zIndex: 200
      }
    });
  });

  return arr;
});

var makeGetNotification = function makeGetNotification() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (_, base) {
    return base;
  }, function (state, _, accountId) {
    return state.getIn(['accounts', accountId]);
  }], function (base, account) {
    return base.set('account', account);
  });
};

var getAccountGallery = Object(__WEBPACK_IMPORTED_MODULE_0_reselect__["createSelector"])([function (state, id) {
  return state.getIn(['timelines', 'account:' + id + ':media', 'items'], Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])());
}, function (state) {
  return state.get('statuses');
}], function (statusIds, statuses) {
  var medias = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])();

  statusIds.forEach(function (statusId) {
    var status = statuses.get(statusId);
    medias = medias.concat(status.get('media_attachments').map(function (media) {
      return media.set('status', status);
    }));
  });

  return medias;
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DisplayName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var DisplayName = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DisplayName, _React$PureComponent);

  function DisplayName() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DisplayName);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.apply(this, arguments));
  }

  DisplayName.prototype.render = function render() {
    var displayNameHtml = { __html: this.props.account.get('display_name_html') };

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('span', {
      className: 'display-name'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('bdi', {}, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('strong', {
      className: 'display-name__html',
      dangerouslySetInnerHTML: displayNameHtml
    })), ' ', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('span', {
      className: 'display-name__account'
    }, void 0, '@', this.props.account.get('acct')));
  };

  return DisplayName;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent);



/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Avatar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__initial_state__ = __webpack_require__(14);





var _class, _temp2;





var Avatar = (_temp2 = _class = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Avatar, _React$PureComponent);

  function Avatar() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Avatar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
      hovering: false
    }, _this.handleMouseEnter = function () {
      if (_this.props.animate) return;
      _this.setState({ hovering: true });
    }, _this.handleMouseLeave = function () {
      if (_this.props.animate) return;
      _this.setState({ hovering: false });
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Avatar.prototype.render = function render() {
    var _props = this.props,
        account = _props.account,
        size = _props.size,
        animate = _props.animate,
        inline = _props.inline;
    var hovering = this.state.hovering;


    var src = account.get('avatar');
    var staticSrc = account.get('avatar_static');

    var className = 'account__avatar';

    if (inline) {
      className = className + ' account__avatar-inline';
    }

    var style = Object.assign({}, this.props.style, {
      width: size + 'px',
      height: size + 'px',
      backgroundSize: size + 'px ' + size + 'px'
    });

    if (hovering || animate) {
      style.backgroundImage = 'url(' + src + ')';
    } else {
      style.backgroundImage = 'url(' + staticSrc + ')';
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: className,
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave,
      style: style
    });
  };

  return Avatar;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent), _class.defaultProps = {
  animate: __WEBPACK_IMPORTED_MODULE_5__initial_state__["a" /* autoPlayGif */],
  size: 20,
  inline: false
}, _temp2);


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 57 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = function () {
	return this;
}();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SETTING_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SETTING_SAVE; });
/* harmony export (immutable) */ __webpack_exports__["c"] = changeSetting;
/* harmony export (immutable) */ __webpack_exports__["d"] = saveSettings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_debounce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__alerts__ = __webpack_require__(33);





var SETTING_CHANGE = 'SETTING_CHANGE';
var SETTING_SAVE = 'SETTING_SAVE';

function changeSetting(path, value) {
  return function (dispatch) {
    dispatch({
      type: SETTING_CHANGE,
      path: path,
      value: value
    });

    dispatch(saveSettings());
  };
};

var debouncedSave = __WEBPACK_IMPORTED_MODULE_0_lodash_debounce___default()(function (dispatch, getState) {
  if (getState().getIn(['settings', 'saved'])) {
    return;
  }

  var data = getState().get('settings').filter(function (_, path) {
    return path !== 'saved';
  }).toJS();

  Object(__WEBPACK_IMPORTED_MODULE_1__api__["a" /* default */])().put('/api/web/settings', { data: data }).then(function () {
    return dispatch({ type: SETTING_SAVE });
  }).catch(function (error) {
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__alerts__["e" /* showAlertForError */])(error));
  });
}, 5000, { trailing: true });

function saveSettings() {
  return function (dispatch, getState) {
    return debouncedSave(dispatch, getState);
  };
};

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["i"] = EmojiPicker;
/* harmony export (immutable) */ __webpack_exports__["e"] = Compose;
/* harmony export (immutable) */ __webpack_exports__["z"] = Notifications;
/* harmony export (immutable) */ __webpack_exports__["r"] = HomeTimeline;
/* harmony export (immutable) */ __webpack_exports__["C"] = PublicTimeline;
/* harmony export (immutable) */ __webpack_exports__["d"] = CommunityTimeline;
/* harmony export (immutable) */ __webpack_exports__["q"] = HashtagTimeline;
/* harmony export (immutable) */ __webpack_exports__["f"] = DirectTimeline;
/* harmony export (immutable) */ __webpack_exports__["u"] = ListTimeline;
/* harmony export (immutable) */ __webpack_exports__["v"] = Lists;
/* harmony export (immutable) */ __webpack_exports__["F"] = Status;
/* harmony export (immutable) */ __webpack_exports__["p"] = GettingStarted;
/* harmony export (immutable) */ __webpack_exports__["s"] = KeyboardShortcuts;
/* harmony export (immutable) */ __webpack_exports__["B"] = PinnedStatuses;
/* harmony export (immutable) */ __webpack_exports__["b"] = AccountTimeline;
/* harmony export (immutable) */ __webpack_exports__["a"] = AccountGallery;
/* harmony export (immutable) */ __webpack_exports__["m"] = Followers;
/* harmony export (immutable) */ __webpack_exports__["n"] = Following;
/* harmony export (immutable) */ __webpack_exports__["D"] = Reblogs;
/* harmony export (immutable) */ __webpack_exports__["k"] = Favourites;
/* harmony export (immutable) */ __webpack_exports__["l"] = FollowRequests;
/* harmony export (immutable) */ __webpack_exports__["o"] = GenericNotFound;
/* harmony export (immutable) */ __webpack_exports__["j"] = FavouritedStatuses;
/* harmony export (immutable) */ __webpack_exports__["c"] = Blocks;
/* harmony export (immutable) */ __webpack_exports__["g"] = DomainBlocks;
/* harmony export (immutable) */ __webpack_exports__["y"] = Mutes;
/* harmony export (immutable) */ __webpack_exports__["A"] = OnboardingModal;
/* harmony export (immutable) */ __webpack_exports__["x"] = MuteModal;
/* harmony export (immutable) */ __webpack_exports__["E"] = ReportModal;
/* harmony export (immutable) */ __webpack_exports__["w"] = MediaGallery;
/* harmony export (immutable) */ __webpack_exports__["G"] = Video;
/* harmony export (immutable) */ __webpack_exports__["h"] = EmbedModal;
/* harmony export (immutable) */ __webpack_exports__["t"] = ListEditor;
function EmojiPicker() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 828));
}

function Compose() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 829));
}

function Notifications() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 830));
}

function HomeTimeline() {
  return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 831));
}

function PublicTimeline() {
  return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 832));
}

function CommunityTimeline() {
  return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 833));
}

function HashtagTimeline() {
  return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 834));
}

function DirectTimeline() {
  return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 835));
}

function ListTimeline() {
  return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 836));
}

function Lists() {
  return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 837));
}

function Status() {
  return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 838));
}

function GettingStarted() {
  return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 839));
}

function KeyboardShortcuts() {
  return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 840));
}

function PinnedStatuses() {
  return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 841));
}

function AccountTimeline() {
  return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 842));
}

function AccountGallery() {
  return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 843));
}

function Followers() {
  return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 844));
}

function Following() {
  return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 845));
}

function Reblogs() {
  return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 846));
}

function Favourites() {
  return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 847));
}

function FollowRequests() {
  return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 848));
}

function GenericNotFound() {
  return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 849));
}

function FavouritedStatuses() {
  return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 850));
}

function Blocks() {
  return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 851));
}

function DomainBlocks() {
  return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 852));
}

function Mutes() {
  return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 853));
}

function OnboardingModal() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 854));
}

function MuteModal() {
  return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 855));
}

function ReportModal() {
  return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 856));
}

function MediaGallery() {
  return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 825));
}

function Video() {
  return new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, 75));
}

function EmbedModal() {
  return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 857));
}

function ListEditor() {
  return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 858));
}

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlMessageFormat = __webpack_require__(452)['default'];

// Add all locale data to `IntlMessageFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(459);

// Re-export `IntlMessageFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlMessageFormat;
exports['default'] = exports;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(62);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 62 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = ready;
function ready(loaded) {
  if (['interactive', 'complete'].includes(document.readyState)) {
    loaded();
  } else {
    document.addEventListener('DOMContentLoaded', loaded);
  }
}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (componentOrElement) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
};

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ownerDocument = __webpack_require__(137);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

module.exports = exports['default'];

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
module.exports = exports['default'];

/***/ }),
/* 66 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;

/***/ }),
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REBLOG_REQUEST; });
/* unused harmony export REBLOG_SUCCESS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REBLOG_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FAVOURITE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FAVOURITE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FAVOURITE_FAIL; });
/* unused harmony export UNREBLOG_REQUEST */
/* unused harmony export UNREBLOG_SUCCESS */
/* unused harmony export UNREBLOG_FAIL */
/* unused harmony export UNFAVOURITE_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UNFAVOURITE_SUCCESS; });
/* unused harmony export UNFAVOURITE_FAIL */
/* unused harmony export REBLOGS_FETCH_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REBLOGS_FETCH_SUCCESS; });
/* unused harmony export REBLOGS_FETCH_FAIL */
/* unused harmony export FAVOURITES_FETCH_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FAVOURITES_FETCH_SUCCESS; });
/* unused harmony export FAVOURITES_FETCH_FAIL */
/* unused harmony export PIN_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return PIN_SUCCESS; });
/* unused harmony export PIN_FAIL */
/* unused harmony export UNPIN_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UNPIN_SUCCESS; });
/* unused harmony export UNPIN_FAIL */
/* harmony export (immutable) */ __webpack_exports__["o"] = reblog;
/* harmony export (immutable) */ __webpack_exports__["r"] = unreblog;
/* unused harmony export reblogRequest */
/* unused harmony export reblogSuccess */
/* unused harmony export reblogFail */
/* unused harmony export unreblogRequest */
/* unused harmony export unreblogSuccess */
/* unused harmony export unreblogFail */
/* harmony export (immutable) */ __webpack_exports__["k"] = favourite;
/* harmony export (immutable) */ __webpack_exports__["p"] = unfavourite;
/* unused harmony export favouriteRequest */
/* unused harmony export favouriteSuccess */
/* unused harmony export favouriteFail */
/* unused harmony export unfavouriteRequest */
/* unused harmony export unfavouriteSuccess */
/* unused harmony export unfavouriteFail */
/* harmony export (immutable) */ __webpack_exports__["m"] = fetchReblogs;
/* unused harmony export fetchReblogsRequest */
/* unused harmony export fetchReblogsSuccess */
/* unused harmony export fetchReblogsFail */
/* harmony export (immutable) */ __webpack_exports__["l"] = fetchFavourites;
/* unused harmony export fetchFavouritesRequest */
/* unused harmony export fetchFavouritesSuccess */
/* unused harmony export fetchFavouritesFail */
/* harmony export (immutable) */ __webpack_exports__["n"] = pin;
/* unused harmony export pinRequest */
/* unused harmony export pinSuccess */
/* unused harmony export pinFail */
/* harmony export (immutable) */ __webpack_exports__["q"] = unpin;
/* unused harmony export unpinRequest */
/* unused harmony export unpinSuccess */
/* unused harmony export unpinFail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__importer__ = __webpack_require__(15);



var REBLOG_REQUEST = 'REBLOG_REQUEST';
var REBLOG_SUCCESS = 'REBLOG_SUCCESS';
var REBLOG_FAIL = 'REBLOG_FAIL';

var FAVOURITE_REQUEST = 'FAVOURITE_REQUEST';
var FAVOURITE_SUCCESS = 'FAVOURITE_SUCCESS';
var FAVOURITE_FAIL = 'FAVOURITE_FAIL';

var UNREBLOG_REQUEST = 'UNREBLOG_REQUEST';
var UNREBLOG_SUCCESS = 'UNREBLOG_SUCCESS';
var UNREBLOG_FAIL = 'UNREBLOG_FAIL';

var UNFAVOURITE_REQUEST = 'UNFAVOURITE_REQUEST';
var UNFAVOURITE_SUCCESS = 'UNFAVOURITE_SUCCESS';
var UNFAVOURITE_FAIL = 'UNFAVOURITE_FAIL';

var REBLOGS_FETCH_REQUEST = 'REBLOGS_FETCH_REQUEST';
var REBLOGS_FETCH_SUCCESS = 'REBLOGS_FETCH_SUCCESS';
var REBLOGS_FETCH_FAIL = 'REBLOGS_FETCH_FAIL';

var FAVOURITES_FETCH_REQUEST = 'FAVOURITES_FETCH_REQUEST';
var FAVOURITES_FETCH_SUCCESS = 'FAVOURITES_FETCH_SUCCESS';
var FAVOURITES_FETCH_FAIL = 'FAVOURITES_FETCH_FAIL';

var PIN_REQUEST = 'PIN_REQUEST';
var PIN_SUCCESS = 'PIN_SUCCESS';
var PIN_FAIL = 'PIN_FAIL';

var UNPIN_REQUEST = 'UNPIN_REQUEST';
var UNPIN_SUCCESS = 'UNPIN_SUCCESS';
var UNPIN_FAIL = 'UNPIN_FAIL';

function reblog(status) {
  return function (dispatch, getState) {
    dispatch(reblogRequest(status));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).post('/api/v1/statuses/' + status.get('id') + '/reblog').then(function (response) {
      // The reblog API method returns a new status wrapped around the original. In this case we are only
      // interested in how the original is modified, hence passing it skipping the wrapper
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__importer__["h" /* importFetchedStatus */])(response.data.reblog));
      dispatch(reblogSuccess(status));
    }).catch(function (error) {
      dispatch(reblogFail(status, error));
    });
  };
};

function unreblog(status) {
  return function (dispatch, getState) {
    dispatch(unreblogRequest(status));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).post('/api/v1/statuses/' + status.get('id') + '/unreblog').then(function (response) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__importer__["h" /* importFetchedStatus */])(response.data));
      dispatch(unreblogSuccess(status));
    }).catch(function (error) {
      dispatch(unreblogFail(status, error));
    });
  };
};

function reblogRequest(status) {
  return {
    type: REBLOG_REQUEST,
    status: status,
    skipLoading: true
  };
};

function reblogSuccess(status) {
  return {
    type: REBLOG_SUCCESS,
    status: status,
    skipLoading: true
  };
};

function reblogFail(status, error) {
  return {
    type: REBLOG_FAIL,
    status: status,
    error: error,
    skipLoading: true
  };
};

function unreblogRequest(status) {
  return {
    type: UNREBLOG_REQUEST,
    status: status,
    skipLoading: true
  };
};

function unreblogSuccess(status) {
  return {
    type: UNREBLOG_SUCCESS,
    status: status,
    skipLoading: true
  };
};

function unreblogFail(status, error) {
  return {
    type: UNREBLOG_FAIL,
    status: status,
    error: error,
    skipLoading: true
  };
};

function favourite(status) {
  return function (dispatch, getState) {
    dispatch(favouriteRequest(status));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).post('/api/v1/statuses/' + status.get('id') + '/favourite').then(function (response) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__importer__["h" /* importFetchedStatus */])(response.data));
      dispatch(favouriteSuccess(status));
    }).catch(function (error) {
      dispatch(favouriteFail(status, error));
    });
  };
};

function unfavourite(status) {
  return function (dispatch, getState) {
    dispatch(unfavouriteRequest(status));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).post('/api/v1/statuses/' + status.get('id') + '/unfavourite').then(function (response) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__importer__["h" /* importFetchedStatus */])(response.data));
      dispatch(unfavouriteSuccess(status));
    }).catch(function (error) {
      dispatch(unfavouriteFail(status, error));
    });
  };
};

function favouriteRequest(status) {
  return {
    type: FAVOURITE_REQUEST,
    status: status,
    skipLoading: true
  };
};

function favouriteSuccess(status) {
  return {
    type: FAVOURITE_SUCCESS,
    status: status,
    skipLoading: true
  };
};

function favouriteFail(status, error) {
  return {
    type: FAVOURITE_FAIL,
    status: status,
    error: error,
    skipLoading: true
  };
};

function unfavouriteRequest(status) {
  return {
    type: UNFAVOURITE_REQUEST,
    status: status,
    skipLoading: true
  };
};

function unfavouriteSuccess(status) {
  return {
    type: UNFAVOURITE_SUCCESS,
    status: status,
    skipLoading: true
  };
};

function unfavouriteFail(status, error) {
  return {
    type: UNFAVOURITE_FAIL,
    status: status,
    error: error,
    skipLoading: true
  };
};

function fetchReblogs(id) {
  return function (dispatch, getState) {
    dispatch(fetchReblogsRequest(id));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get('/api/v1/statuses/' + id + '/reblogged_by').then(function (response) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__importer__["g" /* importFetchedAccounts */])(response.data));
      dispatch(fetchReblogsSuccess(id, response.data));
    }).catch(function (error) {
      dispatch(fetchReblogsFail(id, error));
    });
  };
};

function fetchReblogsRequest(id) {
  return {
    type: REBLOGS_FETCH_REQUEST,
    id: id
  };
};

function fetchReblogsSuccess(id, accounts) {
  return {
    type: REBLOGS_FETCH_SUCCESS,
    id: id,
    accounts: accounts
  };
};

function fetchReblogsFail(id, error) {
  return {
    type: REBLOGS_FETCH_FAIL,
    error: error
  };
};

function fetchFavourites(id) {
  return function (dispatch, getState) {
    dispatch(fetchFavouritesRequest(id));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get('/api/v1/statuses/' + id + '/favourited_by').then(function (response) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__importer__["g" /* importFetchedAccounts */])(response.data));
      dispatch(fetchFavouritesSuccess(id, response.data));
    }).catch(function (error) {
      dispatch(fetchFavouritesFail(id, error));
    });
  };
};

function fetchFavouritesRequest(id) {
  return {
    type: FAVOURITES_FETCH_REQUEST,
    id: id
  };
};

function fetchFavouritesSuccess(id, accounts) {
  return {
    type: FAVOURITES_FETCH_SUCCESS,
    id: id,
    accounts: accounts
  };
};

function fetchFavouritesFail(id, error) {
  return {
    type: FAVOURITES_FETCH_FAIL,
    error: error
  };
};

function pin(status) {
  return function (dispatch, getState) {
    dispatch(pinRequest(status));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).post('/api/v1/statuses/' + status.get('id') + '/pin').then(function (response) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__importer__["h" /* importFetchedStatus */])(response.data));
      dispatch(pinSuccess(status));
    }).catch(function (error) {
      dispatch(pinFail(status, error));
    });
  };
};

function pinRequest(status) {
  return {
    type: PIN_REQUEST,
    status: status,
    skipLoading: true
  };
};

function pinSuccess(status) {
  return {
    type: PIN_SUCCESS,
    status: status,
    skipLoading: true
  };
};

function pinFail(status, error) {
  return {
    type: PIN_FAIL,
    status: status,
    error: error,
    skipLoading: true
  };
};

function unpin(status) {
  return function (dispatch, getState) {
    dispatch(unpinRequest(status));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).post('/api/v1/statuses/' + status.get('id') + '/unpin').then(function (response) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__importer__["h" /* importFetchedStatus */])(response.data));
      dispatch(unpinSuccess(status));
    }).catch(function (error) {
      dispatch(unpinFail(status, error));
    });
  };
};

function unpinRequest(status) {
  return {
    type: UNPIN_REQUEST,
    status: status,
    skipLoading: true
  };
};

function unpinSuccess(status) {
  return {
    type: UNPIN_SUCCESS,
    status: status,
    skipLoading: true
  };
};

function unpinFail(status, error) {
  return {
    type: UNPIN_FAIL,
    status: status,
    error: error,
    skipLoading: true
  };
};

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export STATUS_FETCH_REQUEST */
/* unused harmony export STATUS_FETCH_SUCCESS */
/* unused harmony export STATUS_FETCH_FAIL */
/* unused harmony export STATUS_DELETE_REQUEST */
/* unused harmony export STATUS_DELETE_SUCCESS */
/* unused harmony export STATUS_DELETE_FAIL */
/* unused harmony export CONTEXT_FETCH_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CONTEXT_FETCH_SUCCESS; });
/* unused harmony export CONTEXT_FETCH_FAIL */
/* unused harmony export STATUS_MUTE_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return STATUS_MUTE_SUCCESS; });
/* unused harmony export STATUS_MUTE_FAIL */
/* unused harmony export STATUS_UNMUTE_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return STATUS_UNMUTE_SUCCESS; });
/* unused harmony export STATUS_UNMUTE_FAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return STATUS_REVEAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return STATUS_HIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REDRAFT; });
/* unused harmony export fetchStatusRequest */
/* harmony export (immutable) */ __webpack_exports__["h"] = fetchStatus;
/* unused harmony export fetchStatusSuccess */
/* unused harmony export fetchStatusFail */
/* unused harmony export redraft */
/* harmony export (immutable) */ __webpack_exports__["g"] = deleteStatus;
/* unused harmony export deleteStatusRequest */
/* unused harmony export deleteStatusSuccess */
/* unused harmony export deleteStatusFail */
/* unused harmony export fetchContext */
/* unused harmony export fetchContextRequest */
/* unused harmony export fetchContextSuccess */
/* unused harmony export fetchContextFail */
/* harmony export (immutable) */ __webpack_exports__["j"] = muteStatus;
/* unused harmony export muteStatusRequest */
/* unused harmony export muteStatusSuccess */
/* unused harmony export muteStatusFail */
/* harmony export (immutable) */ __webpack_exports__["l"] = unmuteStatus;
/* unused harmony export unmuteStatusRequest */
/* unused harmony export unmuteStatusSuccess */
/* unused harmony export unmuteStatusFail */
/* harmony export (immutable) */ __webpack_exports__["i"] = hideStatus;
/* harmony export (immutable) */ __webpack_exports__["k"] = revealStatus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__storage_db__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__storage_modifier__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__timelines__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__cards__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__importer__ = __webpack_require__(15);








var STATUS_FETCH_REQUEST = 'STATUS_FETCH_REQUEST';
var STATUS_FETCH_SUCCESS = 'STATUS_FETCH_SUCCESS';
var STATUS_FETCH_FAIL = 'STATUS_FETCH_FAIL';

var STATUS_DELETE_REQUEST = 'STATUS_DELETE_REQUEST';
var STATUS_DELETE_SUCCESS = 'STATUS_DELETE_SUCCESS';
var STATUS_DELETE_FAIL = 'STATUS_DELETE_FAIL';

var CONTEXT_FETCH_REQUEST = 'CONTEXT_FETCH_REQUEST';
var CONTEXT_FETCH_SUCCESS = 'CONTEXT_FETCH_SUCCESS';
var CONTEXT_FETCH_FAIL = 'CONTEXT_FETCH_FAIL';

var STATUS_MUTE_REQUEST = 'STATUS_MUTE_REQUEST';
var STATUS_MUTE_SUCCESS = 'STATUS_MUTE_SUCCESS';
var STATUS_MUTE_FAIL = 'STATUS_MUTE_FAIL';

var STATUS_UNMUTE_REQUEST = 'STATUS_UNMUTE_REQUEST';
var STATUS_UNMUTE_SUCCESS = 'STATUS_UNMUTE_SUCCESS';
var STATUS_UNMUTE_FAIL = 'STATUS_UNMUTE_FAIL';

var STATUS_REVEAL = 'STATUS_REVEAL';
var STATUS_HIDE = 'STATUS_HIDE';

var REDRAFT = 'REDRAFT';

function fetchStatusRequest(id, skipLoading) {
  return {
    type: STATUS_FETCH_REQUEST,
    id: id,
    skipLoading: skipLoading
  };
};

function getFromDB(dispatch, getState, accountIndex, index, id) {
  return new Promise(function (resolve, reject) {
    var request = index.get(id);

    request.onerror = reject;

    request.onsuccess = function () {
      var promises = [];

      if (!request.result) {
        reject();
        return;
      }

      dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__importer__["j" /* importStatus */])(request.result));

      if (getState().getIn(['accounts', request.result.account], null) === null) {
        promises.push(new Promise(function (accountResolve, accountReject) {
          var accountRequest = accountIndex.get(request.result.account);

          accountRequest.onerror = accountReject;
          accountRequest.onsuccess = function () {
            if (!request.result) {
              accountReject();
              return;
            }

            dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__importer__["e" /* importAccount */])(accountRequest.result));
            accountResolve();
          };
        }));
      }

      if (request.result.reblog && getState().getIn(['statuses', request.result.reblog], null) === null) {
        promises.push(getFromDB(dispatch, getState, accountIndex, index, request.result.reblog));
      }

      resolve(Promise.all(promises));
    };
  });
}

function fetchStatus(id) {
  return function (dispatch, getState) {
    var skipLoading = getState().getIn(['statuses', id], null) !== null;

    dispatch(fetchContext(id));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__cards__["b" /* fetchStatusCard */])(id));

    if (skipLoading) {
      return;
    }

    dispatch(fetchStatusRequest(id, skipLoading));

    Object(__WEBPACK_IMPORTED_MODULE_1__storage_db__["a" /* default */])().then(function (db) {
      var transaction = db.transaction(['accounts', 'statuses'], 'read');
      var accountIndex = transaction.objectStore('accounts').index('id');
      var index = transaction.objectStore('statuses').index('id');

      return getFromDB(dispatch, getState, accountIndex, index, id).then(function () {
        db.close();
      }, function (error) {
        db.close();
        throw error;
      });
    }).then(function () {
      dispatch(fetchStatusSuccess(skipLoading));
    }, function () {
      return Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get('/api/v1/statuses/' + id).then(function (response) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__importer__["h" /* importFetchedStatus */])(response.data));
        dispatch(fetchStatusSuccess(skipLoading));
      });
    }).catch(function (error) {
      dispatch(fetchStatusFail(id, error, skipLoading));
    });
  };
};

function fetchStatusSuccess(skipLoading) {
  return {
    type: STATUS_FETCH_SUCCESS,
    skipLoading: skipLoading
  };
};

function fetchStatusFail(id, error, skipLoading) {
  return {
    type: STATUS_FETCH_FAIL,
    id: id,
    error: error,
    skipLoading: skipLoading,
    skipAlert: true
  };
};

function redraft(status) {
  return {
    type: REDRAFT,
    status: status
  };
};

function deleteStatus(id) {
  var withRedraft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  return function (dispatch, getState) {
    var status = getState().getIn(['statuses', id]);

    dispatch(deleteStatusRequest(id));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).delete('/api/v1/statuses/' + id).then(function () {
      Object(__WEBPACK_IMPORTED_MODULE_2__storage_modifier__["a" /* evictStatus */])(id);
      dispatch(deleteStatusSuccess(id));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__timelines__["h" /* deleteFromTimelines */])(id));

      if (withRedraft) {
        dispatch(redraft(status));
      }
    }).catch(function (error) {
      dispatch(deleteStatusFail(id, error));
    });
  };
};

function deleteStatusRequest(id) {
  return {
    type: STATUS_DELETE_REQUEST,
    id: id
  };
};

function deleteStatusSuccess(id) {
  return {
    type: STATUS_DELETE_SUCCESS,
    id: id
  };
};

function deleteStatusFail(id, error) {
  return {
    type: STATUS_DELETE_FAIL,
    id: id,
    error: error
  };
};

function fetchContext(id) {
  return function (dispatch, getState) {
    dispatch(fetchContextRequest(id));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get('/api/v1/statuses/' + id + '/context').then(function (response) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_5__importer__["i" /* importFetchedStatuses */])(response.data.ancestors.concat(response.data.descendants)));
      dispatch(fetchContextSuccess(id, response.data.ancestors, response.data.descendants));
    }).catch(function (error) {
      if (error.response && error.response.status === 404) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__timelines__["h" /* deleteFromTimelines */])(id));
      }

      dispatch(fetchContextFail(id, error));
    });
  };
};

function fetchContextRequest(id) {
  return {
    type: CONTEXT_FETCH_REQUEST,
    id: id
  };
};

function fetchContextSuccess(id, ancestors, descendants) {
  return {
    type: CONTEXT_FETCH_SUCCESS,
    id: id,
    ancestors: ancestors,
    descendants: descendants,
    statuses: ancestors.concat(descendants)
  };
};

function fetchContextFail(id, error) {
  return {
    type: CONTEXT_FETCH_FAIL,
    id: id,
    error: error,
    skipAlert: true
  };
};

function muteStatus(id) {
  return function (dispatch, getState) {
    dispatch(muteStatusRequest(id));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).post('/api/v1/statuses/' + id + '/mute').then(function () {
      dispatch(muteStatusSuccess(id));
    }).catch(function (error) {
      dispatch(muteStatusFail(id, error));
    });
  };
};

function muteStatusRequest(id) {
  return {
    type: STATUS_MUTE_REQUEST,
    id: id
  };
};

function muteStatusSuccess(id) {
  return {
    type: STATUS_MUTE_SUCCESS,
    id: id
  };
};

function muteStatusFail(id, error) {
  return {
    type: STATUS_MUTE_FAIL,
    id: id,
    error: error
  };
};

function unmuteStatus(id) {
  return function (dispatch, getState) {
    dispatch(unmuteStatusRequest(id));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).post('/api/v1/statuses/' + id + '/unmute').then(function () {
      dispatch(unmuteStatusSuccess(id));
    }).catch(function (error) {
      dispatch(unmuteStatusFail(id, error));
    });
  };
};

function unmuteStatusRequest(id) {
  return {
    type: STATUS_UNMUTE_REQUEST,
    id: id
  };
};

function unmuteStatusSuccess(id) {
  return {
    type: STATUS_UNMUTE_SUCCESS,
    id: id
  };
};

function unmuteStatusFail(id, error) {
  return {
    type: STATUS_UNMUTE_FAIL,
    id: id,
    error: error
  };
};

function hideStatus(ids) {
  if (!Array.isArray(ids)) {
    ids = [ids];
  }

  return {
    type: STATUS_HIDE,
    ids: ids
  };
};

function revealStatus(ids) {
  if (!Array.isArray(ids)) {
    ids = [ids];
  }

  return {
    type: STATUS_REVEAL,
    ids: ids
  };
};

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ColumnHeader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(7);





var _class, _class2, _temp2;






var messages = Object(__WEBPACK_IMPORTED_MODULE_7_react_intl__["f" /* defineMessages */])({
  show: {
    'id': 'column_header.show_settings',
    'defaultMessage': 'Show settings'
  },
  hide: {
    'id': 'column_header.hide_settings',
    'defaultMessage': 'Hide settings'
  },
  moveLeft: {
    'id': 'column_header.moveLeft_settings',
    'defaultMessage': 'Move column to the left'
  },
  moveRight: {
    'id': 'column_header.moveRight_settings',
    'defaultMessage': 'Move column to the right'
  }
});

var ColumnHeader = Object(__WEBPACK_IMPORTED_MODULE_7_react_intl__["g" /* injectIntl */])(_class = (_temp2 = _class2 = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ColumnHeader, _React$PureComponent);

  function ColumnHeader() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ColumnHeader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
      collapsed: true,
      animating: false
    }, _this.handleToggleClick = function (e) {
      e.stopPropagation();
      _this.setState({ collapsed: !_this.state.collapsed, animating: true });
    }, _this.handleTitleClick = function () {
      _this.props.onClick();
    }, _this.handleMoveLeft = function () {
      _this.props.onMove(-1);
    }, _this.handleMoveRight = function () {
      _this.props.onMove(1);
    }, _this.handleBackClick = function () {
      if (window.history && window.history.length === 1) _this.context.router.history.push('/');else _this.context.router.history.goBack();
    }, _this.handleTransitionEnd = function () {
      _this.setState({ animating: false });
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  ColumnHeader.prototype.render = function render() {
    var _props = this.props,
        title = _props.title,
        icon = _props.icon,
        active = _props.active,
        children = _props.children,
        pinned = _props.pinned,
        onPin = _props.onPin,
        multiColumn = _props.multiColumn,
        extraButton = _props.extraButton,
        showBackButton = _props.showBackButton,
        formatMessage = _props.intl.formatMessage;
    var _state = this.state,
        collapsed = _state.collapsed,
        animating = _state.animating;


    var wrapperClassName = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('column-header__wrapper', {
      'active': active
    });

    var buttonClassName = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('column-header', {
      'active': active
    });

    var collapsibleClassName = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('column-header__collapsible', {
      'collapsed': collapsed,
      'animating': animating
    });

    var collapsibleButtonClassName = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('column-header__button', {
      'active': !collapsed
    });

    var extraContent = void 0,
        pinButton = void 0,
        moveButtons = void 0,
        backButton = void 0,
        collapseButton = void 0;

    if (children) {
      extraContent = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
        className: 'column-header__collapsible__extra'
      }, 'extra-content', children);
    }

    if (multiColumn && pinned) {
      pinButton = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
        className: 'text-btn column-header__setting-btn',
        onClick: onPin
      }, 'pin-button', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
        className: 'fa fa fa-times'
      }), ' ', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7_react_intl__["b" /* FormattedMessage */], {
        id: 'column_header.unpin',
        defaultMessage: 'Unpin'
      }));

      moveButtons = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
        className: 'column-header__setting-arrows'
      }, 'move-buttons', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
        title: formatMessage(messages.moveLeft),
        'aria-label': formatMessage(messages.moveLeft),
        className: 'text-btn column-header__setting-btn',
        onClick: this.handleMoveLeft
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
        className: 'fa fa-chevron-left'
      })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
        title: formatMessage(messages.moveRight),
        'aria-label': formatMessage(messages.moveRight),
        className: 'text-btn column-header__setting-btn',
        onClick: this.handleMoveRight
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
        className: 'fa fa-chevron-right'
      })));
    } else if (multiColumn) {
      pinButton = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
        className: 'text-btn column-header__setting-btn',
        onClick: onPin
      }, 'pin-button', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
        className: 'fa fa fa-plus'
      }), ' ', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7_react_intl__["b" /* FormattedMessage */], {
        id: 'column_header.pin',
        defaultMessage: 'Pin'
      }));
    }

    if (!pinned && (multiColumn || showBackButton)) {
      backButton = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
        onClick: this.handleBackClick,
        className: 'column-header__back-button'
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
        className: 'fa fa-fw fa-chevron-left column-back-button__icon'
      }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7_react_intl__["b" /* FormattedMessage */], {
        id: 'column_back_button.label',
        defaultMessage: 'Back'
      }));
    }

    var collapsedContent = [extraContent];

    if (multiColumn) {
      collapsedContent.push(moveButtons);
      collapsedContent.push(pinButton);
    }

    if (children || multiColumn) {
      collapseButton = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
        className: collapsibleButtonClassName,
        title: formatMessage(collapsed ? messages.show : messages.hide),
        'aria-label': formatMessage(collapsed ? messages.show : messages.hide),
        'aria-pressed': collapsed ? 'false' : 'true',
        onClick: this.handleToggleClick
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
        className: 'fa fa-sliders'
      }));
    }

    var hasTitle = icon && title;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: wrapperClassName
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('h1', {
      className: buttonClassName
    }, void 0, hasTitle && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
      onClick: this.handleTitleClick
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
      className: 'fa fa-fw fa-' + icon + ' column-header__icon'
    }), title), !hasTitle && backButton, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'column-header__buttons'
    }, void 0, hasTitle && backButton, extraButton, collapseButton)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: collapsibleClassName,
      tabIndex: collapsed ? -1 : null,
      onTransitionEnd: this.handleTransitionEnd
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'column-header__collapsible-inner'
    }, void 0, (!collapsed || animating) && collapsedContent)));
  };

  return ColumnHeader;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent), _class2.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
}, _temp2)) || _class;



/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Column; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_detect_passive_events__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_detect_passive_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_detect_passive_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__scroll__ = __webpack_require__(91);








var Column = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Column, _React$PureComponent);

  function Column() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Column);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.handleWheel = function () {
      if (typeof _this._interruptScrollAnimation !== 'function') {
        return;
      }

      _this._interruptScrollAnimation();
    }, _this.setRef = function (c) {
      _this.node = c;
    }, _temp), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Column.prototype.scrollTop = function scrollTop() {
    var scrollable = this.node.querySelector('.scrollable');

    if (!scrollable) {
      return;
    }

    this._interruptScrollAnimation = Object(__WEBPACK_IMPORTED_MODULE_5__scroll__["b" /* scrollTop */])(scrollable);
  };

  Column.prototype.componentDidMount = function componentDidMount() {
    this.node.addEventListener('wheel', this.handleWheel, __WEBPACK_IMPORTED_MODULE_4_detect_passive_events___default.a.hasSupport ? { passive: true } : false);
  };

  Column.prototype.componentWillUnmount = function componentWillUnmount() {
    this.node.removeEventListener('wheel', this.handleWheel);
  };

  Column.prototype.render = function render() {
    var children = this.props.children;


    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      { role: 'region', className: 'column', ref: this.setRef },
      children
    );
  };

  return Column;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.PureComponent);



/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export connectTimelineStream */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return connectUserStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return connectCommunityStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return connectPublicStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return connectHashtagStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return connectDirectStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return connectListStream; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stream__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__timelines__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__notifications__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filters__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__locales__ = __webpack_require__(6);






var _getLocale = Object(__WEBPACK_IMPORTED_MODULE_4__locales__["getLocale"])(),
    messages = _getLocale.messages;

function connectTimelineStream(timelineId, path) {
  var pollingRefresh = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;


  return Object(__WEBPACK_IMPORTED_MODULE_0__stream__["a" /* connectStream */])(path, pollingRefresh, function (dispatch, getState) {
    var locale = getState().getIn(['meta', 'locale']);
    return {
      onDisconnect: function onDisconnect() {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__timelines__["i" /* disconnectTimeline */])(timelineId));
      },
      onReceive: function onReceive(data) {
        switch (data.event) {
          case 'update':
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__timelines__["t" /* updateTimeline */])(timelineId, JSON.parse(data.payload)));
            break;
          case 'delete':
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__timelines__["h" /* deleteFromTimelines */])(data.payload));
            break;
          case 'notification':
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["j" /* updateNotifications */])(JSON.parse(data.payload), messages, locale));
            break;
          case 'filters_changed':
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__filters__["b" /* fetchFilters */])());
            break;
        }
      }
    };
  });
}

var refreshHomeTimelineAndNotification = function refreshHomeTimelineAndNotification(dispatch, done) {
  dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__timelines__["p" /* expandHomeTimeline */])({}, function () {
    return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__notifications__["h" /* expandNotifications */])({}, done));
  }));
};

var connectUserStream = function connectUserStream() {
  return connectTimelineStream('home', 'user', refreshHomeTimelineAndNotification);
};
var connectCommunityStream = function connectCommunityStream() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      onlyMedia = _ref.onlyMedia;

  return connectTimelineStream('community' + (onlyMedia ? ':media' : ''), 'public:local' + (onlyMedia ? ':media' : ''));
};
var connectPublicStream = function connectPublicStream() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      onlyMedia = _ref2.onlyMedia;

  return connectTimelineStream('public' + (onlyMedia ? ':media' : ''), 'public' + (onlyMedia ? ':media' : ''));
};
var connectHashtagStream = function connectHashtagStream(tag) {
  return connectTimelineStream('hashtag:' + tag, 'hashtag&tag=' + tag);
};
var connectDirectStream = function connectDirectStream() {
  return connectTimelineStream('direct', 'direct');
};
var connectListStream = function connectListStream(id) {
  return connectTimelineStream('list:' + id, 'list&list=' + id);
};

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "buildCustomEmojis", function() { return buildCustomEmojis; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__initial_state__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emoji_unicode_mapping_light__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emoji_unicode_mapping_light___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__emoji_unicode_mapping_light__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_substring_trie__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_substring_trie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_substring_trie__);




var trie = new __WEBPACK_IMPORTED_MODULE_2_substring_trie___default.a(Object.keys(__WEBPACK_IMPORTED_MODULE_1__emoji_unicode_mapping_light___default.a));

var assetHost = process.env.CDN_HOST || '';

var emojify = function emojify(str) {
  var customEmojis = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var tagCharsWithoutEmojis = '<&';
  var tagCharsWithEmojis = Object.keys(customEmojis).length ? '<&:' : '<&';
  var rtn = '',
      tagChars = tagCharsWithEmojis,
      invisible = 0;

  var _loop = function _loop() {
    var match = void 0,
        i = 0,
        tag = void 0;
    while (i < str.length && (tag = tagChars.indexOf(str[i])) === -1 && (invisible || !(match = trie.search(str.slice(i))))) {
      i += str.codePointAt(i) < 65536 ? 1 : 2;
    }
    var rend = void 0,
        replacement = '';
    if (i === str.length) {
      return 'break';
    } else if (str[i] === ':') {
      if (!function () {
        rend = str.indexOf(':', i + 1) + 1;
        if (!rend) return false; // no pair of ':'
        var lt = str.indexOf('<', i + 1);
        if (!(lt === -1 || lt >= rend)) return false; // tag appeared before closing ':'
        var shortname = str.slice(i, rend);
        // now got a replacee as ':shortname:'
        // if you want additional emoji handler, add statements below which set replacement and return true.
        if (shortname in customEmojis) {
          var filename = __WEBPACK_IMPORTED_MODULE_0__initial_state__["a" /* autoPlayGif */] ? customEmojis[shortname].url : customEmojis[shortname].static_url;
          replacement = '<img draggable="false" class="emojione" alt="' + shortname + '" title="' + shortname + '" src="' + filename + '" />';
          return true;
        }
        return false;
      }()) rend = ++i;
    } else if (tag >= 0) {
      // <, &
      rend = str.indexOf('>;'[tag], i + 1) + 1;
      if (!rend) {
        return 'break';
      }
      if (tag === 0) {
        if (invisible) {
          if (str[i + 1] === '/') {
            // closing tag
            if (! --invisible) {
              tagChars = tagCharsWithEmojis;
            }
          } else if (str[rend - 2] !== '/') {
            // opening tag
            invisible++;
          }
        } else {
          if (str.startsWith('<span class="invisible">', i)) {
            // avoid emojifying on invisible text
            invisible = 1;
            tagChars = tagCharsWithoutEmojis;
          }
        }
      }
      i = rend;
    } else {
      // matched to unicode emoji
      var _unicodeMapping$match = __WEBPACK_IMPORTED_MODULE_1__emoji_unicode_mapping_light___default.a[match],
          filename = _unicodeMapping$match.filename,
          shortCode = _unicodeMapping$match.shortCode;

      var title = shortCode ? ':' + shortCode + ':' : '';
      replacement = '<img draggable="false" class="emojione" alt="' + match + '" title="' + title + '" src="' + assetHost + '/emoji/' + filename + '.svg" />';
      rend = i + match.length;
    }
    rtn += str.slice(0, i) + replacement;
    str = str.slice(rend);
  };

  for (;;) {
    var _ret = _loop();

    if (_ret === 'break') break;
  }
  return rtn + str;
};

/* harmony default export */ __webpack_exports__["default"] = (emojify);

var buildCustomEmojis = function buildCustomEmojis(customEmojis) {
  var emojis = [];

  customEmojis.forEach(function (emoji) {
    var shortcode = emoji.get('shortcode');
    var url = __WEBPACK_IMPORTED_MODULE_0__initial_state__["a" /* autoPlayGif */] ? emoji.get('url') : emoji.get('static_url');
    var name = shortcode.replace(':', '');

    emojis.push({
      id: name,
      name: name,
      short_names: [name],
      text: '',
      emoticons: [],
      keywords: [name],
      imageUrl: url,
      custom: true
    });
  });

  return emojis;
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(35)))

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findElementPosition", function() { return findElementPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getPointerPosition", function() { return getPointerPosition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Video; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_throttle__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_throttle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_throttle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_intl__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ui_util_fullscreen__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__initial_state__ = __webpack_require__(14);






var _class;










var messages = Object(__WEBPACK_IMPORTED_MODULE_6_react_intl__["f" /* defineMessages */])({
  play: {
    'id': 'video.play',
    'defaultMessage': 'Play'
  },
  pause: {
    'id': 'video.pause',
    'defaultMessage': 'Pause'
  },
  mute: {
    'id': 'video.mute',
    'defaultMessage': 'Mute sound'
  },
  unmute: {
    'id': 'video.unmute',
    'defaultMessage': 'Unmute sound'
  },
  hide: {
    'id': 'video.hide',
    'defaultMessage': 'Hide video'
  },
  expand: {
    'id': 'video.expand',
    'defaultMessage': 'Expand video'
  },
  close: {
    'id': 'video.close',
    'defaultMessage': 'Close video'
  },
  fullscreen: {
    'id': 'video.fullscreen',
    'defaultMessage': 'Full screen'
  },
  exit_fullscreen: {
    'id': 'video.exit_fullscreen',
    'defaultMessage': 'Exit full screen'
  }
});

var formatTime = function formatTime(secondsNum) {
  var hours = Math.floor(secondsNum / 3600);
  var minutes = Math.floor((secondsNum - hours * 3600) / 60);
  var seconds = secondsNum - hours * 3600 - minutes * 60;

  if (hours < 10) hours = '0' + hours;
  if (minutes < 10) minutes = '0' + minutes;
  if (seconds < 10) seconds = '0' + seconds;

  return (hours === '00' ? '' : hours + ':') + (minutes + ':' + seconds);
};

var findElementPosition = function findElementPosition(el) {
  var box = void 0;

  if (el.getBoundingClientRect && el.parentNode) {
    box = el.getBoundingClientRect();
  }

  if (!box) {
    return {
      left: 0,
      top: 0
    };
  }

  var docEl = document.documentElement;
  var body = document.body;

  var clientLeft = docEl.clientLeft || body.clientLeft || 0;
  var scrollLeft = window.pageXOffset || body.scrollLeft;
  var left = box.left + scrollLeft - clientLeft;

  var clientTop = docEl.clientTop || body.clientTop || 0;
  var scrollTop = window.pageYOffset || body.scrollTop;
  var top = box.top + scrollTop - clientTop;

  return {
    left: Math.round(left),
    top: Math.round(top)
  };
};

var getPointerPosition = function getPointerPosition(el, event) {
  var position = {};
  var box = findElementPosition(el);
  var boxW = el.offsetWidth;
  var boxH = el.offsetHeight;
  var boxY = box.top;
  var boxX = box.left;

  var pageY = event.pageY;
  var pageX = event.pageX;

  if (event.changedTouches) {
    pageX = event.changedTouches[0].pageX;
    pageY = event.changedTouches[0].pageY;
  }

  position.y = Math.max(0, Math.min(1, (pageY - boxY) / boxH));
  position.x = Math.max(0, Math.min(1, (pageX - boxX) / boxW));

  return position;
};

var Video = Object(__WEBPACK_IMPORTED_MODULE_6_react_intl__["g" /* injectIntl */])(_class = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Video, _React$PureComponent);

  function Video() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Video);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
      currentTime: 0,
      duration: 0,
      paused: true,
      dragging: false,
      containerWidth: false,
      fullscreen: false,
      hovered: false,
      muted: false,
      revealed: !_this.props.sensitive || __WEBPACK_IMPORTED_MODULE_10__initial_state__["e" /* displaySensitiveMedia */]
    }, _this.setPlayerRef = function (c) {
      _this.player = c;

      if (c) {
        _this.setState({
          containerWidth: c.offsetWidth
        });
      }
    }, _this.setVideoRef = function (c) {
      _this.video = c;
    }, _this.setSeekRef = function (c) {
      _this.seek = c;
    }, _this.handleClickRoot = function (e) {
      return e.stopPropagation();
    }, _this.handlePlay = function () {
      _this.setState({ paused: false });
    }, _this.handlePause = function () {
      _this.setState({ paused: true });
    }, _this.handleTimeUpdate = function () {
      _this.setState({
        currentTime: Math.floor(_this.video.currentTime),
        duration: Math.floor(_this.video.duration)
      });
    }, _this.handleMouseDown = function (e) {
      document.addEventListener('mousemove', _this.handleMouseMove, true);
      document.addEventListener('mouseup', _this.handleMouseUp, true);
      document.addEventListener('touchmove', _this.handleMouseMove, true);
      document.addEventListener('touchend', _this.handleMouseUp, true);

      _this.setState({ dragging: true });
      _this.video.pause();
      _this.handleMouseMove(e);
    }, _this.handleMouseUp = function () {
      document.removeEventListener('mousemove', _this.handleMouseMove, true);
      document.removeEventListener('mouseup', _this.handleMouseUp, true);
      document.removeEventListener('touchmove', _this.handleMouseMove, true);
      document.removeEventListener('touchend', _this.handleMouseUp, true);

      _this.setState({ dragging: false });
      _this.video.play();
    }, _this.handleMouseMove = __WEBPACK_IMPORTED_MODULE_4_lodash_throttle___default()(function (e) {
      var _getPointerPosition = getPointerPosition(_this.seek, e),
          x = _getPointerPosition.x;

      var currentTime = Math.floor(_this.video.duration * x);

      _this.video.currentTime = currentTime;
      _this.setState({ currentTime: currentTime });
    }, 60), _this.togglePlay = function () {
      if (_this.state.paused) {
        _this.video.play();
      } else {
        _this.video.pause();
      }
    }, _this.toggleFullscreen = function () {
      if (Object(__WEBPACK_IMPORTED_MODULE_9__ui_util_fullscreen__["d" /* isFullscreen */])()) {
        Object(__WEBPACK_IMPORTED_MODULE_9__ui_util_fullscreen__["c" /* exitFullscreen */])();
      } else {
        Object(__WEBPACK_IMPORTED_MODULE_9__ui_util_fullscreen__["e" /* requestFullscreen */])(_this.player);
      }
    }, _this.handleFullscreenChange = function () {
      _this.setState({ fullscreen: Object(__WEBPACK_IMPORTED_MODULE_9__ui_util_fullscreen__["d" /* isFullscreen */])() });
    }, _this.handleMouseEnter = function () {
      _this.setState({ hovered: true });
    }, _this.handleMouseLeave = function () {
      _this.setState({ hovered: false });
    }, _this.toggleMute = function () {
      _this.video.muted = !_this.video.muted;
      _this.setState({ muted: _this.video.muted });
    }, _this.toggleReveal = function () {
      if (_this.state.revealed) {
        _this.video.pause();
      }

      _this.setState({ revealed: !_this.state.revealed });
    }, _this.handleLoadedData = function () {
      if (_this.props.startTime) {
        _this.video.currentTime = _this.props.startTime;
        _this.video.play();
      }
    }, _this.handleProgress = function () {
      if (_this.video.buffered.length > 0) {
        _this.setState({ buffer: _this.video.buffered.end(0) / _this.video.duration * 100 });
      }
    }, _this.handleOpenVideo = function () {
      var _this$props = _this.props,
          src = _this$props.src,
          preview = _this$props.preview,
          width = _this$props.width,
          height = _this$props.height;

      var media = Object(__WEBPACK_IMPORTED_MODULE_7_immutable__["fromJS"])({
        type: 'video',
        url: src,
        preview_url: preview,
        width: width,
        height: height
      });

      _this.video.pause();
      _this.props.onOpenVideo(media, _this.video.currentTime);
    }, _this.handleCloseVideo = function () {
      _this.video.pause();
      _this.props.onCloseVideo();
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Video.prototype.componentDidMount = function componentDidMount() {
    document.addEventListener('fullscreenchange', this.handleFullscreenChange, true);
    document.addEventListener('webkitfullscreenchange', this.handleFullscreenChange, true);
    document.addEventListener('mozfullscreenchange', this.handleFullscreenChange, true);
    document.addEventListener('MSFullscreenChange', this.handleFullscreenChange, true);
  };

  Video.prototype.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('fullscreenchange', this.handleFullscreenChange, true);
    document.removeEventListener('webkitfullscreenchange', this.handleFullscreenChange, true);
    document.removeEventListener('mozfullscreenchange', this.handleFullscreenChange, true);
    document.removeEventListener('MSFullscreenChange', this.handleFullscreenChange, true);
  };

  Video.prototype.render = function render() {
    var _props = this.props,
        preview = _props.preview,
        src = _props.src,
        inline = _props.inline,
        startTime = _props.startTime,
        onOpenVideo = _props.onOpenVideo,
        onCloseVideo = _props.onCloseVideo,
        intl = _props.intl,
        alt = _props.alt,
        detailed = _props.detailed;
    var _state = this.state,
        containerWidth = _state.containerWidth,
        currentTime = _state.currentTime,
        duration = _state.duration,
        buffer = _state.buffer,
        dragging = _state.dragging,
        paused = _state.paused,
        fullscreen = _state.fullscreen,
        hovered = _state.hovered,
        muted = _state.muted,
        revealed = _state.revealed;

    var progress = currentTime / duration * 100;
    var playerStyle = {};

    var _props2 = this.props,
        width = _props2.width,
        height = _props2.height;


    if (inline && containerWidth) {
      width = containerWidth;
      height = containerWidth / (16 / 9);

      playerStyle.width = width;
      playerStyle.height = height;
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'div',
      {
        role: 'menuitem',
        className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('video-player', { inactive: !revealed, detailed: detailed, inline: inline && !fullscreen, fullscreen: fullscreen }),
        style: playerStyle,
        ref: this.setPlayerRef,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        onClick: this.handleClickRoot,
        tabIndex: 0
      },
      __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('video', {
        ref: this.setVideoRef,
        src: src,
        poster: preview,
        preload: startTime ? 'auto' : 'none',
        loop: true,
        role: 'button',
        tabIndex: '0',
        'aria-label': alt,
        width: width,
        height: height,
        onClick: this.togglePlay,
        onPlay: this.handlePlay,
        onPause: this.handlePause,
        onTimeUpdate: this.handleTimeUpdate,
        onLoadedData: this.handleLoadedData,
        onProgress: this.handleProgress
      }),
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
        type: 'button',
        className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('video-player__spoiler', { active: !revealed }),
        onClick: this.toggleReveal
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('span', {
        className: 'video-player__spoiler__title'
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6_react_intl__["b" /* FormattedMessage */], {
        id: 'status.sensitive_warning',
        defaultMessage: 'Sensitive content'
      })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('span', {
        className: 'video-player__spoiler__subtitle'
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6_react_intl__["b" /* FormattedMessage */], {
        id: 'status.sensitive_toggle',
        defaultMessage: 'Click to view'
      }))),
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
        className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('video-player__controls', { active: paused || hovered })
      }, void 0, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        { className: 'video-player__seek', onMouseDown: this.handleMouseDown, ref: this.setSeekRef },
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
          className: 'video-player__seek__buffer',
          style: { width: buffer + '%' }
        }),
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
          className: 'video-player__seek__progress',
          style: { width: progress + '%' }
        }),
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('span', {
          className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('video-player__seek__handle', { active: dragging }),
          tabIndex: '0',
          style: { left: progress + '%' }
        })
      ), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
        className: 'video-player__buttons-bar'
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
        className: 'video-player__buttons left'
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
        type: 'button',
        'aria-label': intl.formatMessage(paused ? messages.play : messages.pause),
        onClick: this.togglePlay
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
        className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('fa fa-fw', { 'fa-play': paused, 'fa-pause': !paused })
      })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
        type: 'button',
        'aria-label': intl.formatMessage(muted ? messages.unmute : messages.mute),
        onClick: this.toggleMute
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
        className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('fa fa-fw', { 'fa-volume-off': muted, 'fa-volume-up': !muted })
      })), !onCloseVideo && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
        type: 'button',
        'aria-label': intl.formatMessage(messages.hide),
        onClick: this.toggleReveal
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
        className: 'fa fa-fw fa-eye'
      })), (detailed || fullscreen) && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('span', {}, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('span', {
        className: 'video-player__time-current'
      }, void 0, formatTime(currentTime)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('span', {
        className: 'video-player__time-sep'
      }, void 0, '/'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('span', {
        className: 'video-player__time-total'
      }, void 0, formatTime(duration)))), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
        className: 'video-player__buttons right'
      }, void 0, !fullscreen && onOpenVideo && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
        type: 'button',
        'aria-label': intl.formatMessage(messages.expand),
        onClick: this.handleOpenVideo
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
        className: 'fa fa-fw fa-expand'
      })), onCloseVideo && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
        type: 'button',
        'aria-label': intl.formatMessage(messages.close),
        onClick: this.handleCloseVideo
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
        className: 'fa fa-fw fa-compress'
      })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
        type: 'button',
        'aria-label': intl.formatMessage(fullscreen ? messages.exit_fullscreen : messages.fullscreen),
        onClick: this.toggleFullscreen
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
        className: __WEBPACK_IMPORTED_MODULE_8_classnames___default()('fa fa-fw', { 'fa-arrows-alt': !fullscreen, 'fa-compress': fullscreen })
      })))))
    );
  };

  return Video;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.PureComponent)) || _class;



/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(173);
var enumBugKeys = __webpack_require__(118);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jshint node:true */



var IntlRelativeFormat = __webpack_require__(460)['default'];

// Add all locale data to `IntlRelativeFormat`. This module will be ignored when
// bundling for the browser with Browserify/Webpack.
__webpack_require__(465);

// Re-export `IntlRelativeFormat` as the CommonJS default exports with all the
// locale data registered, and with English set as the default locale. Define
// the `default` prop for use with other compiled ES6 Modules.
exports = module.exports = IntlRelativeFormat;
exports['default'] = exports;

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Convenience function to load polyfills and return a promise when it's done.
// If there are no polyfills, then this is just Promise.resolve() which means
// it will execute in the same tick of the event loop (i.e. near-instant).

function importBasePolyfills() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 826));
}

function importExtraPolyfills() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 827));
}

function loadPolyfills() {
  var needsBasePolyfills = !(Array.prototype.includes && HTMLCanvasElement.prototype.toBlob && window.Intl && Number.isNaN && Object.assign && Object.values && window.Symbol);

  // Latest version of Firefox and Safari do not have IntersectionObserver.
  // Edge does not have requestIdleCallback and object-fit CSS property.
  // This avoids shipping them all the polyfills.
  var needsExtraPolyfills = !(window.IntersectionObserver && window.IntersectionObserverEntry && 'isIntersecting' in IntersectionObserverEntry.prototype && window.requestIdleCallback && 'object-fit' in new Image().style);

  return Promise.all([needsBasePolyfills && importBasePolyfills(), needsExtraPolyfills && importExtraPolyfills()]);
}

/* harmony default export */ __webpack_exports__["a"] = (loadPolyfills);

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

/***/ }),
/* 80 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 81 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return locationsAreEqual; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_resolve_pathname__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_value_equal__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PathUtils__ = __webpack_require__(52);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};





var createLocation = function createLocation(path, state, key, currentLocation) {
  var location = void 0;
  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = Object(__WEBPACK_IMPORTED_MODULE_2__PathUtils__["d" /* parsePath */])(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends({}, path);

    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_0_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
};

var locationsAreEqual = function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_1_value_equal__["a" /* default */])(a.state, b.state);
};

/***/ }),
/* 84 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || value !== value && other !== other;
}

module.exports = eq;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(232),
    isLength = __webpack_require__(234);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(586),
    listCacheDelete = __webpack_require__(587),
    listCacheGet = __webpack_require__(588),
    listCacheHas = __webpack_require__(589),
    listCacheSet = __webpack_require__(590);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(84);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(604);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}

module.exports = getMapData;

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MUTES_FETCH_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MUTES_FETCH_SUCCESS; });
/* unused harmony export MUTES_FETCH_FAIL */
/* unused harmony export MUTES_EXPAND_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MUTES_EXPAND_SUCCESS; });
/* unused harmony export MUTES_EXPAND_FAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MUTES_INIT_MODAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return MUTES_TOGGLE_HIDE_NOTIFICATIONS; });
/* harmony export (immutable) */ __webpack_exports__["f"] = fetchMutes;
/* unused harmony export fetchMutesRequest */
/* unused harmony export fetchMutesSuccess */
/* unused harmony export fetchMutesFail */
/* harmony export (immutable) */ __webpack_exports__["e"] = expandMutes;
/* unused harmony export expandMutesRequest */
/* unused harmony export expandMutesSuccess */
/* unused harmony export expandMutesFail */
/* harmony export (immutable) */ __webpack_exports__["g"] = initMuteModal;
/* harmony export (immutable) */ __webpack_exports__["h"] = toggleHideNotifications;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accounts__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__importer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modal__ = __webpack_require__(26);





var MUTES_FETCH_REQUEST = 'MUTES_FETCH_REQUEST';
var MUTES_FETCH_SUCCESS = 'MUTES_FETCH_SUCCESS';
var MUTES_FETCH_FAIL = 'MUTES_FETCH_FAIL';

var MUTES_EXPAND_REQUEST = 'MUTES_EXPAND_REQUEST';
var MUTES_EXPAND_SUCCESS = 'MUTES_EXPAND_SUCCESS';
var MUTES_EXPAND_FAIL = 'MUTES_EXPAND_FAIL';

var MUTES_INIT_MODAL = 'MUTES_INIT_MODAL';
var MUTES_TOGGLE_HIDE_NOTIFICATIONS = 'MUTES_TOGGLE_HIDE_NOTIFICATIONS';

function fetchMutes() {
  return function (dispatch, getState) {
    dispatch(fetchMutesRequest());

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get('/api/v1/mutes').then(function (response) {
      var next = Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* getLinks */])(response).refs.find(function (link) {
        return link.rel === 'next';
      });
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__importer__["g" /* importFetchedAccounts */])(response.data));
      dispatch(fetchMutesSuccess(response.data, next ? next.uri : null));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__accounts__["y" /* fetchRelationships */])(response.data.map(function (item) {
        return item.id;
      })));
    }).catch(function (error) {
      return dispatch(fetchMutesFail(error));
    });
  };
};

function fetchMutesRequest() {
  return {
    type: MUTES_FETCH_REQUEST
  };
};

function fetchMutesSuccess(accounts, next) {
  return {
    type: MUTES_FETCH_SUCCESS,
    accounts: accounts,
    next: next
  };
};

function fetchMutesFail(error) {
  return {
    type: MUTES_FETCH_FAIL,
    error: error
  };
};

function expandMutes() {
  return function (dispatch, getState) {
    var url = getState().getIn(['user_lists', 'mutes', 'next']);

    if (url === null) {
      return;
    }

    dispatch(expandMutesRequest());

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get(url).then(function (response) {
      var next = Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* getLinks */])(response).refs.find(function (link) {
        return link.rel === 'next';
      });
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__importer__["g" /* importFetchedAccounts */])(response.data));
      dispatch(expandMutesSuccess(response.data, next ? next.uri : null));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__accounts__["y" /* fetchRelationships */])(response.data.map(function (item) {
        return item.id;
      })));
    }).catch(function (error) {
      return dispatch(expandMutesFail(error));
    });
  };
};

function expandMutesRequest() {
  return {
    type: MUTES_EXPAND_REQUEST
  };
};

function expandMutesSuccess(accounts, next) {
  return {
    type: MUTES_EXPAND_SUCCESS,
    accounts: accounts,
    next: next
  };
};

function expandMutesFail(error) {
  return {
    type: MUTES_EXPAND_FAIL,
    error: error
  };
};

function initMuteModal(account) {
  return function (dispatch) {
    dispatch({
      type: MUTES_INIT_MODAL,
      account: account
    });

    dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__modal__["d" /* openModal */])('MUTE'));
  };
}

function toggleHideNotifications() {
  return function (dispatch) {
    dispatch({ type: MUTES_TOGGLE_HIDE_NOTIFICATIONS });
  };
}

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return scrollRight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return scrollTop; });
var easingOutQuint = function easingOutQuint(x, t, b, c, d) {
  return c * ((t = t / d - 1) * t * t * t * t + 1) + b;
};

var scroll = function scroll(node, key, target) {
  var startTime = Date.now();
  var offset = node[key];
  var gap = target - offset;
  var duration = 1000;
  var interrupt = false;

  var step = function step() {
    var elapsed = Date.now() - startTime;
    var percentage = elapsed / duration;

    if (percentage > 1 || interrupt) {
      return;
    }

    node[key] = easingOutQuint(0, elapsed, offset, gap, duration);
    requestAnimationFrame(step);
  };

  step();

  return function () {
    interrupt = true;
  };
};

var scrollRight = function scrollRight(node, position) {
  return scroll(node, 'scrollLeft', position);
};
var scrollTop = function scrollTop(node) {
  return scroll(node, 'scrollTop', 0);
};

/***/ }),
/* 92 */,
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(32),
    isObject = __webpack_require__(40);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return HEIGHT_CACHE_SET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HEIGHT_CACHE_CLEAR; });
/* harmony export (immutable) */ __webpack_exports__["d"] = setHeight;
/* harmony export (immutable) */ __webpack_exports__["c"] = clearHeight;
var HEIGHT_CACHE_SET = 'HEIGHT_CACHE_SET';
var HEIGHT_CACHE_CLEAR = 'HEIGHT_CACHE_CLEAR';

function setHeight(key, id, height) {
  return {
    type: HEIGHT_CACHE_SET,
    key: key,
    id: id,
    height: height
  };
};

function clearHeight() {
  return {
    type: HEIGHT_CACHE_CLEAR
  };
};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.defaultMemoize = defaultMemoize;
exports.createSelectorCreator = createSelectorCreator;
exports.createStructuredSelector = createStructuredSelector;
function defaultEqualityCheck(a, b) {
  return a === b;
}

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false;
  }

  // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.
  var length = prev.length;
  for (var i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false;
    }
  }

  return true;
}

function defaultMemoize(func) {
  var equalityCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultEqualityCheck;

  var lastArgs = null;
  var lastResult = null;
  // we reference arguments instead of spreading them for performance reasons
  return function () {
    if (!areArgumentsShallowlyEqual(equalityCheck, lastArgs, arguments)) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments);
    }

    lastArgs = arguments;
    return lastResult;
  };
}

function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep;
    }).join(', ');
    throw new Error('Selector creators expect all input-selectors to be functions, ' + ('instead received the following types: [' + dependencyTypes + ']'));
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptions[_key - 1] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var recomputations = 0;
    var resultFunc = funcs.pop();
    var dependencies = getDependencies(funcs);

    var memoizedResultFunc = memoize.apply(undefined, [function () {
      recomputations++;
      // apply arguments instead of spreading for performance.
      return resultFunc.apply(null, arguments);
    }].concat(memoizeOptions));

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    var selector = defaultMemoize(function () {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments));
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params);
    });

    selector.resultFunc = resultFunc;
    selector.recomputations = function () {
      return recomputations;
    };
    selector.resetRecomputations = function () {
      return recomputations = 0;
    };
    return selector;
  };
}

var createSelector = exports.createSelector = createSelectorCreator(defaultMemoize);

function createStructuredSelector(selectors) {
  var selectorCreator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : createSelector;

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ('where each property is a selector, instead received a ' + typeof selectors));
  }
  var objectKeys = Object.keys(selectors);
  return selectorCreator(objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
}

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LIST_FETCH_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return LIST_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return LIST_FETCH_FAIL; });
/* unused harmony export LISTS_FETCH_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LISTS_FETCH_SUCCESS; });
/* unused harmony export LISTS_FETCH_FAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return LIST_EDITOR_TITLE_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return LIST_EDITOR_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return LIST_EDITOR_SETUP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return LIST_CREATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LIST_CREATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return LIST_CREATE_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return LIST_UPDATE_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return LIST_UPDATE_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return LIST_UPDATE_FAIL; });
/* unused harmony export LIST_DELETE_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LIST_DELETE_SUCCESS; });
/* unused harmony export LIST_DELETE_FAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LIST_ACCOUNTS_FETCH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LIST_ACCOUNTS_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LIST_ACCOUNTS_FETCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return LIST_EDITOR_SUGGESTIONS_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return LIST_EDITOR_SUGGESTIONS_READY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return LIST_EDITOR_SUGGESTIONS_CLEAR; });
/* unused harmony export LIST_EDITOR_ADD_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LIST_EDITOR_ADD_SUCCESS; });
/* unused harmony export LIST_EDITOR_ADD_FAIL */
/* unused harmony export LIST_EDITOR_REMOVE_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LIST_EDITOR_REMOVE_SUCCESS; });
/* unused harmony export LIST_EDITOR_REMOVE_FAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return fetchList; });
/* unused harmony export fetchListRequest */
/* unused harmony export fetchListSuccess */
/* unused harmony export fetchListFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return fetchLists; });
/* unused harmony export fetchListsRequest */
/* unused harmony export fetchListsSuccess */
/* unused harmony export fetchListsFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return submitListEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return setupListEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return changeListEditorTitle; });
/* unused harmony export createList */
/* unused harmony export createListRequest */
/* unused harmony export createListSuccess */
/* unused harmony export createListFail */
/* unused harmony export updateList */
/* unused harmony export updateListRequest */
/* unused harmony export updateListSuccess */
/* unused harmony export updateListFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return resetListEditor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return deleteList; });
/* unused harmony export deleteListRequest */
/* unused harmony export deleteListSuccess */
/* unused harmony export deleteListFail */
/* unused harmony export fetchListAccounts */
/* unused harmony export fetchListAccountsRequest */
/* unused harmony export fetchListAccountsSuccess */
/* unused harmony export fetchListAccountsFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return fetchListSuggestions; });
/* unused harmony export fetchListSuggestionsReady */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return clearListSuggestions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return changeListSuggestions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return addToListEditor; });
/* unused harmony export addToList */
/* unused harmony export addToListRequest */
/* unused harmony export addToListSuccess */
/* unused harmony export addToListFail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return removeFromListEditor; });
/* unused harmony export removeFromList */
/* unused harmony export removeFromListRequest */
/* unused harmony export removeFromListSuccess */
/* unused harmony export removeFromListFail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__importer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__alerts__ = __webpack_require__(33);




var LIST_FETCH_REQUEST = 'LIST_FETCH_REQUEST';
var LIST_FETCH_SUCCESS = 'LIST_FETCH_SUCCESS';
var LIST_FETCH_FAIL = 'LIST_FETCH_FAIL';

var LISTS_FETCH_REQUEST = 'LISTS_FETCH_REQUEST';
var LISTS_FETCH_SUCCESS = 'LISTS_FETCH_SUCCESS';
var LISTS_FETCH_FAIL = 'LISTS_FETCH_FAIL';

var LIST_EDITOR_TITLE_CHANGE = 'LIST_EDITOR_TITLE_CHANGE';
var LIST_EDITOR_RESET = 'LIST_EDITOR_RESET';
var LIST_EDITOR_SETUP = 'LIST_EDITOR_SETUP';

var LIST_CREATE_REQUEST = 'LIST_CREATE_REQUEST';
var LIST_CREATE_SUCCESS = 'LIST_CREATE_SUCCESS';
var LIST_CREATE_FAIL = 'LIST_CREATE_FAIL';

var LIST_UPDATE_REQUEST = 'LIST_UPDATE_REQUEST';
var LIST_UPDATE_SUCCESS = 'LIST_UPDATE_SUCCESS';
var LIST_UPDATE_FAIL = 'LIST_UPDATE_FAIL';

var LIST_DELETE_REQUEST = 'LIST_DELETE_REQUEST';
var LIST_DELETE_SUCCESS = 'LIST_DELETE_SUCCESS';
var LIST_DELETE_FAIL = 'LIST_DELETE_FAIL';

var LIST_ACCOUNTS_FETCH_REQUEST = 'LIST_ACCOUNTS_FETCH_REQUEST';
var LIST_ACCOUNTS_FETCH_SUCCESS = 'LIST_ACCOUNTS_FETCH_SUCCESS';
var LIST_ACCOUNTS_FETCH_FAIL = 'LIST_ACCOUNTS_FETCH_FAIL';

var LIST_EDITOR_SUGGESTIONS_CHANGE = 'LIST_EDITOR_SUGGESTIONS_CHANGE';
var LIST_EDITOR_SUGGESTIONS_READY = 'LIST_EDITOR_SUGGESTIONS_READY';
var LIST_EDITOR_SUGGESTIONS_CLEAR = 'LIST_EDITOR_SUGGESTIONS_CLEAR';

var LIST_EDITOR_ADD_REQUEST = 'LIST_EDITOR_ADD_REQUEST';
var LIST_EDITOR_ADD_SUCCESS = 'LIST_EDITOR_ADD_SUCCESS';
var LIST_EDITOR_ADD_FAIL = 'LIST_EDITOR_ADD_FAIL';

var LIST_EDITOR_REMOVE_REQUEST = 'LIST_EDITOR_REMOVE_REQUEST';
var LIST_EDITOR_REMOVE_SUCCESS = 'LIST_EDITOR_REMOVE_SUCCESS';
var LIST_EDITOR_REMOVE_FAIL = 'LIST_EDITOR_REMOVE_FAIL';

var fetchList = function fetchList(id) {
  return function (dispatch, getState) {
    if (getState().getIn(['lists', id])) {
      return;
    }

    dispatch(fetchListRequest(id));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get('/api/v1/lists/' + id).then(function (_ref) {
      var data = _ref.data;
      return dispatch(fetchListSuccess(data));
    }).catch(function (err) {
      return dispatch(fetchListFail(id, err));
    });
  };
};

var fetchListRequest = function fetchListRequest(id) {
  return {
    type: LIST_FETCH_REQUEST,
    id: id
  };
};

var fetchListSuccess = function fetchListSuccess(list) {
  return {
    type: LIST_FETCH_SUCCESS,
    list: list
  };
};

var fetchListFail = function fetchListFail(id, error) {
  return {
    type: LIST_FETCH_FAIL,
    id: id,
    error: error
  };
};

var fetchLists = function fetchLists() {
  return function (dispatch, getState) {
    dispatch(fetchListsRequest());

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get('/api/v1/lists').then(function (_ref2) {
      var data = _ref2.data;
      return dispatch(fetchListsSuccess(data));
    }).catch(function (err) {
      return dispatch(fetchListsFail(err));
    });
  };
};

var fetchListsRequest = function fetchListsRequest() {
  return {
    type: LISTS_FETCH_REQUEST
  };
};

var fetchListsSuccess = function fetchListsSuccess(lists) {
  return {
    type: LISTS_FETCH_SUCCESS,
    lists: lists
  };
};

var fetchListsFail = function fetchListsFail(error) {
  return {
    type: LISTS_FETCH_FAIL,
    error: error
  };
};

var submitListEditor = function submitListEditor(shouldReset) {
  return function (dispatch, getState) {
    var listId = getState().getIn(['listEditor', 'listId']);
    var title = getState().getIn(['listEditor', 'title']);

    if (listId === null) {
      dispatch(createList(title, shouldReset));
    } else {
      dispatch(updateList(listId, title, shouldReset));
    }
  };
};

var setupListEditor = function setupListEditor(listId) {
  return function (dispatch, getState) {
    dispatch({
      type: LIST_EDITOR_SETUP,
      list: getState().getIn(['lists', listId])
    });

    dispatch(fetchListAccounts(listId));
  };
};

var changeListEditorTitle = function changeListEditorTitle(value) {
  return {
    type: LIST_EDITOR_TITLE_CHANGE,
    value: value
  };
};

var createList = function createList(title, shouldReset) {
  return function (dispatch, getState) {
    dispatch(createListRequest());

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).post('/api/v1/lists', { title: title }).then(function (_ref3) {
      var data = _ref3.data;

      dispatch(createListSuccess(data));

      if (shouldReset) {
        dispatch(resetListEditor());
      }
    }).catch(function (err) {
      return dispatch(createListFail(err));
    });
  };
};

var createListRequest = function createListRequest() {
  return {
    type: LIST_CREATE_REQUEST
  };
};

var createListSuccess = function createListSuccess(list) {
  return {
    type: LIST_CREATE_SUCCESS,
    list: list
  };
};

var createListFail = function createListFail(error) {
  return {
    type: LIST_CREATE_FAIL,
    error: error
  };
};

var updateList = function updateList(id, title, shouldReset) {
  return function (dispatch, getState) {
    dispatch(updateListRequest(id));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).put('/api/v1/lists/' + id, { title: title }).then(function (_ref4) {
      var data = _ref4.data;

      dispatch(updateListSuccess(data));

      if (shouldReset) {
        dispatch(resetListEditor());
      }
    }).catch(function (err) {
      return dispatch(updateListFail(id, err));
    });
  };
};

var updateListRequest = function updateListRequest(id) {
  return {
    type: LIST_UPDATE_REQUEST,
    id: id
  };
};

var updateListSuccess = function updateListSuccess(list) {
  return {
    type: LIST_UPDATE_SUCCESS,
    list: list
  };
};

var updateListFail = function updateListFail(id, error) {
  return {
    type: LIST_UPDATE_FAIL,
    id: id,
    error: error
  };
};

var resetListEditor = function resetListEditor() {
  return {
    type: LIST_EDITOR_RESET
  };
};

var deleteList = function deleteList(id) {
  return function (dispatch, getState) {
    dispatch(deleteListRequest(id));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).delete('/api/v1/lists/' + id).then(function () {
      return dispatch(deleteListSuccess(id));
    }).catch(function (err) {
      return dispatch(deleteListFail(id, err));
    });
  };
};

var deleteListRequest = function deleteListRequest(id) {
  return {
    type: LIST_DELETE_REQUEST,
    id: id
  };
};

var deleteListSuccess = function deleteListSuccess(id) {
  return {
    type: LIST_DELETE_SUCCESS,
    id: id
  };
};

var deleteListFail = function deleteListFail(id, error) {
  return {
    type: LIST_DELETE_FAIL,
    id: id,
    error: error
  };
};

var fetchListAccounts = function fetchListAccounts(listId) {
  return function (dispatch, getState) {
    dispatch(fetchListAccountsRequest(listId));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get('/api/v1/lists/' + listId + '/accounts', { params: { limit: 0 } }).then(function (_ref5) {
      var data = _ref5.data;

      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__importer__["g" /* importFetchedAccounts */])(data));
      dispatch(fetchListAccountsSuccess(listId, data));
    }).catch(function (err) {
      return dispatch(fetchListAccountsFail(listId, err));
    });
  };
};

var fetchListAccountsRequest = function fetchListAccountsRequest(id) {
  return {
    type: LIST_ACCOUNTS_FETCH_REQUEST,
    id: id
  };
};

var fetchListAccountsSuccess = function fetchListAccountsSuccess(id, accounts, next) {
  return {
    type: LIST_ACCOUNTS_FETCH_SUCCESS,
    id: id,
    accounts: accounts,
    next: next
  };
};

var fetchListAccountsFail = function fetchListAccountsFail(id, error) {
  return {
    type: LIST_ACCOUNTS_FETCH_FAIL,
    id: id,
    error: error
  };
};

var fetchListSuggestions = function fetchListSuggestions(q) {
  return function (dispatch, getState) {
    var params = {
      q: q,
      resolve: false,
      limit: 4,
      following: true
    };

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get('/api/v1/accounts/search', { params: params }).then(function (_ref6) {
      var data = _ref6.data;

      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__importer__["g" /* importFetchedAccounts */])(data));
      dispatch(fetchListSuggestionsReady(q, data));
    }).catch(function (error) {
      return dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__alerts__["e" /* showAlertForError */])(error));
    });
  };
};

var fetchListSuggestionsReady = function fetchListSuggestionsReady(query, accounts) {
  return {
    type: LIST_EDITOR_SUGGESTIONS_READY,
    query: query,
    accounts: accounts
  };
};

var clearListSuggestions = function clearListSuggestions() {
  return {
    type: LIST_EDITOR_SUGGESTIONS_CLEAR
  };
};

var changeListSuggestions = function changeListSuggestions(value) {
  return {
    type: LIST_EDITOR_SUGGESTIONS_CHANGE,
    value: value
  };
};

var addToListEditor = function addToListEditor(accountId) {
  return function (dispatch, getState) {
    dispatch(addToList(getState().getIn(['listEditor', 'listId']), accountId));
  };
};

var addToList = function addToList(listId, accountId) {
  return function (dispatch, getState) {
    dispatch(addToListRequest(listId, accountId));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).post('/api/v1/lists/' + listId + '/accounts', { account_ids: [accountId] }).then(function () {
      return dispatch(addToListSuccess(listId, accountId));
    }).catch(function (err) {
      return dispatch(addToListFail(listId, accountId, err));
    });
  };
};

var addToListRequest = function addToListRequest(listId, accountId) {
  return {
    type: LIST_EDITOR_ADD_REQUEST,
    listId: listId,
    accountId: accountId
  };
};

var addToListSuccess = function addToListSuccess(listId, accountId) {
  return {
    type: LIST_EDITOR_ADD_SUCCESS,
    listId: listId,
    accountId: accountId
  };
};

var addToListFail = function addToListFail(listId, accountId, error) {
  return {
    type: LIST_EDITOR_ADD_FAIL,
    listId: listId,
    accountId: accountId,
    error: error
  };
};

var removeFromListEditor = function removeFromListEditor(accountId) {
  return function (dispatch, getState) {
    dispatch(removeFromList(getState().getIn(['listEditor', 'listId']), accountId));
  };
};

var removeFromList = function removeFromList(listId, accountId) {
  return function (dispatch, getState) {
    dispatch(removeFromListRequest(listId, accountId));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).delete('/api/v1/lists/' + listId + '/accounts', { params: { account_ids: [accountId] } }).then(function () {
      return dispatch(removeFromListSuccess(listId, accountId));
    }).catch(function (err) {
      return dispatch(removeFromListFail(listId, accountId, err));
    });
  };
};

var removeFromListRequest = function removeFromListRequest(listId, accountId) {
  return {
    type: LIST_EDITOR_REMOVE_REQUEST,
    listId: listId,
    accountId: accountId
  };
};

var removeFromListSuccess = function removeFromListSuccess(listId, accountId) {
  return {
    type: LIST_EDITOR_REMOVE_SUCCESS,
    listId: listId,
    accountId: accountId
  };
};

var removeFromListFail = function removeFromListFail(listId, accountId, error) {
  return {
    type: LIST_EDITOR_REMOVE_FAIL,
    listId: listId,
    accountId: accountId,
    error: error
  };
};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementType = __webpack_require__(517);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Portal = __webpack_require__(518);

var _Portal2 = _interopRequireDefault(_Portal);

var _Position = __webpack_require__(520);

var _Position2 = _interopRequireDefault(_Position);

var _RootCloseWrapper = __webpack_require__(530);

var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
 */
var Overlay = function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay(props, context) {
    _classCallCheck(this, Overlay);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleHidden = function () {
      _this.setState({ exited: true });

      if (_this.props.onExited) {
        var _this$props;

        (_this$props = _this.props).onExited.apply(_this$props, arguments);
      }
    };

    _this.state = { exited: !props.show };
    _this.onHiddenListener = _this.handleHidden.bind(_this);
    return _this;
  }

  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Overlay.prototype.render = function render() {
    var _props = this.props,
        container = _props.container,
        containerPadding = _props.containerPadding,
        target = _props.target,
        placement = _props.placement,
        shouldUpdatePosition = _props.shouldUpdatePosition,
        rootClose = _props.rootClose,
        children = _props.children,
        Transition = _props.transition,
        props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);

    // Don't un-render the overlay while it's transitioning out.


    var mountOverlay = props.show || Transition && !this.state.exited;
    if (!mountOverlay) {
      // Don't bother showing anything if we don't have to.
      return null;
    }

    var child = children;

    // Position is be inner-most because it adds inline styles into the child,
    // which the other wrappers don't forward correctly.
    child = _react2.default.createElement(_Position2.default, { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition }, child);

    if (Transition) {
      var onExit = props.onExit,
          onExiting = props.onExiting,
          onEnter = props.onEnter,
          onEntering = props.onEntering,
          onEntered = props.onEntered;

      // This animates the child node by injecting props, so it must precede
      // anything that adds a wrapping div.

      child = _react2.default.createElement(Transition, {
        'in': props.show,
        appear: true,
        onExit: onExit,
        onExiting: onExiting,
        onExited: this.onHiddenListener,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered
      }, child);
    }

    // This goes after everything else because it adds a wrapping div.
    if (rootClose) {
      child = _react2.default.createElement(_RootCloseWrapper2.default, { onRootClose: props.onHide }, child);
    }

    return _react2.default.createElement(_Portal2.default, { container: container }, child);
  };

  return Overlay;
}(_react2.default.Component);

Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: _propTypes2.default.bool,

  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */
  rootClose: _propTypes2.default.bool,

  /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */
  onHide: function onHide(props) {
    var propType = _propTypes2.default.func;
    if (props.rootClose) {
      propType = propType.isRequired;
    }

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return propType.apply(undefined, [props].concat(args));
  },

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component
   * used to animate the overlay as it changes visibility.
   */
  transition: _elementType2.default,

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: _propTypes2.default.func
});

exports.default = Overlay;
module.exports = exports['default'];

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isRtl;
// U+0590  to U+05FF  - Hebrew
// U+0600  to U+06FF  - Arabic
// U+0700  to U+074F  - Syriac
// U+0750  to U+077F  - Arabic Supplement
// U+0780  to U+07BF  - Thaana
// U+07C0  to U+07FF  - N'Ko
// U+0800  to U+083F  - Samaritan
// U+08A0  to U+08FF  - Arabic Extended-A
// U+FB1D  to U+FB4F  - Hebrew presentation forms
// U+FB50  to U+FDFF  - Arabic presentation forms A
// U+FE70  to U+FEFF  - Arabic presentation forms B

var rtlChars = /[\u0590-\u083F]|[\u08A0-\u08FF]|[\uFB1D-\uFDFF]|[\uFE70-\uFEFF]/mg;

function isRtl(text) {
  if (text.length === 0) {
    return false;
  }

  text = text.replace(/(?:^|[^\/\w])@([a-z0-9_]+(@[a-z0-9\.\-]+)?)/ig, '');
  text = text.replace(/(?:^|[^\/\w])#([\S]+)/ig, '');
  text = text.replace(/\s+/g, '');

  var matches = text.match(rtlChars);

  if (!matches) {
    return false;
  }

  return matches.length / text.length > 0.3;
};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.length = length;
exports.substring = substring;
exports.substr = substr;
exports.limit = limit;
exports.indexOf = indexOf;

var _string = __webpack_require__(532);

/**
 * Returns the length of a string
 *
 * @export
 * @param {string} str
 * @returns {number}
 */
function length(str) {
  // Check for input
  if (typeof str !== 'string') {
    throw new Error('Input must be a string');
  }

  var match = str.match(_string.astralRange);
  return match === null ? 0 : match.length;
}

/**
 * Returns a substring by providing start and end position
 *
 * @export
 * @param {string} str
 * @param {number} [begin=0] Starting position
 * @param {number} end End position
 * @returns {string}
 */
function substring(str) {
  var begin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var end = arguments[2];

  // Check for input
  if (typeof str !== 'string') {
    throw new Error('Input must be a string');
  }

  // Even though negative numbers work here, theyre not in the spec
  if (typeof begin !== 'number' || begin < 0) {
    begin = 0;
  }

  if (typeof end === 'number' && end < 0) {
    end = 0;
  }

  return str.match(_string.astralRange).slice(begin, end).join('');
}

/**
 * Returns a substring by providing start position and length
 *
 * @export
 * @param {string} str
 * @param {number} [begin=0] Starting position
 * @param {number} len Desired length
 * @returns {string}
 */
function substr(str) {
  var begin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var len = arguments[2];

  // Check for input
  if (typeof str !== 'string') {
    throw new Error('Input must be a string');
  }

  var strLength = length(str);

  // Fix type
  if (typeof begin !== 'number') {
    begin = parseInt(begin, 10);
  }

  // Return zero-length string if got oversize number.
  if (begin >= strLength) {
    return '';
  }

  // Calculating postive version of negative value.
  if (begin < 0) {
    begin += strLength;
  }

  var end = void 0;

  if (typeof len === 'undefined') {
    end = strLength;
  } else {
    // Fix type
    if (typeof len !== 'number') {
      len = parseInt(len, 10);
    }

    end = len >= 0 ? len + begin : begin;
  }

  return str.match(_string.astralRange).slice(begin, end).join('');
}

/**
 * Enforces a string to be a certain length by
 * adding or removing characters
 *
 * @export
 * @param {string} str
 * @param {number} [limit=16] Limit
 * @param {string} [padString='#'] The Pad String
 * @param {string} [padPosition='right'] The Pad Position
 * @returns {string}
 */
function limit(str) {
  var limit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 16;
  var padString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '#';
  var padPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'right';

  // Input should be a string, limit should be a number
  if (typeof str !== 'string' || typeof limit !== 'number') {
    throw new Error('Invalid arguments specified');
  }

  // Pad position should be either left or right
  if (['left', 'right'].indexOf(padPosition) === -1) {
    throw new Error('Pad position should be either left or right');
  }

  // Pad string can be anything, we convert it to string
  if (typeof padString !== 'string') {
    padString = String(padString);
  }

  // Calculate string length considering astral code points
  var strLength = length(str);

  if (strLength > limit) {
    return substring(str, 0, limit);
  } else if (strLength < limit) {
    var padRepeats = padString.repeat(limit - strLength);
    return padPosition === 'left' ? padRepeats + str : str + padRepeats;
  }

  return str;
}

/**
 * Returns the index of the first occurrence of a given string
 *
 * @export
 * @param {string} str
 * @param {string} [searchStr] the string to search
 * @param {number} [pos] starting position
 * @returns {number}
 */
function indexOf(str, searchStr, pos) {
  if (typeof str !== 'string') {
    throw new Error('Input must be a string');
  }

  if (str === '') {
    if (searchStr === '') {
      return 0;
    }
    return -1;
  }

  // fix type
  pos = parseInt(pos, 10);
  pos = isNaN(pos) ? 0 : pos;
  searchStr = String(searchStr);

  var strArr = str.match(_string.astralRange);
  if (pos >= strArr.length) {
    if (searchStr === '') {
      return strArr.length;
    }
    return -1;
  }
  if (searchStr === '') {
    return pos;
  }

  var searchArr = searchStr.match(_string.astralRange);
  var finded = false;
  var index = void 0;
  for (index = pos; index < strArr.length; index += 1) {
    var searchIndex = 0;
    while (searchIndex < searchArr.length && searchArr[searchIndex] === strArr[index + searchIndex]) {
      searchIndex += 1;
    }
    if (searchIndex === searchArr.length && searchArr[searchIndex - 1] === strArr[index + searchIndex - 1]) {
      finded = true;
      break;
    }
  }
  return finded ? index : -1;
}

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Button; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);




var _class, _temp2;





var Button = (_temp2 = _class = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(Button, _React$PureComponent);

  function Button() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Button);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.handleClick = function (e) {
      if (!_this.props.disabled) {
        _this.props.onClick(e);
      }
    }, _this.setRef = function (c) {
      _this.node = c;
    }, _temp), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Button.prototype.focus = function focus() {
    this.node.focus();
  };

  Button.prototype.render = function render() {
    var style = Object.assign({
      padding: '0 ' + this.props.size / 2.25 + 'px',
      height: this.props.size + 'px',
      lineHeight: this.props.size + 'px'
    }, this.props.style);

    var className = __WEBPACK_IMPORTED_MODULE_4_classnames___default()('button', this.props.className, {
      'button-secondary': this.props.secondary,
      'button--block': this.props.block
    });

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'button',
      {
        className: className,
        disabled: this.props.disabled,
        onClick: this.handleClick,
        ref: this.setRef,
        style: style
      },
      this.props.text || this.props.children
    );
  };

  return Button;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.PureComponent), _class.defaultProps = {
  size: 36
}, _temp2);


/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = function (module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function () {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function () {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function () {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EMOJI_USE; });
/* harmony export (immutable) */ __webpack_exports__["b"] = useEmoji;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__settings__ = __webpack_require__(58);


var EMOJI_USE = 'EMOJI_USE';

function useEmoji(emoji) {
  return function (dispatch) {
    dispatch({
      type: EMOJI_USE,
      emoji: emoji
    });

    dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__settings__["d" /* saveSettings */])());
  };
};

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NOTIFICATIONS_UPDATE; });
/* unused harmony export NOTIFICATIONS_UPDATE_NOOP */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NOTIFICATIONS_EXPAND_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return NOTIFICATIONS_EXPAND_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NOTIFICATIONS_EXPAND_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NOTIFICATIONS_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return NOTIFICATIONS_SCROLL_TOP; });
/* harmony export (immutable) */ __webpack_exports__["j"] = updateNotifications;
/* harmony export (immutable) */ __webpack_exports__["h"] = expandNotifications;
/* unused harmony export expandNotificationsRequest */
/* unused harmony export expandNotificationsSuccess */
/* unused harmony export expandNotificationsFail */
/* harmony export (immutable) */ __webpack_exports__["g"] = clearNotifications;
/* harmony export (immutable) */ __webpack_exports__["i"] = scrollTopNotifications;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_intl_messageformat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__accounts__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__importer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_intl__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_html__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__selectors__ = __webpack_require__(53);








var NOTIFICATIONS_UPDATE = 'NOTIFICATIONS_UPDATE';
var NOTIFICATIONS_UPDATE_NOOP = 'NOTIFICATIONS_UPDATE_NOOP';

var NOTIFICATIONS_EXPAND_REQUEST = 'NOTIFICATIONS_EXPAND_REQUEST';
var NOTIFICATIONS_EXPAND_SUCCESS = 'NOTIFICATIONS_EXPAND_SUCCESS';
var NOTIFICATIONS_EXPAND_FAIL = 'NOTIFICATIONS_EXPAND_FAIL';

var NOTIFICATIONS_CLEAR = 'NOTIFICATIONS_CLEAR';
var NOTIFICATIONS_SCROLL_TOP = 'NOTIFICATIONS_SCROLL_TOP';

Object(__WEBPACK_IMPORTED_MODULE_4_react_intl__["f" /* defineMessages */])({
  mention: {
    'id': 'notification.mention',
    'defaultMessage': '{name} mentioned you'
  },
  group: {
    'id': 'notifications.group',
    'defaultMessage': '{count} notifications'
  }
});

var fetchRelatedRelationships = function fetchRelatedRelationships(dispatch, notifications) {
  var accountIds = notifications.filter(function (item) {
    return item.type === 'follow';
  }).map(function (item) {
    return item.account.id;
  });

  if (accountIds.length > 0) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__accounts__["y" /* fetchRelationships */])(accountIds));
  }
};

function updateNotifications(notification, intlMessages, intlLocale) {
  return function (dispatch, getState) {
    var showInColumn = getState().getIn(['settings', 'notifications', 'shows', notification.type], true);
    var showAlert = getState().getIn(['settings', 'notifications', 'alerts', notification.type], true);
    var playSound = getState().getIn(['settings', 'notifications', 'sounds', notification.type], true);
    var filters = Object(__WEBPACK_IMPORTED_MODULE_6__selectors__["c" /* getFilters */])(getState(), { contextType: 'notifications' });

    var filtered = false;

    if (notification.type === 'mention') {
      var regex = Object(__WEBPACK_IMPORTED_MODULE_6__selectors__["g" /* regexFromFilters */])(filters);
      var searchIndex = notification.status.spoiler_text + '\n' + Object(__WEBPACK_IMPORTED_MODULE_5__utils_html__["a" /* unescapeHTML */])(notification.status.content);

      filtered = regex && regex.test(searchIndex);
    }

    if (showInColumn) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__importer__["f" /* importFetchedAccount */])(notification.account));

      if (notification.status) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__importer__["h" /* importFetchedStatus */])(notification.status));
      }

      dispatch({
        type: NOTIFICATIONS_UPDATE,
        notification: notification,
        meta: playSound && !filtered ? { sound: 'boop' } : undefined
      });

      fetchRelatedRelationships(dispatch, [notification]);
    } else if (playSound && !filtered) {
      dispatch({
        type: NOTIFICATIONS_UPDATE_NOOP,
        meta: { sound: 'boop' }
      });
    }

    // Desktop notifications
    if (typeof window.Notification !== 'undefined' && showAlert && !filtered) {
      var title = new __WEBPACK_IMPORTED_MODULE_1_intl_messageformat___default.a(intlMessages['notification.' + notification.type], intlLocale).format({ name: notification.account.display_name.length > 0 ? notification.account.display_name : notification.account.username });
      var body = notification.status && notification.status.spoiler_text.length > 0 ? notification.status.spoiler_text : Object(__WEBPACK_IMPORTED_MODULE_5__utils_html__["a" /* unescapeHTML */])(notification.status ? notification.status.content : '');

      var notify = new Notification(title, { body: body, icon: notification.account.avatar, tag: notification.id });

      notify.addEventListener('click', function () {
        window.focus();
        notify.close();
      });
    }
  };
};

var excludeTypesFromSettings = function excludeTypesFromSettings(state) {
  return state.getIn(['settings', 'notifications', 'shows']).filter(function (enabled) {
    return !enabled;
  }).keySeq().toJS();
};

var noOp = function noOp() {};

function expandNotifications() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      maxId = _ref.maxId;

  var done = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noOp;

  return function (dispatch, getState) {
    var notifications = getState().get('notifications');

    if (notifications.get('isLoading')) {
      done();
      return;
    }

    var params = {
      max_id: maxId,
      exclude_types: excludeTypesFromSettings(getState())
    };

    if (!maxId && notifications.get('items').size > 0) {
      params.since_id = notifications.getIn(['items', 0]);
    }

    dispatch(expandNotificationsRequest());

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get('/api/v1/notifications', { params: params }).then(function (response) {
      var next = Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* getLinks */])(response).refs.find(function (link) {
        return link.rel === 'next';
      });

      dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__importer__["g" /* importFetchedAccounts */])(response.data.map(function (item) {
        return item.account;
      })));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__importer__["i" /* importFetchedStatuses */])(response.data.map(function (item) {
        return item.status;
      }).filter(function (status) {
        return !!status;
      })));

      dispatch(expandNotificationsSuccess(response.data, next ? next.uri : null));
      fetchRelatedRelationships(dispatch, response.data);
      done();
    }).catch(function (error) {
      dispatch(expandNotificationsFail(error));
      done();
    });
  };
};

function expandNotificationsRequest() {
  return {
    type: NOTIFICATIONS_EXPAND_REQUEST
  };
};

function expandNotificationsSuccess(notifications, next) {
  return {
    type: NOTIFICATIONS_EXPAND_SUCCESS,
    notifications: notifications,
    next: next
  };
};

function expandNotificationsFail(error) {
  return {
    type: NOTIFICATIONS_EXPAND_FAIL,
    error: error
  };
};

function clearNotifications() {
  return function (dispatch, getState) {
    dispatch({
      type: NOTIFICATIONS_CLEAR
    });

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).post('/api/v1/notifications/clear');
  };
};

function scrollTopNotifications(top) {
  return {
    type: NOTIFICATIONS_SCROLL_TOP,
    top: top
  };
};

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatusContent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rtl__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__permalink__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);





var _class, _temp2;









var StatusContent = (_temp2 = _class = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(StatusContent, _React$PureComponent);

  function StatusContent() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, StatusContent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
      hidden: true
    }, _this.onMentionClick = function (mention, e) {
      if (_this.context.router && e.button === 0) {
        e.preventDefault();
        _this.context.router.history.push('/accounts/' + mention.get('id'));
      }
    }, _this.onHashtagClick = function (hashtag, e) {
      hashtag = hashtag.replace(/^#/, '').toLowerCase();

      if (_this.context.router && e.button === 0) {
        e.preventDefault();
        _this.context.router.history.push('/timelines/tag/' + hashtag);
      }
    }, _this.handleMouseDown = function (e) {
      _this.startXY = [e.clientX, e.clientY];
    }, _this.handleMouseUp = function (e) {
      if (!_this.startXY) {
        return;
      }

      var _this$startXY = _this.startXY,
          startX = _this$startXY[0],
          startY = _this$startXY[1];
      var _ref = [Math.abs(e.clientX - startX), Math.abs(e.clientY - startY)],
          deltaX = _ref[0],
          deltaY = _ref[1];


      if (e.target.localName === 'button' || e.target.localName === 'a' || e.target.parentNode && (e.target.parentNode.localName === 'button' || e.target.parentNode.localName === 'a')) {
        return;
      }

      if (deltaX + deltaY < 5 && e.button === 0 && _this.props.onClick) {
        _this.props.onClick();
      }

      _this.startXY = null;
    }, _this.handleSpoilerClick = function (e) {
      e.preventDefault();

      if (_this.props.onExpandedToggle) {
        // The parent manages the state
        _this.props.onExpandedToggle();
      } else {
        _this.setState({ hidden: !_this.state.hidden });
      }
    }, _this.setRef = function (c) {
      _this.node = c;
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  StatusContent.prototype._updateStatusLinks = function _updateStatusLinks() {
    var _this2 = this;

    var node = this.node;

    if (!node) {
      return;
    }

    var links = node.querySelectorAll('a');

    var _loop = function _loop() {
      var link = links[i];
      if (link.classList.contains('status-link')) {
        return 'continue';
      }
      link.classList.add('status-link');

      var mention = _this2.props.status.get('mentions').find(function (item) {
        return link.href === item.get('url');
      });

      if (mention) {
        link.addEventListener('click', _this2.onMentionClick.bind(_this2, mention), false);
        link.setAttribute('title', mention.get('acct'));
      } else if (link.textContent[0] === '#' || link.previousSibling && link.previousSibling.textContent && link.previousSibling.textContent[link.previousSibling.textContent.length - 1] === '#') {
        link.addEventListener('click', _this2.onHashtagClick.bind(_this2, link.text), false);
      } else {
        link.setAttribute('title', link.href);
      }

      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener');
    };

    for (var i = 0; i < links.length; ++i) {
      var _ret2 = _loop();

      if (_ret2 === 'continue') continue;
    }
  };

  StatusContent.prototype.componentDidMount = function componentDidMount() {
    this._updateStatusLinks();
  };

  StatusContent.prototype.componentDidUpdate = function componentDidUpdate() {
    this._updateStatusLinks();
  };

  StatusContent.prototype.render = function render() {
    var status = this.props.status;


    if (status.get('content').length === 0) {
      return null;
    }

    var hidden = this.props.onExpandedToggle ? !this.props.expanded : this.state.hidden;

    var content = { __html: status.get('contentHtml') };
    var spoilerContent = { __html: status.get('spoilerHtml') };
    var directionStyle = { direction: 'ltr' };
    var classNames = __WEBPACK_IMPORTED_MODULE_9_classnames___default()('status__content', {
      'status__content--with-action': this.props.onClick && this.context.router,
      'status__content--with-spoiler': status.get('spoiler_text').length > 0
    });

    if (Object(__WEBPACK_IMPORTED_MODULE_6__rtl__["a" /* isRtl */])(status.get('search_index'))) {
      directionStyle.direction = 'rtl';
    }

    if (status.get('spoiler_text').length > 0) {
      var mentionsPlaceholder = '';

      var mentionLinks = status.get('mentions').map(function (item) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8__permalink__["a" /* default */], {
          to: '/accounts/' + item.get('id'),
          href: item.get('url'),
          className: 'mention'
        }, item.get('id'), '@', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('span', {}, void 0, item.get('username')));
      }).reduce(function (aggregate, item) {
        return [].concat(aggregate, [item, ' ']);
      }, []);

      var toggleText = hidden ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7_react_intl__["b" /* FormattedMessage */], {
        id: 'status.show_more',
        defaultMessage: 'Show more'
      }) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7_react_intl__["b" /* FormattedMessage */], {
        id: 'status.show_less',
        defaultMessage: 'Show less'
      });

      if (hidden) {
        mentionsPlaceholder = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {}, void 0, mentionLinks);
      }

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        'div',
        { className: classNames, ref: this.setRef, tabIndex: '0', style: directionStyle, onMouseDown: this.handleMouseDown, onMouseUp: this.handleMouseUp },
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('p', {
          style: { marginBottom: hidden && status.get('mentions').isEmpty() ? '0px' : null }
        }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('span', {
          dangerouslySetInnerHTML: spoilerContent
        }), ' ', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
          tabIndex: '0',
          className: 'status__content__spoiler-link ' + (hidden ? 'status__content__spoiler-link--show-more' : 'status__content__spoiler-link--show-less'),
          onClick: this.handleSpoilerClick
        }, void 0, toggleText)),
        mentionsPlaceholder,
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
          tabIndex: !hidden ? 0 : null,
          className: 'status__content__text ' + (!hidden ? 'status__content__text--visible' : ''),
          style: directionStyle,
          dangerouslySetInnerHTML: content
        })
      );
    } else if (this.props.onClick) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', {
        ref: this.setRef,
        tabIndex: '0',
        className: classNames,
        style: directionStyle,
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp,
        dangerouslySetInnerHTML: content
      });
    } else {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', {
        tabIndex: '0',
        ref: this.setRef,
        className: 'status__content',
        style: directionStyle,
        dangerouslySetInnerHTML: content
      });
    }
  };

  return StatusContent;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent), _class.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
}, _temp2);


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */

var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(115);
module.exports = function (it) {
  return Object(defined(it));
};

/***/ }),
/* 107 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(466)['default'];
exports['default'] = exports;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(62);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(30);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});
module.exports = function (key) {
  return store[key] || (store[key] = {});
};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(39).f;
var has = __webpack_require__(36);
var TAG = __webpack_require__(48)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(48);

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(30);
var core = __webpack_require__(24);
var LIBRARY = __webpack_require__(114);
var wksExt = __webpack_require__(112);
var defineProperty = __webpack_require__(39).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports = true;

/***/ }),
/* 115 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 116 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(110)('keys');
var uid = __webpack_require__(80);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 118 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

/***/ }),
/* 119 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(61);
var dPs = __webpack_require__(352);
var enumBugKeys = __webpack_require__(118);
var IE_PROTO = __webpack_require__(117)('IE_PROTO');
var Empty = function () {/* empty */};
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(171)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(353).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};

/***/ }),
/* 121 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(397);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = configureStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__middleware_loading_bar__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__middleware_errors__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__middleware_sounds__ = __webpack_require__(500);







function configureStore() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* createStore */])(__WEBPACK_IMPORTED_MODULE_2__reducers__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* compose */])(Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_1_redux_thunk___default.a, Object(__WEBPACK_IMPORTED_MODULE_3__middleware_loading_bar__["a" /* default */])({ promiseTypeSuffixes: ['REQUEST', 'SUCCESS', 'FAIL'] }), Object(__WEBPACK_IMPORTED_MODULE_4__middleware_errors__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_5__middleware_sounds__["a" /* default */])()), window.devToolsExtension ? window.devToolsExtension() : function (f) {
    return f;
  }));
};

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return unescapeHTML; });
// NB: This function can still return unsafe HTML
var unescapeHTML = function unescapeHTML(html) {
  var wrapper = document.createElement('div');
  wrapper.innerHTML = html.replace(/<br\s*\/?>/g, '\n').replace(/<\/p><p>/g, '\n\n').replace(/<[^>]*>/g, '');
  return wrapper.textContent;
};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(21);
var normalizeHeaderName = __webpack_require__(424);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(196);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(196);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {/* Ignore */}
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35)))

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function () {
  return new Promise(function (resolve, reject) {
    // ServiceWorker is required to synchronize the login state.
    // Microsoft Edge 17 does not support getAll according to:
    // Catalog of standard and vendor APIs across browsers - Microsoft Edge Development
    // https://developer.microsoft.com/en-us/microsoft-edge/platform/catalog/?q=specName%3Aindexeddb
    if (!('caches' in self && 'getAll' in IDBObjectStore.prototype)) {
      reject();
      return;
    }

    var request = indexedDB.open('mastodon');

    request.onerror = reject;
    request.onsuccess = function (_ref) {
      var target = _ref.target;
      return resolve(target.result);
    };

    request.onupgradeneeded = function (_ref2) {
      var target = _ref2.target;

      var accounts = target.result.createObjectStore('accounts', { autoIncrement: true });
      var statuses = target.result.createObjectStore('statuses', { autoIncrement: true });

      accounts.createIndex('id', 'id', { unique: true });
      accounts.createIndex('moved', 'moved');

      statuses.createIndex('id', 'id', { unique: true });
      statuses.createIndex('account', 'account');
      statuses.createIndex('reblog', 'reblog');
    };
  });
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compareId;
function compareId(id1, id2) {
  if (id1 === id2) {
    return 0;
  }
  if (id1.length === id2.length) {
    return id1 > id2 ? 1 : -1;
  } else {
    return id1.length > id2.length ? 1 : -1;
  }
}

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(25);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showLoading = exports.resetLoading = exports.loadingBarReducer = exports.loadingBarMiddleware = exports.LoadingBar = exports.ImmutableLoadingBar = exports.hideLoading = undefined;

var _loading_bar = __webpack_require__(206);

var _loading_bar2 = _interopRequireDefault(_loading_bar);

var _loading_bar_middleware = __webpack_require__(471);

var _loading_bar_middleware2 = _interopRequireDefault(_loading_bar_middleware);

var _loading_bar_ducks = __webpack_require__(207);

var _immutable = __webpack_require__(472);

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.hideLoading = _loading_bar_ducks.hideLoading;
exports.ImmutableLoadingBar = _immutable2.default;
exports.LoadingBar = _loading_bar.LoadingBar;
exports.loadingBarMiddleware = _loading_bar_middleware2.default;
exports.loadingBarReducer = _loading_bar_ducks.loadingBarReducer;
exports.resetLoading = _loading_bar_ducks.resetLoading;
exports.showLoading = _loading_bar_ducks.showLoading;
exports.default = _loading_bar2.default;

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export FILTERS_FETCH_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FILTERS_FETCH_SUCCESS; });
/* unused harmony export FILTERS_FETCH_FAIL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchFilters; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(11);


var FILTERS_FETCH_REQUEST = 'FILTERS_FETCH_REQUEST';
var FILTERS_FETCH_SUCCESS = 'FILTERS_FETCH_SUCCESS';
var FILTERS_FETCH_FAIL = 'FILTERS_FETCH_FAIL';

var fetchFilters = function fetchFilters() {
  return function (dispatch, getState) {
    dispatch({
      type: FILTERS_FETCH_REQUEST,
      skipLoading: true
    });

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get('/api/v1/filters').then(function (_ref) {
      var data = _ref.data;
      return dispatch({
        type: FILTERS_FETCH_SUCCESS,
        filters: data,
        skipLoading: true
      });
    }).catch(function (err) {
      return dispatch({
        type: FILTERS_FETCH_FAIL,
        err: err,
        skipLoading: true,
        skipAlert: true
      });
    });
  };
};

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RelativeTimestamp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(7);





var _class, _class2, _temp2;





var messages = Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["f" /* defineMessages */])({
  just_now: {
    'id': 'relative_time.just_now',
    'defaultMessage': 'now'
  },
  seconds: {
    'id': 'relative_time.seconds',
    'defaultMessage': '{number}s'
  },
  minutes: {
    'id': 'relative_time.minutes',
    'defaultMessage': '{number}m'
  },
  hours: {
    'id': 'relative_time.hours',
    'defaultMessage': '{number}h'
  },
  days: {
    'id': 'relative_time.days',
    'defaultMessage': '{number}d'
  }
});

var dateFormatOptions = {
  hour12: false,
  year: 'numeric',
  month: 'short',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit'
};

var shortDateFormatOptions = {
  month: 'short',
  day: 'numeric'
};

var SECOND = 1000;
var MINUTE = 1000 * 60;
var HOUR = 1000 * 60 * 60;
var DAY = 1000 * 60 * 60 * 24;

var MAX_DELAY = 2147483647;

var selectUnits = function selectUnits(delta) {
  var absDelta = Math.abs(delta);

  if (absDelta < MINUTE) {
    return 'second';
  } else if (absDelta < HOUR) {
    return 'minute';
  } else if (absDelta < DAY) {
    return 'hour';
  }

  return 'day';
};

var getUnitDelay = function getUnitDelay(units) {
  switch (units) {
    case 'second':
      return SECOND;
    case 'minute':
      return MINUTE;
    case 'hour':
      return HOUR;
    case 'day':
      return DAY;
    default:
      return MAX_DELAY;
  }
};

var RelativeTimestamp = Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["g" /* injectIntl */])(_class = (_temp2 = _class2 = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(RelativeTimestamp, _React$Component);

  function RelativeTimestamp() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, RelativeTimestamp);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      now: _this.props.intl.now()
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  RelativeTimestamp.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    // As of right now the locale doesn't change without a new page load,
    // but we might as well check in case that ever changes.
    return this.props.timestamp !== nextProps.timestamp || this.props.intl.locale !== nextProps.intl.locale || this.state.now !== nextState.now;
  };

  RelativeTimestamp.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.timestamp !== nextProps.timestamp) {
      this.setState({ now: this.props.intl.now() });
    }
  };

  RelativeTimestamp.prototype.componentDidMount = function componentDidMount() {
    this._scheduleNextUpdate(this.props, this.state);
  };

  RelativeTimestamp.prototype.componentWillUpdate = function componentWillUpdate(nextProps, nextState) {
    this._scheduleNextUpdate(nextProps, nextState);
  };

  RelativeTimestamp.prototype.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this._timer);
  };

  RelativeTimestamp.prototype._scheduleNextUpdate = function _scheduleNextUpdate(props, state) {
    var _this2 = this;

    clearTimeout(this._timer);

    var timestamp = props.timestamp;

    var delta = new Date(timestamp).getTime() - state.now;
    var unitDelay = getUnitDelay(selectUnits(delta));
    var unitRemainder = Math.abs(delta % unitDelay);
    var updateInterval = 1000 * 10;
    var delay = delta < 0 ? Math.max(updateInterval, unitDelay - unitRemainder) : Math.max(updateInterval, unitRemainder);

    this._timer = setTimeout(function () {
      _this2.setState({ now: _this2.props.intl.now() });
    }, delay);
  };

  RelativeTimestamp.prototype.render = function render() {
    var _props = this.props,
        timestamp = _props.timestamp,
        intl = _props.intl,
        year = _props.year;


    var date = new Date(timestamp);
    var delta = this.state.now - date.getTime();

    var relativeTime = void 0;

    if (delta < 10 * SECOND) {
      relativeTime = intl.formatMessage(messages.just_now);
    } else if (delta < 7 * DAY) {
      if (delta < MINUTE) {
        relativeTime = intl.formatMessage(messages.seconds, { number: Math.floor(delta / SECOND) });
      } else if (delta < HOUR) {
        relativeTime = intl.formatMessage(messages.minutes, { number: Math.floor(delta / MINUTE) });
      } else if (delta < DAY) {
        relativeTime = intl.formatMessage(messages.hours, { number: Math.floor(delta / HOUR) });
      } else {
        relativeTime = intl.formatMessage(messages.days, { number: Math.floor(delta / DAY) });
      }
    } else if (date.getFullYear() === year) {
      relativeTime = intl.formatDate(date, shortDateFormatOptions);
    } else {
      relativeTime = intl.formatDate(date, Object.assign({}, shortDateFormatOptions, { year: 'numeric' }));
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('time', {
      dateTime: timestamp,
      title: intl.formatDate(date, dateFormatOptions)
    }, void 0, relativeTime);
  };

  return RelativeTimestamp;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component), _class2.defaultProps = {
  year: new Date().getFullYear()
}, _temp2)) || _class;



/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(213);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function validate(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
  }

  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(validate);
module.exports = exports['default'];

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getContainer;

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}
module.exports = exports['default'];

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ownerDocument;
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}
module.exports = exports["default"];

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getWindow;
function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}
module.exports = exports["default"];

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollTop;

var _isWindow = __webpack_require__(138);

var _isWindow2 = _interopRequireDefault(_isWindow);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function scrollTop(node, val) {
  var win = (0, _isWindow2.default)(node);

  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;

  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
}
module.exports = exports['default'];

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(65);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var on = function on() {};
if (_inDOM2.default) {
  on = function () {

    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

exports.default = on;
module.exports = exports['default'];

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(65);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var off = function off() {};
if (_inDOM2.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

exports.default = off;
module.exports = exports['default'];

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var createTransitionManager = function createTransitionManager() {
  var prompt = null;

  var setPrompt = function setPrompt(nextPrompt) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(prompt == null, 'A history supports only one prompt at a time');

    prompt = nextPrompt;

    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'A history needs a getUserConfirmation function in order to use a prompt message');

          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  };

  var listeners = [];

  var appendListener = function appendListener(fn) {
    var isActive = true;

    var listener = function listener() {
      if (isActive) fn.apply(undefined, arguments);
    };

    listeners.push(listener);

    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var notifyListeners = function notifyListeners() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(undefined, args);
    });
  };

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createTransitionManager);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(144);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: '/',
      url: '/',
      params: {},
      isExact: pathname === '/'
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, 'A <Router> may have only one child element');

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, 'You cannot change <Router history>');
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = '' + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof options === 'string') options = { path: options };

  var _options = options,
      _options$path = _options.path,
      path = _options$path === undefined ? '/' : _options$path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 146 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(572),
    baseKeys = __webpack_require__(580),
    isArrayLike = __webpack_require__(85);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41),
    root = __webpack_require__(25);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;

/***/ }),
/* 149 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function (n) {
  if (!isNumber(n) || n < 0 || isNaN(n)) throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function (type) {
  var er, handler, len, args, i, listeners;

  if (!this._events) this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error || isObject(this._events.error) && !this._events.error.length) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler)) return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++) listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function (type, listener) {
  var m;

  if (!isFunction(listener)) throw TypeError('listener must be a function');

  if (!this._events) this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener) this.emit('newListener', type, isFunction(listener.listener) ? listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' + 'leak detected. %d listeners added. ' + 'Use emitter.setMaxListeners() to increase limit.', this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function (type, listener) {
  if (!isFunction(listener)) throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function (type, listener) {
  var list, position, length, i;

  if (!isFunction(listener)) throw TypeError('listener must be a function');

  if (!this._events || !this._events[type]) return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener || isFunction(list.listener) && list.listener === listener) {
    delete this._events[type];
    if (this._events.removeListener) this.emit('removeListener', type, listener);
  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener || list[i].listener && list[i].listener === listener) {
        position = i;
        break;
      }
    }

    if (position < 0) return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener) this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function (type) {
  var key, listeners;

  if (!this._events) return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0) this._events = {};else if (this._events[type]) delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length) this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function (type) {
  var ret;
  if (!this._events || !this._events[type]) ret = [];else if (isFunction(this._events[type])) ret = [this._events[type]];else ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function (type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener)) return 1;else if (evlistener) return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function (emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * Copyright (c) 2012 Mathieu Turcotte
 * Licensed under the MIT license.
 */

module.exports = __webpack_require__(644);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_modal_root__ = __webpack_require__(664);




var mapStateToProps = function mapStateToProps(state) {
  return {
    type: state.get('modal').modalType,
    props: state.get('modal').modalProps
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onClose: function onClose() {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_modal__["c" /* closeModal */])());
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_2__components_modal_root__["a" /* default */]));

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_bundle__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_bundles__ = __webpack_require__(665);






var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onFetch: function onFetch() {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_bundles__["b" /* fetchBundleRequest */])());
    },
    onFetchSuccess: function onFetchSuccess() {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_bundles__["c" /* fetchBundleSuccess */])());
    },
    onFetchFail: function onFetchFail(error) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__actions_bundles__["a" /* fetchBundleFail */])(error));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(null, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_1__components_bundle__["a" /* default */]));

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
Unobtrusive JavaScript
https://github.com/rails/rails/blob/master/actionview/app/assets/javascripts
Released under the MIT license
 */

(function () {
  var context = this;

  (function () {
    (function () {
      this.Rails = {
        linkClickSelector: 'a[data-confirm], a[data-method], a[data-remote]:not([disabled]), a[data-disable-with], a[data-disable]',
        buttonClickSelector: {
          selector: 'button[data-remote]:not([form]), button[data-confirm]:not([form])',
          exclude: 'form button'
        },
        inputChangeSelector: 'select[data-remote], input[data-remote], textarea[data-remote]',
        formSubmitSelector: 'form',
        formInputClickSelector: 'form input[type=submit], form input[type=image], form button[type=submit], form button:not([type]), input[type=submit][form], input[type=image][form], button[type=submit][form], button[form]:not([type])',
        formDisableSelector: 'input[data-disable-with]:enabled, button[data-disable-with]:enabled, textarea[data-disable-with]:enabled, input[data-disable]:enabled, button[data-disable]:enabled, textarea[data-disable]:enabled',
        formEnableSelector: 'input[data-disable-with]:disabled, button[data-disable-with]:disabled, textarea[data-disable-with]:disabled, input[data-disable]:disabled, button[data-disable]:disabled, textarea[data-disable]:disabled',
        fileInputSelector: 'input[name][type=file]:not([disabled])',
        linkDisableSelector: 'a[data-disable-with], a[data-disable]',
        buttonDisableSelector: 'button[data-remote][data-disable-with], button[data-remote][data-disable]'
      };
    }).call(this);
  }).call(context);

  var Rails = context.Rails;

  (function () {
    (function () {
      var expando, m;

      m = Element.prototype.matches || Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector;

      Rails.matches = function (element, selector) {
        if (selector.exclude != null) {
          return m.call(element, selector.selector) && !m.call(element, selector.exclude);
        } else {
          return m.call(element, selector);
        }
      };

      expando = '_ujsData';

      Rails.getData = function (element, key) {
        var ref;
        return (ref = element[expando]) != null ? ref[key] : void 0;
      };

      Rails.setData = function (element, key, value) {
        if (element[expando] == null) {
          element[expando] = {};
        }
        return element[expando][key] = value;
      };

      Rails.$ = function (selector) {
        return Array.prototype.slice.call(document.querySelectorAll(selector));
      };
    }).call(this);
    (function () {
      var $, csrfParam, csrfToken;

      $ = Rails.$;

      csrfToken = Rails.csrfToken = function () {
        var meta;
        meta = document.querySelector('meta[name=csrf-token]');
        return meta && meta.content;
      };

      csrfParam = Rails.csrfParam = function () {
        var meta;
        meta = document.querySelector('meta[name=csrf-param]');
        return meta && meta.content;
      };

      Rails.CSRFProtection = function (xhr) {
        var token;
        token = csrfToken();
        if (token != null) {
          return xhr.setRequestHeader('X-CSRF-Token', token);
        }
      };

      Rails.refreshCSRFTokens = function () {
        var param, token;
        token = csrfToken();
        param = csrfParam();
        if (token != null && param != null) {
          return $('form input[name="' + param + '"]').forEach(function (input) {
            return input.value = token;
          });
        }
      };
    }).call(this);
    (function () {
      var CustomEvent, fire, matches;

      matches = Rails.matches;

      CustomEvent = window.CustomEvent;

      if (typeof CustomEvent !== 'function') {
        CustomEvent = function (event, params) {
          var evt;
          evt = document.createEvent('CustomEvent');
          evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
          return evt;
        };
        CustomEvent.prototype = window.Event.prototype;
      }

      fire = Rails.fire = function (obj, name, data) {
        var event;
        event = new CustomEvent(name, {
          bubbles: true,
          cancelable: true,
          detail: data
        });
        obj.dispatchEvent(event);
        return !event.defaultPrevented;
      };

      Rails.stopEverything = function (e) {
        fire(e.target, 'ujs:everythingStopped');
        e.preventDefault();
        e.stopPropagation();
        return e.stopImmediatePropagation();
      };

      Rails.delegate = function (element, selector, eventType, handler) {
        return element.addEventListener(eventType, function (e) {
          var target;
          target = e.target;
          while (!(!(target instanceof Element) || matches(target, selector))) {
            target = target.parentNode;
          }
          if (target instanceof Element && handler.call(target, e) === false) {
            e.preventDefault();
            return e.stopPropagation();
          }
        });
      };
    }).call(this);
    (function () {
      var AcceptHeaders, CSRFProtection, createXHR, fire, prepareOptions, processResponse;

      CSRFProtection = Rails.CSRFProtection, fire = Rails.fire;

      AcceptHeaders = {
        '*': '*/*',
        text: 'text/plain',
        html: 'text/html',
        xml: 'application/xml, text/xml',
        json: 'application/json, text/javascript',
        script: 'text/javascript, application/javascript, application/ecmascript, application/x-ecmascript'
      };

      Rails.ajax = function (options) {
        var xhr;
        options = prepareOptions(options);
        xhr = createXHR(options, function () {
          var response;
          response = processResponse(xhr.response, xhr.getResponseHeader('Content-Type'));
          if (Math.floor(xhr.status / 100) === 2) {
            if (typeof options.success === "function") {
              options.success(response, xhr.statusText, xhr);
            }
          } else {
            if (typeof options.error === "function") {
              options.error(response, xhr.statusText, xhr);
            }
          }
          return typeof options.complete === "function" ? options.complete(xhr, xhr.statusText) : void 0;
        });
        if (typeof options.beforeSend === "function") {
          options.beforeSend(xhr, options);
        }
        if (xhr.readyState === XMLHttpRequest.OPENED) {
          return xhr.send(options.data);
        } else {
          return fire(document, 'ajaxStop');
        }
      };

      prepareOptions = function (options) {
        options.url = options.url || location.href;
        options.type = options.type.toUpperCase();
        if (options.type === 'GET' && options.data) {
          if (options.url.indexOf('?') < 0) {
            options.url += '?' + options.data;
          } else {
            options.url += '&' + options.data;
          }
        }
        if (AcceptHeaders[options.dataType] == null) {
          options.dataType = '*';
        }
        options.accept = AcceptHeaders[options.dataType];
        if (options.dataType !== '*') {
          options.accept += ', */*; q=0.01';
        }
        return options;
      };

      createXHR = function (options, done) {
        var xhr;
        xhr = new XMLHttpRequest();
        xhr.open(options.type, options.url, true);
        xhr.setRequestHeader('Accept', options.accept);
        if (typeof options.data === 'string') {
          xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        }
        if (!options.crossDomain) {
          xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
        }
        CSRFProtection(xhr);
        xhr.withCredentials = !!options.withCredentials;
        xhr.onreadystatechange = function () {
          if (xhr.readyState === XMLHttpRequest.DONE) {
            return done(xhr);
          }
        };
        return xhr;
      };

      processResponse = function (response, type) {
        var parser, script;
        if (typeof response === 'string' && typeof type === 'string') {
          if (type.match(/\bjson\b/)) {
            try {
              response = JSON.parse(response);
            } catch (error) {}
          } else if (type.match(/\b(?:java|ecma)script\b/)) {
            script = document.createElement('script');
            script.text = response;
            document.head.appendChild(script).parentNode.removeChild(script);
          } else if (type.match(/\b(xml|html|svg)\b/)) {
            parser = new DOMParser();
            type = type.replace(/;.+/, '');
            try {
              response = parser.parseFromString(response, type);
            } catch (error) {}
          }
        }
        return response;
      };

      Rails.href = function (element) {
        return element.href;
      };

      Rails.isCrossDomain = function (url) {
        var e, originAnchor, urlAnchor;
        originAnchor = document.createElement('a');
        originAnchor.href = location.href;
        urlAnchor = document.createElement('a');
        try {
          urlAnchor.href = url;
          return !((!urlAnchor.protocol || urlAnchor.protocol === ':') && !urlAnchor.host || originAnchor.protocol + '//' + originAnchor.host === urlAnchor.protocol + '//' + urlAnchor.host);
        } catch (error) {
          e = error;
          return true;
        }
      };
    }).call(this);
    (function () {
      var matches, toArray;

      matches = Rails.matches;

      toArray = function (e) {
        return Array.prototype.slice.call(e);
      };

      Rails.serializeElement = function (element, additionalParam) {
        var inputs, params;
        inputs = [element];
        if (matches(element, 'form')) {
          inputs = toArray(element.elements);
        }
        params = [];
        inputs.forEach(function (input) {
          if (!input.name) {
            return;
          }
          if (matches(input, 'select')) {
            return toArray(input.options).forEach(function (option) {
              if (option.selected) {
                return params.push({
                  name: input.name,
                  value: option.value
                });
              }
            });
          } else if (input.checked || ['radio', 'checkbox', 'submit'].indexOf(input.type) === -1) {
            return params.push({
              name: input.name,
              value: input.value
            });
          }
        });
        if (additionalParam) {
          params.push(additionalParam);
        }
        return params.map(function (param) {
          if (param.name != null) {
            return encodeURIComponent(param.name) + "=" + encodeURIComponent(param.value);
          } else {
            return param;
          }
        }).join('&');
      };

      Rails.formElements = function (form, selector) {
        if (matches(form, 'form')) {
          return toArray(form.elements).filter(function (el) {
            return matches(el, selector);
          });
        } else {
          return toArray(form.querySelectorAll(selector));
        }
      };
    }).call(this);
    (function () {
      var allowAction, fire, stopEverything;

      fire = Rails.fire, stopEverything = Rails.stopEverything;

      Rails.handleConfirm = function (e) {
        if (!allowAction(this)) {
          return stopEverything(e);
        }
      };

      allowAction = function (element) {
        var answer, callback, message;
        message = element.getAttribute('data-confirm');
        if (!message) {
          return true;
        }
        answer = false;
        if (fire(element, 'confirm')) {
          try {
            answer = confirm(message);
          } catch (error) {}
          callback = fire(element, 'confirm:complete', [answer]);
        }
        return answer && callback;
      };
    }).call(this);
    (function () {
      var disableFormElement, disableFormElements, disableLinkElement, enableFormElement, enableFormElements, enableLinkElement, formElements, getData, matches, setData, stopEverything;

      matches = Rails.matches, getData = Rails.getData, setData = Rails.setData, stopEverything = Rails.stopEverything, formElements = Rails.formElements;

      Rails.handleDisabledElement = function (e) {
        var element;
        element = this;
        if (element.disabled) {
          return stopEverything(e);
        }
      };

      Rails.enableElement = function (e) {
        var element;
        element = e instanceof Event ? e.target : e;
        if (matches(element, Rails.linkDisableSelector)) {
          return enableLinkElement(element);
        } else if (matches(element, Rails.buttonDisableSelector) || matches(element, Rails.formEnableSelector)) {
          return enableFormElement(element);
        } else if (matches(element, Rails.formSubmitSelector)) {
          return enableFormElements(element);
        }
      };

      Rails.disableElement = function (e) {
        var element;
        element = e instanceof Event ? e.target : e;
        if (matches(element, Rails.linkDisableSelector)) {
          return disableLinkElement(element);
        } else if (matches(element, Rails.buttonDisableSelector) || matches(element, Rails.formDisableSelector)) {
          return disableFormElement(element);
        } else if (matches(element, Rails.formSubmitSelector)) {
          return disableFormElements(element);
        }
      };

      disableLinkElement = function (element) {
        var replacement;
        replacement = element.getAttribute('data-disable-with');
        if (replacement != null) {
          setData(element, 'ujs:enable-with', element.innerHTML);
          element.innerHTML = replacement;
        }
        element.addEventListener('click', stopEverything);
        return setData(element, 'ujs:disabled', true);
      };

      enableLinkElement = function (element) {
        var originalText;
        originalText = getData(element, 'ujs:enable-with');
        if (originalText != null) {
          element.innerHTML = originalText;
          setData(element, 'ujs:enable-with', null);
        }
        element.removeEventListener('click', stopEverything);
        return setData(element, 'ujs:disabled', null);
      };

      disableFormElements = function (form) {
        return formElements(form, Rails.formDisableSelector).forEach(disableFormElement);
      };

      disableFormElement = function (element) {
        var replacement;
        replacement = element.getAttribute('data-disable-with');
        if (replacement != null) {
          if (matches(element, 'button')) {
            setData(element, 'ujs:enable-with', element.innerHTML);
            element.innerHTML = replacement;
          } else {
            setData(element, 'ujs:enable-with', element.value);
            element.value = replacement;
          }
        }
        element.disabled = true;
        return setData(element, 'ujs:disabled', true);
      };

      enableFormElements = function (form) {
        return formElements(form, Rails.formEnableSelector).forEach(enableFormElement);
      };

      enableFormElement = function (element) {
        var originalText;
        originalText = getData(element, 'ujs:enable-with');
        if (originalText != null) {
          if (matches(element, 'button')) {
            element.innerHTML = originalText;
          } else {
            element.value = originalText;
          }
          setData(element, 'ujs:enable-with', null);
        }
        element.disabled = false;
        return setData(element, 'ujs:disabled', null);
      };
    }).call(this);
    (function () {
      var stopEverything;

      stopEverything = Rails.stopEverything;

      Rails.handleMethod = function (e) {
        var csrfParam, csrfToken, form, formContent, href, link, method;
        link = this;
        method = link.getAttribute('data-method');
        if (!method) {
          return;
        }
        href = Rails.href(link);
        csrfToken = Rails.csrfToken();
        csrfParam = Rails.csrfParam();
        form = document.createElement('form');
        formContent = "<input name='_method' value='" + method + "' type='hidden' />";
        if (csrfParam != null && csrfToken != null && !Rails.isCrossDomain(href)) {
          formContent += "<input name='" + csrfParam + "' value='" + csrfToken + "' type='hidden' />";
        }
        formContent += '<input type="submit" />';
        form.method = 'post';
        form.action = href;
        form.target = link.target;
        form.innerHTML = formContent;
        form.style.display = 'none';
        document.body.appendChild(form);
        form.querySelector('[type="submit"]').click();
        return stopEverything(e);
      };
    }).call(this);
    (function () {
      var ajax,
          fire,
          getData,
          isCrossDomain,
          isRemote,
          matches,
          serializeElement,
          setData,
          stopEverything,
          slice = [].slice;

      matches = Rails.matches, getData = Rails.getData, setData = Rails.setData, fire = Rails.fire, stopEverything = Rails.stopEverything, ajax = Rails.ajax, isCrossDomain = Rails.isCrossDomain, serializeElement = Rails.serializeElement;

      isRemote = function (element) {
        var value;
        value = element.getAttribute('data-remote');
        return value != null && value !== 'false';
      };

      Rails.handleRemote = function (e) {
        var button, data, dataType, element, method, url, withCredentials;
        element = this;
        if (!isRemote(element)) {
          return true;
        }
        if (!fire(element, 'ajax:before')) {
          fire(element, 'ajax:stopped');
          return false;
        }
        withCredentials = element.getAttribute('data-with-credentials');
        dataType = element.getAttribute('data-type') || 'script';
        if (matches(element, Rails.formSubmitSelector)) {
          button = getData(element, 'ujs:submit-button');
          method = getData(element, 'ujs:submit-button-formmethod') || element.method;
          url = getData(element, 'ujs:submit-button-formaction') || element.getAttribute('action') || location.href;
          if (method.toUpperCase() === 'GET') {
            url = url.replace(/\?.*$/, '');
          }
          if (element.enctype === 'multipart/form-data') {
            data = new FormData(element);
            if (button != null) {
              data.append(button.name, button.value);
            }
          } else {
            data = serializeElement(element, button);
          }
          setData(element, 'ujs:submit-button', null);
          setData(element, 'ujs:submit-button-formmethod', null);
          setData(element, 'ujs:submit-button-formaction', null);
        } else if (matches(element, Rails.buttonClickSelector) || matches(element, Rails.inputChangeSelector)) {
          method = element.getAttribute('data-method');
          url = element.getAttribute('data-url');
          data = serializeElement(element, element.getAttribute('data-params'));
        } else {
          method = element.getAttribute('data-method');
          url = Rails.href(element);
          data = element.getAttribute('data-params');
        }
        ajax({
          type: method || 'GET',
          url: url,
          data: data,
          dataType: dataType,
          beforeSend: function (xhr, options) {
            if (fire(element, 'ajax:beforeSend', [xhr, options])) {
              return fire(element, 'ajax:send', [xhr]);
            } else {
              fire(element, 'ajax:stopped');
              return xhr.abort();
            }
          },
          success: function () {
            var args;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            return fire(element, 'ajax:success', args);
          },
          error: function () {
            var args;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            return fire(element, 'ajax:error', args);
          },
          complete: function () {
            var args;
            args = 1 <= arguments.length ? slice.call(arguments, 0) : [];
            return fire(element, 'ajax:complete', args);
          },
          crossDomain: isCrossDomain(url),
          withCredentials: withCredentials != null && withCredentials !== 'false'
        });
        return stopEverything(e);
      };

      Rails.formSubmitButtonClick = function (e) {
        var button, form;
        button = this;
        form = button.form;
        if (!form) {
          return;
        }
        if (button.name) {
          setData(form, 'ujs:submit-button', {
            name: button.name,
            value: button.value
          });
        }
        setData(form, 'ujs:formnovalidate-button', button.formNoValidate);
        setData(form, 'ujs:submit-button-formaction', button.getAttribute('formaction'));
        return setData(form, 'ujs:submit-button-formmethod', button.getAttribute('formmethod'));
      };

      Rails.handleMetaClick = function (e) {
        var data, link, metaClick, method;
        link = this;
        method = (link.getAttribute('data-method') || 'GET').toUpperCase();
        data = link.getAttribute('data-params');
        metaClick = e.metaKey || e.ctrlKey;
        if (metaClick && method === 'GET' && !data) {
          return e.stopImmediatePropagation();
        }
      };
    }).call(this);
    (function () {
      var $, CSRFProtection, delegate, disableElement, enableElement, fire, formSubmitButtonClick, getData, handleConfirm, handleDisabledElement, handleMetaClick, handleMethod, handleRemote, refreshCSRFTokens;

      fire = Rails.fire, delegate = Rails.delegate, getData = Rails.getData, $ = Rails.$, refreshCSRFTokens = Rails.refreshCSRFTokens, CSRFProtection = Rails.CSRFProtection, enableElement = Rails.enableElement, disableElement = Rails.disableElement, handleDisabledElement = Rails.handleDisabledElement, handleConfirm = Rails.handleConfirm, handleRemote = Rails.handleRemote, formSubmitButtonClick = Rails.formSubmitButtonClick, handleMetaClick = Rails.handleMetaClick, handleMethod = Rails.handleMethod;

      if (typeof jQuery !== "undefined" && jQuery !== null && jQuery.ajax != null && !jQuery.rails) {
        jQuery.rails = Rails;
        jQuery.ajaxPrefilter(function (options, originalOptions, xhr) {
          if (!options.crossDomain) {
            return CSRFProtection(xhr);
          }
        });
      }

      Rails.start = function () {
        if (window._rails_loaded) {
          throw new Error('rails-ujs has already been loaded!');
        }
        window.addEventListener('pageshow', function () {
          $(Rails.formEnableSelector).forEach(function (el) {
            if (getData(el, 'ujs:disabled')) {
              return enableElement(el);
            }
          });
          return $(Rails.linkDisableSelector).forEach(function (el) {
            if (getData(el, 'ujs:disabled')) {
              return enableElement(el);
            }
          });
        });
        delegate(document, Rails.linkDisableSelector, 'ajax:complete', enableElement);
        delegate(document, Rails.linkDisableSelector, 'ajax:stopped', enableElement);
        delegate(document, Rails.buttonDisableSelector, 'ajax:complete', enableElement);
        delegate(document, Rails.buttonDisableSelector, 'ajax:stopped', enableElement);
        delegate(document, Rails.linkClickSelector, 'click', handleDisabledElement);
        delegate(document, Rails.linkClickSelector, 'click', handleConfirm);
        delegate(document, Rails.linkClickSelector, 'click', handleMetaClick);
        delegate(document, Rails.linkClickSelector, 'click', disableElement);
        delegate(document, Rails.linkClickSelector, 'click', handleRemote);
        delegate(document, Rails.linkClickSelector, 'click', handleMethod);
        delegate(document, Rails.buttonClickSelector, 'click', handleDisabledElement);
        delegate(document, Rails.buttonClickSelector, 'click', handleConfirm);
        delegate(document, Rails.buttonClickSelector, 'click', disableElement);
        delegate(document, Rails.buttonClickSelector, 'click', handleRemote);
        delegate(document, Rails.inputChangeSelector, 'change', handleDisabledElement);
        delegate(document, Rails.inputChangeSelector, 'change', handleConfirm);
        delegate(document, Rails.inputChangeSelector, 'change', handleRemote);
        delegate(document, Rails.formSubmitSelector, 'submit', handleDisabledElement);
        delegate(document, Rails.formSubmitSelector, 'submit', handleConfirm);
        delegate(document, Rails.formSubmitSelector, 'submit', handleRemote);
        delegate(document, Rails.formSubmitSelector, 'submit', function (e) {
          return setTimeout(function () {
            return disableElement(e);
          }, 13);
        });
        delegate(document, Rails.formSubmitSelector, 'ajax:send', disableElement);
        delegate(document, Rails.formSubmitSelector, 'ajax:complete', enableElement);
        delegate(document, Rails.formInputClickSelector, 'click', handleDisabledElement);
        delegate(document, Rails.formInputClickSelector, 'click', handleConfirm);
        delegate(document, Rails.formInputClickSelector, 'click', formSubmitButtonClick);
        document.addEventListener('DOMContentLoaded', refreshCSRFTokens);
        return window._rails_loaded = true;
      };

      if (window.Rails === Rails && fire(document, 'rails:attachBindings')) {
        Rails.start();
      }
    }).call(this);
  }).call(this);

  if (typeof module === "object" && module.exports) {
    module.exports = Rails;
  } else if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (Rails),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}).call(this);

/***/ }),
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ScrollBehaviorContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scroll_behavior__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_scroll_behavior___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_scroll_behavior__);







var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var DEV = "production" !== 'production';

var propTypes = {
  scrollKey: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
  shouldUpdateScroll: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
};

var contextTypes = {
  // This is necessary when rendering on the client. However, when rendering on
  // the server, this container will do nothing, and thus does not require the
  // scroll behavior context.
  scrollBehavior: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};

var ScrollContainer = function (_React$Component) {
  inherits(ScrollContainer, _React$Component);

  function ScrollContainer(props, context) {
    classCallCheck(this, ScrollContainer);

    // We don't re-register if the scroll key changes, so make sure we
    // unregister with the initial scroll key just in case the user changes it.
    var _this = possibleConstructorReturn(this, (ScrollContainer.__proto__ || Object.getPrototypeOf(ScrollContainer)).call(this, props, context));

    _this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
      var shouldUpdateScroll = _this.props.shouldUpdateScroll;

      if (!shouldUpdateScroll) {
        return true;
      }

      // Hack to allow accessing scrollBehavior._stateStorage.
      return shouldUpdateScroll.call(_this.context.scrollBehavior.scrollBehavior, prevRouterProps, routerProps);
    };

    _this.scrollKey = props.scrollKey;
    return _this;
  }

  createClass(ScrollContainer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.context.scrollBehavior.registerElement(this.props.scrollKey, __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this), this.shouldUpdateScroll);

      // Only keep around the current DOM node in development, as this is only
      // for emitting the appropriate warning.
      if (DEV) {
        this.domNode = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
       false ? warning(nextProps.scrollKey === this.props.scrollKey, '<ScrollContainer> does not support changing scrollKey.') : void 0;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (DEV) {
        var prevDomNode = this.domNode;
        this.domNode = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(this);

         false ? warning(this.domNode === prevDomNode, '<ScrollContainer> does not support changing DOM node.') : void 0;
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.context.scrollBehavior.unregisterElement(this.scrollKey);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(this.props.children);
    }
  }]);
  return ScrollContainer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ScrollContainer.propTypes = propTypes;
ScrollContainer.contextTypes = contextTypes;

var STATE_KEY_PREFIX = '@@scroll|';

var SessionStorage = function () {
  function SessionStorage() {
    classCallCheck(this, SessionStorage);
  }

  createClass(SessionStorage, [{
    key: 'read',
    value: function read(location, key) {
      var stateKey = this.getStateKey(location, key);
      var value = sessionStorage.getItem(stateKey);
      return JSON.parse(value);
    }
  }, {
    key: 'save',
    value: function save(location, key, value) {
      var stateKey = this.getStateKey(location, key);
      var storedValue = JSON.stringify(value);
      sessionStorage.setItem(stateKey, storedValue);
    }
  }, {
    key: 'getStateKey',
    value: function getStateKey(location, key) {
      var locationKey = location.key;
      var stateKeyBase = '' + STATE_KEY_PREFIX + locationKey;
      return key == null ? stateKeyBase : stateKeyBase + '|' + key;
    }
  }]);
  return SessionStorage;
}();

var propTypes$1 = {
  shouldUpdateScroll: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired,
  history: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};

var childContextTypes = {
  scrollBehavior: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object.isRequired
};

var ScrollContext = function (_React$Component) {
  inherits(ScrollContext, _React$Component);

  function ScrollContext(props, context) {
    classCallCheck(this, ScrollContext);

    var _this = possibleConstructorReturn(this, (ScrollContext.__proto__ || Object.getPrototypeOf(ScrollContext)).call(this, props, context));

    _this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
      var shouldUpdateScroll = _this.props.shouldUpdateScroll;

      if (!shouldUpdateScroll) {
        return true;
      }

      // Hack to allow accessing scrollBehavior._stateStorage.
      return shouldUpdateScroll.call(_this.scrollBehavior, prevRouterProps, routerProps);
    };

    _this.registerElement = function (key, element, shouldUpdateScroll) {
      _this.scrollBehavior.registerElement(key, element, shouldUpdateScroll, _this.getRouterProps());
    };

    _this.unregisterElement = function (key) {
      _this.scrollBehavior.unregisterElement(key);
    };

    var history = props.history;

    _this.scrollBehavior = new __WEBPACK_IMPORTED_MODULE_5_scroll_behavior___default.a({
      addTransitionHook: history.listen,
      stateStorage: new SessionStorage(),
      getCurrentLocation: function getCurrentLocation() {
        return _this.props.location;
      },
      shouldUpdateScroll: _this.shouldUpdateScroll
    });

    _this.scrollBehavior.updateScroll(null, _this.getRouterProps());
    return _this;
  }

  createClass(ScrollContext, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        scrollBehavior: this
      };
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          location = _props.location,
          history = _props.history;

      var prevLocation = prevProps.location;

      if (location === prevLocation) {
        return;
      }

      var prevRouterProps = {
        history: prevProps.history,
        location: prevProps.location
      };

      this.scrollBehavior.updateScroll(prevRouterProps, { history: history, location: location });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.scrollBehavior.stop();
    }
  }, {
    key: 'getRouterProps',
    value: function getRouterProps() {
      var _props2 = this.props,
          history = _props2.history,
          location = _props2.location;

      return { history: history, location: location };
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(this.props.children);
    }
  }]);
  return ScrollContext;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ScrollContext.propTypes = propTypes$1;
ScrollContext.childContextTypes = childContextTypes;

var ScrollBehaviorContext = Object(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["g" /* withRouter */])(ScrollContext);



/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REPORT_INIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REPORT_CANCEL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REPORT_SUBMIT_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REPORT_SUBMIT_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return REPORT_SUBMIT_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return REPORT_STATUS_TOGGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return REPORT_COMMENT_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REPORT_FORWARD_CHANGE; });
/* harmony export (immutable) */ __webpack_exports__["k"] = initReport;
/* unused harmony export cancelReport */
/* harmony export (immutable) */ __webpack_exports__["m"] = toggleStatusReport;
/* harmony export (immutable) */ __webpack_exports__["l"] = submitReport;
/* unused harmony export submitReportRequest */
/* unused harmony export submitReportSuccess */
/* unused harmony export submitReportFail */
/* harmony export (immutable) */ __webpack_exports__["i"] = changeReportComment;
/* harmony export (immutable) */ __webpack_exports__["j"] = changeReportForward;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modal__ = __webpack_require__(26);



var REPORT_INIT = 'REPORT_INIT';
var REPORT_CANCEL = 'REPORT_CANCEL';

var REPORT_SUBMIT_REQUEST = 'REPORT_SUBMIT_REQUEST';
var REPORT_SUBMIT_SUCCESS = 'REPORT_SUBMIT_SUCCESS';
var REPORT_SUBMIT_FAIL = 'REPORT_SUBMIT_FAIL';

var REPORT_STATUS_TOGGLE = 'REPORT_STATUS_TOGGLE';
var REPORT_COMMENT_CHANGE = 'REPORT_COMMENT_CHANGE';
var REPORT_FORWARD_CHANGE = 'REPORT_FORWARD_CHANGE';

function initReport(account, status) {
  return function (dispatch) {
    dispatch({
      type: REPORT_INIT,
      account: account,
      status: status
    });

    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__modal__["d" /* openModal */])('REPORT'));
  };
};

function cancelReport() {
  return {
    type: REPORT_CANCEL
  };
};

function toggleStatusReport(statusId, checked) {
  return {
    type: REPORT_STATUS_TOGGLE,
    statusId: statusId,
    checked: checked
  };
};

function submitReport() {
  return function (dispatch, getState) {
    dispatch(submitReportRequest());

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).post('/api/v1/reports', {
      account_id: getState().getIn(['reports', 'new', 'account_id']),
      status_ids: getState().getIn(['reports', 'new', 'status_ids']),
      comment: getState().getIn(['reports', 'new', 'comment']),
      forward: getState().getIn(['reports', 'new', 'forward'])
    }).then(function (response) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__modal__["c" /* closeModal */])());
      dispatch(submitReportSuccess(response.data));
    }).catch(function (error) {
      return dispatch(submitReportFail(error));
    });
  };
};

function submitReportRequest() {
  return {
    type: REPORT_SUBMIT_REQUEST
  };
};

function submitReportSuccess(report) {
  return {
    type: REPORT_SUBMIT_SUCCESS,
    report: report
  };
};

function submitReportFail(error) {
  return {
    type: REPORT_SUBMIT_FAIL,
    error: error
  };
};

function changeReportComment(comment) {
  return {
    type: REPORT_COMMENT_CHANGE,
    comment: comment
  };
};

function changeReportForward(forward) {
  return {
    type: REPORT_FORWARD_CHANGE,
    forward: forward
  };
};

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Status; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_immutable_proptypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__avatar__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__avatar_overlay__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__relative_timestamp__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__display_name__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__status_content__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__status_action_bar__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__attachment_list__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_intl__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_immutable_pure_component__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_immutable_pure_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_immutable_pure_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__features_ui_util_async_components__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_hotkeys__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_hotkeys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_react_hotkeys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__features_ui_components_bundle__ = __webpack_require__(167);








var _class, _temp2;

















// We use the component (and not the container) since we do not want
// to use the progress bar to show download progress


var Status = (_temp2 = _class = function (_ImmutablePureCompone) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Status, _ImmutablePureCompone);

  function Status() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Status);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, _ImmutablePureCompone.call.apply(_ImmutablePureCompone, [this].concat(args))), _this), _this.updateOnProps = ['status', 'account', 'muted', 'hidden'], _this.handleClick = function () {
      if (!_this.context.router) {
        return;
      }

      var status = _this.props.status;

      _this.context.router.history.push('/statuses/' + status.getIn(['reblog', 'id'], status.get('id')));
    }, _this.handleAccountClick = function (e) {
      if (_this.context.router && e.button === 0) {
        var id = e.currentTarget.getAttribute('data-id');
        e.preventDefault();
        _this.context.router.history.push('/accounts/' + id);
      }
    }, _this.handleExpandedToggle = function () {
      _this.props.onToggleHidden(_this._properStatus());
    }, _this.handleOpenVideo = function (media, startTime) {
      _this.props.onOpenVideo(media, startTime);
    }, _this.handleHotkeyReply = function (e) {
      e.preventDefault();
      _this.props.onReply(_this._properStatus(), _this.context.router.history);
    }, _this.handleHotkeyFavourite = function () {
      _this.props.onFavourite(_this._properStatus());
    }, _this.handleHotkeyBoost = function (e) {
      _this.props.onReblog(_this._properStatus(), e);
    }, _this.handleHotkeyMention = function (e) {
      e.preventDefault();
      _this.props.onMention(_this._properStatus().get('account'), _this.context.router.history);
    }, _this.handleHotkeyOpen = function () {
      _this.context.router.history.push('/statuses/' + _this._properStatus().get('id'));
    }, _this.handleHotkeyOpenProfile = function () {
      _this.context.router.history.push('/accounts/' + _this._properStatus().getIn(['account', 'id']));
    }, _this.handleHotkeyMoveUp = function (e) {
      _this.props.onMoveUp(_this.props.status.get('id'), e.target.getAttribute('data-featured'));
    }, _this.handleHotkeyMoveDown = function (e) {
      _this.props.onMoveDown(_this.props.status.get('id'), e.target.getAttribute('data-featured'));
    }, _this.handleHotkeyToggleHidden = function () {
      _this.props.onToggleHidden(_this._properStatus());
    }, _temp), __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  // Avoid checking props that are functions (and whose equality will always
  // evaluate to false. See react-immutable-pure-component for usage.


  Status.prototype.renderLoadingMediaGallery = function renderLoadingMediaGallery() {
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()('div', {
      className: 'media_gallery',
      style: { height: '110px' }
    });
  };

  Status.prototype.renderLoadingVideoPlayer = function renderLoadingVideoPlayer() {
    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()('div', {
      className: 'media-spoiler-video',
      style: { height: '110px' }
    });
  };

  Status.prototype._properStatus = function _properStatus() {
    var status = this.props.status;


    if (status.get('reblog', null) !== null && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(status.get('reblog')) === 'object') {
      return status.get('reblog');
    } else {
      return status;
    }
  };

  Status.prototype.render = function render() {
    var _this2 = this;

    var media = null;
    var statusAvatar = void 0,
        prepend = void 0;

    var _props = this.props,
        hidden = _props.hidden,
        featured = _props.featured;

    var _props2 = this.props,
        status = _props2.status,
        account = _props2.account,
        other = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props2, ['status', 'account']);

    if (status === null) {
      return null;
    }

    if (hidden) {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()('div', {}, void 0, status.getIn(['account', 'display_name']) || status.getIn(['account', 'username']), status.get('content'));
    }

    if (status.get('filtered') || status.getIn(['reblog', 'filtered'])) {
      var minHandlers = this.props.muted ? {} : {
        moveUp: this.handleHotkeyMoveUp,
        moveDown: this.handleHotkeyMoveDown
      };

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_20_react_hotkeys__["HotKeys"], {
        handlers: minHandlers
      }, void 0, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()('div', {
        className: 'status__wrapper status__wrapper--filtered focusable',
        tabIndex: '0'
      }, void 0, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_17_react_intl__["b" /* FormattedMessage */], {
        id: 'status.filtered',
        defaultMessage: 'Filtered'
      })));
    }

    if (featured) {
      prepend = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()('div', {
        className: 'status__prepend'
      }, void 0, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()('div', {
        className: 'status__prepend-icon-wrapper'
      }, void 0, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()('i', {
        className: 'fa fa-fw fa-thumb-tack status__prepend-icon'
      })), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_17_react_intl__["b" /* FormattedMessage */], {
        id: 'status.pinned',
        defaultMessage: 'Pinned toot'
      }));
    } else if (status.get('reblog', null) !== null && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(status.get('reblog')) === 'object') {
      var display_name_html = { __html: status.getIn(['account', 'display_name_html']) };

      prepend = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()('div', {
        className: 'status__prepend'
      }, void 0, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()('div', {
        className: 'status__prepend-icon-wrapper'
      }, void 0, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()('i', {
        className: 'fa fa-fw fa-retweet status__prepend-icon'
      })), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_17_react_intl__["b" /* FormattedMessage */], {
        id: 'status.reblogged_by',
        defaultMessage: '{name} boosted',
        values: { name: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()('a', {
            onClick: this.handleAccountClick,
            'data-id': status.getIn(['account', 'id']),
            href: status.getIn(['account', 'url']),
            className: 'status__display-name muted'
          }, void 0, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()('bdi', {}, void 0, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()('strong', {
            dangerouslySetInnerHTML: display_name_html
          }))) }
      }));

      account = status.get('account');
      status = status.get('reblog');
    }

    if (status.get('media_attachments').size > 0) {
      if (this.props.muted || status.get('media_attachments').some(function (item) {
        return item.get('type') === 'unknown';
      })) {
        media = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_16__attachment_list__["a" /* default */], {
          compact: true,
          media: status.get('media_attachments')
        });
      } else if (status.getIn(['media_attachments', 0, 'type']) === 'video') {
        var video = status.getIn(['media_attachments', 0]);

        media = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_22__features_ui_components_bundle__["a" /* default */], {
          fetchComponent: __WEBPACK_IMPORTED_MODULE_19__features_ui_util_async_components__["G" /* Video */],
          loading: this.renderLoadingVideoPlayer
        }, void 0, function (Component) {
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()(Component, {
            preview: video.get('preview_url'),
            src: video.get('url'),
            width: 239,
            height: 110,
            inline: true,
            sensitive: status.get('sensitive'),
            onOpenVideo: _this2.handleOpenVideo
          });
        });
      } else {
        media = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_22__features_ui_components_bundle__["a" /* default */], {
          fetchComponent: __WEBPACK_IMPORTED_MODULE_19__features_ui_util_async_components__["w" /* MediaGallery */],
          loading: this.renderLoadingMediaGallery
        }, void 0, function (Component) {
          return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()(Component, {
            media: status.get('media_attachments'),
            sensitive: status.get('sensitive'),
            height: 110,
            onOpenMedia: _this2.props.onOpenMedia
          });
        });
      }
    }

    if (account === undefined || account === null) {
      statusAvatar = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__avatar__["a" /* default */], {
        account: status.get('account'),
        size: 48
      });
    } else {
      statusAvatar = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__avatar_overlay__["a" /* default */], {
        account: status.get('account'),
        friend: account
      });
    }

    var handlers = this.props.muted ? {} : {
      reply: this.handleHotkeyReply,
      favourite: this.handleHotkeyFavourite,
      boost: this.handleHotkeyBoost,
      mention: this.handleHotkeyMention,
      open: this.handleHotkeyOpen,
      openProfile: this.handleHotkeyOpenProfile,
      moveUp: this.handleHotkeyMoveUp,
      moveDown: this.handleHotkeyMoveDown,
      toggleHidden: this.handleHotkeyToggleHidden
    };

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_20_react_hotkeys__["HotKeys"], {
      handlers: handlers
    }, void 0, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()('div', {
      className: __WEBPACK_IMPORTED_MODULE_21_classnames___default()('status__wrapper', 'status__wrapper-' + status.get('visibility'), { focusable: !this.props.muted }),
      tabIndex: this.props.muted ? null : 0,
      'data-featured': featured ? 'true' : null
    }, void 0, prepend, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()('div', {
      className: __WEBPACK_IMPORTED_MODULE_21_classnames___default()('status', 'status-' + status.get('visibility'), { muted: this.props.muted }),
      'data-id': status.get('id')
    }, void 0, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()('div', {
      className: 'status__info'
    }, void 0, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()('a', {
      href: status.get('url'),
      className: 'status__relative-time',
      target: '_blank',
      rel: 'noopener'
    }, void 0, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__relative_timestamp__["a" /* default */], {
      timestamp: status.get('created_at')
    })), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()('a', {
      onClick: this.handleAccountClick,
      target: '_blank',
      'data-id': status.getIn(['account', 'id']),
      href: status.getIn(['account', 'url']),
      title: status.getIn(['account', 'acct']),
      className: 'status__display-name'
    }, void 0, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()('div', {
      className: 'status__avatar'
    }, void 0, statusAvatar), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_13__display_name__["a" /* default */], {
      account: status.get('account')
    }))), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_14__status_content__["a" /* default */], {
      status: status,
      onClick: this.handleClick,
      expanded: !status.get('hidden'),
      onExpandedToggle: this.handleExpandedToggle
    }), media, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__status_action_bar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ status: status, account: account }, other)))));
  };

  return Status;
}(__WEBPACK_IMPORTED_MODULE_18_react_immutable_pure_component___default.a), _class.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.object
}, _class.propTypes = {
  status: __WEBPACK_IMPORTED_MODULE_8_react_immutable_proptypes___default.a.map,
  account: __WEBPACK_IMPORTED_MODULE_8_react_immutable_proptypes___default.a.map,
  onReply: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  onFavourite: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  onReblog: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  onDelete: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  onDirect: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  onMention: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  onPin: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  onOpenMedia: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  onOpenVideo: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  onBlock: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  onEmbed: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  onHeightChange: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  onToggleHidden: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  muted: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  hidden: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  onMoveUp: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,
  onMoveDown: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func
}, _temp2);


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isFullscreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return exitFullscreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return requestFullscreen; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return attachFullscreenListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return detachFullscreenListener; });
// APIs for normalizing fullscreen operations. Note that Edge uses
// the WebKit-prefixed APIs currently (as of Edge 16).

var isFullscreen = function isFullscreen() {
  return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement;
};

var exitFullscreen = function exitFullscreen() {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  }
};

var requestFullscreen = function requestFullscreen(el) {
  if (el.requestFullscreen) {
    el.requestFullscreen();
  } else if (el.webkitRequestFullscreen) {
    el.webkitRequestFullscreen();
  } else if (el.mozRequestFullScreen) {
    el.mozRequestFullScreen();
  }
};

var attachFullscreenListener = function attachFullscreenListener(listener) {
  if ('onfullscreenchange' in document) {
    document.addEventListener('fullscreenchange', listener);
  } else if ('onwebkitfullscreenchange' in document) {
    document.addEventListener('webkitfullscreenchange', listener);
  } else if ('onmozfullscreenchange' in document) {
    document.addEventListener('mozfullscreenchange', listener);
  }
};

var detachFullscreenListener = function detachFullscreenListener(listener) {
  if ('onfullscreenchange' in document) {
    document.removeEventListener('fullscreenchange', listener);
  } else if ('onwebkitfullscreenchange' in document) {
    document.removeEventListener('webkitfullscreenchange', listener);
  } else if ('onmozfullscreenchange' in document) {
    document.removeEventListener('mozfullscreenchange', listener);
  }
};

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DOMAIN_BLOCK_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DOMAIN_BLOCK_SUCCESS; });
/* unused harmony export DOMAIN_BLOCK_FAIL */
/* unused harmony export DOMAIN_UNBLOCK_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DOMAIN_UNBLOCK_SUCCESS; });
/* unused harmony export DOMAIN_UNBLOCK_FAIL */
/* unused harmony export DOMAIN_BLOCKS_FETCH_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DOMAIN_BLOCKS_FETCH_SUCCESS; });
/* unused harmony export DOMAIN_BLOCKS_FETCH_FAIL */
/* unused harmony export DOMAIN_BLOCKS_EXPAND_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DOMAIN_BLOCKS_EXPAND_SUCCESS; });
/* unused harmony export DOMAIN_BLOCKS_EXPAND_FAIL */
/* harmony export (immutable) */ __webpack_exports__["e"] = blockDomain;
/* unused harmony export blockDomainRequest */
/* unused harmony export blockDomainSuccess */
/* unused harmony export blockDomainFail */
/* harmony export (immutable) */ __webpack_exports__["h"] = unblockDomain;
/* unused harmony export unblockDomainRequest */
/* unused harmony export unblockDomainSuccess */
/* unused harmony export unblockDomainFail */
/* harmony export (immutable) */ __webpack_exports__["g"] = fetchDomainBlocks;
/* unused harmony export fetchDomainBlocksRequest */
/* unused harmony export fetchDomainBlocksSuccess */
/* unused harmony export fetchDomainBlocksFail */
/* harmony export (immutable) */ __webpack_exports__["f"] = expandDomainBlocks;
/* unused harmony export expandDomainBlocksRequest */
/* unused harmony export expandDomainBlocksSuccess */
/* unused harmony export expandDomainBlocksFail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(11);


var DOMAIN_BLOCK_REQUEST = 'DOMAIN_BLOCK_REQUEST';
var DOMAIN_BLOCK_SUCCESS = 'DOMAIN_BLOCK_SUCCESS';
var DOMAIN_BLOCK_FAIL = 'DOMAIN_BLOCK_FAIL';

var DOMAIN_UNBLOCK_REQUEST = 'DOMAIN_UNBLOCK_REQUEST';
var DOMAIN_UNBLOCK_SUCCESS = 'DOMAIN_UNBLOCK_SUCCESS';
var DOMAIN_UNBLOCK_FAIL = 'DOMAIN_UNBLOCK_FAIL';

var DOMAIN_BLOCKS_FETCH_REQUEST = 'DOMAIN_BLOCKS_FETCH_REQUEST';
var DOMAIN_BLOCKS_FETCH_SUCCESS = 'DOMAIN_BLOCKS_FETCH_SUCCESS';
var DOMAIN_BLOCKS_FETCH_FAIL = 'DOMAIN_BLOCKS_FETCH_FAIL';

var DOMAIN_BLOCKS_EXPAND_REQUEST = 'DOMAIN_BLOCKS_EXPAND_REQUEST';
var DOMAIN_BLOCKS_EXPAND_SUCCESS = 'DOMAIN_BLOCKS_EXPAND_SUCCESS';
var DOMAIN_BLOCKS_EXPAND_FAIL = 'DOMAIN_BLOCKS_EXPAND_FAIL';

function blockDomain(domain) {
  return function (dispatch, getState) {
    dispatch(blockDomainRequest(domain));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).post('/api/v1/domain_blocks', { domain: domain }).then(function () {
      var at_domain = '@' + domain;
      var accounts = getState().get('accounts').filter(function (item) {
        return item.get('acct').endsWith(at_domain);
      }).valueSeq().map(function (item) {
        return item.get('id');
      });
      dispatch(blockDomainSuccess(domain, accounts));
    }).catch(function (err) {
      dispatch(blockDomainFail(domain, err));
    });
  };
};

function blockDomainRequest(domain) {
  return {
    type: DOMAIN_BLOCK_REQUEST,
    domain: domain
  };
};

function blockDomainSuccess(domain, accounts) {
  return {
    type: DOMAIN_BLOCK_SUCCESS,
    domain: domain,
    accounts: accounts
  };
};

function blockDomainFail(domain, error) {
  return {
    type: DOMAIN_BLOCK_FAIL,
    domain: domain,
    error: error
  };
};

function unblockDomain(domain) {
  return function (dispatch, getState) {
    dispatch(unblockDomainRequest(domain));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).delete('/api/v1/domain_blocks', { params: { domain: domain } }).then(function () {
      var at_domain = '@' + domain;
      var accounts = getState().get('accounts').filter(function (item) {
        return item.get('acct').endsWith(at_domain);
      }).valueSeq().map(function (item) {
        return item.get('id');
      });
      dispatch(unblockDomainSuccess(domain, accounts));
    }).catch(function (err) {
      dispatch(unblockDomainFail(domain, err));
    });
  };
};

function unblockDomainRequest(domain) {
  return {
    type: DOMAIN_UNBLOCK_REQUEST,
    domain: domain
  };
};

function unblockDomainSuccess(domain, accounts) {
  return {
    type: DOMAIN_UNBLOCK_SUCCESS,
    domain: domain,
    accounts: accounts
  };
};

function unblockDomainFail(domain, error) {
  return {
    type: DOMAIN_UNBLOCK_FAIL,
    domain: domain,
    error: error
  };
};

function fetchDomainBlocks() {
  return function (dispatch, getState) {
    dispatch(fetchDomainBlocksRequest());

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get('/api/v1/domain_blocks').then(function (response) {
      var next = Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* getLinks */])(response).refs.find(function (link) {
        return link.rel === 'next';
      });
      dispatch(fetchDomainBlocksSuccess(response.data, next ? next.uri : null));
    }).catch(function (err) {
      dispatch(fetchDomainBlocksFail(err));
    });
  };
};

function fetchDomainBlocksRequest() {
  return {
    type: DOMAIN_BLOCKS_FETCH_REQUEST
  };
};

function fetchDomainBlocksSuccess(domains, next) {
  return {
    type: DOMAIN_BLOCKS_FETCH_SUCCESS,
    domains: domains,
    next: next
  };
};

function fetchDomainBlocksFail(error) {
  return {
    type: DOMAIN_BLOCKS_FETCH_FAIL,
    error: error
  };
};

function expandDomainBlocks() {
  return function (dispatch, getState) {
    var url = getState().getIn(['domain_lists', 'blocks', 'next']);

    if (url === null) {
      return;
    }

    dispatch(expandDomainBlocksRequest());

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get(url).then(function (response) {
      var next = Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* getLinks */])(response).refs.find(function (link) {
        return link.rel === 'next';
      });
      dispatch(expandDomainBlocksSuccess(response.data, next ? next.uri : null));
    }).catch(function (err) {
      dispatch(expandDomainBlocksFail(err));
    });
  };
};

function expandDomainBlocksRequest() {
  return {
    type: DOMAIN_BLOCKS_EXPAND_REQUEST
  };
};

function expandDomainBlocksSuccess(domains, next) {
  return {
    type: DOMAIN_BLOCKS_EXPAND_SUCCESS,
    domains: domains,
    next: next
  };
};

function expandDomainBlocksFail(error) {
  return {
    type: DOMAIN_BLOCKS_EXPAND_FAIL,
    error: error
  };
};

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

// A mapping of unicode strings to an object containing the filename
// (i.e. the svg filename) and a shortCode intended to be shown
var _require = __webpack_require__(193),
    shortCodesToEmojiData = _require[0],
    skins = _require[1],
    // eslint-disable-line no-unused-vars
categories = _require[2],
    // eslint-disable-line no-unused-vars
short_names = _require[3],
    // eslint-disable-line no-unused-vars
emojisWithoutShortCodes = _require[4];

var _require2 = __webpack_require__(419),
    unicodeToFilename = _require2.unicodeToFilename;

// decompress


var unicodeMapping = {};

function processEmojiMapData(emojiMapData, shortCode) {
  var native = emojiMapData[0],
      filename = emojiMapData[1];

  if (!filename) {
    // filename name can be derived from unicodeToFilename
    filename = unicodeToFilename(native);
  }
  unicodeMapping[native] = {
    shortCode: shortCode,
    filename: filename
  };
}

Object.keys(shortCodesToEmojiData).forEach(function (shortCode) {
  var _shortCodesToEmojiDat = shortCodesToEmojiData[shortCode],
      filenameData = _shortCodesToEmojiDat[0];

  filenameData.forEach(function (emojiMapData) {
    return processEmojiMapData(emojiMapData, shortCode);
  });
});
emojisWithoutShortCodes.forEach(function (emojiMapData) {
  return processEmojiMapData(emojiMapData);
});

module.exports = unicodeMapping;

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HotKeys = __webpack_require__(554);

Object.defineProperty(exports, 'HotKeys', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_HotKeys).default;
  }
});

var _FocusTrap = __webpack_require__(227);

Object.defineProperty(exports, 'FocusTrap', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FocusTrap).default;
  }
});

var _HotKeyMapMixin = __webpack_require__(228);

Object.defineProperty(exports, 'HotKeyMapMixin', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_HotKeyMapMixin).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = changeAlerts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setter__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__registerer__ = __webpack_require__(483);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__setter__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__setter__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__setter__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__setter__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__registerer__["a"]; });





function changeAlerts(path, value) {
  return function (dispatch) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__setter__["f" /* setAlerts */])(path, value));
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__registerer__["b" /* saveSettings */])());
  };
}

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "elephant_ui_plane-e3f2d57c12c376e189c274cbe81af8dd.svg";

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SwipeableViews = __webpack_require__(650);

var _SwipeableViews2 = _interopRequireDefault(_SwipeableViews);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = _SwipeableViews2.default;

/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);





var _class, _temp2;




var emptyComponent = function emptyComponent() {
  return null;
};
var noop = function noop() {};

var Bundle = (_temp2 = _class = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Bundle, _React$PureComponent);

  function Bundle() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Bundle);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
      mod: undefined,
      forceRender: false
    }, _this.load = function (props) {
      var _ref = props || _this.props,
          fetchComponent = _ref.fetchComponent,
          onFetch = _ref.onFetch,
          onFetchSuccess = _ref.onFetchSuccess,
          onFetchFail = _ref.onFetchFail,
          renderDelay = _ref.renderDelay;

      var cachedMod = Bundle.cache.get(fetchComponent);

      onFetch();

      if (cachedMod) {
        _this.setState({ mod: cachedMod.default });
        onFetchSuccess();
        return Promise.resolve();
      }

      _this.setState({ mod: undefined });

      if (renderDelay !== 0) {
        _this.timestamp = new Date();
        _this.timeout = setTimeout(function () {
          return _this.setState({ forceRender: true });
        }, renderDelay);
      }

      return fetchComponent().then(function (mod) {
        Bundle.cache.set(fetchComponent, mod);
        _this.setState({ mod: mod.default });
        onFetchSuccess();
      }).catch(function (error) {
        _this.setState({ mod: null });
        onFetchFail(error);
      });
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Bundle.prototype.componentWillMount = function componentWillMount() {
    this.load(this.props);
  };

  Bundle.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.fetchComponent !== this.props.fetchComponent) {
      this.load(nextProps);
    }
  };

  Bundle.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  };

  Bundle.prototype.render = function render() {
    var _props = this.props,
        Loading = _props.loading,
        Error = _props.error,
        children = _props.children,
        renderDelay = _props.renderDelay;
    var _state = this.state,
        mod = _state.mod,
        forceRender = _state.forceRender;

    var elapsed = this.timestamp ? new Date() - this.timestamp : renderDelay;

    if (mod === undefined) {
      return elapsed >= renderDelay || forceRender ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(Loading, {}) : null;
    }

    if (mod === null) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(Error, {
        onRetry: this.load
      });
    }

    return children(mod);
  };

  return Bundle;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent), _class.defaultProps = {
  loading: emptyComponent,
  error: emptyComponent,
  renderDelay: 0,
  onFetch: noop,
  onFetchSuccess: noop,
  onFetchFail: noop
}, _class.cache = new Map(), _temp2);


/* harmony default export */ __webpack_exports__["a"] = (Bundle);

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim

var global = __webpack_require__(30);
var has = __webpack_require__(36);
var DESCRIPTORS = __webpack_require__(37);
var $export = __webpack_require__(38);
var redefine = __webpack_require__(172);
var META = __webpack_require__(346).KEY;
var $fails = __webpack_require__(46);
var shared = __webpack_require__(110);
var setToStringTag = __webpack_require__(111);
var uid = __webpack_require__(80);
var wks = __webpack_require__(48);
var wksExt = __webpack_require__(112);
var wksDefine = __webpack_require__(113);
var enumKeys = __webpack_require__(347);
var isArray = __webpack_require__(351);
var anObject = __webpack_require__(61);
var toIObject = __webpack_require__(49);
var toPrimitive = __webpack_require__(109);
var createDesc = __webpack_require__(79);
var _create = __webpack_require__(120);
var gOPNExt = __webpack_require__(354);
var $GOPD = __webpack_require__(177);
var $DP = __webpack_require__(39);
var $keys = __webpack_require__(76);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () {
      return dP(this, 'a', { value: 7 }).a;
    }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    }return setSymbolDesc(it, key, D);
  }return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  }return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  }return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(176).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(81).f = $propertyIsEnumerable;
  __webpack_require__(119).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(114)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols =
// 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), j = 0; es6Symbols.length > j;) wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () {
    setter = true;
  },
  useSimple: function () {
    setter = false;
  }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    replacer = args[1];
    if (typeof replacer == 'function') $replacer = replacer;
    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
      if ($replacer) value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(47)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(345);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1:
      return function (a) {
        return fn.call(that, a);
      };
    case 2:
      return function (a, b) {
        return fn.call(that, a, b);
      };
    case 3:
      return function (a, b, c) {
        return fn.call(that, a, b, c);
      };
  }
  return function () /* ...args */{
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(37) && !__webpack_require__(46)(function () {
  return Object.defineProperty(__webpack_require__(171)('div'), 'a', { get: function () {
      return 7;
    } }).a != 7;
});

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(62);
var document = __webpack_require__(30).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(47);

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(36);
var toIObject = __webpack_require__(49);
var arrayIndexOf = __webpack_require__(348)(false);
var IE_PROTO = __webpack_require__(117)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(175);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 175 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(173);
var hiddenKeys = __webpack_require__(118).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(81);
var createDesc = __webpack_require__(79);
var toIObject = __webpack_require__(49);
var toPrimitive = __webpack_require__(109);
var has = __webpack_require__(36);
var IE8_DOM_DEFINE = __webpack_require__(170);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(37) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) {/* empty */}
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(355), __esModule: true };

/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var LIBRARY = __webpack_require__(114);
var $export = __webpack_require__(38);
var redefine = __webpack_require__(172);
var hide = __webpack_require__(47);
var has = __webpack_require__(36);
var Iterators = __webpack_require__(121);
var $iterCreate = __webpack_require__(363);
var setToStringTag = __webpack_require__(111);
var getPrototypeOf = __webpack_require__(180);
var ITERATOR = __webpack_require__(48)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () {
  return this;
};

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS:
        return function keys() {
          return new Constructor(this, kind);
        };
      case VALUES:
        return function values() {
          return new Constructor(this, kind);
        };
    }return function entries() {
      return new Constructor(this, kind);
    };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() {
      return $native.call(this);
    };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(36);
var toObject = __webpack_require__(106);
var IE_PROTO = __webpack_require__(117)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  }return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__ = __webpack_require__(181);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}








var hotReloadingVersion = 0;
var dummyState = {};
function noop() {}
function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);
        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };

  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory) {
  var _contextTypes, _childContextTypes;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$getDisplayName = _ref.getDisplayName,
      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
    return 'ConnectAdvanced(' + name + ')';
  } : _ref$getDisplayName,
      _ref$methodName = _ref.methodName,
      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
      _ref$renderCountProp = _ref.renderCountProp,
      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
      _ref$storeKey = _ref.storeKey,
      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
      _ref$withRef = _ref.withRef,
      withRef = _ref$withRef === undefined ? false : _ref$withRef,
      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;

  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_4__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);

  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);

        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));

        _this.initSelector();
        _this.initSubscription();
        return _this;
      }

      Connect.prototype.getChildContext = function getChildContext() {
        var _ref2;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return;

        // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.
        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_1_invariant___default()(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
        return this.wrappedInstance;
      };

      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      Connect.prototype.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      Connect.prototype.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return;

        // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_3__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this));

        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.
        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      Connect.prototype.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      Connect.prototype.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
        // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad
        var withExtras = _extends({}, props);
        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      Connect.prototype.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector();

          // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.
          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }
          this.initSubscription();
          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_0_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
};

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(187);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* unused harmony reexport combineReducers */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_symbol_observable__);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable___default.a] = observable, _ref2;
}

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(391);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(190);


function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }
    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
}

// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}

// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    
function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    };

    // allow detectFactoryAndVerify to get ownProps
    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);

      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(124);



function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
  }
}

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (action) {
  return action && action.type === '@@redux/INIT' ? 'initialState argument passed to createStore' : 'previous state received by the reducer';
};

module.exports = exports['default'];
//# sourceMappingURL=getStateName.js.map

/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DROPDOWN_MENU_OPEN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DROPDOWN_MENU_CLOSE; });
/* harmony export (immutable) */ __webpack_exports__["d"] = openDropdownMenu;
/* harmony export (immutable) */ __webpack_exports__["c"] = closeDropdownMenu;
var DROPDOWN_MENU_OPEN = 'DROPDOWN_MENU_OPEN';
var DROPDOWN_MENU_CLOSE = 'DROPDOWN_MENU_CLOSE';

function openDropdownMenu(id, placement) {
  return { type: DROPDOWN_MENU_OPEN, id: id, placement: placement };
}

function closeDropdownMenu(id) {
  return { type: DROPDOWN_MENU_CLOSE, id: id };
}

/***/ }),
/* 193 */
/***/ (function(module, exports) {

// this file was prevaled
// http://www.unicode.org/Public/emoji/5.0/emoji-test.txt
// This file contains the compressed version of the emoji data from
// both emoji_map.json and from emoji-mart's emojiIndex and data objects.
// It's designed to be emitted in an array format to take up less space
// over the wire.

module.exports = [{ "100": [[["💯"]], ["💯", [], "100,hundred,points,symbol,score,perfect,numbers,century,exam,quiz,test,pass"]], "1234": [[["🔢"]], ["🔢", [], "1234,input,symbol,for,numbers,blue-square"]], "grinning": [[["😀"]], ["😀", [], "grinning,face,smile,happy,joy,:d,grin"]], "grin": [[["😁"]], ["😁", [], "grin,grinning,face,with,smiling,eyes,happy,smile,joy,kawaii"]], "joy": [[["😂"]], ["😂", [], "joy,face,with,tears,of,cry,weep,happy,happytears,haha"]], "rolling_on_the_floor_laughing": [[["🤣"]], ["🤣", [], "rolling,on,the,floor,laughing"]], "smiley": [[["😃"]], ["😃", [], "smiley,smiling,face,with,open,mouth,happy,joy,haha,:d,:),smile,funny,=),=-)"]], "smile": [[["😄"]], ["😄", [], "smile,smiling,face,with,open,mouth,and,eyes,happy,joy,funny,haha,laugh,like,:d,:),c:,:-d"]], "sweat_smile": [[["😅"]], ["😅", [], "sweat,smile,smiling,face,with,open,mouth,and,cold,hot,happy,laugh,relief"]], "laughing": [[["😆"]], ["😆", ["satisfied"], "laughing,satisfied,smiling,face,with,open,mouth,and,tightly,closed,eyes,happy,joy,lol,haha,glad,xd,laugh,:>,:->"]], "wink": [[["😉"]], ["😉", [], "wink,winking,face,happy,mischievous,secret,;),smile,eye,;-)"]], "blush": [[["😊"]], ["😊", [], "blush,smiling,face,with,eyes,smile,happy,flushed,crush,embarrassed,shy,joy"]],
  "yum": [[["😋"]], ["😋", [], "yum,face,savouring,delicious,food,happy,joy,tongue,smile,silly,yummy,nom"]], "sunglasses": [[["😎"]], ["😎", [], "sunglasses,smiling,face,with,cool,smile,summer,beach,sunglass,8)"]], "heart_eyes": [[["😍"]], ["😍", [], "heart,eyes,smiling,face,with,shaped,love,like,affection,valentines,infatuation,crush"]], "kissing_heart": [[["😘"]], ["😘", [], "kissing,heart,face,throwing,a,kiss,love,like,affection,valentines,infatuation,:*,:-*"]], "kissing": [[["😗"]], ["😗", [], "kissing,face,love,like,3,valentines,infatuation,kiss"]], "kissing_smiling_eyes": [[["😙"]], ["😙", [], "kissing,smiling,eyes,face,with,affection,valentines,infatuation,kiss"]], "kissing_closed_eyes": [[["😚"]], ["😚", [], "kissing,closed,eyes,face,with,love,like,affection,valentines,infatuation,kiss"]], "relaxed": [[["☺"], ["☺️", "263a"]], ["☺️", [], "relaxed,white,smiling,face,blush,massage,happiness", "263A-FE0F"]], "slightly_smiling_face": [[["🙂"]], ["🙂", [], "slightly,smiling,face,smile,:),(:,:-)"]], "hugging_face": [[["🤗"]], ["🤗", [], "hugging,face"]], "star-struck": [[["🤩"]], ["🤩", ["grinning_face_with_star_eyes"], "star,struck,grinning,face,with,eyes"]], "thinking_face": [[["🤔"]], ["🤔", [], "thinking,face"]],
  "face_with_raised_eyebrow": [[["🤨"]], ["🤨", ["face_with_one_eyebrow_raised"], "face,with,raised,eyebrow,one"]], "neutral_face": [[["😐"]], ["😐", [], "neutral,face,indifference,meh,:|,:-|"]], "expressionless": [[["😑"]], ["😑", [], "expressionless,face,indifferent,-_-,meh,deadpan"]], "no_mouth": [[["😶"]], ["😶", [], "no,mouth,face,without,hellokitty"]], "face_with_rolling_eyes": [[["🙄"]], ["🙄", [], "face,with,rolling,eyes"]], "smirk": [[["😏"]], ["😏", [], "smirk,smirking,face,smile,mean,prank,smug,sarcasm"]], "persevere": [[["😣"]], ["😣", [], "persevere,persevering,face,sick,no,upset,oops"]], "disappointed_relieved": [[["😥"]], ["😥", [], "disappointed,relieved,but,face,phew,sweat,nervous"]], "open_mouth": [[["😮"]], ["😮", [], "open,mouth,face,with,surprise,impressed,wow,whoa,:o,:-o"]], "zipper_mouth_face": [[["🤐"]], ["🤐", [], "zipper,mouth,face,sealed,secret"]], "hushed": [[["😯"]], ["😯", [], "hushed,face,woo,shh"]], "sleepy": [[["😪"]], ["😪", [], "sleepy,face,tired,rest,nap"]], "tired_face": [[["😫"]], ["😫", [], "tired,face,sick,whine,upset,frustrated"]], "sleeping": [[["😴"]], ["😴", [], "sleeping,face,tired,sleepy,night,zzz"]], "relieved": [[["😌"]], ["😌", [], "relieved,face,relaxed,phew,massage,happiness"]], "stuck_out_tongue": [[["😛"]], ["😛", [], "stuck,out,tongue,face,with,prank,childish,playful,mischievous,smile,:p,:-p,:b,:-b"]], "stuck_out_tongue_winking_eye": [[["😜"]], ["😜", [], "stuck,out,tongue,winking,eye,face,with,and,prank,childish,playful,mischievous,smile,wink,;p,;-p,;b,;-b"]], "stuck_out_tongue_closed_eyes": [[["😝"]], ["😝", [], "stuck,out,tongue,closed,eyes,face,with,and,tightly,prank,playful,mischievous,smile"]], "drooling_face": [[["🤤"]], ["🤤", [], "drooling,face"]], "unamused": [[["😒"]], ["😒", [], "unamused,face,indifference,bored,straight face,serious,sarcasm"]], "sweat": [[["😓"]], ["😓", [], "sweat,face,with,cold,hot,sad,tired,exercise"]], "pensive": [[["😔"]], ["😔", [], "pensive,face,sad,depressed,upset"]], "confused": [[["😕"]], ["😕", [], "confused,face,indifference,huh,weird,hmmm,:/,:\\,:-\\,:-/"]], "upside_down_face": [[["🙃"]], ["🙃", [], "upside,down,face,flipped,silly,smile"]], "money_mouth_face": [[["🤑"]], ["🤑", [], "money,mouth,face,rich,dollar"]], "astonished": [[["😲"]], ["😲", [], "astonished,face,xox,surprised,poisoned"]], "white_frowning_face": [[["☹"], ["☹️", "2639"]], ["☹️", [], "white,frowning,face", "2639-FE0F"]], "slightly_frowning_face": [[["🙁"]], ["🙁", [], "slightly,frowning,face,disappointed,sad,upset"]], "confounded": [[["😖"]], ["😖", [], "confounded,face,confused,sick,unwell,oops,:s"]], "disappointed": [[["😞"]], ["😞", [], "disappointed,face,sad,upset,depressed,:(,):,:-("]], "worried": [[["😟"]], ["😟", [], "worried,face,concern,nervous,:("]], "triumph": [[["😤"]], ["😤", [], "triumph,face,with,look,of,gas,phew,proud,pride"]], "cry": [[["😢"]], ["😢", [], "cry,crying,face,tears,sad,depressed,upset,:'("]], "sob": [[["😭"]], ["😭", [], "sob,loudly,crying,face,cry,tears,sad,upset,depressed"]], "frowning": [[["😦"]], ["😦", [], "frowning,face,with,open,mouth,aw,what"]], "anguished": [[["😧"]], ["😧", [], "anguished,face,stunned,nervous,d:"]], "fearful": [[["😨"]], ["😨", [], "fearful,face,scared,terrified,nervous,oops,huh"]], "weary": [[["😩"]], ["😩", [], "weary,face,tired,sleepy,sad,frustrated,upset"]], "exploding_head": [[["🤯"]], ["🤯", ["shocked_face_with_exploding_head"], "exploding,head,shocked,face,with"]], "grimacing": [[["😬"]], ["😬", [], "grimacing,face,grimace,teeth"]], "cold_sweat": [[["😰"]], ["😰", [], "cold,sweat,face,with,open,mouth,and,nervous"]], "scream": [[["😱"]], ["😱", [], "scream,face,screaming,in,fear,munch,scared,omg"]], "flushed": [[["😳"]], ["😳", [], "flushed,face,blush,shy,flattered"]], "zany_face": [[["🤪"]], ["🤪", ["grinning_face_with_one_large_and_one_small_eye"], "zany,face,grinning,with,one,large,and,small,eye"]], "dizzy_face": [[["😵"]], ["😵", [], "dizzy,face,spent,unconscious,xox"]], "rage": [[["😡"]], ["😡", [], "rage,pouting,face,angry,mad,hate,despise"]], "angry": [[["😠"]], ["😠", [], "angry,face,mad,annoyed,frustrated,>:(,>:-("]], "face_with_symbols_on_mouth": [[["🤬"]], ["🤬", ["serious_face_with_symbols_covering_mouth"], "face,with,symbols,on,mouth,serious,covering"]], "mask": [[["😷"]], ["😷", [], "mask,face,with,medical,sick,ill,disease"]], "face_with_thermometer": [[["🤒"]], ["🤒", [], "face,with,thermometer,sick,temperature,cold,fever"]], "face_with_head_bandage": [[["🤕"]], ["🤕", [], "face,with,head,bandage,injured,clumsy,hurt"]], "nauseated_face": [[["🤢"]], ["🤢", [], "nauseated,face,vomit,gross,green,sick,throw up,ill"]], "face_vomiting": [[["🤮"]], ["🤮", ["face_with_open_mouth_vomiting"], "face,vomiting,with,open,mouth"]], "sneezing_face": [[["🤧"]], ["🤧", [], "sneezing,face,gesundheit,sneeze,sick,allergy"]], "innocent": [[["😇"]], ["😇", [], "innocent,smiling,face,with,halo,angel,heaven"]], "face_with_cowboy_hat": [[["🤠"]], ["🤠", [], "face,with,cowboy,hat"]], "clown_face": [[["🤡"]], ["🤡", [], "clown,face"]], "lying_face": [[["🤥"]], ["🤥", [], "lying,face,lie,pinocchio"]], "shushing_face": [[["🤫"]], ["🤫", ["face_with_finger_covering_closed_lips"], "shushing,face,with,finger,covering,closed,lips"]], "face_with_hand_over_mouth": [[["🤭"]], ["🤭", ["smiling_face_with_smiling_eyes_and_hand_covering_mouth"], "face,with,hand,over,mouth,smiling,eyes,and,covering"]], "face_with_monocle": [[["🧐"]], ["🧐", [], "face,with,monocle"]], "nerd_face": [[["🤓"]], ["🤓", [], "nerd,face,nerdy,geek,dork"]], "smiling_imp": [[["😈"]], ["😈", [], "smiling,imp,face,with,horns,devil"]], "imp": [[["👿"]], ["👿", [], "imp,devil,angry,horns"]], "japanese_ogre": [[["👹"]], ["👹", [], "japanese,ogre,monster,red,mask,halloween,scary,creepy,devil,demon"]], "japanese_goblin": [[["👺"]], ["👺", [], "japanese,goblin,red,evil,mask,monster,scary,creepy"]], "skull": [[["💀"]], ["💀", [], "skull,dead,skeleton,creepy,death"]], "skull_and_crossbones": [[["☠"], ["☠️", "2620"]], ["☠️", [], "skull,and,crossbones,poison,danger,deadly,scary,death,pirate,evil", "2620-FE0F"]], "ghost": [[["👻"]], ["👻", [], "ghost,halloween,spooky,scary"]], "alien": [[["👽"]], ["👽", [], "alien,extraterrestrial,ufo,paul,weird,outer_space"]], "space_invader": [[["👾"]], ["👾", [], "space,invader,alien,monster,game,arcade,play"]], "robot_face": [[["🤖"]], ["🤖", [], "robot,face"]], "hankey": [[["💩"]], ["💩", ["poop", "shit"], "hankey,poop,shit,pile,of,poo"]], "smiley_cat": [[["😺"]], ["😺", [], "smiley,cat,smiling,face,with,open,mouth,animal,cats,happy,smile"]], "smile_cat": [[["😸"]], ["😸", [], "smile,cat,grinning,face,with,smiling,eyes,animal,cats"]], "joy_cat": [[["😹"]], ["😹", [], "joy,cat,face,with,tears,of,animal,cats,haha,happy"]], "heart_eyes_cat": [[["😻"]], ["😻", [], "heart,eyes,cat,smiling,face,with,shaped,animal,love,like,affection,cats,valentines"]], "smirk_cat": [[["😼"]], ["😼", [], "smirk,cat,face,with,wry,smile,animal,cats"]], "kissing_cat": [[["😽"]], ["😽", [], "kissing,cat,face,with,closed,eyes,animal,cats,kiss"]], "scream_cat": [[["🙀"]], ["🙀", [], "scream,cat,weary,face,animal,cats,munch,scared"]], "crying_cat_face": [[["😿"]], ["😿", [], "crying,cat,face,animal,tears,weep,sad,cats,upset,cry"]], "pouting_cat": [[["😾"]], ["😾", [], "pouting,cat,face,animal,cats"]], "see_no_evil": [[["🙈"]], ["🙈", [], "see,no,evil,monkey,animal,nature,haha"]], "hear_no_evil": [[["🙉"]], ["🙉", [], "hear,no,evil,monkey,animal,nature"]], "speak_no_evil": [[["🙊"]], ["🙊", [], "speak,no,evil,monkey,animal,nature,omg"]], "baby": [[["👶"], ["👶🏻"], ["👶🏼"], ["👶🏽"], ["👶🏾"], ["👶🏿"]], ["👶", [], "baby,child,boy,girl,toddler"]], "child": [[["🧒"], ["🧒🏻"], ["🧒🏼"], ["🧒🏽"], ["🧒🏾"], ["🧒🏿"]], ["🧒", [], "child"]], "boy": [[["👦"], ["👦🏻"], ["👦🏼"], ["👦🏽"], ["👦🏾"], ["👦🏿"]], ["👦", [], "boy,man,male,guy,teenager"]], "girl": [[["👧"], ["👧🏻"], ["👧🏼"], ["👧🏽"], ["👧🏾"], ["👧🏿"]], ["👧", [], "girl,female,woman,teenager"]], "adult": [[["🧑"], ["🧑🏻"], ["🧑🏼"], ["🧑🏽"], ["🧑🏾"], ["🧑🏿"]], ["🧑", [], "adult"]], "man": [[["👨"], ["👨🏻"], ["👨🏼"], ["👨🏽"], ["👨🏾"], ["👨🏿"]], ["👨", [], "man,mustache,father,dad,guy,classy,sir,moustache"]], "woman": [[["👩"], ["👩🏻"], ["👩🏼"], ["👩🏽"], ["👩🏾"], ["👩🏿"]], ["👩", [], "woman,female,girls,lady"]], "older_adult": [[["🧓"], ["🧓🏻"], ["🧓🏼"], ["🧓🏽"], ["🧓🏾"], ["🧓🏿"]], ["🧓", [], "older,adult"]], "older_man": [[["👴"], ["👴🏻"], ["👴🏼"], ["👴🏽"], ["👴🏾"], ["👴🏿"]], ["👴", [], "older,man,human,male,men,old,elder,senior"]], "older_woman": [[["👵"], ["👵🏻"], ["👵🏼"], ["👵🏽"], ["👵🏾"], ["👵🏿"]], ["👵", [], "older,woman,human,female,women,lady,old,elder,senior"]], "cop": [[["👮"], ["👮🏻"], ["👮🏼"], ["👮🏽"], ["👮🏾"], ["👮🏿"]], ["👮", [], "cop,police,officer"]], "sleuth_or_spy": [[["🕵"], ["🕵️", "1f575"], ["🕵🏻"], ["🕵🏼"], ["🕵🏽"], ["🕵🏾"], ["🕵🏿"]], ["🕵️", [], "sleuth,or,spy"]], "guardsman": [[["💂"], ["💂🏻"], ["💂🏼"], ["💂🏽"], ["💂🏾"], ["💂🏿"]], ["💂", [], "guardsman,uk,gb,british,male,guy,royal"]], "construction_worker": [[["👷"], ["👷🏻"], ["👷🏼"], ["👷🏽"], ["👷🏾"], ["👷🏿"]], ["👷", [], "construction,worker"]], "prince": [[["🤴"], ["🤴🏻"], ["🤴🏼"], ["🤴🏽"], ["🤴🏾"], ["🤴🏿"]], ["🤴", [], "prince,boy,man,male,crown,royal,king"]], "princess": [[["👸"], ["👸🏻"], ["👸🏼"], ["👸🏽"], ["👸🏾"], ["👸🏿"]], ["👸", [], "princess,girl,woman,female,blond,crown,royal,queen"]], "man_with_turban": [[["👳"], ["👳🏻"], ["👳🏼"], ["👳🏽"], ["👳🏾"], ["👳🏿"]], ["👳", [], "man,with,turban,male,indian,hinduism,arabs"]], "man_with_gua_pi_mao": [[["👲"], ["👲🏻"], ["👲🏼"], ["👲🏽"], ["👲🏾"], ["👲🏿"]], ["👲", [], "man,with,gua,pi,mao,male,boy,chinese"]], "person_with_headscarf": [[["🧕"], ["🧕🏻"], ["🧕🏼"], ["🧕🏽"], ["🧕🏾"], ["🧕🏿"]], ["🧕", [], "person,with,headscarf"]], "bearded_person": [[["🧔"], ["🧔🏻"], ["🧔🏼"], ["🧔🏽"], ["🧔🏾"], ["🧔🏿"]], ["🧔", [], "bearded,person"]], "person_with_blond_hair": [[["👱"], ["👱🏻"], ["👱🏼"], ["👱🏽"], ["👱🏾"], ["👱🏿"]], ["👱", [], "person,with,blond,hair"]], "man_in_tuxedo": [[["🤵"], ["🤵🏻"], ["🤵🏼"], ["🤵🏽"], ["🤵🏾"], ["🤵🏿"]], ["🤵", [], "man,in,tuxedo,couple,marriage,wedding,groom"]], "bride_with_veil": [[["👰"], ["👰🏻"], ["👰🏼"], ["👰🏽"], ["👰🏾"], ["👰🏿"]], ["👰", [], "bride,with,veil,couple,marriage,wedding,woman"]], "pregnant_woman": [[["🤰"], ["🤰🏻"], ["🤰🏼"], ["🤰🏽"], ["🤰🏾"], ["🤰🏿"]], ["🤰", [], "pregnant,woman,baby"]], "breast-feeding": [[["🤱"], ["🤱🏻"], ["🤱🏼"], ["🤱🏽"], ["🤱🏾"], ["🤱🏿"]], ["🤱", [], "breast,feeding"]], "angel": [[["👼"], ["👼🏻"], ["👼🏼"], ["👼🏽"], ["👼🏾"], ["👼🏿"]], ["👼", [], "angel,baby,heaven,wings,halo"]], "santa": [[["🎅"], ["🎅🏻"], ["🎅🏼"], ["🎅🏽"], ["🎅🏾"], ["🎅🏿"]], ["🎅", [], "santa,father,christmas,festival,man,male,xmas,father christmas"]], "mrs_claus": [[["🤶"], ["🤶🏻"], ["🤶🏼"], ["🤶🏽"], ["🤶🏾"], ["🤶🏿"]], ["🤶", ["mother_christmas"], "mrs,claus,mother,christmas,woman,female,xmas,mother christmas"]], "mage": [[["🧙"], ["🧙🏻"], ["🧙🏼"], ["🧙🏽"], ["🧙🏾"], ["🧙🏿"]], ["🧙", [], "mage"]], "fairy": [[["🧚"], ["🧚🏻"], ["🧚🏼"], ["🧚🏽"], ["🧚🏾"], ["🧚🏿"]], ["🧚", [], "fairy"]], "vampire": [[["🧛"], ["🧛🏻"], ["🧛🏼"], ["🧛🏽"], ["🧛🏾"], ["🧛🏿"]], ["🧛", [], "vampire"]], "merperson": [[["🧜"], ["🧜🏻"], ["🧜🏼"], ["🧜🏽"], ["🧜🏾"], ["🧜🏿"]], ["🧜", [], "merperson"]], "elf": [[["🧝"], ["🧝🏻"], ["🧝🏼"], ["🧝🏽"], ["🧝🏾"], ["🧝🏿"]], ["🧝", [], "elf"]], "genie": [[["🧞"]], ["🧞", [], "genie"]], "zombie": [[["🧟"]], ["🧟", [], "zombie"]], "person_frowning": [[["🙍"], ["🙍🏻"], ["🙍🏼"], ["🙍🏽"], ["🙍🏾"], ["🙍🏿"]], ["🙍", [], "person,frowning"]], "person_with_pouting_face": [[["🙎"], ["🙎🏻"], ["🙎🏼"], ["🙎🏽"], ["🙎🏾"], ["🙎🏿"]], ["🙎", [], "person,with,pouting,face"]], "no_good": [[["🙅"], ["🙅🏻"], ["🙅🏼"], ["🙅🏽"], ["🙅🏾"], ["🙅🏿"]], ["🙅", [], "no,good,face,with,gesture"]], "ok_woman": [[["🙆"], ["🙆🏻"], ["🙆🏼"], ["🙆🏽"], ["🙆🏾"], ["🙆🏿"]], ["🙆", [], "ok,woman,face,with,gesture,women,girl,female,pink,human"]], "information_desk_person": [[["💁"], ["💁🏻"], ["💁🏼"], ["💁🏽"], ["💁🏾"], ["💁🏿"]], ["💁", [], "information,desk,person"]], "raising_hand": [[["🙋"], ["🙋🏻"], ["🙋🏼"], ["🙋🏽"], ["🙋🏾"], ["🙋🏿"]], ["🙋", [], "raising,hand,happy,person,one"]], "bow": [[["🙇"], ["🙇🏻"], ["🙇🏼"], ["🙇🏽"], ["🙇🏾"], ["🙇🏿"]], ["🙇", [], "bow,person,bowing,deeply"]], "face_palm": [[["🤦"], ["🤦🏻"], ["🤦🏼"], ["🤦🏽"], ["🤦🏾"], ["🤦🏿"]], ["🤦", [], "face,palm"]], "shrug": [[["🤷"], ["🤷🏻"], ["🤷🏼"], ["🤷🏽"], ["🤷🏾"], ["🤷🏿"]], ["🤷", [], "shrug"]], "massage": [[["💆"], ["💆🏻"], ["💆🏼"], ["💆🏽"], ["💆🏾"], ["💆🏿"]], ["💆", [], "massage,face"]], "haircut": [[["💇"], ["💇🏻"], ["💇🏼"], ["💇🏽"], ["💇🏾"], ["💇🏿"]], ["💇", [], "haircut"]], "walking": [[["🚶"], ["🚶🏻"], ["🚶🏼"], ["🚶🏽"], ["🚶🏾"], ["🚶🏿"]], ["🚶", [], "walking,pedestrian"]], "runner": [[["🏃"], ["🏃🏻"], ["🏃🏼"], ["🏃🏽"], ["🏃🏾"], ["🏃🏿"]], ["🏃", ["running"], "runner,running"]], "dancer": [[["💃"], ["💃🏻"], ["💃🏼"], ["💃🏽"], ["💃🏾"], ["💃🏿"]], ["💃", [], "dancer,female,girl,woman,fun"]], "man_dancing": [[["🕺"], ["🕺🏻"], ["🕺🏼"], ["🕺🏽"], ["🕺🏾"], ["🕺🏿"]], ["🕺", [], "man,dancing,male,boy,fun,dancer"]], "dancers": [[["👯"]], ["👯", [], "dancers,woman,with,bunny,ears"]], "person_in_steamy_room": [[["🧖"], ["🧖🏻"], ["🧖🏼"], ["🧖🏽"], ["🧖🏾"], ["🧖🏿"]], ["🧖", [], "person,in,steamy,room"]], "person_climbing": [[["🧗"], ["🧗🏻"], ["🧗🏼"], ["🧗🏽"], ["🧗🏾"], ["🧗🏿"]], ["🧗", [], "person,climbing"]], "person_in_lotus_position": [[["🧘"], ["🧘🏻"], ["🧘🏼"], ["🧘🏽"], ["🧘🏾"], ["🧘🏿"]], ["🧘", [], "person,in,lotus,position"]], "bath": [[["🛀"], ["🛀🏻"], ["🛀🏼"], ["🛀🏽"], ["🛀🏾"], ["🛀🏿"]], ["🛀", [], "bath,clean,shower,bathroom"]], "sleeping_accommodation": [[["🛌"], ["🛌🏻"], ["🛌🏼"], ["🛌🏽"], ["🛌🏾"], ["🛌🏿"]], ["🛌", [], "sleeping,accommodation"]], "man_in_business_suit_levitating": [[["🕴"], ["🕴️", "1f574"], ["🕴🏻"], ["🕴🏼"], ["🕴🏽"], ["🕴🏾"], ["🕴🏿"]], ["🕴️", [], "man,in,business,suit,levitating"]], "speaking_head_in_silhouette": [[["🗣"], ["🗣️", "1f5e3"]], ["🗣️", [], "speaking,head,in,silhouette"]], "bust_in_silhouette": [[["👤"]], ["👤", [], "bust,in,silhouette,user,person,human"]], "busts_in_silhouette": [[["👥"]], ["👥", [], "busts,in,silhouette,user,person,human,group,team"]], "fencer": [[["🤺"]], ["🤺", [], "fencer"]], "horse_racing": [[["🏇"], ["🏇🏻"], ["🏇🏼"], ["🏇🏽"], ["🏇🏾"], ["🏇🏿"]], ["🏇", [], "horse,racing,animal,betting,competition,gambling,luck"]], "skier": [[["⛷"], ["⛷️", "26f7"]], ["⛷️", [], "skier,sports,winter,snow", "26F7-FE0F"]], "snowboarder": [[["🏂"], ["🏂🏻"], ["🏂🏼"], ["🏂🏽"], ["🏂🏾"], ["🏂🏿"]], ["🏂", [], "snowboarder,sports,winter"]], "golfer": [[["🏌"], ["🏌️", "1f3cc"], ["🏌🏻"], ["🏌🏼"], ["🏌🏽"], ["🏌🏾"], ["🏌🏿"]], ["🏌️", [], "golfer"]], "surfer": [[["🏄"], ["🏄🏻"], ["🏄🏼"], ["🏄🏽"], ["🏄🏾"], ["🏄🏿"]], ["🏄", [], "surfer"]], "rowboat": [[["🚣"], ["🚣🏻"], ["🚣🏼"], ["🚣🏽"], ["🚣🏾"], ["🚣🏿"]], ["🚣", [], "rowboat"]], "swimmer": [[["🏊"], ["🏊🏻"], ["🏊🏼"], ["🏊🏽"], ["🏊🏾"], ["🏊🏿"]], ["🏊", [], "swimmer"]], "person_with_ball": [[["⛹"], ["⛹️", "26f9"], ["⛹🏻"], ["⛹🏼"], ["⛹🏽"], ["⛹🏾"], ["⛹🏿"]], ["⛹️", [], "person,with,ball", "26F9-FE0F"]], "weight_lifter": [[["🏋"], ["🏋️", "1f3cb"], ["🏋🏻"], ["🏋🏼"], ["🏋🏽"], ["🏋🏾"], ["🏋🏿"]], ["🏋️", [], "weight,lifter"]], "bicyclist": [[["🚴"], ["🚴🏻"], ["🚴🏼"], ["🚴🏽"], ["🚴🏾"], ["🚴🏿"]], ["🚴", [], "bicyclist"]], "mountain_bicyclist": [[["🚵"], ["🚵🏻"], ["🚵🏼"], ["🚵🏽"], ["🚵🏾"], ["🚵🏿"]], ["🚵", [], "mountain,bicyclist"]], "racing_car": [[["🏎"], ["🏎️", "1f3ce"]], ["🏎️", [], "racing,car,sports,race,fast,formula,f1"]], "racing_motorcycle": [[["🏍"], ["🏍️", "1f3cd"]], ["🏍️", [], "racing,motorcycle"]], "person_doing_cartwheel": [[["🤸"], ["🤸🏻"], ["🤸🏼"], ["🤸🏽"], ["🤸🏾"], ["🤸🏿"]], ["🤸", [], "person,doing,cartwheel"]], "wrestlers": [[["🤼"]], ["🤼", [], "wrestlers"]], "water_polo": [[["🤽"], ["🤽🏻"], ["🤽🏼"], ["🤽🏽"], ["🤽🏾"], ["🤽🏿"]], ["🤽", [], "water,polo"]], "handball": [[["🤾"], ["🤾🏻"], ["🤾🏼"], ["🤾🏽"], ["🤾🏾"], ["🤾🏿"]], ["🤾", [], "handball"]], "juggling": [[["🤹"], ["🤹🏻"], ["🤹🏼"], ["🤹🏽"], ["🤹🏾"], ["🤹🏿"]], ["🤹", [], "juggling"]], "couple": [[["👫"]], ["👫", ["man_and_woman_holding_hands"], "couple,man,and,woman,holding,hands,pair,people,human,love,date,dating,like,affection,valentines,marriage"]], "two_men_holding_hands": [[["👬"]], ["👬", [], "two,men,holding,hands,pair,couple,love,like,bromance,friendship,people,human"]], "two_women_holding_hands": [[["👭"]], ["👭", [], "two,women,holding,hands,pair,friendship,couple,love,like,female,people,human"]], "couplekiss": [[["💏"]], ["💏", [], "couplekiss,kiss"]], "couple_with_heart": [[["💑"]], ["💑", [], "couple,with,heart"]], "family": [[["👪"]], ["👨‍👩‍👦", ["man-woman-boy"], "family,man,woman,boy", "1F46A"]], "selfie": [[["🤳"], ["🤳🏻"], ["🤳🏼"], ["🤳🏽"], ["🤳🏾"], ["🤳🏿"]], ["🤳", [], "selfie,camera,phone"]], "muscle": [[["💪"], ["💪🏻"], ["💪🏼"], ["💪🏽"], ["💪🏾"], ["💪🏿"]], ["💪", [], "muscle,flexed,biceps,arm,flex,hand,summer,strong"]], "point_left": [[["👈"], ["👈🏻"], ["👈🏼"], ["👈🏽"], ["👈🏾"], ["👈🏿"]], ["👈", [], "point,left,white,pointing,backhand,index,direction,fingers,hand"]], "point_right": [[["👉"], ["👉🏻"], ["👉🏼"], ["👉🏽"], ["👉🏾"], ["👉🏿"]], ["👉", [], "point,right,white,pointing,backhand,index,fingers,hand,direction"]], "point_up": [[["☝"], ["☝️", "261d"], ["☝🏻"], ["☝🏼"], ["☝🏽"], ["☝🏾"], ["☝🏿"]], ["☝️", [], "point,up,white,pointing,index,hand,fingers,direction", "261D-FE0F"]], "point_up_2": [[["👆"], ["👆🏻"], ["👆🏼"], ["👆🏽"], ["👆🏾"], ["👆🏿"]], ["👆", [], "point,up,2,white,pointing,backhand,index,fingers,hand,direction"]], "middle_finger": [[["🖕"], ["🖕🏻"], ["🖕🏼"], ["🖕🏽"], ["🖕🏾"], ["🖕🏿"]], ["🖕", ["reversed_hand_with_middle_finger_extended"], "middle,finger,reversed,hand,with,extended"]], "point_down": [[["👇"], ["👇🏻"], ["👇🏼"], ["👇🏽"], ["👇🏾"], ["👇🏿"]], ["👇", [], "point,down,white,pointing,backhand,index,fingers,hand,direction"]], "v": [[["✌"], ["✌️", "270c"], ["✌🏻"], ["✌🏼"], ["✌🏽"], ["✌🏾"], ["✌🏿"]], ["✌️", [], "v,victory,hand,fingers,ohyeah,peace,two", "270C-FE0F"]], "crossed_fingers": [[["🤞"], ["🤞🏻"], ["🤞🏼"], ["🤞🏽"], ["🤞🏾"], ["🤞🏿"]], ["🤞", ["hand_with_index_and_middle_fingers_crossed"], "crossed,fingers,hand,with,index,and,middle,good,lucky"]], "spock-hand": [[["🖖"], ["🖖🏻"], ["🖖🏼"], ["🖖🏽"], ["🖖🏾"], ["🖖🏿"]], ["🖖", [], "spock,hand,raised,with,part,between,middle,and,ring,fingers"]], "the_horns": [[["🤘"], ["🤘🏻"], ["🤘🏼"], ["🤘🏽"], ["🤘🏾"], ["🤘🏿"]], ["🤘", ["sign_of_the_horns"], "the,horns,sign,of"]], "call_me_hand": [[["🤙"], ["🤙🏻"], ["🤙🏼"], ["🤙🏽"], ["🤙🏾"], ["🤙🏿"]], ["🤙", [], "call,me,hand,hands,gesture"]], "raised_hand_with_fingers_splayed": [[["🖐"], ["🖐️", "1f590"], ["🖐🏻"], ["🖐🏼"], ["🖐🏽"], ["🖐🏾"], ["🖐🏿"]], ["🖐️", [], "raised,hand,with,fingers,splayed,palm"]], "hand": [[["✋"], ["✋🏻"], ["✋🏼"], ["✋🏽"], ["✋🏾"], ["✋🏿"]], ["✋", ["raised_hand"], "hand,raised"]], "ok_hand": [[["👌"], ["👌🏻"], ["👌🏼"], ["👌🏽"], ["👌🏾"], ["👌🏿"]], ["👌", [], "ok,hand,sign,fingers,limbs,perfect,okay"]], "+1": [[["👍"], ["👍🏻"], ["👍🏼"], ["👍🏽"], ["👍🏾"], ["👍🏿"]], ["👍", ["thumbsup"], "+1,thumbsup,thumbs,up,sign,yes,awesome,good,agree,accept,cool,hand,like"]], "-1": [[["👎"], ["👎🏻"], ["👎🏼"], ["👎🏽"], ["👎🏾"], ["👎🏿"]], ["👎", ["thumbsdown"], ",1,thumbsdown,thumbs,down,sign,no,dislike,hand"]], "fist": [[["✊"], ["✊🏻"], ["✊🏼"], ["✊🏽"], ["✊🏾"], ["✊🏿"]], ["✊", [], "fist,raised,fingers,hand,grasp"]], "facepunch": [[["👊"], ["👊🏻"], ["👊🏼"], ["👊🏽"], ["👊🏾"], ["👊🏿"]], ["👊", ["punch"], "facepunch,punch,fisted,hand,sign,angry,violence,fist,hit,attack"]], "left-facing_fist": [[["🤛"], ["🤛🏻"], ["🤛🏼"], ["🤛🏽"], ["🤛🏾"], ["🤛🏿"]], ["🤛", [], "left,facing,fist"]], "right-facing_fist": [[["🤜"], ["🤜🏻"], ["🤜🏼"], ["🤜🏽"], ["🤜🏾"], ["🤜🏿"]], ["🤜", [], "right,facing,fist"]], "raised_back_of_hand": [[["🤚"], ["🤚🏻"], ["🤚🏼"], ["🤚🏽"], ["🤚🏾"], ["🤚🏿"]], ["🤚", [], "raised,back,of,hand,fingers,backhand"]], "wave": [[["👋"], ["👋🏻"], ["👋🏼"], ["👋🏽"], ["👋🏾"], ["👋🏿"]], ["👋", [], "wave,waving,hand,sign,hands,gesture,goodbye,solong,farewell,hello,hi,palm"]], "i_love_you_hand_sign": [[["🤟"], ["🤟🏻"], ["🤟🏼"], ["🤟🏽"], ["🤟🏾"], ["🤟🏿"]], ["🤟", [], "i,love,you,hand,sign"]], "writing_hand": [[["✍"], ["✍️", "270d"], ["✍🏻"], ["✍🏼"], ["✍🏽"], ["✍🏾"], ["✍🏿"]], ["✍️", [], "writing,hand,lower_left_ballpoint_pen,stationery,write,compose", "270D-FE0F"]], "clap": [[["👏"], ["👏🏻"], ["👏🏼"], ["👏🏽"], ["👏🏾"], ["👏🏿"]], ["👏", [], "clap,clapping,hands,sign,praise,applause,congrats,yay"]], "open_hands": [[["👐"], ["👐🏻"], ["👐🏼"], ["👐🏽"], ["👐🏾"], ["👐🏿"]], ["👐", [], "open,hands,sign,fingers,butterfly"]], "raised_hands": [[["🙌"], ["🙌🏻"], ["🙌🏼"], ["🙌🏽"], ["🙌🏾"], ["🙌🏿"]], ["🙌", [], "raised,hands,person,raising,both,in,celebration,gesture,hooray,yea"]], "palms_up_together": [[["🤲"], ["🤲🏻"], ["🤲🏼"], ["🤲🏽"], ["🤲🏾"], ["🤲🏿"]], ["🤲", [], "palms,up,together"]], "pray": [[["🙏"], ["🙏🏻"], ["🙏🏼"], ["🙏🏽"], ["🙏🏾"], ["🙏🏿"]], ["🙏", [], "pray,person,with,folded,hands,please,hope,wish,namaste,highfive"]], "handshake": [[["🤝"]], ["🤝", [], "handshake,agreement,shake"]], "nail_care": [[["💅"], ["💅🏻"], ["💅🏼"], ["💅🏽"], ["💅🏾"], ["💅🏿"]], ["💅", [], "nail,care,polish,beauty,manicure,finger,fashion"]], "ear": [[["👂"], ["👂🏻"], ["👂🏼"], ["👂🏽"], ["👂🏾"], ["👂🏿"]], ["👂", [], "ear,face,hear,sound,listen"]], "nose": [[["👃"], ["👃🏻"], ["👃🏼"], ["👃🏽"], ["👃🏾"], ["👃🏿"]], ["👃", [], "nose,smell,sniff"]], "footprints": [[["👣"]], ["👣", [], "footprints,feet,tracking,walking,beach"]], "eyes": [[["👀"]], ["👀", [], "eyes,look,watch,stalk,peek,see"]], "eye": [[["👁"], ["👁️", "1f441"]], ["👁️", [], "eye,face,look,see,watch,stare"]], "brain": [[["🧠"]], ["🧠", [], "brain"]], "tongue": [[["👅"]], ["👅", [], "tongue,mouth,playful"]], "lips": [[["👄"]], ["👄", [], "lips,mouth,kiss"]], "kiss": [[["💋"]], ["💋", [], "kiss,mark,face,lips,love,like,affection,valentines"]], "cupid": [[["💘"]], ["💘", [], "cupid,heart,with,arrow,love,like,affection,valentines"]], "heart": [[["❤"], ["❤️", "2764"]], ["❤️", [], "heart,heavy,black,love,like,valentines,<3", "2764-FE0F"]], "heartbeat": [[["💓"]], ["💓", [], "heartbeat,beating,heart,love,like,affection,valentines,pink"]], "broken_heart": [[["💔"]], ["💔", [], "broken,heart,sad,sorry,break,heartbreak,</3"]], "two_hearts": [[["💕"]], ["💕", [], "two,hearts,love,like,affection,valentines,heart"]], "sparkling_heart": [[["💖"]], ["💖", [], "sparkling,heart,love,like,affection,valentines"]], "heartpulse": [[["💗"]], ["💗", [], "heartpulse,growing,heart,like,love,affection,valentines,pink"]], "blue_heart": [[["💙"]], ["💙", [], "blue,heart,love,like,affection,valentines"]], "green_heart": [[["💚"]], ["💚", [], "green,heart,love,like,affection,valentines"]], "yellow_heart": [[["💛"]], ["💛", [], "yellow,heart,love,like,affection,valentines"]], "orange_heart": [[["🧡"]], ["🧡", [], "orange,heart"]], "purple_heart": [[["💜"]], ["💜", [], "purple,heart,love,like,affection,valentines"]], "black_heart": [[["🖤"]], ["🖤", [], "black,heart,evil"]], "gift_heart": [[["💝"]], ["💝", [], "gift,heart,with,ribbon,love,valentines"]], "revolving_hearts": [[["💞"]], ["💞", [], "revolving,hearts,love,like,affection,valentines"]], "heart_decoration": [[["💟"]], ["💟", [], "heart,decoration,purple-square,love,like"]], "heavy_heart_exclamation_mark_ornament": [[["❣"], ["❣️", "2763"]], ["❣️", [], "heavy,heart,exclamation,mark,ornament", "2763-FE0F"]], "love_letter": [[["💌"]], ["💌", [], "love,letter,email,like,affection,envelope,valentines"]], "zzz": [[["💤"]], ["💤", [], "zzz,sleeping,symbol,sleepy,tired,dream"]], "anger": [[["💢"]], ["💢", [], "anger,symbol,angry,mad"]], "bomb": [[["💣"]], ["💣", [], "bomb,boom,explode,explosion,terrorism"]], "boom": [[["💥"]], ["💥", ["collision"], "boom,collision,symbol,bomb,explode,explosion,blown"]], "sweat_drops": [[["💦"]], ["💦", [], "sweat,drops,splashing,symbol,water,drip,oops"]], "dash": [[["💨"]], ["💨", [], "dash,symbol,wind,air,fast,shoo,fart,smoke,puff"]], "dizzy": [[["💫"]], ["💫", [], "dizzy,symbol,star,sparkle,shoot,magic"]], "speech_balloon": [[["💬"]], ["💬", [], "speech,balloon,bubble,words,message,talk,chatting"]], "left_speech_bubble": [[["🗨"], ["🗨️", "1f5e8"]], ["🗨️", [], "left,speech,bubble,words,message,talk,chatting"]], "right_anger_bubble": [[["🗯"], ["🗯️", "1f5ef"]], ["🗯️", [], "right,anger,bubble,caption,speech,thinking,mad"]], "thought_balloon": [[["💭"]], ["💭", [], "thought,balloon,bubble,cloud,speech,thinking,dream"]], "hole": [[["🕳"], ["🕳️", "1f573"]], ["🕳️", [], "hole,embarrassing"]], "eyeglasses": [[["👓"]], ["👓", [], "eyeglasses,fashion,accessories,eyesight,nerdy,dork,geek"]], "dark_sunglasses": [[["🕶"], ["🕶️", "1f576"]], ["🕶️", [], "dark,sunglasses,face,cool,accessories"]], "necktie": [[["👔"]], ["👔", [], "necktie,shirt,suitup,formal,fashion,cloth,business"]], "shirt": [[["👕"]], ["👕", ["tshirt"], "shirt,tshirt,t"]], "jeans": [[["👖"]], ["👖", [], "jeans,fashion,shopping"]], "scarf": [[["🧣"]], ["🧣", [], "scarf"]], "gloves": [[["🧤"]], ["🧤", [], "gloves"]], "coat": [[["🧥"]], ["🧥", [], "coat"]], "socks": [[["🧦"]], ["🧦", [], "socks"]], "dress": [[["👗"]], ["👗", [], "dress,clothes,fashion,shopping"]], "kimono": [[["👘"]], ["👘", [], "kimono,dress,fashion,women,female,japanese"]], "bikini": [[["👙"]], ["👙", [], "bikini,swimming,female,woman,girl,fashion,beach,summer"]], "womans_clothes": [[["👚"]], ["👚", [], "womans,clothes,fashion,shopping_bags,female"]], "purse": [[["👛"]], ["👛", [], "purse,fashion,accessories,money,sales,shopping"]], "handbag": [[["👜"]], ["👜", [], "handbag,fashion,accessory,accessories,shopping"]], "pouch": [[["👝"]], ["👝", [], "pouch,bag,accessories,shopping"]], "shopping_bags": [[["🛍"], ["🛍️", "1f6cd"]], ["🛍️", [], "shopping,bags"]], "school_satchel": [[["🎒"]], ["🎒", [], "school,satchel,student,education,bag,backpack"]], "mans_shoe": [[["👞"]], ["👞", ["shoe"], "mans,shoe,fashion,male"]], "athletic_shoe": [[["👟"]], ["👟", [], "athletic,shoe,shoes,sports,sneakers"]], "high_heel": [[["👠"]], ["👠", [], "high,heel,heeled,shoe,fashion,shoes,female,pumps,stiletto"]], "sandal": [[["👡"]], ["👡", [], "sandal,womans,shoes,fashion,flip flops"]], "boot": [[["👢"]], ["👢", [], "boot,womans,boots,shoes,fashion"]], "crown": [[["👑"]], ["👑", [], "crown,king,kod,leader,royalty,lord"]], "womans_hat": [[["👒"]], ["👒", [], "womans,hat,fashion,accessories,female,lady,spring"]], "tophat": [[["🎩"]], ["🎩", [], "tophat,top,hat,magic,gentleman,classy,circus"]], "mortar_board": [[["🎓"]], ["🎓", [], "mortar,board,graduation,cap,school,college,degree,university,hat,legal,learn,education"]], "billed_cap": [[["🧢"]], ["🧢", [], "billed,cap"]], "helmet_with_white_cross": [[["⛑"], ["⛑️", "26d1"]], ["⛑️", [], "helmet,with,white,cross", "26D1-FE0F"]], "prayer_beads": [[["📿"]], ["📿", [], "prayer,beads,dhikr,religious"]], "lipstick": [[["💄"]], ["💄", [], "lipstick,female,girl,fashion,woman"]], "ring": [[["💍"]], ["💍", [], "ring,wedding,propose,marriage,valentines,diamond,fashion,jewelry,gem,engagement"]], "gem": [[["💎"]], ["💎", [], "gem,stone,blue,ruby,diamond,jewelry"]], "monkey_face": [[["🐵"]], ["🐵", [], "monkey,face,animal,nature,circus,:o)"]], "monkey": [[["🐒"]], ["🐒", [], "monkey,animal,nature,banana,circus"]], "gorilla": [[["🦍"]], ["🦍", [], "gorilla,animal,nature,circus"]], "dog": [[["🐶"]], ["🐶", [], "dog,face,animal,friend,nature,woof,puppy,pet,faithful"]], "dog2": [[["🐕"]], ["🐕", [], "dog2,dog,animal,nature,friend,doge,pet,faithful"]], "poodle": [[["🐩"]], ["🐩", [], "poodle,dog,animal,101,nature,pet"]], "wolf": [[["🐺"]], ["🐺", [], "wolf,face,animal,nature,wild"]], "fox_face": [[["🦊"]], ["🦊", [], "fox,face,animal,nature"]], "cat": [[["🐱"]], ["🐱", [], "cat,face,animal,meow,nature,pet,kitten"]], "cat2": [[["🐈"]], ["🐈", [], "cat2,cat,animal,meow,pet,cats"]], "lion_face": [[["🦁"]], ["🦁", [], "lion,face"]], "tiger": [[["🐯"]], ["🐯", [], "tiger,face,animal,cat,danger,wild,nature,roar"]], "tiger2": [[["🐅"]], ["🐅", [], "tiger2,tiger,animal,nature,roar"]], "leopard": [[["🐆"]], ["🐆", [], "leopard,animal,nature"]], "horse": [[["🐴"]], ["🐴", [], "horse,face,animal,brown,nature"]], "racehorse": [[["🐎"]], ["🐎", [], "racehorse,horse,animal,gamble,luck"]], "unicorn_face": [[["🦄"]], ["🦄", [], "unicorn,face"]], "zebra_face": [[["🦓"]], ["🦓", [], "zebra,face"]], "deer": [[["🦌"]], ["🦌", [], "deer,animal,nature,horns,venison"]], "cow": [[["🐮"]], ["🐮", [], "cow,face,beef,ox,animal,nature,moo,milk"]], "ox": [[["🐂"]], ["🐂", [], "ox,animal,cow,beef"]], "water_buffalo": [[["🐃"]], ["🐃", [], "water,buffalo,animal,nature,ox,cow"]], "cow2": [[["🐄"]], ["🐄", [], "cow2,cow,beef,ox,animal,nature,moo,milk"]], "pig": [[["🐷"]], ["🐷", [], "pig,face,animal,oink,nature"]], "pig2": [[["🐖"]], ["🐖", [], "pig2,pig,animal,nature"]], "boar": [[["🐗"]], ["🐗", [], "boar,animal,nature"]], "pig_nose": [[["🐽"]], ["🐽", [], "pig,nose,animal,oink"]], "ram": [[["🐏"]], ["🐏", [], "ram,animal,sheep,nature"]], "sheep": [[["🐑"]], ["🐑", [], "sheep,animal,nature,wool,shipit"]], "goat": [[["🐐"]], ["🐐", [], "goat,animal,nature"]], "dromedary_camel": [[["🐪"]], ["🐪", [], "dromedary,camel,animal,hot,desert,hump"]], "camel": [[["🐫"]], ["🐫", [], "camel,bactrian,animal,nature,hot,desert,hump"]], "giraffe_face": [[["🦒"]], ["🦒", [], "giraffe,face"]], "elephant": [[["🐘"]], ["🐘", [], "elephant,animal,nature,nose,th,circus"]], "rhinoceros": [[["🦏"]], ["🦏", [], "rhinoceros,animal,nature,horn"]], "mouse": [[["🐭"]], ["🐭", [], "mouse,face,animal,nature,cheese_wedge,rodent"]], "mouse2": [[["🐁"]], ["🐁", [], "mouse2,mouse,animal,nature,rodent"]], "rat": [[["🐀"]], ["🐀", [], "rat,animal,mouse,rodent"]], "hamster": [[["🐹"]], ["🐹", [], "hamster,face,animal,nature"]], "rabbit": [[["🐰"]], ["🐰", [], "rabbit,face,animal,nature,pet,spring,magic,bunny"]], "rabbit2": [[["🐇"]], ["🐇", [], "rabbit2,rabbit,animal,nature,pet,magic,spring"]], "chipmunk": [[["🐿"], ["🐿️", "1f43f"]], ["🐿️", [], "chipmunk,animal,nature,rodent,squirrel"]], "hedgehog": [[["🦔"]], ["🦔", [], "hedgehog"]], "bat": [[["🦇"]], ["🦇", [], "bat,animal,nature,blind,vampire"]], "bear": [[["🐻"]], ["🐻", [], "bear,face,animal,nature,wild"]], "koala": [[["🐨"]], ["🐨", [], "koala,animal,nature"]], "panda_face": [[["🐼"]], ["🐼", [], "panda,face,animal,nature"]], "feet": [[["🐾"]], ["🐾", ["paw_prints"], "feet,paw,prints"]], "turkey": [[["🦃"]], ["🦃", [], "turkey,animal,bird"]], "chicken": [[["🐔"]], ["🐔", [], "chicken,animal,cluck,nature,bird"]], "rooster": [[["🐓"]], ["🐓", [], "rooster,animal,nature,chicken"]], "hatching_chick": [[["🐣"]], ["🐣", [], "hatching,chick,animal,chicken,egg,born,baby,bird"]], "baby_chick": [[["🐤"]], ["🐤", [], "baby,chick,animal,chicken,bird"]], "hatched_chick": [[["🐥"]], ["🐥", [], "hatched,chick,front,facing,baby,animal,chicken,bird"]], "bird": [[["🐦"]], ["🐦", [], "bird,animal,nature,fly,tweet,spring"]], "penguin": [[["🐧"]], ["🐧", [], "penguin,animal,nature"]], "dove_of_peace": [[["🕊"], ["🕊️", "1f54a"]], ["🕊️", [], "dove,of,peace"]], "eagle": [[["🦅"]], ["🦅", [], "eagle,animal,nature,bird"]], "duck": [[["🦆"]], ["🦆", [], "duck,animal,nature,bird,mallard"]], "owl": [[["🦉"]], ["🦉", [], "owl,animal,nature,bird,hoot"]], "frog": [[["🐸"]], ["🐸", [], "frog,face,animal,nature,croak,toad"]], "crocodile": [[["🐊"]], ["🐊", [], "crocodile,animal,nature,reptile,lizard,alligator"]], "turtle": [[["🐢"]], ["🐢", [], "turtle,animal,slow,nature,tortoise"]], "lizard": [[["🦎"]], ["🦎", [], "lizard,animal,nature,reptile"]], "snake": [[["🐍"]], ["🐍", [], "snake,animal,evil,nature,hiss,python"]], "dragon_face": [[["🐲"]], ["🐲", [], "dragon,face,animal,myth,nature,chinese,green"]], "dragon": [[["🐉"]], ["🐉", [], "dragon,animal,myth,nature,chinese,green"]], "sauropod": [[["🦕"]], ["🦕", [], "sauropod"]], "t-rex": [[["🦖"]], ["🦖", [], "t,rex"]], "whale": [[["🐳"]], ["🐳", [], "whale,spouting,animal,nature,sea,ocean"]], "whale2": [[["🐋"]], ["🐋", [], "whale2,whale,animal,nature,sea,ocean"]], "dolphin": [[["🐬"]], ["🐬", ["flipper"], "dolphin,flipper,animal,nature,fish,sea,ocean,fins,beach"]], "fish": [[["🐟"]], ["🐟", [], "fish,animal,food,nature"]], "tropical_fish": [[["🐠"]], ["🐠", [], "tropical,fish,animal,swim,ocean,beach,nemo"]], "blowfish": [[["🐡"]], ["🐡", [], "blowfish,animal,nature,food,sea,ocean"]], "shark": [[["🦈"]], ["🦈", [], "shark,animal,nature,fish,sea,ocean,jaws,fins,beach"]], "octopus": [[["🐙"]], ["🐙", [], "octopus,animal,creature,ocean,sea,nature,beach"]], "shell": [[["🐚"]], ["🐚", [], "shell,spiral,nature,sea,beach"]], "crab": [[["🦀"]], ["🦀", [], "crab,animal,crustacean"]], "shrimp": [[["🦐"]], ["🦐", [], "shrimp,animal,ocean,nature,seafood"]], "squid": [[["🦑"]], ["🦑", [], "squid,animal,nature,ocean,sea"]], "snail": [[["🐌"]], ["🐌", [], "snail,slow,animal,shell"]], "butterfly": [[["🦋"]], ["🦋", [], "butterfly,animal,insect,nature,caterpillar"]], "bug": [[["🐛"]], ["🐛", [], "bug,animal,insect,nature,worm"]], "ant": [[["🐜"]], ["🐜", [], "ant,animal,insect,nature,bug"]], "bee": [[["🐝"]], ["🐝", ["honeybee"], "bee,honeybee"]], "beetle": [[["🐞"]], ["🐞", [], "beetle,lady,animal,insect,nature,ladybug"]], "cricket": [[["🦗"]], ["🦗", [], "cricket,sports"]], "spider": [[["🕷"], ["🕷️", "1f577"]], ["🕷️", [], "spider,animal,arachnid"]], "spider_web": [[["🕸"], ["🕸️", "1f578"]], ["🕸️", [], "spider,web,animal,insect,arachnid,silk"]], "scorpion": [[["🦂"]], ["🦂", [], "scorpion,animal,arachnid"]], "bouquet": [[["💐"]], ["💐", [], "bouquet,flowers,nature,spring"]], "cherry_blossom": [[["🌸"]], ["🌸", [], "cherry,blossom,nature,plant,spring,flower"]], "white_flower": [[["💮"]], ["💮", [], "white,flower,japanese,spring"]], "rosette": [[["🏵"], ["🏵️", "1f3f5"]], ["🏵️", [], "rosette,flower,decoration,military"]], "rose": [[["🌹"]], ["🌹", [], "rose,flowers,valentines,love,spring"]], "wilted_flower": [[["🥀"]], ["🥀", [], "wilted,flower,plant,nature"]], "hibiscus": [[["🌺"]], ["🌺", [], "hibiscus,plant,vegetable,flowers,beach"]], "sunflower": [[["🌻"]], ["🌻", [], "sunflower,nature,plant,fall"]], "blossom": [[["🌼"]], ["🌼", [], "blossom,nature,flowers,yellow"]], "tulip": [[["🌷"]], ["🌷", [], "tulip,flowers,plant,nature,summer,spring"]], "seedling": [[["🌱"]], ["🌱", [], "seedling,plant,nature,grass,lawn,spring"]], "evergreen_tree": [[["🌲"]], ["🌲", [], "evergreen,tree,plant,nature"]], "deciduous_tree": [[["🌳"]], ["🌳", [], "deciduous,tree,plant,nature"]], "palm_tree": [[["🌴"]], ["🌴", [], "palm,tree,plant,vegetable,nature,summer,beach,mojito,tropical"]], "cactus": [[["🌵"]], ["🌵", [], "cactus,vegetable,plant,nature"]], "ear_of_rice": [[["🌾"]], ["🌾", [], "ear,of,rice,nature,plant"]], "herb": [[["🌿"]], ["🌿", [], "herb,vegetable,plant,medicine,weed,grass,lawn"]], "shamrock": [[["☘"], ["☘️", "2618"]], ["☘️", [], "shamrock,vegetable,plant,nature,irish,clover", "2618-FE0F"]], "four_leaf_clover": [[["🍀"]], ["🍀", [], "four,leaf,clover,vegetable,plant,nature,lucky,irish"]], "maple_leaf": [[["🍁"]], ["🍁", [], "maple,leaf,nature,plant,vegetable,ca,fall"]], "fallen_leaf": [[["🍂"]], ["🍂", [], "fallen,leaf,nature,plant,vegetable,leaves"]], "leaves": [[["🍃"]], ["🍃", [], "leaves,leaf,fluttering,in,wind,nature,plant,tree,vegetable,grass,lawn,spring"]], "grapes": [[["🍇"]], ["🍇", [], "grapes,fruit,food,wine"]], "melon": [[["🍈"]], ["🍈", [], "melon,fruit,nature,food"]], "watermelon": [[["🍉"]], ["🍉", [], "watermelon,fruit,food,picnic,summer"]], "tangerine": [[["🍊"]], ["🍊", [], "tangerine,food,fruit,nature,orange"]], "lemon": [[["🍋"]], ["🍋", [], "lemon,fruit,nature"]], "banana": [[["🍌"]], ["🍌", [], "banana,fruit,food,monkey"]], "pineapple": [[["🍍"]], ["🍍", [], "pineapple,fruit,nature,food"]], "apple": [[["🍎"]], ["🍎", [], "apple,red,fruit,mac,school"]], "green_apple": [[["🍏"]], ["🍏", [], "green,apple,fruit,nature"]], "pear": [[["🍐"]], ["🍐", [], "pear,fruit,nature,food"]], "peach": [[["🍑"]], ["🍑", [], "peach,fruit,nature,food"]], "cherries": [[["🍒"]], ["🍒", [], "cherries,food,fruit"]], "strawberry": [[["🍓"]], ["🍓", [], "strawberry,fruit,food,nature"]], "kiwifruit": [[["🥝"]], ["🥝", [], "kiwifruit"]], "tomato": [[["🍅"]], ["🍅", [], "tomato,fruit,vegetable,nature,food"]], "coconut": [[["🥥"]], ["🥥", [], "coconut"]], "avocado": [[["🥑"]], ["🥑", [], "avocado,fruit,food"]], "eggplant": [[["🍆"]], ["🍆", [], "eggplant,aubergine,vegetable,nature,food"]], "potato": [[["🥔"]], ["🥔", [], "potato,food,tuber,vegatable,starch"]], "carrot": [[["🥕"]], ["🥕", [], "carrot,vegetable,food,orange"]], "corn": [[["🌽"]], ["🌽", [], "corn,ear,of,maize,food,vegetable,plant"]], "hot_pepper": [[["🌶"], ["🌶️", "1f336"]], ["🌶️", [], "hot,pepper,food,spicy,chilli,chili"]], "cucumber": [[["🥒"]], ["🥒", [], "cucumber,fruit,food,pickle"]], "broccoli": [[["🥦"]], ["🥦", [], "broccoli"]], "mushroom": [[["🍄"]], ["🍄", [], "mushroom,plant,vegetable"]], "peanuts": [[["🥜"]], ["🥜", [], "peanuts,food,nut"]], "chestnut": [[["🌰"]], ["🌰", [], "chestnut,food,squirrel"]], "bread": [[["🍞"]], ["🍞", [], "bread,food,wheat,breakfast,toast"]], "croissant": [[["🥐"]], ["🥐", [], "croissant,food,bread,french"]], "baguette_bread": [[["🥖"]], ["🥖", [], "baguette,bread,food,french"]], "pretzel": [[["🥨"]], ["🥨", [], "pretzel"]], "pancakes": [[["🥞"]], ["🥞", [], "pancakes,food,breakfast,flapjacks,hotcakes"]], "cheese_wedge": [[["🧀"]], ["🧀", [], "cheese,wedge"]], "meat_on_bone": [[["🍖"]], ["🍖", [], "meat,on,bone,good,food,drumstick"]], "poultry_leg": [[["🍗"]], ["🍗", [], "poultry,leg,food,meat,drumstick,bird,chicken,turkey"]], "cut_of_meat": [[["🥩"]], ["🥩", [], "cut,of,meat"]], "bacon": [[["🥓"]], ["🥓", [], "bacon,food,breakfast,pork,pig,meat"]], "hamburger": [[["🍔"]], ["🍔", [], "hamburger,meat,fast food,beef,cheeseburger,mcdonalds,burger king"]], "fries": [[["🍟"]], ["🍟", [], "fries,french,chips,snack,fast food"]], "pizza": [[["🍕"]], ["🍕", [], "pizza,slice,of,food,party"]], "hotdog": [[["🌭"]], ["🌭", [], "hotdog,hot,dog,food,frankfurter"]], "sandwich": [[["🥪"]], ["🥪", [], "sandwich"]], "taco": [[["🌮"]], ["🌮", [], "taco,food,mexican"]], "burrito": [[["🌯"]], ["🌯", [], "burrito,food,mexican"]], "stuffed_flatbread": [[["🥙"]], ["🥙", [], "stuffed,flatbread,food,gyro"]], "egg": [[["🥚"]], ["🥚", [], "egg,food,chicken,breakfast"]], "fried_egg": [[["🍳"]], ["🍳", ["cooking"], "fried,egg,cooking,food,breakfast,kitchen"]], "shallow_pan_of_food": [[["🥘"]], ["🥘", [], "shallow,pan,of,food,cooking,casserole,paella"]], "stew": [[["🍲"]], ["🍲", [], "stew,pot,of,food,meat,soup"]], "bowl_with_spoon": [[["🥣"]], ["🥣", [], "bowl,with,spoon"]], "green_salad": [[["🥗"]], ["🥗", [], "green,salad,food,healthy,lettuce"]], "popcorn": [[["🍿"]], ["🍿", [], "popcorn,food,movie theater,films,snack"]], "canned_food": [[["🥫"]], ["🥫", [], "canned,food"]], "bento": [[["🍱"]], ["🍱", [], "bento,box,food,japanese"]], "rice_cracker": [[["🍘"]], ["🍘", [], "rice,cracker,food,japanese"]], "rice_ball": [[["🍙"]], ["🍙", [], "rice,ball,food,japanese"]], "rice": [[["🍚"]], ["🍚", [], "rice,cooked,food,china,asian"]], "curry": [[["🍛"]], ["🍛", [], "curry,and,rice,food,spicy,hot,indian"]], "ramen": [[["🍜"]], ["🍜", [], "ramen,steaming,bowl,food,japanese,noodle,chopsticks"]], "spaghetti": [[["🍝"]], ["🍝", [], "spaghetti,food,italian,noodle"]], "sweet_potato": [[["🍠"]], ["🍠", [], "sweet,potato,roasted,food,nature"]], "oden": [[["🍢"]], ["🍢", [], "oden,food,japanese"]], "sushi": [[["🍣"]], ["🍣", [], "sushi,food,fish,japanese,rice"]], "fried_shrimp": [[["🍤"]], ["🍤", [], "fried,shrimp,food,animal,appetizer,summer"]], "fish_cake": [[["🍥"]], ["🍥", [], "fish,cake,with,swirl,design,food,japan,sea,beach,narutomaki,pink,kamaboko,surimi,ramen"]], "dango": [[["🍡"]], ["🍡", [], "dango,food,dessert,sweet,japanese,barbecue,meat"]], "dumpling": [[["🥟"]], ["🥟", [], "dumpling"]], "fortune_cookie": [[["🥠"]], ["🥠", [], "fortune,cookie"]], "takeout_box": [[["🥡"]], ["🥡", [], "takeout,box"]], "icecream": [[["🍦"]], ["🍦", [], "icecream,soft,ice,cream,food,hot,dessert,summer"]], "shaved_ice": [[["🍧"]], ["🍧", [], "shaved,ice,hot,dessert,summer"]], "ice_cream": [[["🍨"]], ["🍨", [], "ice,cream,food,hot,dessert"]], "doughnut": [[["🍩"]], ["🍩", [], "doughnut,food,dessert,snack,sweet,donut"]], "cookie": [[["🍪"]], ["🍪", [], "cookie,food,snack,oreo,chocolate,sweet,dessert"]], "birthday": [[["🎂"]], ["🎂", [], "birthday,cake,food,dessert"]], "cake": [[["🍰"]], ["🍰", [], "cake,shortcake,food,dessert"]], "pie": [[["🥧"]], ["🥧", [], "pie"]], "chocolate_bar": [[["🍫"]], ["🍫", [], "chocolate,bar,food,snack,dessert,sweet"]], "candy": [[["🍬"]], ["🍬", [], "candy,snack,dessert,sweet,lolly"]], "lollipop": [[["🍭"]], ["🍭", [], "lollipop,food,snack,candy,sweet"]], "custard": [[["🍮"]], ["🍮", [], "custard,dessert,food"]], "honey_pot": [[["🍯"]], ["🍯", [], "honey,pot,bees,sweet,kitchen"]], "baby_bottle": [[["🍼"]], ["🍼", [], "baby,bottle,food,container,milk"]], "glass_of_milk": [[["🥛"]], ["🥛", [], "glass,of,milk"]], "coffee": [[["☕"]], ["☕", [], "coffee,hot,beverage,caffeine,latte,espresso"]], "tea": [[["🍵"]], ["🍵", [], "tea,teacup,without,handle,drink,bowl,breakfast,green,british"]], "sake": [[["🍶"]], ["🍶", [], "sake,bottle,and,cup,wine,drink,drunk,beverage,japanese,alcohol,booze"]], "champagne": [[["🍾"]], ["🍾", [], "champagne,bottle,with,popping,cork,drink,wine,celebration"]], "wine_glass": [[["🍷"]], ["🍷", [], "wine,glass,drink,beverage,drunk,alcohol,booze"]], "cocktail": [[["🍸"]], ["🍸", [], "cocktail,glass,drink,drunk,alcohol,beverage,booze,mojito"]], "tropical_drink": [[["🍹"]], ["🍹", [], "tropical,drink,beverage,cocktail,summer,beach,alcohol,booze,mojito"]], "beer": [[["🍺"]], ["🍺", [], "beer,mug,relax,beverage,drink,drunk,party,pub,summer,alcohol,booze"]], "beers": [[["🍻"]], ["🍻", [], "beers,clinking,beer,mugs,relax,beverage,drink,drunk,party,pub,summer,alcohol,booze"]], "clinking_glasses": [[["🥂"]], ["🥂", [], "clinking,glasses,beverage,drink,party,alcohol,celebrate,cheers"]], "tumbler_glass": [[["🥃"]], ["🥃", [], "tumbler,glass,drink,beverage,drunk,alcohol,liquor,booze,bourbon,scotch,whisky,shot"]], "cup_with_straw": [[["🥤"]], ["🥤", [], "cup,with,straw"]], "chopsticks": [[["🥢"]], ["🥢", [], "chopsticks"]], "knife_fork_plate": [[["🍽"], ["🍽️", "1f37d"]], ["🍽️", [], "knife,fork,plate"]], "fork_and_knife": [[["🍴"]], ["🍴", [], "fork,and,knife,cutlery,kitchen"]], "spoon": [[["🥄"]], ["🥄", [], "spoon,cutlery,kitchen,tableware"]], "hocho": [[["🔪"]], ["🔪", ["knife"], "hocho,knife,blade,cutlery,kitchen,weapon"]], "amphora": [[["🏺"]], ["🏺", [], "amphora,vase,jar"]], "earth_africa": [[["🌍"]], ["🌍", [], "earth,africa,globe,europe,world,international"]], "earth_americas": [[["🌎"]], ["🌎", [], "earth,americas,globe,world,usa,international"]], "earth_asia": [[["🌏"]], ["🌏", [], "earth,asia,globe,australia,world,east,international"]], "globe_with_meridians": [[["🌐"]], ["🌐", [], "globe,with,meridians,earth,international,world,internet,interweb,i18n"]], "world_map": [[["🗺"], ["🗺️", "1f5fa"]], ["🗺️", [], "world,map,location,direction"]], "japan": [[["🗾"]], ["🗾", [], "japan,silhouette,of,nation,country,japanese,asia"]], "snow_capped_mountain": [[["🏔"], ["🏔️", "1f3d4"]], ["🏔️", [], "snow,capped,mountain"]], "mountain": [[["⛰"], ["⛰️", "26f0"]], ["⛰️", [], "mountain,photo,nature,environment", "26F0-FE0F"]], "volcano": [[["🌋"]], ["🌋", [], "volcano,photo,nature,disaster"]], "mount_fuji": [[["🗻"]], ["🗻", [], "mount,fuji,photo,mountain,nature,japanese"]], "camping": [[["🏕"], ["🏕️", "1f3d5"]], ["🏕️", [], "camping,photo,outdoors,tent"]], "beach_with_umbrella": [[["🏖"], ["🏖️", "1f3d6"]], ["🏖️", [], "beach,with,umbrella"]], "desert": [[["🏜"], ["🏜️", "1f3dc"]], ["🏜️", [], "desert,photo,warm,saharah"]], "desert_island": [[["🏝"], ["🏝️", "1f3dd"]], ["🏝️", [], "desert,island,photo,tropical,mojito"]], "national_park": [[["🏞"], ["🏞️", "1f3de"]], ["🏞️", [], "national,park,photo,environment,nature"]], "stadium": [[["🏟"], ["🏟️", "1f3df"]], ["🏟️", [], "stadium,photo,place,sports,concert,venue"]], "classical_building": [[["🏛"], ["🏛️", "1f3db"]], ["🏛️", [], "classical,building,art,culture,history"]], "building_construction": [[["🏗"], ["🏗️", "1f3d7"]], ["🏗️", [], "building,construction,wip,working,progress"]], "house_buildings": [[["🏘"], ["🏘️", "1f3d8"]], ["🏘️", [], "house,buildings"]], "cityscape": [[["🏙"], ["🏙️", "1f3d9"]], ["🏙️", [], "cityscape,photo,night life,urban"]], "derelict_house_building": [[["🏚"], ["🏚️", "1f3da"]], ["🏚️", [], "derelict,house,building"]], "house": [[["🏠"]], ["🏠", [], "house,building,home"]], "house_with_garden": [[["🏡"]], ["🏡", [], "house,with,garden,home,plant,nature"]], "office": [[["🏢"]], ["🏢", [], "office,building,bureau,work"]], "post_office": [[["🏣"]], ["🏣", [], "post,office,japanese,building,envelope,communication"]], "european_post_office": [[["🏤"]], ["🏤", [], "european,post,office,building,email"]], "hospital": [[["🏥"]], ["🏥", [], "hospital,building,health,surgery,doctor"]], "bank": [[["🏦"]], ["🏦", [], "bank,building,money,sales,cash,business,enterprise"]], "hotel": [[["🏨"]], ["🏨", [], "hotel,building,accomodation,checkin"]], "love_hotel": [[["🏩"]], ["🏩", [], "love,hotel,like,affection,dating"]], "convenience_store": [[["🏪"]], ["🏪", [], "convenience,store,building,shopping,groceries"]], "school": [[["🏫"]], ["🏫", [], "school,building,student,education,learn,teach"]], "department_store": [[["🏬"]], ["🏬", [], "department,store,building,shopping,mall"]], "factory": [[["🏭"]], ["🏭", [], "factory,building,industry,pollution,smoke"]], "japanese_castle": [[["🏯"]], ["🏯", [], "japanese,castle,photo,building"]], "european_castle": [[["🏰"]], ["🏰", [], "european,castle,building,royalty,history"]], "wedding": [[["💒"]], ["💒", [], "wedding,love,like,affection,couple,marriage,bride,groom"]], "tokyo_tower": [[["🗼"]], ["🗼", [], "tokyo,tower,photo,japanese"]], "statue_of_liberty": [[["🗽"]], ["🗽", [], "statue,of,liberty,american,newyork"]], "church": [[["⛪"]], ["⛪", [], "church,building,religion,christ"]], "mosque": [[["🕌"]], ["🕌", [], "mosque,islam,worship,minaret"]], "synagogue": [[["🕍"]], ["🕍", [], "synagogue,judaism,worship,temple,jewish"]], "shinto_shrine": [[["⛩"], ["⛩️", "26e9"]], ["⛩️", [], "shinto,shrine,temple,japan,kyoto", "26E9-FE0F"]], "kaaba": [[["🕋"]], ["🕋", [], "kaaba,mecca,mosque,islam"]], "fountain": [[["⛲"]], ["⛲", [], "fountain,photo,summer,water,fresh"]], "tent": [[["⛺"]], ["⛺", [], "tent,photo,camping,outdoors"]], "foggy": [[["🌁"]], ["🌁", [], "foggy,photo,mountain"]], "night_with_stars": [[["🌃"]], ["🌃", [], "night,with,stars,evening,city,downtown"]], "sunrise_over_mountains": [[["🌄"]], ["🌄", [], "sunrise,over,mountains,view,vacation,photo"]], "sunrise": [[["🌅"]], ["🌅", [], "sunrise,morning,view,vacation,photo"]], "city_sunset": [[["🌆"]], ["🌆", [], "city,sunset,cityscape,at,dusk,photo,evening,sky,buildings"]], "city_sunrise": [[["🌇"]], ["🌇", [], "city,sunrise,sunset,over,buildings,photo,good morning,dawn"]], "bridge_at_night": [[["🌉"]], ["🌉", [], "bridge,at,night,photo,sanfrancisco"]], "hotsprings": [[["♨"], ["♨️", "2668"]], ["♨️", [], "hotsprings,hot,springs,bath,warm,relax", "2668-FE0F"]], "milky_way": [[["🌌"]], ["🌌", [], "milky,way,photo,space,stars"]], "carousel_horse": [[["🎠"]], ["🎠", [], "carousel,horse,photo,carnival"]], "ferris_wheel": [[["🎡"]], ["🎡", [], "ferris,wheel,photo,carnival,londoneye"]], "roller_coaster": [[["🎢"]], ["🎢", [], "roller,coaster,carnival,playground,photo,fun"]], "barber": [[["💈"]], ["💈", [], "barber,pole,hair,salon,style"]], "circus_tent": [[["🎪"]], ["🎪", [], "circus,tent,festival,carnival,party"]], "performing_arts": [[["🎭"]], ["🎭", [], "performing,arts,acting,theater,drama"]], "frame_with_picture": [[["🖼"], ["🖼️", "1f5bc"]], ["🖼️", [], "frame,with,picture"]], "art": [[["🎨"]], ["🎨", [], "art,artist,palette,design,paint,draw,colors"]], "slot_machine": [[["🎰"]], ["🎰", [], "slot,machine,bet,gamble,vegas,fruit machine,luck,casino"]], "steam_locomotive": [[["🚂"]], ["🚂", [], "steam,locomotive,transportation,vehicle,train"]], "railway_car": [[["🚃"]], ["🚃", [], "railway,car,transportation,vehicle"]], "bullettrain_side": [[["🚄"]], ["🚄", [], "bullettrain,side,high,speed,train,transportation,vehicle"]], "bullettrain_front": [[["🚅"]], ["🚅", [], "bullettrain,front,high,speed,train,with,bullet,nose,transportation,vehicle,fast,public,travel"]], "train2": [[["🚆"]], ["🚆", [], "train2,train,transportation,vehicle"]], "metro": [[["🚇"]], ["🚇", [], "metro,transportation,blue-square,mrt,underground,tube"]], "light_rail": [[["🚈"]], ["🚈", [], "light,rail,transportation,vehicle"]], "station": [[["🚉"]], ["🚉", [], "station,transportation,vehicle,public"]], "tram": [[["🚊"]], ["🚊", [], "tram,transportation,vehicle"]], "monorail": [[["🚝"]], ["🚝", [], "monorail,transportation,vehicle"]], "mountain_railway": [[["🚞"]], ["🚞", [], "mountain,railway,transportation,vehicle"]], "train": [[["🚋"]], ["🚋", [], "train,tram,car,transportation,vehicle,carriage,public,travel"]], "bus": [[["🚌"]], ["🚌", [], "bus,car,vehicle,transportation"]], "oncoming_bus": [[["🚍"]], ["🚍", [], "oncoming,bus,vehicle,transportation"]], "trolleybus": [[["🚎"]], ["🚎", [], "trolleybus,bart,transportation,vehicle"]], "minibus": [[["🚐"]], ["🚐", [], "minibus,vehicle,car,transportation"]], "ambulance": [[["🚑"]], ["🚑", [], "ambulance,health,911,hospital"]], "fire_engine": [[["🚒"]], ["🚒", [], "fire,engine,transportation,cars,vehicle"]], "police_car": [[["🚓"]], ["🚓", [], "police,car,vehicle,cars,transportation,law,legal,enforcement"]], "oncoming_police_car": [[["🚔"]], ["🚔", [], "oncoming,police,car,vehicle,law,legal,enforcement,911"]], "taxi": [[["🚕"]], ["🚕", [], "taxi,uber,vehicle,cars,transportation"]], "oncoming_taxi": [[["🚖"]], ["🚖", [], "oncoming,taxi,vehicle,cars,uber"]], "car": [[["🚗"]], ["🚗", ["red_car"], "car,red,automobile"]], "oncoming_automobile": [[["🚘"]], ["🚘", [], "oncoming,automobile,car,vehicle,transportation"]], "blue_car": [[["🚙"]], ["🚙", [], "blue,car,recreational,vehicle,transportation"]], "truck": [[["🚚"]], ["🚚", [], "truck,delivery,cars,transportation"]], "articulated_lorry": [[["🚛"]], ["🚛", [], "articulated,lorry,vehicle,cars,transportation,express"]], "tractor": [[["🚜"]], ["🚜", [], "tractor,vehicle,car,farming,agriculture"]], "bike": [[["🚲"]], ["🚲", [], "bike,bicycle,sports,exercise,hipster"]], "scooter": [[["🛴"]], ["🛴", [], "scooter"]], "motor_scooter": [[["🛵"]], ["🛵", [], "motor,scooter,vehicle,vespa,sasha"]], "busstop": [[["🚏"]], ["🚏", [], "busstop,bus,stop,transportation,wait"]], "motorway": [[["🛣"], ["🛣️", "1f6e3"]], ["🛣️", [], "motorway,road,cupertino,interstate,highway"]], "railway_track": [[["🛤"], ["🛤️", "1f6e4"]], ["🛤️", [], "railway,track,train,transportation"]], "fuelpump": [[["⛽"]], ["⛽", [], "fuelpump,fuel,pump,gas station,petroleum"]], "rotating_light": [[["🚨"]], ["🚨", [], "rotating,light,police,cars,revolving,ambulance,911,emergency,alert,error,pinged,law,legal"]], "traffic_light": [[["🚥"]], ["🚥", [], "traffic,light,horizontal,transportation,signal"]], "vertical_traffic_light": [[["🚦"]], ["🚦", [], "vertical,traffic,light,transportation,driving"]], "construction": [[["🚧"]], ["🚧", [], "construction,sign,wip,progress,caution,warning"]], "octagonal_sign": [[["🛑"]], ["🛑", [], "octagonal,sign"]], "anchor": [[["⚓"]], ["⚓", [], "anchor,ship,ferry,sea,boat"]], "boat": [[["⛵"]], ["⛵", ["sailboat"], "boat,sailboat"]], "canoe": [[["🛶"]], ["🛶", [], "canoe,boat,paddle,water,ship"]], "speedboat": [[["🚤"]], ["🚤", [], "speedboat,ship,transportation,vehicle,summer"]], "passenger_ship": [[["🛳"], ["🛳️", "1f6f3"]], ["🛳️", [], "passenger,ship,yacht,cruise,ferry"]], "ferry": [[["⛴"], ["⛴️", "26f4"]], ["⛴️", [], "ferry,boat,ship,yacht", "26F4-FE0F"]], "motor_boat": [[["🛥"], ["🛥️", "1f6e5"]], ["🛥️", [], "motor,boat,ship"]], "ship": [[["🚢"]], ["🚢", [], "ship,transportation,titanic,deploy"]], "airplane": [[["✈"], ["✈️", "2708"]], ["✈️", [], "airplane,vehicle,transportation,flight,fly", "2708-FE0F"]], "small_airplane": [[["🛩"], ["🛩️", "1f6e9"]], ["🛩️", [], "small,airplane,flight,transportation,fly,vehicle"]], "airplane_departure": [[["🛫"]], ["🛫", [], "airplane,departure"]], "airplane_arriving": [[["🛬"]], ["🛬", [], "airplane,arriving"]], "seat": [[["💺"]], ["💺", [], "seat,sit,airplane,transport,bus,flight,fly"]], "helicopter": [[["🚁"]], ["🚁", [], "helicopter,transportation,vehicle,fly"]], "suspension_railway": [[["🚟"]], ["🚟", [], "suspension,railway,vehicle,transportation"]], "mountain_cableway": [[["🚠"]], ["🚠", [], "mountain,cableway,transportation,vehicle,ski"]], "aerial_tramway": [[["🚡"]], ["🚡", [], "aerial,tramway,transportation,vehicle,ski"]], "satellite": [[["🛰"], ["🛰️", "1f6f0"]], ["🛰️", [], "satellite,communication,future,radio,space"]], "rocket": [[["🚀"]], ["🚀", [], "rocket,launch,ship,staffmode,nasa,outer space,outer_space,fly"]], "flying_saucer": [[["🛸"]], ["🛸", [], "flying,saucer"]], "bellhop_bell": [[["🛎"], ["🛎️", "1f6ce"]], ["🛎️", [], "bellhop,bell,service"]], "door": [[["🚪"]], ["🚪", [], "door,house,entry,exit"]], "bed": [[["🛏"], ["🛏️", "1f6cf"]], ["🛏️", [], "bed,sleep,rest"]], "couch_and_lamp": [[["🛋"], ["🛋️", "1f6cb"]], ["🛋️", [], "couch,and,lamp,read,chill"]], "toilet": [[["🚽"]], ["🚽", [], "toilet,restroom,wc,washroom,bathroom,potty"]], "shower": [[["🚿"]], ["🚿", [], "shower,clean,water,bathroom"]], "bathtub": [[["🛁"]], ["🛁", [], "bathtub,clean,shower,bathroom"]], "hourglass": [[["⌛"]], ["⌛", [], "hourglass,time,clock,oldschool,limit,exam,quiz,test"]], "hourglass_flowing_sand": [[["⏳"]], ["⏳", [], "hourglass,flowing,sand,with,oldschool,time,countdown"]], "watch": [[["⌚"]], ["⌚", [], "watch,time,accessories"]], "alarm_clock": [[["⏰"]], ["⏰", [], "alarm,clock,time,wake"]], "stopwatch": [[["⏱"], ["⏱️", "23f1"]], ["⏱️", [], "stopwatch,time,deadline", "23F1-FE0F"]], "timer_clock": [[["⏲"], ["⏲️", "23f2"]], ["⏲️", [], "timer,clock,alarm", "23F2-FE0F"]], "mantelpiece_clock": [[["🕰"], ["🕰️", "1f570"]], ["🕰️", [], "mantelpiece,clock,time"]], "clock12": [[["🕛"]], ["🕛", [], "clock12,clock,face,twelve,oclock,time,noon,midnight,midday,late,early,schedule"]], "clock1230": [[["🕧"]], ["🕧", [], "clock1230,clock,face,twelve,thirty,time,late,early,schedule"]], "clock1": [[["🕐"]], ["🕐", [], "clock1,clock,face,one,oclock,time,late,early,schedule"]], "clock130": [[["🕜"]], ["🕜", [], "clock130,clock,face,one,thirty,time,late,early,schedule"]], "clock2": [[["🕑"]], ["🕑", [], "clock2,clock,face,two,oclock,time,late,early,schedule"]], "clock230": [[["🕝"]], ["🕝", [], "clock230,clock,face,two,thirty,time,late,early,schedule"]], "clock3": [[["🕒"]], ["🕒", [], "clock3,clock,face,three,oclock,time,late,early,schedule"]], "clock330": [[["🕞"]], ["🕞", [], "clock330,clock,face,three,thirty,time,late,early,schedule"]], "clock4": [[["🕓"]], ["🕓", [], "clock4,clock,face,four,oclock,time,late,early,schedule"]], "clock430": [[["🕟"]], ["🕟", [], "clock430,clock,face,four,thirty,time,late,early,schedule"]], "clock5": [[["🕔"]], ["🕔", [], "clock5,clock,face,five,oclock,time,late,early,schedule"]], "clock530": [[["🕠"]], ["🕠", [], "clock530,clock,face,five,thirty,time,late,early,schedule"]], "clock6": [[["🕕"]], ["🕕", [], "clock6,clock,face,six,oclock,time,late,early,schedule,dawn,dusk"]], "clock630": [[["🕡"]], ["🕡", [], "clock630,clock,face,six,thirty,time,late,early,schedule"]], "clock7": [[["🕖"]], ["🕖", [], "clock7,clock,face,seven,oclock,time,late,early,schedule"]], "clock730": [[["🕢"]], ["🕢", [], "clock730,clock,face,seven,thirty,time,late,early,schedule"]], "clock8": [[["🕗"]], ["🕗", [], "clock8,clock,face,eight,oclock,time,late,early,schedule"]], "clock830": [[["🕣"]], ["🕣", [], "clock830,clock,face,eight,thirty,time,late,early,schedule"]], "clock9": [[["🕘"]], ["🕘", [], "clock9,clock,face,nine,oclock,time,late,early,schedule"]], "clock930": [[["🕤"]], ["🕤", [], "clock930,clock,face,nine,thirty,time,late,early,schedule"]], "clock10": [[["🕙"]], ["🕙", [], "clock10,clock,face,ten,oclock,time,late,early,schedule"]], "clock1030": [[["🕥"]], ["🕥", [], "clock1030,clock,face,ten,thirty,time,late,early,schedule"]], "clock11": [[["🕚"]], ["🕚", [], "clock11,clock,face,eleven,oclock,time,late,early,schedule"]], "clock1130": [[["🕦"]], ["🕦", [], "clock1130,clock,face,eleven,thirty,time,late,early,schedule"]], "new_moon": [[["🌑"]], ["🌑", [], "new,moon,symbol,nature,twilight,planet,space,night,evening,sleep"]], "waxing_crescent_moon": [[["🌒"]], ["🌒", [], "waxing,crescent,moon,symbol,nature,twilight,planet,space,night,evening,sleep"]], "first_quarter_moon": [[["🌓"]], ["🌓", [], "first,quarter,moon,symbol,nature,twilight,planet,space,night,evening,sleep"]], "moon": [[["🌔"]], ["🌔", ["waxing_gibbous_moon"], "moon,waxing,gibbous,symbol"]], "full_moon": [[["🌕"]], ["🌕", [], "full,moon,symbol,nature,yellow,twilight,planet,space,night,evening,sleep"]], "waning_gibbous_moon": [[["🌖"]], ["🌖", [], "waning,gibbous,moon,symbol,nature,twilight,planet,space,night,evening,sleep,waxing_gibbous_moon"]], "last_quarter_moon": [[["🌗"]], ["🌗", [], "last,quarter,moon,symbol,nature,twilight,planet,space,night,evening,sleep"]], "waning_crescent_moon": [[["🌘"]], ["🌘", [], "waning,crescent,moon,symbol,nature,twilight,planet,space,night,evening,sleep"]], "crescent_moon": [[["🌙"]], ["🌙", [], "crescent,moon,night,sleep,sky,evening,magic"]], "new_moon_with_face": [[["🌚"]], ["🌚", [], "new,moon,with,face,nature,twilight,planet,space,night,evening,sleep"]], "first_quarter_moon_with_face": [[["🌛"]], ["🌛", [], "first,quarter,moon,with,face,nature,twilight,planet,space,night,evening,sleep"]], "last_quarter_moon_with_face": [[["🌜"]], ["🌜", [], "last,quarter,moon,with,face,nature,twilight,planet,space,night,evening,sleep"]], "thermometer": [[["🌡"], ["🌡️", "1f321"]], ["🌡️", [], "thermometer,weather,temperature,hot,cold"]], "sunny": [[["☀"], ["☀️", "2600"]], ["☀️", [], "sunny,black,sun,with,rays,weather,nature,brightness,summer,beach,spring", "2600-FE0F"]], "full_moon_with_face": [[["🌝"]], ["🌝", [], "full,moon,with,face,nature,twilight,planet,space,night,evening,sleep"]], "sun_with_face": [[["🌞"]], ["🌞", [], "sun,with,face,nature,morning,sky"]], "star": [[["⭐"]], ["⭐", [], "star,white,medium,night,yellow"]], "star2": [[["🌟"]], ["🌟", [], "star2,glowing,star,night,sparkle,awesome,good,magic"]], "stars": [[["🌠"]], ["🌠", [], "stars,shooting,star,night,photo"]], "cloud": [[["☁"], ["☁️", "2601"]], ["☁️", [], "cloud,weather,sky", "2601-FE0F"]], "partly_sunny": [[["⛅"]], ["⛅", [], "partly,sunny,sun,behind,cloud,weather,nature,cloudy,morning,fall,spring"]], "thunder_cloud_and_rain": [[["⛈"], ["⛈️", "26c8"]], ["⛈️", [], "thunder,cloud,and,rain", "26C8-FE0F"]], "mostly_sunny": [[["🌤"], ["🌤️", "1f324"]], ["🌤️", ["sun_small_cloud"], "mostly,sunny,sun,small,cloud"]], "barely_sunny": [[["🌥"], ["🌥️", "1f325"]], ["🌥️", ["sun_behind_cloud"], "barely,sunny,sun,behind,cloud"]], "partly_sunny_rain": [[["🌦"], ["🌦️", "1f326"]], ["🌦️", ["sun_behind_rain_cloud"], "partly,sunny,rain,sun,behind,cloud"]], "rain_cloud": [[["🌧"], ["🌧️", "1f327"]], ["🌧️", [], "rain,cloud"]], "snow_cloud": [[["🌨"], ["🌨️", "1f328"]], ["🌨️", [], "snow,cloud"]], "lightning": [[["🌩"], ["🌩️", "1f329"]], ["🌩️", ["lightning_cloud"], "lightning,cloud"]], "tornado": [[["🌪"], ["🌪️", "1f32a"]], ["🌪️", ["tornado_cloud"], "tornado,cloud,weather,cyclone,twister"]], "fog": [[["🌫"], ["🌫️", "1f32b"]], ["🌫️", [], "fog,weather"]], "wind_blowing_face": [[["🌬"], ["🌬️", "1f32c"]], ["🌬️", [], "wind,blowing,face"]], "cyclone": [[["🌀"]], ["🌀", [], "cyclone,weather,swirl,blue,cloud,vortex,spiral,whirlpool,spin,tornado,hurricane,typhoon"]], "rainbow": [[["🌈"]], ["🌈", [], "rainbow,nature,happy,unicorn_face,photo,sky,spring"]], "closed_umbrella": [[["🌂"]], ["🌂", [], "closed,umbrella,weather,rain,drizzle"]], "umbrella": [[["☂"], ["☂️", "2602"]], ["☂️", [], "umbrella,rainy,weather,spring", "2602-FE0F"]], "umbrella_with_rain_drops": [[["☔"]], ["☔", [], "umbrella,with,rain,drops"]], "umbrella_on_ground": [[["⛱"], ["⛱️", "26f1"]], ["⛱️", [], "umbrella,on,ground", "26F1-FE0F"]], "zap": [[["⚡"]], ["⚡", [], "zap,high,voltage,sign,thunder,weather,lightning bolt,fast"]], "snowflake": [[["❄"], ["❄️", "2744"]], ["❄️", [], "snowflake,winter,season,cold,weather,christmas,xmas", "2744-FE0F"]], "snowman": [[["☃"], ["☃️", "2603"]], ["☃️", [], "snowman,winter,season,cold,weather,christmas,xmas,frozen,without_snow", "2603-FE0F"]], "snowman_without_snow": [[["⛄"]], ["⛄", [], "snowman,without,snow"]], "comet": [[["☄"], ["☄️", "2604"]], ["☄️", [], "comet,space", "2604-FE0F"]], "fire": [[["🔥"]], ["🔥", [], "fire,hot,cook,flame"]], "droplet": [[["💧"]], ["💧", [], "droplet,water,drip,faucet,spring"]], "ocean": [[["🌊"]], ["🌊", [], "ocean,water,wave,sea,nature,tsunami,disaster"]], "jack_o_lantern": [[["🎃"]], ["🎃", [], "jack,o,lantern,halloween,light,pumpkin,creepy,fall"]], "christmas_tree": [[["🎄"]], ["🎄", [], "christmas,tree,festival,vacation,december,xmas,celebration"]], "fireworks": [[["🎆"]], ["🎆", [], "fireworks,photo,festival,carnival,congratulations"]], "sparkler": [[["🎇"]], ["🎇", [], "sparkler,firework,stars,night,shine"]], "sparkles": [[["✨"]], ["✨", [], "sparkles,stars,shine,shiny,cool,awesome,good,magic"]], "balloon": [[["🎈"]], ["🎈", [], "balloon,party,celebration,birthday,circus"]], "tada": [[["🎉"]], ["🎉", [], "tada,party,popper,congratulations,birthday,magic,circus,celebration"]], "confetti_ball": [[["🎊"]], ["🎊", [], "confetti,ball,festival,party,birthday,circus"]], "tanabata_tree": [[["🎋"]], ["🎋", [], "tanabata,tree,plant,nature,branch,summer"]], "bamboo": [[["🎍"]], ["🎍", [], "bamboo,pine,decoration,plant,nature,vegetable,panda,pine_decoration"]], "dolls": [[["🎎"]], ["🎎", [], "dolls,japanese,toy,kimono"]], "flags": [[["🎏"]], ["🎏", [], "flags,carp,streamer,fish,japanese,koinobori,banner"]], "wind_chime": [[["🎐"]], ["🎐", [], "wind,chime,nature,ding,spring,bell"]], "rice_scene": [[["🎑"]], ["🎑", [], "rice,scene,moon,viewing,ceremony,photo,japan,asia,tsukimi"]], "ribbon": [[["🎀"]], ["🎀", [], "ribbon,decoration,pink,girl,bowtie"]], "gift": [[["🎁"]], ["🎁", [], "gift,wrapped,present,birthday,christmas,xmas"]], "reminder_ribbon": [[["🎗"], ["🎗️", "1f397"]], ["🎗️", [], "reminder,ribbon,sports,cause,support,awareness"]], "admission_tickets": [[["🎟"], ["🎟️", "1f39f"]], ["🎟️", [], "admission,tickets"]], "ticket": [[["🎫"]], ["🎫", [], "ticket,event,concert,pass"]], "medal": [[["🎖"], ["🎖️", "1f396"]], ["🎖️", [], "medal"]], "trophy": [[["🏆"]], ["🏆", [], "trophy,win,award,contest,place,ftw,ceremony"]], "sports_medal": [[["🏅"]], ["🏅", [], "sports,medal"]], "first_place_medal": [[["🥇"]], ["🥇", [], "first,place,medal"]], "second_place_medal": [[["🥈"]], ["🥈", [], "second,place,medal"]], "third_place_medal": [[["🥉"]], ["🥉", [], "third,place,medal"]], "soccer": [[["⚽"]], ["⚽", [], "soccer,ball,sports,football"]], "baseball": [[["⚾"]], ["⚾", [], "baseball,sports,balls"]], "basketball": [[["🏀"]], ["🏀", [], "basketball,and,hoop,sports,balls,nba"]], "volleyball": [[["🏐"]], ["🏐", [], "volleyball,sports,balls"]], "football": [[["🏈"]], ["🏈", [], "football,american,sports,balls,nfl"]], "rugby_football": [[["🏉"]], ["🏉", [], "rugby,football,sports,team"]], "tennis": [[["🎾"]], ["🎾", [], "tennis,racquet,and,ball,sports,balls,green"]], "8ball": [[["🎱"]], ["🎱", [], "8ball,billiards,pool,hobby,game,luck,magic"]], "bowling": [[["🎳"]], ["🎳", [], "bowling,sports,fun,play"]], "cricket_bat_and_ball": [[["🏏"]], ["🏏", [], "cricket,bat,and,ball"]], "field_hockey_stick_and_ball": [[["🏑"]], ["🏑", [], "field,hockey,stick,and,ball"]], "ice_hockey_stick_and_puck": [[["🏒"]], ["🏒", [], "ice,hockey,stick,and,puck"]], "table_tennis_paddle_and_ball": [[["🏓"]], ["🏓", [], "table,tennis,paddle,and,ball"]], "badminton_racquet_and_shuttlecock": [[["🏸"]], ["🏸", [], "badminton,racquet,and,shuttlecock"]], "boxing_glove": [[["🥊"]], ["🥊", [], "boxing,glove,sports,fighting"]], "martial_arts_uniform": [[["🥋"]], ["🥋", [], "martial,arts,uniform,judo,karate,taekwondo"]], "goal_net": [[["🥅"]], ["🥅", [], "goal,net,sports"]], "dart": [[["🎯"]], ["🎯", [], "dart,direct,hit,game,play,bar"]], "golf": [[["⛳"]], ["⛳", [], "golf,flag,in,hole,sports,business,summer"]], "ice_skate": [[["⛸"], ["⛸️", "26f8"]], ["⛸️", [], "ice,skate,sports", "26F8-FE0F"]], "fishing_pole_and_fish": [[["🎣"]], ["🎣", [], "fishing,pole,and,fish,food,hobby,summer"]], "running_shirt_with_sash": [[["🎽"]], ["🎽", [], "running,shirt,with,sash,play,pageant"]], "ski": [[["🎿"]], ["🎿", [], "ski,and,boot,sports,winter,cold,snow"]], "sled": [[["🛷"]], ["🛷", [], "sled"]], "curling_stone": [[["🥌"]], ["🥌", [], "curling,stone"]], "video_game": [[["🎮"]], ["🎮", [], "video,game,play,console,ps4,controller"]], "joystick": [[["🕹"], ["🕹️", "1f579"]], ["🕹️", [], "joystick,game,play"]], "game_die": [[["🎲"]], ["🎲", [], "game,die,dice,random,tabletop,play,luck"]], "spades": [[["♠"], ["♠️", "2660"]], ["♠️", [], "spades,black,spade,suit,poker,cards,suits,magic", "2660-FE0F"]], "hearts": [[["♥"], ["♥️", "2665"]], ["♥️", [], "hearts,black,heart,suit,poker,cards,magic,suits", "2665-FE0F"]], "diamonds": [[["♦"], ["♦️", "2666"]], ["♦️", [], "diamonds,black,diamond,suit,poker,cards,magic,suits", "2666-FE0F"]], "clubs": [[["♣"], ["♣️", "2663"]], ["♣️", [], "clubs,black,club,suit,poker,cards,magic,suits", "2663-FE0F"]], "black_joker": [[["🃏"]], ["🃏", [], "black,joker,playing,card,poker,cards,game,play,magic"]], "mahjong": [[["🀄"]], ["🀄", [], "mahjong,tile,red,dragon,game,play,chinese,kanji"]], "flower_playing_cards": [[["🎴"]], ["🎴", [], "flower,playing,cards,game,sunset,red"]], "mute": [[["🔇"]], ["🔇", [], "mute,speaker,with,cancellation,stroke,sound,volume,silence,quiet"]], "speaker": [[["🔈"]], ["🔈", [], "speaker,sound,volume,silence,broadcast"]], "sound": [[["🔉"]], ["🔉", [], "sound,speaker,with,one,wave,volume,broadcast"]], "loud_sound": [[["🔊"]], ["🔊", [], "loud,sound,speaker,with,three,waves,volume,noise,noisy,broadcast"]], "loudspeaker": [[["📢"]], ["📢", [], "loudspeaker,public,address,volume,sound"]], "mega": [[["📣"]], ["📣", [], "mega,cheering,megaphone,sound,speaker,volume"]], "postal_horn": [[["📯"]], ["📯", [], "postal,horn,instrument,music"]], "bell": [[["🔔"]], ["🔔", [], "bell,sound,notification,christmas,xmas,chime"]], "no_bell": [[["🔕"]], ["🔕", [], "no,bell,with,cancellation,stroke,sound,volume,mute,quiet,silent"]], "musical_score": [[["🎼"]], ["🎼", [], "musical,score,treble,clef,compose"]], "musical_note": [[["🎵"]], ["🎵", [], "musical,note,score,tone,sound"]], "notes": [[["🎶"]], ["🎶", [], "notes,multiple,musical,music,score"]], "studio_microphone": [[["🎙"], ["🎙️", "1f399"]], ["🎙️", [], "studio,microphone,sing,recording,artist,talkshow"]], "level_slider": [[["🎚"], ["🎚️", "1f39a"]], ["🎚️", [], "level,slider,scale"]], "control_knobs": [[["🎛"], ["🎛️", "1f39b"]], ["🎛️", [], "control,knobs,dial"]], "microphone": [[["🎤"]], ["🎤", [], "microphone,sound,music,pa,sing,talkshow"]], "headphones": [[["🎧"]], ["🎧", [], "headphones,headphone,music,score,gadgets"]], "radio": [[["📻"]], ["📻", [], "radio,communication,music,podcast,program"]], "saxophone": [[["🎷"]], ["🎷", [], "saxophone,music,instrument,jazz,blues"]], "guitar": [[["🎸"]], ["🎸", [], "guitar,music,instrument"]], "musical_keyboard": [[["🎹"]], ["🎹", [], "musical,keyboard,piano,instrument,compose"]], "trumpet": [[["🎺"]], ["🎺", [], "trumpet,music,brass"]], "violin": [[["🎻"]], ["🎻", [], "violin,music,instrument,orchestra,symphony"]], "drum_with_drumsticks": [[["🥁"]], ["🥁", [], "drum,with,drumsticks"]], "iphone": [[["📱"]], ["📱", [], "iphone,mobile,phone,technology,apple,gadgets,dial"]], "calling": [[["📲"]], ["📲", [], "calling,mobile,phone,with,rightwards,arrow,at,left,iphone,incoming"]], "phone": [[["☎"], ["☎️", "260e"]], ["☎️", ["telephone"], "phone,telephone,black,technology,communication,dial", "260E-FE0F"]], "telephone_receiver": [[["📞"]], ["📞", [], "telephone,receiver,technology,communication,dial"]], "pager": [[["📟"]], ["📟", [], "pager,bbcall,oldschool,90s"]], "fax": [[["📠"]], ["📠", [], "fax,machine,communication,technology"]], "battery": [[["🔋"]], ["🔋", [], "battery,power,energy,sustain"]], "electric_plug": [[["🔌"]], ["🔌", [], "electric,plug,charger,power"]], "computer": [[["💻"]], ["💻", [], "computer,personal,technology,laptop,screen,display,monitor"]], "desktop_computer": [[["🖥"], ["🖥️", "1f5a5"]], ["🖥️", [], "desktop,computer,technology,computing,screen"]], "printer": [[["🖨"], ["🖨️", "1f5a8"]], ["🖨️", [], "printer,paper,ink"]], "keyboard": [[["⌨"], ["⌨️", "2328"]], ["⌨️", [], "keyboard,technology,computer,type,input,text", "2328-FE0F"]], "three_button_mouse": [[["🖱"], ["🖱️", "1f5b1"]], ["🖱️", [], "three,button,mouse"]], "trackball": [[["🖲"], ["🖲️", "1f5b2"]], ["🖲️", [], "trackball,technology,trackpad"]], "minidisc": [[["💽"]], ["💽", [], "minidisc,technology,record,data,disk,90s"]], "floppy_disk": [[["💾"]], ["💾", [], "floppy,disk,oldschool,technology,save,90s,80s"]], "cd": [[["💿"]], ["💿", [], "cd,optical,disc,technology,dvd,disk,90s"]], "dvd": [[["📀"]], ["📀", [], "dvd,cd,disk,disc"]], "movie_camera": [[["🎥"]], ["🎥", [], "movie,camera,film,record"]], "film_frames": [[["🎞"], ["🎞️", "1f39e"]], ["🎞️", [], "film,frames"]], "film_projector": [[["📽"], ["📽️", "1f4fd"]], ["📽️", [], "film,projector,video,tape,record,movie"]], "clapper": [[["🎬"]], ["🎬", [], "clapper,board,movie,film,record"]], "tv": [[["📺"]], ["📺", [], "tv,television,technology,program,oldschool,show"]], "camera": [[["📷"]], ["📷", [], "camera,gadgets,photography"]], "camera_with_flash": [[["📸"]], ["📸", [], "camera,with,flash"]], "video_camera": [[["📹"]], ["📹", [], "video,camera,film,record"]], "vhs": [[["📼"]], ["📼", [], "vhs,videocassette,record,video,oldschool,90s,80s"]], "mag": [[["🔍"]], ["🔍", [], "mag,left,pointing,magnifying,glass,search,zoom,find,detective"]], "mag_right": [[["🔎"]], ["🔎", [], "mag,right,pointing,magnifying,glass,search,zoom,find,detective"]], "microscope": [[["🔬"]], ["🔬", [], "microscope,laboratory,experiment,zoomin,science,study"]], "telescope": [[["🔭"]], ["🔭", [], "telescope,stars,space,zoom,science,astronomy"]], "satellite_antenna": [[["📡"]], ["📡", [], "satellite,antenna"]], "candle": [[["🕯"], ["🕯️", "1f56f"]], ["🕯️", [], "candle,fire,wax"]], "bulb": [[["💡"]], ["💡", [], "bulb,electric,light,electricity,idea"]], "flashlight": [[["🔦"]], ["🔦", [], "flashlight,electric,torch,dark,camping,sight,night"]], "izakaya_lantern": [[["🏮"]], ["🏮", ["lantern"], "izakaya,lantern,light,paper,halloween,spooky"]], "notebook_with_decorative_cover": [[["📔"]], ["📔", [], "notebook,with,decorative,cover,classroom,notes,record,paper,study"]], "closed_book": [[["📕"]], ["📕", [], "closed,book,read,library,knowledge,textbook,learn"]], "book": [[["📖"]], ["📖", ["open_book"], "book,open"]], "green_book": [[["📗"]], ["📗", [], "green,book,read,library,knowledge,study"]], "blue_book": [[["📘"]], ["📘", [], "blue,book,read,library,knowledge,learn,study"]], "orange_book": [[["📙"]], ["📙", [], "orange,book,read,library,knowledge,textbook,study"]], "books": [[["📚"]], ["📚", [], "books,literature,library,study"]], "notebook": [[["📓"]], ["📓", [], "notebook,stationery,record,notes,paper,study"]], "ledger": [[["📒"]], ["📒", [], "ledger,notes,paper"]], "page_with_curl": [[["📃"]], ["📃", [], "page,with,curl,documents,office,paper"]], "scroll": [[["📜"]], ["📜", [], "scroll,documents,ancient,history,paper"]], "page_facing_up": [[["📄"]], ["📄", [], "page,facing,up,documents,office,paper,information"]], "newspaper": [[["📰"]], ["📰", [], "newspaper,press,headline"]], "rolled_up_newspaper": [[["🗞"], ["🗞️", "1f5de"]], ["🗞️", [], "rolled,up,newspaper"]], "bookmark_tabs": [[["📑"]], ["📑", [], "bookmark,tabs,favorite,save,order,tidy"]], "bookmark": [[["🔖"]], ["🔖", [], "bookmark,favorite,label,save"]], "label": [[["🏷"], ["🏷️", "1f3f7"]], ["🏷️", [], "label,sale,tag"]], "moneybag": [[["💰"]], ["💰", [], "moneybag,money,bag,dollar,payment,coins,sale"]], "yen": [[["💴"]], ["💴", [], "yen,banknote,with,sign,money,sales,japanese,dollar,currency"]], "dollar": [[["💵"]], ["💵", [], "dollar,banknote,with,sign,money,sales,bill,currency"]], "euro": [[["💶"]], ["💶", [], "euro,banknote,with,sign,money,sales,dollar,currency"]], "pound": [[["💷"]], ["💷", [], "pound,banknote,with,sign,british,sterling,money,sales,bills,uk,england,currency"]], "money_with_wings": [[["💸"]], ["💸", [], "money,with,wings,dollar,bills,payment,sale"]], "credit_card": [[["💳"]], ["💳", [], "credit,card,money,sales,dollar,bill,payment,shopping"]], "chart": [[["💹"]], ["💹", [], "chart,with,upwards,trend,and,yen,sign,green-square,graph,presentation,stats"]], "currency_exchange": [[["💱"]], ["💱", [], "currency,exchange,money,sales,dollar,travel"]], "heavy_dollar_sign": [[["💲"]], ["💲", [], "heavy,dollar,sign,money,sales,payment,currency,buck"]], "email": [[["✉"], ["✉️", "2709"]], ["✉️", ["envelope"], "email,envelope,letter,postal,inbox,communication", "2709-FE0F"]], "e-mail": [[["📧"]], ["📧", [], "e,mail,symbol,communication,inbox"]], "incoming_envelope": [[["📨"]], ["📨", [], "incoming,envelope,email,inbox"]], "envelope_with_arrow": [[["📩"]], ["📩", [], "envelope,with,arrow,downwards,above,email,communication"]], "outbox_tray": [[["📤"]], ["📤", [], "outbox,tray,inbox,email"]], "inbox_tray": [[["📥"]], ["📥", [], "inbox,tray,email,documents"]], "package": [[["📦"]], ["📦", [], "package,mail,gift,cardboard,box,moving"]], "mailbox": [[["📫"]], ["📫", [], "mailbox,closed,with,raised,flag,email,inbox,communication"]], "mailbox_closed": [[["📪"]], ["📪", [], "mailbox,closed,with,lowered,flag,email,communication,inbox"]], "mailbox_with_mail": [[["📬"]], ["📬", [], "mailbox,with,mail,open,raised,flag,email,inbox,communication"]], "mailbox_with_no_mail": [[["📭"]], ["📭", [], "mailbox,with,no,mail,open,lowered,flag,email,inbox"]], "postbox": [[["📮"]], ["📮", [], "postbox,email,letter,envelope"]], "ballot_box_with_ballot": [[["🗳"], ["🗳️", "1f5f3"]], ["🗳️", [], "ballot,box,with"]], "pencil2": [[["✏"], ["✏️", "270f"]], ["✏️", [], "pencil2,pencil,stationery,write,paper,writing,school,study", "270F-FE0F"]], "black_nib": [[["✒"], ["✒️", "2712"]], ["✒️", [], "black,nib,pen,stationery,writing,write", "2712-FE0F"]], "lower_left_fountain_pen": [[["🖋"], ["🖋️", "1f58b"]], ["🖋️", [], "lower,left,fountain,pen"]], "lower_left_ballpoint_pen": [[["🖊"], ["🖊️", "1f58a"]], ["🖊️", [], "lower,left,ballpoint,pen"]], "lower_left_paintbrush": [[["🖌"], ["🖌️", "1f58c"]], ["🖌️", [], "lower,left,paintbrush"]], "lower_left_crayon": [[["🖍"], ["🖍️", "1f58d"]], ["🖍️", [], "lower,left,crayon"]], "memo": [[["📝"]], ["📝", ["pencil"], "memo,pencil,write,documents,stationery,paper,writing,legal,exam,quiz,test,study,compose"]], "briefcase": [[["💼"]], ["💼", [], "briefcase,business,documents,work,law,legal,job,career"]], "file_folder": [[["📁"]], ["📁", [], "file,folder,documents,business,office"]], "open_file_folder": [[["📂"]], ["📂", [], "open,file,folder,documents,load"]], "card_index_dividers": [[["🗂"], ["🗂️", "1f5c2"]], ["🗂️", [], "card,index,dividers,organizing,business,stationery"]], "date": [[["📅"]], ["📅", [], "date,calendar,schedule"]], "calendar": [[["📆"]], ["📆", [], "calendar,tear,off,schedule,date,planning"]], "spiral_note_pad": [[["🗒"], ["🗒️", "1f5d2"]], ["🗒️", [], "spiral,note,pad"]], "spiral_calendar_pad": [[["🗓"], ["🗓️", "1f5d3"]], ["🗓️", [], "spiral,calendar,pad"]], "card_index": [[["📇"]], ["📇", [], "card,index,business,stationery"]], "chart_with_upwards_trend": [[["📈"]], ["📈", [], "chart,with,upwards,trend,graph,presentation,stats,recovery,business,economics,money,sales,good,success"]], "chart_with_downwards_trend": [[["📉"]], ["📉", [], "chart,with,downwards,trend,graph,presentation,stats,recession,business,economics,money,sales,bad,failure"]], "bar_chart": [[["📊"]], ["📊", [], "bar,chart,graph,presentation,stats"]], "clipboard": [[["📋"]], ["📋", [], "clipboard,stationery,documents"]], "pushpin": [[["📌"]], ["📌", [], "pushpin,stationery,mark,here"]], "round_pushpin": [[["📍"]], ["📍", [], "round,pushpin,stationery,location,map,here"]], "paperclip": [[["📎"]], ["📎", [], "paperclip,documents,stationery"]], "linked_paperclips": [[["🖇"], ["🖇️", "1f587"]], ["🖇️", [], "linked,paperclips"]], "straight_ruler": [[["📏"]], ["📏", [], "straight,ruler,stationery,calculate,length,math,school,drawing,architect,sketch"]], "triangular_ruler": [[["📐"]], ["📐", [], "triangular,ruler,stationery,math,architect,sketch"]], "scissors": [[["✂"], ["✂️", "2702"]], ["✂️", [], "scissors,black,stationery,cut", "2702-FE0F"]], "card_file_box": [[["🗃"], ["🗃️", "1f5c3"]], ["🗃️", [], "card,file,box,business,stationery"]], "file_cabinet": [[["🗄"], ["🗄️", "1f5c4"]], ["🗄️", [], "file,cabinet,filing,organizing"]], "wastebasket": [[["🗑"], ["🗑️", "1f5d1"]], ["🗑️", [], "wastebasket,bin,trash,rubbish,garbage,toss"]], "lock": [[["🔒"]], ["🔒", [], "lock,security,password,padlock"]], "unlock": [[["🔓"]], ["🔓", [], "unlock,open,lock,privacy,security"]], "lock_with_ink_pen": [[["🔏"]], ["🔏", [], "lock,with,ink,pen,security,secret"]], "closed_lock_with_key": [[["🔐"]], ["🔐", [], "closed,lock,with,key,security,privacy"]], "key": [[["🔑"]], ["🔑", [], "key,lock,door,password"]], "old_key": [[["🗝"], ["🗝️", "1f5dd"]], ["🗝️", [], "old,key,lock,door,password"]], "hammer": [[["🔨"]], ["🔨", [], "hammer,tools,build,create"]], "pick": [[["⛏"], ["⛏️", "26cf"]], ["⛏️", [], "pick,tools,dig", "26CF-FE0F"]], "hammer_and_pick": [[["⚒"], ["⚒️", "2692"]], ["⚒️", [], "hammer,and,pick,tools,build,create", "2692-FE0F"]], "hammer_and_wrench": [[["🛠"], ["🛠️", "1f6e0"]], ["🛠️", [], "hammer,and,wrench,tools,build,create"]], "dagger_knife": [[["🗡"], ["🗡️", "1f5e1"]], ["🗡️", [], "dagger,knife"]], "crossed_swords": [[["⚔"], ["⚔️", "2694"]], ["⚔️", [], "crossed,swords,weapon", "2694-FE0F"]], "gun": [[["🔫"]], ["🔫", [], "gun,pistol,violence,weapon,revolver"]], "bow_and_arrow": [[["🏹"]], ["🏹", [], "bow,and,arrow,sports"]], "shield": [[["🛡"], ["🛡️", "1f6e1"]], ["🛡️", [], "shield,protection,security"]], "wrench": [[["🔧"]], ["🔧", [], "wrench,tools,diy,ikea,fix,maintainer"]], "nut_and_bolt": [[["🔩"]], ["🔩", [], "nut,and,bolt,handy,tools,fix"]], "gear": [[["⚙"], ["⚙️", "2699"]], ["⚙️", [], "gear,cog", "2699-FE0F"]], "compression": [[["🗜"], ["🗜️", "1f5dc"]], ["🗜️", [], "compression"]], "alembic": [[["⚗"], ["⚗️", "2697"]], ["⚗️", [], "alembic,distilling,science,experiment,chemistry", "2697-FE0F"]], "scales": [[["⚖"], ["⚖️", "2696"]], ["⚖️", [], "scales", "2696-FE0F"]], "link": [[["🔗"]], ["🔗", [], "link,symbol,rings,url"]], "chains": [[["⛓"], ["⛓️", "26d3"]], ["⛓️", [], "chains,lock,arrest", "26D3-FE0F"]], "syringe": [[["💉"]], ["💉", [], "syringe,health,hospital,drugs,blood,medicine,needle,doctor,nurse"]], "pill": [[["💊"]], ["💊", [], "pill,health,medicine,doctor,pharmacy,drug"]], "smoking": [[["🚬"]], ["🚬", [], "smoking,symbol,kills,tobacco,cigarette,joint,smoke"]], "coffin": [[["⚰"], ["⚰️", "26b0"]], ["⚰️", [], "coffin,vampire,dead,die,death,rip,graveyard,cemetery,casket,funeral,box", "26B0-FE0F"]], "funeral_urn": [[["⚱"], ["⚱️", "26b1"]], ["⚱️", [], "funeral,urn,dead,die,death,rip,ashes", "26B1-FE0F"]], "moyai": [[["🗿"]], ["🗿", [], "moyai,rock,easter island,moai"]], "oil_drum": [[["🛢"], ["🛢️", "1f6e2"]], ["🛢️", [], "oil,drum,barrell"]], "crystal_ball": [[["🔮"]], ["🔮", [], "crystal,ball,disco,party,magic,circus,fortune_teller"]], "shopping_trolley": [[["🛒"]], ["🛒", [], "shopping,trolley"]], "atm": [[["🏧"]], ["🏧", [], "atm,automated,teller,machine,money,sales,cash,blue-square,payment,bank"]], "put_litter_in_its_place": [[["🚮"]], ["🚮", [], "put,litter,in,its,place,symbol,blue-square,sign,human,info"]], "potable_water": [[["🚰"]], ["🚰", [], "potable,water,symbol,blue-square,liquid,restroom,cleaning,faucet"]], "wheelchair": [[["♿"]], ["♿", [], "wheelchair,symbol,blue-square,disabled,a11y,accessibility"]], "mens": [[["🚹"]], ["🚹", [], "mens,symbol,toilet,restroom,wc,blue-square,gender,male"]], "womens": [[["🚺"]], ["🚺", [], "womens,symbol,purple-square,woman,female,toilet,loo,restroom,gender"]], "restroom": [[["🚻"]], ["🚻", [], "restroom,blue-square,toilet,refresh,wc,gender"]], "baby_symbol": [[["🚼"]], ["🚼", [], "baby,symbol,orange-square,child"]], "wc": [[["🚾"]], ["🚾", [], "wc,water,closet,toilet,restroom,blue-square"]], "passport_control": [[["🛂"]], ["🛂", [], "passport,control,custom,blue-square"]], "customs": [[["🛃"]], ["🛃", [], "customs,passport,border,blue-square"]], "baggage_claim": [[["🛄"]], ["🛄", [], "baggage,claim,blue-square,airport,transport"]], "left_luggage": [[["🛅"]], ["🛅", [], "left,luggage,blue-square,travel"]], "warning": [[["⚠"], ["⚠️", "26a0"]], ["⚠️", [], "warning,sign,exclamation,wip,alert,error,problem,issue", "26A0-FE0F"]], "children_crossing": [[["🚸"]], ["🚸", [], "children,crossing,school,warning,danger,sign,driving,yellow-diamond"]], "no_entry": [[["⛔"]], ["⛔", [], "no,entry,limit,security,privacy,bad,denied,stop,circle"]], "no_entry_sign": [[["🚫"]], ["🚫", [], "no,entry,sign,forbid,stop,limit,denied,disallow,circle"]], "no_bicycles": [[["🚳"]], ["🚳", [], "no,bicycles,cyclist,prohibited,circle"]], "no_smoking": [[["🚭"]], ["🚭", [], "no,smoking,symbol,cigarette,blue-square,smell,smoke"]], "do_not_litter": [[["🚯"]], ["🚯", [], "do,not,litter,symbol,trash,bin,garbage,circle"]], "non-potable_water": [[["🚱"]], ["🚱", [], "non,potable,water,symbol,drink,faucet,tap,circle"]], "no_pedestrians": [[["🚷"]], ["🚷", [], "no,pedestrians,rules,crossing,walking,circle"]], "no_mobile_phones": [[["📵"]], ["📵", [], "no,mobile,phones,iphone,mute,circle"]], "underage": [[["🔞"]], ["🔞", [], "underage,no,one,under,eighteen,symbol,18,drink,pub,night,minor,circle"]], "radioactive_sign": [[["☢"], ["☢️", "2622"]], ["☢️", [], "radioactive,sign", "2622-FE0F"]], "biohazard_sign": [[["☣"], ["☣️", "2623"]], ["☣️", [], "biohazard,sign", "2623-FE0F"]], "arrow_up": [[["⬆"], ["⬆️", "2b06"]], ["⬆️", [], "arrow,up,upwards,black,blue-square,continue,top,direction", "2B06-FE0F"]], "arrow_upper_right": [[["↗"], ["↗️", "2197"]], ["↗️", [], "arrow,upper,right,north,east,blue-square,point,direction,diagonal,northeast", "2197-FE0F"]], "arrow_right": [[["➡"], ["➡️", "27a1"]], ["➡️", [], "arrow,right,black,rightwards,blue-square,next", "27A1-FE0F"]], "arrow_lower_right": [[["↘"], ["↘️", "2198"]], ["↘️", [], "arrow,lower,right,south,east,blue-square,direction,diagonal,southeast", "2198-FE0F"]], "arrow_down": [[["⬇"], ["⬇️", "2b07"]], ["⬇️", [], "arrow,down,downwards,black,blue-square,direction,bottom", "2B07-FE0F"]], "arrow_lower_left": [[["↙"], ["↙️", "2199"]], ["↙️", [], "arrow,lower,left,south,west,blue-square,direction,diagonal,southwest", "2199-FE0F"]], "arrow_left": [[["⬅"], ["⬅️", "2b05"]], ["⬅️", [], "arrow,left,leftwards,black,blue-square,previous,back", "2B05-FE0F"]], "arrow_upper_left": [[["↖"], ["↖️", "2196"]], ["↖️", [], "arrow,upper,left,north,west,blue-square,point,direction,diagonal,northwest", "2196-FE0F"]], "arrow_up_down": [[["↕"], ["↕️", "2195"]], ["↕️", [], "arrow,up,down,blue-square,direction,way,vertical", "2195-FE0F"]], "left_right_arrow": [[["↔"], ["↔️", "2194"]], ["↔️", [], "left,right,arrow,shape,direction,horizontal,sideways", "2194-FE0F"]], "leftwards_arrow_with_hook": [[["↩"], ["↩️", "21a9"]], ["↩️", [], "leftwards,arrow,with,hook,back,return,blue-square,undo,enter", "21A9-FE0F"]], "arrow_right_hook": [[["↪"], ["↪️", "21aa"]], ["↪️", [], "arrow,right,hook,rightwards,with,blue-square,return,rotate,direction", "21AA-FE0F"]], "arrow_heading_up": [[["⤴"], ["⤴️", "2934"]], ["⤴️", [], "arrow,heading,up,pointing,rightwards,then,curving,upwards,blue-square,direction,top", "2934-FE0F"]], "arrow_heading_down": [[["⤵"], ["⤵️", "2935"]], ["⤵️", [], "arrow,heading,down,pointing,rightwards,then,curving,downwards,blue-square,direction,bottom", "2935-FE0F"]], "arrows_clockwise": [[["🔃"]], ["🔃", [], "arrows,clockwise,downwards,and,upwards,open,circle,sync,cycle,round,repeat"]], "arrows_counterclockwise": [[["🔄"]], ["🔄", [], "arrows,counterclockwise,anticlockwise,downwards,and,upwards,open,circle,blue-square,sync,cycle"]], "back": [[["🔙"]], ["🔙", [], "back,with,leftwards,arrow,above,words,return"]], "end": [[["🔚"]], ["🔚", [], "end,with,leftwards,arrow,above,words"]], "on": [[["🔛"]], ["🔛", [], "on,with,exclamation,mark,left,right,arrow,above,words"]], "soon": [[["🔜"]], ["🔜", [], "soon,with,rightwards,arrow,above,words"]], "top": [[["🔝"]], ["🔝", [], "top,with,upwards,arrow,above,words,blue-square"]], "place_of_worship": [[["🛐"]], ["🛐", [], "place,of,worship,religion,church,temple,prayer"]], "atom_symbol": [[["⚛"], ["⚛️", "269b"]], ["⚛️", [], "atom,symbol,science,physics,chemistry", "269B-FE0F"]], "om_symbol": [[["🕉"], ["🕉️", "1f549"]], ["🕉️", [], "om,symbol"]], "star_of_david": [[["✡"], ["✡️", "2721"]], ["✡️", [], "star,of,david,judaism", "2721-FE0F"]], "wheel_of_dharma": [[["☸"], ["☸️", "2638"]], ["☸️", [], "wheel,of,dharma,hinduism,buddhism,sikhism,jainism", "2638-FE0F"]], "yin_yang": [[["☯"], ["☯️", "262f"]], ["☯️", [], "yin,yang,balance", "262F-FE0F"]], "latin_cross": [[["✝"], ["✝️", "271d"]], ["✝️", [], "latin,cross,christianity", "271D-FE0F"]], "orthodox_cross": [[["☦"], ["☦️", "2626"]], ["☦️", [], "orthodox,cross,suppedaneum,religion", "2626-FE0F"]], "star_and_crescent": [[["☪"], ["☪️", "262a"]], ["☪️", [], "star,and,crescent,islam", "262A-FE0F"]], "peace_symbol": [[["☮"], ["☮️", "262e"]], ["☮️", [], "peace,symbol,hippie", "262E-FE0F"]], "menorah_with_nine_branches": [[["🕎"]], ["🕎", [], "menorah,with,nine,branches"]], "six_pointed_star": [[["🔯"]], ["🔯", [], "six,pointed,star,with,middle,dot,purple-square,religion,jewish,hexagram"]], "aries": [[["♈"]], ["♈", [], "aries,sign,purple-square,zodiac,astrology"]], "taurus": [[["♉"]], ["♉", [], "taurus,purple-square,sign,zodiac,astrology"]], "gemini": [[["♊"]], ["♊", [], "gemini,sign,zodiac,purple-square,astrology"]], "cancer": [[["♋"]], ["♋", [], "cancer,sign,zodiac,purple-square,astrology"]], "leo": [[["♌"]], ["♌", [], "leo,sign,purple-square,zodiac,astrology"]], "virgo": [[["♍"]], ["♍", [], "virgo,sign,zodiac,purple-square,astrology"]], "libra": [[["♎"]], ["♎", [], "libra,sign,purple-square,zodiac,astrology"]], "scorpius": [[["♏"]], ["♏", [], "scorpius,sign,zodiac,purple-square,astrology,scorpio"]], "sagittarius": [[["♐"]], ["♐", [], "sagittarius,sign,zodiac,purple-square,astrology"]], "capricorn": [[["♑"]], ["♑", [], "capricorn,sign,zodiac,purple-square,astrology"]], "aquarius": [[["♒"]], ["♒", [], "aquarius,sign,purple-square,zodiac,astrology"]], "pisces": [[["♓"]], ["♓", [], "pisces,purple-square,sign,zodiac,astrology"]], "ophiuchus": [[["⛎"]], ["⛎", [], "ophiuchus,sign,purple-square,constellation,astrology"]], "twisted_rightwards_arrows": [[["🔀"]], ["🔀", [], "twisted,rightwards,arrows,blue-square,shuffle,music,random"]], "repeat": [[["🔁"]], ["🔁", [], "repeat,clockwise,rightwards,and,leftwards,open,circle,arrows,loop,record"]], "repeat_one": [[["🔂"]], ["🔂", [], "repeat,one,clockwise,rightwards,and,leftwards,open,circle,arrows,with,circled,overlay,blue-square,loop"]], "arrow_forward": [[["▶"], ["▶️", "25b6"]], ["▶️", [], "arrow,forward,black,right,pointing,triangle,blue-square,direction,play", "25B6-FE0F"]], "fast_forward": [[["⏩"]], ["⏩", [], "fast,forward,black,right,pointing,double,triangle,blue-square,play,speed,continue"]], "black_right_pointing_double_triangle_with_vertical_bar": [[["⏭"], ["⏭️", "23ed"]], ["⏭️", [], "black,right,pointing,double,triangle,with,vertical,bar", "23ED-FE0F"]], "black_right_pointing_triangle_with_double_vertical_bar": [[["⏯"], ["⏯️", "23ef"]], ["⏯️", [], "black,right,pointing,triangle,with,double,vertical,bar", "23EF-FE0F"]], "arrow_backward": [[["◀"], ["◀️", "25c0"]], ["◀️", [], "arrow,backward,black,left,pointing,triangle,blue-square,direction", "25C0-FE0F"]], "rewind": [[["⏪"]], ["⏪", [], "rewind,black,left,pointing,double,triangle,play,blue-square"]], "black_left_pointing_double_triangle_with_vertical_bar": [[["⏮"], ["⏮️", "23ee"]], ["⏮️", [], "black,left,pointing,double,triangle,with,vertical,bar", "23EE-FE0F"]], "arrow_up_small": [[["🔼"]], ["🔼", [], "arrow,up,small,pointing,red,triangle,blue-square,direction,point,forward,top"]], "arrow_double_up": [[["⏫"]], ["⏫", [], "arrow,double,up,black,pointing,triangle,blue-square,direction,top"]], "arrow_down_small": [[["🔽"]], ["🔽", [], "arrow,down,small,pointing,red,triangle,blue-square,direction,bottom"]], "arrow_double_down": [[["⏬"]], ["⏬", [], "arrow,double,down,black,pointing,triangle,blue-square,direction,bottom"]], "double_vertical_bar": [[["⏸"], ["⏸️", "23f8"]], ["⏸️", [], "double,vertical,bar", "23F8-FE0F"]], "black_square_for_stop": [[["⏹"], ["⏹️", "23f9"]], ["⏹️", [], "black,square,for,stop", "23F9-FE0F"]], "black_circle_for_record": [[["⏺"], ["⏺️", "23fa"]], ["⏺️", [], "black,circle,for,record", "23FA-FE0F"]], "eject": [[["⏏"], ["⏏️", "23cf"]], ["⏏️", [], "eject", "23CF-FE0F"]], "cinema": [[["🎦"]], ["🎦", [], "cinema,blue-square,record,film,movie,curtain,stage,theater"]], "low_brightness": [[["🔅"]], ["🔅", [], "low,brightness,symbol,sun,afternoon,warm,summer"]], "high_brightness": [[["🔆"]], ["🔆", [], "high,brightness,symbol,sun,light"]], "signal_strength": [[["📶"]], ["📶", [], "signal,strength,antenna,with,bars,blue-square,reception,phone,internet,connection,wifi,bluetooth"]], "vibration_mode": [[["📳"]], ["📳", [], "vibration,mode,orange-square,phone"]], "mobile_phone_off": [[["📴"]], ["📴", [], "mobile,phone,off,mute,orange-square,silence,quiet"]], "female_sign": [[["♀"], ["♀️", "2640"]], ["♀️", [], "female,sign", "2640-FE0F"]], "male_sign": [[["♂"], ["♂️", "2642"]], ["♂️", [], "male,sign", "2642-FE0F"]], "medical_symbol": [[["⚕"], ["⚕️", "2695"]], ["⚕️", ["staff_of_aesculapius"], "medical,symbol,staff,of,aesculapius", "2695-FE0F"]], "recycle": [[["♻"], ["♻️", "267b"]], ["♻️", [], "recycle,black,universal,recycling,symbol,arrow,environment,garbage,trash", "267B-FE0F"]], "fleur_de_lis": [[["⚜"], ["⚜️", "269c"]], ["⚜️", [], "fleur,de,lis,decorative,scout", "269C-FE0F"]], "trident": [[["🔱"]], ["🔱", [], "trident,emblem,weapon,spear"]], "name_badge": [[["📛"]], ["📛", [], "name,badge,fire,forbid"]], "beginner": [[["🔰"]], ["🔰", [], "beginner,japanese,symbol,for,badge,shield"]], "o": [[["⭕"]], ["⭕", [], "o,heavy,large,circle,round"]], "white_check_mark": [[["✅"]], ["✅", [], "white,check,mark,heavy,green-square,ok,agree,vote,election,answer,tick"]], "ballot_box_with_check": [[["☑"], ["☑️", "2611"]], ["☑️", [], "ballot,box,with,check,ok,agree,confirm,black-square,vote,election,yes,tick", "2611-FE0F"]], "heavy_check_mark": [[["✔"], ["✔️", "2714"]], ["✔️", [], "heavy,check,mark,ok,nike,answer,yes,tick", "2714-FE0F"]], "heavy_multiplication_x": [[["✖"], ["✖️", "2716"]], ["✖️", [], "heavy,multiplication,x,math,calculation", "2716-FE0F"]], "x": [[["❌"]], ["❌", [], "x,cross,mark,no,delete,remove,cancel"]], "negative_squared_cross_mark": [[["❎"]], ["❎", [], "negative,squared,cross,mark,x,green-square,no,deny"]], "heavy_plus_sign": [[["➕"]], ["➕", [], "heavy,plus,sign,math,calculation,addition,more,increase"]], "heavy_minus_sign": [[["➖"]], ["➖", [], "heavy,minus,sign,math,calculation,subtract,less"]], "heavy_division_sign": [[["➗"]], ["➗", [], "heavy,division,sign,divide,math,calculation"]], "curly_loop": [[["➰"]], ["➰", [], "curly,loop,scribble,draw,shape,squiggle"]], "loop": [[["➿"]], ["➿", [], "loop,double,curly,tape,cassette"]], "part_alternation_mark": [[["〽"], ["〽️", "303d"]], ["〽️", [], "part,alternation,mark,graph,presentation,stats,business,economics,bad", "303D-FE0F"]], "eight_spoked_asterisk": [[["✳"], ["✳️", "2733"]], ["✳️", [], "eight,spoked,asterisk,star,sparkle,green-square", "2733-FE0F"]], "eight_pointed_black_star": [[["✴"], ["✴️", "2734"]], ["✴️", [], "eight,pointed,black,star,orange-square,shape,polygon", "2734-FE0F"]], "sparkle": [[["❇"], ["❇️", "2747"]], ["❇️", [], "sparkle,stars,green-square,awesome,good,fireworks", "2747-FE0F"]], "bangbang": [[["‼"], ["‼️", "203c"]], ["‼️", [], "bangbang,double,exclamation,mark,surprise", "203C-FE0F"]], "interrobang": [[["⁉"], ["⁉️", "2049"]], ["⁉️", [], "interrobang,exclamation,question,mark,wat,punctuation,surprise", "2049-FE0F"]], "question": [[["❓"]], ["❓", [], "question,black,mark,ornament,doubt,confused"]], "grey_question": [[["❔"]], ["❔", [], "grey,question,white,mark,ornament,doubts,gray,huh,confused"]], "grey_exclamation": [[["❕"]], ["❕", [], "grey,exclamation,white,mark,ornament,surprise,punctuation,gray,wow,warning"]], "exclamation": [[["❗"]], ["❗", ["heavy_exclamation_mark"], "exclamation,heavy,mark,symbol,heavy_exclamation_mark,danger,surprise,punctuation,wow,warning"]], "wavy_dash": [[["〰"], ["〰️", "3030"]], ["〰️", [], "wavy,dash,draw,line,moustache,mustache,squiggle,scribble", "3030-FE0F"]], "keycap_ten": [[["🔟"]], ["🔟", [], "keycap,ten,numbers,10,blue-square"]], "capital_abcd": [[["🔠"]], ["🔠", [], "capital,abcd,input,symbol,for,latin,letters,alphabet,words,blue-square"]], "abcd": [[["🔡"]], ["🔡", [], "abcd,input,symbol,for,latin,small,letters,blue-square,alphabet"]], "symbols": [[["🔣"]], ["🔣", [], "symbols,input,symbol,for,blue-square,music,note,ampersand,percent,glyphs,characters"]], "abc": [[["🔤"]], ["🔤", [], "abc,input,symbol,for,latin,letters,blue-square,alphabet"]], "a": [[["🅰"], ["🅰️", "1f170"]], ["🅰️", [], "a,negative,squared,latin,capital,letter,red-square,alphabet"]], "ab": [[["🆎"]], ["🆎", [], "ab,negative,squared,red-square,alphabet"]], "b": [[["🅱"], ["🅱️", "1f171"]], ["🅱️", [], "b,negative,squared,latin,capital,letter,red-square,alphabet"]], "cl": [[["🆑"]], ["🆑", [], "cl,squared,alphabet,words,red-square"]], "cool": [[["🆒"]], ["🆒", [], "cool,squared,words,blue-square"]], "free": [[["🆓"]], ["🆓", [], "free,squared,blue-square,words"]], "information_source": [[["ℹ"], ["ℹ️", "2139"]], ["ℹ️", [], "information,source,blue-square,alphabet,letter", "2139-FE0F"]], "id": [[["🆔"]], ["🆔", [], "id,squared,purple-square,words"]], "m": [[["Ⓜ"], ["Ⓜ️", "24c2"]], ["Ⓜ️", [], "m,circled,latin,capital,letter,alphabet,blue-circle", "24C2-FE0F"]], "new": [[["🆕"]], ["🆕", [], "new,squared,blue-square,words,start"]], "ng": [[["🆖"]], ["🆖", [], "ng,squared,blue-square,words,shape,icon"]], "o2": [[["🅾"], ["🅾️", "1f17e"]], ["🅾️", [], "o2,negative,squared,latin,capital,letter,o,alphabet,red-square"]], "ok": [[["🆗"]], ["🆗", [], "ok,squared,good,agree,yes,blue-square"]], "parking": [[["🅿"], ["🅿️", "1f17f"]], ["🅿️", [], "parking,negative,squared,latin,capital,letter,p,cars,blue-square,alphabet"]], "sos": [[["🆘"]], ["🆘", [], "sos,squared,help,red-square,words,emergency,911"]], "up": [[["🆙"]], ["🆙", [], "up,squared,with,exclamation,mark,blue-square,above,high"]], "vs": [[["🆚"]], ["🆚", [], "vs,squared,words,orange-square"]], "koko": [[["🈁"]], ["🈁", [], "koko,squared,katakana,blue-square,here,japanese,destination"]], "sa": [[["🈂"], ["🈂️", "1f202"]], ["🈂️", [], "sa,squared,katakana,japanese,blue-square"]], "u6708": [[["🈷"], ["🈷️", "1f237"]], ["🈷️", [], "u6708,squared,cjk,unified,ideograph,6708,chinese,month,moon,japanese,orange-square,kanji"]], "u6709": [[["🈶"]], ["🈶", [], "u6709,squared,cjk,unified,ideograph,6709,orange-square,chinese,have,kanji"]], "u6307": [[["🈯"]], ["🈯", [], "u6307,squared,cjk,unified,ideograph,6307,chinese,point,green-square,kanji"]], "ideograph_advantage": [[["🉐"]], ["🉐", [], "ideograph,advantage,circled,chinese,kanji,obtain,get,circle"]], "u5272": [[["🈹"]], ["🈹", [], "u5272,squared,cjk,unified,ideograph,5272,cut,divide,chinese,kanji,pink-square"]], "u7121": [[["🈚"]], ["🈚", [], "u7121,squared,cjk,unified,ideograph,7121,nothing,chinese,kanji,japanese,orange-square"]], "u7981": [[["🈲"]], ["🈲", [], "u7981,squared,cjk,unified,ideograph,7981,kanji,japanese,chinese,forbidden,limit,restricted,red-square"]], "accept": [[["🉑"]], ["🉑", [], "accept,circled,ideograph,ok,good,chinese,kanji,agree,yes,orange-circle"]], "u7533": [[["🈸"]], ["🈸", [], "u7533,squared,cjk,unified,ideograph,7533,chinese,japanese,kanji,orange-square"]], "u5408": [[["🈴"]], ["🈴", [], "u5408,squared,cjk,unified,ideograph,5408,japanese,chinese,join,kanji,red-square"]], "u7a7a": [[["🈳"]], ["🈳", [], "u7a7a,squared,cjk,unified,ideograph,7a7a,kanji,japanese,chinese,empty,sky,blue-square"]], "congratulations": [[["㊗"], ["㊗️", "3297"]], ["㊗️", [], "congratulations,circled,ideograph,congratulation,chinese,kanji,japanese,red-circle", "3297-FE0F"]], "secret": [[["㊙"], ["㊙️", "3299"]], ["㊙️", [], "secret,circled,ideograph,privacy,chinese,sshh,kanji,red-circle", "3299-FE0F"]], "u55b6": [[["🈺"]], ["🈺", [], "u55b6,squared,cjk,unified,ideograph,55b6,japanese,opening hours,orange-square"]], "u6e80": [[["🈵"]], ["🈵", [], "u6e80,squared,cjk,unified,ideograph,6e80,full,chinese,japanese,red-square,kanji"]], "black_small_square": [[["▪"], ["▪️", "25aa"]], ["▪️", [], "black,small,square,shape,icon", "25AA-FE0F"]], "white_small_square": [[["▫"], ["▫️", "25ab"]], ["▫️", [], "white,small,square,shape,icon", "25AB-FE0F"]], "white_medium_square": [[["◻"], ["◻️", "25fb"]], ["◻️", [], "white,medium,square,shape,stone,icon", "25FB-FE0F"]], "black_medium_square": [[["◼"], ["◼️", "25fc"]], ["◼️", [], "black,medium,square,shape,button,icon", "25FC-FE0F"]], "white_medium_small_square": [[["◽"]], ["◽", [], "white,medium,small,square,shape,stone,icon,button"]], "black_medium_small_square": [[["◾"]], ["◾", [], "black,medium,small,square,icon,shape,button"]], "black_large_square": [[["⬛"]], ["⬛", [], "black,large,square,shape,icon,button"]], "white_large_square": [[["⬜"]], ["⬜", [], "white,large,square,shape,icon,stone,button"]], "large_orange_diamond": [[["🔶"]], ["🔶", [], "large,orange,diamond,shape,jewel,gem"]], "large_blue_diamond": [[["🔷"]], ["🔷", [], "large,blue,diamond,shape,jewel,gem"]], "small_orange_diamond": [[["🔸"]], ["🔸", [], "small,orange,diamond,shape,jewel,gem"]], "small_blue_diamond": [[["🔹"]], ["🔹", [], "small,blue,diamond,shape,jewel,gem"]], "small_red_triangle": [[["🔺"]], ["🔺", [], "small,red,triangle,up,pointing,shape,direction,top"]], "small_red_triangle_down": [[["🔻"]], ["🔻", [], "small,red,triangle,down,pointing,shape,direction,bottom"]], "diamond_shape_with_a_dot_inside": [[["💠"]], ["💠", [], "diamond,shape,with,a,dot,inside,jewel,blue,gem,crystal,fancy"]], "radio_button": [[["🔘"]], ["🔘", [], "radio,button,input,old,music,circle"]], "black_square_button": [[["🔲"]], ["🔲", [], "black,square,button,shape,input,frame"]], "white_square_button": [[["🔳"]], ["🔳", [], "white,square,button,shape,input"]], "white_circle": [[["⚪"]], ["⚪", [], "white,circle,medium,shape,round"]], "black_circle": [[["⚫"]], ["⚫", [], "black,circle,medium,shape,button,round"]], "red_circle": [[["🔴"]], ["🔴", [], "red,circle,large,shape,error,danger"]], "large_blue_circle": [[["🔵"]], ["🔵", [], "large,blue,circle,shape,icon,button"]], "checkered_flag": [[["🏁"]], ["🏁", [], "checkered,flag,chequered,contest,finishline,race,gokart"]], "triangular_flag_on_post": [[["🚩"]], ["🚩", [], "triangular,flag,on,post,mark,milestone,place"]], "crossed_flags": [[["🎌"]], ["🎌", [], "crossed,flags,japanese,nation,country,border"]], "waving_black_flag": [[["🏴"]], ["🏴", [], "waving,black,flag"]], "waving_white_flag": [[["🏳"], ["🏳️", "1f3f3"]], ["🏳️", [], "waving,white,flag"]], "copyright": [[["©️", "a9"]], ["©️", [], "copyright,sign,ip,license,circle,law,legal", "00A9-FE0F"]], "registered": [[["®️", "ae"]], ["®️", [], "registered,sign,alphabet,circle", "00AE-FE0F"]], "tm": [[["™️", "2122"]], ["™️", [], "tm,trade,mark,sign,trademark,brand,law,legal", "2122-FE0F"]], "flag-ac": [[["🇦🇨"]], ["🇦🇨", [], "flag,ac,ascension,island"]], "flag-ad": [[["🇦🇩"]], ["🇦🇩", [], "flag,ad,andorra"]], "flag-ae": [[["🇦🇪"]], ["🇦🇪", [], "flag,ae,united,arab,emirates"]], "flag-af": [[["🇦🇫"]], ["🇦🇫", [], "flag,af,afghanistan"]], "flag-ag": [[["🇦🇬"]], ["🇦🇬", [], "flag,ag,antigua,&,barbuda"]], "flag-ai": [[["🇦🇮"]], ["🇦🇮", [], "flag,ai,anguilla"]], "flag-al": [[["🇦🇱"]], ["🇦🇱", [], "flag,al,albania"]], "flag-am": [[["🇦🇲"]], ["🇦🇲", [], "flag,am,armenia"]], "flag-ao": [[["🇦🇴"]], ["🇦🇴", [], "flag,ao,angola"]], "flag-aq": [[["🇦🇶"]], ["🇦🇶", [], "flag,aq,antarctica"]], "flag-ar": [[["🇦🇷"]], ["🇦🇷", [], "flag,ar,argentina"]], "flag-as": [[["🇦🇸"]], ["🇦🇸", [], "flag,as,american,samoa"]], "flag-at": [[["🇦🇹"]], ["🇦🇹", [], "flag,at,austria"]], "flag-au": [[["🇦🇺"]], ["🇦🇺", [], "flag,au,australia"]], "flag-aw": [[["🇦🇼"]], ["🇦🇼", [], "flag,aw,aruba"]], "flag-ax": [[["🇦🇽"]], ["🇦🇽", [], "flag,ax,åland,islands"]], "flag-az": [[["🇦🇿"]], ["🇦🇿", [], "flag,az,azerbaijan"]], "flag-ba": [[["🇧🇦"]], ["🇧🇦", [], "flag,ba,bosnia,&,herzegovina"]], "flag-bb": [[["🇧🇧"]], ["🇧🇧", [], "flag,bb,barbados"]], "flag-bd": [[["🇧🇩"]], ["🇧🇩", [], "flag,bd,bangladesh"]], "flag-be": [[["🇧🇪"]], ["🇧🇪", [], "flag,be,belgium"]], "flag-bf": [[["🇧🇫"]], ["🇧🇫", [], "flag,bf,burkina,faso"]], "flag-bg": [[["🇧🇬"]], ["🇧🇬", [], "flag,bg,bulgaria"]], "flag-bh": [[["🇧🇭"]], ["🇧🇭", [], "flag,bh,bahrain"]], "flag-bi": [[["🇧🇮"]], ["🇧🇮", [], "flag,bi,burundi"]], "flag-bj": [[["🇧🇯"]], ["🇧🇯", [], "flag,bj,benin"]], "flag-bl": [[["🇧🇱"]], ["🇧🇱", [], "flag,bl,st.,barthélemy"]], "flag-bm": [[["🇧🇲"]], ["🇧🇲", [], "flag,bm,bermuda"]], "flag-bn": [[["🇧🇳"]], ["🇧🇳", [], "flag,bn,brunei"]], "flag-bo": [[["🇧🇴"]], ["🇧🇴", [], "flag,bo,bolivia"]], "flag-bq": [[["🇧🇶"]], ["🇧🇶", [], "flag,bq,caribbean,netherlands"]], "flag-br": [[["🇧🇷"]], ["🇧🇷", [], "flag,br,brazil"]], "flag-bs": [[["🇧🇸"]], ["🇧🇸", [], "flag,bs,bahamas"]], "flag-bt": [[["🇧🇹"]], ["🇧🇹", [], "flag,bt,bhutan"]], "flag-bv": [[["🇧🇻"]], ["🇧🇻", [], "flag,bv,bouvet,island"]], "flag-bw": [[["🇧🇼"]], ["🇧🇼", [], "flag,bw,botswana"]], "flag-by": [[["🇧🇾"]], ["🇧🇾", [], "flag,by,belarus"]], "flag-bz": [[["🇧🇿"]], ["🇧🇿", [], "flag,bz,belize"]], "flag-ca": [[["🇨🇦"]], ["🇨🇦", [], "flag,ca,canada"]], "flag-cc": [[["🇨🇨"]], ["🇨🇨", [], "flag,cc,cocos,(keeling),islands"]], "flag-cd": [[["🇨🇩"]], ["🇨🇩", [], "flag,cd,congo,kinshasa"]], "flag-cf": [[["🇨🇫"]], ["🇨🇫", [], "flag,cf,central,african,republic"]], "flag-cg": [[["🇨🇬"]], ["🇨🇬", [], "flag,cg,congo,brazzaville"]], "flag-ch": [[["🇨🇭"]], ["🇨🇭", [], "flag,ch,switzerland"]], "flag-ci": [[["🇨🇮"]], ["🇨🇮", [], "flag,ci,côte,d’ivoire"]], "flag-ck": [[["🇨🇰"]], ["🇨🇰", [], "flag,ck,cook,islands"]], "flag-cl": [[["🇨🇱"]], ["🇨🇱", [], "flag,cl,chile"]], "flag-cm": [[["🇨🇲"]], ["🇨🇲", [], "flag,cm,cameroon"]], "cn": [[["🇨🇳"]], ["🇨🇳", ["flag-cn"], "cn,flag,china,chinese,prc,country,nation,banner"]], "flag-co": [[["🇨🇴"]], ["🇨🇴", [], "flag,co,colombia"]], "flag-cp": [[["🇨🇵"]], ["🇨🇵", [], "flag,cp,clipperton,island"]], "flag-cr": [[["🇨🇷"]], ["🇨🇷", [], "flag,cr,costa,rica"]], "flag-cu": [[["🇨🇺"]], ["🇨🇺", [], "flag,cu,cuba"]], "flag-cv": [[["🇨🇻"]], ["🇨🇻", [], "flag,cv,cape,verde"]], "flag-cw": [[["🇨🇼"]], ["🇨🇼", [], "flag,cw,curaçao"]], "flag-cx": [[["🇨🇽"]], ["🇨🇽", [], "flag,cx,christmas,island"]], "flag-cy": [[["🇨🇾"]], ["🇨🇾", [], "flag,cy,cyprus"]], "flag-cz": [[["🇨🇿"]], ["🇨🇿", [], "flag,cz,czechia"]], "de": [[["🇩🇪"]], ["🇩🇪", ["flag-de"], "de,flag,germany,german,nation,country,banner"]], "flag-dg": [[["🇩🇬"]], ["🇩🇬", [], "flag,dg,diego,garcia"]], "flag-dj": [[["🇩🇯"]], ["🇩🇯", [], "flag,dj,djibouti"]], "flag-dk": [[["🇩🇰"]], ["🇩🇰", [], "flag,dk,denmark"]], "flag-dm": [[["🇩🇲"]], ["🇩🇲", [], "flag,dm,dominica"]], "flag-do": [[["🇩🇴"]], ["🇩🇴", [], "flag,do,dominican,republic"]], "flag-dz": [[["🇩🇿"]], ["🇩🇿", [], "flag,dz,algeria"]], "flag-ea": [[["🇪🇦"]], ["🇪🇦", [], "flag,ea,ceuta,&,melilla"]], "flag-ec": [[["🇪🇨"]], ["🇪🇨", [], "flag,ec,ecuador"]], "flag-ee": [[["🇪🇪"]], ["🇪🇪", [], "flag,ee,estonia"]], "flag-eg": [[["🇪🇬"]], ["🇪🇬", [], "flag,eg,egypt"]], "flag-eh": [[["🇪🇭"]], ["🇪🇭", [], "flag,eh,western,sahara"]], "flag-er": [[["🇪🇷"]], ["🇪🇷", [], "flag,er,eritrea"]], "es": [[["🇪🇸"]], ["🇪🇸", ["flag-es"], "es,flag,spain,nation,country,banner"]], "flag-et": [[["🇪🇹"]], ["🇪🇹", [], "flag,et,ethiopia"]], "flag-eu": [[["🇪🇺"]], ["🇪🇺", [], "flag,eu,european,union"]], "flag-fi": [[["🇫🇮"]], ["🇫🇮", [], "flag,fi,finland"]], "flag-fj": [[["🇫🇯"]], ["🇫🇯", [], "flag,fj,fiji"]], "flag-fk": [[["🇫🇰"]], ["🇫🇰", [], "flag,fk,falkland,islands"]], "flag-fm": [[["🇫🇲"]], ["🇫🇲", [], "flag,fm,micronesia"]], "flag-fo": [[["🇫🇴"]], ["🇫🇴", [], "flag,fo,faroe,islands"]], "fr": [[["🇫🇷"]], ["🇫🇷", ["flag-fr"], "fr,flag,france,banner,nation,french,country"]], "flag-ga": [[["🇬🇦"]], ["🇬🇦", [], "flag,ga,gabon"]], "gb": [[["🇬🇧"]], ["🇬🇧", ["uk", "flag-gb"], "gb,uk,flag,united,kingdom"]], "flag-gd": [[["🇬🇩"]], ["🇬🇩", [], "flag,gd,grenada"]], "flag-ge": [[["🇬🇪"]], ["🇬🇪", [], "flag,ge,georgia"]], "flag-gf": [[["🇬🇫"]], ["🇬🇫", [], "flag,gf,french,guiana"]], "flag-gg": [[["🇬🇬"]], ["🇬🇬", [], "flag,gg,guernsey"]], "flag-gh": [[["🇬🇭"]], ["🇬🇭", [], "flag,gh,ghana"]], "flag-gi": [[["🇬🇮"]], ["🇬🇮", [], "flag,gi,gibraltar"]], "flag-gl": [[["🇬🇱"]], ["🇬🇱", [], "flag,gl,greenland"]], "flag-gm": [[["🇬🇲"]], ["🇬🇲", [], "flag,gm,gambia"]], "flag-gn": [[["🇬🇳"]], ["🇬🇳", [], "flag,gn,guinea"]], "flag-gp": [[["🇬🇵"]], ["🇬🇵", [], "flag,gp,guadeloupe"]], "flag-gq": [[["🇬🇶"]], ["🇬🇶", [], "flag,gq,equatorial,guinea"]], "flag-gr": [[["🇬🇷"]], ["🇬🇷", [], "flag,gr,greece"]], "flag-gs": [[["🇬🇸"]], ["🇬🇸", [], "flag,gs,south,georgia,&,sandwich,islands"]], "flag-gt": [[["🇬🇹"]], ["🇬🇹", [], "flag,gt,guatemala"]], "flag-gu": [[["🇬🇺"]], ["🇬🇺", [], "flag,gu,guam"]], "flag-gw": [[["🇬🇼"]], ["🇬🇼", [], "flag,gw,guinea,bissau"]], "flag-gy": [[["🇬🇾"]], ["🇬🇾", [], "flag,gy,guyana"]], "flag-hk": [[["🇭🇰"]], ["🇭🇰", [], "flag,hk,hong,kong,sar,china"]], "flag-hm": [[["🇭🇲"]], ["🇭🇲", [], "flag,hm,heard,&,mcdonald,islands"]], "flag-hn": [[["🇭🇳"]], ["🇭🇳", [], "flag,hn,honduras"]], "flag-hr": [[["🇭🇷"]], ["🇭🇷", [], "flag,hr,croatia"]], "flag-ht": [[["🇭🇹"]], ["🇭🇹", [], "flag,ht,haiti"]], "flag-hu": [[["🇭🇺"]], ["🇭🇺", [], "flag,hu,hungary"]], "flag-ic": [[["🇮🇨"]], ["🇮🇨", [], "flag,ic,canary,islands"]], "flag-id": [[["🇮🇩"]], ["🇮🇩", [], "flag,id,indonesia"]], "flag-ie": [[["🇮🇪"]], ["🇮🇪", [], "flag,ie,ireland"]], "flag-il": [[["🇮🇱"]], ["🇮🇱", [], "flag,il,israel"]], "flag-im": [[["🇮🇲"]], ["🇮🇲", [], "flag,im,isle,of,man"]], "flag-in": [[["🇮🇳"]], ["🇮🇳", [], "flag,in,india"]], "flag-io": [[["🇮🇴"]], ["🇮🇴", [], "flag,io,british,indian,ocean,territory"]], "flag-iq": [[["🇮🇶"]], ["🇮🇶", [], "flag,iq,iraq"]], "flag-ir": [[["🇮🇷"]], ["🇮🇷", [], "flag,ir,iran"]], "flag-is": [[["🇮🇸"]], ["🇮🇸", [], "flag,is,iceland"]], "it": [[["🇮🇹"]], ["🇮🇹", ["flag-it"], "it,flag,italy,nation,country,banner"]], "flag-je": [[["🇯🇪"]], ["🇯🇪", [], "flag,je,jersey"]], "flag-jm": [[["🇯🇲"]], ["🇯🇲", [], "flag,jm,jamaica"]], "flag-jo": [[["🇯🇴"]], ["🇯🇴", [], "flag,jo,jordan"]], "jp": [[["🇯🇵"]], ["🇯🇵", ["flag-jp"], "jp,flag,japan,japanese,nation,country,banner"]], "flag-ke": [[["🇰🇪"]], ["🇰🇪", [], "flag,ke,kenya"]], "flag-kg": [[["🇰🇬"]], ["🇰🇬", [], "flag,kg,kyrgyzstan"]], "flag-kh": [[["🇰🇭"]], ["🇰🇭", [], "flag,kh,cambodia"]], "flag-ki": [[["🇰🇮"]], ["🇰🇮", [], "flag,ki,kiribati"]], "flag-km": [[["🇰🇲"]], ["🇰🇲", [], "flag,km,comoros"]], "flag-kn": [[["🇰🇳"]], ["🇰🇳", [], "flag,kn,st.,kitts,&,nevis"]], "flag-kp": [[["🇰🇵"]], ["🇰🇵", [], "flag,kp,north,korea"]], "kr": [[["🇰🇷"]], ["🇰🇷", ["flag-kr"], "kr,flag,south,korea,nation,country,banner"]], "flag-kw": [[["🇰🇼"]], ["🇰🇼", [], "flag,kw,kuwait"]], "flag-ky": [[["🇰🇾"]], ["🇰🇾", [], "flag,ky,cayman,islands"]], "flag-kz": [[["🇰🇿"]], ["🇰🇿", [], "flag,kz,kazakhstan"]], "flag-la": [[["🇱🇦"]], ["🇱🇦", [], "flag,la,laos"]], "flag-lb": [[["🇱🇧"]], ["🇱🇧", [], "flag,lb,lebanon"]], "flag-lc": [[["🇱🇨"]], ["🇱🇨", [], "flag,lc,st.,lucia"]], "flag-li": [[["🇱🇮"]], ["🇱🇮", [], "flag,li,liechtenstein"]], "flag-lk": [[["🇱🇰"]], ["🇱🇰", [], "flag,lk,sri,lanka"]], "flag-lr": [[["🇱🇷"]], ["🇱🇷", [], "flag,lr,liberia"]], "flag-ls": [[["🇱🇸"]], ["🇱🇸", [], "flag,ls,lesotho"]], "flag-lt": [[["🇱🇹"]], ["🇱🇹", [], "flag,lt,lithuania"]], "flag-lu": [[["🇱🇺"]], ["🇱🇺", [], "flag,lu,luxembourg"]], "flag-lv": [[["🇱🇻"]], ["🇱🇻", [], "flag,lv,latvia"]], "flag-ly": [[["🇱🇾"]], ["🇱🇾", [], "flag,ly,libya"]], "flag-ma": [[["🇲🇦"]], ["🇲🇦", [], "flag,ma,morocco"]], "flag-mc": [[["🇲🇨"]], ["🇲🇨", [], "flag,mc,monaco"]], "flag-md": [[["🇲🇩"]], ["🇲🇩", [], "flag,md,moldova"]], "flag-me": [[["🇲🇪"]], ["🇲🇪", [], "flag,me,montenegro"]], "flag-mf": [[["🇲🇫"]], ["🇲🇫", [], "flag,mf,st.,martin"]], "flag-mg": [[["🇲🇬"]], ["🇲🇬", [], "flag,mg,madagascar"]], "flag-mh": [[["🇲🇭"]], ["🇲🇭", [], "flag,mh,marshall,islands"]], "flag-mk": [[["🇲🇰"]], ["🇲🇰", [], "flag,mk,macedonia"]], "flag-ml": [[["🇲🇱"]], ["🇲🇱", [], "flag,ml,mali"]], "flag-mm": [[["🇲🇲"]], ["🇲🇲", [], "flag,mm,myanmar,(burma)"]], "flag-mn": [[["🇲🇳"]], ["🇲🇳", [], "flag,mn,mongolia"]], "flag-mo": [[["🇲🇴"]], ["🇲🇴", [], "flag,mo,macau,sar,china"]], "flag-mp": [[["🇲🇵"]], ["🇲🇵", [], "flag,mp,northern,mariana,islands"]], "flag-mq": [[["🇲🇶"]], ["🇲🇶", [], "flag,mq,martinique"]], "flag-mr": [[["🇲🇷"]], ["🇲🇷", [], "flag,mr,mauritania"]], "flag-ms": [[["🇲🇸"]], ["🇲🇸", [], "flag,ms,montserrat"]], "flag-mt": [[["🇲🇹"]], ["🇲🇹", [], "flag,mt,malta"]], "flag-mu": [[["🇲🇺"]], ["🇲🇺", [], "flag,mu,mauritius"]], "flag-mv": [[["🇲🇻"]], ["🇲🇻", [], "flag,mv,maldives"]], "flag-mw": [[["🇲🇼"]], ["🇲🇼", [], "flag,mw,malawi"]], "flag-mx": [[["🇲🇽"]], ["🇲🇽", [], "flag,mx,mexico"]], "flag-my": [[["🇲🇾"]], ["🇲🇾", [], "flag,my,malaysia"]], "flag-mz": [[["🇲🇿"]], ["🇲🇿", [], "flag,mz,mozambique"]], "flag-na": [[["🇳🇦"]], ["🇳🇦", [], "flag,na,namibia"]], "flag-nc": [[["🇳🇨"]], ["🇳🇨", [], "flag,nc,new,caledonia"]], "flag-ne": [[["🇳🇪"]], ["🇳🇪", [], "flag,ne,niger"]], "flag-nf": [[["🇳🇫"]], ["🇳🇫", [], "flag,nf,norfolk,island"]], "flag-ng": [[["🇳🇬"]], ["🇳🇬", [], "flag,ng,nigeria"]], "flag-ni": [[["🇳🇮"]], ["🇳🇮", [], "flag,ni,nicaragua"]], "flag-nl": [[["🇳🇱"]], ["🇳🇱", [], "flag,nl,netherlands"]], "flag-no": [[["🇳🇴"]], ["🇳🇴", [], "flag,no,norway"]], "flag-np": [[["🇳🇵"]], ["🇳🇵", [], "flag,np,nepal"]], "flag-nr": [[["🇳🇷"]], ["🇳🇷", [], "flag,nr,nauru"]], "flag-nu": [[["🇳🇺"]], ["🇳🇺", [], "flag,nu,niue"]], "flag-nz": [[["🇳🇿"]], ["🇳🇿", [], "flag,nz,new,zealand"]], "flag-om": [[["🇴🇲"]], ["🇴🇲", [], "flag,om,oman"]], "flag-pa": [[["🇵🇦"]], ["🇵🇦", [], "flag,pa,panama"]], "flag-pe": [[["🇵🇪"]], ["🇵🇪", [], "flag,pe,peru"]], "flag-pf": [[["🇵🇫"]], ["🇵🇫", [], "flag,pf,french,polynesia"]], "flag-pg": [[["🇵🇬"]], ["🇵🇬", [], "flag,pg,papua,new,guinea"]], "flag-ph": [[["🇵🇭"]], ["🇵🇭", [], "flag,ph,philippines"]], "flag-pk": [[["🇵🇰"]], ["🇵🇰", [], "flag,pk,pakistan"]], "flag-pl": [[["🇵🇱"]], ["🇵🇱", [], "flag,pl,poland"]], "flag-pm": [[["🇵🇲"]], ["🇵🇲", [], "flag,pm,st.,pierre,&,miquelon"]], "flag-pn": [[["🇵🇳"]], ["🇵🇳", [], "flag,pn,pitcairn,islands"]], "flag-pr": [[["🇵🇷"]], ["🇵🇷", [], "flag,pr,puerto,rico"]], "flag-ps": [[["🇵🇸"]], ["🇵🇸", [], "flag,ps,palestinian,territories"]], "flag-pt": [[["🇵🇹"]], ["🇵🇹", [], "flag,pt,portugal"]], "flag-pw": [[["🇵🇼"]], ["🇵🇼", [], "flag,pw,palau"]], "flag-py": [[["🇵🇾"]], ["🇵🇾", [], "flag,py,paraguay"]], "flag-qa": [[["🇶🇦"]], ["🇶🇦", [], "flag,qa,qatar"]], "flag-re": [[["🇷🇪"]], ["🇷🇪", [], "flag,re,réunion"]], "flag-ro": [[["🇷🇴"]], ["🇷🇴", [], "flag,ro,romania"]], "flag-rs": [[["🇷🇸"]], ["🇷🇸", [], "flag,rs,serbia"]], "ru": [[["🇷🇺"]], ["🇷🇺", ["flag-ru"], "ru,flag,russia,russian,federation,nation,country,banner"]], "flag-rw": [[["🇷🇼"]], ["🇷🇼", [], "flag,rw,rwanda"]], "flag-sa": [[["🇸🇦"]], ["🇸🇦", [], "flag,sa,saudi,arabia"]], "flag-sb": [[["🇸🇧"]], ["🇸🇧", [], "flag,sb,solomon,islands"]], "flag-sc": [[["🇸🇨"]], ["🇸🇨", [], "flag,sc,seychelles"]], "flag-sd": [[["🇸🇩"]], ["🇸🇩", [], "flag,sd,sudan"]], "flag-se": [[["🇸🇪"]], ["🇸🇪", [], "flag,se,sweden"]], "flag-sg": [[["🇸🇬"]], ["🇸🇬", [], "flag,sg,singapore"]], "flag-sh": [[["🇸🇭"]], ["🇸🇭", [], "flag,sh,st.,helena"]], "flag-si": [[["🇸🇮"]], ["🇸🇮", [], "flag,si,slovenia"]], "flag-sj": [[["🇸🇯"]], ["🇸🇯", [], "flag,sj,svalbard,&,jan,mayen"]], "flag-sk": [[["🇸🇰"]], ["🇸🇰", [], "flag,sk,slovakia"]], "flag-sl": [[["🇸🇱"]], ["🇸🇱", [], "flag,sl,sierra,leone"]], "flag-sm": [[["🇸🇲"]], ["🇸🇲", [], "flag,sm,san,marino"]], "flag-sn": [[["🇸🇳"]], ["🇸🇳", [], "flag,sn,senegal"]], "flag-so": [[["🇸🇴"]], ["🇸🇴", [], "flag,so,somalia"]], "flag-sr": [[["🇸🇷"]], ["🇸🇷", [], "flag,sr,suriname"]], "flag-ss": [[["🇸🇸"]], ["🇸🇸", [], "flag,ss,south,sudan"]], "flag-st": [[["🇸🇹"]], ["🇸🇹", [], "flag,st,são,tomé,&,príncipe"]], "flag-sv": [[["🇸🇻"]], ["🇸🇻", [], "flag,sv,el,salvador"]], "flag-sx": [[["🇸🇽"]], ["🇸🇽", [], "flag,sx,sint,maarten"]], "flag-sy": [[["🇸🇾"]], ["🇸🇾", [], "flag,sy,syria"]], "flag-sz": [[["🇸🇿"]], ["🇸🇿", [], "flag,sz,swaziland"]], "flag-ta": [[["🇹🇦"]], ["🇹🇦", [], "flag,ta,tristan,da,cunha"]], "flag-tc": [[["🇹🇨"]], ["🇹🇨", [], "flag,tc,turks,&,caicos,islands"]], "flag-td": [[["🇹🇩"]], ["🇹🇩", [], "flag,td,chad"]], "flag-tf": [[["🇹🇫"]], ["🇹🇫", [], "flag,tf,french,southern,territories"]], "flag-tg": [[["🇹🇬"]], ["🇹🇬", [], "flag,tg,togo"]], "flag-th": [[["🇹🇭"]], ["🇹🇭", [], "flag,th,thailand"]], "flag-tj": [[["🇹🇯"]], ["🇹🇯", [], "flag,tj,tajikistan"]], "flag-tk": [[["🇹🇰"]], ["🇹🇰", [], "flag,tk,tokelau"]], "flag-tl": [[["🇹🇱"]], ["🇹🇱", [], "flag,tl,timor,leste"]], "flag-tm": [[["🇹🇲"]], ["🇹🇲", [], "flag,tm,turkmenistan"]], "flag-tn": [[["🇹🇳"]], ["🇹🇳", [], "flag,tn,tunisia"]], "flag-to": [[["🇹🇴"]], ["🇹🇴", [], "flag,to,tonga"]], "flag-tr": [[["🇹🇷"]], ["🇹🇷", [], "flag,tr,turkey"]], "flag-tt": [[["🇹🇹"]], ["🇹🇹", [], "flag,tt,trinidad,&,tobago"]], "flag-tv": [[["🇹🇻"]], ["🇹🇻", [], "flag,tv,tuvalu"]], "flag-tw": [[["🇹🇼"]], ["🇹🇼", [], "flag,tw,taiwan"]], "flag-tz": [[["🇹🇿"]], ["🇹🇿", [], "flag,tz,tanzania"]], "flag-ua": [[["🇺🇦"]], ["🇺🇦", [], "flag,ua,ukraine"]], "flag-ug": [[["🇺🇬"]], ["🇺🇬", [], "flag,ug,uganda"]], "flag-um": [[["🇺🇲"]], ["🇺🇲", [], "flag,um,u.s.,outlying,islands"]], "flag-un": [[["🇺🇳"]], ["🇺🇳", [], "flag,un,united,nations"]], "us": [[["🇺🇸"]], ["🇺🇸", ["flag-us"], "us,flag,united,states,america,nation,country,banner"]], "flag-uy": [[["🇺🇾"]], ["🇺🇾", [], "flag,uy,uruguay"]], "flag-uz": [[["🇺🇿"]], ["🇺🇿", [], "flag,uz,uzbekistan"]], "flag-va": [[["🇻🇦"]], ["🇻🇦", [], "flag,va,vatican,city"]], "flag-vc": [[["🇻🇨"]], ["🇻🇨", [], "flag,vc,st.,vincent,&,grenadines"]], "flag-ve": [[["🇻🇪"]], ["🇻🇪", [], "flag,ve,venezuela"]], "flag-vg": [[["🇻🇬"]], ["🇻🇬", [], "flag,vg,british,virgin,islands"]], "flag-vi": [[["🇻🇮"]], ["🇻🇮", [], "flag,vi,u.s.,virgin,islands"]], "flag-vn": [[["🇻🇳"]], ["🇻🇳", [], "flag,vn,vietnam"]], "flag-vu": [[["🇻🇺"]], ["🇻🇺", [], "flag,vu,vanuatu"]], "flag-wf": [[["🇼🇫"]], ["🇼🇫", [], "flag,wf,wallis,&,futuna"]], "flag-ws": [[["🇼🇸"]], ["🇼🇸", [], "flag,ws,samoa"]], "flag-xk": [[["🇽🇰"]], ["🇽🇰", [], "flag,xk,kosovo"]], "flag-ye": [[["🇾🇪"]], ["🇾🇪", [], "flag,ye,yemen"]], "flag-yt": [[["🇾🇹"]], ["🇾🇹", [], "flag,yt,mayotte"]], "flag-za": [[["🇿🇦"]], ["🇿🇦", [], "flag,za,south,africa"]], "flag-zm": [[["🇿🇲"]], ["🇿🇲", [], "flag,zm,zambia"]], "flag-zw": [[["🇿🇼"]], ["🇿🇼", [], "flag,zw,zimbabwe"]], "male-doctor": [[["👨‍⚕", "1f468-200d-2695-fe0f"], ["👨‍⚕️"], ["👨🏻‍⚕", "1f468-1f3fb-200d-2695-fe0f"], ["👨🏼‍⚕", "1f468-1f3fc-200d-2695-fe0f"], ["👨🏽‍⚕", "1f468-1f3fd-200d-2695-fe0f"], ["👨🏾‍⚕", "1f468-1f3fe-200d-2695-fe0f"], ["👨🏿‍⚕", "1f468-1f3ff-200d-2695-fe0f"], ["👨🏻‍⚕️"], ["👨🏼‍⚕️"], ["👨🏽‍⚕️"], ["👨🏾‍⚕️"], ["👨🏿‍⚕️"]], ["👨‍⚕️", [], "male,doctor", "1F468-200D-2695-FE0F"]], "female-doctor": [[["👩‍⚕", "1f469-200d-2695-fe0f"], ["👩‍⚕️"], ["👩🏻‍⚕", "1f469-1f3fb-200d-2695-fe0f"], ["👩🏼‍⚕", "1f469-1f3fc-200d-2695-fe0f"], ["👩🏽‍⚕", "1f469-1f3fd-200d-2695-fe0f"], ["👩🏾‍⚕", "1f469-1f3fe-200d-2695-fe0f"], ["👩🏿‍⚕", "1f469-1f3ff-200d-2695-fe0f"], ["👩🏻‍⚕️"], ["👩🏼‍⚕️"], ["👩🏽‍⚕️"], ["👩🏾‍⚕️"], ["👩🏿‍⚕️"]], ["👩‍⚕️", [], "female,doctor", "1F469-200D-2695-FE0F"]], "male-student": [[["👨‍🎓"], ["👨🏻‍🎓"], ["👨🏼‍🎓"], ["👨🏽‍🎓"], ["👨🏾‍🎓"], ["👨🏿‍🎓"]], ["👨‍🎓", [], "male,student", "1F468-200D-1F393"]], "female-student": [[["👩‍🎓"], ["👩🏻‍🎓"], ["👩🏼‍🎓"], ["👩🏽‍🎓"], ["👩🏾‍🎓"], ["👩🏿‍🎓"]], ["👩‍🎓", [], "female,student", "1F469-200D-1F393"]], "male-teacher": [[["👨‍🏫"], ["👨🏻‍🏫"], ["👨🏼‍🏫"], ["👨🏽‍🏫"], ["👨🏾‍🏫"], ["👨🏿‍🏫"]], ["👨‍🏫", [], "male,teacher", "1F468-200D-1F3EB"]], "female-teacher": [[["👩‍🏫"], ["👩🏻‍🏫"], ["👩🏼‍🏫"], ["👩🏽‍🏫"], ["👩🏾‍🏫"], ["👩🏿‍🏫"]], ["👩‍🏫", [], "female,teacher", "1F469-200D-1F3EB"]], "male-judge": [[["👨‍⚖", "1f468-200d-2696-fe0f"], ["👨‍⚖️"], ["👨🏻‍⚖", "1f468-1f3fb-200d-2696-fe0f"], ["👨🏼‍⚖", "1f468-1f3fc-200d-2696-fe0f"], ["👨🏽‍⚖", "1f468-1f3fd-200d-2696-fe0f"], ["👨🏾‍⚖", "1f468-1f3fe-200d-2696-fe0f"], ["👨🏿‍⚖", "1f468-1f3ff-200d-2696-fe0f"], ["👨🏻‍⚖️"], ["👨🏼‍⚖️"], ["👨🏽‍⚖️"], ["👨🏾‍⚖️"], ["👨🏿‍⚖️"]], ["👨‍⚖️", [], "male,judge", "1F468-200D-2696-FE0F"]], "female-judge": [[["👩‍⚖", "1f469-200d-2696-fe0f"], ["👩‍⚖️"], ["👩🏻‍⚖", "1f469-1f3fb-200d-2696-fe0f"], ["👩🏼‍⚖", "1f469-1f3fc-200d-2696-fe0f"], ["👩🏽‍⚖", "1f469-1f3fd-200d-2696-fe0f"], ["👩🏾‍⚖", "1f469-1f3fe-200d-2696-fe0f"], ["👩🏿‍⚖", "1f469-1f3ff-200d-2696-fe0f"], ["👩🏻‍⚖️"], ["👩🏼‍⚖️"], ["👩🏽‍⚖️"], ["👩🏾‍⚖️"], ["👩🏿‍⚖️"]], ["👩‍⚖️", [], "female,judge", "1F469-200D-2696-FE0F"]], "male-farmer": [[["👨‍🌾"], ["👨🏻‍🌾"], ["👨🏼‍🌾"], ["👨🏽‍🌾"], ["👨🏾‍🌾"], ["👨🏿‍🌾"]], ["👨‍🌾", [], "male,farmer", "1F468-200D-1F33E"]], "female-farmer": [[["👩‍🌾"], ["👩🏻‍🌾"], ["👩🏼‍🌾"], ["👩🏽‍🌾"], ["👩🏾‍🌾"], ["👩🏿‍🌾"]], ["👩‍🌾", [], "female,farmer", "1F469-200D-1F33E"]], "male-cook": [[["👨‍🍳"], ["👨🏻‍🍳"], ["👨🏼‍🍳"], ["👨🏽‍🍳"], ["👨🏾‍🍳"], ["👨🏿‍🍳"]], ["👨‍🍳", [], "male,cook", "1F468-200D-1F373"]], "female-cook": [[["👩‍🍳"], ["👩🏻‍🍳"], ["👩🏼‍🍳"], ["👩🏽‍🍳"], ["👩🏾‍🍳"], ["👩🏿‍🍳"]], ["👩‍🍳", [], "female,cook", "1F469-200D-1F373"]], "male-mechanic": [[["👨‍🔧"], ["👨🏻‍🔧"], ["👨🏼‍🔧"], ["👨🏽‍🔧"], ["👨🏾‍🔧"], ["👨🏿‍🔧"]], ["👨‍🔧", [], "male,mechanic", "1F468-200D-1F527"]], "female-mechanic": [[["👩‍🔧"], ["👩🏻‍🔧"], ["👩🏼‍🔧"], ["👩🏽‍🔧"], ["👩🏾‍🔧"], ["👩🏿‍🔧"]], ["👩‍🔧", [], "female,mechanic", "1F469-200D-1F527"]], "male-factory-worker": [[["👨‍🏭"], ["👨🏻‍🏭"], ["👨🏼‍🏭"], ["👨🏽‍🏭"], ["👨🏾‍🏭"], ["👨🏿‍🏭"]], ["👨‍🏭", [], "male,factory,worker", "1F468-200D-1F3ED"]], "female-factory-worker": [[["👩‍🏭"], ["👩🏻‍🏭"], ["👩🏼‍🏭"], ["👩🏽‍🏭"], ["👩🏾‍🏭"], ["👩🏿‍🏭"]], ["👩‍🏭", [], "female,factory,worker", "1F469-200D-1F3ED"]], "male-office-worker": [[["👨‍💼"], ["👨🏻‍💼"], ["👨🏼‍💼"], ["👨🏽‍💼"], ["👨🏾‍💼"], ["👨🏿‍💼"]], ["👨‍💼", [], "male,office,worker", "1F468-200D-1F4BC"]], "female-office-worker": [[["👩‍💼"], ["👩🏻‍💼"], ["👩🏼‍💼"], ["👩🏽‍💼"], ["👩🏾‍💼"], ["👩🏿‍💼"]], ["👩‍💼", [], "female,office,worker", "1F469-200D-1F4BC"]], "male-scientist": [[["👨‍🔬"], ["👨🏻‍🔬"], ["👨🏼‍🔬"], ["👨🏽‍🔬"], ["👨🏾‍🔬"], ["👨🏿‍🔬"]], ["👨‍🔬", [], "male,scientist", "1F468-200D-1F52C"]], "female-scientist": [[["👩‍🔬"], ["👩🏻‍🔬"], ["👩🏼‍🔬"], ["👩🏽‍🔬"], ["👩🏾‍🔬"], ["👩🏿‍🔬"]], ["👩‍🔬", [], "female,scientist", "1F469-200D-1F52C"]], "male-technologist": [[["👨‍💻"], ["👨🏻‍💻"], ["👨🏼‍💻"], ["👨🏽‍💻"], ["👨🏾‍💻"], ["👨🏿‍💻"]], ["👨‍💻", [], "male,technologist", "1F468-200D-1F4BB"]], "female-technologist": [[["👩‍💻"], ["👩🏻‍💻"], ["👩🏼‍💻"], ["👩🏽‍💻"], ["👩🏾‍💻"], ["👩🏿‍💻"]], ["👩‍💻", [], "female,technologist", "1F469-200D-1F4BB"]], "male-singer": [[["👨‍🎤"], ["👨🏻‍🎤"], ["👨🏼‍🎤"], ["👨🏽‍🎤"], ["👨🏾‍🎤"], ["👨🏿‍🎤"]], ["👨‍🎤", [], "male,singer", "1F468-200D-1F3A4"]], "female-singer": [[["👩‍🎤"], ["👩🏻‍🎤"], ["👩🏼‍🎤"], ["👩🏽‍🎤"], ["👩🏾‍🎤"], ["👩🏿‍🎤"]], ["👩‍🎤", [], "female,singer", "1F469-200D-1F3A4"]], "male-artist": [[["👨‍🎨"], ["👨🏻‍🎨"], ["👨🏼‍🎨"], ["👨🏽‍🎨"], ["👨🏾‍🎨"], ["👨🏿‍🎨"]], ["👨‍🎨", [], "male,artist", "1F468-200D-1F3A8"]], "female-artist": [[["👩‍🎨"], ["👩🏻‍🎨"], ["👩🏼‍🎨"], ["👩🏽‍🎨"], ["👩🏾‍🎨"], ["👩🏿‍🎨"]], ["👩‍🎨", [], "female,artist", "1F469-200D-1F3A8"]], "male-pilot": [[["👨‍✈", "1f468-200d-2708-fe0f"], ["👨‍✈️"], ["👨🏻‍✈", "1f468-1f3fb-200d-2708-fe0f"], ["👨🏼‍✈", "1f468-1f3fc-200d-2708-fe0f"], ["👨🏽‍✈", "1f468-1f3fd-200d-2708-fe0f"], ["👨🏾‍✈", "1f468-1f3fe-200d-2708-fe0f"], ["👨🏿‍✈", "1f468-1f3ff-200d-2708-fe0f"], ["👨🏻‍✈️"], ["👨🏼‍✈️"], ["👨🏽‍✈️"], ["👨🏾‍✈️"], ["👨🏿‍✈️"]], ["👨‍✈️", [], "male,pilot", "1F468-200D-2708-FE0F"]], "female-pilot": [[["👩‍✈", "1f469-200d-2708-fe0f"], ["👩‍✈️"], ["👩🏻‍✈", "1f469-1f3fb-200d-2708-fe0f"], ["👩🏼‍✈", "1f469-1f3fc-200d-2708-fe0f"], ["👩🏽‍✈", "1f469-1f3fd-200d-2708-fe0f"], ["👩🏾‍✈", "1f469-1f3fe-200d-2708-fe0f"], ["👩🏿‍✈", "1f469-1f3ff-200d-2708-fe0f"], ["👩🏻‍✈️"], ["👩🏼‍✈️"], ["👩🏽‍✈️"], ["👩🏾‍✈️"], ["👩🏿‍✈️"]], ["👩‍✈️", [], "female,pilot", "1F469-200D-2708-FE0F"]], "male-astronaut": [[["👨‍🚀"], ["👨🏻‍🚀"], ["👨🏼‍🚀"], ["👨🏽‍🚀"], ["👨🏾‍🚀"], ["👨🏿‍🚀"]], ["👨‍🚀", [], "male,astronaut", "1F468-200D-1F680"]], "female-astronaut": [[["👩‍🚀"], ["👩🏻‍🚀"], ["👩🏼‍🚀"], ["👩🏽‍🚀"], ["👩🏾‍🚀"], ["👩🏿‍🚀"]], ["👩‍🚀", [], "female,astronaut", "1F469-200D-1F680"]], "male-firefighter": [[["👨‍🚒"], ["👨🏻‍🚒"], ["👨🏼‍🚒"], ["👨🏽‍🚒"], ["👨🏾‍🚒"], ["👨🏿‍🚒"]], ["👨‍🚒", [], "male,firefighter", "1F468-200D-1F692"]], "female-firefighter": [[["👩‍🚒"], ["👩🏻‍🚒"], ["👩🏼‍🚒"], ["👩🏽‍🚒"], ["👩🏾‍🚒"], ["👩🏿‍🚒"]], ["👩‍🚒", [], "female,firefighter", "1F469-200D-1F692"]], "male-police-officer": [[["👮‍♂", "1f46e-200d-2642-fe0f"], ["👮‍♂️"], ["👮🏻‍♂", "1f46e-1f3fb-200d-2642-fe0f"], ["👮🏼‍♂", "1f46e-1f3fc-200d-2642-fe0f"], ["👮🏽‍♂", "1f46e-1f3fd-200d-2642-fe0f"], ["👮🏾‍♂", "1f46e-1f3fe-200d-2642-fe0f"], ["👮🏿‍♂", "1f46e-1f3ff-200d-2642-fe0f"], ["👮🏻‍♂️"], ["👮🏼‍♂️"], ["👮🏽‍♂️"], ["👮🏾‍♂️"], ["👮🏿‍♂️"]], ["👮‍♂️", [], "male,police,officer", "1F46E-200D-2642-FE0F"]], "female-police-officer": [[["👮‍♀", "1f46e-200d-2640-fe0f"], ["👮‍♀️"], ["👮🏻‍♀", "1f46e-1f3fb-200d-2640-fe0f"], ["👮🏼‍♀", "1f46e-1f3fc-200d-2640-fe0f"], ["👮🏽‍♀", "1f46e-1f3fd-200d-2640-fe0f"], ["👮🏾‍♀", "1f46e-1f3fe-200d-2640-fe0f"], ["👮🏿‍♀", "1f46e-1f3ff-200d-2640-fe0f"], ["👮🏻‍♀️"], ["👮🏼‍♀️"], ["👮🏽‍♀️"], ["👮🏾‍♀️"], ["👮🏿‍♀️"]], ["👮‍♀️", [], "female,police,officer", "1F46E-200D-2640-FE0F"]], "male-guard": [[["💂‍♂", "1f482-200d-2642-fe0f"], ["💂‍♂️"], ["💂🏻‍♂", "1f482-1f3fb-200d-2642-fe0f"], ["💂🏼‍♂", "1f482-1f3fc-200d-2642-fe0f"], ["💂🏽‍♂", "1f482-1f3fd-200d-2642-fe0f"], ["💂🏾‍♂", "1f482-1f3fe-200d-2642-fe0f"], ["💂🏿‍♂", "1f482-1f3ff-200d-2642-fe0f"], ["💂🏻‍♂️"], ["💂🏼‍♂️"], ["💂🏽‍♂️"], ["💂🏾‍♂️"], ["💂🏿‍♂️"]], ["💂‍♂️", [], "male,guard", "1F482-200D-2642-FE0F"]], "female-guard": [[["💂‍♀", "1f482-200d-2640-fe0f"], ["💂‍♀️"], ["💂🏻‍♀", "1f482-1f3fb-200d-2640-fe0f"], ["💂🏼‍♀", "1f482-1f3fc-200d-2640-fe0f"], ["💂🏽‍♀", "1f482-1f3fd-200d-2640-fe0f"], ["💂🏾‍♀", "1f482-1f3fe-200d-2640-fe0f"], ["💂🏿‍♀", "1f482-1f3ff-200d-2640-fe0f"], ["💂🏻‍♀️"], ["💂🏼‍♀️"], ["💂🏽‍♀️"], ["💂🏾‍♀️"], ["💂🏿‍♀️"]], ["💂‍♀️", [], "female,guard", "1F482-200D-2640-FE0F"]], "male-construction-worker": [[["👷‍♂", "1f477-200d-2642-fe0f"], ["👷‍♂️"], ["👷🏻‍♂", "1f477-1f3fb-200d-2642-fe0f"], ["👷🏼‍♂", "1f477-1f3fc-200d-2642-fe0f"], ["👷🏽‍♂", "1f477-1f3fd-200d-2642-fe0f"], ["👷🏾‍♂", "1f477-1f3fe-200d-2642-fe0f"], ["👷🏿‍♂", "1f477-1f3ff-200d-2642-fe0f"], ["👷🏻‍♂️"], ["👷🏼‍♂️"], ["👷🏽‍♂️"], ["👷🏾‍♂️"], ["👷🏿‍♂️"]], ["👷‍♂️", [], "male,construction,worker", "1F477-200D-2642-FE0F"]], "female-construction-worker": [[["👷‍♀", "1f477-200d-2640-fe0f"], ["👷‍♀️"], ["👷🏻‍♀", "1f477-1f3fb-200d-2640-fe0f"], ["👷🏼‍♀", "1f477-1f3fc-200d-2640-fe0f"], ["👷🏽‍♀", "1f477-1f3fd-200d-2640-fe0f"], ["👷🏾‍♀", "1f477-1f3fe-200d-2640-fe0f"], ["👷🏿‍♀", "1f477-1f3ff-200d-2640-fe0f"], ["👷🏻‍♀️"], ["👷🏼‍♀️"], ["👷🏽‍♀️"], ["👷🏾‍♀️"], ["👷🏿‍♀️"]], ["👷‍♀️", [], "female,construction,worker", "1F477-200D-2640-FE0F"]], "man-wearing-turban": [[["👳‍♂", "1f473-200d-2642-fe0f"], ["👳‍♂️"], ["👳🏻‍♂", "1f473-1f3fb-200d-2642-fe0f"], ["👳🏼‍♂", "1f473-1f3fc-200d-2642-fe0f"], ["👳🏽‍♂", "1f473-1f3fd-200d-2642-fe0f"], ["👳🏾‍♂", "1f473-1f3fe-200d-2642-fe0f"], ["👳🏿‍♂", "1f473-1f3ff-200d-2642-fe0f"], ["👳🏻‍♂️"], ["👳🏼‍♂️"], ["👳🏽‍♂️"], ["👳🏾‍♂️"], ["👳🏿‍♂️"]], ["👳‍♂️", [], "man,wearing,turban", "1F473-200D-2642-FE0F"]], "woman-wearing-turban": [[["👳‍♀", "1f473-200d-2640-fe0f"], ["👳‍♀️"], ["👳🏻‍♀", "1f473-1f3fb-200d-2640-fe0f"], ["👳🏼‍♀", "1f473-1f3fc-200d-2640-fe0f"], ["👳🏽‍♀", "1f473-1f3fd-200d-2640-fe0f"], ["👳🏾‍♀", "1f473-1f3fe-200d-2640-fe0f"], ["👳🏿‍♀", "1f473-1f3ff-200d-2640-fe0f"], ["👳🏻‍♀️"], ["👳🏼‍♀️"], ["👳🏽‍♀️"], ["👳🏾‍♀️"], ["👳🏿‍♀️"]], ["👳‍♀️", [], "woman,wearing,turban", "1F473-200D-2640-FE0F"]], "blond-haired-man": [[["👱‍♂", "1f471-200d-2642-fe0f"], ["👱‍♂️"], ["👱🏻‍♂", "1f471-1f3fb-200d-2642-fe0f"], ["👱🏼‍♂", "1f471-1f3fc-200d-2642-fe0f"], ["👱🏽‍♂", "1f471-1f3fd-200d-2642-fe0f"], ["👱🏾‍♂", "1f471-1f3fe-200d-2642-fe0f"], ["👱🏿‍♂", "1f471-1f3ff-200d-2642-fe0f"], ["👱🏻‍♂️"], ["👱🏼‍♂️"], ["👱🏽‍♂️"], ["👱🏾‍♂️"], ["👱🏿‍♂️"]], ["👱‍♂️", [], "blond,haired,man", "1F471-200D-2642-FE0F"]], "blond-haired-woman": [[["👱‍♀", "1f471-200d-2640-fe0f"], ["👱‍♀️"], ["👱🏻‍♀", "1f471-1f3fb-200d-2640-fe0f"], ["👱🏼‍♀", "1f471-1f3fc-200d-2640-fe0f"], ["👱🏽‍♀", "1f471-1f3fd-200d-2640-fe0f"], ["👱🏾‍♀", "1f471-1f3fe-200d-2640-fe0f"], ["👱🏿‍♀", "1f471-1f3ff-200d-2640-fe0f"], ["👱🏻‍♀️"], ["👱🏼‍♀️"], ["👱🏽‍♀️"], ["👱🏾‍♀️"], ["👱🏿‍♀️"]], ["👱‍♀️", [], "blond,haired,woman", "1F471-200D-2640-FE0F"]], "female_mage": [[["🧙‍♀", "1f9d9-200d-2640-fe0f"], ["🧙‍♀️"], ["🧙🏻‍♀", "1f9d9-1f3fb-200d-2640-fe0f"], ["🧙🏼‍♀", "1f9d9-1f3fc-200d-2640-fe0f"], ["🧙🏽‍♀", "1f9d9-1f3fd-200d-2640-fe0f"], ["🧙🏾‍♀", "1f9d9-1f3fe-200d-2640-fe0f"], ["🧙🏿‍♀", "1f9d9-1f3ff-200d-2640-fe0f"], ["🧙🏻‍♀️"], ["🧙🏼‍♀️"], ["🧙🏽‍♀️"], ["🧙🏾‍♀️"], ["🧙🏿‍♀️"]], ["🧙‍♀️", [], "female,mage", "1F9D9-200D-2640-FE0F"]], "male_mage": [[["🧙‍♂", "1f9d9-200d-2642-fe0f"], ["🧙‍♂️"], ["🧙🏻‍♂", "1f9d9-1f3fb-200d-2642-fe0f"], ["🧙🏼‍♂", "1f9d9-1f3fc-200d-2642-fe0f"], ["🧙🏽‍♂", "1f9d9-1f3fd-200d-2642-fe0f"], ["🧙🏾‍♂", "1f9d9-1f3fe-200d-2642-fe0f"], ["🧙🏿‍♂", "1f9d9-1f3ff-200d-2642-fe0f"], ["🧙🏻‍♂️"], ["🧙🏼‍♂️"], ["🧙🏽‍♂️"], ["🧙🏾‍♂️"], ["🧙🏿‍♂️"]], ["🧙‍♂️", [], "male,mage", "1F9D9-200D-2642-FE0F"]], "female_fairy": [[["🧚‍♀", "1f9da-200d-2640-fe0f"], ["🧚‍♀️"], ["🧚🏻‍♀", "1f9da-1f3fb-200d-2640-fe0f"], ["🧚🏼‍♀", "1f9da-1f3fc-200d-2640-fe0f"], ["🧚🏽‍♀", "1f9da-1f3fd-200d-2640-fe0f"], ["🧚🏾‍♀", "1f9da-1f3fe-200d-2640-fe0f"], ["🧚🏿‍♀", "1f9da-1f3ff-200d-2640-fe0f"], ["🧚🏻‍♀️"], ["🧚🏼‍♀️"], ["🧚🏽‍♀️"], ["🧚🏾‍♀️"], ["🧚🏿‍♀️"]], ["🧚‍♀️", [], "female,fairy", "1F9DA-200D-2640-FE0F"]], "male_fairy": [[["🧚‍♂", "1f9da-200d-2642-fe0f"], ["🧚‍♂️"], ["🧚🏻‍♂", "1f9da-1f3fb-200d-2642-fe0f"], ["🧚🏼‍♂", "1f9da-1f3fc-200d-2642-fe0f"], ["🧚🏽‍♂", "1f9da-1f3fd-200d-2642-fe0f"], ["🧚🏾‍♂", "1f9da-1f3fe-200d-2642-fe0f"], ["🧚🏿‍♂", "1f9da-1f3ff-200d-2642-fe0f"], ["🧚🏻‍♂️"], ["🧚🏼‍♂️"], ["🧚🏽‍♂️"], ["🧚🏾‍♂️"], ["🧚🏿‍♂️"]], ["🧚‍♂️", [], "male,fairy", "1F9DA-200D-2642-FE0F"]], "female_vampire": [[["🧛‍♀", "1f9db-200d-2640-fe0f"], ["🧛‍♀️"], ["🧛🏻‍♀", "1f9db-1f3fb-200d-2640-fe0f"], ["🧛🏼‍♀", "1f9db-1f3fc-200d-2640-fe0f"], ["🧛🏽‍♀", "1f9db-1f3fd-200d-2640-fe0f"], ["🧛🏾‍♀", "1f9db-1f3fe-200d-2640-fe0f"], ["🧛🏿‍♀", "1f9db-1f3ff-200d-2640-fe0f"], ["🧛🏻‍♀️"], ["🧛🏼‍♀️"], ["🧛🏽‍♀️"], ["🧛🏾‍♀️"], ["🧛🏿‍♀️"]], ["🧛‍♀️", [], "female,vampire", "1F9DB-200D-2640-FE0F"]], "male_vampire": [[["🧛‍♂", "1f9db-200d-2642-fe0f"], ["🧛‍♂️"], ["🧛🏻‍♂", "1f9db-1f3fb-200d-2642-fe0f"], ["🧛🏼‍♂", "1f9db-1f3fc-200d-2642-fe0f"], ["🧛🏽‍♂", "1f9db-1f3fd-200d-2642-fe0f"], ["🧛🏾‍♂", "1f9db-1f3fe-200d-2642-fe0f"], ["🧛🏿‍♂", "1f9db-1f3ff-200d-2642-fe0f"], ["🧛🏻‍♂️"], ["🧛🏼‍♂️"], ["🧛🏽‍♂️"], ["🧛🏾‍♂️"], ["🧛🏿‍♂️"]], ["🧛‍♂️", [], "male,vampire", "1F9DB-200D-2642-FE0F"]], "mermaid": [[["🧜‍♀", "1f9dc-200d-2640-fe0f"], ["🧜‍♀️"], ["🧜🏻‍♀", "1f9dc-1f3fb-200d-2640-fe0f"], ["🧜🏼‍♀", "1f9dc-1f3fc-200d-2640-fe0f"], ["🧜🏽‍♀", "1f9dc-1f3fd-200d-2640-fe0f"], ["🧜🏾‍♀", "1f9dc-1f3fe-200d-2640-fe0f"], ["🧜🏿‍♀", "1f9dc-1f3ff-200d-2640-fe0f"], ["🧜🏻‍♀️"], ["🧜🏼‍♀️"], ["🧜🏽‍♀️"], ["🧜🏾‍♀️"], ["🧜🏿‍♀️"]], ["🧜‍♀️", [], "mermaid", "1F9DC-200D-2640-FE0F"]], "merman": [[["🧜‍♂", "1f9dc-200d-2642-fe0f"], ["🧜‍♂️"], ["🧜🏻‍♂", "1f9dc-1f3fb-200d-2642-fe0f"], ["🧜🏼‍♂", "1f9dc-1f3fc-200d-2642-fe0f"], ["🧜🏽‍♂", "1f9dc-1f3fd-200d-2642-fe0f"], ["🧜🏾‍♂", "1f9dc-1f3fe-200d-2642-fe0f"], ["🧜🏿‍♂", "1f9dc-1f3ff-200d-2642-fe0f"], ["🧜🏻‍♂️"], ["🧜🏼‍♂️"], ["🧜🏽‍♂️"], ["🧜🏾‍♂️"], ["🧜🏿‍♂️"]], ["🧜‍♂️", [], "merman", "1F9DC-200D-2642-FE0F"]], "female_elf": [[["🧝‍♀", "1f9dd-200d-2640-fe0f"], ["🧝‍♀️"], ["🧝🏻‍♀", "1f9dd-1f3fb-200d-2640-fe0f"], ["🧝🏼‍♀", "1f9dd-1f3fc-200d-2640-fe0f"], ["🧝🏽‍♀", "1f9dd-1f3fd-200d-2640-fe0f"], ["🧝🏾‍♀", "1f9dd-1f3fe-200d-2640-fe0f"], ["🧝🏿‍♀", "1f9dd-1f3ff-200d-2640-fe0f"], ["🧝🏻‍♀️"], ["🧝🏼‍♀️"], ["🧝🏽‍♀️"], ["🧝🏾‍♀️"], ["🧝🏿‍♀️"]], ["🧝‍♀️", [], "female,elf", "1F9DD-200D-2640-FE0F"]], "male_elf": [[["🧝‍♂", "1f9dd-200d-2642-fe0f"], ["🧝‍♂️"], ["🧝🏻‍♂", "1f9dd-1f3fb-200d-2642-fe0f"], ["🧝🏼‍♂", "1f9dd-1f3fc-200d-2642-fe0f"], ["🧝🏽‍♂", "1f9dd-1f3fd-200d-2642-fe0f"], ["🧝🏾‍♂", "1f9dd-1f3fe-200d-2642-fe0f"], ["🧝🏿‍♂", "1f9dd-1f3ff-200d-2642-fe0f"], ["🧝🏻‍♂️"], ["🧝🏼‍♂️"], ["🧝🏽‍♂️"], ["🧝🏾‍♂️"], ["🧝🏿‍♂️"]], ["🧝‍♂️", [], "male,elf", "1F9DD-200D-2642-FE0F"]], "female_genie": [[["🧞‍♀", "1f9de-200d-2640-fe0f"], ["🧞‍♀️"]], ["🧞‍♀️", [], "female,genie", "1F9DE-200D-2640-FE0F"]], "male_genie": [[["🧞‍♂", "1f9de-200d-2642-fe0f"], ["🧞‍♂️"]], ["🧞‍♂️", [], "male,genie", "1F9DE-200D-2642-FE0F"]], "female_zombie": [[["🧟‍♀", "1f9df-200d-2640-fe0f"], ["🧟‍♀️"]], ["🧟‍♀️", [], "female,zombie", "1F9DF-200D-2640-FE0F"]], "male_zombie": [[["🧟‍♂", "1f9df-200d-2642-fe0f"], ["🧟‍♂️"]], ["🧟‍♂️", [], "male,zombie", "1F9DF-200D-2642-FE0F"]], "man-frowning": [[["🙍‍♂", "1f64d-200d-2642-fe0f"], ["🙍‍♂️"], ["🙍🏻‍♂", "1f64d-1f3fb-200d-2642-fe0f"], ["🙍🏼‍♂", "1f64d-1f3fc-200d-2642-fe0f"], ["🙍🏽‍♂", "1f64d-1f3fd-200d-2642-fe0f"], ["🙍🏾‍♂", "1f64d-1f3fe-200d-2642-fe0f"], ["🙍🏿‍♂", "1f64d-1f3ff-200d-2642-fe0f"], ["🙍🏻‍♂️"], ["🙍🏼‍♂️"], ["🙍🏽‍♂️"], ["🙍🏾‍♂️"], ["🙍🏿‍♂️"]], ["🙍‍♂️", [], "man,frowning", "1F64D-200D-2642-FE0F"]], "woman-frowning": [[["🙍‍♀", "1f64d-200d-2640-fe0f"], ["🙍‍♀️"], ["🙍🏻‍♀", "1f64d-1f3fb-200d-2640-fe0f"], ["🙍🏼‍♀", "1f64d-1f3fc-200d-2640-fe0f"], ["🙍🏽‍♀", "1f64d-1f3fd-200d-2640-fe0f"], ["🙍🏾‍♀", "1f64d-1f3fe-200d-2640-fe0f"], ["🙍🏿‍♀", "1f64d-1f3ff-200d-2640-fe0f"], ["🙍🏻‍♀️"], ["🙍🏼‍♀️"], ["🙍🏽‍♀️"], ["🙍🏾‍♀️"], ["🙍🏿‍♀️"]], ["🙍‍♀️", [], "woman,frowning", "1F64D-200D-2640-FE0F"]], "man-pouting": [[["🙎‍♂", "1f64e-200d-2642-fe0f"], ["🙎‍♂️"], ["🙎🏻‍♂", "1f64e-1f3fb-200d-2642-fe0f"], ["🙎🏼‍♂", "1f64e-1f3fc-200d-2642-fe0f"], ["🙎🏽‍♂", "1f64e-1f3fd-200d-2642-fe0f"], ["🙎🏾‍♂", "1f64e-1f3fe-200d-2642-fe0f"], ["🙎🏿‍♂", "1f64e-1f3ff-200d-2642-fe0f"], ["🙎🏻‍♂️"], ["🙎🏼‍♂️"], ["🙎🏽‍♂️"], ["🙎🏾‍♂️"], ["🙎🏿‍♂️"]], ["🙎‍♂️", [], "man,pouting", "1F64E-200D-2642-FE0F"]], "woman-pouting": [[["🙎‍♀", "1f64e-200d-2640-fe0f"], ["🙎‍♀️"], ["🙎🏻‍♀", "1f64e-1f3fb-200d-2640-fe0f"], ["🙎🏼‍♀", "1f64e-1f3fc-200d-2640-fe0f"], ["🙎🏽‍♀", "1f64e-1f3fd-200d-2640-fe0f"], ["🙎🏾‍♀", "1f64e-1f3fe-200d-2640-fe0f"], ["🙎🏿‍♀", "1f64e-1f3ff-200d-2640-fe0f"], ["🙎🏻‍♀️"], ["🙎🏼‍♀️"], ["🙎🏽‍♀️"], ["🙎🏾‍♀️"], ["🙎🏿‍♀️"]], ["🙎‍♀️", [], "woman,pouting", "1F64E-200D-2640-FE0F"]], "man-gesturing-no": [[["🙅‍♂", "1f645-200d-2642-fe0f"], ["🙅‍♂️"], ["🙅🏻‍♂", "1f645-1f3fb-200d-2642-fe0f"], ["🙅🏼‍♂", "1f645-1f3fc-200d-2642-fe0f"], ["🙅🏽‍♂", "1f645-1f3fd-200d-2642-fe0f"], ["🙅🏾‍♂", "1f645-1f3fe-200d-2642-fe0f"], ["🙅🏿‍♂", "1f645-1f3ff-200d-2642-fe0f"], ["🙅🏻‍♂️"], ["🙅🏼‍♂️"], ["🙅🏽‍♂️"], ["🙅🏾‍♂️"], ["🙅🏿‍♂️"]], ["🙅‍♂️", [], "man,gesturing,no", "1F645-200D-2642-FE0F"]], "woman-gesturing-no": [[["🙅‍♀", "1f645-200d-2640-fe0f"], ["🙅‍♀️"], ["🙅🏻‍♀", "1f645-1f3fb-200d-2640-fe0f"], ["🙅🏼‍♀", "1f645-1f3fc-200d-2640-fe0f"], ["🙅🏽‍♀", "1f645-1f3fd-200d-2640-fe0f"], ["🙅🏾‍♀", "1f645-1f3fe-200d-2640-fe0f"], ["🙅🏿‍♀", "1f645-1f3ff-200d-2640-fe0f"], ["🙅🏻‍♀️"], ["🙅🏼‍♀️"], ["🙅🏽‍♀️"], ["🙅🏾‍♀️"], ["🙅🏿‍♀️"]], ["🙅‍♀️", [], "woman,gesturing,no", "1F645-200D-2640-FE0F"]], "man-gesturing-ok": [[["🙆‍♂", "1f646-200d-2642-fe0f"], ["🙆‍♂️"], ["🙆🏻‍♂", "1f646-1f3fb-200d-2642-fe0f"], ["🙆🏼‍♂", "1f646-1f3fc-200d-2642-fe0f"], ["🙆🏽‍♂", "1f646-1f3fd-200d-2642-fe0f"], ["🙆🏾‍♂", "1f646-1f3fe-200d-2642-fe0f"], ["🙆🏿‍♂", "1f646-1f3ff-200d-2642-fe0f"], ["🙆🏻‍♂️"], ["🙆🏼‍♂️"], ["🙆🏽‍♂️"], ["🙆🏾‍♂️"], ["🙆🏿‍♂️"]], ["🙆‍♂️", [], "man,gesturing,ok", "1F646-200D-2642-FE0F"]], "woman-gesturing-ok": [[["🙆‍♀", "1f646-200d-2640-fe0f"], ["🙆‍♀️"], ["🙆🏻‍♀", "1f646-1f3fb-200d-2640-fe0f"], ["🙆🏼‍♀", "1f646-1f3fc-200d-2640-fe0f"], ["🙆🏽‍♀", "1f646-1f3fd-200d-2640-fe0f"], ["🙆🏾‍♀", "1f646-1f3fe-200d-2640-fe0f"], ["🙆🏿‍♀", "1f646-1f3ff-200d-2640-fe0f"], ["🙆🏻‍♀️"], ["🙆🏼‍♀️"], ["🙆🏽‍♀️"], ["🙆🏾‍♀️"], ["🙆🏿‍♀️"]], ["🙆‍♀️", [], "woman,gesturing,ok", "1F646-200D-2640-FE0F"]], "man-tipping-hand": [[["💁‍♂", "1f481-200d-2642-fe0f"], ["💁‍♂️"], ["💁🏻‍♂", "1f481-1f3fb-200d-2642-fe0f"], ["💁🏼‍♂", "1f481-1f3fc-200d-2642-fe0f"], ["💁🏽‍♂", "1f481-1f3fd-200d-2642-fe0f"], ["💁🏾‍♂", "1f481-1f3fe-200d-2642-fe0f"], ["💁🏿‍♂", "1f481-1f3ff-200d-2642-fe0f"], ["💁🏻‍♂️"], ["💁🏼‍♂️"], ["💁🏽‍♂️"], ["💁🏾‍♂️"], ["💁🏿‍♂️"]], ["💁‍♂️", [], "man,tipping,hand", "1F481-200D-2642-FE0F"]], "woman-tipping-hand": [[["💁‍♀", "1f481-200d-2640-fe0f"], ["💁‍♀️"], ["💁🏻‍♀", "1f481-1f3fb-200d-2640-fe0f"], ["💁🏼‍♀", "1f481-1f3fc-200d-2640-fe0f"], ["💁🏽‍♀", "1f481-1f3fd-200d-2640-fe0f"], ["💁🏾‍♀", "1f481-1f3fe-200d-2640-fe0f"], ["💁🏿‍♀", "1f481-1f3ff-200d-2640-fe0f"], ["💁🏻‍♀️"], ["💁🏼‍♀️"], ["💁🏽‍♀️"], ["💁🏾‍♀️"], ["💁🏿‍♀️"]], ["💁‍♀️", [], "woman,tipping,hand", "1F481-200D-2640-FE0F"]], "man-raising-hand": [[["🙋‍♂", "1f64b-200d-2642-fe0f"], ["🙋‍♂️"], ["🙋🏻‍♂", "1f64b-1f3fb-200d-2642-fe0f"], ["🙋🏼‍♂", "1f64b-1f3fc-200d-2642-fe0f"], ["🙋🏽‍♂", "1f64b-1f3fd-200d-2642-fe0f"], ["🙋🏾‍♂", "1f64b-1f3fe-200d-2642-fe0f"], ["🙋🏿‍♂", "1f64b-1f3ff-200d-2642-fe0f"], ["🙋🏻‍♂️"], ["🙋🏼‍♂️"], ["🙋🏽‍♂️"], ["🙋🏾‍♂️"], ["🙋🏿‍♂️"]], ["🙋‍♂️", [], "man,raising,hand", "1F64B-200D-2642-FE0F"]], "woman-raising-hand": [[["🙋‍♀", "1f64b-200d-2640-fe0f"], ["🙋‍♀️"], ["🙋🏻‍♀", "1f64b-1f3fb-200d-2640-fe0f"], ["🙋🏼‍♀", "1f64b-1f3fc-200d-2640-fe0f"], ["🙋🏽‍♀", "1f64b-1f3fd-200d-2640-fe0f"], ["🙋🏾‍♀", "1f64b-1f3fe-200d-2640-fe0f"], ["🙋🏿‍♀", "1f64b-1f3ff-200d-2640-fe0f"], ["🙋🏻‍♀️"], ["🙋🏼‍♀️"], ["🙋🏽‍♀️"], ["🙋🏾‍♀️"], ["🙋🏿‍♀️"]], ["🙋‍♀️", [], "woman,raising,hand", "1F64B-200D-2640-FE0F"]], "man-bowing": [[["🙇‍♂", "1f647-200d-2642-fe0f"], ["🙇‍♂️"], ["🙇🏻‍♂", "1f647-1f3fb-200d-2642-fe0f"], ["🙇🏼‍♂", "1f647-1f3fc-200d-2642-fe0f"], ["🙇🏽‍♂", "1f647-1f3fd-200d-2642-fe0f"], ["🙇🏾‍♂", "1f647-1f3fe-200d-2642-fe0f"], ["🙇🏿‍♂", "1f647-1f3ff-200d-2642-fe0f"], ["🙇🏻‍♂️"], ["🙇🏼‍♂️"], ["🙇🏽‍♂️"], ["🙇🏾‍♂️"], ["🙇🏿‍♂️"]], ["🙇‍♂️", [], "man,bowing", "1F647-200D-2642-FE0F"]], "woman-bowing": [[["🙇‍♀", "1f647-200d-2640-fe0f"], ["🙇‍♀️"], ["🙇🏻‍♀", "1f647-1f3fb-200d-2640-fe0f"], ["🙇🏼‍♀", "1f647-1f3fc-200d-2640-fe0f"], ["🙇🏽‍♀", "1f647-1f3fd-200d-2640-fe0f"], ["🙇🏾‍♀", "1f647-1f3fe-200d-2640-fe0f"], ["🙇🏿‍♀", "1f647-1f3ff-200d-2640-fe0f"], ["🙇🏻‍♀️"], ["🙇🏼‍♀️"], ["🙇🏽‍♀️"], ["🙇🏾‍♀️"], ["🙇🏿‍♀️"]], ["🙇‍♀️", [], "woman,bowing", "1F647-200D-2640-FE0F"]], "man-facepalming": [[["🤦‍♂", "1f926-200d-2642-fe0f"], ["🤦‍♂️"], ["🤦🏻‍♂", "1f926-1f3fb-200d-2642-fe0f"], ["🤦🏼‍♂", "1f926-1f3fc-200d-2642-fe0f"], ["🤦🏽‍♂", "1f926-1f3fd-200d-2642-fe0f"], ["🤦🏾‍♂", "1f926-1f3fe-200d-2642-fe0f"], ["🤦🏿‍♂", "1f926-1f3ff-200d-2642-fe0f"], ["🤦🏻‍♂️"], ["🤦🏼‍♂️"], ["🤦🏽‍♂️"], ["🤦🏾‍♂️"], ["🤦🏿‍♂️"]], ["🤦‍♂️", [], "man,facepalming", "1F926-200D-2642-FE0F"]], "woman-facepalming": [[["🤦‍♀", "1f926-200d-2640-fe0f"], ["🤦‍♀️"], ["🤦🏻‍♀", "1f926-1f3fb-200d-2640-fe0f"], ["🤦🏼‍♀", "1f926-1f3fc-200d-2640-fe0f"], ["🤦🏽‍♀", "1f926-1f3fd-200d-2640-fe0f"], ["🤦🏾‍♀", "1f926-1f3fe-200d-2640-fe0f"], ["🤦🏿‍♀", "1f926-1f3ff-200d-2640-fe0f"], ["🤦🏻‍♀️"], ["🤦🏼‍♀️"], ["🤦🏽‍♀️"], ["🤦🏾‍♀️"], ["🤦🏿‍♀️"]], ["🤦‍♀️", [], "woman,facepalming", "1F926-200D-2640-FE0F"]], "man-shrugging": [[["🤷‍♂", "1f937-200d-2642-fe0f"], ["🤷‍♂️"], ["🤷🏻‍♂", "1f937-1f3fb-200d-2642-fe0f"], ["🤷🏼‍♂", "1f937-1f3fc-200d-2642-fe0f"], ["🤷🏽‍♂", "1f937-1f3fd-200d-2642-fe0f"], ["🤷🏾‍♂", "1f937-1f3fe-200d-2642-fe0f"], ["🤷🏿‍♂", "1f937-1f3ff-200d-2642-fe0f"], ["🤷🏻‍♂️"], ["🤷🏼‍♂️"], ["🤷🏽‍♂️"], ["🤷🏾‍♂️"], ["🤷🏿‍♂️"]], ["🤷‍♂️", [], "man,shrugging", "1F937-200D-2642-FE0F"]], "woman-shrugging": [[["🤷‍♀", "1f937-200d-2640-fe0f"], ["🤷‍♀️"], ["🤷🏻‍♀", "1f937-1f3fb-200d-2640-fe0f"], ["🤷🏼‍♀", "1f937-1f3fc-200d-2640-fe0f"], ["🤷🏽‍♀", "1f937-1f3fd-200d-2640-fe0f"], ["🤷🏾‍♀", "1f937-1f3fe-200d-2640-fe0f"], ["🤷🏿‍♀", "1f937-1f3ff-200d-2640-fe0f"], ["🤷🏻‍♀️"], ["🤷🏼‍♀️"], ["🤷🏽‍♀️"], ["🤷🏾‍♀️"], ["🤷🏿‍♀️"]], ["🤷‍♀️", [], "woman,shrugging", "1F937-200D-2640-FE0F"]], "man-getting-massage": [[["💆‍♂", "1f486-200d-2642-fe0f"], ["💆‍♂️"], ["💆🏻‍♂", "1f486-1f3fb-200d-2642-fe0f"], ["💆🏼‍♂", "1f486-1f3fc-200d-2642-fe0f"], ["💆🏽‍♂", "1f486-1f3fd-200d-2642-fe0f"], ["💆🏾‍♂", "1f486-1f3fe-200d-2642-fe0f"], ["💆🏿‍♂", "1f486-1f3ff-200d-2642-fe0f"], ["💆🏻‍♂️"], ["💆🏼‍♂️"], ["💆🏽‍♂️"], ["💆🏾‍♂️"], ["💆🏿‍♂️"]], ["💆‍♂️", [], "man,getting,massage", "1F486-200D-2642-FE0F"]], "woman-getting-massage": [[["💆‍♀", "1f486-200d-2640-fe0f"], ["💆‍♀️"], ["💆🏻‍♀", "1f486-1f3fb-200d-2640-fe0f"], ["💆🏼‍♀", "1f486-1f3fc-200d-2640-fe0f"], ["💆🏽‍♀", "1f486-1f3fd-200d-2640-fe0f"], ["💆🏾‍♀", "1f486-1f3fe-200d-2640-fe0f"], ["💆🏿‍♀", "1f486-1f3ff-200d-2640-fe0f"], ["💆🏻‍♀️"], ["💆🏼‍♀️"], ["💆🏽‍♀️"], ["💆🏾‍♀️"], ["💆🏿‍♀️"]], ["💆‍♀️", [], "woman,getting,massage", "1F486-200D-2640-FE0F"]], "man-getting-haircut": [[["💇‍♂", "1f487-200d-2642-fe0f"], ["💇‍♂️"], ["💇🏻‍♂", "1f487-1f3fb-200d-2642-fe0f"], ["💇🏼‍♂", "1f487-1f3fc-200d-2642-fe0f"], ["💇🏽‍♂", "1f487-1f3fd-200d-2642-fe0f"], ["💇🏾‍♂", "1f487-1f3fe-200d-2642-fe0f"], ["💇🏿‍♂", "1f487-1f3ff-200d-2642-fe0f"], ["💇🏻‍♂️"], ["💇🏼‍♂️"], ["💇🏽‍♂️"], ["💇🏾‍♂️"], ["💇🏿‍♂️"]], ["💇‍♂️", [], "man,getting,haircut", "1F487-200D-2642-FE0F"]], "woman-getting-haircut": [[["💇‍♀", "1f487-200d-2640-fe0f"], ["💇‍♀️"], ["💇🏻‍♀", "1f487-1f3fb-200d-2640-fe0f"], ["💇🏼‍♀", "1f487-1f3fc-200d-2640-fe0f"], ["💇🏽‍♀", "1f487-1f3fd-200d-2640-fe0f"], ["💇🏾‍♀", "1f487-1f3fe-200d-2640-fe0f"], ["💇🏿‍♀", "1f487-1f3ff-200d-2640-fe0f"], ["💇🏻‍♀️"], ["💇🏼‍♀️"], ["💇🏽‍♀️"], ["💇🏾‍♀️"], ["💇🏿‍♀️"]], ["💇‍♀️", [], "woman,getting,haircut", "1F487-200D-2640-FE0F"]], "man-walking": [[["🚶‍♂", "1f6b6-200d-2642-fe0f"], ["🚶‍♂️"], ["🚶🏻‍♂", "1f6b6-1f3fb-200d-2642-fe0f"], ["🚶🏼‍♂", "1f6b6-1f3fc-200d-2642-fe0f"], ["🚶🏽‍♂", "1f6b6-1f3fd-200d-2642-fe0f"], ["🚶🏾‍♂", "1f6b6-1f3fe-200d-2642-fe0f"], ["🚶🏿‍♂", "1f6b6-1f3ff-200d-2642-fe0f"], ["🚶🏻‍♂️"], ["🚶🏼‍♂️"], ["🚶🏽‍♂️"], ["🚶🏾‍♂️"], ["🚶🏿‍♂️"]], ["🚶‍♂️", [], "man,walking", "1F6B6-200D-2642-FE0F"]], "woman-walking": [[["🚶‍♀", "1f6b6-200d-2640-fe0f"], ["🚶‍♀️"], ["🚶🏻‍♀", "1f6b6-1f3fb-200d-2640-fe0f"], ["🚶🏼‍♀", "1f6b6-1f3fc-200d-2640-fe0f"], ["🚶🏽‍♀", "1f6b6-1f3fd-200d-2640-fe0f"], ["🚶🏾‍♀", "1f6b6-1f3fe-200d-2640-fe0f"], ["🚶🏿‍♀", "1f6b6-1f3ff-200d-2640-fe0f"], ["🚶🏻‍♀️"], ["🚶🏼‍♀️"], ["🚶🏽‍♀️"], ["🚶🏾‍♀️"], ["🚶🏿‍♀️"]], ["🚶‍♀️", [], "woman,walking", "1F6B6-200D-2640-FE0F"]], "man-running": [[["🏃‍♂", "1f3c3-200d-2642-fe0f"], ["🏃‍♂️"], ["🏃🏻‍♂", "1f3c3-1f3fb-200d-2642-fe0f"], ["🏃🏼‍♂", "1f3c3-1f3fc-200d-2642-fe0f"], ["🏃🏽‍♂", "1f3c3-1f3fd-200d-2642-fe0f"], ["🏃🏾‍♂", "1f3c3-1f3fe-200d-2642-fe0f"], ["🏃🏿‍♂", "1f3c3-1f3ff-200d-2642-fe0f"], ["🏃🏻‍♂️"], ["🏃🏼‍♂️"], ["🏃🏽‍♂️"], ["🏃🏾‍♂️"], ["🏃🏿‍♂️"]], ["🏃‍♂️", [], "man,running", "1F3C3-200D-2642-FE0F"]], "woman-running": [[["🏃‍♀", "1f3c3-200d-2640-fe0f"], ["🏃‍♀️"], ["🏃🏻‍♀", "1f3c3-1f3fb-200d-2640-fe0f"], ["🏃🏼‍♀", "1f3c3-1f3fc-200d-2640-fe0f"], ["🏃🏽‍♀", "1f3c3-1f3fd-200d-2640-fe0f"], ["🏃🏾‍♀", "1f3c3-1f3fe-200d-2640-fe0f"], ["🏃🏿‍♀", "1f3c3-1f3ff-200d-2640-fe0f"], ["🏃🏻‍♀️"], ["🏃🏼‍♀️"], ["🏃🏽‍♀️"], ["🏃🏾‍♀️"], ["🏃🏿‍♀️"]], ["🏃‍♀️", [], "woman,running", "1F3C3-200D-2640-FE0F"]], "man-with-bunny-ears-partying": [[["👯‍♂", "1f46f-200d-2642-fe0f"], ["👯‍♂️"]], ["👯‍♂️", [], "man,with,bunny,ears,partying", "1F46F-200D-2642-FE0F"]], "woman-with-bunny-ears-partying": [[["👯‍♀", "1f46f-200d-2640-fe0f"], ["👯‍♀️"]], ["👯‍♀️", [], "woman,with,bunny,ears,partying", "1F46F-200D-2640-FE0F"]], "woman_in_steamy_room": [[["🧖‍♀", "1f9d6-200d-2640-fe0f"], ["🧖‍♀️"], ["🧖🏻‍♀", "1f9d6-1f3fb-200d-2640-fe0f"], ["🧖🏼‍♀", "1f9d6-1f3fc-200d-2640-fe0f"], ["🧖🏽‍♀", "1f9d6-1f3fd-200d-2640-fe0f"], ["🧖🏾‍♀", "1f9d6-1f3fe-200d-2640-fe0f"], ["🧖🏿‍♀", "1f9d6-1f3ff-200d-2640-fe0f"], ["🧖🏻‍♀️"], ["🧖🏼‍♀️"], ["🧖🏽‍♀️"], ["🧖🏾‍♀️"], ["🧖🏿‍♀️"]], ["🧖‍♀️", [], "woman,in,steamy,room", "1F9D6-200D-2640-FE0F"]], "man_in_steamy_room": [[["🧖‍♂", "1f9d6-200d-2642-fe0f"], ["🧖‍♂️"], ["🧖🏻‍♂", "1f9d6-1f3fb-200d-2642-fe0f"], ["🧖🏼‍♂", "1f9d6-1f3fc-200d-2642-fe0f"], ["🧖🏽‍♂", "1f9d6-1f3fd-200d-2642-fe0f"], ["🧖🏾‍♂", "1f9d6-1f3fe-200d-2642-fe0f"], ["🧖🏿‍♂", "1f9d6-1f3ff-200d-2642-fe0f"], ["🧖🏻‍♂️"], ["🧖🏼‍♂️"], ["🧖🏽‍♂️"], ["🧖🏾‍♂️"], ["🧖🏿‍♂️"]], ["🧖‍♂️", [], "man,in,steamy,room", "1F9D6-200D-2642-FE0F"]], "woman_climbing": [[["🧗‍♀", "1f9d7-200d-2640-fe0f"], ["🧗‍♀️"], ["🧗🏻‍♀", "1f9d7-1f3fb-200d-2640-fe0f"], ["🧗🏼‍♀", "1f9d7-1f3fc-200d-2640-fe0f"], ["🧗🏽‍♀", "1f9d7-1f3fd-200d-2640-fe0f"], ["🧗🏾‍♀", "1f9d7-1f3fe-200d-2640-fe0f"], ["🧗🏿‍♀", "1f9d7-1f3ff-200d-2640-fe0f"], ["🧗🏻‍♀️"], ["🧗🏼‍♀️"], ["🧗🏽‍♀️"], ["🧗🏾‍♀️"], ["🧗🏿‍♀️"]], ["🧗‍♀️", [], "woman,climbing", "1F9D7-200D-2640-FE0F"]], "man_climbing": [[["🧗‍♂", "1f9d7-200d-2642-fe0f"], ["🧗‍♂️"], ["🧗🏻‍♂", "1f9d7-1f3fb-200d-2642-fe0f"], ["🧗🏼‍♂", "1f9d7-1f3fc-200d-2642-fe0f"], ["🧗🏽‍♂", "1f9d7-1f3fd-200d-2642-fe0f"], ["🧗🏾‍♂", "1f9d7-1f3fe-200d-2642-fe0f"], ["🧗🏿‍♂", "1f9d7-1f3ff-200d-2642-fe0f"], ["🧗🏻‍♂️"], ["🧗🏼‍♂️"], ["🧗🏽‍♂️"], ["🧗🏾‍♂️"], ["🧗🏿‍♂️"]], ["🧗‍♂️", [], "man,climbing", "1F9D7-200D-2642-FE0F"]], "woman_in_lotus_position": [[["🧘‍♀", "1f9d8-200d-2640-fe0f"], ["🧘‍♀️"], ["🧘🏻‍♀", "1f9d8-1f3fb-200d-2640-fe0f"], ["🧘🏼‍♀", "1f9d8-1f3fc-200d-2640-fe0f"], ["🧘🏽‍♀", "1f9d8-1f3fd-200d-2640-fe0f"], ["🧘🏾‍♀", "1f9d8-1f3fe-200d-2640-fe0f"], ["🧘🏿‍♀", "1f9d8-1f3ff-200d-2640-fe0f"], ["🧘🏻‍♀️"], ["🧘🏼‍♀️"], ["🧘🏽‍♀️"], ["🧘🏾‍♀️"], ["🧘🏿‍♀️"]], ["🧘‍♀️", [], "woman,in,lotus,position", "1F9D8-200D-2640-FE0F"]], "man_in_lotus_position": [[["🧘‍♂", "1f9d8-200d-2642-fe0f"], ["🧘‍♂️"], ["🧘🏻‍♂", "1f9d8-1f3fb-200d-2642-fe0f"], ["🧘🏼‍♂", "1f9d8-1f3fc-200d-2642-fe0f"], ["🧘🏽‍♂", "1f9d8-1f3fd-200d-2642-fe0f"], ["🧘🏾‍♂", "1f9d8-1f3fe-200d-2642-fe0f"], ["🧘🏿‍♂", "1f9d8-1f3ff-200d-2642-fe0f"], ["🧘🏻‍♂️"], ["🧘🏼‍♂️"], ["🧘🏽‍♂️"], ["🧘🏾‍♂️"], ["🧘🏿‍♂️"]], ["🧘‍♂️", [], "man,in,lotus,position", "1F9D8-200D-2642-FE0F"]], "man-surfing": [[["🏄‍♂", "1f3c4-200d-2642-fe0f"], ["🏄‍♂️"], ["🏄🏻‍♂", "1f3c4-1f3fb-200d-2642-fe0f"], ["🏄🏼‍♂", "1f3c4-1f3fc-200d-2642-fe0f"], ["🏄🏽‍♂", "1f3c4-1f3fd-200d-2642-fe0f"], ["🏄🏾‍♂", "1f3c4-1f3fe-200d-2642-fe0f"], ["🏄🏿‍♂", "1f3c4-1f3ff-200d-2642-fe0f"], ["🏄🏻‍♂️"], ["🏄🏼‍♂️"], ["🏄🏽‍♂️"], ["🏄🏾‍♂️"], ["🏄🏿‍♂️"]], ["🏄‍♂️", [], "man,surfing", "1F3C4-200D-2642-FE0F"]], "woman-surfing": [[["🏄‍♀", "1f3c4-200d-2640-fe0f"], ["🏄‍♀️"], ["🏄🏻‍♀", "1f3c4-1f3fb-200d-2640-fe0f"], ["🏄🏼‍♀", "1f3c4-1f3fc-200d-2640-fe0f"], ["🏄🏽‍♀", "1f3c4-1f3fd-200d-2640-fe0f"], ["🏄🏾‍♀", "1f3c4-1f3fe-200d-2640-fe0f"], ["🏄🏿‍♀", "1f3c4-1f3ff-200d-2640-fe0f"], ["🏄🏻‍♀️"], ["🏄🏼‍♀️"], ["🏄🏽‍♀️"], ["🏄🏾‍♀️"], ["🏄🏿‍♀️"]], ["🏄‍♀️", [], "woman,surfing", "1F3C4-200D-2640-FE0F"]], "man-rowing-boat": [[["🚣‍♂", "1f6a3-200d-2642-fe0f"], ["🚣‍♂️"], ["🚣🏻‍♂", "1f6a3-1f3fb-200d-2642-fe0f"], ["🚣🏼‍♂", "1f6a3-1f3fc-200d-2642-fe0f"], ["🚣🏽‍♂", "1f6a3-1f3fd-200d-2642-fe0f"], ["🚣🏾‍♂", "1f6a3-1f3fe-200d-2642-fe0f"], ["🚣🏿‍♂", "1f6a3-1f3ff-200d-2642-fe0f"], ["🚣🏻‍♂️"], ["🚣🏼‍♂️"], ["🚣🏽‍♂️"], ["🚣🏾‍♂️"], ["🚣🏿‍♂️"]], ["🚣‍♂️", [], "man,rowing,boat", "1F6A3-200D-2642-FE0F"]], "woman-rowing-boat": [[["🚣‍♀", "1f6a3-200d-2640-fe0f"], ["🚣‍♀️"], ["🚣🏻‍♀", "1f6a3-1f3fb-200d-2640-fe0f"], ["🚣🏼‍♀", "1f6a3-1f3fc-200d-2640-fe0f"], ["🚣🏽‍♀", "1f6a3-1f3fd-200d-2640-fe0f"], ["🚣🏾‍♀", "1f6a3-1f3fe-200d-2640-fe0f"], ["🚣🏿‍♀", "1f6a3-1f3ff-200d-2640-fe0f"], ["🚣🏻‍♀️"], ["🚣🏼‍♀️"], ["🚣🏽‍♀️"], ["🚣🏾‍♀️"], ["🚣🏿‍♀️"]], ["🚣‍♀️", [], "woman,rowing,boat", "1F6A3-200D-2640-FE0F"]], "man-swimming": [[["🏊‍♂", "1f3ca-200d-2642-fe0f"], ["🏊‍♂️"], ["🏊🏻‍♂", "1f3ca-1f3fb-200d-2642-fe0f"], ["🏊🏼‍♂", "1f3ca-1f3fc-200d-2642-fe0f"], ["🏊🏽‍♂", "1f3ca-1f3fd-200d-2642-fe0f"], ["🏊🏾‍♂", "1f3ca-1f3fe-200d-2642-fe0f"], ["🏊🏿‍♂", "1f3ca-1f3ff-200d-2642-fe0f"], ["🏊🏻‍♂️"], ["🏊🏼‍♂️"], ["🏊🏽‍♂️"], ["🏊🏾‍♂️"], ["🏊🏿‍♂️"]], ["🏊‍♂️", [], "man,swimming", "1F3CA-200D-2642-FE0F"]], "woman-swimming": [[["🏊‍♀", "1f3ca-200d-2640-fe0f"], ["🏊‍♀️"], ["🏊🏻‍♀", "1f3ca-1f3fb-200d-2640-fe0f"], ["🏊🏼‍♀", "1f3ca-1f3fc-200d-2640-fe0f"], ["🏊🏽‍♀", "1f3ca-1f3fd-200d-2640-fe0f"], ["🏊🏾‍♀", "1f3ca-1f3fe-200d-2640-fe0f"], ["🏊🏿‍♀", "1f3ca-1f3ff-200d-2640-fe0f"], ["🏊🏻‍♀️"], ["🏊🏼‍♀️"], ["🏊🏽‍♀️"], ["🏊🏾‍♀️"], ["🏊🏿‍♀️"]], ["🏊‍♀️", [], "woman,swimming", "1F3CA-200D-2640-FE0F"]], "man-biking": [[["🚴‍♂", "1f6b4-200d-2642-fe0f"], ["🚴‍♂️"], ["🚴🏻‍♂", "1f6b4-1f3fb-200d-2642-fe0f"], ["🚴🏼‍♂", "1f6b4-1f3fc-200d-2642-fe0f"], ["🚴🏽‍♂", "1f6b4-1f3fd-200d-2642-fe0f"], ["🚴🏾‍♂", "1f6b4-1f3fe-200d-2642-fe0f"], ["🚴🏿‍♂", "1f6b4-1f3ff-200d-2642-fe0f"], ["🚴🏻‍♂️"], ["🚴🏼‍♂️"], ["🚴🏽‍♂️"], ["🚴🏾‍♂️"], ["🚴🏿‍♂️"]], ["🚴‍♂️", [], "man,biking", "1F6B4-200D-2642-FE0F"]], "woman-biking": [[["🚴‍♀", "1f6b4-200d-2640-fe0f"], ["🚴‍♀️"], ["🚴🏻‍♀", "1f6b4-1f3fb-200d-2640-fe0f"], ["🚴🏼‍♀", "1f6b4-1f3fc-200d-2640-fe0f"], ["🚴🏽‍♀", "1f6b4-1f3fd-200d-2640-fe0f"], ["🚴🏾‍♀", "1f6b4-1f3fe-200d-2640-fe0f"], ["🚴🏿‍♀", "1f6b4-1f3ff-200d-2640-fe0f"], ["🚴🏻‍♀️"], ["🚴🏼‍♀️"], ["🚴🏽‍♀️"], ["🚴🏾‍♀️"], ["🚴🏿‍♀️"]], ["🚴‍♀️", [], "woman,biking", "1F6B4-200D-2640-FE0F"]], "man-mountain-biking": [[["🚵‍♂", "1f6b5-200d-2642-fe0f"], ["🚵‍♂️"], ["🚵🏻‍♂", "1f6b5-1f3fb-200d-2642-fe0f"], ["🚵🏼‍♂", "1f6b5-1f3fc-200d-2642-fe0f"], ["🚵🏽‍♂", "1f6b5-1f3fd-200d-2642-fe0f"], ["🚵🏾‍♂", "1f6b5-1f3fe-200d-2642-fe0f"], ["🚵🏿‍♂", "1f6b5-1f3ff-200d-2642-fe0f"], ["🚵🏻‍♂️"], ["🚵🏼‍♂️"], ["🚵🏽‍♂️"], ["🚵🏾‍♂️"], ["🚵🏿‍♂️"]], ["🚵‍♂️", [], "man,mountain,biking", "1F6B5-200D-2642-FE0F"]], "woman-mountain-biking": [[["🚵‍♀", "1f6b5-200d-2640-fe0f"], ["🚵‍♀️"], ["🚵🏻‍♀", "1f6b5-1f3fb-200d-2640-fe0f"], ["🚵🏼‍♀", "1f6b5-1f3fc-200d-2640-fe0f"], ["🚵🏽‍♀", "1f6b5-1f3fd-200d-2640-fe0f"], ["🚵🏾‍♀", "1f6b5-1f3fe-200d-2640-fe0f"], ["🚵🏿‍♀", "1f6b5-1f3ff-200d-2640-fe0f"], ["🚵🏻‍♀️"], ["🚵🏼‍♀️"], ["🚵🏽‍♀️"], ["🚵🏾‍♀️"], ["🚵🏿‍♀️"]], ["🚵‍♀️", [], "woman,mountain,biking", "1F6B5-200D-2640-FE0F"]], "man-cartwheeling": [[["🤸‍♂", "1f938-200d-2642-fe0f"], ["🤸‍♂️"], ["🤸🏻‍♂", "1f938-1f3fb-200d-2642-fe0f"], ["🤸🏼‍♂", "1f938-1f3fc-200d-2642-fe0f"], ["🤸🏽‍♂", "1f938-1f3fd-200d-2642-fe0f"], ["🤸🏾‍♂", "1f938-1f3fe-200d-2642-fe0f"], ["🤸🏿‍♂", "1f938-1f3ff-200d-2642-fe0f"], ["🤸🏻‍♂️"], ["🤸🏼‍♂️"], ["🤸🏽‍♂️"], ["🤸🏾‍♂️"], ["🤸🏿‍♂️"]], ["🤸‍♂️", [], "man,cartwheeling", "1F938-200D-2642-FE0F"]], "woman-cartwheeling": [[["🤸‍♀", "1f938-200d-2640-fe0f"], ["🤸‍♀️"], ["🤸🏻‍♀", "1f938-1f3fb-200d-2640-fe0f"], ["🤸🏼‍♀", "1f938-1f3fc-200d-2640-fe0f"], ["🤸🏽‍♀", "1f938-1f3fd-200d-2640-fe0f"], ["🤸🏾‍♀", "1f938-1f3fe-200d-2640-fe0f"], ["🤸🏿‍♀", "1f938-1f3ff-200d-2640-fe0f"], ["🤸🏻‍♀️"], ["🤸🏼‍♀️"], ["🤸🏽‍♀️"], ["🤸🏾‍♀️"], ["🤸🏿‍♀️"]], ["🤸‍♀️", [], "woman,cartwheeling", "1F938-200D-2640-FE0F"]], "man-wrestling": [[["🤼‍♂", "1f93c-200d-2642-fe0f"], ["🤼‍♂️"]], ["🤼‍♂️", [], "man,wrestling", "1F93C-200D-2642-FE0F"]], "woman-wrestling": [[["🤼‍♀", "1f93c-200d-2640-fe0f"], ["🤼‍♀️"]], ["🤼‍♀️", [], "woman,wrestling", "1F93C-200D-2640-FE0F"]], "man-playing-water-polo": [[["🤽‍♂", "1f93d-200d-2642-fe0f"], ["🤽‍♂️"], ["🤽🏻‍♂", "1f93d-1f3fb-200d-2642-fe0f"], ["🤽🏼‍♂", "1f93d-1f3fc-200d-2642-fe0f"], ["🤽🏽‍♂", "1f93d-1f3fd-200d-2642-fe0f"], ["🤽🏾‍♂", "1f93d-1f3fe-200d-2642-fe0f"], ["🤽🏿‍♂", "1f93d-1f3ff-200d-2642-fe0f"], ["🤽🏻‍♂️"], ["🤽🏼‍♂️"], ["🤽🏽‍♂️"], ["🤽🏾‍♂️"], ["🤽🏿‍♂️"]], ["🤽‍♂️", [], "man,playing,water,polo", "1F93D-200D-2642-FE0F"]], "woman-playing-water-polo": [[["🤽‍♀", "1f93d-200d-2640-fe0f"], ["🤽‍♀️"], ["🤽🏻‍♀", "1f93d-1f3fb-200d-2640-fe0f"], ["🤽🏼‍♀", "1f93d-1f3fc-200d-2640-fe0f"], ["🤽🏽‍♀", "1f93d-1f3fd-200d-2640-fe0f"], ["🤽🏾‍♀", "1f93d-1f3fe-200d-2640-fe0f"], ["🤽🏿‍♀", "1f93d-1f3ff-200d-2640-fe0f"], ["🤽🏻‍♀️"], ["🤽🏼‍♀️"], ["🤽🏽‍♀️"], ["🤽🏾‍♀️"], ["🤽🏿‍♀️"]], ["🤽‍♀️", [], "woman,playing,water,polo", "1F93D-200D-2640-FE0F"]], "man-playing-handball": [[["🤾‍♂", "1f93e-200d-2642-fe0f"], ["🤾‍♂️"], ["🤾🏻‍♂", "1f93e-1f3fb-200d-2642-fe0f"], ["🤾🏼‍♂", "1f93e-1f3fc-200d-2642-fe0f"], ["🤾🏽‍♂", "1f93e-1f3fd-200d-2642-fe0f"], ["🤾🏾‍♂", "1f93e-1f3fe-200d-2642-fe0f"], ["🤾🏿‍♂", "1f93e-1f3ff-200d-2642-fe0f"], ["🤾🏻‍♂️"], ["🤾🏼‍♂️"], ["🤾🏽‍♂️"], ["🤾🏾‍♂️"], ["🤾🏿‍♂️"]], ["🤾‍♂️", [], "man,playing,handball", "1F93E-200D-2642-FE0F"]], "woman-playing-handball": [[["🤾‍♀", "1f93e-200d-2640-fe0f"], ["🤾‍♀️"], ["🤾🏻‍♀", "1f93e-1f3fb-200d-2640-fe0f"], ["🤾🏼‍♀", "1f93e-1f3fc-200d-2640-fe0f"], ["🤾🏽‍♀", "1f93e-1f3fd-200d-2640-fe0f"], ["🤾🏾‍♀", "1f93e-1f3fe-200d-2640-fe0f"], ["🤾🏿‍♀", "1f93e-1f3ff-200d-2640-fe0f"], ["🤾🏻‍♀️"], ["🤾🏼‍♀️"], ["🤾🏽‍♀️"], ["🤾🏾‍♀️"], ["🤾🏿‍♀️"]], ["🤾‍♀️", [], "woman,playing,handball", "1F93E-200D-2640-FE0F"]], "man-juggling": [[["🤹‍♂", "1f939-200d-2642-fe0f"], ["🤹‍♂️"], ["🤹🏻‍♂", "1f939-1f3fb-200d-2642-fe0f"], ["🤹🏼‍♂", "1f939-1f3fc-200d-2642-fe0f"], ["🤹🏽‍♂", "1f939-1f3fd-200d-2642-fe0f"], ["🤹🏾‍♂", "1f939-1f3fe-200d-2642-fe0f"], ["🤹🏿‍♂", "1f939-1f3ff-200d-2642-fe0f"], ["🤹🏻‍♂️"], ["🤹🏼‍♂️"], ["🤹🏽‍♂️"], ["🤹🏾‍♂️"], ["🤹🏿‍♂️"]], ["🤹‍♂️", [], "man,juggling", "1F939-200D-2642-FE0F"]], "woman-juggling": [[["🤹‍♀", "1f939-200d-2640-fe0f"], ["🤹‍♀️"], ["🤹🏻‍♀", "1f939-1f3fb-200d-2640-fe0f"], ["🤹🏼‍♀", "1f939-1f3fc-200d-2640-fe0f"], ["🤹🏽‍♀", "1f939-1f3fd-200d-2640-fe0f"], ["🤹🏾‍♀", "1f939-1f3fe-200d-2640-fe0f"], ["🤹🏿‍♀", "1f939-1f3ff-200d-2640-fe0f"], ["🤹🏻‍♀️"], ["🤹🏼‍♀️"], ["🤹🏽‍♀️"], ["🤹🏾‍♀️"], ["🤹🏿‍♀️"]], ["🤹‍♀️", [], "woman,juggling", "1F939-200D-2640-FE0F"]], "man-boy": [[["👨‍👦"]], ["👨‍👦", [], "man,boy", "1F468-200D-1F466"]], "man-girl": [[["👨‍👧"]], ["👨‍👧", [], "man,girl", "1F468-200D-1F467"]], "woman-boy": [[["👩‍👦"]], ["👩‍👦", [], "woman,boy", "1F469-200D-1F466"]], "woman-girl": [[["👩‍👧"]], ["👩‍👧", [], "woman,girl", "1F469-200D-1F467"]], "hash": [[["#️⃣", "23-20e3"]], ["#️⃣", [], "hash,key,symbol,blue-square,twitter", "0023-FE0F-20E3"]], "keycap_star": [[["*️⃣", "2a-20e3"]], ["*️⃣", [], "keycap,star", "002A-FE0F-20E3"]], "zero": [[["0️⃣", "30-20e3"]], ["0️⃣", [], "zero,keycap,0,numbers,blue-square,null", "0030-FE0F-20E3"]], "one": [[["1️⃣", "31-20e3"]], ["1️⃣", [], "one,keycap,1,blue-square,numbers", "0031-FE0F-20E3"]], "two": [[["2️⃣", "32-20e3"]], ["2️⃣", [], "two,keycap,2,numbers,prime,blue-square", "0032-FE0F-20E3"]], "three": [[["3️⃣", "33-20e3"]], ["3️⃣", [], "three,keycap,3,numbers,prime,blue-square", "0033-FE0F-20E3"]], "four": [[["4️⃣", "34-20e3"]], ["4️⃣", [], "four,keycap,4,numbers,blue-square", "0034-FE0F-20E3"]], "five": [[["5️⃣", "35-20e3"]], ["5️⃣", [], "five,keycap,5,numbers,blue-square,prime", "0035-FE0F-20E3"]], "six": [[["6️⃣", "36-20e3"]], ["6️⃣", [], "six,keycap,6,numbers,blue-square", "0036-FE0F-20E3"]], "seven": [[["7️⃣", "37-20e3"]], ["7️⃣", [], "seven,keycap,7,numbers,blue-square,prime", "0037-FE0F-20E3"]], "eight": [[["8️⃣", "38-20e3"]], ["8️⃣", [], "eight,keycap,8,blue-square,numbers", "0038-FE0F-20E3"]], "nine": [[["9️⃣", "39-20e3"]], ["9️⃣", [], "nine,keycap,9,blue-square,numbers", "0039-FE0F-20E3"]], "male-detective": [[["🕵️‍♂", "1f575-fe0f-200d-2642-fe0f"], ["🕵️‍♂️"]], ["🕵️‍♂️", [], "male,detective", "1F575-FE0F-200D-2642-FE0F"]], "female-detective": [[["🕵️‍♀", "1f575-fe0f-200d-2640-fe0f"], ["🕵️‍♀️"]], ["🕵️‍♀️", [], "female,detective", "1F575-FE0F-200D-2640-FE0F"]], "man-golfing": [[["🏌️‍♂", "1f3cc-fe0f-200d-2642-fe0f"], ["🏌️‍♂️"]], ["🏌️‍♂️", [], "man,golfing", "1F3CC-FE0F-200D-2642-FE0F"]], "woman-golfing": [[["🏌️‍♀", "1f3cc-fe0f-200d-2640-fe0f"], ["🏌️‍♀️"]], ["🏌️‍♀️", [], "woman,golfing", "1F3CC-FE0F-200D-2640-FE0F"]], "man-bouncing-ball": [[["⛹️‍♂", "26f9-fe0f-200d-2642-fe0f"], ["⛹️‍♂️"]], ["⛹️‍♂️", [], "man,bouncing,ball", "26F9-FE0F-200D-2642-FE0F"]], "woman-bouncing-ball": [[["⛹️‍♀", "26f9-fe0f-200d-2640-fe0f"], ["⛹️‍♀️"]], ["⛹️‍♀️", [], "woman,bouncing,ball", "26F9-FE0F-200D-2640-FE0F"]], "man-lifting-weights": [[["🏋️‍♂", "1f3cb-fe0f-200d-2642-fe0f"], ["🏋️‍♂️"]], ["🏋️‍♂️", [], "man,lifting,weights", "1F3CB-FE0F-200D-2642-FE0F"]], "woman-lifting-weights": [[["🏋️‍♀", "1f3cb-fe0f-200d-2640-fe0f"], ["🏋️‍♀️"]], ["🏋️‍♀️", [], "woman,lifting,weights", "1F3CB-FE0F-200D-2640-FE0F"]], "eye-in-speech-bubble": [[["👁️‍🗨", "1f441-200d-1f5e8"], ["👁️‍🗨️", "1f441-200d-1f5e8"]], ["👁️‍🗨️", [], "eye,in,speech,bubble", "1F441-FE0F-200D-1F5E8-FE0F"]], "rainbow-flag": [[["🏳️‍🌈"]], ["🏳️‍🌈", [], "rainbow,flag", "1F3F3-FE0F-200D-1F308"]], "man-woman-boy": [[["👨‍👩‍👦"]], ["👪", ["family"], "man,woman,boy,family", "1F468-200D-1F469-200D-1F466"]], "man-woman-girl": [[["👨‍👩‍👧"]], ["👨‍👩‍👧", [], "man,woman,girl", "1F468-200D-1F469-200D-1F467"]], "man-man-boy": [[["👨‍👨‍👦"]], ["👨‍👨‍👦", [], "man,boy", "1F468-200D-1F468-200D-1F466"]], "man-man-girl": [[["👨‍👨‍👧"]], ["👨‍👨‍👧", [], "man,girl", "1F468-200D-1F468-200D-1F467"]], "woman-woman-boy": [[["👩‍👩‍👦"]], ["👩‍👩‍👦", [], "woman,boy", "1F469-200D-1F469-200D-1F466"]], "woman-woman-girl": [[["👩‍👩‍👧"]], ["👩‍👩‍👧", [], "woman,girl", "1F469-200D-1F469-200D-1F467"]], "man-boy-boy": [[["👨‍👦‍👦"]], ["👨‍👦‍👦", [], "man,boy", "1F468-200D-1F466-200D-1F466"]], "man-girl-boy": [[["👨‍👧‍👦"]], ["👨‍👧‍👦", [], "man,girl,boy", "1F468-200D-1F467-200D-1F466"]], "man-girl-girl": [[["👨‍👧‍👧"]], ["👨‍👧‍👧", [], "man,girl", "1F468-200D-1F467-200D-1F467"]], "woman-boy-boy": [[["👩‍👦‍👦"]], ["👩‍👦‍👦", [], "woman,boy", "1F469-200D-1F466-200D-1F466"]], "woman-girl-boy": [[["👩‍👧‍👦"]], ["👩‍👧‍👦", [], "woman,girl,boy", "1F469-200D-1F467-200D-1F466"]], "woman-girl-girl": [[["👩‍👧‍👧"]], ["👩‍👧‍👧", [], "woman,girl", "1F469-200D-1F467-200D-1F467"]], "woman-heart-man": [[["👩‍❤️‍👨"]], ["👩‍❤️‍👨", [], "woman,heart,man", "1F469-200D-2764-FE0F-200D-1F468"]], "man-heart-man": [[["👨‍❤️‍👨"]], ["👨‍❤️‍👨", [], "man,heart", "1F468-200D-2764-FE0F-200D-1F468"]], "woman-heart-woman": [[["👩‍❤️‍👩"]], ["👩‍❤️‍👩", [], "woman,heart", "1F469-200D-2764-FE0F-200D-1F469"]], "man-woman-girl-boy": [[["👨‍👩‍👧‍👦"]], ["👨‍👩‍👧‍👦", [], "man,woman,girl,boy", "1F468-200D-1F469-200D-1F467-200D-1F466"]], "man-woman-boy-boy": [[["👨‍👩‍👦‍👦"]], ["👨‍👩‍👦‍👦", [], "man,woman,boy", "1F468-200D-1F469-200D-1F466-200D-1F466"]], "man-woman-girl-girl": [[["👨‍👩‍👧‍👧"]], ["👨‍👩‍👧‍👧", [], "man,woman,girl", "1F468-200D-1F469-200D-1F467-200D-1F467"]], "man-man-girl-boy": [[["👨‍👨‍👧‍👦"]], ["👨‍👨‍👧‍👦", [], "man,girl,boy", "1F468-200D-1F468-200D-1F467-200D-1F466"]], "man-man-boy-boy": [[["👨‍👨‍👦‍👦"]], ["👨‍👨‍👦‍👦", [], "man,boy", "1F468-200D-1F468-200D-1F466-200D-1F466"]], "man-man-girl-girl": [[["👨‍👨‍👧‍👧"]], ["👨‍👨‍👧‍👧", [], "man,girl", "1F468-200D-1F468-200D-1F467-200D-1F467"]], "woman-woman-girl-boy": [[["👩‍👩‍👧‍👦"]], ["👩‍👩‍👧‍👦", [], "woman,girl,boy", "1F469-200D-1F469-200D-1F467-200D-1F466"]], "woman-woman-boy-boy": [[["👩‍👩‍👦‍👦"]], ["👩‍👩‍👦‍👦", [], "woman,boy", "1F469-200D-1F469-200D-1F466-200D-1F466"]], "woman-woman-girl-girl": [[["👩‍👩‍👧‍👧"]], ["👩‍👩‍👧‍👧", [], "woman,girl", "1F469-200D-1F469-200D-1F467-200D-1F467"]], "flag-england": [[["🏴󠁧󠁢󠁥󠁮󠁧󠁿"]], ["🏴󠁧󠁢󠁥󠁮󠁧󠁿", [], "flag,england"]], "flag-scotland": [[["🏴󠁧󠁢󠁳󠁣󠁴󠁿"]], ["🏴󠁧󠁢󠁳󠁣󠁴󠁿", [], "flag,scotland"]], "flag-wales": [[["🏴󠁧󠁢󠁷󠁬󠁳󠁿"]], ["🏴󠁧󠁢󠁷󠁬󠁳󠁿", [], "flag,wales"]], "woman-kiss-man": [[["👩‍❤️‍💋‍👨"]], ["👩‍❤️‍💋‍👨", [], "woman,kiss,man", "1F469-200D-2764-FE0F-200D-1F48B-200D-1F468"]], "man-kiss-man": [[["👨‍❤️‍💋‍👨"]], ["👨‍❤️‍💋‍👨", [], "man,kiss", "1F468-200D-2764-FE0F-200D-1F48B-200D-1F468"]], "woman-kiss-woman": [[["👩‍❤️‍💋‍👩"]], ["👩‍❤️‍💋‍👩", [], "woman,kiss", "1F469-200D-2764-FE0F-200D-1F48B-200D-1F469"]] }, null, [{ "id": "people", "name": "Smileys & People", "emojis": ["grinning", "grin", "joy", "rolling_on_the_floor_laughing", "smiley", "smile", "sweat_smile", "laughing", "wink", "blush", "yum", "sunglasses", "heart_eyes", "kissing_heart", "kissing", "kissing_smiling_eyes", "kissing_closed_eyes", "relaxed", "slightly_smiling_face", "hugging_face", "star-struck", "thinking_face", "face_with_raised_eyebrow", "neutral_face", "expressionless", "no_mouth", "face_with_rolling_eyes", "smirk", "persevere", "disappointed_relieved", "open_mouth", "zipper_mouth_face", "hushed", "sleepy", "tired_face", "sleeping", "relieved", "stuck_out_tongue", "stuck_out_tongue_winking_eye", "stuck_out_tongue_closed_eyes", "drooling_face", "unamused", "sweat", "pensive", "confused", "upside_down_face", "money_mouth_face", "astonished", "white_frowning_face", "slightly_frowning_face", "confounded", "disappointed", "worried", "triumph", "cry", "sob", "frowning", "anguished", "fearful", "weary", "exploding_head", "grimacing", "cold_sweat", "scream", "flushed", "zany_face", "dizzy_face", "rage", "angry", "face_with_symbols_on_mouth", "mask", "face_with_thermometer", "face_with_head_bandage", "nauseated_face", "face_vomiting", "sneezing_face", "innocent", "face_with_cowboy_hat", "clown_face", "lying_face", "shushing_face", "face_with_hand_over_mouth", "face_with_monocle", "nerd_face", "smiling_imp", "imp", "japanese_ogre", "japanese_goblin", "skull", "skull_and_crossbones", "ghost", "alien", "space_invader", "robot_face", "hankey", "smiley_cat", "smile_cat", "joy_cat", "heart_eyes_cat", "smirk_cat", "kissing_cat", "scream_cat", "crying_cat_face", "pouting_cat", "see_no_evil", "hear_no_evil", "speak_no_evil", "baby", "child", "boy", "girl", "adult", "man", "woman", "older_adult", "older_man", "older_woman", "male-doctor", "female-doctor", "male-student", "female-student", "male-teacher", "female-teacher", "male-judge", "female-judge", "male-farmer", "female-farmer", "male-cook", "female-cook", "male-mechanic", "female-mechanic", "male-factory-worker", "female-factory-worker", "male-office-worker", "female-office-worker", "male-scientist", "female-scientist", "male-technologist", "female-technologist", "male-singer", "female-singer", "male-artist", "female-artist", "male-pilot", "female-pilot", "male-astronaut", "female-astronaut", "male-firefighter", "female-firefighter", "cop", "male-police-officer", "female-police-officer", "sleuth_or_spy", "male-detective", "female-detective", "guardsman", "male-guard", "female-guard", "construction_worker", "male-construction-worker", "female-construction-worker", "prince", "princess", "man_with_turban", "man-wearing-turban", "woman-wearing-turban", "man_with_gua_pi_mao", "person_with_headscarf", "bearded_person", "person_with_blond_hair", "blond-haired-man", "blond-haired-woman", "man_in_tuxedo", "bride_with_veil", "pregnant_woman", "breast-feeding", "angel", "santa", "mrs_claus", "mage", "female_mage", "male_mage", "fairy", "female_fairy", "male_fairy", "vampire", "female_vampire", "male_vampire", "merperson", "mermaid", "merman", "elf", "female_elf", "male_elf", "genie", "female_genie", "male_genie", "zombie", "female_zombie", "male_zombie", "person_frowning", "man-frowning", "woman-frowning", "person_with_pouting_face", "man-pouting", "woman-pouting", "no_good", "man-gesturing-no", "woman-gesturing-no", "ok_woman", "man-gesturing-ok", "woman-gesturing-ok", "information_desk_person", "man-tipping-hand", "woman-tipping-hand", "raising_hand", "man-raising-hand", "woman-raising-hand", "bow", "man-bowing", "woman-bowing", "face_palm", "man-facepalming", "woman-facepalming", "shrug", "man-shrugging", "woman-shrugging", "massage", "man-getting-massage", "woman-getting-massage", "haircut", "man-getting-haircut", "woman-getting-haircut", "walking", "man-walking", "woman-walking", "runner", "man-running", "woman-running", "dancer", "man_dancing", "dancers", "man-with-bunny-ears-partying", "woman-with-bunny-ears-partying", "person_in_steamy_room", "woman_in_steamy_room", "man_in_steamy_room", "person_climbing", "woman_climbing", "man_climbing", "person_in_lotus_position", "woman_in_lotus_position", "man_in_lotus_position", "bath", "sleeping_accommodation", "man_in_business_suit_levitating", "speaking_head_in_silhouette", "bust_in_silhouette", "busts_in_silhouette", "fencer", "horse_racing", "skier", "snowboarder", "golfer", "man-golfing", "woman-golfing", "surfer", "man-surfing", "woman-surfing", "rowboat", "man-rowing-boat", "woman-rowing-boat", "swimmer", "man-swimming", "woman-swimming", "person_with_ball", "man-bouncing-ball", "woman-bouncing-ball", "weight_lifter", "man-lifting-weights", "woman-lifting-weights", "bicyclist", "man-biking", "woman-biking", "mountain_bicyclist", "man-mountain-biking", "woman-mountain-biking", "racing_car", "racing_motorcycle", "person_doing_cartwheel", "man-cartwheeling", "woman-cartwheeling", "wrestlers", "man-wrestling", "woman-wrestling", "water_polo", "man-playing-water-polo", "woman-playing-water-polo", "handball", "man-playing-handball", "woman-playing-handball", "juggling", "man-juggling", "woman-juggling", "couple", "two_men_holding_hands", "two_women_holding_hands", "couplekiss", "woman-kiss-man", "man-kiss-man", "woman-kiss-woman", "couple_with_heart", "woman-heart-man", "man-heart-man", "woman-heart-woman", "family", "man-woman-boy", "man-woman-girl", "man-woman-girl-boy", "man-woman-boy-boy", "man-woman-girl-girl", "man-man-boy", "man-man-girl", "man-man-girl-boy", "man-man-boy-boy", "man-man-girl-girl", "woman-woman-boy", "woman-woman-girl", "woman-woman-girl-boy", "woman-woman-boy-boy", "woman-woman-girl-girl", "man-boy", "man-boy-boy", "man-girl", "man-girl-boy", "man-girl-girl", "woman-boy", "woman-boy-boy", "woman-girl", "woman-girl-boy", "woman-girl-girl", "selfie", "muscle", "point_left", "point_right", "point_up", "point_up_2", "middle_finger", "point_down", "v", "crossed_fingers", "spock-hand", "the_horns", "call_me_hand", "raised_hand_with_fingers_splayed", "hand", "ok_hand", "+1", "-1", "fist", "facepunch", "left-facing_fist", "right-facing_fist", "raised_back_of_hand", "wave", "i_love_you_hand_sign", "writing_hand", "clap", "open_hands", "raised_hands", "palms_up_together", "pray", "handshake", "nail_care", "ear", "nose", "footprints", "eyes", "eye", "eye-in-speech-bubble", "brain", "tongue", "lips", "kiss", "cupid", "heart", "heartbeat", "broken_heart", "two_hearts", "sparkling_heart", "heartpulse", "blue_heart", "green_heart", "yellow_heart", "orange_heart", "purple_heart", "black_heart", "gift_heart", "revolving_hearts", "heart_decoration", "heavy_heart_exclamation_mark_ornament", "love_letter", "zzz", "anger", "bomb", "boom", "sweat_drops", "dash", "dizzy", "speech_balloon", "left_speech_bubble", "right_anger_bubble", "thought_balloon", "hole", "eyeglasses", "dark_sunglasses", "necktie", "shirt", "jeans", "scarf", "gloves", "coat", "socks", "dress", "kimono", "bikini", "womans_clothes", "purse", "handbag", "pouch", "shopping_bags", "school_satchel", "mans_shoe", "athletic_shoe", "high_heel", "sandal", "boot", "crown", "womans_hat", "tophat", "mortar_board", "billed_cap", "helmet_with_white_cross", "prayer_beads", "lipstick", "ring", "gem"] }, { "id": "nature", "name": "Animals & Nature", "emojis": ["monkey_face", "monkey", "gorilla", "dog", "dog2", "poodle", "wolf", "fox_face", "cat", "cat2", "lion_face", "tiger", "tiger2", "leopard", "horse", "racehorse", "unicorn_face", "zebra_face", "deer", "cow", "ox", "water_buffalo", "cow2", "pig", "pig2", "boar", "pig_nose", "ram", "sheep", "goat", "dromedary_camel", "camel", "giraffe_face", "elephant", "rhinoceros", "mouse", "mouse2", "rat", "hamster", "rabbit", "rabbit2", "chipmunk", "hedgehog", "bat", "bear", "koala", "panda_face", "feet", "turkey", "chicken", "rooster", "hatching_chick", "baby_chick", "hatched_chick", "bird", "penguin", "dove_of_peace", "eagle", "duck", "owl", "frog", "crocodile", "turtle", "lizard", "snake", "dragon_face", "dragon", "sauropod", "t-rex", "whale", "whale2", "dolphin", "fish", "tropical_fish", "blowfish", "shark", "octopus", "shell", "crab", "shrimp", "squid", "snail", "butterfly", "bug", "ant", "bee", "beetle", "cricket", "spider", "spider_web", "scorpion", "bouquet", "cherry_blossom", "white_flower", "rosette", "rose", "wilted_flower", "hibiscus", "sunflower", "blossom", "tulip", "seedling", "evergreen_tree", "deciduous_tree", "palm_tree", "cactus", "ear_of_rice", "herb", "shamrock", "four_leaf_clover", "maple_leaf", "fallen_leaf", "leaves"] }, { "id": "foods", "name": "Food & Drink", "emojis": ["grapes", "melon", "watermelon", "tangerine", "lemon", "banana", "pineapple", "apple", "green_apple", "pear", "peach", "cherries", "strawberry", "kiwifruit", "tomato", "coconut", "avocado", "eggplant", "potato", "carrot", "corn", "hot_pepper", "cucumber", "broccoli", "mushroom", "peanuts", "chestnut", "bread", "croissant", "baguette_bread", "pretzel", "pancakes", "cheese_wedge", "meat_on_bone", "poultry_leg", "cut_of_meat", "bacon", "hamburger", "fries", "pizza", "hotdog", "sandwich", "taco", "burrito", "stuffed_flatbread", "egg", "fried_egg", "shallow_pan_of_food", "stew", "bowl_with_spoon", "green_salad", "popcorn", "canned_food", "bento", "rice_cracker", "rice_ball", "rice", "curry", "ramen", "spaghetti", "sweet_potato", "oden", "sushi", "fried_shrimp", "fish_cake", "dango", "dumpling", "fortune_cookie", "takeout_box", "icecream", "shaved_ice", "ice_cream", "doughnut", "cookie", "birthday", "cake", "pie", "chocolate_bar", "candy", "lollipop", "custard", "honey_pot", "baby_bottle", "glass_of_milk", "coffee", "tea", "sake", "champagne", "wine_glass", "cocktail", "tropical_drink", "beer", "beers", "clinking_glasses", "tumbler_glass", "cup_with_straw", "chopsticks", "knife_fork_plate", "fork_and_knife", "spoon", "hocho", "amphora"] }, { "id": "activity", "name": "Activities", "emojis": ["jack_o_lantern", "christmas_tree", "fireworks", "sparkler", "sparkles", "balloon", "tada", "confetti_ball", "tanabata_tree", "bamboo", "dolls", "flags", "wind_chime", "rice_scene", "ribbon", "gift", "reminder_ribbon", "admission_tickets", "ticket", "medal", "trophy", "sports_medal", "first_place_medal", "second_place_medal", "third_place_medal", "soccer", "baseball", "basketball", "volleyball", "football", "rugby_football", "tennis", "8ball", "bowling", "cricket_bat_and_ball", "field_hockey_stick_and_ball", "ice_hockey_stick_and_puck", "table_tennis_paddle_and_ball", "badminton_racquet_and_shuttlecock", "boxing_glove", "martial_arts_uniform", "goal_net", "dart", "golf", "ice_skate", "fishing_pole_and_fish", "running_shirt_with_sash", "ski", "sled", "curling_stone", "video_game", "joystick", "game_die", "spades", "hearts", "diamonds", "clubs", "black_joker", "mahjong", "flower_playing_cards"] }, { "id": "places", "name": "Travel & Places", "emojis": ["earth_africa", "earth_americas", "earth_asia", "globe_with_meridians", "world_map", "japan", "snow_capped_mountain", "mountain", "volcano", "mount_fuji", "camping", "beach_with_umbrella", "desert", "desert_island", "national_park", "stadium", "classical_building", "building_construction", "house_buildings", "cityscape", "derelict_house_building", "house", "house_with_garden", "office", "post_office", "european_post_office", "hospital", "bank", "hotel", "love_hotel", "convenience_store", "school", "department_store", "factory", "japanese_castle", "european_castle", "wedding", "tokyo_tower", "statue_of_liberty", "church", "mosque", "synagogue", "shinto_shrine", "kaaba", "fountain", "tent", "foggy", "night_with_stars", "sunrise_over_mountains", "sunrise", "city_sunset", "city_sunrise", "bridge_at_night", "hotsprings", "milky_way", "carousel_horse", "ferris_wheel", "roller_coaster", "barber", "circus_tent", "performing_arts", "frame_with_picture", "art", "slot_machine", "steam_locomotive", "railway_car", "bullettrain_side", "bullettrain_front", "train2", "metro", "light_rail", "station", "tram", "monorail", "mountain_railway", "train", "bus", "oncoming_bus", "trolleybus", "minibus", "ambulance", "fire_engine", "police_car", "oncoming_police_car", "taxi", "oncoming_taxi", "car", "oncoming_automobile", "blue_car", "truck", "articulated_lorry", "tractor", "bike", "scooter", "motor_scooter", "busstop", "motorway", "railway_track", "fuelpump", "rotating_light", "traffic_light", "vertical_traffic_light", "construction", "octagonal_sign", "anchor", "boat", "canoe", "speedboat", "passenger_ship", "ferry", "motor_boat", "ship", "airplane", "small_airplane", "airplane_departure", "airplane_arriving", "seat", "helicopter", "suspension_railway", "mountain_cableway", "aerial_tramway", "satellite", "rocket", "flying_saucer", "bellhop_bell", "door", "bed", "couch_and_lamp", "toilet", "shower", "bathtub", "hourglass", "hourglass_flowing_sand", "watch", "alarm_clock", "stopwatch", "timer_clock", "mantelpiece_clock", "clock12", "clock1230", "clock1", "clock130", "clock2", "clock230", "clock3", "clock330", "clock4", "clock430", "clock5", "clock530", "clock6", "clock630", "clock7", "clock730", "clock8", "clock830", "clock9", "clock930", "clock10", "clock1030", "clock11", "clock1130", "new_moon", "waxing_crescent_moon", "first_quarter_moon", "moon", "full_moon", "waning_gibbous_moon", "last_quarter_moon", "waning_crescent_moon", "crescent_moon", "new_moon_with_face", "first_quarter_moon_with_face", "last_quarter_moon_with_face", "thermometer", "sunny", "full_moon_with_face", "sun_with_face", "star", "star2", "stars", "cloud", "partly_sunny", "thunder_cloud_and_rain", "mostly_sunny", "barely_sunny", "partly_sunny_rain", "rain_cloud", "snow_cloud", "lightning", "tornado", "fog", "wind_blowing_face", "cyclone", "rainbow", "closed_umbrella", "umbrella", "umbrella_with_rain_drops", "umbrella_on_ground", "zap", "snowflake", "snowman", "snowman_without_snow", "comet", "fire", "droplet", "ocean"] }, { "id": "objects", "name": "Objects", "emojis": ["mute", "speaker", "sound", "loud_sound", "loudspeaker", "mega", "postal_horn", "bell", "no_bell", "musical_score", "musical_note", "notes", "studio_microphone", "level_slider", "control_knobs", "microphone", "headphones", "radio", "saxophone", "guitar", "musical_keyboard", "trumpet", "violin", "drum_with_drumsticks", "iphone", "calling", "phone", "telephone_receiver", "pager", "fax", "battery", "electric_plug", "computer", "desktop_computer", "printer", "keyboard", "three_button_mouse", "trackball", "minidisc", "floppy_disk", "cd", "dvd", "movie_camera", "film_frames", "film_projector", "clapper", "tv", "camera", "camera_with_flash", "video_camera", "vhs", "mag", "mag_right", "microscope", "telescope", "satellite_antenna", "candle", "bulb", "flashlight", "izakaya_lantern", "notebook_with_decorative_cover", "closed_book", "book", "green_book", "blue_book", "orange_book", "books", "notebook", "ledger", "page_with_curl", "scroll", "page_facing_up", "newspaper", "rolled_up_newspaper", "bookmark_tabs", "bookmark", "label", "moneybag", "yen", "dollar", "euro", "pound", "money_with_wings", "credit_card", "chart", "currency_exchange", "heavy_dollar_sign", "email", "e-mail", "incoming_envelope", "envelope_with_arrow", "outbox_tray", "inbox_tray", "package", "mailbox", "mailbox_closed", "mailbox_with_mail", "mailbox_with_no_mail", "postbox", "ballot_box_with_ballot", "pencil2", "black_nib", "lower_left_fountain_pen", "lower_left_ballpoint_pen", "lower_left_paintbrush", "lower_left_crayon", "memo", "briefcase", "file_folder", "open_file_folder", "card_index_dividers", "date", "calendar", "spiral_note_pad", "spiral_calendar_pad", "card_index", "chart_with_upwards_trend", "chart_with_downwards_trend", "bar_chart", "clipboard", "pushpin", "round_pushpin", "paperclip", "linked_paperclips", "straight_ruler", "triangular_ruler", "scissors", "card_file_box", "file_cabinet", "wastebasket", "lock", "unlock", "lock_with_ink_pen", "closed_lock_with_key", "key", "old_key", "hammer", "pick", "hammer_and_pick", "hammer_and_wrench", "dagger_knife", "crossed_swords", "gun", "bow_and_arrow", "shield", "wrench", "nut_and_bolt", "gear", "compression", "alembic", "scales", "link", "chains", "syringe", "pill", "smoking", "coffin", "funeral_urn", "moyai", "oil_drum", "crystal_ball", "shopping_trolley"] }, { "id": "symbols", "name": "Symbols", "emojis": ["atm", "put_litter_in_its_place", "potable_water", "wheelchair", "mens", "womens", "restroom", "baby_symbol", "wc", "passport_control", "customs", "baggage_claim", "left_luggage", "warning", "children_crossing", "no_entry", "no_entry_sign", "no_bicycles", "no_smoking", "do_not_litter", "non-potable_water", "no_pedestrians", "no_mobile_phones", "underage", "radioactive_sign", "biohazard_sign", "arrow_up", "arrow_upper_right", "arrow_right", "arrow_lower_right", "arrow_down", "arrow_lower_left", "arrow_left", "arrow_upper_left", "arrow_up_down", "left_right_arrow", "leftwards_arrow_with_hook", "arrow_right_hook", "arrow_heading_up", "arrow_heading_down", "arrows_clockwise", "arrows_counterclockwise", "back", "end", "on", "soon", "top", "place_of_worship", "atom_symbol", "om_symbol", "star_of_david", "wheel_of_dharma", "yin_yang", "latin_cross", "orthodox_cross", "star_and_crescent", "peace_symbol", "menorah_with_nine_branches", "six_pointed_star", "aries", "taurus", "gemini", "cancer", "leo", "virgo", "libra", "scorpius", "sagittarius", "capricorn", "aquarius", "pisces", "ophiuchus", "twisted_rightwards_arrows", "repeat", "repeat_one", "arrow_forward", "fast_forward", "black_right_pointing_double_triangle_with_vertical_bar", "black_right_pointing_triangle_with_double_vertical_bar", "arrow_backward", "rewind", "black_left_pointing_double_triangle_with_vertical_bar", "arrow_up_small", "arrow_double_up", "arrow_down_small", "arrow_double_down", "double_vertical_bar", "black_square_for_stop", "black_circle_for_record", "eject", "cinema", "low_brightness", "high_brightness", "signal_strength", "vibration_mode", "mobile_phone_off", "female_sign", "male_sign", "medical_symbol", "recycle", "fleur_de_lis", "trident", "name_badge", "beginner", "o", "white_check_mark", "ballot_box_with_check", "heavy_check_mark", "heavy_multiplication_x", "x", "negative_squared_cross_mark", "heavy_plus_sign", "heavy_minus_sign", "heavy_division_sign", "curly_loop", "loop", "part_alternation_mark", "eight_spoked_asterisk", "eight_pointed_black_star", "sparkle", "bangbang", "interrobang", "question", "grey_question", "grey_exclamation", "exclamation", "wavy_dash", "copyright", "registered", "tm", "hash", "keycap_star", "zero", "one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "keycap_ten", "100", "capital_abcd", "abcd", "1234", "symbols", "abc", "a", "ab", "b", "cl", "cool", "free", "information_source", "id", "m", "new", "ng", "o2", "ok", "parking", "sos", "up", "vs", "koko", "sa", "u6708", "u6709", "u6307", "ideograph_advantage", "u5272", "u7121", "u7981", "accept", "u7533", "u5408", "u7a7a", "congratulations", "secret", "u55b6", "u6e80", "black_small_square", "white_small_square", "white_medium_square", "black_medium_square", "white_medium_small_square", "black_medium_small_square", "black_large_square", "white_large_square", "large_orange_diamond", "large_blue_diamond", "small_orange_diamond", "small_blue_diamond", "small_red_triangle", "small_red_triangle_down", "diamond_shape_with_a_dot_inside", "radio_button", "black_square_button", "white_square_button", "white_circle", "black_circle", "red_circle", "large_blue_circle"] }, { "id": "flags", "name": "Flags", "emojis": ["checkered_flag", "cn", "crossed_flags", "de", "es", "flag-ac", "flag-ad", "flag-ae", "flag-af", "flag-ag", "flag-ai", "flag-al", "flag-am", "flag-ao", "flag-aq", "flag-ar", "flag-as", "flag-at", "flag-au", "flag-aw", "flag-ax", "flag-az", "flag-ba", "flag-bb", "flag-bd", "flag-be", "flag-bf", "flag-bg", "flag-bh", "flag-bi", "flag-bj", "flag-bl", "flag-bm", "flag-bn", "flag-bo", "flag-bq", "flag-br", "flag-bs", "flag-bt", "flag-bv", "flag-bw", "flag-by", "flag-bz", "flag-ca", "flag-cc", "flag-cd", "flag-cf", "flag-cg", "flag-ch", "flag-ci", "flag-ck", "flag-cl", "flag-cm", "flag-co", "flag-cp", "flag-cr", "flag-cu", "flag-cv", "flag-cw", "flag-cx", "flag-cy", "flag-cz", "flag-dg", "flag-dj", "flag-dk", "flag-dm", "flag-do", "flag-dz", "flag-ea", "flag-ec", "flag-ee", "flag-eg", "flag-eh", "flag-england", "flag-er", "flag-et", "flag-eu", "flag-fi", "flag-fj", "flag-fk", "flag-fm", "flag-fo", "flag-ga", "flag-gd", "flag-ge", "flag-gf", "flag-gg", "flag-gh", "flag-gi", "flag-gl", "flag-gm", "flag-gn", "flag-gp", "flag-gq", "flag-gr", "flag-gs", "flag-gt", "flag-gu", "flag-gw", "flag-gy", "flag-hk", "flag-hm", "flag-hn", "flag-hr", "flag-ht", "flag-hu", "flag-ic", "flag-id", "flag-ie", "flag-il", "flag-im", "flag-in", "flag-io", "flag-iq", "flag-ir", "flag-is", "flag-je", "flag-jm", "flag-jo", "flag-ke", "flag-kg", "flag-kh", "flag-ki", "flag-km", "flag-kn", "flag-kp", "flag-kw", "flag-ky", "flag-kz", "flag-la", "flag-lb", "flag-lc", "flag-li", "flag-lk", "flag-lr", "flag-ls", "flag-lt", "flag-lu", "flag-lv", "flag-ly", "flag-ma", "flag-mc", "flag-md", "flag-me", "flag-mf", "flag-mg", "flag-mh", "flag-mk", "flag-ml", "flag-mm", "flag-mn", "flag-mo", "flag-mp", "flag-mq", "flag-mr", "flag-ms", "flag-mt", "flag-mu", "flag-mv", "flag-mw", "flag-mx", "flag-my", "flag-mz", "flag-na", "flag-nc", "flag-ne", "flag-nf", "flag-ng", "flag-ni", "flag-nl", "flag-no", "flag-np", "flag-nr", "flag-nu", "flag-nz", "flag-om", "flag-pa", "flag-pe", "flag-pf", "flag-pg", "flag-ph", "flag-pk", "flag-pl", "flag-pm", "flag-pn", "flag-pr", "flag-ps", "flag-pt", "flag-pw", "flag-py", "flag-qa", "flag-re", "flag-ro", "flag-rs", "flag-rw", "flag-sa", "flag-sb", "flag-sc", "flag-scotland", "flag-sd", "flag-se", "flag-sg", "flag-sh", "flag-si", "flag-sj", "flag-sk", "flag-sl", "flag-sm", "flag-sn", "flag-so", "flag-sr", "flag-ss", "flag-st", "flag-sv", "flag-sx", "flag-sy", "flag-sz", "flag-ta", "flag-tc", "flag-td", "flag-tf", "flag-tg", "flag-th", "flag-tj", "flag-tk", "flag-tl", "flag-tm", "flag-tn", "flag-to", "flag-tr", "flag-tt", "flag-tv", "flag-tw", "flag-tz", "flag-ua", "flag-ug", "flag-um", "flag-uy", "flag-uz", "flag-va", "flag-vc", "flag-ve", "flag-vg", "flag-vi", "flag-vn", "flag-vu", "flag-wales", "flag-wf", "flag-ws", "flag-xk", "flag-ye", "flag-yt", "flag-za", "flag-zm", "flag-zw", "fr", "gb", "it", "jp", "kr", "rainbow-flag", "ru", "triangular_flag_on_post", "us", "waving_black_flag", "waving_white_flag"] }], { "satisfied": "laughing", "grinning_face_with_star_eyes": "star-struck", "face_with_one_eyebrow_raised": "face_with_raised_eyebrow", "telephone": "phone", "cooking": "fried_egg", "paw_prints": "feet", "flag-cn": "cn", "lantern": "izakaya_lantern", "shocked_face_with_exploding_head": "exploding_head", "open_book": "book", "flag-de": "de", "grinning_face_with_one_large_and_one_small_eye": "zany_face", "serious_face_with_symbols_covering_mouth": "face_with_symbols_on_mouth", "flipper": "dolphin", "face_with_open_mouth_vomiting": "face_vomiting", "flag-es": "es", "face_with_finger_covering_closed_lips": "shushing_face", "smiling_face_with_smiling_eyes_and_hand_covering_mouth": "face_with_hand_over_mouth", "flag-fr": "fr", "honeybee": "bee", "red_car": "car", "envelope": "email", "uk": "gb", "flag-gb": "gb", "poop": "hankey", "shit": "hankey", "staff_of_aesculapius": "medical_symbol", "knife": "hocho", "sailboat": "boat", "pencil": "memo", "flag-it": "it", "flag-jp": "jp", "heavy_exclamation_mark": "exclamation", "flag-kr": "kr", "waxing_gibbous_moon": "moon", "mother_christmas": "mrs_claus", "sun_small_cloud": "mostly_sunny", "sun_behind_cloud": "barely_sunny", "sun_behind_rain_cloud": "partly_sunny_rain", "lightning_cloud": "lightning", "tornado_cloud": "tornado", "flag-ru": "ru", "running": "runner", "flag-us": "us", "man_and_woman_holding_hands": "couple", "man-woman-boy": "family", "family": "man-woman-boy", "reversed_hand_with_middle_finger_extended": "middle_finger", "hand_with_index_and_middle_fingers_crossed": "crossed_fingers", "sign_of_the_horns": "the_horns", "raised_hand": "hand", "thumbsup": "+1", "thumbsdown": "-1", "punch": "facepunch", "collision": "boom", "tshirt": "shirt", "shoe": "mans_shoe" }, [["#⃣"], ["*⃣"], ["0⃣"], ["1⃣"], ["2⃣"], ["3⃣"], ["4⃣"], ["5⃣"], ["6⃣"], ["7⃣"], ["8⃣"], ["9⃣"], ["🕵‍♂", "1f575-fe0f-200d-2642-fe0f"], ["🕵‍♀", "1f575-fe0f-200d-2640-fe0f"], ["🏌‍♂", "1f3cc-fe0f-200d-2642-fe0f"], ["🏌‍♀", "1f3cc-fe0f-200d-2640-fe0f"], ["⛹‍♂", "26f9-fe0f-200d-2642-fe0f"], ["⛹‍♀", "26f9-fe0f-200d-2640-fe0f"], ["🏋‍♂", "1f3cb-fe0f-200d-2642-fe0f"], ["🏋‍♀", "1f3cb-fe0f-200d-2640-fe0f"], ["👁‍🗨"], ["🏳‍🌈", "1f3f3-fe0f-200d-1f308"], ["🕵‍♂️", "1f575-fe0f-200d-2642-fe0f"], ["🕵🏻‍♂", "1f575-1f3fb-200d-2642-fe0f"], ["🕵🏼‍♂", "1f575-1f3fc-200d-2642-fe0f"], ["🕵🏽‍♂", "1f575-1f3fd-200d-2642-fe0f"], ["🕵🏾‍♂", "1f575-1f3fe-200d-2642-fe0f"], ["🕵🏿‍♂", "1f575-1f3ff-200d-2642-fe0f"], ["🕵‍♀️", "1f575-fe0f-200d-2640-fe0f"], ["🕵🏻‍♀", "1f575-1f3fb-200d-2640-fe0f"], ["🕵🏼‍♀", "1f575-1f3fc-200d-2640-fe0f"], ["🕵🏽‍♀", "1f575-1f3fd-200d-2640-fe0f"], ["🕵🏾‍♀", "1f575-1f3fe-200d-2640-fe0f"], ["🕵🏿‍♀", "1f575-1f3ff-200d-2640-fe0f"], ["🏌‍♂️", "1f3cc-fe0f-200d-2642-fe0f"], ["🏌🏻‍♂", "1f3cc-1f3fb-200d-2642-fe0f"], ["🏌🏼‍♂", "1f3cc-1f3fc-200d-2642-fe0f"], ["🏌🏽‍♂", "1f3cc-1f3fd-200d-2642-fe0f"], ["🏌🏾‍♂", "1f3cc-1f3fe-200d-2642-fe0f"], ["🏌🏿‍♂", "1f3cc-1f3ff-200d-2642-fe0f"], ["🏌‍♀️", "1f3cc-fe0f-200d-2640-fe0f"], ["🏌🏻‍♀", "1f3cc-1f3fb-200d-2640-fe0f"], ["🏌🏼‍♀", "1f3cc-1f3fc-200d-2640-fe0f"], ["🏌🏽‍♀", "1f3cc-1f3fd-200d-2640-fe0f"], ["🏌🏾‍♀", "1f3cc-1f3fe-200d-2640-fe0f"], ["🏌🏿‍♀", "1f3cc-1f3ff-200d-2640-fe0f"], ["⛹‍♂️", "26f9-fe0f-200d-2642-fe0f"], ["⛹🏻‍♂", "26f9-1f3fb-200d-2642-fe0f"], ["⛹🏼‍♂", "26f9-1f3fc-200d-2642-fe0f"], ["⛹🏽‍♂", "26f9-1f3fd-200d-2642-fe0f"], ["⛹🏾‍♂", "26f9-1f3fe-200d-2642-fe0f"], ["⛹🏿‍♂", "26f9-1f3ff-200d-2642-fe0f"], ["⛹‍♀️", "26f9-fe0f-200d-2640-fe0f"], ["⛹🏻‍♀", "26f9-1f3fb-200d-2640-fe0f"], ["⛹🏼‍♀", "26f9-1f3fc-200d-2640-fe0f"], ["⛹🏽‍♀", "26f9-1f3fd-200d-2640-fe0f"], ["⛹🏾‍♀", "26f9-1f3fe-200d-2640-fe0f"], ["⛹🏿‍♀", "26f9-1f3ff-200d-2640-fe0f"], ["🏋‍♂️", "1f3cb-fe0f-200d-2642-fe0f"], ["🏋🏻‍♂", "1f3cb-1f3fb-200d-2642-fe0f"], ["🏋🏼‍♂", "1f3cb-1f3fc-200d-2642-fe0f"], ["🏋🏽‍♂", "1f3cb-1f3fd-200d-2642-fe0f"], ["🏋🏾‍♂", "1f3cb-1f3fe-200d-2642-fe0f"], ["🏋🏿‍♂", "1f3cb-1f3ff-200d-2642-fe0f"], ["🏋‍♀️", "1f3cb-fe0f-200d-2640-fe0f"], ["🏋🏻‍♀", "1f3cb-1f3fb-200d-2640-fe0f"], ["🏋🏼‍♀", "1f3cb-1f3fc-200d-2640-fe0f"], ["🏋🏽‍♀", "1f3cb-1f3fd-200d-2640-fe0f"], ["🏋🏾‍♀", "1f3cb-1f3fe-200d-2640-fe0f"], ["🏋🏿‍♀", "1f3cb-1f3ff-200d-2640-fe0f"], ["👁‍🗨️", "1f441-200d-1f5e8"], ["🕵🏻‍♂️"], ["🕵🏼‍♂️"], ["🕵🏽‍♂️"], ["🕵🏾‍♂️"], ["🕵🏿‍♂️"], ["🕵🏻‍♀️"], ["🕵🏼‍♀️"], ["🕵🏽‍♀️"], ["🕵🏾‍♀️"], ["🕵🏿‍♀️"], ["🏌🏻‍♂️"], ["🏌🏼‍♂️"], ["🏌🏽‍♂️"], ["🏌🏾‍♂️"], ["🏌🏿‍♂️"], ["🏌🏻‍♀️"], ["🏌🏼‍♀️"], ["🏌🏽‍♀️"], ["🏌🏾‍♀️"], ["🏌🏿‍♀️"], ["⛹🏻‍♂️"], ["⛹🏼‍♂️"], ["⛹🏽‍♂️"], ["⛹🏾‍♂️"], ["⛹🏿‍♂️"], ["⛹🏻‍♀️"], ["⛹🏼‍♀️"], ["⛹🏽‍♀️"], ["⛹🏾‍♀️"], ["⛹🏿‍♀️"], ["🏋🏻‍♂️"], ["🏋🏼‍♂️"], ["🏋🏽‍♂️"], ["🏋🏾‍♂️"], ["🏋🏿‍♂️"], ["🏋🏻‍♀️"], ["🏋🏼‍♀️"], ["🏋🏽‍♀️"], ["🏋🏾‍♀️"], ["🏋🏿‍♀️"], ["👩‍❤‍👨", "1f469-200d-2764-fe0f-200d-1f468"], ["👨‍❤‍👨", "1f468-200d-2764-fe0f-200d-1f468"], ["👩‍❤‍👩", "1f469-200d-2764-fe0f-200d-1f469"], ["👩‍❤‍💋‍👨", "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468"], ["👨‍❤‍💋‍👨", "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468"], ["👩‍❤‍💋‍👩", "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469"]]];

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(421);

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(21);
var settle = __webpack_require__(425);
var buildURL = __webpack_require__(427);
var parseHeaders = __webpack_require__(428);
var isURLSameOrigin = __webpack_require__(429);
var createError = __webpack_require__(197);
var btoa = typeof window !== 'undefined' && window.btoa && window.btoa.bind(window) || __webpack_require__(430);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' && typeof window !== 'undefined' && window.XDomainRequest && !('withCredentials' in request) && !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || request.readyState !== 4 && !xDomain) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(431);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(426);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */

function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(441);
exports.encode = exports.stringify = __webpack_require__(442);

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return search; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emoji_mart_data_light__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__emoji_mart_data_light___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__emoji_mart_data_light__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emoji_utils__ = __webpack_require__(451);
// This code is largely borrowed from:
// https://github.com/missive/emoji-mart/blob/5f2ffcc/src/utils/emoji-index.js




var originalPool = {};
var index = {};
var emojisList = {};
var emoticonsList = {};
var customEmojisList = [];

var _loop = function _loop(emoji) {
  var emojiData = __WEBPACK_IMPORTED_MODULE_0__emoji_mart_data_light___default.a.emojis[emoji];
  var short_names = emojiData.short_names,
      emoticons = emojiData.emoticons;

  var id = short_names[0];

  if (emoticons) {
    emoticons.forEach(function (emoticon) {
      if (emoticonsList[emoticon]) {
        return;
      }

      emoticonsList[emoticon] = id;
    });
  }

  emojisList[id] = Object(__WEBPACK_IMPORTED_MODULE_1__emoji_utils__["b" /* getSanitizedData */])(id);
  originalPool[id] = emojiData;
};

for (var emoji in __WEBPACK_IMPORTED_MODULE_0__emoji_mart_data_light___default.a.emojis) {
  _loop(emoji);
}

function clearCustomEmojis(pool) {
  customEmojisList.forEach(function (emoji) {
    var emojiId = emoji.id || emoji.short_names[0];

    delete pool[emojiId];
    delete emojisList[emojiId];
  });
}

function addCustomToPool(custom, pool) {
  if (customEmojisList.length) clearCustomEmojis(pool);

  custom.forEach(function (emoji) {
    var emojiId = emoji.id || emoji.short_names[0];

    if (emojiId && !pool[emojiId]) {
      pool[emojiId] = Object(__WEBPACK_IMPORTED_MODULE_1__emoji_utils__["a" /* getData */])(emoji);
      emojisList[emojiId] = Object(__WEBPACK_IMPORTED_MODULE_1__emoji_utils__["b" /* getSanitizedData */])(emoji);
    }
  });

  customEmojisList = custom;
  index = {};
}

function search(value) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      emojisToShowFilter = _ref.emojisToShowFilter,
      maxResults = _ref.maxResults,
      include = _ref.include,
      exclude = _ref.exclude,
      custom = _ref.custom;

  if (custom !== undefined) {
    if (customEmojisList !== custom) addCustomToPool(custom, originalPool);
  } else {
    custom = [];
  }

  maxResults = maxResults || 75;
  include = include || [];
  exclude = exclude || [];

  var results = null,
      pool = originalPool;

  if (value.length) {
    if (value === '-' || value === '-1') {
      return [emojisList['-1']];
    }

    var values = value.toLowerCase().split(/[\s|,|\-|_]+/),
        allResults = [];

    if (values.length > 2) {
      values = [values[0], values[1]];
    }

    if (include.length || exclude.length) {
      pool = {};

      __WEBPACK_IMPORTED_MODULE_0__emoji_mart_data_light___default.a.categories.forEach(function (category) {
        var isIncluded = include && include.length ? include.indexOf(category.name.toLowerCase()) > -1 : true;
        var isExcluded = exclude && exclude.length ? exclude.indexOf(category.name.toLowerCase()) > -1 : false;
        if (!isIncluded || isExcluded) {
          return;
        }

        category.emojis.forEach(function (emojiId) {
          return pool[emojiId] = __WEBPACK_IMPORTED_MODULE_0__emoji_mart_data_light___default.a.emojis[emojiId];
        });
      });

      if (custom.length) {
        var customIsIncluded = include && include.length ? include.indexOf('custom') > -1 : true;
        var customIsExcluded = exclude && exclude.length ? exclude.indexOf('custom') > -1 : false;
        if (customIsIncluded && !customIsExcluded) {
          addCustomToPool(custom, pool);
        }
      }
    }

    allResults = values.map(function (value) {
      var aPool = pool,
          aIndex = index,
          length = 0;

      for (var charIndex = 0; charIndex < value.length; charIndex++) {
        var char = value[charIndex];
        length++;

        aIndex[char] = aIndex[char] || {};
        aIndex = aIndex[char];

        if (!aIndex.results) {
          (function () {
            var scores = {};

            aIndex.results = [];
            aIndex.pool = {};

            for (var _id in aPool) {
              var emoji = aPool[_id],
                  _search = emoji.search,
                  sub = value.substr(0, length),
                  subIndex = _search.indexOf(sub);


              if (subIndex !== -1) {
                var score = subIndex + 1;
                if (sub === _id) score = 0;

                aIndex.results.push(emojisList[_id]);
                aIndex.pool[_id] = emoji;

                scores[_id] = score;
              }
            }

            aIndex.results.sort(function (a, b) {
              var aScore = scores[a.id],
                  bScore = scores[b.id];

              return aScore - bScore;
            });
          })();
        }

        aPool = aIndex.pool;
      }

      return aIndex.results;
    }).filter(function (a) {
      return a;
    });

    if (allResults.length > 1) {
      results = __WEBPACK_IMPORTED_MODULE_1__emoji_utils__["c" /* intersect */].apply(null, allResults);
    } else if (allResults.length) {
      results = allResults[0];
    } else {
      results = [];
    }
  }

  if (results) {
    if (emojisToShowFilter) {
      results = results.filter(function (result) {
        return emojisToShowFilter(__WEBPACK_IMPORTED_MODULE_0__emoji_mart_data_light___default.a.emojis[result.id]);
      });
    }

    if (results && results.length > maxResults) {
      results = results.slice(0, maxResults);
    }
  }

  return results;
}



/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

// The output of this module is designed to mimic emoji-mart's
// "data" object, such that we can use it for a light version of emoji-mart's
// emojiIndex.search functionality.
var _require = __webpack_require__(450),
    unicodeToUnifiedName = _require.unicodeToUnifiedName;

var _require2 = __webpack_require__(193),
    shortCodesToEmojiData = _require2[0],
    skins = _require2[1],
    categories = _require2[2],
    short_names = _require2[3];

var emojis = {};

// decompress
Object.keys(shortCodesToEmojiData).forEach(function (shortCode) {
  var _shortCodesToEmojiDat = shortCodesToEmojiData[shortCode],
      filenameData = _shortCodesToEmojiDat[0],
      // eslint-disable-line no-unused-vars
  searchData = _shortCodesToEmojiDat[1];
  var native = searchData[0],
      short_names = searchData[1],
      search = searchData[2],
      unified = searchData[3];


  if (!unified) {
    // unified name can be derived from unicodeToUnifiedName
    unified = unicodeToUnifiedName(native);
  }

  short_names = [shortCode].concat(short_names);
  emojis[shortCode] = {
    native: native,
    search: search,
    short_names: short_names,
    unified: unified
  };
});

module.exports = {
  emojis: emojis,
  skins: skins,
  categories: categories,
  short_names: short_names
};

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return pushNotificationsSetting; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return tagHistory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


var Settings = function () {
  function Settings() {
    var keyBase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Settings);

    this.keyBase = keyBase;
  }

  Settings.prototype.generateKey = function generateKey(id) {
    return this.keyBase ? [this.keyBase, 'id' + id].join('.') : id;
  };

  Settings.prototype.set = function set(id, data) {
    var key = this.generateKey(id);
    try {
      var encodedData = JSON.stringify(data);
      localStorage.setItem(key, encodedData);
      return data;
    } catch (e) {
      return null;
    }
  };

  Settings.prototype.get = function get(id) {
    var key = this.generateKey(id);
    try {
      var rawData = localStorage.getItem(key);
      return JSON.parse(rawData);
    } catch (e) {
      return null;
    }
  };

  Settings.prototype.remove = function remove(id) {
    var data = this.get(id);
    if (data) {
      var key = this.generateKey(id);
      try {
        localStorage.removeItem(key);
      } catch (e) {}
    }
    return data;
  };

  return Settings;
}();




var pushNotificationsSetting = new Settings('mastodon_push_notification_data');
var tagHistory = new Settings('mastodon_tag_history');

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



exports.extend = extend;
var hop = Object.prototype.hasOwnProperty;

function extend(obj) {
    var sources = Array.prototype.slice.call(arguments, 1),
        i,
        len,
        source,
        key;

    for (i = 0, len = sources.length; i < len; i += 1) {
        source = sources[i];
        if (!source) {
            continue;
        }

        for (key in source) {
            if (hop.call(source, key)) {
                obj[key] = source[key];
            }
        }
    }

    return obj;
}
exports.hop = hop;

//# sourceMappingURL=utils.js.map

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LoadingBar = exports.TERMINATING_ANIMATION_TIME = exports.ANIMATION_TIME = exports.PROGRESS_INCREASE = exports.MAX_PROGRESS = exports.UPDATE_TIME = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _reactRedux = __webpack_require__(9);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var UPDATE_TIME = exports.UPDATE_TIME = 200;
var MAX_PROGRESS = exports.MAX_PROGRESS = 99;
var PROGRESS_INCREASE = exports.PROGRESS_INCREASE = 10;
var ANIMATION_TIME = exports.ANIMATION_TIME = UPDATE_TIME * 4;
var TERMINATING_ANIMATION_TIME = exports.TERMINATING_ANIMATION_TIME = UPDATE_TIME / 2;

var initialState = {
  terminatingAnimationTimeout: null,
  percent: 0,
  progressInterval: null
};

var LoadingBar = exports.LoadingBar = function (_React$Component) {
  _inherits(LoadingBar, _React$Component);

  function LoadingBar(props) {
    _classCallCheck(this, LoadingBar);

    var _this = _possibleConstructorReturn(this, (LoadingBar.__proto__ || Object.getPrototypeOf(LoadingBar)).call(this, props));

    _this.state = _extends({}, initialState, {
      hasMounted: false
    });

    _this.boundSimulateProgress = _this.simulateProgress.bind(_this);
    _this.boundResetProgress = _this.resetProgress.bind(_this);
    return _this;
  }

  _createClass(LoadingBar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Re-render the component after mount to fix problems with SSR and CSP.
      //
      // Apps that use Server Side Rendering and has Content Security Policy
      // for style that doesn't allow inline styles should render an empty div
      // and replace it with the actual Loading Bar after mount
      // See: https://github.com/mironov/react-redux-loading-bar/issues/39
      //
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({ hasMounted: true });

      if (this.props.loading > 0) {
        this.launch();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.shouldStart(nextProps)) {
        this.launch();
      } else if (this.shouldStop(nextProps)) {
        if (this.state.percent === 0 && !this.props.showFastActions) {
          // not even shown yet because the action finished quickly after start
          clearInterval(this.state.progressInterval);
          this.resetProgress();
        } else {
          // should progress to 100 percent
          this.setState({ percent: 100 });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.state.progressInterval);
      clearTimeout(this.state.terminatingAnimationTimeout);
    }
  }, {
    key: 'shouldStart',
    value: function shouldStart(nextProps) {
      return this.props.loading === 0 && nextProps.loading > 0;
    }
  }, {
    key: 'shouldStop',
    value: function shouldStop(nextProps) {
      return this.state.progressInterval && nextProps.loading === 0;
    }
  }, {
    key: 'shouldShow',
    value: function shouldShow() {
      return this.state.percent > 0 && this.state.percent <= 100;
    }
  }, {
    key: 'launch',
    value: function launch() {
      var _state = this.state,
          progressInterval = _state.progressInterval,
          percent = _state.percent;
      var terminatingAnimationTimeout = this.state.terminatingAnimationTimeout;

      var loadingBarNotShown = !progressInterval;
      var terminatingAnimationGoing = percent === 100;

      if (loadingBarNotShown) {
        progressInterval = setInterval(this.boundSimulateProgress, this.props.updateTime);
      }

      if (terminatingAnimationGoing) {
        clearTimeout(terminatingAnimationTimeout);
      }

      percent = 0;

      this.setState({ progressInterval: progressInterval, percent: percent });
    }
  }, {
    key: 'newPercent',
    value: function newPercent() {
      var percent = this.state.percent;
      var progressIncrease = this.props.progressIncrease;

      // Use cos as a smoothing function
      // Can be any function to slow down progress near the 100%

      var smoothedProgressIncrease = progressIncrease * Math.cos(percent * (Math.PI / 2 / 100));

      return percent + smoothedProgressIncrease;
    }
  }, {
    key: 'simulateProgress',
    value: function simulateProgress() {
      var _state2 = this.state,
          progressInterval = _state2.progressInterval,
          percent = _state2.percent,
          terminatingAnimationTimeout = _state2.terminatingAnimationTimeout;
      var maxProgress = this.props.maxProgress;

      if (percent === 100) {
        clearInterval(progressInterval);
        terminatingAnimationTimeout = setTimeout(this.boundResetProgress, TERMINATING_ANIMATION_TIME);
        progressInterval = null;
      } else if (this.newPercent() <= maxProgress) {
        percent = this.newPercent();
      }

      this.setState({ percent: percent, progressInterval: progressInterval, terminatingAnimationTimeout: terminatingAnimationTimeout });
    }
  }, {
    key: 'resetProgress',
    value: function resetProgress() {
      this.setState(initialState);
    }
  }, {
    key: 'buildStyle',
    value: function buildStyle() {
      var animationTime = this.state.percent !== 100 ? ANIMATION_TIME : TERMINATING_ANIMATION_TIME;

      var style = {
        opacity: '1',
        transform: 'scaleX(' + this.state.percent / 100 + ')',
        transformOrigin: 'left',
        transition: 'transform ' + animationTime + 'ms linear',
        width: '100%',
        willChange: 'transform, opacity'

        // Use default styling if there's no CSS class applied
      };if (!this.props.className) {
        style.height = '3px';
        style.backgroundColor = 'red';
        style.position = 'absolute';
      }

      if (this.shouldShow()) {
        style.opacity = '1';
      } else {
        style.opacity = '0';
      }

      return _extends({}, style, this.props.style);
    }
  }, {
    key: 'render',
    value: function render() {
      // In order not to violate strict style CSP it's better to make
      // an extra re-render after component mount
      if (!this.state.hasMounted) {
        return _react2.default.createElement('div', null);
      }

      return _react2.default.createElement('div', null, _react2.default.createElement('div', { style: this.buildStyle(), className: this.props.className }), _react2.default.createElement('div', { style: { display: 'table', clear: 'both' } }));
    }
  }]);

  return LoadingBar;
}(_react2.default.Component);

LoadingBar.propTypes = {
  className: _propTypes.string,
  loading: _propTypes.number,
  maxProgress: _propTypes.number,
  progressIncrease: _propTypes.number,
  showFastActions: _propTypes.bool,
  // eslint-disable-next-line react/forbid-prop-types
  style: _propTypes.object,
  updateTime: _propTypes.number
};

LoadingBar.defaultProps = {
  className: undefined,
  loading: 0,
  maxProgress: MAX_PROGRESS,
  progressIncrease: PROGRESS_INCREASE,
  showFastActions: false,
  style: {},
  updateTime: UPDATE_TIME
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    loading: state.loadingBar
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(LoadingBar);

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showLoading = showLoading;
exports.hideLoading = hideLoading;
exports.resetLoading = resetLoading;
exports.loadingBarReducer = loadingBarReducer;
var SHOW = exports.SHOW = 'loading-bar/SHOW';
var HIDE = exports.HIDE = 'loading-bar/HIDE';
var RESET = exports.RESET = 'loading-bar/RESET';

function showLoading() {
  return {
    type: SHOW
  };
}

function hideLoading() {
  return {
    type: HIDE
  };
}

function resetLoading() {
  return {
    type: RESET
  };
}

function loadingBarReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var newState = void 0;

  switch (action.type) {
    case SHOW:
      newState = state + 1;
      break;
    case HIDE:
      newState = state > 0 ? state - 1 : 0;
      break;
    case RESET:
      newState = 0;
      break;
    default:
      return state;
  }

  return newState;
}

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export STATUS_CARD_FETCH_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return STATUS_CARD_FETCH_SUCCESS; });
/* unused harmony export STATUS_CARD_FETCH_FAIL */
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchStatusCard;
/* unused harmony export fetchStatusCardRequest */
/* unused harmony export fetchStatusCardSuccess */
/* unused harmony export fetchStatusCardFail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(11);


var STATUS_CARD_FETCH_REQUEST = 'STATUS_CARD_FETCH_REQUEST';
var STATUS_CARD_FETCH_SUCCESS = 'STATUS_CARD_FETCH_SUCCESS';
var STATUS_CARD_FETCH_FAIL = 'STATUS_CARD_FETCH_FAIL';

function fetchStatusCard(id) {
  return function (dispatch, getState) {
    if (getState().getIn(['cards', id], null) !== null) {
      return;
    }

    dispatch(fetchStatusCardRequest(id));

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get('/api/v1/statuses/' + id + '/card').then(function (response) {
      if (!response.data.url) {
        return;
      }

      dispatch(fetchStatusCardSuccess(id, response.data));
    }).catch(function (error) {
      dispatch(fetchStatusCardFail(id, error));
    });
  };
};

function fetchStatusCardRequest(id) {
  return {
    type: STATUS_CARD_FETCH_REQUEST,
    id: id,
    skipLoading: true
  };
};

function fetchStatusCardSuccess(id, card) {
  return {
    type: STATUS_CARD_FETCH_SUCCESS,
    id: id,
    card: card,
    skipLoading: true
  };
};

function fetchStatusCardFail(id, error) {
  return {
    type: STATUS_CARD_FETCH_FAIL,
    id: id,
    error: error,
    skipLoading: true,
    skipAlert: true
  };
};

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = uuid;
function uuid(a) {
  return a ? (a ^ Math.random() * 16 >> a / 4).toString(16) : ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, uuid);
};

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_BROWSER_SUPPORT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_SUBSCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLEAR_SUBSCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_ALERTS; });
/* harmony export (immutable) */ __webpack_exports__["g"] = setBrowserSupport;
/* harmony export (immutable) */ __webpack_exports__["h"] = setSubscription;
/* harmony export (immutable) */ __webpack_exports__["e"] = clearSubscription;
/* harmony export (immutable) */ __webpack_exports__["f"] = setAlerts;
var SET_BROWSER_SUPPORT = 'PUSH_NOTIFICATIONS_SET_BROWSER_SUPPORT';
var SET_SUBSCRIPTION = 'PUSH_NOTIFICATIONS_SET_SUBSCRIPTION';
var CLEAR_SUBSCRIPTION = 'PUSH_NOTIFICATIONS_CLEAR_SUBSCRIPTION';
var SET_ALERTS = 'PUSH_NOTIFICATIONS_SET_ALERTS';

function setBrowserSupport(value) {
  return {
    type: SET_BROWSER_SUPPORT,
    value: value
  };
}

function setSubscription(subscription) {
  return {
    type: SET_SUBSCRIPTION,
    subscription: subscription
  };
}

function clearSubscription() {
  return {
    type: CLEAR_SUBSCRIPTION
  };
}

function setAlerts(path, value) {
  return function (dispatch) {
    dispatch({
      type: SET_ALERTS,
      path: path,
      value: value
    });
  };
}

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CUSTOM_EMOJIS_FETCH_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CUSTOM_EMOJIS_FETCH_SUCCESS; });
/* unused harmony export CUSTOM_EMOJIS_FETCH_FAIL */
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchCustomEmojis;
/* unused harmony export fetchCustomEmojisRequest */
/* unused harmony export fetchCustomEmojisSuccess */
/* unused harmony export fetchCustomEmojisFail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(11);


var CUSTOM_EMOJIS_FETCH_REQUEST = 'CUSTOM_EMOJIS_FETCH_REQUEST';
var CUSTOM_EMOJIS_FETCH_SUCCESS = 'CUSTOM_EMOJIS_FETCH_SUCCESS';
var CUSTOM_EMOJIS_FETCH_FAIL = 'CUSTOM_EMOJIS_FETCH_FAIL';

function fetchCustomEmojis() {
  return function (dispatch, getState) {
    dispatch(fetchCustomEmojisRequest());

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get('/api/v1/custom_emojis').then(function (response) {
      dispatch(fetchCustomEmojisSuccess(response.data));
    }).catch(function (error) {
      dispatch(fetchCustomEmojisFail(error));
    });
  };
};

function fetchCustomEmojisRequest() {
  return {
    type: CUSTOM_EMOJIS_FETCH_REQUEST
  };
};

function fetchCustomEmojisSuccess(custom_emojis) {
  return {
    type: CUSTOM_EMOJIS_FETCH_SUCCESS,
    custom_emojis: custom_emojis
  };
};

function fetchCustomEmojisFail(error) {
  return {
    type: CUSTOM_EMOJIS_FETCH_FAIL,
    error: error
  };
};

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ('value' in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError('Cannot call a class as a function');
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== 'function' && superClass !== null) {
    throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var _mapToZero = __webpack_require__(508);

var _mapToZero2 = _interopRequireDefault(_mapToZero);

var _stripStyle = __webpack_require__(509);

var _stripStyle2 = _interopRequireDefault(_stripStyle);

var _stepper3 = __webpack_require__(510);

var _stepper4 = _interopRequireDefault(_stepper3);

var _performanceNow = __webpack_require__(511);

var _performanceNow2 = _interopRequireDefault(_performanceNow);

var _raf = __webpack_require__(512);

var _raf2 = _interopRequireDefault(_raf);

var _shouldStopAnimation = __webpack_require__(514);

var _shouldStopAnimation2 = _interopRequireDefault(_shouldStopAnimation);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var msPerFrame = 1000 / 60;

var Motion = function (_React$Component) {
  _inherits(Motion, _React$Component);

  _createClass(Motion, null, [{
    key: 'propTypes',
    value: {
      // TOOD: warn against putting a config in here
      defaultStyle: _propTypes2['default'].objectOf(_propTypes2['default'].number),
      style: _propTypes2['default'].objectOf(_propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].object])).isRequired,
      children: _propTypes2['default'].func.isRequired,
      onRest: _propTypes2['default'].func
    },
    enumerable: true
  }]);

  function Motion(props) {
    var _this = this;

    _classCallCheck(this, Motion);

    _React$Component.call(this, props);
    this.wasAnimating = false;
    this.animationID = null;
    this.prevTime = 0;
    this.accumulatedTime = 0;
    this.unreadPropStyle = null;

    this.clearUnreadPropStyle = function (destStyle) {
      var dirty = false;
      var _state = _this.state;
      var currentStyle = _state.currentStyle;
      var currentVelocity = _state.currentVelocity;
      var lastIdealStyle = _state.lastIdealStyle;
      var lastIdealVelocity = _state.lastIdealVelocity;

      for (var key in destStyle) {
        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) {
          continue;
        }

        var styleValue = destStyle[key];
        if (typeof styleValue === 'number') {
          if (!dirty) {
            dirty = true;
            currentStyle = _extends({}, currentStyle);
            currentVelocity = _extends({}, currentVelocity);
            lastIdealStyle = _extends({}, lastIdealStyle);
            lastIdealVelocity = _extends({}, lastIdealVelocity);
          }

          currentStyle[key] = styleValue;
          currentVelocity[key] = 0;
          lastIdealStyle[key] = styleValue;
          lastIdealVelocity[key] = 0;
        }
      }

      if (dirty) {
        _this.setState({ currentStyle: currentStyle, currentVelocity: currentVelocity, lastIdealStyle: lastIdealStyle, lastIdealVelocity: lastIdealVelocity });
      }
    };

    this.startAnimationIfNecessary = function () {
      // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
      // call cb? No, otherwise accidental parent rerender causes cb trigger
      _this.animationID = _raf2['default'](function (timestamp) {
        // check if we need to animate in the first place
        var propsStyle = _this.props.style;
        if (_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
          if (_this.wasAnimating && _this.props.onRest) {
            _this.props.onRest();
          }

          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.wasAnimating = false;
          _this.accumulatedTime = 0;
          return;
        }

        _this.wasAnimating = true;

        var currentTime = timestamp || _performanceNow2['default']();
        var timeDelta = currentTime - _this.prevTime;
        _this.prevTime = currentTime;
        _this.accumulatedTime = _this.accumulatedTime + timeDelta;
        // more than 10 frames? prolly switched browser tab. Restart
        if (_this.accumulatedTime > msPerFrame * 10) {
          _this.accumulatedTime = 0;
        }

        if (_this.accumulatedTime === 0) {
          // no need to cancel animationID here; shouldn't have any in flight
          _this.animationID = null;
          _this.startAnimationIfNecessary();
          return;
        }

        var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / msPerFrame) * msPerFrame) / msPerFrame;
        var framesToCatchUp = Math.floor(_this.accumulatedTime / msPerFrame);

        var newLastIdealStyle = {};
        var newLastIdealVelocity = {};
        var newCurrentStyle = {};
        var newCurrentVelocity = {};

        for (var key in propsStyle) {
          if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) {
            continue;
          }

          var styleValue = propsStyle[key];
          if (typeof styleValue === 'number') {
            newCurrentStyle[key] = styleValue;
            newCurrentVelocity[key] = 0;
            newLastIdealStyle[key] = styleValue;
            newLastIdealVelocity[key] = 0;
          } else {
            var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
            var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
            for (var i = 0; i < framesToCatchUp; i++) {
              var _stepper = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

              newLastIdealStyleValue = _stepper[0];
              newLastIdealVelocityValue = _stepper[1];
            }

            var _stepper2 = _stepper4['default'](msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);

            var nextIdealX = _stepper2[0];
            var nextIdealV = _stepper2[1];

            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
            newLastIdealStyle[key] = newLastIdealStyleValue;
            newLastIdealVelocity[key] = newLastIdealVelocityValue;
          }
        }

        _this.animationID = null;
        // the amount we're looped over above
        _this.accumulatedTime -= framesToCatchUp * msPerFrame;

        _this.setState({
          currentStyle: newCurrentStyle,
          currentVelocity: newCurrentVelocity,
          lastIdealStyle: newLastIdealStyle,
          lastIdealVelocity: newLastIdealVelocity
        });

        _this.unreadPropStyle = null;

        _this.startAnimationIfNecessary();
      });
    };

    this.state = this.defaultState();
  }

  Motion.prototype.defaultState = function defaultState() {
    var _props = this.props;
    var defaultStyle = _props.defaultStyle;
    var style = _props.style;

    var currentStyle = defaultStyle || _stripStyle2['default'](style);
    var currentVelocity = _mapToZero2['default'](currentStyle);
    return {
      currentStyle: currentStyle,
      currentVelocity: currentVelocity,
      lastIdealStyle: currentStyle,
      lastIdealVelocity: currentVelocity
    };
  };

  // it's possible that currentStyle's value is stale: if props is immediately
  // changed from 0 to 400 to spring(0) again, the async currentStyle is still
  // at 0 (didn't have time to tick and interpolate even once). If we naively
  // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
  // In reality currentStyle should be 400

  Motion.prototype.componentDidMount = function componentDidMount() {
    this.prevTime = _performanceNow2['default']();
    this.startAnimationIfNecessary();
  };

  Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (this.unreadPropStyle != null) {
      // previous props haven't had the chance to be set yet; set them here
      this.clearUnreadPropStyle(this.unreadPropStyle);
    }

    this.unreadPropStyle = props.style;
    if (this.animationID == null) {
      this.prevTime = _performanceNow2['default']();
      this.startAnimationIfNecessary();
    }
  };

  Motion.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.animationID != null) {
      _raf2['default'].cancel(this.animationID);
      this.animationID = null;
    }
  };

  Motion.prototype.render = function render() {
    var renderedChildren = this.props.children(this.state.currentStyle);
    return renderedChildren && _react2['default'].Children.only(renderedChildren);
  };

  return Motion;
}(_react2['default'].Component);

exports['default'] = Motion;
module.exports = exports['default'];

// after checking for unreadPropStyle != null, we manually go set the
// non-interpolating values (those that are a number, without a spring
// config)

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = offset;

var _contains = __webpack_require__(215);

var _contains2 = _interopRequireDefault(_contains);

var _isWindow = __webpack_require__(138);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(137);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function offset(node) {
  var doc = (0, _ownerDocument2.default)(node),
      win = (0, _isWindow2.default)(doc),
      docElem = doc && doc.documentElement,
      box = { top: 0, left: 0, height: 0, width: 0 };

  if (!doc) return;

  // Make sure it's not a disconnected DOM node
  if (!(0, _contains2.default)(docElem, node)) return box;

  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect();

  // IE8 getBoundingClientRect doesn't support width & height
  box = {
    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
    width: (box.width == null ? node.offsetWidth : box.width) || 0,
    height: (box.height == null ? node.offsetHeight : box.height) || 0
  };

  return box;
}
module.exports = exports['default'];

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(65);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM2.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);

  return false;
}
module.exports = exports['default'];

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = style;

var _camelizeStyle = __webpack_require__(217);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

var _hyphenateStyle = __webpack_require__(525);

var _hyphenateStyle2 = _interopRequireDefault(_hyphenateStyle);

var _getComputedStyle2 = __webpack_require__(527);

var _getComputedStyle3 = _interopRequireDefault(_getComputedStyle2);

var _removeStyle = __webpack_require__(528);

var _removeStyle2 = _interopRequireDefault(_removeStyle);

var _properties = __webpack_require__(218);

var _isTransform = __webpack_require__(529);

var _isTransform2 = _interopRequireDefault(_isTransform);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle2.default)(property)] || (0, _getComputedStyle3.default)(node).getPropertyValue((0, _hyphenateStyle2.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];
    if (!value && value !== 0) {
      (0, _removeStyle2.default)(node, (0, _hyphenateStyle2.default)(key));
    } else if ((0, _isTransform2.default)(key)) {
      transforms += key + '(' + value + ') ';
    } else {
      css += (0, _hyphenateStyle2.default)(key) + ': ' + value + ';';
    }
  });

  if (transforms) {
    css += _properties.transform + ': ' + transforms + ';';
  }

  node.style.cssText += ';' + css;
}
module.exports = exports['default'];

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelizeStyleName;

var _camelize = __webpack_require__(524);

var _camelize2 = _interopRequireDefault(_camelize);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var msPattern = /^-ms-/; /**
                          * Copyright 2014-2015, Facebook, Inc.
                          * All rights reserved.
                          * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
                          */
function camelizeStyleName(string) {
  return (0, _camelize2.default)(string.replace(msPattern, 'ms-'));
}
module.exports = exports['default'];

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = undefined;

var _inDOM = __webpack_require__(65);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var transform = 'transform';
var prefix = void 0,
    transitionEnd = void 0,
    animationEnd = void 0;
var transitionProperty = void 0,
    transitionDuration = void 0,
    transitionTiming = void 0,
    transitionDelay = void 0;
var animationName = void 0,
    animationDuration = void 0,
    animationTiming = void 0,
    animationDelay = void 0;

if (_inDOM2.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;

  exports.transform = transform = prefix + '-' + transform;
  exports.transitionProperty = transitionProperty = prefix + '-transition-property';
  exports.transitionDuration = transitionDuration = prefix + '-transition-duration';
  exports.transitionDelay = transitionDelay = prefix + '-transition-delay';
  exports.transitionTiming = transitionTiming = prefix + '-transition-timing-function';

  exports.animationName = animationName = prefix + '-animation-name';
  exports.animationDuration = animationDuration = prefix + '-animation-duration';
  exports.animationTiming = animationTiming = prefix + '-animation-delay';
  exports.animationDelay = animationDelay = prefix + '-animation-timing-function';
}

exports.transform = transform;
exports.transitionProperty = transitionProperty;
exports.transitionTiming = transitionTiming;
exports.transitionDelay = transitionDelay;
exports.transitionDuration = transitionDuration;
exports.transitionEnd = transitionEnd;
exports.animationName = animationName;
exports.animationDuration = animationDuration;
exports.animationTiming = animationTiming;
exports.animationDelay = animationDelay;
exports.animationEnd = animationEnd;
exports.default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};

function getTransitionProperties() {
  var style = document.createElement('div').style;

  var vendorMap = {
    O: function O(e) {
      return 'o' + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return 'webkit' + e;
    },
    ms: function ms(e) {
      return 'MS' + e;
    }
  };

  var vendors = Object.keys(vendorMap);

  var transitionEnd = void 0,
      animationEnd = void 0;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + 'TransitionProperty' in style) {
      prefix = '-' + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';

  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';

  style = null;

  return { animationEnd: animationEnd, transitionEnd: transitionEnd, prefix: prefix };
}

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = scrollTop;

var _isWindow = __webpack_require__(138);

var _isWindow2 = _interopRequireDefault(_isWindow);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function scrollTop(node, val) {
  var win = (0, _isWindow2.default)(node);

  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;

  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
}
module.exports = exports['default'];

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(221);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};








var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var getHistoryState = function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
};

/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */
var createBrowserHistory = function createBrowserHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Browser history needs a DOM');

  var globalHistory = window.history;
  var canUseHistory = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["g" /* supportsHistory */])();
  var needsHashChangeListener = !Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["h" /* supportsPopStateOnHashChange */])();

  var _props$forceRefresh = props.forceRefresh,
      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
      _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var getDOMLocation = function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;

    var path = pathname + search + hash;

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, key);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var handlePopState = function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["d" /* isExtraneousPopstateEvent */])(event)) return;

    handlePop(getDOMLocation(event.state));
  };

  var handleHashChange = function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  };

  var forceNextPop = false;

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allKeys.indexOf(fromLocation.key);

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key];

  // Public interface

  var createHref = function createHref(location) {
    return basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

          nextKeys.push(location.key);
          allKeys = nextKeys;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');

        window.location.href = href;
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({ key: key, state: state }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);

          if (prevIndex !== -1) allKeys[prevIndex] = location.key;

          setState({ action: action, location: location });
        }
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');

        window.location.replace(href);
      }
    });
  };

  var go = function go(n) {
    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, PopStateEvent, handlePopState);

      if (needsHashChangeListener) Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createBrowserHistory);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canUseDOM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeEventListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getConfirmation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return supportsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return supportsPopStateOnHashChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return supportsGoWithoutReloadUsingHash; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isExtraneousPopstateEvent; });
var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

var addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

var getConfirmation = function getConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PathUtils__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DOMUtils__ = __webpack_require__(221);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};








var HashChangeEvent = 'hashchange';

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */])(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["f" /* stripLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  },
  slash: {
    encodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */],
    decodePath: __WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */]
  }
};

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var createHashHistory = function createHashHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  __WEBPACK_IMPORTED_MODULE_1_invariant___default()(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["b" /* canUseDOM */], 'Hash history needs a DOM');

  var globalHistory = window.history;
  var canGoWithoutReload = Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["f" /* supportsGoWithoutReloadUsingHash */])();

  var _props$getUserConfirm = props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === undefined ? __WEBPACK_IMPORTED_MODULE_5__DOMUtils__["c" /* getConfirmation */] : _props$getUserConfirm,
      _props$hashType = props.hashType,
      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;

  var basename = props.basename ? Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["g" /* stripTrailingSlash */])(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["a" /* addLeadingSlash */])(props.basename)) : '';

  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  var getDOMLocation = function getDOMLocation() {
    var path = decodePath(getHashPath());

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!basename || Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["c" /* hasBasename */])(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');

    if (basename) path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["e" /* stripBasename */])(path, basename);

    return Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path);
  };

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = globalHistory.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var forceNextPop = false;
  var ignorePath = null;

  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;

      if (!forceNextPop && Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["b" /* locationsAreEqual */])(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;

      handlePop(location);
    }
  };

  var handlePop = function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';

      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({ action: action, location: location });
        } else {
          revertPop(location);
        }
      });
    }
  };

  var revertPop = function revertPop(fromLocation) {
    var toLocation = history.location;

    // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(toLocation));

    if (toIndex === -1) toIndex = 0;

    var fromIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(fromLocation));

    if (fromIndex === -1) fromIndex = 0;

    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  };

  // Ensure the hash is encoded properly before doing anything else.
  var path = getHashPath();
  var encodedPath = encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  var initialLocation = getDOMLocation();
  var allPaths = [Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(initialLocation)];

  // Public interface

  var createHref = function createHref(location) {
    return '#' + encodePath(basename + Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location));
  };

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot push state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);

        var prevIndex = allPaths.lastIndexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));
        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);

        nextPaths.push(path);
        allPaths = nextPaths;

        setState({ action: action, location: location });
      } else {
        __WEBPACK_IMPORTED_MODULE_0_warning___default()(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');

        setState();
      }
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(state === undefined, 'Hash history cannot replace state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, undefined, undefined, history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var path = Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(Object(__WEBPACK_IMPORTED_MODULE_3__PathUtils__["b" /* createPath */])(history.location));

      if (prevIndex !== -1) allPaths[prevIndex] = path;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');

    globalHistory.go(n);
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var listenerCount = 0;

  var checkDOMListeners = function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["a" /* addEventListener */])(window, HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      Object(__WEBPACK_IMPORTED_MODULE_5__DOMUtils__["e" /* removeEventListener */])(window, HashChangeEvent, handleHashChange);
    }
  };

  var isBlocked = false;

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  };

  var listen = function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);

    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  };

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createHashHistory);

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}





var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;

          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Link> outside a <Router>');

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PathUtils__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LocationUtils__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(142);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};






var clamp = function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
};

/**
 * Creates a history object that stores locations in memory.
 */
var createMemoryHistory = function createMemoryHistory() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getUserConfirmation = props.getUserConfirmation,
      _props$initialEntries = props.initialEntries,
      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
      _props$initialIndex = props.initialIndex,
      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
      _props$keyLength = props.keyLength,
      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;

  var transitionManager = Object(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])();

  var setState = function setState(nextState) {
    _extends(history, nextState);

    history.length = history.entries.length;

    transitionManager.notifyListeners(history.location, history.action);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  };

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, createKey()) : Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(entry, undefined, entry.key || createKey());
  });

  // Public interface

  var createHref = __WEBPACK_IMPORTED_MODULE_1__PathUtils__["b" /* createPath */];

  var push = function push(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'PUSH';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;

      var nextEntries = history.entries.slice(0);
      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  };

  var replace = function replace(path, state) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');

    var action = 'REPLACE';
    var location = Object(__WEBPACK_IMPORTED_MODULE_2__LocationUtils__["a" /* createLocation */])(path, state, createKey(), history.location);

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;

      history.entries[history.index] = location;

      setState({ action: action, location: location });
    });
  };

  var go = function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);

    var action = 'POP';
    var location = history.entries[nextIndex];

    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var canGo = function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  };

  var block = function block() {
    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return transitionManager.setPrompt(prompt);
  };

  var listen = function listen(listener) {
    return transitionManager.appendListener(listener);
  };

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };

  return history;
};

/* harmony default export */ __webpack_exports__["a"] = (createMemoryHistory);

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(226);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(145);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, 'You should not use <Route> or withRouter() outside a <Router>');

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    return component ? // component prop gets first priority, only called if there's a match
    match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
    match ? render(props) : null : children ? // children come last, always called
    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null : null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var FocusTrap = function (_React$Component) {
  _inherits(FocusTrap, _React$Component);

  function FocusTrap() {
    _classCallCheck(this, FocusTrap);

    return _possibleConstructorReturn(this, (FocusTrap.__proto__ || Object.getPrototypeOf(FocusTrap)).apply(this, arguments));
  }

  _createClass(FocusTrap, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          Component = _props.component,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['component', 'children']);

      return _react2.default.createElement(Component, _extends({ tabIndex: '-1' }, props), children);
    }
  }]);

  return FocusTrap;
}(_react2.default.Component);

FocusTrap.propTypes = {
  onFocus: _propTypes2.default.func,
  onBlur: _propTypes2.default.func,
  component: _propTypes2.default.any,
  children: _propTypes2.default.node
};
FocusTrap.defaultProps = {
  component: 'div'
};
exports.default = FocusTrap;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HotKeyMapMixin;

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _assign = __webpack_require__(557);

var _assign2 = _interopRequireDefault(_assign);

var _isEqual = __webpack_require__(239);

var _isEqual2 = _interopRequireDefault(_isEqual);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function HotKeyMapMixin() {
  var hotKeyMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {

    contextTypes: {
      hotKeyMap: _propTypes2.default.object
    },

    childContextTypes: {
      hotKeyMap: _propTypes2.default.object
    },

    getChildContext: function getChildContext() {
      return {
        hotKeyMap: this.__hotKeyMap__
      };
    },
    componentWillMount: function componentWillMount() {
      this.updateMap();
    },
    updateMap: function updateMap() {
      var newMap = this.buildMap();

      if (!(0, _isEqual2.default)(newMap, this.__hotKeyMap__)) {
        this.__hotKeyMap__ = newMap;
        return true;
      }

      return false;
    },
    buildMap: function buildMap() {
      var parentMap = this.context.hotKeyMap || {};
      var thisMap = this.props.keyMap || {};

      return (0, _assign2.default)({}, parentMap, hotKeyMap, thisMap);
    },
    getMap: function getMap() {
      return this.__hotKeyMap__;
    }
  };
}

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(230),
    eq = __webpack_require__(84);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(231);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41);

var defineProperty = function () {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}();

module.exports = defineProperty;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(50),
    isObject = __webpack_require__(40);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
    if (!isObject(value)) {
        return false;
    }
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;

/***/ }),
/* 233 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return func + '';
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;

/***/ }),
/* 234 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;

/***/ }),
/* 235 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length && (typeof value == 'number' || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}

module.exports = isIndex;

/***/ }),
/* 236 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;

  return value === proto;
}

module.exports = isPrototype;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(25),
    stubFalse = __webpack_require__(576);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(101)(module)))

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(577),
    baseUnary = __webpack_require__(578),
    nodeUtil = __webpack_require__(579);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(583);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(596),
    mapCacheDelete = __webpack_require__(603),
    mapCacheGet = __webpack_require__(605),
    mapCacheHas = __webpack_require__(606),
    mapCacheSet = __webpack_require__(607);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(608),
    arraySome = __webpack_require__(611),
    cacheHas = __webpack_require__(612);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function (othValue, othIndex) {
        if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          return seen.push(othIndex);
        }
      })) {
        result = false;
        break;
      }
    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

//      Copyright (c) 2012 Mathieu Turcotte
//      Licensed under the MIT license.

var events = __webpack_require__(149);
var precond = __webpack_require__(150);
var util = __webpack_require__(42);

// A class to hold the state of a backoff operation. Accepts a backoff strategy
// to generate the backoff delays.
function Backoff(backoffStrategy) {
    events.EventEmitter.call(this);

    this.backoffStrategy_ = backoffStrategy;
    this.maxNumberOfRetry_ = -1;
    this.backoffNumber_ = 0;
    this.backoffDelay_ = 0;
    this.timeoutID_ = -1;

    this.handlers = {
        backoff: this.onBackoff_.bind(this)
    };
}
util.inherits(Backoff, events.EventEmitter);

// Sets a limit, greater than 0, on the maximum number of backoffs. A 'fail'
// event will be emitted when the limit is reached.
Backoff.prototype.failAfter = function (maxNumberOfRetry) {
    precond.checkArgument(maxNumberOfRetry > 0, 'Expected a maximum number of retry greater than 0 but got %s.', maxNumberOfRetry);

    this.maxNumberOfRetry_ = maxNumberOfRetry;
};

// Starts a backoff operation. Accepts an optional parameter to let the
// listeners know why the backoff operation was started.
Backoff.prototype.backoff = function (err) {
    precond.checkState(this.timeoutID_ === -1, 'Backoff in progress.');

    if (this.backoffNumber_ === this.maxNumberOfRetry_) {
        this.emit('fail', err);
        this.reset();
    } else {
        this.backoffDelay_ = this.backoffStrategy_.next();
        this.timeoutID_ = setTimeout(this.handlers.backoff, this.backoffDelay_);
        this.emit('backoff', this.backoffNumber_, this.backoffDelay_, err);
    }
};

// Handles the backoff timeout completion.
Backoff.prototype.onBackoff_ = function () {
    this.timeoutID_ = -1;
    this.emit('ready', this.backoffNumber_, this.backoffDelay_);
    this.backoffNumber_++;
};

// Stops any backoff operation and resets the backoff delay to its inital value.
Backoff.prototype.reset = function () {
    this.backoffNumber_ = 0;
    this.backoffStrategy_.reset();
    clearTimeout(this.timeoutID_);
    this.timeoutID_ = -1;
};

module.exports = Backoff;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

//      Copyright (c) 2012 Mathieu Turcotte
//      Licensed under the MIT license.

var events = __webpack_require__(149);
var util = __webpack_require__(42);

function isDef(value) {
    return value !== undefined && value !== null;
}

// Abstract class defining the skeleton for the backoff strategies. Accepts an
// object holding the options for the backoff strategy:
//
//  * `randomisationFactor`: The randomisation factor which must be between 0
//     and 1 where 1 equates to a randomization factor of 100% and 0 to no
//     randomization.
//  * `initialDelay`: The backoff initial delay in milliseconds.
//  * `maxDelay`: The backoff maximal delay in milliseconds.
function BackoffStrategy(options) {
    options = options || {};

    if (isDef(options.initialDelay) && options.initialDelay < 1) {
        throw new Error('The initial timeout must be greater than 0.');
    } else if (isDef(options.maxDelay) && options.maxDelay < 1) {
        throw new Error('The maximal timeout must be greater than 0.');
    }

    this.initialDelay_ = options.initialDelay || 100;
    this.maxDelay_ = options.maxDelay || 10000;

    if (this.maxDelay_ <= this.initialDelay_) {
        throw new Error('The maximal backoff delay must be ' + 'greater than the initial backoff delay.');
    }

    if (isDef(options.randomisationFactor) && (options.randomisationFactor < 0 || options.randomisationFactor > 1)) {
        throw new Error('The randomisation factor must be between 0 and 1.');
    }

    this.randomisationFactor_ = options.randomisationFactor || 0;
}

// Gets the maximal backoff delay.
BackoffStrategy.prototype.getMaxDelay = function () {
    return this.maxDelay_;
};

// Gets the initial backoff delay.
BackoffStrategy.prototype.getInitialDelay = function () {
    return this.initialDelay_;
};

// Template method that computes and returns the next backoff delay in
// milliseconds.
BackoffStrategy.prototype.next = function () {
    var backoffDelay = this.next_();
    var randomisationMultiple = 1 + Math.random() * this.randomisationFactor_;
    var randomizedDelay = Math.round(backoffDelay * randomisationMultiple);
    return randomizedDelay;
};

// Computes and returns the next backoff delay. Intended to be overridden by
// subclasses.
BackoffStrategy.prototype.next_ = function () {
    throw new Error('BackoffStrategy.next_() unimplemented.');
};

// Template method that resets the backoff delay to its initial value.
BackoffStrategy.prototype.reset = function () {
    this.reset_();
};

// Resets the backoff delay to its initial value. Intended to be overridden by
// subclasses.
BackoffStrategy.prototype.reset_ = function () {
    throw new Error('BackoffStrategy.reset_() unimplemented.');
};

module.exports = BackoffStrategy;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

//      Copyright (c) 2012 Mathieu Turcotte
//      Licensed under the MIT license.

var util = __webpack_require__(42);

var BackoffStrategy = __webpack_require__(243);

// Fibonacci backoff strategy.
function FibonacciBackoffStrategy(options) {
    BackoffStrategy.call(this, options);
    this.backoffDelay_ = 0;
    this.nextBackoffDelay_ = this.getInitialDelay();
}
util.inherits(FibonacciBackoffStrategy, BackoffStrategy);

FibonacciBackoffStrategy.prototype.next_ = function () {
    var backoffDelay = Math.min(this.nextBackoffDelay_, this.getMaxDelay());
    this.nextBackoffDelay_ += this.backoffDelay_;
    this.backoffDelay_ = backoffDelay;
    return backoffDelay;
};

FibonacciBackoffStrategy.prototype.reset_ = function () {
    this.nextBackoffDelay_ = this.getInitialDelay();
    this.backoffDelay_ = 0;
};

module.exports = FibonacciBackoffStrategy;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(654);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  RESISTANCE_COEF: 0.6,

  // This value is closed to what browsers are using internally to
  // trigger a native scroll.
  UNCERTAINTY_THRESHOLD: 3 // px
};

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImageLoader; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__zoomable_image__ = __webpack_require__(670);






var _class, _temp2;






var ImageLoader = (_temp2 = _class = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ImageLoader, _React$PureComponent);

  function ImageLoader() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ImageLoader);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
      loading: true,
      error: false
    }, _this.removers = [], _this.canvas = null, _this.loadPreviewCanvas = function (_ref) {
      var previewSrc = _ref.previewSrc,
          width = _ref.width,
          height = _ref.height;
      return new Promise(function (resolve, reject) {
        var image = new Image();
        var removeEventListeners = function removeEventListeners() {
          image.removeEventListener('error', handleError);
          image.removeEventListener('load', handleLoad);
        };
        var handleError = function handleError() {
          removeEventListeners();
          reject();
        };
        var handleLoad = function handleLoad() {
          removeEventListeners();
          _this.canvasContext.drawImage(image, 0, 0, width, height);
          resolve();
        };
        image.addEventListener('error', handleError);
        image.addEventListener('load', handleLoad);
        image.src = previewSrc;
        _this.removers.push(removeEventListeners);
      });
    }, _this.loadOriginalImage = function (_ref2) {
      var src = _ref2.src;
      return new Promise(function (resolve, reject) {
        var image = new Image();
        var removeEventListeners = function removeEventListeners() {
          image.removeEventListener('error', handleError);
          image.removeEventListener('load', handleLoad);
        };
        var handleError = function handleError() {
          removeEventListeners();
          reject();
        };
        var handleLoad = function handleLoad() {
          removeEventListeners();
          resolve();
        };
        image.addEventListener('error', handleError);
        image.addEventListener('load', handleLoad);
        image.src = src;
        _this.removers.push(removeEventListeners);
      });
    }, _this.setCanvasRef = function (c) {
      _this.canvas = c;
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  ImageLoader.prototype.componentDidMount = function componentDidMount() {
    this.loadImage(this.props);
  };

  ImageLoader.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.src !== nextProps.src) {
      this.loadImage(nextProps);
    }
  };

  ImageLoader.prototype.componentWillUnmount = function componentWillUnmount() {
    this.removeEventListeners();
  };

  ImageLoader.prototype.loadImage = function loadImage(props) {
    var _this2 = this;

    this.removeEventListeners();
    this.setState({ loading: true, error: false });
    Promise.all([props.previewSrc && this.loadPreviewCanvas(props), this.hasSize() && this.loadOriginalImage(props)].filter(Boolean)).then(function () {
      _this2.setState({ loading: false, error: false });
      _this2.clearPreviewCanvas();
    }).catch(function () {
      return _this2.setState({ loading: false, error: true });
    });
  };

  ImageLoader.prototype.clearPreviewCanvas = function clearPreviewCanvas() {
    var _canvas = this.canvas,
        width = _canvas.width,
        height = _canvas.height;

    this.canvasContext.clearRect(0, 0, width, height);
  };

  ImageLoader.prototype.removeEventListeners = function removeEventListeners() {
    this.removers.forEach(function (listeners) {
      return listeners();
    });
    this.removers = [];
  };

  ImageLoader.prototype.hasSize = function hasSize() {
    var _props = this.props,
        width = _props.width,
        height = _props.height;

    return typeof width === 'number' && typeof height === 'number';
  };

  ImageLoader.prototype.render = function render() {
    var _props2 = this.props,
        alt = _props2.alt,
        src = _props2.src,
        width = _props2.width,
        height = _props2.height,
        onClick = _props2.onClick;
    var loading = this.state.loading;


    var className = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('image-loader', {
      'image-loader--loading': loading,
      'image-loader--amorphous': !this.hasSize()
    });

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: className
    }, void 0, loading ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement('canvas', {
      className: 'image-loader__preview-canvas',
      ref: this.setCanvasRef,
      width: width,
      height: height
    }) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__zoomable_image__["a" /* default */], {
      alt: alt,
      src: src,
      onClick: onClick
    }));
  };

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ImageLoader, [{
    key: 'canvasContext',
    get: function get() {
      if (!this.canvas) {
        return null;
      }
      this._canvasContext = this._canvasContext || this.canvas.getContext('2d');
      return this._canvasContext;
    }
  }]);

  return ImageLoader;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.PureComponent), _class.defaultProps = {
  alt: '',
  width: null,
  height: null
}, _temp2);


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_intl__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_notification__ = __webpack_require__(681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_notification__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectors__ = __webpack_require__(53);







var mapStateToProps = function mapStateToProps(state, _ref) {
  var intl = _ref.intl;

  var notifications = Object(__WEBPACK_IMPORTED_MODULE_5__selectors__["b" /* getAlerts */])(state);

  notifications.forEach(function (notification) {
    return ['title', 'message'].forEach(function (key) {
      var value = notification[key];

      if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object') {
        notification[key] = intl.formatMessage(value);
      }
    });
  });

  return { notifications: notifications };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    onDismiss: function onDismiss(alert) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__actions_alerts__["d" /* dismissAlert */])(alert));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_intl__["g" /* injectIntl */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3_react_notification__["NotificationStack"])));

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _defaultPropTypes = __webpack_require__(250);

var _defaultPropTypes2 = _interopRequireDefault(_defaultPropTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Notification = function (_Component) {
  _inherits(Notification, _Component);

  function Notification(props) {
    _classCallCheck(this, Notification);

    var _this = _possibleConstructorReturn(this, (Notification.__proto__ || Object.getPrototypeOf(Notification)).call(this, props));

    _this.getBarStyle = _this.getBarStyle.bind(_this);
    _this.getActionStyle = _this.getActionStyle.bind(_this);
    _this.getTitleStyle = _this.getTitleStyle.bind(_this);
    _this.handleClick = _this.handleClick.bind(_this);

    if (props.onDismiss && props.isActive) {
      _this.dismissTimeout = setTimeout(props.onDismiss, props.dismissAfter);
    }
    return _this;
  }

  _createClass(Notification, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.dismissAfter === false) return;

      // See http://eslint.org/docs/rules/no-prototype-builtins
      if (!{}.hasOwnProperty.call(nextProps, 'isLast')) {
        clearTimeout(this.dismissTimeout);
      }

      if (nextProps.onDismiss) {
        if (nextProps.isActive && !this.props.isActive || nextProps.dismissAfter && this.props.dismissAfter === false) {
          this.dismissTimeout = setTimeout(nextProps.onDismiss, nextProps.dismissAfter);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.dismissAfter) clearTimeout(this.dismissTimeout);
    }

    /*
    * @description Dynamically get the styles for the bar.
    * @returns {object} result The style.
    */

  }, {
    key: 'getBarStyle',
    value: function getBarStyle() {
      if (this.props.style === false) return {};

      var _props = this.props,
          isActive = _props.isActive,
          barStyle = _props.barStyle,
          activeBarStyle = _props.activeBarStyle;

      var baseStyle = {
        position: 'fixed',
        bottom: '2rem',
        left: '-100%',
        width: 'auto',
        padding: '1rem',
        margin: 0,
        color: '#fafafa',
        font: '1rem normal Roboto, sans-serif',
        borderRadius: '5px',
        background: '#212121',
        borderSizing: 'border-box',
        boxShadow: '0 0 1px 1px rgba(10, 10, 11, .125)',
        cursor: 'default',
        WebKitTransition: '.5s cubic-bezier(0.89, 0.01, 0.5, 1.1)',
        MozTransition: '.5s cubic-bezier(0.89, 0.01, 0.5, 1.1)',
        msTransition: '.5s cubic-bezier(0.89, 0.01, 0.5, 1.1)',
        OTransition: '.5s cubic-bezier(0.89, 0.01, 0.5, 1.1)',
        transition: '.5s cubic-bezier(0.89, 0.01, 0.5, 1.1)',
        WebkitTransform: 'translatez(0)',
        MozTransform: 'translatez(0)',
        msTransform: 'translatez(0)',
        OTransform: 'translatez(0)',
        transform: 'translatez(0)'
      };

      return isActive ? _extends({}, baseStyle, { left: '1rem' }, barStyle, activeBarStyle) : _extends({}, baseStyle, barStyle);
    }

    /*
    * @function getActionStyle
    * @description Dynamically get the styles for the action text.
    * @returns {object} result The style.
    */

  }, {
    key: 'getActionStyle',
    value: function getActionStyle() {
      return this.props.style !== false ? _extends({}, {
        padding: '0.125rem',
        marginLeft: '1rem',
        color: '#f44336',
        font: '.75rem normal Roboto, sans-serif',
        lineHeight: '1rem',
        letterSpacing: '.125ex',
        textTransform: 'uppercase',
        borderRadius: '5px',
        cursor: 'pointer'
      }, this.props.actionStyle) : {};
    }

    /*
    * @function getTitleStyle
    * @description Dynamically get the styles for the title.
    * @returns {object} result The style.
    */

  }, {
    key: 'getTitleStyle',
    value: function getTitleStyle() {
      return this.props.style !== false ? _extends({}, {
        fontWeight: '700',
        marginRight: '.5rem'
      }, this.props.titleStyle) : {};
    }

    /*
    * @function handleClick
    * @description Handle click events on the action button.
    */

  }, {
    key: 'handleClick',
    value: function handleClick() {
      if (this.props.onClick && typeof this.props.onClick === 'function') {
        return this.props.onClick();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var className = 'notification-bar';

      if (this.props.isActive) className += ' ' + this.props.activeClassName;
      if (this.props.className) className += ' ' + this.props.className;

      return _react2.default.createElement('div', { className: className, style: this.getBarStyle() }, _react2.default.createElement('div', { className: 'notification-bar-wrapper' }, this.props.title ? _react2.default.createElement('span', {
        className: 'notification-bar-title',
        style: this.getTitleStyle()
      }, this.props.title) : null, _react2.default.createElement('span', { className: 'notification-bar-message' }, this.props.message), this.props.action ? _react2.default.createElement('span', {
        className: 'notification-bar-action',
        onClick: this.handleClick,
        style: this.getActionStyle()
      }, this.props.action) : null));
    }
  }]);

  return Notification;
}(_react.Component);

Notification.propTypes = _defaultPropTypes2.default;

Notification.defaultProps = {
  isActive: false,
  dismissAfter: 2000,
  activeClassName: 'notification-bar-active'
};

exports.default = Notification;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = {
  message: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]).isRequired,
  action: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string, _propTypes2.default.node]),
  onClick: _propTypes2.default.func,
  style: _propTypes2.default.bool,
  actionStyle: _propTypes2.default.object,
  titleStyle: _propTypes2.default.object,
  barStyle: _propTypes2.default.object,
  activeBarStyle: _propTypes2.default.object,
  dismissAfter: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number]),
  onDismiss: _propTypes2.default.func,
  className: _propTypes2.default.string,
  activeClassName: _propTypes2.default.string,
  isActive: _propTypes2.default.bool,
  title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node])
};

/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_loading_bar__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux_loading_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_redux_loading_bar__);



var mapStateToProps = function mapStateToProps(state) {
  return {
    loading: state.get('loadingBar')
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["connect"])(mapStateToProps)(__WEBPACK_IMPORTED_MODULE_1_react_redux_loading_bar___default.a.WrappedComponent));

/***/ }),
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "elephant-fren-7561ce069a5a55b86ebc8789728b8fbc.png";

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "elephant_ui_disappointed-8864342480c3612e3061702851d3a798.svg";

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "elephant_ui_greeting-475430963d0b00fe82b07b17857ebf6c.svg";

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "elephant_ui_working-2e653cc278c2ac871c23aeb10de1c0e2.svg";

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon_cached-108e30d96e1d5152be7fe2978bcdfe14.svg";

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon_done-dba357bfbba455428787fefc655ce120.svg";

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon_email-1346985c7aaceb601b0d4257133254f4.svg";

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon_file_download-4b5c054e76b0df3cbbc851854cd10c3c.svg";

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon_grade-8e81b8e88c2b5834347a2a226c65d440.svg";

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon_lock_open-c9627928caaaa505ac7de2a64bd065ec.svg";

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon_person_add-5c56ef10b9e99e77a44d89041f4b77b5.svg";

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon_reply-b5e28e1fe6acd4ec003e643e947f1c4a.svg";

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo-fe5141d38a25f50068b4c69b77ca1ec8.svg";

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo_alt-6090911445f54a587465e41da77a6969.svg";

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo_full-96e7a97fe469f75a23a74852b2478fa3.svg";

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo_transparent-6900bab180aa3a46c34425e5367a218f.svg";

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon_cached-26ffa26120a2a16a9be78a75cc603793.png";

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon_done-e07ea253e82d137816cfb8d77a3b1562.png";

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon_email-ed5d2a37fa765e4c5fec080a82b0a783.png";

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon_file_download-0b212ed1bca11e1e02539a20b3821d87.png";

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon_grade-1f9e039d0f024626ab071d18098b65a0.png";

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon_lock_open-d377f10d3f005d0d042a1ee1dee8284d.png";

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon_person_add-44d0a8dfa7dce95be5f6e3cfe0cdd133.png";

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "icon_reply-1c00f97d10006dd420bc620b26a79d8a.png";

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo_full-efefe08462ede002abb7fc1e69005cbb.png";

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "logo_transparent-73bf4bea5ad08ce44d516e472dc452c1.png";

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "preview-9a17d32fc48369e8ccd910a75260e67d.jpg";

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "reticle-6490ecbb61185e86e62dca0845cf2dcf.png";

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "void-4c8270c17facce6d53726a2ebb9745f2.png";

/***/ }),
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Permalink; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);






var _class, _temp2;




var Permalink = (_temp2 = _class = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Permalink, _React$PureComponent);

  function Permalink() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Permalink);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.handleClick = function (e) {
      if (_this.props.onInterceptClick && _this.props.onInterceptClick()) {
        e.preventDefault();
        return;
      }

      if (_this.context.router && e.button === 0 && !(e.ctrlKey || e.metaKey)) {
        e.preventDefault();
        _this.context.router.history.push(_this.props.to);
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  Permalink.prototype.render = function render() {
    var _props = this.props,
        href = _props.href,
        children = _props.children,
        className = _props.className,
        onInterceptClick = _props.onInterceptClick,
        other = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['href', 'children', 'className', 'onInterceptClick']);

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
      'a',
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ target: '_blank', href: href, onClick: this.handleClick }, other, { className: 'permalink' + (className ? ' ' + className : '') }),
      children
    );
  };

  return Permalink;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.PureComponent), _class.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
}, _temp2);


/***/ }),
/* 298 */,
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_intl__ = __webpack_require__(7);




var LoadingIndicator = function LoadingIndicator() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
    className: 'loading-indicator'
  }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
    className: 'loading-indicator__figure'
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_2_react_intl__["b" /* FormattedMessage */], {
    id: 'loading_indicator.label',
    defaultMessage: 'Loading...'
  }));
};

/* harmony default export */ __webpack_exports__["a"] = (LoadingIndicator);

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return COLUMN_ADD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return COLUMN_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COLUMN_MOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return COLUMN_PARAMS_CHANGE; });
/* harmony export (immutable) */ __webpack_exports__["e"] = addColumn;
/* harmony export (immutable) */ __webpack_exports__["h"] = removeColumn;
/* harmony export (immutable) */ __webpack_exports__["g"] = moveColumn;
/* harmony export (immutable) */ __webpack_exports__["f"] = changeColumnParams;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__settings__ = __webpack_require__(58);


var COLUMN_ADD = 'COLUMN_ADD';
var COLUMN_REMOVE = 'COLUMN_REMOVE';
var COLUMN_MOVE = 'COLUMN_MOVE';
var COLUMN_PARAMS_CHANGE = 'COLUMN_PARAMS_CHANGE';

function addColumn(id, params) {
  return function (dispatch) {
    dispatch({
      type: COLUMN_ADD,
      id: id,
      params: params
    });

    dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__settings__["d" /* saveSettings */])());
  };
};

function removeColumn(uuid) {
  return function (dispatch) {
    dispatch({
      type: COLUMN_REMOVE,
      uuid: uuid
    });

    dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__settings__["d" /* saveSettings */])());
  };
};

function moveColumn(uuid, direction) {
  return function (dispatch) {
    dispatch({
      type: COLUMN_MOVE,
      uuid: uuid,
      direction: direction
    });

    dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__settings__["d" /* saveSettings */])());
  };
};

function changeColumnParams(uuid, path, value) {
  return function (dispatch) {
    dispatch({
      type: COLUMN_PARAMS_CHANGE,
      uuid: uuid,
      path: path,
      value: value
    });

    dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__settings__["d" /* saveSettings */])());
  };
}

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_dropdown_menu__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_modal__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_dropdown_menu__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__is_mobile__ = __webpack_require__(43);






var mapStateToProps = function mapStateToProps(state) {
  return {
    isModalOpen: state.get('modal').modalType === 'ACTIONS',
    dropdownPlacement: state.getIn(['dropdown_menu', 'placement']),
    openDropdownId: state.getIn(['dropdown_menu', 'openId'])
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref) {
  var status = _ref.status,
      items = _ref.items;
  return {
    onOpen: function onOpen(id, onItemClick, dropdownPlacement) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_4__is_mobile__["c" /* isUserTouching */])() ? Object(__WEBPACK_IMPORTED_MODULE_1__actions_modal__["d" /* openModal */])('ACTIONS', {
        status: status,
        actions: items,
        onClick: onItemClick
      }) : Object(__WEBPACK_IMPORTED_MODULE_0__actions_dropdown_menu__["d" /* openDropdownMenu */])(id, dropdownPlacement));
    },
    onClose: function onClose(id) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__actions_modal__["c" /* closeModal */])());
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions_dropdown_menu__["c" /* closeDropdownMenu */])(id));
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["connect"])(mapStateToProps, mapDispatchToProps)(__WEBPACK_IMPORTED_MODULE_3__components_dropdown_menu__["a" /* default */]));

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AvatarOverlay; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__initial_state__ = __webpack_require__(14);





var _class, _temp;





var AvatarOverlay = (_temp = _class = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AvatarOverlay, _React$PureComponent);

  function AvatarOverlay() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AvatarOverlay);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.apply(this, arguments));
  }

  AvatarOverlay.prototype.render = function render() {
    var _props = this.props,
        account = _props.account,
        friend = _props.friend,
        animate = _props.animate;


    var baseStyle = {
      backgroundImage: 'url(' + account.get(animate ? 'avatar' : 'avatar_static') + ')'
    };

    var overlayStyle = {
      backgroundImage: 'url(' + friend.get(animate ? 'avatar' : 'avatar_static') + ')'
    };

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'account__avatar-overlay'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'account__avatar-overlay-base',
      style: baseStyle
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'account__avatar-overlay-overlay',
      style: overlayStyle
    }));
  };

  return AvatarOverlay;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent), _class.defaultProps = {
  animate: __WEBPACK_IMPORTED_MODULE_5__initial_state__["a" /* autoPlayGif */]
}, _temp);


/***/ }),
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return decode; });
var decode = function decode(base64) {
  var rawData = window.atob(base64);
  var outputArray = new Uint8Array(rawData.length);

  for (var i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
};

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BLOCKS_FETCH_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BLOCKS_FETCH_SUCCESS; });
/* unused harmony export BLOCKS_FETCH_FAIL */
/* unused harmony export BLOCKS_EXPAND_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BLOCKS_EXPAND_SUCCESS; });
/* unused harmony export BLOCKS_EXPAND_FAIL */
/* harmony export (immutable) */ __webpack_exports__["d"] = fetchBlocks;
/* unused harmony export fetchBlocksRequest */
/* unused harmony export fetchBlocksSuccess */
/* unused harmony export fetchBlocksFail */
/* harmony export (immutable) */ __webpack_exports__["c"] = expandBlocks;
/* unused harmony export expandBlocksRequest */
/* unused harmony export expandBlocksSuccess */
/* unused harmony export expandBlocksFail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accounts__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__importer__ = __webpack_require__(15);




var BLOCKS_FETCH_REQUEST = 'BLOCKS_FETCH_REQUEST';
var BLOCKS_FETCH_SUCCESS = 'BLOCKS_FETCH_SUCCESS';
var BLOCKS_FETCH_FAIL = 'BLOCKS_FETCH_FAIL';

var BLOCKS_EXPAND_REQUEST = 'BLOCKS_EXPAND_REQUEST';
var BLOCKS_EXPAND_SUCCESS = 'BLOCKS_EXPAND_SUCCESS';
var BLOCKS_EXPAND_FAIL = 'BLOCKS_EXPAND_FAIL';

function fetchBlocks() {
  return function (dispatch, getState) {
    dispatch(fetchBlocksRequest());

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get('/api/v1/blocks').then(function (response) {
      var next = Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* getLinks */])(response).refs.find(function (link) {
        return link.rel === 'next';
      });
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__importer__["g" /* importFetchedAccounts */])(response.data));
      dispatch(fetchBlocksSuccess(response.data, next ? next.uri : null));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__accounts__["y" /* fetchRelationships */])(response.data.map(function (item) {
        return item.id;
      })));
    }).catch(function (error) {
      return dispatch(fetchBlocksFail(error));
    });
  };
};

function fetchBlocksRequest() {
  return {
    type: BLOCKS_FETCH_REQUEST
  };
};

function fetchBlocksSuccess(accounts, next) {
  return {
    type: BLOCKS_FETCH_SUCCESS,
    accounts: accounts,
    next: next
  };
};

function fetchBlocksFail(error) {
  return {
    type: BLOCKS_FETCH_FAIL,
    error: error
  };
};

function expandBlocks() {
  return function (dispatch, getState) {
    var url = getState().getIn(['user_lists', 'blocks', 'next']);

    if (url === null) {
      return;
    }

    dispatch(expandBlocksRequest());

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get(url).then(function (response) {
      var next = Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* getLinks */])(response).refs.find(function (link) {
        return link.rel === 'next';
      });
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__importer__["g" /* importFetchedAccounts */])(response.data));
      dispatch(expandBlocksSuccess(response.data, next ? next.uri : null));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__accounts__["y" /* fetchRelationships */])(response.data.map(function (item) {
        return item.id;
      })));
    }).catch(function (error) {
      return dispatch(expandBlocksFail(error));
    });
  };
};

function expandBlocksRequest() {
  return {
    type: BLOCKS_EXPAND_REQUEST
  };
};

function expandBlocksSuccess(accounts, next) {
  return {
    type: BLOCKS_EXPAND_SUCCESS,
    accounts: accounts,
    next: next
  };
};

function expandBlocksFail(error) {
  return {
    type: BLOCKS_EXPAND_FAIL,
    error: error
  };
};

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return FAVOURITED_STATUSES_FETCH_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return FAVOURITED_STATUSES_FETCH_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FAVOURITED_STATUSES_FETCH_FAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return FAVOURITED_STATUSES_EXPAND_REQUEST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FAVOURITED_STATUSES_EXPAND_SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FAVOURITED_STATUSES_EXPAND_FAIL; });
/* harmony export (immutable) */ __webpack_exports__["h"] = fetchFavouritedStatuses;
/* unused harmony export fetchFavouritedStatusesRequest */
/* unused harmony export fetchFavouritedStatusesSuccess */
/* unused harmony export fetchFavouritedStatusesFail */
/* harmony export (immutable) */ __webpack_exports__["g"] = expandFavouritedStatuses;
/* unused harmony export expandFavouritedStatusesRequest */
/* unused harmony export expandFavouritedStatusesSuccess */
/* unused harmony export expandFavouritedStatusesFail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__importer__ = __webpack_require__(15);



var FAVOURITED_STATUSES_FETCH_REQUEST = 'FAVOURITED_STATUSES_FETCH_REQUEST';
var FAVOURITED_STATUSES_FETCH_SUCCESS = 'FAVOURITED_STATUSES_FETCH_SUCCESS';
var FAVOURITED_STATUSES_FETCH_FAIL = 'FAVOURITED_STATUSES_FETCH_FAIL';

var FAVOURITED_STATUSES_EXPAND_REQUEST = 'FAVOURITED_STATUSES_EXPAND_REQUEST';
var FAVOURITED_STATUSES_EXPAND_SUCCESS = 'FAVOURITED_STATUSES_EXPAND_SUCCESS';
var FAVOURITED_STATUSES_EXPAND_FAIL = 'FAVOURITED_STATUSES_EXPAND_FAIL';

function fetchFavouritedStatuses() {
  return function (dispatch, getState) {
    if (getState().getIn(['status_lists', 'favourites', 'isLoading'])) {
      return;
    }

    dispatch(fetchFavouritedStatusesRequest());

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get('/api/v1/favourites').then(function (response) {
      var next = Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* getLinks */])(response).refs.find(function (link) {
        return link.rel === 'next';
      });
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__importer__["i" /* importFetchedStatuses */])(response.data));
      dispatch(fetchFavouritedStatusesSuccess(response.data, next ? next.uri : null));
    }).catch(function (error) {
      dispatch(fetchFavouritedStatusesFail(error));
    });
  };
};

function fetchFavouritedStatusesRequest() {
  return {
    type: FAVOURITED_STATUSES_FETCH_REQUEST
  };
};

function fetchFavouritedStatusesSuccess(statuses, next) {
  return {
    type: FAVOURITED_STATUSES_FETCH_SUCCESS,
    statuses: statuses,
    next: next
  };
};

function fetchFavouritedStatusesFail(error) {
  return {
    type: FAVOURITED_STATUSES_FETCH_FAIL,
    error: error
  };
};

function expandFavouritedStatuses() {
  return function (dispatch, getState) {
    var url = getState().getIn(['status_lists', 'favourites', 'next'], null);

    if (url === null || getState().getIn(['status_lists', 'favourites', 'isLoading'])) {
      return;
    }

    dispatch(expandFavouritedStatusesRequest());

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get(url).then(function (response) {
      var next = Object(__WEBPACK_IMPORTED_MODULE_0__api__["b" /* getLinks */])(response).refs.find(function (link) {
        return link.rel === 'next';
      });
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__importer__["i" /* importFetchedStatuses */])(response.data));
      dispatch(expandFavouritedStatusesSuccess(response.data, next ? next.uri : null));
    }).catch(function (error) {
      dispatch(expandFavouritedStatusesFail(error));
    });
  };
};

function expandFavouritedStatusesRequest() {
  return {
    type: FAVOURITED_STATUSES_EXPAND_REQUEST
  };
};

function expandFavouritedStatusesSuccess(statuses, next) {
  return {
    type: FAVOURITED_STATUSES_EXPAND_SUCCESS,
    statuses: statuses,
    next: next
  };
};

function expandFavouritedStatusesFail(error) {
  return {
    type: FAVOURITED_STATUSES_EXPAND_FAIL,
    error: error
  };
};

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PINNED_STATUSES_FETCH_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PINNED_STATUSES_FETCH_SUCCESS; });
/* unused harmony export PINNED_STATUSES_FETCH_FAIL */
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchPinnedStatuses;
/* unused harmony export fetchPinnedStatusesRequest */
/* unused harmony export fetchPinnedStatusesSuccess */
/* unused harmony export fetchPinnedStatusesFail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__importer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__initial_state__ = __webpack_require__(14);



var PINNED_STATUSES_FETCH_REQUEST = 'PINNED_STATUSES_FETCH_REQUEST';
var PINNED_STATUSES_FETCH_SUCCESS = 'PINNED_STATUSES_FETCH_SUCCESS';
var PINNED_STATUSES_FETCH_FAIL = 'PINNED_STATUSES_FETCH_FAIL';



function fetchPinnedStatuses() {
  return function (dispatch, getState) {
    dispatch(fetchPinnedStatusesRequest());

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get('/api/v1/accounts/' + __WEBPACK_IMPORTED_MODULE_2__initial_state__["g" /* me */] + '/statuses', { params: { pinned: true } }).then(function (response) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__importer__["i" /* importFetchedStatuses */])(response.data));
      dispatch(fetchPinnedStatusesSuccess(response.data, null));
    }).catch(function (error) {
      dispatch(fetchPinnedStatusesFail(error));
    });
  };
};

function fetchPinnedStatusesRequest() {
  return {
    type: PINNED_STATUSES_FETCH_REQUEST
  };
};

function fetchPinnedStatusesSuccess(statuses, next) {
  return {
    type: PINNED_STATUSES_FETCH_SUCCESS,
    statuses: statuses,
    next: next
  };
};

function fetchPinnedStatusesFail(error) {
  return {
    type: PINNED_STATUSES_FETCH_FAIL,
    error: error
  };
};

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SEARCH_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SEARCH_CLEAR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SEARCH_SHOW; });
/* unused harmony export SEARCH_FETCH_REQUEST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SEARCH_FETCH_SUCCESS; });
/* unused harmony export SEARCH_FETCH_FAIL */
/* harmony export (immutable) */ __webpack_exports__["e"] = changeSearch;
/* harmony export (immutable) */ __webpack_exports__["f"] = clearSearch;
/* harmony export (immutable) */ __webpack_exports__["h"] = submitSearch;
/* unused harmony export fetchSearchRequest */
/* unused harmony export fetchSearchSuccess */
/* unused harmony export fetchSearchFail */
/* harmony export (immutable) */ __webpack_exports__["g"] = showSearch;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__accounts__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__importer__ = __webpack_require__(15);




var SEARCH_CHANGE = 'SEARCH_CHANGE';
var SEARCH_CLEAR = 'SEARCH_CLEAR';
var SEARCH_SHOW = 'SEARCH_SHOW';

var SEARCH_FETCH_REQUEST = 'SEARCH_FETCH_REQUEST';
var SEARCH_FETCH_SUCCESS = 'SEARCH_FETCH_SUCCESS';
var SEARCH_FETCH_FAIL = 'SEARCH_FETCH_FAIL';

function changeSearch(value) {
  return {
    type: SEARCH_CHANGE,
    value: value
  };
};

function clearSearch() {
  return {
    type: SEARCH_CLEAR
  };
};

function submitSearch() {
  return function (dispatch, getState) {
    var value = getState().getIn(['search', 'value']);

    if (value.length === 0) {
      return;
    }

    dispatch(fetchSearchRequest());

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])(getState).get('/api/v2/search', {
      params: {
        q: value,
        resolve: true
      }
    }).then(function (response) {
      if (response.data.accounts) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__importer__["g" /* importFetchedAccounts */])(response.data.accounts));
      }

      if (response.data.statuses) {
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_2__importer__["i" /* importFetchedStatuses */])(response.data.statuses));
      }

      dispatch(fetchSearchSuccess(response.data));
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_1__accounts__["y" /* fetchRelationships */])(response.data.accounts.map(function (item) {
        return item.id;
      })));
    }).catch(function (error) {
      dispatch(fetchSearchFail(error));
    });
  };
};

function fetchSearchRequest() {
  return {
    type: SEARCH_FETCH_REQUEST
  };
};

function fetchSearchSuccess(results) {
  return {
    type: SEARCH_FETCH_SUCCESS,
    results: results
  };
};

function fetchSearchFail(error) {
  return {
    type: SEARCH_FETCH_FAIL,
    error: error
  };
};

function showSearch() {
  return {
    type: SEARCH_SHOW
  };
};

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AttachmentList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_immutable_pure_component__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_immutable_pure_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_immutable_pure_component__);





var _class, _temp;






var filename = function filename(url) {
  return url.split('/').pop().split('#')[0].split('?')[0];
};

var AttachmentList = (_temp = _class = function (_ImmutablePureCompone) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AttachmentList, _ImmutablePureCompone);

  function AttachmentList() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AttachmentList);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _ImmutablePureCompone.apply(this, arguments));
  }

  AttachmentList.prototype.render = function render() {
    var _props = this.props,
        media = _props.media,
        compact = _props.compact;


    if (compact) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
        className: 'attachment-list compact'
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('ul', {
        className: 'attachment-list__list'
      }, void 0, media.map(function (attachment) {
        var displayUrl = attachment.get('remote_url') || attachment.get('url');

        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('li', {}, attachment.get('id'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('a', {
          href: displayUrl,
          target: '_blank',
          rel: 'noopener'
        }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
          className: 'fa fa-link'
        }), ' ', filename(displayUrl)));
      })));
    }

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'attachment-list'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'attachment-list__icon'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
      className: 'fa fa-link'
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('ul', {
      className: 'attachment-list__list'
    }, void 0, media.map(function (attachment) {
      var displayUrl = attachment.get('remote_url') || attachment.get('url');

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('li', {}, attachment.get('id'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('a', {
        href: displayUrl,
        target: '_blank',
        rel: 'noopener'
      }, void 0, filename(displayUrl)));
    })));
  };

  return AttachmentList;
}(__WEBPACK_IMPORTED_MODULE_7_react_immutable_pure_component___default.a), _class.propTypes = {
  media: __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.list.isRequired,
  compact: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
}, _temp);


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(38);
var core = __webpack_require__(24);
var fails = __webpack_require__(46);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () {
    fn(1);
  }), 'Object', exp);
};

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalRoot; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var ModalRoot = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ModalRoot, _React$PureComponent);

  function ModalRoot() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ModalRoot);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
      revealed: !!_this.props.children
    }, _this.activeElement = _this.state.revealed ? document.activeElement : null, _this.handleKeyUp = function (e) {
      if ((e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27) && !!_this.props.children) {
        _this.props.onClose();
      }
    }, _this.getSiblings = function () {
      return Array.apply(undefined, _this.node.parentElement.childNodes).filter(function (node) {
        return node !== _this.node;
      });
    }, _this.setRef = function (ref) {
      _this.node = ref;
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  ModalRoot.prototype.componentDidMount = function componentDidMount() {
    window.addEventListener('keyup', this.handleKeyUp, false);
  };

  ModalRoot.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!!nextProps.children && !this.props.children) {
      this.activeElement = document.activeElement;

      this.getSiblings().forEach(function (sibling) {
        return sibling.setAttribute('inert', true);
      });
    } else if (!nextProps.children) {
      this.setState({ revealed: false });
    }
  };

  ModalRoot.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    if (!this.props.children && !!prevProps.children) {
      this.getSiblings().forEach(function (sibling) {
        return sibling.removeAttribute('inert');
      });
      this.activeElement.focus();
      this.activeElement = null;
    }
    if (this.props.children) {
      requestAnimationFrame(function () {
        _this2.setState({ revealed: true });
      });
    }
  };

  ModalRoot.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('keyup', this.handleKeyUp);
  };

  ModalRoot.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        onClose = _props.onClose;
    var revealed = this.state.revealed;

    var visible = !!children;

    if (!visible) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', { className: 'modal-root', ref: this.setRef, style: { opacity: 0 } });
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      { className: 'modal-root', ref: this.setRef, style: { opacity: revealed ? 1 : 0 } },
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
        style: { pointerEvents: visible ? 'auto' : 'none' }
      }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
        role: 'presentation',
        className: 'modal-root__overlay',
        onClick: onClose
      }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
        role: 'dialog',
        className: 'modal-root__container'
      }, void 0, children))
    );
  };

  return ModalRoot;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent);



/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MediaModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_swipeable_views__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_swipeable_views___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_swipeable_views__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_immutable_proptypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__video__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_extended_video_player__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_intl__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_icon_button__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_immutable_pure_component__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_immutable_pure_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_immutable_pure_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__image_loader__ = __webpack_require__(247);





var _class, _class2, _temp2;













var messages = Object(__WEBPACK_IMPORTED_MODULE_11_react_intl__["f" /* defineMessages */])({
  close: {
    'id': 'lightbox.close',
    'defaultMessage': 'Close'
  },
  previous: {
    'id': 'lightbox.previous',
    'defaultMessage': 'Previous'
  },
  next: {
    'id': 'lightbox.next',
    'defaultMessage': 'Next'
  }
});

var previewState = 'previewMediaModal';

var MediaModal = Object(__WEBPACK_IMPORTED_MODULE_11_react_intl__["g" /* injectIntl */])(_class = (_temp2 = _class2 = function (_ImmutablePureCompone) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(MediaModal, _ImmutablePureCompone);

  function MediaModal() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MediaModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _ImmutablePureCompone.call.apply(_ImmutablePureCompone, [this].concat(args))), _this), _this.state = {
      index: null,
      navigationHidden: false
    }, _this.handleSwipe = function (index) {
      _this.setState({ index: index % _this.props.media.size });
    }, _this.handleNextClick = function () {
      _this.setState({ index: (_this.getIndex() + 1) % _this.props.media.size });
    }, _this.handlePrevClick = function () {
      _this.setState({ index: (_this.props.media.size + _this.getIndex() - 1) % _this.props.media.size });
    }, _this.handleChangeIndex = function (e) {
      var index = Number(e.currentTarget.getAttribute('data-index'));
      _this.setState({ index: index % _this.props.media.size });
    }, _this.handleKeyUp = function (e) {
      switch (e.key) {
        case 'ArrowLeft':
          _this.handlePrevClick();
          break;
        case 'ArrowRight':
          _this.handleNextClick();
          break;
      }
    }, _this.toggleNavigation = function () {
      _this.setState(function (prevState) {
        return {
          navigationHidden: !prevState.navigationHidden
        };
      });
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  MediaModal.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    window.addEventListener('keyup', this.handleKeyUp, false);
    if (this.context.router) {
      var history = this.context.router.history;
      history.push(history.location.pathname, previewState);
      this.unlistenHistory = history.listen(function () {
        _this2.props.onClose();
      });
    }
  };

  MediaModal.prototype.componentWillUnmount = function componentWillUnmount() {
    window.removeEventListener('keyup', this.handleKeyUp);
    if (this.context.router) {
      this.unlistenHistory();

      if (this.context.router.history.location.state === previewState) {
        this.context.router.history.goBack();
      }
    }
  };

  MediaModal.prototype.getIndex = function getIndex() {
    return this.state.index !== null ? this.state.index : this.props.index;
  };

  MediaModal.prototype.render = function render() {
    var _this3 = this;

    var _props = this.props,
        media = _props.media,
        intl = _props.intl,
        onClose = _props.onClose;
    var navigationHidden = this.state.navigationHidden;


    var index = this.getIndex();
    var pagination = [];

    var leftNav = media.size > 1 && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
      tabIndex: '0',
      className: 'media-modal__nav media-modal__nav--left',
      onClick: this.handlePrevClick,
      'aria-label': intl.formatMessage(messages.previous)
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
      className: 'fa fa-fw fa-chevron-left'
    }));
    var rightNav = media.size > 1 && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
      tabIndex: '0',
      className: 'media-modal__nav  media-modal__nav--right',
      onClick: this.handleNextClick,
      'aria-label': intl.formatMessage(messages.next)
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
      className: 'fa fa-fw fa-chevron-right'
    }));

    if (media.size > 1) {
      pagination = media.map(function (item, i) {
        var classes = ['media-modal__button'];
        if (i === index) {
          classes.push('media-modal__button--active');
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('li', {
          className: 'media-modal__page-dot'
        }, i, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
          tabIndex: '0',
          className: classes.join(' '),
          onClick: _this3.handleChangeIndex,
          'data-index': i
        }, void 0, i + 1));
      });
    }

    var content = media.map(function (image) {
      var width = image.getIn(['meta', 'original', 'width']) || null;
      var height = image.getIn(['meta', 'original', 'height']) || null;

      if (image.get('type') === 'image') {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_14__image_loader__["a" /* default */], {
          previewSrc: image.get('preview_url'),
          src: image.get('url'),
          width: width,
          height: height,
          alt: image.get('description'),
          onClick: _this3.toggleNavigation
        }, image.get('url'));
      } else if (image.get('type') === 'video') {
        var time = _this3.props.time;


        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8__video__["default"], {
          preview: image.get('preview_url'),
          src: image.get('url'),
          width: image.get('width'),
          height: image.get('height'),
          startTime: time || 0,
          onCloseVideo: onClose,
          detailed: true,
          description: image.get('description')
        }, image.get('url'));
      } else if (image.get('type') === 'gifv') {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__components_extended_video_player__["a" /* default */], {
          src: image.get('url'),
          muted: true,
          controls: false,
          width: width,
          height: height,
          alt: image.get('description'),
          onClick: _this3.toggleNavigation
        }, image.get('preview_url'));
      }

      return null;
    }).toArray();

    // you can't use 100vh, because the viewport height is taller
    // than the visible part of the document in some mobile
    // browsers when it's address bar is visible.
    // https://developers.google.com/web/updates/2016/12/url-bar-resizing
    var swipeableViewsStyle = {
      width: '100%',
      height: '100%'
    };

    var containerStyle = {
      alignItems: 'center' // center vertically
    };

    var navigationClassName = __WEBPACK_IMPORTED_MODULE_10_classnames___default()('media-modal__navigation', {
      'media-modal__navigation--hidden': navigationHidden
    });

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'modal-root__modal media-modal'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'media-modal__closer',
      role: 'presentation',
      onClick: onClose
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_5_react_swipeable_views___default.a, {
      style: swipeableViewsStyle,
      containerStyle: containerStyle,
      onChangeIndex: this.handleSwipe,
      onSwitching: this.handleSwitching,
      index: index
    }, void 0, content)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: navigationClassName
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__components_icon_button__["a" /* default */], {
      className: 'media-modal__close',
      title: intl.formatMessage(messages.close),
      icon: 'times',
      onClick: onClose,
      size: 40
    }), leftNav, rightNav, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('ul', {
      className: 'media-modal__pagination'
    }, void 0, pagination)));
  };

  return MediaModal;
}(__WEBPACK_IMPORTED_MODULE_13_react_immutable_pure_component___default.a), _class2.propTypes = {
  media: __WEBPACK_IMPORTED_MODULE_6_react_immutable_proptypes___default.a.list.isRequired,
  index: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number.isRequired,
  onClose: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired
}, _class2.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object
}, _temp2)) || _class;



/***/ }),
/* 341 */,
/* 342 */,
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(344), __esModule: true };

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(168);
module.exports = __webpack_require__(24).Symbol['for'];

/***/ }),
/* 345 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(80)('meta');
var isObject = __webpack_require__(62);
var has = __webpack_require__(36);
var setDesc = __webpack_require__(39).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(46)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
      i: 'O' + ++id, // object ID
      w: {} // weak collections IDs
    } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
    // return object ID
  }return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
    // return hash weak collections IDs
  }return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(76);
var gOPS = __webpack_require__(119);
var pIE = __webpack_require__(81);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  }return result;
};

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(49);
var toLength = __webpack_require__(349);
var toAbsoluteIndex = __webpack_require__(350);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
      // Array#indexOf ignores holes, Array#includes - not
    } else for (; length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    }return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(116);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(116);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(175);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(39);
var anObject = __webpack_require__(61);
var getKeys = __webpack_require__(76);

module.exports = __webpack_require__(37) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(30).document;
module.exports = document && document.documentElement;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(49);
var gOPN = __webpack_require__(176).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(168);
__webpack_require__(356);
__webpack_require__(357);
__webpack_require__(358);
module.exports = __webpack_require__(24).Symbol;

/***/ }),
/* 356 */
/***/ (function(module, exports) {



/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(113)('asyncIterator');

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(113)('observable');

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(360), __esModule: true };

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(361);
__webpack_require__(364);
module.exports = __webpack_require__(112).f('iterator');

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $at = __webpack_require__(362)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(179)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0; // next index
  // 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(116);
var defined = __webpack_require__(115);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var create = __webpack_require__(120);
var descriptor = __webpack_require__(79);
var setToStringTag = __webpack_require__(111);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(47)(IteratorPrototype, __webpack_require__(48)('iterator'), function () {
  return this;
});

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(365);
var global = __webpack_require__(30);
var hide = __webpack_require__(47);
var Iterators = __webpack_require__(121);
var TO_STRING_TAG = __webpack_require__(48)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' + 'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' + 'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' + 'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' + 'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var addToUnscopables = __webpack_require__(366);
var step = __webpack_require__(367);
var Iterators = __webpack_require__(121);
var toIObject = __webpack_require__(49);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(179)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0; // next index
  this._k = kind; // kind
  // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 366 */
/***/ (function(module, exports) {

module.exports = function () {/* empty */};

/***/ }),
/* 367 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(369), __esModule: true };

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(370);
module.exports = __webpack_require__(24).Object.setPrototypeOf;

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(38);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(371).set });

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(62);
var anObject = __webpack_require__(61);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
  function (test, buggy, set) {
    try {
      set = __webpack_require__(169)(Function.call, __webpack_require__(177).f(Object.prototype, '__proto__').set, 2);
      set(test, []);
      buggy = !(test instanceof Array);
    } catch (e) {
      buggy = true;
    }
    return function setPrototypeOf(O, proto) {
      check(O, proto);
      if (buggy) O.__proto__ = proto;else set(O, proto);
      return O;
    };
  }({}, false) : undefined),
  check: check
};

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(373), __esModule: true };

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(374);
var $Object = __webpack_require__(24).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(38);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(120) });

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var m = __webpack_require__(105),
    n = __webpack_require__(82),
    p = __webpack_require__(122),
    q = __webpack_require__(123),
    r = "function" === typeof Symbol && Symbol["for"],
    t = r ? Symbol["for"]("react.element") : 60103,
    u = r ? Symbol["for"]("react.portal") : 60106,
    v = r ? Symbol["for"]("react.fragment") : 60107,
    w = r ? Symbol["for"]("react.strict_mode") : 60108,
    x = r ? Symbol["for"]("react.provider") : 60109,
    y = r ? Symbol["for"]("react.context") : 60110,
    z = r ? Symbol["for"]("react.async_mode") : 60111,
    A = r ? Symbol["for"]("react.forward_ref") : 60112,
    B = "function" === typeof Symbol && Symbol.iterator;function C(a) {
  for (var b = arguments.length - 1, e = "http://reactjs.org/docs/error-decoder.html?invariant\x3d" + a, c = 0; c < b; c++) e += "\x26args[]\x3d" + encodeURIComponent(arguments[c + 1]);n(!1, "Minified React error #" + a + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", e);
}var D = { isMounted: function () {
    return !1;
  }, enqueueForceUpdate: function () {}, enqueueReplaceState: function () {}, enqueueSetState: function () {} };
function E(a, b, e) {
  this.props = a;this.context = b;this.refs = p;this.updater = e || D;
}E.prototype.isReactComponent = {};E.prototype.setState = function (a, b) {
  "object" !== typeof a && "function" !== typeof a && null != a ? C("85") : void 0;this.updater.enqueueSetState(this, a, b, "setState");
};E.prototype.forceUpdate = function (a) {
  this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};function F() {}F.prototype = E.prototype;function G(a, b, e) {
  this.props = a;this.context = b;this.refs = p;this.updater = e || D;
}var H = G.prototype = new F();
H.constructor = G;m(H, E.prototype);H.isPureReactComponent = !0;var I = { current: null },
    J = Object.prototype.hasOwnProperty,
    K = { key: !0, ref: !0, __self: !0, __source: !0 };
function L(a, b, e) {
  var c = void 0,
      d = {},
      g = null,
      h = null;if (null != b) for (c in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (g = "" + b.key), b) J.call(b, c) && !K.hasOwnProperty(c) && (d[c] = b[c]);var f = arguments.length - 2;if (1 === f) d.children = e;else if (1 < f) {
    for (var k = Array(f), l = 0; l < f; l++) k[l] = arguments[l + 2];d.children = k;
  }if (a && a.defaultProps) for (c in f = a.defaultProps, f) void 0 === d[c] && (d[c] = f[c]);return { $$typeof: t, type: a, key: g, ref: h, props: d, _owner: I.current };
}
function M(a) {
  return "object" === typeof a && null !== a && a.$$typeof === t;
}function escape(a) {
  var b = { "\x3d": "\x3d0", ":": "\x3d2" };return "$" + ("" + a).replace(/[=:]/g, function (a) {
    return b[a];
  });
}var N = /\/+/g,
    O = [];function P(a, b, e, c) {
  if (O.length) {
    var d = O.pop();d.result = a;d.keyPrefix = b;d.func = e;d.context = c;d.count = 0;return d;
  }return { result: a, keyPrefix: b, func: e, context: c, count: 0 };
}function Q(a) {
  a.result = null;a.keyPrefix = null;a.func = null;a.context = null;a.count = 0;10 > O.length && O.push(a);
}
function R(a, b, e, c) {
  var d = typeof a;if ("undefined" === d || "boolean" === d) a = null;var g = !1;if (null === a) g = !0;else switch (d) {case "string":case "number":
      g = !0;break;case "object":
      switch (a.$$typeof) {case t:case u:
          g = !0;}}if (g) return e(c, a, "" === b ? "." + S(a, 0) : b), 1;g = 0;b = "" === b ? "." : b + ":";if (Array.isArray(a)) for (var h = 0; h < a.length; h++) {
    d = a[h];var f = b + S(d, h);g += R(d, f, e, c);
  } else if (null === a || "undefined" === typeof a ? f = null : (f = B && a[B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for (a = f.call(a), h = 0; !(d = a.next()).done;) d = d.value, f = b + S(d, h++), g += R(d, f, e, c);else "object" === d && (e = "" + a, C("31", "[object Object]" === e ? "object with keys {" + Object.keys(a).join(", ") + "}" : e, ""));return g;
}function S(a, b) {
  return "object" === typeof a && null !== a && null != a.key ? escape(a.key) : b.toString(36);
}function T(a, b) {
  a.func.call(a.context, b, a.count++);
}
function U(a, b, e) {
  var c = a.result,
      d = a.keyPrefix;a = a.func.call(a.context, b, a.count++);Array.isArray(a) ? V(a, c, e, q.thatReturnsArgument) : null != a && (M(a) && (b = d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace(N, "$\x26/") + "/") + e, a = { $$typeof: t, type: a.type, key: b, ref: a.ref, props: a.props, _owner: a._owner }), c.push(a));
}function V(a, b, e, c, d) {
  var g = "";null != e && (g = ("" + e).replace(N, "$\x26/") + "/");b = P(b, g, c, d);null == a || R(a, "", U, b);Q(b);
}
var W = { Children: { map: function (a, b, e) {
      if (null == a) return a;var c = [];V(a, c, null, b, e);return c;
    }, forEach: function (a, b, e) {
      if (null == a) return a;b = P(null, null, b, e);null == a || R(a, "", T, b);Q(b);
    }, count: function (a) {
      return null == a ? 0 : R(a, "", q.thatReturnsNull, null);
    }, toArray: function (a) {
      var b = [];V(a, b, null, q.thatReturnsArgument);return b;
    }, only: function (a) {
      M(a) ? void 0 : C("143");return a;
    } }, createRef: function () {
    return { current: null };
  }, Component: E, PureComponent: G, createContext: function (a, b) {
    void 0 === b && (b = null);a = { $$typeof: y,
      _calculateChangedBits: b, _defaultValue: a, _currentValue: a, _changedBits: 0, Provider: null, Consumer: null };a.Provider = { $$typeof: x, _context: a };return a.Consumer = a;
  }, forwardRef: function (a) {
    return { $$typeof: A, render: a };
  }, Fragment: v, StrictMode: w, unstable_AsyncMode: z, createElement: L, cloneElement: function (a, b, e) {
    null === a || void 0 === a ? C("267", a) : void 0;var c = void 0,
        d = m({}, a.props),
        g = a.key,
        h = a.ref,
        f = a._owner;if (null != b) {
      void 0 !== b.ref && (h = b.ref, f = I.current);void 0 !== b.key && (g = "" + b.key);var k = void 0;a.type && a.type.defaultProps && (k = a.type.defaultProps);for (c in b) J.call(b, c) && !K.hasOwnProperty(c) && (d[c] = void 0 === b[c] && void 0 !== k ? k[c] : b[c]);
    }c = arguments.length - 2;if (1 === c) d.children = e;else if (1 < c) {
      k = Array(c);for (var l = 0; l < c; l++) k[l] = arguments[l + 2];d.children = k;
    }return { $$typeof: t, type: a.type, key: g, ref: h, props: d, _owner: f };
  }, createFactory: function (a) {
    var b = L.bind(null, a);b.type = a;return b;
  }, isValidElement: M, version: "16.3.2", __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: { ReactCurrentOwner: I, assign: m } },
    X = Object.freeze({ default: W }),
    Y = X && W || X;module.exports = Y["default"] ? Y["default"] : Y;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.3.2
 * react-dom.production.min.js
 *
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/

var ba = __webpack_require__(82),
    ea = __webpack_require__(0),
    m = __webpack_require__(377),
    A = __webpack_require__(105),
    C = __webpack_require__(123),
    fa = __webpack_require__(378),
    ha = __webpack_require__(379),
    ja = __webpack_require__(380),
    ka = __webpack_require__(122);
function D(a) {
  for (var b = arguments.length - 1, c = "http://reactjs.org/docs/error-decoder.html?invariant\x3d" + a, d = 0; d < b; d++) c += "\x26args[]\x3d" + encodeURIComponent(arguments[d + 1]);ba(!1, "Minified React error #" + a + "; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ", c);
}ea ? void 0 : D("227");
function ma(a, b, c, d, e, f, h, g, k) {
  this._hasCaughtError = !1;this._caughtError = null;var v = Array.prototype.slice.call(arguments, 3);try {
    b.apply(c, v);
  } catch (l) {
    this._caughtError = l, this._hasCaughtError = !0;
  }
}
var E = { _caughtError: null, _hasCaughtError: !1, _rethrowError: null, _hasRethrowError: !1, invokeGuardedCallback: function (a, b, c, d, e, f, h, g, k) {
    ma.apply(E, arguments);
  }, invokeGuardedCallbackAndCatchFirstError: function (a, b, c, d, e, f, h, g, k) {
    E.invokeGuardedCallback.apply(this, arguments);if (E.hasCaughtError()) {
      var v = E.clearCaughtError();E._hasRethrowError || (E._hasRethrowError = !0, E._rethrowError = v);
    }
  }, rethrowCaughtError: function () {
    return na.apply(E, arguments);
  }, hasCaughtError: function () {
    return E._hasCaughtError;
  }, clearCaughtError: function () {
    if (E._hasCaughtError) {
      var a = E._caughtError;E._caughtError = null;E._hasCaughtError = !1;return a;
    }D("198");
  } };function na() {
  if (E._hasRethrowError) {
    var a = E._rethrowError;E._rethrowError = null;E._hasRethrowError = !1;throw a;
  }
}var oa = null,
    pa = {};
function qa() {
  if (oa) for (var a in pa) {
    var b = pa[a],
        c = oa.indexOf(a);-1 < c ? void 0 : D("96", a);if (!ra[c]) {
      b.extractEvents ? void 0 : D("97", a);ra[c] = b;c = b.eventTypes;for (var d in c) {
        var e = void 0;var f = c[d],
            h = b,
            g = d;sa.hasOwnProperty(g) ? D("99", g) : void 0;sa[g] = f;var k = f.phasedRegistrationNames;if (k) {
          for (e in k) k.hasOwnProperty(e) && ta(k[e], h, g);e = !0;
        } else f.registrationName ? (ta(f.registrationName, h, g), e = !0) : e = !1;e ? void 0 : D("98", d, a);
      }
    }
  }
}
function ta(a, b, c) {
  ua[a] ? D("100", a) : void 0;ua[a] = b;va[a] = b.eventTypes[c].dependencies;
}var ra = [],
    sa = {},
    ua = {},
    va = {};function wa(a) {
  oa ? D("101") : void 0;oa = Array.prototype.slice.call(a);qa();
}function xa(a) {
  var b = !1,
      c;for (c in a) if (a.hasOwnProperty(c)) {
    var d = a[c];pa.hasOwnProperty(c) && pa[c] === d || (pa[c] ? D("102", c) : void 0, pa[c] = d, b = !0);
  }b && qa();
}
var Ca = Object.freeze({ plugins: ra, eventNameDispatchConfigs: sa, registrationNameModules: ua, registrationNameDependencies: va, possibleRegistrationNames: null, injectEventPluginOrder: wa, injectEventPluginsByName: xa }),
    Da = null,
    Ea = null,
    Fa = null;function Ga(a, b, c, d) {
  b = a.type || "unknown-event";a.currentTarget = Fa(d);E.invokeGuardedCallbackAndCatchFirstError(b, c, void 0, a);a.currentTarget = null;
}
function Ha(a, b) {
  null == b ? D("30") : void 0;if (null == a) return b;if (Array.isArray(a)) {
    if (Array.isArray(b)) return a.push.apply(a, b), a;a.push(b);return a;
  }return Array.isArray(b) ? [a].concat(b) : [a, b];
}function Ia(a, b, c) {
  Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}var Ja = null;
function Ka(a, b) {
  if (a) {
    var c = a._dispatchListeners,
        d = a._dispatchInstances;if (Array.isArray(c)) for (var e = 0; e < c.length && !a.isPropagationStopped(); e++) Ga(a, b, c[e], d[e]);else c && Ga(a, b, c, d);a._dispatchListeners = null;a._dispatchInstances = null;a.isPersistent() || a.constructor.release(a);
  }
}function La(a) {
  return Ka(a, !0);
}function Ma(a) {
  return Ka(a, !1);
}var Na = { injectEventPluginOrder: wa, injectEventPluginsByName: xa };
function Oa(a, b) {
  var c = a.stateNode;if (!c) return null;var d = Da(c);if (!d) return null;c = d[b];a: switch (b) {case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":
      (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));a = !d;break a;default:
      a = !1;}if (a) return null;c && "function" !== typeof c ? D("231", b, typeof c) : void 0;
  return c;
}function Pa(a, b) {
  null !== a && (Ja = Ha(Ja, a));a = Ja;Ja = null;a && (b ? Ia(a, La) : Ia(a, Ma), Ja ? D("95") : void 0, E.rethrowCaughtError());
}function Qa(a, b, c, d) {
  for (var e = null, f = 0; f < ra.length; f++) {
    var h = ra[f];h && (h = h.extractEvents(a, b, c, d)) && (e = Ha(e, h));
  }Pa(e, !1);
}var Ra = Object.freeze({ injection: Na, getListener: Oa, runEventsInBatch: Pa, runExtractedEventsInBatch: Qa }),
    Sa = Math.random().toString(36).slice(2),
    F = "__reactInternalInstance$" + Sa,
    Ta = "__reactEventHandlers$" + Sa;
function Ua(a) {
  if (a[F]) return a[F];for (; !a[F];) if (a.parentNode) a = a.parentNode;else return null;a = a[F];return 5 === a.tag || 6 === a.tag ? a : null;
}function Va(a) {
  if (5 === a.tag || 6 === a.tag) return a.stateNode;D("33");
}function Xa(a) {
  return a[Ta] || null;
}var bb = Object.freeze({ precacheFiberNode: function (a, b) {
    b[F] = a;
  }, getClosestInstanceFromNode: Ua, getInstanceFromNode: function (a) {
    a = a[F];return !a || 5 !== a.tag && 6 !== a.tag ? null : a;
  }, getNodeFromInstance: Va, getFiberCurrentPropsFromNode: Xa, updateFiberProps: function (a, b) {
    a[Ta] = b;
  } });
function L(a) {
  do a = a["return"]; while (a && 5 !== a.tag);return a ? a : null;
}function cb(a, b, c) {
  for (var d = []; a;) d.push(a), a = L(a);for (a = d.length; 0 < a--;) b(d[a], "captured", c);for (a = 0; a < d.length; a++) b(d[a], "bubbled", c);
}function db(a, b, c) {
  if (b = Oa(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = Ha(c._dispatchListeners, b), c._dispatchInstances = Ha(c._dispatchInstances, a);
}function eb(a) {
  a && a.dispatchConfig.phasedRegistrationNames && cb(a._targetInst, db, a);
}
function fb(a) {
  if (a && a.dispatchConfig.phasedRegistrationNames) {
    var b = a._targetInst;b = b ? L(b) : null;cb(b, db, a);
  }
}function gb(a, b, c) {
  a && c && c.dispatchConfig.registrationName && (b = Oa(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = Ha(c._dispatchListeners, b), c._dispatchInstances = Ha(c._dispatchInstances, a));
}function hb(a) {
  a && a.dispatchConfig.registrationName && gb(a._targetInst, null, a);
}function ib(a) {
  Ia(a, eb);
}
function jb(a, b, c, d) {
  if (c && d) a: {
    var e = c;for (var f = d, h = 0, g = e; g; g = L(g)) h++;g = 0;for (var k = f; k; k = L(k)) g++;for (; 0 < h - g;) e = L(e), h--;for (; 0 < g - h;) f = L(f), g--;for (; h--;) {
      if (e === f || e === f.alternate) break a;e = L(e);f = L(f);
    }e = null;
  } else e = null;f = e;for (e = []; c && c !== f;) {
    h = c.alternate;if (null !== h && h === f) break;e.push(c);c = L(c);
  }for (c = []; d && d !== f;) {
    h = d.alternate;if (null !== h && h === f) break;c.push(d);d = L(d);
  }for (d = 0; d < e.length; d++) gb(e[d], "bubbled", a);for (a = c.length; 0 < a--;) gb(c[a], "captured", b);
}
var kb = Object.freeze({ accumulateTwoPhaseDispatches: ib, accumulateTwoPhaseDispatchesSkipTarget: function (a) {
    Ia(a, fb);
  }, accumulateEnterLeaveDispatches: jb, accumulateDirectDispatches: function (a) {
    Ia(a, hb);
  } }),
    lb = null;function mb() {
  !lb && m.canUseDOM && (lb = "textContent" in document.documentElement ? "textContent" : "innerText");return lb;
}var M = { _root: null, _startText: null, _fallbackText: null };
function nb() {
  if (M._fallbackText) return M._fallbackText;var a,
      b = M._startText,
      c = b.length,
      d,
      e = ob(),
      f = e.length;for (a = 0; a < c && b[a] === e[a]; a++);var h = c - a;for (d = 1; d <= h && b[c - d] === e[f - d]; d++);M._fallbackText = e.slice(a, 1 < d ? 1 - d : void 0);return M._fallbackText;
}function ob() {
  return "value" in M._root ? M._root.value : M._root[mb()];
}
var pb = "dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),
    qb = { type: null, target: null, currentTarget: C.thatReturnsNull, eventPhase: null, bubbles: null, cancelable: null, timeStamp: function (a) {
    return a.timeStamp || Date.now();
  }, defaultPrevented: null, isTrusted: null };
function N(a, b, c, d) {
  this.dispatchConfig = a;this._targetInst = b;this.nativeEvent = c;a = this.constructor.Interface;for (var e in a) a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? C.thatReturnsTrue : C.thatReturnsFalse;this.isPropagationStopped = C.thatReturnsFalse;return this;
}
A(N.prototype, { preventDefault: function () {
    this.defaultPrevented = !0;var a = this.nativeEvent;a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = C.thatReturnsTrue);
  }, stopPropagation: function () {
    var a = this.nativeEvent;a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = C.thatReturnsTrue);
  }, persist: function () {
    this.isPersistent = C.thatReturnsTrue;
  }, isPersistent: C.thatReturnsFalse,
  destructor: function () {
    var a = this.constructor.Interface,
        b;for (b in a) this[b] = null;for (a = 0; a < pb.length; a++) this[pb[a]] = null;
  } });N.Interface = qb;N.extend = function (a) {
  function b() {}function c() {
    return d.apply(this, arguments);
  }var d = this;b.prototype = d.prototype;var e = new b();A(e, c.prototype);c.prototype = e;c.prototype.constructor = c;c.Interface = A({}, d.Interface, a);c.extend = d.extend;rb(c);return c;
};rb(N);
function sb(a, b, c, d) {
  if (this.eventPool.length) {
    var e = this.eventPool.pop();this.call(e, a, b, c, d);return e;
  }return new this(a, b, c, d);
}function tb(a) {
  a instanceof this ? void 0 : D("223");a.destructor();10 > this.eventPool.length && this.eventPool.push(a);
}function rb(a) {
  a.eventPool = [];a.getPooled = sb;a.release = tb;
}var ub = N.extend({ data: null }),
    vb = N.extend({ data: null }),
    wb = [9, 13, 27, 32],
    xb = m.canUseDOM && "CompositionEvent" in window,
    yb = null;m.canUseDOM && "documentMode" in document && (yb = document.documentMode);
var zb = m.canUseDOM && "TextEvent" in window && !yb,
    Ab = m.canUseDOM && (!xb || yb && 8 < yb && 11 >= yb),
    Bb = String.fromCharCode(32),
    Kb = { beforeInput: { phasedRegistrationNames: { bubbled: "onBeforeInput", captured: "onBeforeInputCapture" }, dependencies: ["topCompositionEnd", "topKeyPress", "topTextInput", "topPaste"] }, compositionEnd: { phasedRegistrationNames: { bubbled: "onCompositionEnd", captured: "onCompositionEndCapture" }, dependencies: "topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ") }, compositionStart: { phasedRegistrationNames: { bubbled: "onCompositionStart",
      captured: "onCompositionStartCapture" }, dependencies: "topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ") }, compositionUpdate: { phasedRegistrationNames: { bubbled: "onCompositionUpdate", captured: "onCompositionUpdateCapture" }, dependencies: "topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ") } },
    Lb = !1;
function Mb(a, b) {
  switch (a) {case "topKeyUp":
      return -1 !== wb.indexOf(b.keyCode);case "topKeyDown":
      return 229 !== b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":
      return !0;default:
      return !1;}
}function Nb(a) {
  a = a.detail;return "object" === typeof a && "data" in a ? a.data : null;
}var Ob = !1;function Pb(a, b) {
  switch (a) {case "topCompositionEnd":
      return Nb(b);case "topKeyPress":
      if (32 !== b.which) return null;Lb = !0;return Bb;case "topTextInput":
      return a = b.data, a === Bb && Lb ? null : a;default:
      return null;}
}
function Qb(a, b) {
  if (Ob) return "topCompositionEnd" === a || !xb && Mb(a, b) ? (a = nb(), M._root = null, M._startText = null, M._fallbackText = null, Ob = !1, a) : null;switch (a) {case "topPaste":
      return null;case "topKeyPress":
      if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
        if (b.char && 1 < b.char.length) return b.char;if (b.which) return String.fromCharCode(b.which);
      }return null;case "topCompositionEnd":
      return Ab ? null : b.data;default:
      return null;}
}
var Rb = { eventTypes: Kb, extractEvents: function (a, b, c, d) {
    var e = void 0;var f = void 0;if (xb) b: {
      switch (a) {case "topCompositionStart":
          e = Kb.compositionStart;break b;case "topCompositionEnd":
          e = Kb.compositionEnd;break b;case "topCompositionUpdate":
          e = Kb.compositionUpdate;break b;}e = void 0;
    } else Ob ? Mb(a, c) && (e = Kb.compositionEnd) : "topKeyDown" === a && 229 === c.keyCode && (e = Kb.compositionStart);e ? (Ab && (Ob || e !== Kb.compositionStart ? e === Kb.compositionEnd && Ob && (f = nb()) : (M._root = d, M._startText = ob(), Ob = !0)), e = ub.getPooled(e, b, c, d), f ? e.data = f : (f = Nb(c), null !== f && (e.data = f)), ib(e), f = e) : f = null;(a = zb ? Pb(a, c) : Qb(a, c)) ? (b = vb.getPooled(Kb.beforeInput, b, c, d), b.data = a, ib(b)) : b = null;return null === f ? b : null === b ? f : [f, b];
  } },
    Sb = null,
    Tb = { injectFiberControlledHostComponent: function (a) {
    Sb = a;
  } },
    Ub = null,
    Vb = null;function Wb(a) {
  if (a = Ea(a)) {
    Sb && "function" === typeof Sb.restoreControlledState ? void 0 : D("194");var b = Da(a.stateNode);Sb.restoreControlledState(a.stateNode, a.type, b);
  }
}function Xb(a) {
  Ub ? Vb ? Vb.push(a) : Vb = [a] : Ub = a;
}
function Yb() {
  return null !== Ub || null !== Vb;
}function Zb() {
  if (Ub) {
    var a = Ub,
        b = Vb;Vb = Ub = null;Wb(a);if (b) for (a = 0; a < b.length; a++) Wb(b[a]);
  }
}var $b = Object.freeze({ injection: Tb, enqueueStateRestore: Xb, needsStateRestore: Yb, restoreStateIfNeeded: Zb });function ac(a, b) {
  return a(b);
}function bc(a, b, c) {
  return a(b, c);
}function cc() {}var dc = !1;function ec(a, b) {
  if (dc) return a(b);dc = !0;try {
    return ac(a, b);
  } finally {
    dc = !1, Yb() && (cc(), Zb());
  }
}
var fc = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };function gc(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();return "input" === b ? !!fc[a.type] : "textarea" === b ? !0 : !1;
}function hc(a) {
  a = a.target || window;a.correspondingUseElement && (a = a.correspondingUseElement);return 3 === a.nodeType ? a.parentNode : a;
}
function ic(a, b) {
  if (!m.canUseDOM || b && !("addEventListener" in document)) return !1;a = "on" + a;b = a in document;b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);return b;
}function jc(a) {
  var b = a.type;return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function kc(a) {
  var b = jc(a) ? "checked" : "value",
      c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b),
      d = "" + a[b];if (!a.hasOwnProperty(b) && "function" === typeof c.get && "function" === typeof c.set) return Object.defineProperty(a, b, { configurable: !0, get: function () {
      return c.get.call(this);
    }, set: function (a) {
      d = "" + a;c.set.call(this, a);
    } }), Object.defineProperty(a, b, { enumerable: c.enumerable }), { getValue: function () {
      return d;
    }, setValue: function (a) {
      d = "" + a;
    }, stopTracking: function () {
      a._valueTracker = null;delete a[b];
    } };
}
function lc(a) {
  a._valueTracker || (a._valueTracker = kc(a));
}function mc(a) {
  if (!a) return !1;var b = a._valueTracker;if (!b) return !0;var c = b.getValue();var d = "";a && (d = jc(a) ? a.checked ? "true" : "false" : a.value);a = d;return a !== c ? (b.setValue(a), !0) : !1;
}
var nc = ea.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,
    O = "function" === typeof Symbol && Symbol["for"],
    oc = O ? Symbol["for"]("react.element") : 60103,
    pc = O ? Symbol["for"]("react.call") : 60104,
    qc = O ? Symbol["for"]("react.return") : 60105,
    rc = O ? Symbol["for"]("react.portal") : 60106,
    sc = O ? Symbol["for"]("react.fragment") : 60107,
    tc = O ? Symbol["for"]("react.strict_mode") : 60108,
    uc = O ? Symbol["for"]("react.provider") : 60109,
    vc = O ? Symbol["for"]("react.context") : 60110,
    wc = O ? Symbol["for"]("react.async_mode") : 60111,
    xc = O ? Symbol["for"]("react.forward_ref") : 60112,
    yc = "function" === typeof Symbol && Symbol.iterator;function zc(a) {
  if (null === a || "undefined" === typeof a) return null;a = yc && a[yc] || a["@@iterator"];return "function" === typeof a ? a : null;
}
function Ac(a) {
  a = a.type;if ("function" === typeof a) return a.displayName || a.name;if ("string" === typeof a) return a;switch (a) {case sc:
      return "ReactFragment";case rc:
      return "ReactPortal";case pc:
      return "ReactCall";case qc:
      return "ReactReturn";}if ("object" === typeof a && null !== a) switch (a.$$typeof) {case xc:
      return a = a.render.displayName || a.render.name || "", "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef";}return null;
}
function Bc(a) {
  var b = "";do {
    a: switch (a.tag) {case 0:case 1:case 2:case 5:
        var c = a._debugOwner,
            d = a._debugSource;var e = Ac(a);var f = null;c && (f = Ac(c));c = d;e = "\n    in " + (e || "Unknown") + (c ? " (at " + c.fileName.replace(/^.*[\\\/]/, "") + ":" + c.lineNumber + ")" : f ? " (created by " + f + ")" : "");break a;default:
        e = "";}b += e;a = a["return"];
  } while (a);return b;
}
var Cc = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
    Dc = {},
    Ec = {};function Fc(a) {
  if (Ec.hasOwnProperty(a)) return !0;if (Dc.hasOwnProperty(a)) return !1;if (Cc.test(a)) return Ec[a] = !0;Dc[a] = !0;return !1;
}
function Gc(a, b, c, d) {
  if (null !== c && 0 === c.type) return !1;switch (typeof b) {case "function":case "symbol":
      return !0;case "boolean":
      if (d) return !1;if (null !== c) return !c.acceptsBooleans;a = a.toLowerCase().slice(0, 5);return "data-" !== a && "aria-" !== a;default:
      return !1;}
}function Hc(a, b, c, d) {
  if (null === b || "undefined" === typeof b || Gc(a, b, c, d)) return !0;if (null !== c) switch (c.type) {case 3:
      return !b;case 4:
      return !1 === b;case 5:
      return isNaN(b);case 6:
      return isNaN(b) || 1 > b;}return !1;
}
function U(a, b, c, d, e) {
  this.acceptsBooleans = 2 === b || 3 === b || 4 === b;this.attributeName = d;this.attributeNamespace = e;this.mustUseProperty = c;this.propertyName = a;this.type = b;
}var V = {};"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function (a) {
  V[a] = new U(a, 0, !1, a, null);
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function (a) {
  var b = a[0];V[b] = new U(b, 1, !1, a[1], null);
});["contentEditable", "draggable", "spellCheck", "value"].forEach(function (a) {
  V[a] = new U(a, 2, !1, a.toLowerCase(), null);
});["autoReverse", "externalResourcesRequired", "preserveAlpha"].forEach(function (a) {
  V[a] = new U(a, 2, !1, a, null);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function (a) {
  V[a] = new U(a, 3, !1, a.toLowerCase(), null);
});["checked", "multiple", "muted", "selected"].forEach(function (a) {
  V[a] = new U(a, 3, !0, a.toLowerCase(), null);
});["capture", "download"].forEach(function (a) {
  V[a] = new U(a, 4, !1, a.toLowerCase(), null);
});
["cols", "rows", "size", "span"].forEach(function (a) {
  V[a] = new U(a, 6, !1, a.toLowerCase(), null);
});["rowSpan", "start"].forEach(function (a) {
  V[a] = new U(a, 5, !1, a.toLowerCase(), null);
});var Sc = /[\-:]([a-z])/g;function Tc(a) {
  return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function (a) {
  var b = a.replace(Sc, Tc);V[b] = new U(b, 1, !1, a, null);
});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function (a) {
  var b = a.replace(Sc, Tc);V[b] = new U(b, 1, !1, a, "http://www.w3.org/1999/xlink");
});["xml:base", "xml:lang", "xml:space"].forEach(function (a) {
  var b = a.replace(Sc, Tc);V[b] = new U(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace");
});V.tabIndex = new U("tabIndex", 1, !1, "tabindex", null);
function Uc(a, b, c, d) {
  var e = V.hasOwnProperty(b) ? V[b] : null;var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;f || (Hc(b, c, e, d) && (c = null), d || null === e ? Fc(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
function Vc(a, b) {
  var c = b.checked;return A({}, b, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: null != c ? c : a._wrapperState.initialChecked });
}function Wc(a, b) {
  var c = null == b.defaultValue ? "" : b.defaultValue,
      d = null != b.checked ? b.checked : b.defaultChecked;c = Xc(null != b.value ? b.value : c);a._wrapperState = { initialChecked: d, initialValue: c, controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value };
}function Yc(a, b) {
  b = b.checked;null != b && Uc(a, "checked", b, !1);
}
function Zc(a, b) {
  Yc(a, b);var c = Xc(b.value);if (null != c) if ("number" === b.type) {
    if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
  } else a.value !== "" + c && (a.value = "" + c);b.hasOwnProperty("value") ? $c(a, b.type, c) : b.hasOwnProperty("defaultValue") && $c(a, b.type, Xc(b.defaultValue));null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function ad(a, b) {
  if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) "" === a.value && (a.value = "" + a._wrapperState.initialValue), a.defaultValue = "" + a._wrapperState.initialValue;b = a.name;"" !== b && (a.name = "");a.defaultChecked = !a.defaultChecked;a.defaultChecked = !a.defaultChecked;"" !== b && (a.name = b);
}function $c(a, b, c) {
  if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function Xc(a) {
  switch (typeof a) {case "boolean":case "number":case "object":case "string":case "undefined":
      return a;default:
      return "";}
}var bd = { change: { phasedRegistrationNames: { bubbled: "onChange", captured: "onChangeCapture" }, dependencies: "topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ") } };function cd(a, b, c) {
  a = N.getPooled(bd.change, a, b, c);a.type = "change";Xb(c);ib(a);return a;
}var dd = null,
    ed = null;function fd(a) {
  Pa(a, !1);
}
function gd(a) {
  var b = Va(a);if (mc(b)) return a;
}function hd(a, b) {
  if ("topChange" === a) return b;
}var id = !1;m.canUseDOM && (id = ic("input") && (!document.documentMode || 9 < document.documentMode));function jd() {
  dd && (dd.detachEvent("onpropertychange", kd), ed = dd = null);
}function kd(a) {
  "value" === a.propertyName && gd(ed) && (a = cd(ed, a, hc(a)), ec(fd, a));
}function ld(a, b, c) {
  "topFocus" === a ? (jd(), dd = b, ed = c, dd.attachEvent("onpropertychange", kd)) : "topBlur" === a && jd();
}
function md(a) {
  if ("topSelectionChange" === a || "topKeyUp" === a || "topKeyDown" === a) return gd(ed);
}function nd(a, b) {
  if ("topClick" === a) return gd(b);
}function od(a, b) {
  if ("topInput" === a || "topChange" === a) return gd(b);
}
var pd = { eventTypes: bd, _isInputEventSupported: id, extractEvents: function (a, b, c, d) {
    var e = b ? Va(b) : window,
        f = void 0,
        h = void 0,
        g = e.nodeName && e.nodeName.toLowerCase();"select" === g || "input" === g && "file" === e.type ? f = hd : gc(e) ? id ? f = od : (f = md, h = ld) : (g = e.nodeName) && "input" === g.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (f = nd);if (f && (f = f(a, b))) return cd(f, c, d);h && h(a, e, b);"topBlur" === a && null != b && (a = b._wrapperState || e._wrapperState) && a.controlled && "number" === e.type && $c(e, "number", e.value);
  } },
    qd = N.extend({ view: null,
  detail: null }),
    rd = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };function sd(a) {
  var b = this.nativeEvent;return b.getModifierState ? b.getModifierState(a) : (a = rd[a]) ? !!b[a] : !1;
}function td() {
  return sd;
}
var ud = qd.extend({ screenX: null, screenY: null, clientX: null, clientY: null, pageX: null, pageY: null, ctrlKey: null, shiftKey: null, altKey: null, metaKey: null, getModifierState: td, button: null, buttons: null, relatedTarget: function (a) {
    return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
  } }),
    vd = { mouseEnter: { registrationName: "onMouseEnter", dependencies: ["topMouseOut", "topMouseOver"] }, mouseLeave: { registrationName: "onMouseLeave", dependencies: ["topMouseOut", "topMouseOver"] } },
    wd = { eventTypes: vd, extractEvents: function (a, b, c, d) {
    if ("topMouseOver" === a && (c.relatedTarget || c.fromElement) || "topMouseOut" !== a && "topMouseOver" !== a) return null;var e = d.window === d ? d : (e = d.ownerDocument) ? e.defaultView || e.parentWindow : window;"topMouseOut" === a ? (a = b, b = (b = c.relatedTarget || c.toElement) ? Ua(b) : null) : a = null;if (a === b) return null;var f = null == a ? e : Va(a);e = null == b ? e : Va(b);var h = ud.getPooled(vd.mouseLeave, a, c, d);h.type = "mouseleave";h.target = f;h.relatedTarget = e;c = ud.getPooled(vd.mouseEnter, b, c, d);c.type = "mouseenter";c.target = e;c.relatedTarget = f;jb(h, c, a, b);return [h, c];
  } };function xd(a) {
  var b = a;if (a.alternate) for (; b["return"];) b = b["return"];else {
    if (0 !== (b.effectTag & 2)) return 1;for (; b["return"];) if (b = b["return"], 0 !== (b.effectTag & 2)) return 1;
  }return 3 === b.tag ? 2 : 3;
}function yd(a) {
  return (a = a._reactInternalFiber) ? 2 === xd(a) : !1;
}function zd(a) {
  2 !== xd(a) ? D("188") : void 0;
}
function Ad(a) {
  var b = a.alternate;if (!b) return b = xd(a), 3 === b ? D("188") : void 0, 1 === b ? null : a;for (var c = a, d = b;;) {
    var e = c["return"],
        f = e ? e.alternate : null;if (!e || !f) break;if (e.child === f.child) {
      for (var h = e.child; h;) {
        if (h === c) return zd(e), a;if (h === d) return zd(e), b;h = h.sibling;
      }D("188");
    }if (c["return"] !== d["return"]) c = e, d = f;else {
      h = !1;for (var g = e.child; g;) {
        if (g === c) {
          h = !0;c = e;d = f;break;
        }if (g === d) {
          h = !0;d = e;c = f;break;
        }g = g.sibling;
      }if (!h) {
        for (g = f.child; g;) {
          if (g === c) {
            h = !0;c = f;d = e;break;
          }if (g === d) {
            h = !0;d = f;c = e;break;
          }g = g.sibling;
        }h ? void 0 : D("189");
      }
    }c.alternate !== d ? D("190") : void 0;
  }3 !== c.tag ? D("188") : void 0;return c.stateNode.current === c ? a : b;
}function Bd(a) {
  a = Ad(a);if (!a) return null;for (var b = a;;) {
    if (5 === b.tag || 6 === b.tag) return b;if (b.child) b.child["return"] = b, b = b.child;else {
      if (b === a) break;for (; !b.sibling;) {
        if (!b["return"] || b["return"] === a) return null;b = b["return"];
      }b.sibling["return"] = b["return"];b = b.sibling;
    }
  }return null;
}
function Cd(a) {
  a = Ad(a);if (!a) return null;for (var b = a;;) {
    if (5 === b.tag || 6 === b.tag) return b;if (b.child && 4 !== b.tag) b.child["return"] = b, b = b.child;else {
      if (b === a) break;for (; !b.sibling;) {
        if (!b["return"] || b["return"] === a) return null;b = b["return"];
      }b.sibling["return"] = b["return"];b = b.sibling;
    }
  }return null;
}var Dd = N.extend({ animationName: null, elapsedTime: null, pseudoElement: null }),
    Ed = N.extend({ clipboardData: function (a) {
    return "clipboardData" in a ? a.clipboardData : window.clipboardData;
  } }),
    Fd = qd.extend({ relatedTarget: null });
function Gd(a) {
  var b = a.keyCode;"charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;10 === a && (a = 13);return 32 <= a || 13 === a ? a : 0;
}
var Hd = { Esc: "Escape", Spacebar: " ", Left: "ArrowLeft", Up: "ArrowUp", Right: "ArrowRight", Down: "ArrowDown", Del: "Delete", Win: "OS", Menu: "ContextMenu", Apps: "ContextMenu", Scroll: "ScrollLock", MozPrintableKey: "Unidentified" },
    Id = { 8: "Backspace", 9: "Tab", 12: "Clear", 13: "Enter", 16: "Shift", 17: "Control", 18: "Alt", 19: "Pause", 20: "CapsLock", 27: "Escape", 32: " ", 33: "PageUp", 34: "PageDown", 35: "End", 36: "Home", 37: "ArrowLeft", 38: "ArrowUp", 39: "ArrowRight", 40: "ArrowDown", 45: "Insert", 46: "Delete", 112: "F1", 113: "F2", 114: "F3", 115: "F4",
  116: "F5", 117: "F6", 118: "F7", 119: "F8", 120: "F9", 121: "F10", 122: "F11", 123: "F12", 144: "NumLock", 145: "ScrollLock", 224: "Meta" },
    Jd = qd.extend({ key: function (a) {
    if (a.key) {
      var b = Hd[a.key] || a.key;if ("Unidentified" !== b) return b;
    }return "keypress" === a.type ? (a = Gd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? Id[a.keyCode] || "Unidentified" : "";
  }, location: null, ctrlKey: null, shiftKey: null, altKey: null, metaKey: null, repeat: null, locale: null, getModifierState: td, charCode: function (a) {
    return "keypress" === a.type ? Gd(a) : 0;
  }, keyCode: function (a) {
    return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
  }, which: function (a) {
    return "keypress" === a.type ? Gd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
  } }),
    Kd = ud.extend({ dataTransfer: null }),
    Ld = qd.extend({ touches: null, targetTouches: null, changedTouches: null, altKey: null, metaKey: null, ctrlKey: null, shiftKey: null, getModifierState: td }),
    Md = N.extend({ propertyName: null, elapsedTime: null, pseudoElement: null }),
    Nd = ud.extend({ deltaX: function (a) {
    return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
  }, deltaY: function (a) {
    return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
  }, deltaZ: null, deltaMode: null }),
    Od = {},
    Pd = {};function Qd(a, b) {
  var c = a[0].toUpperCase() + a.slice(1),
      d = "on" + c;c = "top" + c;b = { phasedRegistrationNames: { bubbled: d, captured: d + "Capture" }, dependencies: [c], isInteractive: b };Od[a] = b;Pd[c] = b;
}
"blur cancel click close contextMenu copy cut doubleClick dragEnd dragStart drop focus input invalid keyDown keyPress keyUp mouseDown mouseUp paste pause play rateChange reset seeked submit touchCancel touchEnd touchStart volumeChange".split(" ").forEach(function (a) {
  Qd(a, !0);
});
"abort animationEnd animationIteration animationStart canPlay canPlayThrough drag dragEnter dragExit dragLeave dragOver durationChange emptied encrypted ended error load loadedData loadedMetadata loadStart mouseMove mouseOut mouseOver playing progress scroll seeking stalled suspend timeUpdate toggle touchMove transitionEnd waiting wheel".split(" ").forEach(function (a) {
  Qd(a, !1);
});
var Rd = { eventTypes: Od, isInteractiveTopLevelEventType: function (a) {
    a = Pd[a];return void 0 !== a && !0 === a.isInteractive;
  }, extractEvents: function (a, b, c, d) {
    var e = Pd[a];if (!e) return null;switch (a) {case "topKeyPress":
        if (0 === Gd(c)) return null;case "topKeyDown":case "topKeyUp":
        a = Jd;break;case "topBlur":case "topFocus":
        a = Fd;break;case "topClick":
        if (2 === c.button) return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":
        a = ud;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":
        a = Kd;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":
        a = Ld;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":
        a = Dd;break;case "topTransitionEnd":
        a = Md;break;case "topScroll":
        a = qd;break;case "topWheel":
        a = Nd;break;case "topCopy":case "topCut":case "topPaste":
        a = Ed;break;default:
        a = N;}b = a.getPooled(e, b, c, d);ib(b);return b;
  } },
    Sd = Rd.isInteractiveTopLevelEventType,
    Td = [];function Ud(a) {
  var b = a.targetInst;do {
    if (!b) {
      a.ancestors.push(b);break;
    }var c;for (c = b; c["return"];) c = c["return"];c = 3 !== c.tag ? null : c.stateNode.containerInfo;if (!c) break;a.ancestors.push(b);b = Ua(c);
  } while (b);for (c = 0; c < a.ancestors.length; c++) b = a.ancestors[c], Qa(a.topLevelType, b, a.nativeEvent, hc(a.nativeEvent));
}var Vd = !0;function Wd(a) {
  Vd = !!a;
}
function W(a, b, c) {
  if (!c) return null;a = (Sd(a) ? Xd : Yd).bind(null, a);c.addEventListener(b, a, !1);
}function Zd(a, b, c) {
  if (!c) return null;a = (Sd(a) ? Xd : Yd).bind(null, a);c.addEventListener(b, a, !0);
}function Xd(a, b) {
  bc(Yd, a, b);
}
function Yd(a, b) {
  if (Vd) {
    var c = hc(b);c = Ua(c);null !== c && "number" === typeof c.tag && 2 !== xd(c) && (c = null);if (Td.length) {
      var d = Td.pop();d.topLevelType = a;d.nativeEvent = b;d.targetInst = c;a = d;
    } else a = { topLevelType: a, nativeEvent: b, targetInst: c, ancestors: [] };try {
      ec(Ud, a);
    } finally {
      a.topLevelType = null, a.nativeEvent = null, a.targetInst = null, a.ancestors.length = 0, 10 > Td.length && Td.push(a);
    }
  }
}
var $d = Object.freeze({ get _enabled() {
    return Vd;
  }, setEnabled: Wd, isEnabled: function () {
    return Vd;
  }, trapBubbledEvent: W, trapCapturedEvent: Zd, dispatchEvent: Yd });function ae(a, b) {
  var c = {};c[a.toLowerCase()] = b.toLowerCase();c["Webkit" + a] = "webkit" + b;c["Moz" + a] = "moz" + b;c["ms" + a] = "MS" + b;c["O" + a] = "o" + b.toLowerCase();return c;
}
var be = { animationend: ae("Animation", "AnimationEnd"), animationiteration: ae("Animation", "AnimationIteration"), animationstart: ae("Animation", "AnimationStart"), transitionend: ae("Transition", "TransitionEnd") },
    ce = {},
    de = {};m.canUseDOM && (de = document.createElement("div").style, "AnimationEvent" in window || (delete be.animationend.animation, delete be.animationiteration.animation, delete be.animationstart.animation), "TransitionEvent" in window || delete be.transitionend.transition);
function ee(a) {
  if (ce[a]) return ce[a];if (!be[a]) return a;var b = be[a],
      c;for (c in b) if (b.hasOwnProperty(c) && c in de) return ce[a] = b[c];return a;
}
var fe = { topAnimationEnd: ee("animationend"), topAnimationIteration: ee("animationiteration"), topAnimationStart: ee("animationstart"), topBlur: "blur", topCancel: "cancel", topChange: "change", topClick: "click", topClose: "close", topCompositionEnd: "compositionend", topCompositionStart: "compositionstart", topCompositionUpdate: "compositionupdate", topContextMenu: "contextmenu", topCopy: "copy", topCut: "cut", topDoubleClick: "dblclick", topDrag: "drag", topDragEnd: "dragend", topDragEnter: "dragenter", topDragExit: "dragexit", topDragLeave: "dragleave",
  topDragOver: "dragover", topDragStart: "dragstart", topDrop: "drop", topFocus: "focus", topInput: "input", topKeyDown: "keydown", topKeyPress: "keypress", topKeyUp: "keyup", topLoad: "load", topLoadStart: "loadstart", topMouseDown: "mousedown", topMouseMove: "mousemove", topMouseOut: "mouseout", topMouseOver: "mouseover", topMouseUp: "mouseup", topPaste: "paste", topScroll: "scroll", topSelectionChange: "selectionchange", topTextInput: "textInput", topToggle: "toggle", topTouchCancel: "touchcancel", topTouchEnd: "touchend", topTouchMove: "touchmove",
  topTouchStart: "touchstart", topTransitionEnd: ee("transitionend"), topWheel: "wheel" },
    ge = { topAbort: "abort", topCanPlay: "canplay", topCanPlayThrough: "canplaythrough", topDurationChange: "durationchange", topEmptied: "emptied", topEncrypted: "encrypted", topEnded: "ended", topError: "error", topLoadedData: "loadeddata", topLoadedMetadata: "loadedmetadata", topLoadStart: "loadstart", topPause: "pause", topPlay: "play", topPlaying: "playing", topProgress: "progress", topRateChange: "ratechange", topSeeked: "seeked", topSeeking: "seeking",
  topStalled: "stalled", topSuspend: "suspend", topTimeUpdate: "timeupdate", topVolumeChange: "volumechange", topWaiting: "waiting" },
    he = {},
    ie = 0,
    je = "_reactListenersID" + ("" + Math.random()).slice(2);function ke(a) {
  Object.prototype.hasOwnProperty.call(a, je) || (a[je] = ie++, he[a[je]] = {});return he[a[je]];
}function le(a) {
  for (; a && a.firstChild;) a = a.firstChild;return a;
}
function me(a, b) {
  var c = le(a);a = 0;for (var d; c;) {
    if (3 === c.nodeType) {
      d = a + c.textContent.length;if (a <= b && d >= b) return { node: c, offset: b - a };a = d;
    }a: {
      for (; c;) {
        if (c.nextSibling) {
          c = c.nextSibling;break a;
        }c = c.parentNode;
      }c = void 0;
    }c = le(c);
  }
}function ne(a) {
  var b = a && a.nodeName && a.nodeName.toLowerCase();return b && ("input" === b && "text" === a.type || "textarea" === b || "true" === a.contentEditable);
}
var oe = m.canUseDOM && "documentMode" in document && 11 >= document.documentMode,
    pe = { select: { phasedRegistrationNames: { bubbled: "onSelect", captured: "onSelectCapture" }, dependencies: "topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ") } },
    qe = null,
    re = null,
    se = null,
    te = !1;
function ue(a, b) {
  if (te || null == qe || qe !== fa()) return null;var c = qe;"selectionStart" in c && ne(c) ? c = { start: c.selectionStart, end: c.selectionEnd } : window.getSelection ? (c = window.getSelection(), c = { anchorNode: c.anchorNode, anchorOffset: c.anchorOffset, focusNode: c.focusNode, focusOffset: c.focusOffset }) : c = void 0;return se && ha(se, c) ? null : (se = c, a = N.getPooled(pe.select, re, a, b), a.type = "select", a.target = qe, ib(a), a);
}
var ve = { eventTypes: pe, extractEvents: function (a, b, c, d) {
    var e = d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument,
        f;if (!(f = !e)) {
      a: {
        e = ke(e);f = va.onSelect;for (var h = 0; h < f.length; h++) {
          var g = f[h];if (!e.hasOwnProperty(g) || !e[g]) {
            e = !1;break a;
          }
        }e = !0;
      }f = !e;
    }if (f) return null;e = b ? Va(b) : window;switch (a) {case "topFocus":
        if (gc(e) || "true" === e.contentEditable) qe = e, re = b, se = null;break;case "topBlur":
        se = re = qe = null;break;case "topMouseDown":
        te = !0;break;case "topContextMenu":case "topMouseUp":
        return te = !1, ue(c, d);case "topSelectionChange":
        if (oe) break;
      case "topKeyDown":case "topKeyUp":
        return ue(c, d);}return null;
  } };Na.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));Da = bb.getFiberCurrentPropsFromNode;Ea = bb.getInstanceFromNode;Fa = bb.getNodeFromInstance;Na.injectEventPluginsByName({ SimpleEventPlugin: Rd, EnterLeaveEventPlugin: wd, ChangeEventPlugin: pd, SelectEventPlugin: ve, BeforeInputEventPlugin: Rb });
function xe(a, b, c, d) {
  this.tag = a;this.key = c;this.stateNode = this.type = null;this.sibling = this.child = this["return"] = null;this.index = 0;this.ref = null;this.pendingProps = b;this.memoizedState = this.updateQueue = this.memoizedProps = null;this.mode = d;this.effectTag = 0;this.lastEffect = this.firstEffect = this.nextEffect = null;this.expirationTime = 0;this.alternate = null;
}
function ze(a, b, c) {
  var d = a.alternate;null === d ? (d = new xe(a.tag, b, a.key, a.mode), d.type = a.type, d.stateNode = a.stateNode, d.alternate = a, a.alternate = d) : (d.pendingProps = b, d.effectTag = 0, d.nextEffect = null, d.firstEffect = null, d.lastEffect = null);d.expirationTime = c;d.child = a.child;d.memoizedProps = a.memoizedProps;d.memoizedState = a.memoizedState;d.updateQueue = a.updateQueue;d.sibling = a.sibling;d.index = a.index;d.ref = a.ref;return d;
}
function Ae(a, b, c) {
  var d = a.type,
      e = a.key;a = a.props;var f = void 0;if ("function" === typeof d) f = d.prototype && d.prototype.isReactComponent ? 2 : 0;else if ("string" === typeof d) f = 5;else switch (d) {case sc:
      return Be(a.children, b, c, e);case wc:
      f = 11;b |= 3;break;case tc:
      f = 11;b |= 2;break;case pc:
      f = 7;break;case qc:
      f = 9;break;default:
      if ("object" === typeof d && null !== d) switch (d.$$typeof) {case uc:
          f = 13;break;case vc:
          f = 12;break;case xc:
          f = 14;break;default:
          if ("number" === typeof d.tag) return b = d, b.pendingProps = a, b.expirationTime = c, b;D("130", null == d ? d : typeof d, "");} else D("130", null == d ? d : typeof d, "");}b = new xe(f, a, e, b);b.type = d;b.expirationTime = c;return b;
}function Be(a, b, c, d) {
  a = new xe(10, a, d, b);a.expirationTime = c;return a;
}function Ce(a, b, c) {
  a = new xe(6, a, null, b);a.expirationTime = c;return a;
}function De(a, b, c) {
  b = new xe(4, null !== a.children ? a.children : [], a.key, b);b.expirationTime = c;b.stateNode = { containerInfo: a.containerInfo, pendingChildren: null, implementation: a.implementation };return b;
}var Ee = null,
    Fe = null;
function Ge(a) {
  return function (b) {
    try {
      return a(b);
    } catch (c) {}
  };
}function He(a) {
  if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;if (b.isDisabled || !b.supportsFiber) return !0;try {
    var c = b.inject(a);Ee = Ge(function (a) {
      return b.onCommitFiberRoot(c, a);
    });Fe = Ge(function (a) {
      return b.onCommitFiberUnmount(c, a);
    });
  } catch (d) {}return !0;
}function Ie(a) {
  "function" === typeof Ee && Ee(a);
}function Je(a) {
  "function" === typeof Fe && Fe(a);
}new Set();
function Ke(a) {
  return { baseState: a, expirationTime: 0, first: null, last: null, callbackList: null, hasForceUpdate: !1, isInitialized: !1, capturedValues: null };
}function Le(a, b) {
  null === a.last ? a.first = a.last = b : (a.last.next = b, a.last = b);if (0 === a.expirationTime || a.expirationTime > b.expirationTime) a.expirationTime = b.expirationTime;
}var Me = void 0,
    Ne = void 0;
function Oe(a) {
  Me = Ne = null;var b = a.alternate,
      c = a.updateQueue;null === c && (c = a.updateQueue = Ke(null));null !== b ? (a = b.updateQueue, null === a && (a = b.updateQueue = Ke(null))) : a = null;Me = c;Ne = a !== c ? a : null;
}function Pe(a, b) {
  Oe(a);a = Me;var c = Ne;null === c ? Le(a, b) : null === a.last || null === c.last ? (Le(a, b), Le(c, b)) : (Le(a, b), c.last = b);
}function Qe(a, b, c, d) {
  a = a.partialState;return "function" === typeof a ? a.call(b, c, d) : a;
}
function Re(a, b, c, d, e, f) {
  null !== a && a.updateQueue === c && (c = b.updateQueue = { baseState: c.baseState, expirationTime: c.expirationTime, first: c.first, last: c.last, isInitialized: c.isInitialized, capturedValues: c.capturedValues, callbackList: null, hasForceUpdate: !1 });c.expirationTime = 0;c.isInitialized ? a = c.baseState : (a = c.baseState = b.memoizedState, c.isInitialized = !0);for (var h = !0, g = c.first, k = !1; null !== g;) {
    var v = g.expirationTime;if (v > f) {
      var l = c.expirationTime;if (0 === l || l > v) c.expirationTime = v;k || (k = !0, c.baseState = a);
    } else {
      k || (c.first = g.next, null === c.first && (c.last = null));if (g.isReplace) a = Qe(g, d, a, e), h = !0;else if (v = Qe(g, d, a, e)) a = h ? A({}, a, v) : A(a, v), h = !1;g.isForced && (c.hasForceUpdate = !0);null !== g.callback && (v = c.callbackList, null === v && (v = c.callbackList = []), v.push(g));null !== g.capturedValue && (v = c.capturedValues, null === v ? c.capturedValues = [g.capturedValue] : v.push(g.capturedValue));
    }g = g.next;
  }null !== c.callbackList ? b.effectTag |= 32 : null !== c.first || c.hasForceUpdate || null !== c.capturedValues || (b.updateQueue = null);k || (c.baseState = a);
  return a;
}function Se(a, b) {
  var c = a.callbackList;if (null !== c) for (a.callbackList = null, a = 0; a < c.length; a++) {
    var d = c[a],
        e = d.callback;d.callback = null;"function" !== typeof e ? D("191", e) : void 0;e.call(b);
  }
}
function Te(a, b, c, d, e) {
  function f(a, b, c, d, e, f) {
    if (null === b || null !== a.updateQueue && a.updateQueue.hasForceUpdate) return !0;var n = a.stateNode;a = a.type;return "function" === typeof n.shouldComponentUpdate ? n.shouldComponentUpdate(c, e, f) : a.prototype && a.prototype.isPureReactComponent ? !ha(b, c) || !ha(d, e) : !0;
  }function h(a, b) {
    b.updater = r;a.stateNode = b;b._reactInternalFiber = a;
  }function g(a, b, c, d) {
    a = b.state;"function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);"function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);b.state !== a && r.enqueueReplaceState(b, b.state, null);
  }function k(a, b, c, d) {
    a = a.type;if ("function" === typeof a.getDerivedStateFromProps) return a.getDerivedStateFromProps.call(null, c, d);
  }var v = a.cacheContext,
      l = a.getMaskedContext,
      p = a.getUnmaskedContext,
      z = a.isContextConsumer,
      B = a.hasContextChanged,
      r = { isMounted: yd, enqueueSetState: function (a, d, e) {
      a = a._reactInternalFiber;e = void 0 === e ? null : e;var f = c(a);Pe(a, { expirationTime: f, partialState: d, callback: e, isReplace: !1, isForced: !1,
        capturedValue: null, next: null });b(a, f);
    }, enqueueReplaceState: function (a, d, e) {
      a = a._reactInternalFiber;e = void 0 === e ? null : e;var f = c(a);Pe(a, { expirationTime: f, partialState: d, callback: e, isReplace: !0, isForced: !1, capturedValue: null, next: null });b(a, f);
    }, enqueueForceUpdate: function (a, d) {
      a = a._reactInternalFiber;d = void 0 === d ? null : d;var e = c(a);Pe(a, { expirationTime: e, partialState: null, callback: d, isReplace: !1, isForced: !0, capturedValue: null, next: null });b(a, e);
    } };return { adoptClassInstance: h, callGetDerivedStateFromProps: k,
    constructClassInstance: function (a, b) {
      var c = a.type,
          d = p(a),
          e = z(a),
          f = e ? l(a, d) : ka;c = new c(b, f);var n = null !== c.state && void 0 !== c.state ? c.state : null;h(a, c);a.memoizedState = n;b = k(a, c, b, n);null !== b && void 0 !== b && (a.memoizedState = A({}, a.memoizedState, b));e && v(a, d, f);return c;
    }, mountClassInstance: function (a, b) {
      var c = a.type,
          d = a.alternate,
          e = a.stateNode,
          f = a.pendingProps,
          n = p(a);e.props = f;e.state = a.memoizedState;e.refs = ka;e.context = l(a, n);"function" === typeof c.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (c = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), c !== e.state && r.enqueueReplaceState(e, e.state, null), c = a.updateQueue, null !== c && (e.state = Re(d, a, c, e, f, b)));"function" === typeof e.componentDidMount && (a.effectTag |= 4);
    }, resumeMountClassInstance: function (a, b) {
      var c = a.type,
          n = a.stateNode;n.props = a.memoizedProps;n.state = a.memoizedState;var h = a.memoizedProps,
          r = a.pendingProps,
          z = n.context,
          q = p(a);q = l(a, q);(c = "function" === typeof c.getDerivedStateFromProps || "function" === typeof n.getSnapshotBeforeUpdate) || "function" !== typeof n.UNSAFE_componentWillReceiveProps && "function" !== typeof n.componentWillReceiveProps || (h !== r || z !== q) && g(a, n, r, q);z = a.memoizedState;b = null !== a.updateQueue ? Re(null, a, a.updateQueue, n, r, b) : z;var u = void 0;h !== r && (u = k(a, n, r, b));if (null !== u && void 0 !== u) {
        b = null === b || void 0 === b ? u : A({}, b, u);var t = a.updateQueue;
        null !== t && (t.baseState = A({}, t.baseState, u));
      }if (!(h !== r || z !== b || B() || null !== a.updateQueue && a.updateQueue.hasForceUpdate)) return "function" === typeof n.componentDidMount && (a.effectTag |= 4), !1;(h = f(a, h, r, z, b, q)) ? (c || "function" !== typeof n.UNSAFE_componentWillMount && "function" !== typeof n.componentWillMount || ("function" === typeof n.componentWillMount && n.componentWillMount(), "function" === typeof n.UNSAFE_componentWillMount && n.UNSAFE_componentWillMount()), "function" === typeof n.componentDidMount && (a.effectTag |= 4)) : ("function" === typeof n.componentDidMount && (a.effectTag |= 4), d(a, r), e(a, b));n.props = r;n.state = b;n.context = q;return h;
    }, updateClassInstance: function (a, b, c) {
      var n = b.type,
          x = b.stateNode;x.props = b.memoizedProps;x.state = b.memoizedState;var h = b.memoizedProps,
          r = b.pendingProps,
          q = x.context,
          u = p(b);u = l(b, u);(n = "function" === typeof n.getDerivedStateFromProps || "function" === typeof x.getSnapshotBeforeUpdate) || "function" !== typeof x.UNSAFE_componentWillReceiveProps && "function" !== typeof x.componentWillReceiveProps || (h !== r || q !== u) && g(b, x, r, u);q = b.memoizedState;c = null !== b.updateQueue ? Re(a, b, b.updateQueue, x, r, c) : q;var t = void 0;h !== r && (t = k(b, x, r, c));if (null !== t && void 0 !== t) {
        c = null === c || void 0 === c ? t : A({}, c, t);var y = b.updateQueue;null !== y && (y.baseState = A({}, y.baseState, t));
      }if (!(h !== r || q !== c || B() || null !== b.updateQueue && b.updateQueue.hasForceUpdate)) return "function" !== typeof x.componentDidUpdate || h === a.memoizedProps && q === a.memoizedState || (b.effectTag |= 4), "function" !== typeof x.getSnapshotBeforeUpdate || h === a.memoizedProps && q === a.memoizedState || (b.effectTag |= 2048), !1;(t = f(b, h, r, q, c, u)) ? (n || "function" !== typeof x.UNSAFE_componentWillUpdate && "function" !== typeof x.componentWillUpdate || ("function" === typeof x.componentWillUpdate && x.componentWillUpdate(r, c, u), "function" === typeof x.UNSAFE_componentWillUpdate && x.UNSAFE_componentWillUpdate(r, c, u)), "function" === typeof x.componentDidUpdate && (b.effectTag |= 4), "function" === typeof x.getSnapshotBeforeUpdate && (b.effectTag |= 2048)) : ("function" !== typeof x.componentDidUpdate || h === a.memoizedProps && q === a.memoizedState || (b.effectTag |= 4), "function" !== typeof x.getSnapshotBeforeUpdate || h === a.memoizedProps && q === a.memoizedState || (b.effectTag |= 2048), d(b, r), e(b, c));x.props = r;x.state = c;x.context = u;return t;
    } };
}var Ue = Array.isArray;
function Ve(a, b, c) {
  a = c.ref;if (null !== a && "function" !== typeof a && "object" !== typeof a) {
    if (c._owner) {
      c = c._owner;var d = void 0;c && (2 !== c.tag ? D("110") : void 0, d = c.stateNode);d ? void 0 : D("147", a);var e = "" + a;if (null !== b && null !== b.ref && b.ref._stringRef === e) return b.ref;b = function (a) {
        var b = d.refs === ka ? d.refs = {} : d.refs;null === a ? delete b[e] : b[e] = a;
      };b._stringRef = e;return b;
    }"string" !== typeof a ? D("148") : void 0;c._owner ? void 0 : D("254", a);
  }return a;
}
function We(a, b) {
  "textarea" !== a.type && D("31", "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, "");
}
function Xe(a) {
  function b(b, c) {
    if (a) {
      var d = b.lastEffect;null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;c.nextEffect = null;c.effectTag = 8;
    }
  }function c(c, d) {
    if (!a) return null;for (; null !== d;) b(c, d), d = d.sibling;return null;
  }function d(a, b) {
    for (a = new Map(); null !== b;) null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;return a;
  }function e(a, b, c) {
    a = ze(a, b, c);a.index = 0;a.sibling = null;return a;
  }function f(b, c, d) {
    b.index = d;if (!a) return c;d = b.alternate;if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;b.effectTag = 2;return c;
  }function h(b) {
    a && null === b.alternate && (b.effectTag = 2);return b;
  }function g(a, b, c, d) {
    if (null === b || 6 !== b.tag) return b = Ce(c, a.mode, d), b["return"] = a, b;b = e(b, c, d);b["return"] = a;return b;
  }function k(a, b, c, d) {
    if (null !== b && b.type === c.type) return d = e(b, c.props, d), d.ref = Ve(a, b, c), d["return"] = a, d;d = Ae(c, a.mode, d);d.ref = Ve(a, b, c);d["return"] = a;return d;
  }function v(a, b, c, d) {
    if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = De(c, a.mode, d), b["return"] = a, b;b = e(b, c.children || [], d);b["return"] = a;return b;
  }function l(a, b, c, d, f) {
    if (null === b || 10 !== b.tag) return b = Be(c, a.mode, d, f), b["return"] = a, b;b = e(b, c, d);b["return"] = a;return b;
  }function p(a, b, c) {
    if ("string" === typeof b || "number" === typeof b) return b = Ce("" + b, a.mode, c), b["return"] = a, b;if ("object" === typeof b && null !== b) {
      switch (b.$$typeof) {case oc:
          return c = Ae(b, a.mode, c), c.ref = Ve(a, null, b), c["return"] = a, c;case rc:
          return b = De(b, a.mode, c), b["return"] = a, b;}if (Ue(b) || zc(b)) return b = Be(b, a.mode, c, null), b["return"] = a, b;We(a, b);
    }return null;
  }function z(a, b, c, d) {
    var e = null !== b ? b.key : null;if ("string" === typeof c || "number" === typeof c) return null !== e ? null : g(a, b, "" + c, d);if ("object" === typeof c && null !== c) {
      switch (c.$$typeof) {case oc:
          return c.key === e ? c.type === sc ? l(a, b, c.props.children, d, e) : k(a, b, c, d) : null;case rc:
          return c.key === e ? v(a, b, c, d) : null;}if (Ue(c) || zc(c)) return null !== e ? null : l(a, b, c, d, null);We(a, c);
    }return null;
  }function B(a, b, c, d, e) {
    if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, g(b, a, "" + d, e);if ("object" === typeof d && null !== d) {
      switch (d.$$typeof) {case oc:
          return a = a.get(null === d.key ? c : d.key) || null, d.type === sc ? l(b, a, d.props.children, e, d.key) : k(b, a, d, e);case rc:
          return a = a.get(null === d.key ? c : d.key) || null, v(b, a, d, e);}if (Ue(d) || zc(d)) return a = a.get(c) || null, l(b, a, d, e, null);We(b, d);
    }return null;
  }function r(e, l, g, h) {
    for (var r = null, k = null, q = l, u = l = 0, t = null; null !== q && u < g.length; u++) {
      q.index > u ? (t = q, q = null) : t = q.sibling;var n = z(e, q, g[u], h);if (null === n) {
        null === q && (q = t);break;
      }a && q && null === n.alternate && b(e, q);l = f(n, l, u);null === k ? r = n : k.sibling = n;k = n;q = t;
    }if (u === g.length) return c(e, q), r;if (null === q) {
      for (; u < g.length; u++) if (q = p(e, g[u], h)) l = f(q, l, u), null === k ? r = q : k.sibling = q, k = q;return r;
    }for (q = d(e, q); u < g.length; u++) if (t = B(q, e, u, g[u], h)) {
      if (a && null !== t.alternate) q["delete"](null === t.key ? u : t.key);l = f(t, l, u);null === k ? r = t : k.sibling = t;k = t;
    }a && q.forEach(function (a) {
      return b(e, a);
    });return r;
  }function Q(e, l, g, h) {
    var r = zc(g);"function" !== typeof r ? D("150") : void 0;g = r.call(g);null == g ? D("151") : void 0;for (var k = r = null, q = l, u = l = 0, t = null, n = g.next(); null !== q && !n.done; u++, n = g.next()) {
      q.index > u ? (t = q, q = null) : t = q.sibling;var H = z(e, q, n.value, h);if (null === H) {
        q || (q = t);break;
      }a && q && null === H.alternate && b(e, q);l = f(H, l, u);null === k ? r = H : k.sibling = H;k = H;q = t;
    }if (n.done) return c(e, q), r;if (null === q) {
      for (; !n.done; u++, n = g.next()) n = p(e, n.value, h), null !== n && (l = f(n, l, u), null === k ? r = n : k.sibling = n, k = n);return r;
    }for (q = d(e, q); !n.done; u++, n = g.next()) if (n = B(q, e, u, n.value, h), null !== n) {
      if (a && null !== n.alternate) q["delete"](null === n.key ? u : n.key);
      l = f(n, l, u);null === k ? r = n : k.sibling = n;k = n;
    }a && q.forEach(function (a) {
      return b(e, a);
    });return r;
  }return function (a, d, f, l) {
    "object" === typeof f && null !== f && f.type === sc && null === f.key && (f = f.props.children);var g = "object" === typeof f && null !== f;if (g) switch (f.$$typeof) {case oc:
        a: {
          var k = f.key;for (g = d; null !== g;) {
            if (g.key === k) {
              if (10 === g.tag ? f.type === sc : g.type === f.type) {
                c(a, g.sibling);d = e(g, f.type === sc ? f.props.children : f.props, l);d.ref = Ve(a, g, f);d["return"] = a;a = d;break a;
              } else {
                c(a, g);break;
              }
            } else b(a, g);g = g.sibling;
          }f.type === sc ? (d = Be(f.props.children, a.mode, l, f.key), d["return"] = a, a = d) : (l = Ae(f, a.mode, l), l.ref = Ve(a, d, f), l["return"] = a, a = l);
        }return h(a);case rc:
        a: {
          for (g = f.key; null !== d;) {
            if (d.key === g) {
              if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                c(a, d.sibling);d = e(d, f.children || [], l);d["return"] = a;a = d;break a;
              } else {
                c(a, d);break;
              }
            } else b(a, d);d = d.sibling;
          }d = De(f, a.mode, l);d["return"] = a;a = d;
        }return h(a);}if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f, l), d["return"] = a, a = d) : (c(a, d), d = Ce(f, a.mode, l), d["return"] = a, a = d), h(a);if (Ue(f)) return r(a, d, f, l);if (zc(f)) return Q(a, d, f, l);g && We(a, f);if ("undefined" === typeof f) switch (a.tag) {case 2:case 1:
        l = a.type, D("152", l.displayName || l.name || "Component");}return c(a, d);
  };
}var Ye = Xe(!0),
    Ze = Xe(!1);
function $e(a, b, c, d, e, f, h) {
  function g(a, b, c) {
    k(a, b, c, b.expirationTime);
  }function k(a, b, c, d) {
    b.child = null === a ? Ze(b, null, c, d) : Ye(b, a.child, c, d);
  }function v(a, b) {
    var c = b.ref;if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
  }function l(a, b, c, d, e, f) {
    v(a, b);if (!c && !e) return d && y(b, !1), r(a, b);c = b.stateNode;nc.current = b;var l = e ? null : c.render();b.effectTag |= 1;e && (k(a, b, null, f), b.child = null);k(a, b, l, f);b.memoizedState = c.state;b.memoizedProps = c.props;d && y(b, !0);return b.child;
  }function p(a) {
    var b = a.stateNode;
    b.pendingContext ? t(a, b.pendingContext, b.pendingContext !== b.context) : b.context && t(a, b.context, !1);Y(a, b.containerInfo);
  }function z(a, b, c, d) {
    var e = a.child;for (null !== e && (e["return"] = a); null !== e;) {
      switch (e.tag) {case 12:
          var f = e.stateNode | 0;if (e.type === b && 0 !== (f & c)) {
            for (f = e; null !== f;) {
              var l = f.alternate;if (0 === f.expirationTime || f.expirationTime > d) f.expirationTime = d, null !== l && (0 === l.expirationTime || l.expirationTime > d) && (l.expirationTime = d);else if (null !== l && (0 === l.expirationTime || l.expirationTime > d)) l.expirationTime = d;else break;f = f["return"];
            }f = null;
          } else f = e.child;break;case 13:
          f = e.type === a.type ? null : e.child;break;default:
          f = e.child;}if (null !== f) f["return"] = e;else for (f = e; null !== f;) {
        if (f === a) {
          f = null;break;
        }e = f.sibling;if (null !== e) {
          f = e;break;
        }f = f["return"];
      }e = f;
    }
  }function B(a, b, c) {
    var d = b.type._context,
        e = b.pendingProps,
        f = b.memoizedProps;if (!q() && f === e) return b.stateNode = 0, G(b), r(a, b);var l = e.value;b.memoizedProps = e;if (null === f) l = 1073741823;else if (f.value === e.value) {
      if (f.children === e.children) return b.stateNode = 0, G(b), r(a, b);l = 0;
    } else {
      var h = f.value;if (h === l && (0 !== h || 1 / h === 1 / l) || h !== h && l !== l) {
        if (f.children === e.children) return b.stateNode = 0, G(b), r(a, b);l = 0;
      } else if (l = "function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, l) : 1073741823, l |= 0, 0 === l) {
        if (f.children === e.children) return b.stateNode = 0, G(b), r(a, b);
      } else z(b, d, l, c);
    }b.stateNode = l;G(b);g(a, b, e.children);return b.child;
  }function r(a, b) {
    null !== a && b.child !== a.child ? D("153") : void 0;if (null !== b.child) {
      a = b.child;var c = ze(a, a.pendingProps, a.expirationTime);
      b.child = c;for (c["return"] = b; null !== a.sibling;) a = a.sibling, c = c.sibling = ze(a, a.pendingProps, a.expirationTime), c["return"] = b;c.sibling = null;
    }return b.child;
  }var Q = a.shouldSetTextContent,
      n = a.shouldDeprioritizeSubtree,
      x = b.pushHostContext,
      Y = b.pushHostContainer,
      G = d.pushProvider,
      R = c.getMaskedContext,
      S = c.getUnmaskedContext,
      q = c.hasContextChanged,
      u = c.pushContextProvider,
      t = c.pushTopLevelContextObject,
      y = c.invalidateContextProvider,
      H = e.enterHydrationState,
      Wa = e.resetHydrationState,
      Cb = e.tryToClaimNextHydratableInstance;
  a = Te(c, f, h, function (a, b) {
    a.memoizedProps = b;
  }, function (a, b) {
    a.memoizedState = b;
  });var Jc = a.adoptClassInstance,
      Kc = a.callGetDerivedStateFromProps,
      Lc = a.constructClassInstance,
      Db = a.mountClassInstance,
      Mc = a.resumeMountClassInstance,
      Eb = a.updateClassInstance;return { beginWork: function (a, b, c) {
      if (0 === b.expirationTime || b.expirationTime > c) {
        switch (b.tag) {case 3:
            p(b);break;case 2:
            u(b);break;case 4:
            Y(b, b.stateNode.containerInfo);break;case 13:
            G(b);}return null;
      }switch (b.tag) {case 0:
          null !== a ? D("155") : void 0;var d = b.type,
              e = b.pendingProps,
              f = S(b);f = R(b, f);d = d(e, f);b.effectTag |= 1;"object" === typeof d && null !== d && "function" === typeof d.render && void 0 === d.$$typeof ? (f = b.type, b.tag = 2, b.memoizedState = null !== d.state && void 0 !== d.state ? d.state : null, "function" === typeof f.getDerivedStateFromProps && (e = Kc(b, d, e, b.memoizedState), null !== e && void 0 !== e && (b.memoizedState = A({}, b.memoizedState, e))), e = u(b), Jc(b, d), Db(b, c), a = l(a, b, !0, e, !1, c)) : (b.tag = 1, g(a, b, d), b.memoizedProps = e, a = b.child);return a;case 1:
          return e = b.type, c = b.pendingProps, q() || b.memoizedProps !== c ? (d = S(b), d = R(b, d), e = e(c, d), b.effectTag |= 1, g(a, b, e), b.memoizedProps = c, a = b.child) : a = r(a, b), a;case 2:
          e = u(b);null === a ? null === b.stateNode ? (Lc(b, b.pendingProps), Db(b, c), d = !0) : d = Mc(b, c) : d = Eb(a, b, c);f = !1;var h = b.updateQueue;null !== h && null !== h.capturedValues && (f = d = !0);return l(a, b, d, e, f, c);case 3:
          a: if (p(b), d = b.updateQueue, null !== d) {
            f = b.memoizedState;e = Re(a, b, d, null, null, c);b.memoizedState = e;d = b.updateQueue;if (null !== d && null !== d.capturedValues) d = null;else if (f === e) {
              Wa();a = r(a, b);break a;
            } else d = e.element;f = b.stateNode;(null === a || null === a.child) && f.hydrate && H(b) ? (b.effectTag |= 2, b.child = Ze(b, null, d, c)) : (Wa(), g(a, b, d));b.memoizedState = e;a = b.child;
          } else Wa(), a = r(a, b);return a;case 5:
          a: {
            x(b);null === a && Cb(b);e = b.type;h = b.memoizedProps;d = b.pendingProps;f = null !== a ? a.memoizedProps : null;if (!q() && h === d) {
              if (h = b.mode & 1 && n(e, d)) b.expirationTime = 1073741823;if (!h || 1073741823 !== c) {
                a = r(a, b);break a;
              }
            }h = d.children;Q(e, d) ? h = null : f && Q(e, f) && (b.effectTag |= 16);v(a, b);1073741823 !== c && b.mode & 1 && n(e, d) ? (b.expirationTime = 1073741823, b.memoizedProps = d, a = null) : (g(a, b, h), b.memoizedProps = d, a = b.child);
          }return a;case 6:
          return null === a && Cb(b), b.memoizedProps = b.pendingProps, null;case 8:
          b.tag = 7;case 7:
          return e = b.pendingProps, q() || b.memoizedProps !== e || (e = b.memoizedProps), d = e.children, b.stateNode = null === a ? Ze(b, b.stateNode, d, c) : Ye(b, a.stateNode, d, c), b.memoizedProps = e, b.stateNode;case 9:
          return null;case 4:
          return Y(b, b.stateNode.containerInfo), e = b.pendingProps, q() || b.memoizedProps !== e ? (null === a ? b.child = Ye(b, null, e, c) : g(a, b, e), b.memoizedProps = e, a = b.child) : a = r(a, b), a;case 14:
          return c = b.type.render, c = c(b.pendingProps, b.ref), g(a, b, c), b.memoizedProps = c, b.child;case 10:
          return c = b.pendingProps, q() || b.memoizedProps !== c ? (g(a, b, c), b.memoizedProps = c, a = b.child) : a = r(a, b), a;case 11:
          return c = b.pendingProps.children, q() || null !== c && b.memoizedProps !== c ? (g(a, b, c), b.memoizedProps = c, a = b.child) : a = r(a, b), a;case 13:
          return B(a, b, c);case 12:
          a: {
            d = b.type;f = b.pendingProps;h = b.memoizedProps;e = d._currentValue;var t = d._changedBits;if (q() || 0 !== t || h !== f) {
              b.memoizedProps = f;var k = f.unstable_observedBits;if (void 0 === k || null === k) k = 1073741823;b.stateNode = k;if (0 !== (t & k)) z(b, d, t, c);else if (h === f) {
                a = r(a, b);break a;
              }c = f.children;c = c(e);g(a, b, c);a = b.child;
            } else a = r(a, b);
          }return a;default:
          D("156");}
    } };
}
function af(a, b, c, d, e) {
  function f(a) {
    a.effectTag |= 4;
  }var h = a.createInstance,
      g = a.createTextInstance,
      k = a.appendInitialChild,
      v = a.finalizeInitialChildren,
      l = a.prepareUpdate,
      p = a.persistence,
      z = b.getRootHostContainer,
      B = b.popHostContext,
      r = b.getHostContext,
      Q = b.popHostContainer,
      n = c.popContextProvider,
      x = c.popTopLevelContextObject,
      Y = d.popProvider,
      G = e.prepareToHydrateHostInstance,
      R = e.prepareToHydrateHostTextInstance,
      S = e.popHydrationState,
      q = void 0,
      u = void 0,
      t = void 0;a.mutation ? (q = function () {}, u = function (a, b, c) {
    (b.updateQueue = c) && f(b);
  }, t = function (a, b, c, d) {
    c !== d && f(b);
  }) : p ? D("235") : D("236");return { completeWork: function (a, b, c) {
      var d = b.pendingProps;switch (b.tag) {case 1:
          return null;case 2:
          return n(b), a = b.stateNode, d = b.updateQueue, null !== d && null !== d.capturedValues && (b.effectTag &= -65, "function" === typeof a.componentDidCatch ? b.effectTag |= 256 : d.capturedValues = null), null;case 3:
          Q(b);x(b);d = b.stateNode;d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);if (null === a || null === a.child) S(b), b.effectTag &= -3;q(b);a = b.updateQueue;
          null !== a && null !== a.capturedValues && (b.effectTag |= 256);return null;case 5:
          B(b);c = z();var e = b.type;if (null !== a && null != b.stateNode) {
            var p = a.memoizedProps,
                H = b.stateNode,
                y = r();H = l(H, e, p, d, c, y);u(a, b, H, e, p, d, c, y);a.ref !== b.ref && (b.effectTag |= 128);
          } else {
            if (!d) return null === b.stateNode ? D("166") : void 0, null;a = r();if (S(b)) G(b, c, a) && f(b);else {
              p = h(e, d, c, a, b);a: for (y = b.child; null !== y;) {
                if (5 === y.tag || 6 === y.tag) k(p, y.stateNode);else if (4 !== y.tag && null !== y.child) {
                  y.child["return"] = y;y = y.child;continue;
                }if (y === b) break;
                for (; null === y.sibling;) {
                  if (null === y["return"] || y["return"] === b) break a;y = y["return"];
                }y.sibling["return"] = y["return"];y = y.sibling;
              }v(p, e, d, c, a) && f(b);b.stateNode = p;
            }null !== b.ref && (b.effectTag |= 128);
          }return null;case 6:
          if (a && null != b.stateNode) t(a, b, a.memoizedProps, d);else {
            if ("string" !== typeof d) return null === b.stateNode ? D("166") : void 0, null;a = z();c = r();S(b) ? R(b) && f(b) : b.stateNode = g(d, a, c, b);
          }return null;case 7:
          (d = b.memoizedProps) ? void 0 : D("165");b.tag = 8;e = [];a: for ((p = b.stateNode) && (p["return"] = b); null !== p;) {
            if (5 === p.tag || 6 === p.tag || 4 === p.tag) D("247");else if (9 === p.tag) e.push(p.pendingProps.value);else if (null !== p.child) {
              p.child["return"] = p;p = p.child;continue;
            }for (; null === p.sibling;) {
              if (null === p["return"] || p["return"] === b) break a;p = p["return"];
            }p.sibling["return"] = p["return"];p = p.sibling;
          }p = d.handler;d = p(d.props, e);b.child = Ye(b, null !== a ? a.child : null, d, c);return b.child;case 8:
          return b.tag = 7, null;case 9:
          return null;case 14:
          return null;case 10:
          return null;case 11:
          return null;case 4:
          return Q(b), q(b), null;
        case 13:
          return Y(b), null;case 12:
          return null;case 0:
          D("167");default:
          D("156");}
    } };
}
function bf(a, b, c, d, e) {
  var f = a.popHostContainer,
      h = a.popHostContext,
      g = b.popContextProvider,
      k = b.popTopLevelContextObject,
      v = c.popProvider;return { throwException: function (a, b, c) {
      b.effectTag |= 512;b.firstEffect = b.lastEffect = null;b = { value: c, source: b, stack: Bc(b) };do {
        switch (a.tag) {case 3:
            Oe(a);a.updateQueue.capturedValues = [b];a.effectTag |= 1024;return;case 2:
            if (c = a.stateNode, 0 === (a.effectTag & 64) && null !== c && "function" === typeof c.componentDidCatch && !e(c)) {
              Oe(a);c = a.updateQueue;var d = c.capturedValues;null === d ? c.capturedValues = [b] : d.push(b);a.effectTag |= 1024;return;
            }}a = a["return"];
      } while (null !== a);
    }, unwindWork: function (a) {
      switch (a.tag) {case 2:
          g(a);var b = a.effectTag;return b & 1024 ? (a.effectTag = b & -1025 | 64, a) : null;case 3:
          return f(a), k(a), b = a.effectTag, b & 1024 ? (a.effectTag = b & -1025 | 64, a) : null;case 5:
          return h(a), null;case 4:
          return f(a), null;case 13:
          return v(a), null;default:
          return null;}
    }, unwindInterruptedWork: function (a) {
      switch (a.tag) {case 2:
          g(a);break;case 3:
          f(a);k(a);break;case 5:
          h(a);break;case 4:
          f(a);break;case 13:
          v(a);}
    } };
}
function cf(a, b) {
  var c = b.source;null === b.stack && Bc(c);null !== c && Ac(c);b = b.value;null !== a && 2 === a.tag && Ac(a);try {
    b && b.suppressReactErrorLogging || console.error(b);
  } catch (d) {
    d && d.suppressReactErrorLogging || console.error(d);
  }
}
function df(a, b, c, d, e) {
  function f(a) {
    var c = a.ref;if (null !== c) if ("function" === typeof c) try {
      c(null);
    } catch (t) {
      b(a, t);
    } else c.current = null;
  }function h(a) {
    "function" === typeof Je && Je(a);switch (a.tag) {case 2:
        f(a);var c = a.stateNode;if ("function" === typeof c.componentWillUnmount) try {
          c.props = a.memoizedProps, c.state = a.memoizedState, c.componentWillUnmount();
        } catch (t) {
          b(a, t);
        }break;case 5:
        f(a);break;case 7:
        g(a.stateNode);break;case 4:
        p && v(a);}
  }function g(a) {
    for (var b = a;;) if (h(b), null === b.child || p && 4 === b.tag) {
      if (b === a) break;for (; null === b.sibling;) {
        if (null === b["return"] || b["return"] === a) return;b = b["return"];
      }b.sibling["return"] = b["return"];b = b.sibling;
    } else b.child["return"] = b, b = b.child;
  }function k(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
  }function v(a) {
    for (var b = a, c = !1, d = void 0, e = void 0;;) {
      if (!c) {
        c = b["return"];a: for (;;) {
          null === c ? D("160") : void 0;switch (c.tag) {case 5:
              d = c.stateNode;e = !1;break a;case 3:
              d = c.stateNode.containerInfo;e = !0;break a;case 4:
              d = c.stateNode.containerInfo;e = !0;break a;}c = c["return"];
        }c = !0;
      }if (5 === b.tag || 6 === b.tag) g(b), e ? S(d, b.stateNode) : R(d, b.stateNode);else if (4 === b.tag ? d = b.stateNode.containerInfo : h(b), null !== b.child) {
        b.child["return"] = b;b = b.child;continue;
      }if (b === a) break;for (; null === b.sibling;) {
        if (null === b["return"] || b["return"] === a) return;b = b["return"];4 === b.tag && (c = !1);
      }b.sibling["return"] = b["return"];b = b.sibling;
    }
  }var l = a.getPublicInstance,
      p = a.mutation;a = a.persistence;p || (a ? D("235") : D("236"));var z = p.commitMount,
      B = p.commitUpdate,
      r = p.resetTextContent,
      Q = p.commitTextUpdate,
      n = p.appendChild,
      x = p.appendChildToContainer,
      Y = p.insertBefore,
      G = p.insertInContainerBefore,
      R = p.removeChild,
      S = p.removeChildFromContainer;return { commitBeforeMutationLifeCycles: function (a, b) {
      switch (b.tag) {case 2:
          if (b.effectTag & 2048 && null !== a) {
            var c = a.memoizedProps,
                d = a.memoizedState;a = b.stateNode;a.props = b.memoizedProps;a.state = b.memoizedState;b = a.getSnapshotBeforeUpdate(c, d);a.__reactInternalSnapshotBeforeUpdate = b;
          }break;case 3:case 5:case 6:case 4:
          break;default:
          D("163");}
    }, commitResetTextContent: function (a) {
      r(a.stateNode);
    },
    commitPlacement: function (a) {
      a: {
        for (var b = a["return"]; null !== b;) {
          if (k(b)) {
            var c = b;break a;
          }b = b["return"];
        }D("160");c = void 0;
      }var d = b = void 0;switch (c.tag) {case 5:
          b = c.stateNode;d = !1;break;case 3:
          b = c.stateNode.containerInfo;d = !0;break;case 4:
          b = c.stateNode.containerInfo;d = !0;break;default:
          D("161");}c.effectTag & 16 && (r(b), c.effectTag &= -17);a: b: for (c = a;;) {
        for (; null === c.sibling;) {
          if (null === c["return"] || k(c["return"])) {
            c = null;break a;
          }c = c["return"];
        }c.sibling["return"] = c["return"];for (c = c.sibling; 5 !== c.tag && 6 !== c.tag;) {
          if (c.effectTag & 2) continue b;if (null === c.child || 4 === c.tag) continue b;else c.child["return"] = c, c = c.child;
        }if (!(c.effectTag & 2)) {
          c = c.stateNode;break a;
        }
      }for (var e = a;;) {
        if (5 === e.tag || 6 === e.tag) c ? d ? G(b, e.stateNode, c) : Y(b, e.stateNode, c) : d ? x(b, e.stateNode) : n(b, e.stateNode);else if (4 !== e.tag && null !== e.child) {
          e.child["return"] = e;e = e.child;continue;
        }if (e === a) break;for (; null === e.sibling;) {
          if (null === e["return"] || e["return"] === a) return;e = e["return"];
        }e.sibling["return"] = e["return"];e = e.sibling;
      }
    }, commitDeletion: function (a) {
      v(a);
      a["return"] = null;a.child = null;a.alternate && (a.alternate.child = null, a.alternate["return"] = null);
    }, commitWork: function (a, b) {
      switch (b.tag) {case 2:
          break;case 5:
          var c = b.stateNode;if (null != c) {
            var d = b.memoizedProps;a = null !== a ? a.memoizedProps : d;var e = b.type,
                f = b.updateQueue;b.updateQueue = null;null !== f && B(c, f, e, a, d, b);
          }break;case 6:
          null === b.stateNode ? D("162") : void 0;c = b.memoizedProps;Q(b.stateNode, null !== a ? a.memoizedProps : c, c);break;case 3:
          break;default:
          D("163");}
    }, commitLifeCycles: function (a, b, c) {
      switch (c.tag) {case 2:
          a = c.stateNode;if (c.effectTag & 4) if (null === b) a.props = c.memoizedProps, a.state = c.memoizedState, a.componentDidMount();else {
            var d = b.memoizedProps;b = b.memoizedState;a.props = c.memoizedProps;a.state = c.memoizedState;a.componentDidUpdate(d, b, a.__reactInternalSnapshotBeforeUpdate);
          }c = c.updateQueue;null !== c && Se(c, a);break;case 3:
          b = c.updateQueue;if (null !== b) {
            a = null;if (null !== c.child) switch (c.child.tag) {case 5:
                a = l(c.child.stateNode);break;case 2:
                a = c.child.stateNode;}Se(b, a);
          }break;case 5:
          a = c.stateNode;null === b && c.effectTag & 4 && z(a, c.type, c.memoizedProps, c);break;case 6:
          break;case 4:
          break;default:
          D("163");}
    }, commitErrorLogging: function (a, b) {
      switch (a.tag) {case 2:
          var c = a.type;b = a.stateNode;var d = a.updateQueue;null === d || null === d.capturedValues ? D("264") : void 0;var f = d.capturedValues;d.capturedValues = null;"function" !== typeof c.getDerivedStateFromCatch && e(b);b.props = a.memoizedProps;b.state = a.memoizedState;for (c = 0; c < f.length; c++) {
            d = f[c];var l = d.value,
                g = d.stack;cf(a, d);b.componentDidCatch(l, { componentStack: null !== g ? g : "" });
          }break;
        case 3:
          c = a.updateQueue;null === c || null === c.capturedValues ? D("264") : void 0;f = c.capturedValues;c.capturedValues = null;for (c = 0; c < f.length; c++) d = f[c], cf(a, d), b(d.value);break;default:
          D("265");}
    }, commitAttachRef: function (a) {
      var b = a.ref;if (null !== b) {
        var c = a.stateNode;switch (a.tag) {case 5:
            a = l(c);break;default:
            a = c;}"function" === typeof b ? b(a) : b.current = a;
      }
    }, commitDetachRef: function (a) {
      a = a.ref;null !== a && ("function" === typeof a ? a(null) : a.current = null);
    } };
}var ef = {};
function ff(a, b) {
  function c(a) {
    a === ef ? D("174") : void 0;return a;
  }var d = a.getChildHostContext,
      e = a.getRootHostContext;a = b.createCursor;var f = b.push,
      h = b.pop,
      g = a(ef),
      k = a(ef),
      v = a(ef);return { getHostContext: function () {
      return c(g.current);
    }, getRootHostContainer: function () {
      return c(v.current);
    }, popHostContainer: function (a) {
      h(g, a);h(k, a);h(v, a);
    }, popHostContext: function (a) {
      k.current === a && (h(g, a), h(k, a));
    }, pushHostContainer: function (a, b) {
      f(v, b, a);f(k, a, a);f(g, ef, a);b = e(b);h(g, a);f(g, b, a);
    }, pushHostContext: function (a) {
      var b = c(v.current),
          e = c(g.current);b = d(e, a.type, b);e !== b && (f(k, a, a), f(g, b, a));
    } };
}
function gf(a) {
  function b(a, b) {
    var c = new xe(5, null, null, 0);c.type = "DELETED";c.stateNode = b;c["return"] = a;c.effectTag = 8;null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
  }function c(a, b) {
    switch (a.tag) {case 5:
        return b = f(b, a.type, a.pendingProps), null !== b ? (a.stateNode = b, !0) : !1;case 6:
        return b = h(b, a.pendingProps), null !== b ? (a.stateNode = b, !0) : !1;default:
        return !1;}
  }function d(a) {
    for (a = a["return"]; null !== a && 5 !== a.tag && 3 !== a.tag;) a = a["return"];p = a;
  }var e = a.shouldSetTextContent;
  a = a.hydration;if (!a) return { enterHydrationState: function () {
      return !1;
    }, resetHydrationState: function () {}, tryToClaimNextHydratableInstance: function () {}, prepareToHydrateHostInstance: function () {
      D("175");
    }, prepareToHydrateHostTextInstance: function () {
      D("176");
    }, popHydrationState: function () {
      return !1;
    } };var f = a.canHydrateInstance,
      h = a.canHydrateTextInstance,
      g = a.getNextHydratableSibling,
      k = a.getFirstHydratableChild,
      v = a.hydrateInstance,
      l = a.hydrateTextInstance,
      p = null,
      z = null,
      B = !1;return { enterHydrationState: function (a) {
      z = k(a.stateNode.containerInfo);p = a;return B = !0;
    }, resetHydrationState: function () {
      z = p = null;B = !1;
    }, tryToClaimNextHydratableInstance: function (a) {
      if (B) {
        var d = z;if (d) {
          if (!c(a, d)) {
            d = g(d);if (!d || !c(a, d)) {
              a.effectTag |= 2;B = !1;p = a;return;
            }b(p, z);
          }p = a;z = k(d);
        } else a.effectTag |= 2, B = !1, p = a;
      }
    }, prepareToHydrateHostInstance: function (a, b, c) {
      b = v(a.stateNode, a.type, a.memoizedProps, b, c, a);a.updateQueue = b;return null !== b ? !0 : !1;
    }, prepareToHydrateHostTextInstance: function (a) {
      return l(a.stateNode, a.memoizedProps, a);
    }, popHydrationState: function (a) {
      if (a !== p) return !1;if (!B) return d(a), B = !0, !1;var c = a.type;if (5 !== a.tag || "head" !== c && "body" !== c && !e(c, a.memoizedProps)) for (c = z; c;) b(a, c), c = g(c);d(a);z = p ? g(a.stateNode) : null;return !0;
    } };
}
function hf(a) {
  function b(a, b, c) {
    a = a.stateNode;a.__reactInternalMemoizedUnmaskedChildContext = b;a.__reactInternalMemoizedMaskedChildContext = c;
  }function c(a) {
    return 2 === a.tag && null != a.type.childContextTypes;
  }function d(a, b) {
    var c = a.stateNode,
        d = a.type.childContextTypes;if ("function" !== typeof c.getChildContext) return b;c = c.getChildContext();for (var e in c) e in d ? void 0 : D("108", Ac(a) || "Unknown", e);return A({}, b, c);
  }var e = a.createCursor,
      f = a.push,
      h = a.pop,
      g = e(ka),
      k = e(!1),
      v = ka;return { getUnmaskedContext: function (a) {
      return c(a) ? v : g.current;
    }, cacheContext: b, getMaskedContext: function (a, c) {
      var d = a.type.contextTypes;if (!d) return ka;var e = a.stateNode;if (e && e.__reactInternalMemoizedUnmaskedChildContext === c) return e.__reactInternalMemoizedMaskedChildContext;var f = {},
          g;for (g in d) f[g] = c[g];e && b(a, c, f);return f;
    }, hasContextChanged: function () {
      return k.current;
    }, isContextConsumer: function (a) {
      return 2 === a.tag && null != a.type.contextTypes;
    }, isContextProvider: c, popContextProvider: function (a) {
      c(a) && (h(k, a), h(g, a));
    }, popTopLevelContextObject: function (a) {
      h(k, a);h(g, a);
    }, pushTopLevelContextObject: function (a, b, c) {
      null != g.cursor ? D("168") : void 0;f(g, b, a);f(k, c, a);
    }, processChildContext: d, pushContextProvider: function (a) {
      if (!c(a)) return !1;var b = a.stateNode;b = b && b.__reactInternalMemoizedMergedChildContext || ka;v = g.current;f(g, b, a);f(k, k.current, a);return !0;
    }, invalidateContextProvider: function (a, b) {
      var c = a.stateNode;c ? void 0 : D("169");if (b) {
        var e = d(a, v);c.__reactInternalMemoizedMergedChildContext = e;h(k, a);h(g, a);f(g, e, a);
      } else h(k, a);f(k, b, a);
    }, findCurrentUnmaskedContext: function (a) {
      for (2 !== xd(a) || 2 !== a.tag ? D("170") : void 0; 3 !== a.tag;) {
        if (c(a)) return a.stateNode.__reactInternalMemoizedMergedChildContext;(a = a["return"]) ? void 0 : D("171");
      }return a.stateNode.context;
    } };
}
function jf(a) {
  var b = a.createCursor,
      c = a.push,
      d = a.pop,
      e = b(null),
      f = b(null),
      h = b(0);return { pushProvider: function (a) {
      var b = a.type._context;c(h, b._changedBits, a);c(f, b._currentValue, a);c(e, a, a);b._currentValue = a.pendingProps.value;b._changedBits = a.stateNode;
    }, popProvider: function (a) {
      var b = h.current,
          c = f.current;d(e, a);d(f, a);d(h, a);a = a.type._context;a._currentValue = c;a._changedBits = b;
    } };
}
function kf() {
  var a = [],
      b = -1;return { createCursor: function (a) {
      return { current: a };
    }, isEmpty: function () {
      return -1 === b;
    }, pop: function (c) {
      0 > b || (c.current = a[b], a[b] = null, b--);
    }, push: function (c, d) {
      b++;a[b] = c.current;c.current = d;
    }, checkThatStackIsEmpty: function () {}, resetStackAfterFatalErrorInDev: function () {} };
}
function lf(a) {
  function b() {
    if (null !== I) for (var a = I["return"]; null !== a;) Lc(a), a = a["return"];Ya = null;Z = 0;I = null;Nc = !1;
  }function c(a) {
    return null !== ya && ya.has(a);
  }function d(a) {
    for (;;) {
      var b = a.alternate,
          c = a["return"],
          d = a.sibling;if (0 === (a.effectTag & 512)) {
        b = Cb(b, a, Z);var e = a;if (1073741823 === Z || 1073741823 !== e.expirationTime) {
          b: switch (e.tag) {case 3:case 2:
              var f = e.updateQueue;f = null === f ? 0 : f.expirationTime;break b;default:
              f = 0;}for (var g = e.child; null !== g;) 0 !== g.expirationTime && (0 === f || f > g.expirationTime) && (f = g.expirationTime), g = g.sibling;e.expirationTime = f;
        }if (null !== b) return b;null !== c && 0 === (c.effectTag & 512) && (null === c.firstEffect && (c.firstEffect = a.firstEffect), null !== a.lastEffect && (null !== c.lastEffect && (c.lastEffect.nextEffect = a.firstEffect), c.lastEffect = a.lastEffect), 1 < a.effectTag && (null !== c.lastEffect ? c.lastEffect.nextEffect = a : c.firstEffect = a, c.lastEffect = a));if (null !== d) return d;if (null !== c) a = c;else {
          Nc = !0;break;
        }
      } else {
        a = Kc(a);if (null !== a) return a.effectTag &= 2559, a;null !== c && (c.firstEffect = c.lastEffect = null, c.effectTag |= 512);if (null !== d) return d;if (null !== c) a = c;else break;
      }
    }return null;
  }function e(a) {
    var b = Wa(a.alternate, a, Z);null === b && (b = d(a));nc.current = null;return b;
  }function f(a, c, f) {
    ca ? D("243") : void 0;ca = !0;if (c !== Z || a !== Ya || null === I) b(), Ya = a, Z = c, I = ze(Ya.current, null, Z), a.pendingCommitExpirationTime = 0;var g = !1;do {
      try {
        if (f) for (; null !== I && !S();) I = e(I);else for (; null !== I;) I = e(I);
      } catch (Oc) {
        if (null === I) {
          g = !0;q(Oc);break;
        }f = I;var h = f["return"];if (null === h) {
          g = !0;q(Oc);break;
        }Jc(h, f, Oc);I = d(f);
      }break;
    } while (1);
    ca = !1;if (g || null !== I) return null;if (Nc) return a.pendingCommitExpirationTime = c, a.current.alternate;D("262");
  }function h(a, b, c, d) {
    a = { value: c, source: a, stack: Bc(a) };Pe(b, { expirationTime: d, partialState: null, callback: null, isReplace: !1, isForced: !1, capturedValue: a, next: null });v(b, d);
  }function g(a, b) {
    a: {
      ca && !Za ? D("263") : void 0;for (var d = a["return"]; null !== d;) {
        switch (d.tag) {case 2:
            var e = d.stateNode;if ("function" === typeof d.type.getDerivedStateFromCatch || "function" === typeof e.componentDidCatch && !c(e)) {
              h(a, d, b, 1);a = void 0;break a;
            }break;case 3:
            h(a, d, b, 1);a = void 0;break a;}d = d["return"];
      }3 === a.tag && h(a, a, b, 1);a = void 0;
    }return a;
  }function k(a) {
    a = 0 !== ia ? ia : ca ? Za ? 1 : Z : a.mode & 1 ? za ? 10 * (((l() + 15) / 10 | 0) + 1) : 25 * (((l() + 500) / 25 | 0) + 1) : 1;za && (0 === da || a > da) && (da = a);return a;
  }function v(a, c) {
    a: {
      for (; null !== a;) {
        if (0 === a.expirationTime || a.expirationTime > c) a.expirationTime = c;null !== a.alternate && (0 === a.alternate.expirationTime || a.alternate.expirationTime > c) && (a.alternate.expirationTime = c);if (null === a["return"]) if (3 === a.tag) {
          var d = a.stateNode;!ca && 0 !== Z && c < Z && b();ca && !Za && Ya === d || B(d, c);Fb > xg && D("185");
        } else {
          c = void 0;break a;
        }a = a["return"];
      }c = void 0;
    }return c;
  }function l() {
    ye = Ic() - Pc;return yg = (ye / 10 | 0) + 2;
  }function p(a, b, c, d, e) {
    var f = ia;ia = 1;try {
      return a(b, c, d, e);
    } finally {
      ia = f;
    }
  }function z(a) {
    if (0 !== Gb) {
      if (a > Gb) return;mg(Qc);
    }var b = Ic() - Pc;Gb = a;Qc = lg(Q, { timeout: 10 * (a - 2) - b });
  }function B(a, b) {
    if (null === a.nextScheduledRoot) a.remainingExpirationTime = b, null === K ? (la = K = a, a.nextScheduledRoot = a) : (K = K.nextScheduledRoot = a, K.nextScheduledRoot = la);else {
      var c = a.remainingExpirationTime;if (0 === c || b < c) a.remainingExpirationTime = b;
    }T || (J ? Hb && (aa = a, P = 1, G(a, 1, !1)) : 1 === b ? n() : z(b));
  }function r() {
    var a = 0,
        b = null;if (null !== K) for (var c = K, d = la; null !== d;) {
      var e = d.remainingExpirationTime;if (0 === e) {
        null === c || null === K ? D("244") : void 0;if (d === d.nextScheduledRoot) {
          la = K = d.nextScheduledRoot = null;break;
        } else if (d === la) la = e = d.nextScheduledRoot, K.nextScheduledRoot = e, d.nextScheduledRoot = null;else if (d === K) {
          K = c;K.nextScheduledRoot = la;d.nextScheduledRoot = null;break;
        } else c.nextScheduledRoot = d.nextScheduledRoot, d.nextScheduledRoot = null;d = c.nextScheduledRoot;
      } else {
        if (0 === a || e < a) a = e, b = d;if (d === K) break;c = d;d = d.nextScheduledRoot;
      }
    }c = aa;null !== c && c === b && 1 === a ? Fb++ : Fb = 0;aa = b;P = a;
  }function Q(a) {
    x(0, !0, a);
  }function n() {
    x(1, !1, null);
  }function x(a, b, c) {
    $a = c;r();if (b) for (; null !== aa && 0 !== P && (0 === a || a >= P) && (!Ib || l() >= P);) G(aa, P, !Ib), r();else for (; null !== aa && 0 !== P && (0 === a || a >= P);) G(aa, P, !1), r();null !== $a && (Gb = 0, Qc = -1);0 !== P && z(P);$a = null;Ib = !1;Y();
  }function Y() {
    Fb = 0;if (null !== Aa) {
      var a = Aa;Aa = null;for (var b = 0; b < a.length; b++) {
        var c = a[b];try {
          c._onComplete();
        } catch (wg) {
          Ba || (Ba = !0, Jb = wg);
        }
      }
    }if (Ba) throw a = Jb, Jb = null, Ba = !1, a;
  }function G(a, b, c) {
    T ? D("245") : void 0;T = !0;c ? (c = a.finishedWork, null !== c ? R(a, c, b) : (a.finishedWork = null, c = f(a, b, !0), null !== c && (S() ? a.finishedWork = c : R(a, c, b)))) : (c = a.finishedWork, null !== c ? R(a, c, b) : (a.finishedWork = null, c = f(a, b, !1), null !== c && R(a, c, b)));T = !1;
  }function R(a, b, c) {
    var d = a.firstBatch;if (null !== d && d._expirationTime <= c && (null === Aa ? Aa = [d] : Aa.push(d), d._defer)) {
      a.finishedWork = b;a.remainingExpirationTime = 0;return;
    }a.finishedWork = null;Za = ca = !0;c = b.stateNode;c.current === b ? D("177") : void 0;d = c.pendingCommitExpirationTime;0 === d ? D("261") : void 0;c.pendingCommitExpirationTime = 0;var e = l();nc.current = null;if (1 < b.effectTag) {
      if (null !== b.lastEffect) {
        b.lastEffect.nextEffect = b;var f = b.firstEffect;
      } else f = b;
    } else f = b.firstEffect;zg(c.containerInfo);for (w = f; null !== w;) {
      var h = !1,
          k = void 0;try {
        for (; null !== w;) w.effectTag & 2048 && Db(w.alternate, w), w = w.nextEffect;
      } catch (ab) {
        h = !0, k = ab;
      }h && (null === w ? D("178") : void 0, g(w, k), null !== w && (w = w.nextEffect));
    }for (w = f; null !== w;) {
      h = !1;k = void 0;try {
        for (; null !== w;) {
          var p = w.effectTag;p & 16 && Mc(w);if (p & 128) {
            var n = w.alternate;null !== n && kg(n);
          }switch (p & 14) {case 2:
              Eb(w);w.effectTag &= -3;break;case 6:
              Eb(w);w.effectTag &= -3;we(w.alternate, w);break;case 4:
              we(w.alternate, w);break;case 8:
              gg(w);}w = w.nextEffect;
        }
      } catch (ab) {
        h = !0, k = ab;
      }h && (null === w ? D("178") : void 0, g(w, k), null !== w && (w = w.nextEffect));
    }Ag(c.containerInfo);c.current = b;for (w = f; null !== w;) {
      p = !1;n = void 0;try {
        for (f = c, h = e, k = d; null !== w;) {
          var r = w.effectTag;
          r & 36 && hg(f, w.alternate, w, h, k);r & 256 && ig(w, q);r & 128 && jg(w);var t = w.nextEffect;w.nextEffect = null;w = t;
        }
      } catch (ab) {
        p = !0, n = ab;
      }p && (null === w ? D("178") : void 0, g(w, n), null !== w && (w = w.nextEffect));
    }ca = Za = !1;"function" === typeof Ie && Ie(b.stateNode);b = c.current.expirationTime;0 === b && (ya = null);a.remainingExpirationTime = b;
  }function S() {
    return null === $a || $a.timeRemaining() > Bg ? !1 : Ib = !0;
  }function q(a) {
    null === aa ? D("246") : void 0;aa.remainingExpirationTime = 0;Ba || (Ba = !0, Jb = a);
  }var u = kf(),
      t = ff(a, u),
      y = hf(u);u = jf(u);var H = gf(a),
      Wa = $e(a, t, y, u, H, v, k).beginWork,
      Cb = af(a, t, y, u, H).completeWork;t = bf(t, y, u, v, c);var Jc = t.throwException,
      Kc = t.unwindWork,
      Lc = t.unwindInterruptedWork;t = df(a, g, v, k, function (a) {
    null === ya ? ya = new Set([a]) : ya.add(a);
  }, l);var Db = t.commitBeforeMutationLifeCycles,
      Mc = t.commitResetTextContent,
      Eb = t.commitPlacement,
      gg = t.commitDeletion,
      we = t.commitWork,
      hg = t.commitLifeCycles,
      ig = t.commitErrorLogging,
      jg = t.commitAttachRef,
      kg = t.commitDetachRef,
      Ic = a.now,
      lg = a.scheduleDeferredCallback,
      mg = a.cancelDeferredCallback,
      zg = a.prepareForCommit,
      Ag = a.resetAfterCommit,
      Pc = Ic(),
      yg = 2,
      ye = Pc,
      Rc = 0,
      ia = 0,
      ca = !1,
      I = null,
      Ya = null,
      Z = 0,
      w = null,
      Za = !1,
      Nc = !1,
      ya = null,
      la = null,
      K = null,
      Gb = 0,
      Qc = -1,
      T = !1,
      aa = null,
      P = 0,
      da = 0,
      Ib = !1,
      Ba = !1,
      Jb = null,
      $a = null,
      J = !1,
      Hb = !1,
      za = !1,
      Aa = null,
      xg = 1E3,
      Fb = 0,
      Bg = 1;return { recalculateCurrentTime: l, computeExpirationForFiber: k, scheduleWork: v, requestWork: B, flushRoot: function (a, b) {
      T ? D("253") : void 0;aa = a;P = b;G(a, b, !1);n();Y();
    }, batchedUpdates: function (a, b) {
      var c = J;J = !0;try {
        return a(b);
      } finally {
        (J = c) || T || n();
      }
    }, unbatchedUpdates: function (a, b) {
      if (J && !Hb) {
        Hb = !0;try {
          return a(b);
        } finally {
          Hb = !1;
        }
      }return a(b);
    }, flushSync: function (a, b) {
      T ? D("187") : void 0;var c = J;J = !0;try {
        return p(a, b);
      } finally {
        J = c, n();
      }
    }, flushControlled: function (a) {
      var b = J;J = !0;try {
        p(a);
      } finally {
        (J = b) || T || x(1, !1, null);
      }
    }, deferredUpdates: function (a) {
      var b = ia;ia = 25 * (((l() + 500) / 25 | 0) + 1);try {
        return a();
      } finally {
        ia = b;
      }
    }, syncUpdates: p, interactiveUpdates: function (a, b, c) {
      if (za) return a(b, c);J || T || 0 === da || (x(da, !1, null), da = 0);var d = za,
          e = J;J = za = !0;try {
        return a(b, c);
      } finally {
        za = d, (J = e) || T || n();
      }
    }, flushInteractiveUpdates: function () {
      T || 0 === da || (x(da, !1, null), da = 0);
    }, computeUniqueAsyncExpiration: function () {
      var a = 25 * (((l() + 500) / 25 | 0) + 1);a <= Rc && (a = Rc + 1);return Rc = a;
    }, legacyContext: y };
}
function mf(a) {
  function b(a, b, c, d, e, h) {
    d = b.current;if (c) {
      c = c._reactInternalFiber;var l = g(c);c = k(c) ? v(c, l) : l;
    } else c = ka;null === b.context ? b.context = c : b.pendingContext = c;b = h;Pe(d, { expirationTime: e, partialState: { element: a }, callback: void 0 === b ? null : b, isReplace: !1, isForced: !1, capturedValue: null, next: null });f(d, e);return e;
  }var c = a.getPublicInstance;a = lf(a);var d = a.recalculateCurrentTime,
      e = a.computeExpirationForFiber,
      f = a.scheduleWork,
      h = a.legacyContext,
      g = h.findCurrentUnmaskedContext,
      k = h.isContextProvider,
      v = h.processChildContext;return { createContainer: function (a, b, c) {
      b = new xe(3, null, null, b ? 3 : 0);a = { current: b, containerInfo: a, pendingChildren: null, pendingCommitExpirationTime: 0, finishedWork: null, context: null, pendingContext: null, hydrate: c, remainingExpirationTime: 0, firstBatch: null, nextScheduledRoot: null };return b.stateNode = a;
    }, updateContainer: function (a, c, f, h) {
      var g = c.current,
          k = d();g = e(g);return b(a, c, f, k, g, h);
    }, updateContainerAtExpirationTime: function (a, c, e, f, g) {
      var h = d();return b(a, c, e, h, f, g);
    }, flushRoot: a.flushRoot,
    requestWork: a.requestWork, computeUniqueAsyncExpiration: a.computeUniqueAsyncExpiration, batchedUpdates: a.batchedUpdates, unbatchedUpdates: a.unbatchedUpdates, deferredUpdates: a.deferredUpdates, syncUpdates: a.syncUpdates, interactiveUpdates: a.interactiveUpdates, flushInteractiveUpdates: a.flushInteractiveUpdates, flushControlled: a.flushControlled, flushSync: a.flushSync, getPublicRootInstance: function (a) {
      a = a.current;if (!a.child) return null;switch (a.child.tag) {case 5:
          return c(a.child.stateNode);default:
          return a.child.stateNode;}
    },
    findHostInstance: function (a) {
      var b = a._reactInternalFiber;void 0 === b && ("function" === typeof a.render ? D("188") : D("268", Object.keys(a)));a = Bd(b);return null === a ? null : a.stateNode;
    }, findHostInstanceWithNoPortals: function (a) {
      a = Cd(a);return null === a ? null : a.stateNode;
    }, injectIntoDevTools: function (a) {
      var b = a.findFiberByHostInstance;return He(A({}, a, { findHostInstanceByFiber: function (a) {
          a = Bd(a);return null === a ? null : a.stateNode;
        }, findFiberByHostInstance: function (a) {
          return b ? b(a) : null;
        } }));
    } };
}
var nf = Object.freeze({ default: mf }),
    of = nf && mf || nf,
    pf = of["default"] ? of["default"] : of;function qf(a, b, c) {
  var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;return { $$typeof: rc, key: null == d ? null : "" + d, children: a, containerInfo: b, implementation: c };
}var rf = "object" === typeof performance && "function" === typeof performance.now,
    sf = void 0;sf = rf ? function () {
  return performance.now();
} : function () {
  return Date.now();
};var tf = void 0,
    uf = void 0;
if (m.canUseDOM) {
  if ("function" !== typeof requestIdleCallback || "function" !== typeof cancelIdleCallback) {
    var vf = null,
        wf = !1,
        xf = -1,
        yf = !1,
        zf = 0,
        Af = 33,
        Bf = 33,
        Cf = void 0;Cf = rf ? { didTimeout: !1, timeRemaining: function () {
        var a = zf - performance.now();return 0 < a ? a : 0;
      } } : { didTimeout: !1, timeRemaining: function () {
        var a = zf - Date.now();return 0 < a ? a : 0;
      } };var Df = "__reactIdleCallback$" + Math.random().toString(36).slice(2);window.addEventListener("message", function (a) {
      if (a.source === window && a.data === Df) {
        wf = !1;a = sf();if (0 >= zf - a) {
          if (-1 !== xf && xf <= a) Cf.didTimeout = !0;else {
            yf || (yf = !0, requestAnimationFrame(Ef));return;
          }
        } else Cf.didTimeout = !1;xf = -1;a = vf;vf = null;null !== a && a(Cf);
      }
    }, !1);var Ef = function (a) {
      yf = !1;var b = a - zf + Bf;b < Bf && Af < Bf ? (8 > b && (b = 8), Bf = b < Af ? Af : b) : Af = b;zf = a + Bf;wf || (wf = !0, window.postMessage(Df, "*"));
    };tf = function (a, b) {
      vf = a;null != b && "number" === typeof b.timeout && (xf = sf() + b.timeout);yf || (yf = !0, requestAnimationFrame(Ef));return 0;
    };uf = function () {
      vf = null;wf = !1;xf = -1;
    };
  } else tf = window.requestIdleCallback, uf = window.cancelIdleCallback;
} else tf = function (a) {
  return setTimeout(function () {
    a({ timeRemaining: function () {
        return Infinity;
      }, didTimeout: !1 });
  });
}, uf = function (a) {
  clearTimeout(a);
};function Ff(a) {
  var b = "";ea.Children.forEach(a, function (a) {
    null == a || "string" !== typeof a && "number" !== typeof a || (b += a);
  });return b;
}function Gf(a, b) {
  a = A({ children: void 0 }, b);if (b = Ff(b.children)) a.children = b;return a;
}
function Hf(a, b, c, d) {
  a = a.options;if (b) {
    b = {};for (var e = 0; e < c.length; e++) b["$" + c[e]] = !0;for (c = 0; c < a.length; c++) e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
  } else {
    c = "" + c;b = null;for (e = 0; e < a.length; e++) {
      if (a[e].value === c) {
        a[e].selected = !0;d && (a[e].defaultSelected = !0);return;
      }null !== b || a[e].disabled || (b = a[e]);
    }null !== b && (b.selected = !0);
  }
}
function If(a, b) {
  var c = b.value;a._wrapperState = { initialValue: null != c ? c : b.defaultValue, wasMultiple: !!b.multiple };
}function Jf(a, b) {
  null != b.dangerouslySetInnerHTML ? D("91") : void 0;return A({}, b, { value: void 0, defaultValue: void 0, children: "" + a._wrapperState.initialValue });
}function Kf(a, b) {
  var c = b.value;null == c && (c = b.defaultValue, b = b.children, null != b && (null != c ? D("92") : void 0, Array.isArray(b) && (1 >= b.length ? void 0 : D("93"), b = b[0]), c = "" + b), null == c && (c = ""));a._wrapperState = { initialValue: "" + c };
}
function Lf(a, b) {
  var c = b.value;null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && (a.defaultValue = c));null != b.defaultValue && (a.defaultValue = b.defaultValue);
}function Mf(a) {
  var b = a.textContent;b === a._wrapperState.initialValue && (a.value = b);
}var Nf = { html: "http://www.w3.org/1999/xhtml", mathml: "http://www.w3.org/1998/Math/MathML", svg: "http://www.w3.org/2000/svg" };
function Of(a) {
  switch (a) {case "svg":
      return "http://www.w3.org/2000/svg";case "math":
      return "http://www.w3.org/1998/Math/MathML";default:
      return "http://www.w3.org/1999/xhtml";}
}function Pf(a, b) {
  return null == a || "http://www.w3.org/1999/xhtml" === a ? Of(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var Qf = void 0,
    Rf = function (a) {
  return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function (b, c, d, e) {
    MSApp.execUnsafeLocalFunction(function () {
      return a(b, c, d, e);
    });
  } : a;
}(function (a, b) {
  if (a.namespaceURI !== Nf.svg || "innerHTML" in a) a.innerHTML = b;else {
    Qf = Qf || document.createElement("div");Qf.innerHTML = "\x3csvg\x3e" + b + "\x3c/svg\x3e";for (b = Qf.firstChild; a.firstChild;) a.removeChild(a.firstChild);for (; b.firstChild;) a.appendChild(b.firstChild);
  }
});
function Sf(a, b) {
  if (b) {
    var c = a.firstChild;if (c && c === a.lastChild && 3 === c.nodeType) {
      c.nodeValue = b;return;
    }
  }a.textContent = b;
}
var Tf = { animationIterationCount: !0, borderImageOutset: !0, borderImageSlice: !0, borderImageWidth: !0, boxFlex: !0, boxFlexGroup: !0, boxOrdinalGroup: !0, columnCount: !0, columns: !0, flex: !0, flexGrow: !0, flexPositive: !0, flexShrink: !0, flexNegative: !0, flexOrder: !0, gridRow: !0, gridRowEnd: !0, gridRowSpan: !0, gridRowStart: !0, gridColumn: !0, gridColumnEnd: !0, gridColumnSpan: !0, gridColumnStart: !0, fontWeight: !0, lineClamp: !0, lineHeight: !0, opacity: !0, order: !0, orphans: !0, tabSize: !0, widows: !0, zIndex: !0, zoom: !0, fillOpacity: !0, floodOpacity: !0,
  stopOpacity: !0, strokeDasharray: !0, strokeDashoffset: !0, strokeMiterlimit: !0, strokeOpacity: !0, strokeWidth: !0 },
    Uf = ["Webkit", "ms", "Moz", "O"];Object.keys(Tf).forEach(function (a) {
  Uf.forEach(function (b) {
    b = b + a.charAt(0).toUpperCase() + a.substring(1);Tf[b] = Tf[a];
  });
});
function Vf(a, b) {
  a = a.style;for (var c in b) if (b.hasOwnProperty(c)) {
    var d = 0 === c.indexOf("--");var e = c;var f = b[c];e = null == f || "boolean" === typeof f || "" === f ? "" : d || "number" !== typeof f || 0 === f || Tf.hasOwnProperty(e) && Tf[e] ? ("" + f).trim() : f + "px";"float" === c && (c = "cssFloat");d ? a.setProperty(c, e) : a[c] = e;
  }
}var Wf = A({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
function Xf(a, b, c) {
  b && (Wf[a] && (null != b.children || null != b.dangerouslySetInnerHTML ? D("137", a, c()) : void 0), null != b.dangerouslySetInnerHTML && (null != b.children ? D("60") : void 0, "object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML ? void 0 : D("61")), null != b.style && "object" !== typeof b.style ? D("62", c()) : void 0);
}
function Yf(a, b) {
  if (-1 === a.indexOf("-")) return "string" === typeof b.is;switch (a) {case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":
      return !1;default:
      return !0;}
}var Zf = C.thatReturns("");
function $f(a, b) {
  a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;var c = ke(a);b = va[b];for (var d = 0; d < b.length; d++) {
    var e = b[d];c.hasOwnProperty(e) && c[e] || ("topScroll" === e ? Zd("topScroll", "scroll", a) : "topFocus" === e || "topBlur" === e ? (Zd("topFocus", "focus", a), Zd("topBlur", "blur", a), c.topBlur = !0, c.topFocus = !0) : "topCancel" === e ? (ic("cancel", !0) && Zd("topCancel", "cancel", a), c.topCancel = !0) : "topClose" === e ? (ic("close", !0) && Zd("topClose", "close", a), c.topClose = !0) : fe.hasOwnProperty(e) && W(e, fe[e], a), c[e] = !0);
  }
}
function ag(a, b, c, d) {
  c = 9 === c.nodeType ? c : c.ownerDocument;d === Nf.html && (d = Of(a));d === Nf.html ? "script" === a ? (a = c.createElement("div"), a.innerHTML = "\x3cscript\x3e\x3c/script\x3e", a = a.removeChild(a.firstChild)) : a = "string" === typeof b.is ? c.createElement(a, { is: b.is }) : c.createElement(a) : a = c.createElementNS(d, a);return a;
}function bg(a, b) {
  return (9 === b.nodeType ? b : b.ownerDocument).createTextNode(a);
}
function cg(a, b, c, d) {
  var e = Yf(b, c);switch (b) {case "iframe":case "object":
      W("topLoad", "load", a);var f = c;break;case "video":case "audio":
      for (f in ge) ge.hasOwnProperty(f) && W(f, ge[f], a);f = c;break;case "source":
      W("topError", "error", a);f = c;break;case "img":case "image":case "link":
      W("topError", "error", a);W("topLoad", "load", a);f = c;break;case "form":
      W("topReset", "reset", a);W("topSubmit", "submit", a);f = c;break;case "details":
      W("topToggle", "toggle", a);f = c;break;case "input":
      Wc(a, c);f = Vc(a, c);W("topInvalid", "invalid", a);$f(d, "onChange");break;case "option":
      f = Gf(a, c);break;case "select":
      If(a, c);f = A({}, c, { value: void 0 });W("topInvalid", "invalid", a);$f(d, "onChange");break;case "textarea":
      Kf(a, c);f = Jf(a, c);W("topInvalid", "invalid", a);$f(d, "onChange");break;default:
      f = c;}Xf(b, f, Zf);var h = f,
      g;for (g in h) if (h.hasOwnProperty(g)) {
    var k = h[g];"style" === g ? Vf(a, k, Zf) : "dangerouslySetInnerHTML" === g ? (k = k ? k.__html : void 0, null != k && Rf(a, k)) : "children" === g ? "string" === typeof k ? ("textarea" !== b || "" !== k) && Sf(a, k) : "number" === typeof k && Sf(a, "" + k) : "suppressContentEditableWarning" !== g && "suppressHydrationWarning" !== g && "autoFocus" !== g && (ua.hasOwnProperty(g) ? null != k && $f(d, g) : null != k && Uc(a, g, k, e));
  }switch (b) {case "input":
      lc(a);ad(a, c);break;case "textarea":
      lc(a);Mf(a, c);break;case "option":
      null != c.value && a.setAttribute("value", c.value);break;case "select":
      a.multiple = !!c.multiple;b = c.value;null != b ? Hf(a, !!c.multiple, b, !1) : null != c.defaultValue && Hf(a, !!c.multiple, c.defaultValue, !0);break;default:
      "function" === typeof f.onClick && (a.onclick = C);}
}
function dg(a, b, c, d, e) {
  var f = null;switch (b) {case "input":
      c = Vc(a, c);d = Vc(a, d);f = [];break;case "option":
      c = Gf(a, c);d = Gf(a, d);f = [];break;case "select":
      c = A({}, c, { value: void 0 });d = A({}, d, { value: void 0 });f = [];break;case "textarea":
      c = Jf(a, c);d = Jf(a, d);f = [];break;default:
      "function" !== typeof c.onClick && "function" === typeof d.onClick && (a.onclick = C);}Xf(b, d, Zf);b = a = void 0;var h = null;for (a in c) if (!d.hasOwnProperty(a) && c.hasOwnProperty(a) && null != c[a]) if ("style" === a) {
    var g = c[a];for (b in g) g.hasOwnProperty(b) && (h || (h = {}), h[b] = "");
  } else "dangerouslySetInnerHTML" !== a && "children" !== a && "suppressContentEditableWarning" !== a && "suppressHydrationWarning" !== a && "autoFocus" !== a && (ua.hasOwnProperty(a) ? f || (f = []) : (f = f || []).push(a, null));for (a in d) {
    var k = d[a];g = null != c ? c[a] : void 0;if (d.hasOwnProperty(a) && k !== g && (null != k || null != g)) if ("style" === a) {
      if (g) {
        for (b in g) !g.hasOwnProperty(b) || k && k.hasOwnProperty(b) || (h || (h = {}), h[b] = "");for (b in k) k.hasOwnProperty(b) && g[b] !== k[b] && (h || (h = {}), h[b] = k[b]);
      } else h || (f || (f = []), f.push(a, h)), h = k;
    } else "dangerouslySetInnerHTML" === a ? (k = k ? k.__html : void 0, g = g ? g.__html : void 0, null != k && g !== k && (f = f || []).push(a, "" + k)) : "children" === a ? g === k || "string" !== typeof k && "number" !== typeof k || (f = f || []).push(a, "" + k) : "suppressContentEditableWarning" !== a && "suppressHydrationWarning" !== a && (ua.hasOwnProperty(a) ? (null != k && $f(e, a), f || g === k || (f = [])) : (f = f || []).push(a, k));
  }h && (f = f || []).push("style", h);return f;
}
function eg(a, b, c, d, e) {
  "input" === c && "radio" === e.type && null != e.name && Yc(a, e);Yf(c, d);d = Yf(c, e);for (var f = 0; f < b.length; f += 2) {
    var h = b[f],
        g = b[f + 1];"style" === h ? Vf(a, g, Zf) : "dangerouslySetInnerHTML" === h ? Rf(a, g) : "children" === h ? Sf(a, g) : Uc(a, h, g, d);
  }switch (c) {case "input":
      Zc(a, e);break;case "textarea":
      Lf(a, e);break;case "select":
      a._wrapperState.initialValue = void 0, b = a._wrapperState.wasMultiple, a._wrapperState.wasMultiple = !!e.multiple, c = e.value, null != c ? Hf(a, !!e.multiple, c, !1) : b !== !!e.multiple && (null != e.defaultValue ? Hf(a, !!e.multiple, e.defaultValue, !0) : Hf(a, !!e.multiple, e.multiple ? [] : "", !1));}
}
function fg(a, b, c, d, e) {
  switch (b) {case "iframe":case "object":
      W("topLoad", "load", a);break;case "video":case "audio":
      for (var f in ge) ge.hasOwnProperty(f) && W(f, ge[f], a);break;case "source":
      W("topError", "error", a);break;case "img":case "image":case "link":
      W("topError", "error", a);W("topLoad", "load", a);break;case "form":
      W("topReset", "reset", a);W("topSubmit", "submit", a);break;case "details":
      W("topToggle", "toggle", a);break;case "input":
      Wc(a, c);W("topInvalid", "invalid", a);$f(e, "onChange");break;case "select":
      If(a, c);W("topInvalid", "invalid", a);$f(e, "onChange");break;case "textarea":
      Kf(a, c), W("topInvalid", "invalid", a), $f(e, "onChange");}Xf(b, c, Zf);d = null;for (var h in c) c.hasOwnProperty(h) && (f = c[h], "children" === h ? "string" === typeof f ? a.textContent !== f && (d = ["children", f]) : "number" === typeof f && a.textContent !== "" + f && (d = ["children", "" + f]) : ua.hasOwnProperty(h) && null != f && $f(e, h));switch (b) {case "input":
      lc(a);ad(a, c);break;case "textarea":
      lc(a);Mf(a, c);break;case "select":case "option":
      break;default:
      "function" === typeof c.onClick && (a.onclick = C);}return d;
}function ng(a, b) {
  return a.nodeValue !== b;
}
var og = Object.freeze({ createElement: ag, createTextNode: bg, setInitialProperties: cg, diffProperties: dg, updateProperties: eg, diffHydratedProperties: fg, diffHydratedText: ng, warnForUnmatchedText: function () {}, warnForDeletedHydratableElement: function () {}, warnForDeletedHydratableText: function () {}, warnForInsertedHydratedElement: function () {}, warnForInsertedHydratedText: function () {}, restoreControlledState: function (a, b, c) {
    switch (b) {case "input":
        Zc(a, c);b = c.name;if ("radio" === c.type && null != b) {
          for (c = a; c.parentNode;) c = c.parentNode;c = c.querySelectorAll("input[name\x3d" + JSON.stringify("" + b) + '][type\x3d"radio"]');for (b = 0; b < c.length; b++) {
            var d = c[b];if (d !== a && d.form === a.form) {
              var e = Xa(d);e ? void 0 : D("90");mc(d);Zc(d, e);
            }
          }
        }break;case "textarea":
        Lf(a, c);break;case "select":
        b = c.value, null != b && Hf(a, !!c.multiple, b, !1);}
  } });Tb.injectFiberControlledHostComponent(og);var pg = null,
    qg = null;
function rg(a) {
  this._expirationTime = X.computeUniqueAsyncExpiration();this._root = a;this._callbacks = this._next = null;this._hasChildren = this._didComplete = !1;this._children = null;this._defer = !0;
}rg.prototype.render = function (a) {
  this._defer ? void 0 : D("250");this._hasChildren = !0;this._children = a;var b = this._root._internalRoot,
      c = this._expirationTime,
      d = new sg();X.updateContainerAtExpirationTime(a, b, null, c, d._onCommit);return d;
};
rg.prototype.then = function (a) {
  if (this._didComplete) a();else {
    var b = this._callbacks;null === b && (b = this._callbacks = []);b.push(a);
  }
};
rg.prototype.commit = function () {
  var a = this._root._internalRoot,
      b = a.firstBatch;this._defer && null !== b ? void 0 : D("251");if (this._hasChildren) {
    var c = this._expirationTime;if (b !== this) {
      this._hasChildren && (c = this._expirationTime = b._expirationTime, this.render(this._children));for (var d = null, e = b; e !== this;) d = e, e = e._next;null === d ? D("251") : void 0;d._next = e._next;this._next = b;a.firstBatch = this;
    }this._defer = !1;X.flushRoot(a, c);b = this._next;this._next = null;b = a.firstBatch = b;null !== b && b._hasChildren && b.render(b._children);
  } else this._next = null, this._defer = !1;
};rg.prototype._onComplete = function () {
  if (!this._didComplete) {
    this._didComplete = !0;var a = this._callbacks;if (null !== a) for (var b = 0; b < a.length; b++) (0, a[b])();
  }
};function sg() {
  this._callbacks = null;this._didCommit = !1;this._onCommit = this._onCommit.bind(this);
}sg.prototype.then = function (a) {
  if (this._didCommit) a();else {
    var b = this._callbacks;null === b && (b = this._callbacks = []);b.push(a);
  }
};
sg.prototype._onCommit = function () {
  if (!this._didCommit) {
    this._didCommit = !0;var a = this._callbacks;if (null !== a) for (var b = 0; b < a.length; b++) {
      var c = a[b];"function" !== typeof c ? D("191", c) : void 0;c();
    }
  }
};function tg(a, b, c) {
  this._internalRoot = X.createContainer(a, b, c);
}tg.prototype.render = function (a, b) {
  var c = this._internalRoot,
      d = new sg();b = void 0 === b ? null : b;null !== b && d.then(b);X.updateContainer(a, c, null, d._onCommit);return d;
};
tg.prototype.unmount = function (a) {
  var b = this._internalRoot,
      c = new sg();a = void 0 === a ? null : a;null !== a && c.then(a);X.updateContainer(null, b, null, c._onCommit);return c;
};tg.prototype.legacy_renderSubtreeIntoContainer = function (a, b, c) {
  var d = this._internalRoot,
      e = new sg();c = void 0 === c ? null : c;null !== c && e.then(c);X.updateContainer(b, d, a, e._onCommit);return e;
};
tg.prototype.createBatch = function () {
  var a = new rg(this),
      b = a._expirationTime,
      c = this._internalRoot,
      d = c.firstBatch;if (null === d) c.firstBatch = a, a._next = null;else {
    for (c = null; null !== d && d._expirationTime <= b;) c = d, d = d._next;a._next = d;null !== c && (c._next = a);
  }return a;
};function ug(a) {
  return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function vg(a, b) {
  switch (a) {case "button":case "input":case "select":case "textarea":
      return !!b.autoFocus;}return !1;
}
var X = pf({ getRootHostContext: function (a) {
    var b = a.nodeType;switch (b) {case 9:case 11:
        a = (a = a.documentElement) ? a.namespaceURI : Pf(null, "");break;default:
        b = 8 === b ? a.parentNode : a, a = b.namespaceURI || null, b = b.tagName, a = Pf(a, b);}return a;
  }, getChildHostContext: function (a, b) {
    return Pf(a, b);
  }, getPublicInstance: function (a) {
    return a;
  }, prepareForCommit: function () {
    pg = Vd;var a = fa();if (ne(a)) {
      if ("selectionStart" in a) var b = { start: a.selectionStart, end: a.selectionEnd };else a: {
        var c = window.getSelection && window.getSelection();
        if (c && 0 !== c.rangeCount) {
          b = c.anchorNode;var d = c.anchorOffset,
              e = c.focusNode;c = c.focusOffset;try {
            b.nodeType, e.nodeType;
          } catch (B) {
            b = null;break a;
          }var f = 0,
              h = -1,
              g = -1,
              k = 0,
              v = 0,
              l = a,
              p = null;b: for (;;) {
            for (var z;;) {
              l !== b || 0 !== d && 3 !== l.nodeType || (h = f + d);l !== e || 0 !== c && 3 !== l.nodeType || (g = f + c);3 === l.nodeType && (f += l.nodeValue.length);if (null === (z = l.firstChild)) break;p = l;l = z;
            }for (;;) {
              if (l === a) break b;p === b && ++k === d && (h = f);p === e && ++v === c && (g = f);if (null !== (z = l.nextSibling)) break;l = p;p = l.parentNode;
            }l = z;
          }b = -1 === h || -1 === g ? null : { start: h, end: g };
        } else b = null;
      }b = b || { start: 0, end: 0 };
    } else b = null;qg = { focusedElem: a, selectionRange: b };Wd(!1);
  }, resetAfterCommit: function () {
    var a = qg,
        b = fa(),
        c = a.focusedElem,
        d = a.selectionRange;if (b !== c && ja(document.documentElement, c)) {
      if (ne(c)) if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);else if (window.getSelection) {
        b = window.getSelection();var e = c[mb()].length;a = Math.min(d.start, e);d = void 0 === d.end ? a : Math.min(d.end, e);!b.extend && a > d && (e = d, d = a, a = e);e = me(c, a);var f = me(c, d);if (e && f && (1 !== b.rangeCount || b.anchorNode !== e.node || b.anchorOffset !== e.offset || b.focusNode !== f.node || b.focusOffset !== f.offset)) {
          var h = document.createRange();h.setStart(e.node, e.offset);b.removeAllRanges();a > d ? (b.addRange(h), b.extend(f.node, f.offset)) : (h.setEnd(f.node, f.offset), b.addRange(h));
        }
      }b = [];for (a = c; a = a.parentNode;) 1 === a.nodeType && b.push({ element: a, left: a.scrollLeft, top: a.scrollTop });c.focus();for (c = 0; c < b.length; c++) a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }qg = null;Wd(pg);pg = null;
  }, createInstance: function (a, b, c, d, e) {
    a = ag(a, b, c, d);a[F] = e;a[Ta] = b;return a;
  }, appendInitialChild: function (a, b) {
    a.appendChild(b);
  }, finalizeInitialChildren: function (a, b, c, d) {
    cg(a, b, c, d);return vg(b, c);
  }, prepareUpdate: function (a, b, c, d, e) {
    return dg(a, b, c, d, e);
  }, shouldSetTextContent: function (a, b) {
    return "textarea" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && "string" === typeof b.dangerouslySetInnerHTML.__html;
  }, shouldDeprioritizeSubtree: function (a, b) {
    return !!b.hidden;
  }, createTextInstance: function (a, b, c, d) {
    a = bg(a, b);a[F] = d;return a;
  }, now: sf, mutation: { commitMount: function (a, b, c) {
      vg(b, c) && a.focus();
    }, commitUpdate: function (a, b, c, d, e) {
      a[Ta] = e;eg(a, b, c, d, e);
    }, resetTextContent: function (a) {
      Sf(a, "");
    }, commitTextUpdate: function (a, b, c) {
      a.nodeValue = c;
    }, appendChild: function (a, b) {
      a.appendChild(b);
    }, appendChildToContainer: function (a, b) {
      8 === a.nodeType ? a.parentNode.insertBefore(b, a) : a.appendChild(b);
    },
    insertBefore: function (a, b, c) {
      a.insertBefore(b, c);
    }, insertInContainerBefore: function (a, b, c) {
      8 === a.nodeType ? a.parentNode.insertBefore(b, c) : a.insertBefore(b, c);
    }, removeChild: function (a, b) {
      a.removeChild(b);
    }, removeChildFromContainer: function (a, b) {
      8 === a.nodeType ? a.parentNode.removeChild(b) : a.removeChild(b);
    } }, hydration: { canHydrateInstance: function (a, b) {
      return 1 !== a.nodeType || b.toLowerCase() !== a.nodeName.toLowerCase() ? null : a;
    }, canHydrateTextInstance: function (a, b) {
      return "" === b || 3 !== a.nodeType ? null : a;
    }, getNextHydratableSibling: function (a) {
      for (a = a.nextSibling; a && 1 !== a.nodeType && 3 !== a.nodeType;) a = a.nextSibling;return a;
    }, getFirstHydratableChild: function (a) {
      for (a = a.firstChild; a && 1 !== a.nodeType && 3 !== a.nodeType;) a = a.nextSibling;return a;
    }, hydrateInstance: function (a, b, c, d, e, f) {
      a[F] = f;a[Ta] = c;return fg(a, b, c, e, d);
    }, hydrateTextInstance: function (a, b, c) {
      a[F] = c;return ng(a, b);
    }, didNotMatchHydratedContainerTextInstance: function () {}, didNotMatchHydratedTextInstance: function () {}, didNotHydrateContainerInstance: function () {}, didNotHydrateInstance: function () {},
    didNotFindHydratableContainerInstance: function () {}, didNotFindHydratableContainerTextInstance: function () {}, didNotFindHydratableInstance: function () {}, didNotFindHydratableTextInstance: function () {} }, scheduleDeferredCallback: tf, cancelDeferredCallback: uf }),
    Cg = X;ac = Cg.batchedUpdates;bc = Cg.interactiveUpdates;cc = Cg.flushInteractiveUpdates;
function Dg(a, b) {
  b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));if (!b) for (var c; c = a.lastChild;) a.removeChild(c);return new tg(a, !1, b);
}
function Eg(a, b, c, d, e) {
  ug(c) ? void 0 : D("200");var f = c._reactRootContainer;if (f) {
    if ("function" === typeof e) {
      var h = e;e = function () {
        var a = X.getPublicRootInstance(f._internalRoot);h.call(a);
      };
    }null != a ? f.legacy_renderSubtreeIntoContainer(a, b, e) : f.render(b, e);
  } else {
    f = c._reactRootContainer = Dg(c, d);if ("function" === typeof e) {
      var g = e;e = function () {
        var a = X.getPublicRootInstance(f._internalRoot);g.call(a);
      };
    }X.unbatchedUpdates(function () {
      null != a ? f.legacy_renderSubtreeIntoContainer(a, b, e) : f.render(b, e);
    });
  }return X.getPublicRootInstance(f._internalRoot);
}
function Fg(a, b) {
  var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;ug(b) ? void 0 : D("200");return qf(a, b, null, c);
}
var Gg = { createPortal: Fg, findDOMNode: function (a) {
    return null == a ? null : 1 === a.nodeType ? a : X.findHostInstance(a);
  }, hydrate: function (a, b, c) {
    return Eg(null, a, b, !0, c);
  }, render: function (a, b, c) {
    return Eg(null, a, b, !1, c);
  }, unstable_renderSubtreeIntoContainer: function (a, b, c, d) {
    null == a || void 0 === a._reactInternalFiber ? D("38") : void 0;return Eg(a, b, c, !1, d);
  }, unmountComponentAtNode: function (a) {
    ug(a) ? void 0 : D("40");return a._reactRootContainer ? (X.unbatchedUpdates(function () {
      Eg(null, null, a, !1, function () {
        a._reactRootContainer = null;
      });
    }), !0) : !1;
  }, unstable_createPortal: function () {
    return Fg.apply(void 0, arguments);
  }, unstable_batchedUpdates: X.batchedUpdates, unstable_deferredUpdates: X.deferredUpdates, flushSync: X.flushSync, unstable_flushControlled: X.flushControlled, __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED: { EventPluginHub: Ra, EventPluginRegistry: Ca, EventPropagators: kb, ReactControlledComponent: $b, ReactDOMComponentTree: bb, ReactDOMEventListener: $d }, unstable_createRoot: function (a, b) {
    return new tg(a, !0, null != b && !0 === b.hydrate);
  } };
X.injectIntoDevTools({ findFiberByHostInstance: Ua, bundleType: 0, version: "16.3.2", rendererPackageName: "react-dom" });var Hg = Object.freeze({ default: Gg }),
    Ig = Hg && Gg || Hg;module.exports = Ig["default"] ? Ig["default"] : Ig;

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

module.exports = ExecutionEnvironment;

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */

function getActiveElement(doc) /*?DOMElement*/{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);
  if (typeof doc === 'undefined') {
    return null;
  }
  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var isTextNode = __webpack_require__(381);

/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */
function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var isNode = __webpack_require__(382);

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */
function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */

function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_warning__ = __webpack_require__(124);
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}






var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  Object(__WEBPACK_IMPORTED_MODULE_3__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider() {
  var _Provider$childContex;

  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
  var subKey = arguments[1];

  var subscriptionKey = subKey || storeKey + 'Subscription';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      _classCallCheck(this, Provider);

      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

      _this[storeKey] = props.store;
      return _this;
    }

    Provider.prototype.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  if (false) {
    Provider.prototype.componentWillReceiveProps = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_2__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);

  return Provider;
}

/* harmony default export */ __webpack_exports__["b"] = (createProvider());

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(123);
var invariant = __webpack_require__(82);
var ReactPropTypesSecret = __webpack_require__(385);

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];

  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;
      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);

      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;

        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription = function () {
  function Subscription(store, parentSub, onStateChange) {
    _classCallCheck(this, Subscription);

    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  Subscription.prototype.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  Subscription.prototype.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);

      this.listeners = createListenerCollection();
    }
  };

  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeProps__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__selectorFactory__ = __webpack_require__(406);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
  };
}

function strictEqual(a, b) {
  return a === b;
}

// createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios
function createConnect() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === undefined ? __WEBPACK_IMPORTED_MODULE_0__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? __WEBPACK_IMPORTED_MODULE_3__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? __WEBPACK_IMPORTED_MODULE_2__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === undefined ? __WEBPACK_IMPORTED_MODULE_4__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === undefined ? __WEBPACK_IMPORTED_MODULE_5__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
        _ref2$pure = _ref2.pure,
        pure = _ref2$pure === undefined ? true : _ref2$pure,
        _ref2$areStatesEqual = _ref2.areStatesEqual,
        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areOwnPropsEqua,
        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areStatePropsEq,
        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? __WEBPACK_IMPORTED_MODULE_1__utils_shallowEqual__["a" /* default */] : _ref2$areMergedPropsE,
        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');

    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',

      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return 'Connect(' + name + ')';
      },

      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),

      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual

    }, extraOptions));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(189);



function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}

function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return { dispatch: dispatch };
  }) : undefined;
}

function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(394);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return symToStringTag && symToStringTag in Object(value) ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value) : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(392);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(57)))

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(186);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(396);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(399);

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ponyfill = __webpack_require__(400);

var _ponyfill2 = _interopRequireDefault(_ponyfill);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { 'default': obj };
}

var root; /* global window */

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = (0, _ponyfill2['default'])(root);
exports['default'] = result;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57), __webpack_require__(101)(module)))

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports['default'] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var _Symbol = root.Symbol;

	if (typeof _Symbol === 'function') {
		if (_Symbol.observable) {
			result = _Symbol.observable;
		} else {
			result = _Symbol('observable');
			_Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(187);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(188);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(189);


function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}

function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(190);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}

function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;

    var hasRunOnce = false;
    var mergedProps = void 0;

    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;

        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}

function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}

function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__verifySubselectors__ = __webpack_require__(407);
function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}



function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;

  var hasRunAtLeastOnce = false;
  var state = void 0;
  var ownProps = void 0;
  var stateProps = void 0;
  var dispatchProps = void 0;
  var mergedProps = void 0;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);

    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);

    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;

    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);

    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;

    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}

// TODO: Add more comments

// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;

  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(124);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

exports['default'] = thunk;

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dropdown_menu__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__timelines__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__meta__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__alerts__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_loading_bar__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux_loading_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_redux_loading_bar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modal__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__user_lists__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__domain_lists__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__accounts__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__accounts_counters__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__statuses__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__relationships__ = __webpack_require__(480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__settings__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__push_notifications__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__status_lists__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__cards__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__mutes__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__reports__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__contexts__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__compose__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__search__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__media_attachments__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__notifications__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__height_cache__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__custom_emojis__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__lists__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__list_editor__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__filters__ = __webpack_require__(497);






























var reducers = {
  dropdown_menu: __WEBPACK_IMPORTED_MODULE_1__dropdown_menu__["a" /* default */],
  timelines: __WEBPACK_IMPORTED_MODULE_2__timelines__["a" /* default */],
  meta: __WEBPACK_IMPORTED_MODULE_3__meta__["a" /* default */],
  alerts: __WEBPACK_IMPORTED_MODULE_4__alerts__["a" /* default */],
  loadingBar: __WEBPACK_IMPORTED_MODULE_5_react_redux_loading_bar__["loadingBarReducer"],
  modal: __WEBPACK_IMPORTED_MODULE_6__modal__["a" /* default */],
  user_lists: __WEBPACK_IMPORTED_MODULE_7__user_lists__["a" /* default */],
  domain_lists: __WEBPACK_IMPORTED_MODULE_8__domain_lists__["a" /* default */],
  status_lists: __WEBPACK_IMPORTED_MODULE_15__status_lists__["a" /* default */],
  accounts: __WEBPACK_IMPORTED_MODULE_9__accounts__["a" /* default */],
  accounts_counters: __WEBPACK_IMPORTED_MODULE_10__accounts_counters__["a" /* default */],
  statuses: __WEBPACK_IMPORTED_MODULE_11__statuses__["a" /* default */],
  relationships: __WEBPACK_IMPORTED_MODULE_12__relationships__["a" /* default */],
  settings: __WEBPACK_IMPORTED_MODULE_13__settings__["a" /* default */],
  push_notifications: __WEBPACK_IMPORTED_MODULE_14__push_notifications__["a" /* default */],
  cards: __WEBPACK_IMPORTED_MODULE_16__cards__["a" /* default */],
  mutes: __WEBPACK_IMPORTED_MODULE_17__mutes__["a" /* default */],
  reports: __WEBPACK_IMPORTED_MODULE_18__reports__["a" /* default */],
  contexts: __WEBPACK_IMPORTED_MODULE_19__contexts__["a" /* default */],
  compose: __WEBPACK_IMPORTED_MODULE_20__compose__["a" /* default */],
  search: __WEBPACK_IMPORTED_MODULE_21__search__["a" /* default */],
  media_attachments: __WEBPACK_IMPORTED_MODULE_22__media_attachments__["a" /* default */],
  notifications: __WEBPACK_IMPORTED_MODULE_23__notifications__["a" /* default */],
  height_cache: __WEBPACK_IMPORTED_MODULE_24__height_cache__["a" /* default */],
  custom_emojis: __WEBPACK_IMPORTED_MODULE_25__custom_emojis__["a" /* default */],
  lists: __WEBPACK_IMPORTED_MODULE_26__lists__["a" /* default */],
  listEditor: __WEBPACK_IMPORTED_MODULE_27__list_editor__["a" /* default */],
  filters: __WEBPACK_IMPORTED_MODULE_28__filters__["a" /* default */]
};

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux_immutable__["combineReducers"])(reducers));

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.combineReducers = undefined;

var _combineReducers2 = __webpack_require__(411);

var _combineReducers3 = _interopRequireDefault(_combineReducers2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.combineReducers = _combineReducers3.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(8);

var _immutable2 = _interopRequireDefault(_immutable);

var _utilities = __webpack_require__(412);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (reducers) {
  var getDefaultState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _immutable2.default.Map;

  var reducerKeys = Object.keys(reducers);

  // eslint-disable-next-line space-infix-ops
  return function () {
    var inputState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultState();
    var action = arguments[1];

    // eslint-disable-next-line no-process-env
    if (false) {
      var warningMessage = (0, _utilities.getUnexpectedInvocationParameterMessage)(inputState, reducers, action);

      if (warningMessage) {
        // eslint-disable-next-line no-console
        console.error(warningMessage);
      }
    }

    return inputState.withMutations(function (temporaryState) {
      reducerKeys.forEach(function (reducerName) {
        var reducer = reducers[reducerName];
        var currentDomainState = temporaryState.get(reducerName);
        var nextDomainState = reducer(currentDomainState, action);

        (0, _utilities.validateNextState)(nextDomainState, reducerName, action);

        temporaryState.set(reducerName, nextDomainState);
      });
    });
  };
};

module.exports = exports['default'];
//# sourceMappingURL=combineReducers.js.map

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateNextState = exports.getUnexpectedInvocationParameterMessage = exports.getStateName = undefined;

var _getStateName2 = __webpack_require__(191);

var _getStateName3 = _interopRequireDefault(_getStateName2);

var _getUnexpectedInvocationParameterMessage2 = __webpack_require__(413);

var _getUnexpectedInvocationParameterMessage3 = _interopRequireDefault(_getUnexpectedInvocationParameterMessage2);

var _validateNextState2 = __webpack_require__(414);

var _validateNextState3 = _interopRequireDefault(_validateNextState2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.getStateName = _getStateName3.default;
exports.getUnexpectedInvocationParameterMessage = _getUnexpectedInvocationParameterMessage3.default;
exports.validateNextState = _validateNextState3.default;
//# sourceMappingURL=index.js.map

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__(8);

var _immutable2 = _interopRequireDefault(_immutable);

var _getStateName = __webpack_require__(191);

var _getStateName2 = _interopRequireDefault(_getStateName);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

exports.default = function (state, reducers, action) {
  var reducerNames = Object.keys(reducers);

  if (!reducerNames.length) {
    return 'Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.';
  }

  var stateName = (0, _getStateName2.default)(action);

  if (_immutable2.default.isImmutable ? !_immutable2.default.isImmutable(state) : !_immutable2.default.Iterable.isIterable(state)) {
    return 'The ' + stateName + ' is of unexpected type. Expected argument to be an instance of Immutable.Collection or Immutable.Record with the following properties: "' + reducerNames.join('", "') + '".';
  }

  var unexpectedStatePropertyNames = state.toSeq().keySeq().toArray().filter(function (name) {
    return !reducers.hasOwnProperty(name);
  });

  if (unexpectedStatePropertyNames.length > 0) {
    return 'Unexpected ' + (unexpectedStatePropertyNames.length === 1 ? 'property' : 'properties') + ' "' + unexpectedStatePropertyNames.join('", "') + '" found in ' + stateName + '. Expected to find one of the known reducer property names instead: "' + reducerNames.join('", "') + '". Unexpected properties will be ignored.';
  }

  return null;
};

module.exports = exports['default'];
//# sourceMappingURL=getUnexpectedInvocationParameterMessage.js.map

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (nextState, reducerName, action) {
  // eslint-disable-next-line no-undefined
  if (nextState === undefined) {
    throw new Error('Reducer "' + reducerName + '" returned undefined when handling "' + action.type + '" action. To ignore an action, you must explicitly return the previous state.');
  }
};

module.exports = exports['default'];
//# sourceMappingURL=validateNextState.js.map

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dropdownMenu;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_dropdown_menu__ = __webpack_require__(192);



var initialState = __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Map({ openId: null, placement: null });

function dropdownMenu() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions_dropdown_menu__["b" /* DROPDOWN_MENU_OPEN */]:
      return state.merge({ openId: action.id, placement: action.placement });
    case __WEBPACK_IMPORTED_MODULE_1__actions_dropdown_menu__["a" /* DROPDOWN_MENU_CLOSE */]:
      return state.get('openId') === action.id ? state.set('openId', null) : state;
    default:
      return state;
  }
}

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = timelines;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_timelines__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_accounts__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__compare_id__ = __webpack_require__(130);





var initialState = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])();

var initialTimeline = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
  unread: 0,
  top: true,
  isLoading: false,
  hasMore: true,
  items: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])()
});

var expandNormalizedTimeline = function expandNormalizedTimeline(state, timeline, statuses, next, isPartial) {
  return state.update(timeline, initialTimeline, function (map) {
    return map.withMutations(function (mMap) {
      mMap.set('isLoading', false);
      if (!next) mMap.set('hasMore', false);

      if (!statuses.isEmpty()) {
        mMap.update('items', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(), function (oldIds) {
          var newIds = statuses.map(function (status) {
            return status.get('id');
          });

          if (timeline.indexOf(':pinned') !== -1) {
            return newIds;
          }

          var lastIndex = oldIds.findLastIndex(function (id) {
            return id !== null && Object(__WEBPACK_IMPORTED_MODULE_3__compare_id__["a" /* default */])(id, newIds.last()) >= 0;
          }) + 1;
          var firstIndex = oldIds.take(lastIndex).findLastIndex(function (id) {
            return id !== null && Object(__WEBPACK_IMPORTED_MODULE_3__compare_id__["a" /* default */])(id, newIds.first()) > 0;
          });

          if (firstIndex < 0) {
            return (isPartial ? newIds.unshift(null) : newIds).concat(oldIds.skip(lastIndex));
          }

          return oldIds.take(firstIndex + 1).concat(isPartial && oldIds.get(firstIndex) !== null ? newIds.unshift(null) : newIds, oldIds.skip(lastIndex));
        });
      }
    });
  });
};

var updateTimeline = function updateTimeline(state, timeline, status) {
  var top = state.getIn([timeline, 'top']);
  var ids = state.getIn([timeline, 'items'], Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])());
  var includesId = ids.includes(status.get('id'));
  var unread = state.getIn([timeline, 'unread'], 0);

  if (includesId) {
    return state;
  }

  var newIds = ids;

  return state.update(timeline, initialTimeline, function (map) {
    return map.withMutations(function (mMap) {
      if (!top) mMap.set('unread', unread + 1);
      if (top && ids.size > 40) newIds = newIds.take(20);
      mMap.set('items', newIds.unshift(status.get('id')));
    });
  });
};

var deleteStatus = function deleteStatus(state, id, accountId, references) {
  state.keySeq().forEach(function (timeline) {
    state = state.updateIn([timeline, 'items'], function (list) {
      return list.filterNot(function (item) {
        return item === id;
      });
    });
  });

  // Remove reblogs of deleted status
  references.forEach(function (ref) {
    state = deleteStatus(state, ref[0], ref[1], []);
  });

  return state;
};

var filterTimelines = function filterTimelines(state, relationship, statuses) {
  var references = void 0;

  statuses.forEach(function (status) {
    if (status.get('account') !== relationship.id) {
      return;
    }

    references = statuses.filter(function (item) {
      return item.get('reblog') === status.get('id');
    }).map(function (item) {
      return [item.get('id'), item.get('account')];
    });
    state = deleteStatus(state, status.get('id'), status.get('account'), references);
  });

  return state;
};

var filterTimeline = function filterTimeline(timeline, state, relationship, statuses) {
  return state.updateIn([timeline, 'items'], Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(), function (list) {
    return list.filterNot(function (statusId) {
      return statuses.getIn([statusId, 'account']) === relationship.id;
    });
  });
};

var updateTop = function updateTop(state, timeline, top) {
  return state.update(timeline, initialTimeline, function (map) {
    return map.withMutations(function (mMap) {
      if (top) mMap.set('unread', 0);
      mMap.set('top', top);
    });
  });
};

function timelines() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_timelines__["d" /* TIMELINE_EXPAND_REQUEST */]:
      return state.update(action.timeline, initialTimeline, function (map) {
        return map.set('isLoading', true);
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_timelines__["c" /* TIMELINE_EXPAND_FAIL */]:
      return state.update(action.timeline, initialTimeline, function (map) {
        return map.set('isLoading', false);
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_timelines__["e" /* TIMELINE_EXPAND_SUCCESS */]:
      return expandNormalizedTimeline(state, action.timeline, Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(action.statuses), action.next, action.partial);
    case __WEBPACK_IMPORTED_MODULE_0__actions_timelines__["g" /* TIMELINE_UPDATE */]:
      return updateTimeline(state, action.timeline, Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(action.status));
    case __WEBPACK_IMPORTED_MODULE_0__actions_timelines__["a" /* TIMELINE_DELETE */]:
      return deleteStatus(state, action.id, action.accountId, action.references, action.reblogOf);
    case __WEBPACK_IMPORTED_MODULE_1__actions_accounts__["a" /* ACCOUNT_BLOCK_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_1__actions_accounts__["c" /* ACCOUNT_MUTE_SUCCESS */]:
      return filterTimelines(state, action.relationship, action.statuses);
    case __WEBPACK_IMPORTED_MODULE_1__actions_accounts__["e" /* ACCOUNT_UNFOLLOW_SUCCESS */]:
      return filterTimeline('home', state, action.relationship, action.statuses);
    case __WEBPACK_IMPORTED_MODULE_0__actions_timelines__["f" /* TIMELINE_SCROLL_TOP */]:
      return updateTop(state, action.timeline, action.top);
    case __WEBPACK_IMPORTED_MODULE_0__actions_timelines__["b" /* TIMELINE_DISCONNECT */]:
      return state.update(action.timeline, initialTimeline, function (map) {
        return map.update('items', function (items) {
          return items.first() ? items.unshift(null) : items;
        });
      });
    default:
      return state;
  }
};

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normalizeAccount;
/* harmony export (immutable) */ __webpack_exports__["b"] = normalizeStatus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_escape_html__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_escape_html___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_escape_html__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__features_emoji_emoji__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_html__ = __webpack_require__(127);




var domParser = new DOMParser();

var makeEmojiMap = function makeEmojiMap(record) {
  return record.emojis.reduce(function (obj, emoji) {
    obj[':' + emoji.shortcode + ':'] = emoji;
    return obj;
  }, {});
};

function normalizeAccount(account) {
  account = Object.assign({}, account);

  var emojiMap = makeEmojiMap(account);
  var displayName = account.display_name.length === 0 ? account.username : account.display_name;

  account.display_name_html = Object(__WEBPACK_IMPORTED_MODULE_1__features_emoji_emoji__["default"])(__WEBPACK_IMPORTED_MODULE_0_escape_html___default()(displayName), emojiMap);
  account.note_emojified = Object(__WEBPACK_IMPORTED_MODULE_1__features_emoji_emoji__["default"])(account.note, emojiMap);

  if (account.fields) {
    account.fields = account.fields.map(function (pair) {
      return Object.assign({}, pair, {
        name_emojified: Object(__WEBPACK_IMPORTED_MODULE_1__features_emoji_emoji__["default"])(__WEBPACK_IMPORTED_MODULE_0_escape_html___default()(pair.name)),
        value_emojified: Object(__WEBPACK_IMPORTED_MODULE_1__features_emoji_emoji__["default"])(pair.value, emojiMap),
        value_plain: Object(__WEBPACK_IMPORTED_MODULE_2__utils_html__["a" /* unescapeHTML */])(pair.value)
      });
    });
  }

  if (account.moved) {
    account.moved = account.moved.id;
  }

  return account;
}

function normalizeStatus(status, normalOldStatus) {
  var normalStatus = Object.assign({}, status);
  normalStatus.account = status.account.id;

  if (status.reblog && status.reblog.id) {
    normalStatus.reblog = status.reblog.id;
  }

  // Only calculate these values when status first encountered
  // Otherwise keep the ones already in the reducer
  if (normalOldStatus) {
    normalStatus.search_index = normalOldStatus.get('search_index');
    normalStatus.contentHtml = normalOldStatus.get('contentHtml');
    normalStatus.spoilerHtml = normalOldStatus.get('spoilerHtml');
    normalStatus.hidden = normalOldStatus.get('hidden');
  } else {
    var spoilerText = normalStatus.spoiler_text || '';
    var searchContent = [spoilerText, status.content].join('\n\n').replace(/<br\s*\/?>/g, '\n').replace(/<\/p><p>/g, '\n\n');
    var emojiMap = makeEmojiMap(normalStatus);

    normalStatus.search_index = domParser.parseFromString(searchContent, 'text/html').documentElement.textContent;
    normalStatus.contentHtml = Object(__WEBPACK_IMPORTED_MODULE_1__features_emoji_emoji__["default"])(normalStatus.content, emojiMap);
    normalStatus.spoilerHtml = Object(__WEBPACK_IMPORTED_MODULE_1__features_emoji_emoji__["default"])(__WEBPACK_IMPORTED_MODULE_0_escape_html___default()(spoilerText), emojiMap);
    normalStatus.hidden = spoilerText.length > 0 || normalStatus.sensitive;
  }

  return normalStatus;
}

/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * escape-html
 * Copyright(c) 2012-2013 TJ Holowaychuk
 * Copyright(c) 2015 Andreas Lubbe
 * Copyright(c) 2015 Tiancheng "Timothy" Gu
 * MIT Licensed
 */



/**
 * Module variables.
 * @private
 */

var matchHtmlRegExp = /["'&<>]/;

/**
 * Module exports.
 * @public
 */

module.exports = escapeHtml;

/**
 * Escape special characters in the given string of html.
 *
 * @param  {string} string The string to escape for inserting into HTML
 * @return {string}
 * @public
 */

function escapeHtml(string) {
  var str = '' + string;
  var match = matchHtmlRegExp.exec(str);

  if (!match) {
    return str;
  }

  var escape;
  var html = '';
  var index = 0;
  var lastIndex = 0;

  for (index = match.index; index < str.length; index++) {
    switch (str.charCodeAt(index)) {
      case 34:
        // "
        escape = '&quot;';
        break;
      case 38:
        // &
        escape = '&amp;';
        break;
      case 39:
        // '
        escape = '&#39;';
        break;
      case 60:
        // <
        escape = '&lt;';
        break;
      case 62:
        // >
        escape = '&gt;';
        break;
      default:
        continue;
    }

    if (lastIndex !== index) {
      html += str.substring(lastIndex, index);
    }

    lastIndex = index + 1;
    html += escape;
  }

  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
}

/***/ }),
/* 419 */
/***/ (function(module, exports) {

// taken from:
// https://github.com/twitter/twemoji/blob/47732c7/twemoji-generator.js#L848-L866
exports.unicodeToFilename = function (str) {
  var result = '';
  var charCode = 0;
  var p = 0;
  var i = 0;
  while (i < str.length) {
    charCode = str.charCodeAt(i++);
    if (p) {
      if (result.length > 0) {
        result += '-';
      }
      result += (0x10000 + (p - 0xD800 << 10) + (charCode - 0xDC00)).toString(16);
      p = 0;
    } else if (0xD800 <= charCode && charCode <= 0xDBFF) {
      p = charCode;
    } else {
      if (result.length > 0) {
        result += '-';
      }
      result += charCode.toString(16);
    }
  }
  return result;
};

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var CODA_MARKER = '$$'; // marks the end of the string

function MiniTrie(words) {
  this._dict = {};
  for (var i = 0, len = words.length; i < len; i++) {
    var word = words[i];
    var dict = this._dict;
    for (var j = 0, len2 = word.length; j < len2; j++) {
      var char = word.charAt(j);
      dict = dict[char] = dict[char] || {};
    }
    dict[CODA_MARKER] = true;
  }
}

MiniTrie.prototype.search = function (str) {
  var i = -1;
  var len = str.length;
  var stack = [this._dict];
  while (++i < len) {
    var dict = stack[i];
    var char = str.charAt(i);
    if (char in dict) {
      stack.push(dict[char]);
    } else {
      break;
    }
  }
  while (stack.length) {
    if (stack.pop()[CODA_MARKER]) {
      return str.substring(0, stack.length);
    }
  }
};

module.exports = MiniTrie;

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(21);
var bind = __webpack_require__(195);
var Axios = __webpack_require__(423);
var defaults = __webpack_require__(128);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(199);
axios.CancelToken = __webpack_require__(437);
axios.isCancel = __webpack_require__(198);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(438);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;

/***/ }),
/* 422 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

// The _isBuffer check is for Safari 5-7 support, because it's missing
// Object.prototype.constructor. Remove this eventually
module.exports = function (obj) {
  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer);
};

function isBuffer(obj) {
  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj);
}

// For Node v0.10 support. Remove this eventually.
function isSlowBuffer(obj) {
  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0));
}

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(128);
var utils = __webpack_require__(21);
var InterceptorManager = __webpack_require__(432);
var dispatchRequest = __webpack_require__(433);
var isAbsoluteURL = __webpack_require__(435);
var combineURLs = __webpack_require__(436);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
  config.method = config.method.toLowerCase();

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function (url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(21);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(197);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError('Request failed with status code ' + response.status, response.config, null, response.request, response));
  }
};

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */

module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(21);

function encode(val) {
  return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(21);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) {
    return parsed;
  }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(21);

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
  var msie = /(msie|trident)/i.test(navigator.userAgent);
  var urlParsingNode = document.createElement('a');
  var originURL;

  /**
  * Parse a URL to discover it's components
  *
  * @param {String} url The URL to be parsed
  * @returns {Object}
  */
  function resolveURL(url) {
    var href = url;

    if (msie) {
      // IE needs attribute set twice to normalize properties
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }

    urlParsingNode.setAttribute('href', href);

    // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: urlParsingNode.hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  originURL = resolveURL(window.location.href);

  /**
  * Determine if a URL shares the same origin as the current location
  *
  * @param {String} requestURL The URL to test
  * @returns {boolean} True if URL shares the same origin, otherwise false
  */
  return function isURLSameOrigin(requestURL) {
    var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
    return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
  };
}() :

// Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return function isURLSameOrigin() {
    return true;
  };
}();

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error();
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
  // initialize result and counter
  var block, charCode, idx = 0, map = chars;
  // if the next str index does not exist:
  //   change the mapping table to "="
  //   check if d has no fractional digits
  str.charAt(idx | 0) || (map = '=', idx % 1);
  // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
  output += map.charAt(63 & block >> 8 - idx % 1 * 8)) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(21);

module.exports = utils.isStandardBrowserEnv() ?

// Standard browser envs support document.cookie
function standardBrowserEnv() {
  return {
    write: function write(name, value, expires, path, domain, secure) {
      var cookie = [];
      cookie.push(name + '=' + encodeURIComponent(value));

      if (utils.isNumber(expires)) {
        cookie.push('expires=' + new Date(expires).toGMTString());
      }

      if (utils.isString(path)) {
        cookie.push('path=' + path);
      }

      if (utils.isString(domain)) {
        cookie.push('domain=' + domain);
      }

      if (secure === true) {
        cookie.push('secure');
      }

      document.cookie = cookie.join('; ');
    },

    read: function read(name) {
      var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
      return match ? decodeURIComponent(match[3]) : null;
    },

    remove: function remove(name) {
      this.write(name, '', Date.now() - 86400000);
    }
  };
}() :

// Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
  return {
    write: function write() {},
    read: function read() {
      return null;
    },
    remove: function remove() {}
  };
}();

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(21);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(21);
var transformData = __webpack_require__(434);
var isCancel = __webpack_require__(198);
var defaults = __webpack_require__(128);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(config.data, config.headers, config.transformRequest);

  // Flatten headers
  config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers || {});

  utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
    delete config.headers[method];
  });

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(response.data, response.headers, config.transformResponse);

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(reason.response.data, reason.response.headers, config.transformResponse);
      }
    }

    return Promise.reject(reason);
  });
};

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(21);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */

module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return (/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url)
  );
};

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */

module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(199);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */

module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_http_link_header__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_http_link_header___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_http_link_header__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_querystring__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_querystring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_querystring__);



__WEBPACK_IMPORTED_MODULE_0_http_link_header___default.a.parseAttrs = function (link, parts) {
  var match = null;
  var attr = '';
  var value = '';
  var attrs = '';

  var uriAttrs = /<(.*)>;\s*(.*)/gi.exec(parts);

  if (uriAttrs) {
    attrs = uriAttrs[2];
    link = __WEBPACK_IMPORTED_MODULE_0_http_link_header___default.a.parseParams(link, uriAttrs[1]);
  }

  while (match = __WEBPACK_IMPORTED_MODULE_0_http_link_header___default.a.attrPattern.exec(attrs)) {
    // eslint-disable-line no-cond-assign
    attr = match[1].toLowerCase();
    value = match[4] || match[3] || match[2];

    if (/\*$/.test(attr)) {
      __WEBPACK_IMPORTED_MODULE_0_http_link_header___default.a.setAttr(link, attr, __WEBPACK_IMPORTED_MODULE_0_http_link_header___default.a.parseExtendedValue(value));
    } else if (/%/.test(value)) {
      __WEBPACK_IMPORTED_MODULE_0_http_link_header___default.a.setAttr(link, attr, __WEBPACK_IMPORTED_MODULE_1_querystring___default.a.decode(value));
    } else {
      __WEBPACK_IMPORTED_MODULE_0_http_link_header___default.a.setAttr(link, attr, value);
    }
  }

  return link;
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_http_link_header___default.a);

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var querystring = __webpack_require__(200);
var trim = __webpack_require__(443);

/**
 * Link
 * @constructor
 * @return {Link}
 */
function Link(value) {

  if (!(this instanceof Link)) {
    return new Link(value);
  }

  /** @type {Array} URI references */
  this.refs = [];
}

/**
 * General matching pattern
 * @type {RegExp}
 */
Link.pattern = /(?:\<([^\>]+)\>)((\s*;\s*([a-z\*]+)=(("[^"]+")|('[^']+')|([^\,\;]+)))*)(\s*,\s*|$)/gi;

/**
 * Attribute matching pattern
 * @type {RegExp}
 */
Link.attrPattern = /([a-z\*]+)=(?:(?:"([^"]+)")|(?:'([^']+)')|([^\,\;]+))/gi;

/**
 * Determines whether an encoding can be
 * natively handled with a `Buffer`
 * @param {String} value
 * @return {Boolean}
 */
Link.isCompatibleEncoding = function (value) {
  return (/^utf-?8|ascii|utf-?16-?le|ucs-?2|base-?64|latin-?1$/i.test(value)
  );
};

/**
 * Format a given extended attribute and it's value
 * @param {String} attr
 * @param {Object} data
 * @return {String}
 */
Link.formatExtendedAttribute = function (attr, data) {

  var encoding = (data.encoding || 'utf-8').toUpperCase();
  var language = data.language || 'en';

  var encodedValue = '';

  if (Buffer.isBuffer(data.value) && Link.isCompatibleEncoding(encoding)) {
    encodedValue = data.value.toString(encoding);
  } else if (Buffer.isBuffer(data.value)) {
    encodedValue = data.value.toString('hex').replace(/[0-9a-f]{2}/gi, '%$1');
  } else {
    encodedValue = querystring.escape(data.value);
  }

  return attr + '=' + encoding + '\'' + language + '\'' + encodedValue;
};

/**
 * Format a given attribute and it's value
 * @param {String} attr
 * @param {String|Object} value
 * @return {String}
 */
Link.formatAttribute = function (attr, value) {

  // NOTE: Properly test this condition
  if (/\*$/.test(attr) || typeof value !== 'string') return Link.formatExtendedAttribute(attr, value);

  // Strictly, not all values matching this
  // selector would need quotes, but it's better to be safe
  var needsQuotes = /[^a-z]/i.test(value);

  if (needsQuotes) {
    // We don't need to escape <SP> <,> <;>
    value = querystring.escape(value).replace(/%20/g, ' ').replace(/%2C/g, ',').replace(/%3B/g, ';');

    value = '"' + value + '"';
  }

  return attr + '=' + value;
};

/**
 * Parses an extended value and attempts to decode it
 * @internal
 * @param {String} value
 * @return {Object}
 */
Link.parseExtendedValue = function (value) {
  var parts = /([^']+)?(?:'([^']+)')?(.+)/.exec(value);
  return {
    language: parts[2].toLowerCase(),
    encoding: Link.isCompatibleEncoding(parts[1]) ? null : parts[1].toLowerCase(),
    value: Link.isCompatibleEncoding(parts[1]) ? querystring.unescape(parts[3]) : parts[3]
  };
};

/**
 * Set an attribute on a link ref
 * @param {Object} link
 * @param {String} attr
 * @param {String} value
 */
Link.setAttr = function (link, attr, value) {

  // Occurrences after the first "rel" MUST be ignored by parsers
  // @see RFC 5988, Section 5.3: Relation Type
  if (attr === 'rel' && link[attr] != null) return link;

  if (Array.isArray(link[attr])) {
    link[attr].push(value);
  } else if (link[attr] != null) {
    link[attr] = [link[attr], value];
  } else {
    link[attr] = value;
  }

  return link;
};

/**
 * Parses uri attributes
 */
Link.parseParams = function (link, uri) {

  var kvs = {};
  var params = /(.+)\?(.+)/gi.exec(uri);

  if (!params) {
    return link;
  }

  params = params[2].split('&');

  for (var i = 0; i < params.length; i++) {
    var param = params[i].split('=');
    kvs[param[0]] = param[1];
  }

  Link.setAttr(link, 'params', kvs);

  return link;
};

/**
 * Parses out URI attributes
 * @internal
 * @param {Object} link
 * @param {String} parts
 * @return {Object} link
 */
Link.parseAttrs = function (link, parts) {

  var match = null;
  var attr = '';
  var value = '';
  var attrs = '';

  var uriAttrs = /<(.*)>;\s*(.*)/gi.exec(parts);
  if (uriAttrs) {
    attrs = uriAttrs[2];
    link = Link.parseParams(link, uriAttrs[1]);
  }

  while (match = Link.attrPattern.exec(attrs)) {
    attr = match[1].toLowerCase();
    value = match[4] || match[3] || match[2];
    if (/\*$/.test(attr)) {
      Link.setAttr(link, attr, Link.parseExtendedValue(value));
    } else if (/%/.test(value)) {
      Link.setAttr(link, attr, querystring.unescape(value));
    } else {
      Link.setAttr(link, attr, value);
    }
  }

  return link;
};

Link.parse = function (value) {
  return new Link().parse(value);
};

/**
 * Link prototype
 * @type {Object}
 */
Link.prototype = {

  constructor: Link,

  /**
   * Get refs with given relation type
   * @param {String} value
   * @return {Array<Object>}
   */
  rel: function (value) {

    var links = [];

    for (var i = 0; i < this.refs.length; i++) {
      if (this.refs[i].rel === value) {
        links.push(this.refs[i]);
      }
    }

    return links;
  },

  /**
   * Get refs where given attribute has a given value
   * @param {String} attr
   * @param {String} value
   * @return {Array<Object>}
   */
  get: function (attr, value) {

    attr = attr.toLowerCase();

    var links = [];

    for (var i = 0; i < this.refs.length; i++) {
      if (this.refs[i][attr] === value) {
        links.push(this.refs[i]);
      }
    }

    return links;
  },

  set: function (link) {
    this.refs.push(link);
    return this;
  },

  has: function (attr, value) {
    return this.get(attr, value) != null;
  },

  parse: function (value) {

    // Unfold folded lines
    value = trim(value).replace(/\r?\n[\x20\x09]+/g, '');

    var match = null;

    while (match = Link.pattern.exec(value)) {
      var link = Link.parseAttrs({ uri: match[1] }, match[0]);
      this.refs.push(link);
    }

    return this;
  },

  toString: function () {

    var refs = [];
    var link = '';
    var ref = null;

    for (var i = 0; i < this.refs.length; i++) {
      ref = this.refs[i];
      link = Object.keys(this.refs[i]).reduce(function (link, attr) {
        if (attr === 'uri') return link;
        return link + '; ' + Link.formatAttribute(attr, ref[attr]);
      }, '<' + ref.uri + '>');
      refs.push(link);
    }

    return refs.join(', ');
  }

  // Exports
};module.exports = Link;

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function (qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr,
        vstr,
        k,
        v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function (v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function (obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function (k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function (v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);
  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq + encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map(xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports = function trim(value) {
  return value.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
};

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = meta;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_store__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);



var initialState = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({
  streaming_api_base_url: null,
  access_token: null
});

function meta() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_store__["a" /* STORE_HYDRATE */]:
      return state.merge(action.state.get('meta'));
    default:
      return state;
  }
};

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(25);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function () {
  return root.Date.now();
};

module.exports = now;

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(40),
    isSymbol = __webpack_require__(447);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

module.exports = toNumber;

/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(50),
    isObjectLike = __webpack_require__(51);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}

module.exports = isSymbol;

/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(131);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;

/***/ }),
/* 449 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;

/***/ }),
/* 450 */
/***/ (function(module, exports) {

function padLeft(str, num) {
  while (str.length < num) {
    str = '0' + str;
  }
  return str;
}

exports.unicodeToUnifiedName = function (str) {
  var output = '';
  for (var i = 0; i < str.length; i += 2) {
    if (i > 0) {
      output += '-';
    }
    output += padLeft(str.codePointAt(i).toString(16).toUpperCase(), 4);
  }
  return output;
};

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSanitizedData; });
/* unused harmony export uniq */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return intersect; });
/* unused harmony export deepMerge */
/* unused harmony export unifiedToNative */
/* unused harmony export measureScrollbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emoji_mart_data_light__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__emoji_mart_data_light___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__emoji_mart_data_light__);

// This code is largely borrowed from:
// https://github.com/missive/emoji-mart/blob/5f2ffcc/src/utils/index.js



var buildSearch = function buildSearch(data) {
  var search = [];

  var addToSearch = function addToSearch(strings, split) {
    if (!strings) {
      return;
    }

    (Array.isArray(strings) ? strings : [strings]).forEach(function (string) {
      (split ? string.split(/[-|_|\s]+/) : [string]).forEach(function (s) {
        s = s.toLowerCase();

        if (search.indexOf(s) === -1) {
          search.push(s);
        }
      });
    });
  };

  addToSearch(data.short_names, true);
  addToSearch(data.name, true);
  addToSearch(data.keywords, false);
  addToSearch(data.emoticons, false);

  return search.join(',');
};

var _String = String;

var stringFromCodePoint = _String.fromCodePoint || function () {
  var MAX_SIZE = 0x4000;
  var codeUnits = [];
  var highSurrogate = void 0;
  var lowSurrogate = void 0;
  var index = -1;
  var length = arguments.length;
  if (!length) {
    return '';
  }
  var result = '';
  while (++index < length) {
    var codePoint = Number(arguments[index]);
    if (!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
    codePoint < 0 || // not a valid Unicode code point
    codePoint > 0x10FFFF || // not a valid Unicode code point
    Math.floor(codePoint) !== codePoint // not an integer
    ) {
        throw RangeError('Invalid code point: ' + codePoint);
      }
    if (codePoint <= 0xFFFF) {
      // BMP code point
      codeUnits.push(codePoint);
    } else {
      // Astral code point; split in surrogate halves
      // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
      codePoint -= 0x10000;
      highSurrogate = (codePoint >> 10) + 0xD800;
      lowSurrogate = codePoint % 0x400 + 0xDC00;
      codeUnits.push(highSurrogate, lowSurrogate);
    }
    if (index + 1 === length || codeUnits.length > MAX_SIZE) {
      result += String.fromCharCode.apply(null, codeUnits);
      codeUnits.length = 0;
    }
  }
  return result;
};

var _JSON = JSON;

var COLONS_REGEX = /^(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)?$/;
var SKINS = ['1F3FA', '1F3FB', '1F3FC', '1F3FD', '1F3FE', '1F3FF'];

function unifiedToNative(unified) {
  var unicodes = unified.split('-'),
      codePoints = unicodes.map(function (u) {
    return '0x' + u;
  });

  return stringFromCodePoint.apply(null, codePoints);
}

function sanitize(emoji) {
  var name = emoji.name,
      short_names = emoji.short_names,
      skin_tone = emoji.skin_tone,
      skin_variations = emoji.skin_variations,
      emoticons = emoji.emoticons,
      unified = emoji.unified,
      custom = emoji.custom,
      imageUrl = emoji.imageUrl,
      id = emoji.id || short_names[0],
      colons = ':' + id + ':';


  if (custom) {
    return {
      id: id,
      name: name,
      colons: colons,
      emoticons: emoticons,
      custom: custom,
      imageUrl: imageUrl
    };
  }

  if (skin_tone) {
    colons += ':skin-tone-' + skin_tone + ':';
  }

  return {
    id: id,
    name: name,
    colons: colons,
    emoticons: emoticons,
    unified: unified.toLowerCase(),
    skin: skin_tone || (skin_variations ? 1 : null),
    native: unifiedToNative(unified)
  };
}

function getSanitizedData() {
  return sanitize(getData.apply(undefined, arguments));
}

function getData(emoji, skin, set) {
  var emojiData = {};

  if (typeof emoji === 'string') {
    var matches = emoji.match(COLONS_REGEX);

    if (matches) {
      emoji = matches[1];

      if (matches[2]) {
        skin = parseInt(matches[2]);
      }
    }

    if (__WEBPACK_IMPORTED_MODULE_1__emoji_mart_data_light___default.a.short_names.hasOwnProperty(emoji)) {
      emoji = __WEBPACK_IMPORTED_MODULE_1__emoji_mart_data_light___default.a.short_names[emoji];
    }

    if (__WEBPACK_IMPORTED_MODULE_1__emoji_mart_data_light___default.a.emojis.hasOwnProperty(emoji)) {
      emojiData = __WEBPACK_IMPORTED_MODULE_1__emoji_mart_data_light___default.a.emojis[emoji];
    }
  } else if (emoji.id) {
    if (__WEBPACK_IMPORTED_MODULE_1__emoji_mart_data_light___default.a.short_names.hasOwnProperty(emoji.id)) {
      emoji.id = __WEBPACK_IMPORTED_MODULE_1__emoji_mart_data_light___default.a.short_names[emoji.id];
    }

    if (__WEBPACK_IMPORTED_MODULE_1__emoji_mart_data_light___default.a.emojis.hasOwnProperty(emoji.id)) {
      emojiData = __WEBPACK_IMPORTED_MODULE_1__emoji_mart_data_light___default.a.emojis[emoji.id];
      skin = skin || emoji.skin;
    }
  }

  if (!Object.keys(emojiData).length) {
    emojiData = emoji;
    emojiData.custom = true;

    if (!emojiData.search) {
      emojiData.search = buildSearch(emoji);
    }
  }

  emojiData.emoticons = emojiData.emoticons || [];
  emojiData.variations = emojiData.variations || [];

  if (emojiData.skin_variations && skin > 1 && set) {
    emojiData = JSON.parse(_JSON.stringify(emojiData));

    var skinKey = SKINS[skin - 1],
        variationData = emojiData.skin_variations[skinKey];

    if (!variationData.variations && emojiData.variations) {
      delete emojiData.variations;
    }

    if (variationData['has_img_' + set]) {
      emojiData.skin_tone = skin;

      for (var k in variationData) {
        var v = variationData[k];
        emojiData[k] = v;
      }
    }
  }

  if (emojiData.variations && emojiData.variations.length) {
    emojiData = JSON.parse(_JSON.stringify(emojiData));
    emojiData.unified = emojiData.variations.shift();
  }

  return emojiData;
}

function uniq(arr) {
  return arr.reduce(function (acc, item) {
    if (acc.indexOf(item) === -1) {
      acc.push(item);
    }
    return acc;
  }, []);
}

function intersect(a, b) {
  var uniqA = uniq(a);
  var uniqB = uniq(b);

  return uniqA.filter(function (item) {
    return uniqB.indexOf(item) >= 0;
  });
}

function deepMerge(a, b) {
  var o = {};

  for (var key in a) {
    var originalValue = a[key],
        value = originalValue;

    if (b.hasOwnProperty(key)) {
      value = b[key];
    }

    if ((typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === 'object') {
      value = deepMerge(originalValue, value);
    }

    o[key] = value;
  }

  return o;
}

// https://github.com/sonicdoe/measure-scrollbar
function measureScrollbar() {
  var div = document.createElement('div');

  div.style.width = '100px';
  div.style.height = '100px';
  div.style.overflow = 'scroll';
  div.style.position = 'absolute';
  div.style.top = '-9999px';

  document.body.appendChild(div);
  var scrollbarWidth = div.offsetWidth - div.clientWidth;
  document.body.removeChild(div);

  return scrollbarWidth;
}



/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */



var src$core$$ = __webpack_require__(453),
    src$en$$ = __webpack_require__(458);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



var src$utils$$ = __webpack_require__(205),
    src$es5$$ = __webpack_require__(454),
    src$compiler$$ = __webpack_require__(455),
    intl$messageformat$parser$$ = __webpack_require__(456);
exports["default"] = MessageFormat;

// -- MessageFormat --------------------------------------------------------

function MessageFormat(message, locales, formats) {
    // Parse string messages into an AST.
    var ast = typeof message === 'string' ? MessageFormat.__parse(message) : message;

    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new TypeError('A message must be provided as a String or AST.');
    }

    // Creates a new object with the specified `formats` merged with the default
    // formats.
    formats = this._mergeFormats(MessageFormat.formats, formats);

    // Defined first because it's used to build the format pattern.
    src$es5$$.defineProperty(this, '_locale', { value: this._resolveLocale(locales) });

    // Compile the `ast` to a pattern that is highly optimized for repeated
    // `format()` invocations. **Note:** This passes the `locales` set provided
    // to the constructor instead of just the resolved locale.
    var pluralFn = this._findPluralRuleFunction(this._locale);
    var pattern = this._compilePattern(ast, locales, formats, pluralFn);

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var messageFormat = this;
    this.format = function (values) {
        try {
            return messageFormat._format(pattern, values);
        } catch (e) {
            if (e.variableId) {
                throw new Error('The intl string context variable \'' + e.variableId + '\'' + ' was not provided to the string \'' + message + '\'');
            } else {
                throw e;
            }
        }
    };
}

// Default format options used as the prototype of the `formats` provided to the
// constructor. These are used when constructing the internal Intl.NumberFormat
// and Intl.DateTimeFormat instances.
src$es5$$.defineProperty(MessageFormat, 'formats', {
    enumerable: true,

    value: {
        number: {
            'currency': {
                style: 'currency'
            },

            'percent': {
                style: 'percent'
            }
        },

        date: {
            'short': {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },

            'medium': {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },

            'long': {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },

            'full': {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },

        time: {
            'short': {
                hour: 'numeric',
                minute: 'numeric'
            },

            'medium': {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },

            'long': {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },

            'full': {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    }
});

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(MessageFormat, '__localeData__', { value: src$es5$$.objCreate(null) });
src$es5$$.defineProperty(MessageFormat, '__addLocaleData', { value: function (data) {
        if (!(data && data.locale)) {
            throw new Error('Locale data provided to IntlMessageFormat is missing a ' + '`locale` property');
        }

        MessageFormat.__localeData__[data.locale.toLowerCase()] = data;
    } });

// Defines `__parse()` static method as an exposed private.
src$es5$$.defineProperty(MessageFormat, '__parse', { value: intl$messageformat$parser$$["default"].parse });

// Define public `defaultLocale` property which defaults to English, but can be
// set by the developer.
src$es5$$.defineProperty(MessageFormat, 'defaultLocale', {
    enumerable: true,
    writable: true,
    value: undefined
});

MessageFormat.prototype.resolvedOptions = function () {
    // TODO: Provide anything else?
    return {
        locale: this._locale
    };
};

MessageFormat.prototype._compilePattern = function (ast, locales, formats, pluralFn) {
    var compiler = new src$compiler$$["default"](locales, formats, pluralFn);
    return compiler.compile(ast);
};

MessageFormat.prototype._findPluralRuleFunction = function (locale) {
    var localeData = MessageFormat.__localeData__;
    var data = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find a `pluralRuleFunction` to return.
    while (data) {
        if (data.pluralRuleFunction) {
            return data.pluralRuleFunction;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error('Locale data added to IntlMessageFormat is missing a ' + '`pluralRuleFunction` for :' + locale);
};

MessageFormat.prototype._format = function (pattern, values) {
    var result = '',
        i,
        len,
        part,
        id,
        value,
        err;

    for (i = 0, len = pattern.length; i < len; i += 1) {
        part = pattern[i];

        // Exist early for string parts.
        if (typeof part === 'string') {
            result += part;
            continue;
        }

        id = part.id;

        // Enforce that all required values are provided by the caller.
        if (!(values && src$utils$$.hop.call(values, id))) {
            err = new Error('A value must be provided for: ' + id);
            err.variableId = id;
            throw err;
        }

        value = values[id];

        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if (part.options) {
            result += this._format(part.getOption(value), values);
        } else {
            result += part.format(value);
        }
    }

    return result;
};

MessageFormat.prototype._mergeFormats = function (defaults, formats) {
    var mergedFormats = {},
        type,
        mergedType;

    for (type in defaults) {
        if (!src$utils$$.hop.call(defaults, type)) {
            continue;
        }

        mergedFormats[type] = mergedType = src$es5$$.objCreate(defaults[type]);

        if (formats && src$utils$$.hop.call(formats, type)) {
            src$utils$$.extend(mergedType, formats[type]);
        }
    }

    return mergedFormats;
};

MessageFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(MessageFormat.defaultLocale);

    var localeData = MessageFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error('No locale data has been added to IntlMessageFormat for: ' + locales.join(', ') + ', or the default locale: ' + defaultLocale);
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



var src$utils$$ = __webpack_require__(205);

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var realDefineProp = function () {
    try {
        return !!Object.defineProperty({}, 'a', {});
    } catch (e) {
        return false;
    }
}();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty : function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!src$utils$$.hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (src$utils$$.hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



exports["default"] = Compiler;

function Compiler(locales, formats, pluralFn) {
    this.locales = locales;
    this.formats = formats;
    this.pluralFn = pluralFn;
}

Compiler.prototype.compile = function (ast) {
    this.pluralStack = [];
    this.currentPlural = null;
    this.pluralNumberFormat = null;

    return this.compileMessage(ast);
};

Compiler.prototype.compileMessage = function (ast) {
    if (!(ast && ast.type === 'messageFormatPattern')) {
        throw new Error('Message AST is not of type: "messageFormatPattern"');
    }

    var elements = ast.elements,
        pattern = [];

    var i, len, element;

    for (i = 0, len = elements.length; i < len; i += 1) {
        element = elements[i];

        switch (element.type) {
            case 'messageTextElement':
                pattern.push(this.compileMessageText(element));
                break;

            case 'argumentElement':
                pattern.push(this.compileArgument(element));
                break;

            default:
                throw new Error('Message element does not have a valid type');
        }
    }

    return pattern;
};

Compiler.prototype.compileMessageText = function (element) {
    // When this `element` is part of plural sub-pattern and its value contains
    // an unescaped '#', use a `PluralOffsetString` helper to properly output
    // the number with the correct offset in the string.
    if (this.currentPlural && /(^|[^\\])#/g.test(element.value)) {
        // Create a cache a NumberFormat instance that can be reused for any
        // PluralOffsetString instance in this message.
        if (!this.pluralNumberFormat) {
            this.pluralNumberFormat = new Intl.NumberFormat(this.locales);
        }

        return new PluralOffsetString(this.currentPlural.id, this.currentPlural.format.offset, this.pluralNumberFormat, element.value);
    }

    // Unescape the escaped '#'s in the message text.
    return element.value.replace(/\\#/g, '#');
};

Compiler.prototype.compileArgument = function (element) {
    var format = element.format;

    if (!format) {
        return new StringFormat(element.id);
    }

    var formats = this.formats,
        locales = this.locales,
        pluralFn = this.pluralFn,
        options;

    switch (format.type) {
        case 'numberFormat':
            options = formats.number[format.style];
            return {
                id: element.id,
                format: new Intl.NumberFormat(locales, options).format
            };

        case 'dateFormat':
            options = formats.date[format.style];
            return {
                id: element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'timeFormat':
            options = formats.time[format.style];
            return {
                id: element.id,
                format: new Intl.DateTimeFormat(locales, options).format
            };

        case 'pluralFormat':
            options = this.compileOptions(element);
            return new PluralFormat(element.id, format.ordinal, format.offset, options, pluralFn);

        case 'selectFormat':
            options = this.compileOptions(element);
            return new SelectFormat(element.id, options);

        default:
            throw new Error('Message element does not have a valid format type');
    }
};

Compiler.prototype.compileOptions = function (element) {
    var format = element.format,
        options = format.options,
        optionsHash = {};

    // Save the current plural element, if any, then set it to a new value when
    // compiling the options sub-patterns. This conforms the spec's algorithm
    // for handling `"#"` syntax in message text.
    this.pluralStack.push(this.currentPlural);
    this.currentPlural = format.type === 'pluralFormat' ? element : null;

    var i, len, option;

    for (i = 0, len = options.length; i < len; i += 1) {
        option = options[i];

        // Compile the sub-pattern and save it under the options's selector.
        optionsHash[option.selector] = this.compileMessage(option.value);
    }

    // Pop the plural stack to put back the original current plural value.
    this.currentPlural = this.pluralStack.pop();

    return optionsHash;
};

// -- Compiler Helper Classes --------------------------------------------------

function StringFormat(id) {
    this.id = id;
}

StringFormat.prototype.format = function (value) {
    if (!value && typeof value !== 'number') {
        return '';
    }

    return typeof value === 'string' ? value : String(value);
};

function PluralFormat(id, useOrdinal, offset, options, pluralFn) {
    this.id = id;
    this.useOrdinal = useOrdinal;
    this.offset = offset;
    this.options = options;
    this.pluralFn = pluralFn;
}

PluralFormat.prototype.getOption = function (value) {
    var options = this.options;

    var option = options['=' + value] || options[this.pluralFn(value - this.offset, this.useOrdinal)];

    return option || options.other;
};

function PluralOffsetString(id, offset, numberFormat, string) {
    this.id = id;
    this.offset = offset;
    this.numberFormat = numberFormat;
    this.string = string;
}

PluralOffsetString.prototype.format = function (value) {
    var number = this.numberFormat.format(value - this.offset);

    return this.string.replace(/(^|[^\\])#/g, '$1' + number).replace(/\\#/g, '#');
};

function SelectFormat(id, options) {
    this.id = id;
    this.options = options;
}

SelectFormat.prototype.getOption = function (value) {
    var options = this.options;
    return options[value] || options.other;
};

//# sourceMappingURL=compiler.js.map

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports = module.exports = __webpack_require__(457)['default'];
exports['default'] = exports;

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports["default"] = function () {
  "use strict";

  /*
   * Generated by PEG.js 0.9.0.
   *
   * http://pegjs.org/
   */

  function peg$subclass(child, parent) {
    function ctor() {
      this.constructor = child;
    }
    ctor.prototype = parent.prototype;
    child.prototype = new ctor();
  }

  function peg$SyntaxError(message, expected, found, location) {
    this.message = message;
    this.expected = expected;
    this.found = found;
    this.location = location;
    this.name = "SyntaxError";

    if (typeof Error.captureStackTrace === "function") {
      Error.captureStackTrace(this, peg$SyntaxError);
    }
  }

  peg$subclass(peg$SyntaxError, Error);

  function peg$parse(input) {
    var options = arguments.length > 1 ? arguments[1] : {},
        parser = this,
        peg$FAILED = {},
        peg$startRuleFunctions = { start: peg$parsestart },
        peg$startRuleFunction = peg$parsestart,
        peg$c0 = function (elements) {
      return {
        type: 'messageFormatPattern',
        elements: elements,
        location: location()
      };
    },
        peg$c1 = function (text) {
      var string = '',
          i,
          j,
          outerLen,
          inner,
          innerLen;

      for (i = 0, outerLen = text.length; i < outerLen; i += 1) {
        inner = text[i];

        for (j = 0, innerLen = inner.length; j < innerLen; j += 1) {
          string += inner[j];
        }
      }

      return string;
    },
        peg$c2 = function (messageText) {
      return {
        type: 'messageTextElement',
        value: messageText,
        location: location()
      };
    },
        peg$c3 = /^[^ \t\n\r,.+={}#]/,
        peg$c4 = { type: "class", value: "[^ \\t\\n\\r,.+={}#]", description: "[^ \\t\\n\\r,.+={}#]" },
        peg$c5 = "{",
        peg$c6 = { type: "literal", value: "{", description: "\"{\"" },
        peg$c7 = ",",
        peg$c8 = { type: "literal", value: ",", description: "\",\"" },
        peg$c9 = "}",
        peg$c10 = { type: "literal", value: "}", description: "\"}\"" },
        peg$c11 = function (id, format) {
      return {
        type: 'argumentElement',
        id: id,
        format: format && format[2],
        location: location()
      };
    },
        peg$c12 = "number",
        peg$c13 = { type: "literal", value: "number", description: "\"number\"" },
        peg$c14 = "date",
        peg$c15 = { type: "literal", value: "date", description: "\"date\"" },
        peg$c16 = "time",
        peg$c17 = { type: "literal", value: "time", description: "\"time\"" },
        peg$c18 = function (type, style) {
      return {
        type: type + 'Format',
        style: style && style[2],
        location: location()
      };
    },
        peg$c19 = "plural",
        peg$c20 = { type: "literal", value: "plural", description: "\"plural\"" },
        peg$c21 = function (pluralStyle) {
      return {
        type: pluralStyle.type,
        ordinal: false,
        offset: pluralStyle.offset || 0,
        options: pluralStyle.options,
        location: location()
      };
    },
        peg$c22 = "selectordinal",
        peg$c23 = { type: "literal", value: "selectordinal", description: "\"selectordinal\"" },
        peg$c24 = function (pluralStyle) {
      return {
        type: pluralStyle.type,
        ordinal: true,
        offset: pluralStyle.offset || 0,
        options: pluralStyle.options,
        location: location()
      };
    },
        peg$c25 = "select",
        peg$c26 = { type: "literal", value: "select", description: "\"select\"" },
        peg$c27 = function (options) {
      return {
        type: 'selectFormat',
        options: options,
        location: location()
      };
    },
        peg$c28 = "=",
        peg$c29 = { type: "literal", value: "=", description: "\"=\"" },
        peg$c30 = function (selector, pattern) {
      return {
        type: 'optionalFormatPattern',
        selector: selector,
        value: pattern,
        location: location()
      };
    },
        peg$c31 = "offset:",
        peg$c32 = { type: "literal", value: "offset:", description: "\"offset:\"" },
        peg$c33 = function (number) {
      return number;
    },
        peg$c34 = function (offset, options) {
      return {
        type: 'pluralFormat',
        offset: offset,
        options: options,
        location: location()
      };
    },
        peg$c35 = { type: "other", description: "whitespace" },
        peg$c36 = /^[ \t\n\r]/,
        peg$c37 = { type: "class", value: "[ \\t\\n\\r]", description: "[ \\t\\n\\r]" },
        peg$c38 = { type: "other", description: "optionalWhitespace" },
        peg$c39 = /^[0-9]/,
        peg$c40 = { type: "class", value: "[0-9]", description: "[0-9]" },
        peg$c41 = /^[0-9a-f]/i,
        peg$c42 = { type: "class", value: "[0-9a-f]i", description: "[0-9a-f]i" },
        peg$c43 = "0",
        peg$c44 = { type: "literal", value: "0", description: "\"0\"" },
        peg$c45 = /^[1-9]/,
        peg$c46 = { type: "class", value: "[1-9]", description: "[1-9]" },
        peg$c47 = function (digits) {
      return parseInt(digits, 10);
    },
        peg$c48 = /^[^{}\\\0-\x1F \t\n\r]/,
        peg$c49 = { type: "class", value: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]", description: "[^{}\\\\\\0-\\x1F\\x7f \\t\\n\\r]" },
        peg$c50 = "\\\\",
        peg$c51 = { type: "literal", value: "\\\\", description: "\"\\\\\\\\\"" },
        peg$c52 = function () {
      return '\\';
    },
        peg$c53 = "\\#",
        peg$c54 = { type: "literal", value: "\\#", description: "\"\\\\#\"" },
        peg$c55 = function () {
      return '\\#';
    },
        peg$c56 = "\\{",
        peg$c57 = { type: "literal", value: "\\{", description: "\"\\\\{\"" },
        peg$c58 = function () {
      return '\u007B';
    },
        peg$c59 = "\\}",
        peg$c60 = { type: "literal", value: "\\}", description: "\"\\\\}\"" },
        peg$c61 = function () {
      return '\u007D';
    },
        peg$c62 = "\\u",
        peg$c63 = { type: "literal", value: "\\u", description: "\"\\\\u\"" },
        peg$c64 = function (digits) {
      return String.fromCharCode(parseInt(digits, 16));
    },
        peg$c65 = function (chars) {
      return chars.join('');
    },
        peg$currPos = 0,
        peg$savedPos = 0,
        peg$posDetailsCache = [{ line: 1, column: 1, seenCR: false }],
        peg$maxFailPos = 0,
        peg$maxFailExpected = [],
        peg$silentFails = 0,
        peg$result;

    if ("startRule" in options) {
      if (!(options.startRule in peg$startRuleFunctions)) {
        throw new Error("Can't start parsing from rule \"" + options.startRule + "\".");
      }

      peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
    }

    function text() {
      return input.substring(peg$savedPos, peg$currPos);
    }

    function location() {
      return peg$computeLocation(peg$savedPos, peg$currPos);
    }

    function expected(description) {
      throw peg$buildException(null, [{ type: "other", description: description }], input.substring(peg$savedPos, peg$currPos), peg$computeLocation(peg$savedPos, peg$currPos));
    }

    function error(message) {
      throw peg$buildException(message, null, input.substring(peg$savedPos, peg$currPos), peg$computeLocation(peg$savedPos, peg$currPos));
    }

    function peg$computePosDetails(pos) {
      var details = peg$posDetailsCache[pos],
          p,
          ch;

      if (details) {
        return details;
      } else {
        p = pos - 1;
        while (!peg$posDetailsCache[p]) {
          p--;
        }

        details = peg$posDetailsCache[p];
        details = {
          line: details.line,
          column: details.column,
          seenCR: details.seenCR
        };

        while (p < pos) {
          ch = input.charAt(p);
          if (ch === "\n") {
            if (!details.seenCR) {
              details.line++;
            }
            details.column = 1;
            details.seenCR = false;
          } else if (ch === "\r" || ch === "\u2028" || ch === "\u2029") {
            details.line++;
            details.column = 1;
            details.seenCR = true;
          } else {
            details.column++;
            details.seenCR = false;
          }

          p++;
        }

        peg$posDetailsCache[pos] = details;
        return details;
      }
    }

    function peg$computeLocation(startPos, endPos) {
      var startPosDetails = peg$computePosDetails(startPos),
          endPosDetails = peg$computePosDetails(endPos);

      return {
        start: {
          offset: startPos,
          line: startPosDetails.line,
          column: startPosDetails.column
        },
        end: {
          offset: endPos,
          line: endPosDetails.line,
          column: endPosDetails.column
        }
      };
    }

    function peg$fail(expected) {
      if (peg$currPos < peg$maxFailPos) {
        return;
      }

      if (peg$currPos > peg$maxFailPos) {
        peg$maxFailPos = peg$currPos;
        peg$maxFailExpected = [];
      }

      peg$maxFailExpected.push(expected);
    }

    function peg$buildException(message, expected, found, location) {
      function cleanupExpected(expected) {
        var i = 1;

        expected.sort(function (a, b) {
          if (a.description < b.description) {
            return -1;
          } else if (a.description > b.description) {
            return 1;
          } else {
            return 0;
          }
        });

        while (i < expected.length) {
          if (expected[i - 1] === expected[i]) {
            expected.splice(i, 1);
          } else {
            i++;
          }
        }
      }

      function buildMessage(expected, found) {
        function stringEscape(s) {
          function hex(ch) {
            return ch.charCodeAt(0).toString(16).toUpperCase();
          }

          return s.replace(/\\/g, '\\\\').replace(/"/g, '\\"').replace(/\x08/g, '\\b').replace(/\t/g, '\\t').replace(/\n/g, '\\n').replace(/\f/g, '\\f').replace(/\r/g, '\\r').replace(/[\x00-\x07\x0B\x0E\x0F]/g, function (ch) {
            return '\\x0' + hex(ch);
          }).replace(/[\x10-\x1F\x80-\xFF]/g, function (ch) {
            return '\\x' + hex(ch);
          }).replace(/[\u0100-\u0FFF]/g, function (ch) {
            return '\\u0' + hex(ch);
          }).replace(/[\u1000-\uFFFF]/g, function (ch) {
            return '\\u' + hex(ch);
          });
        }

        var expectedDescs = new Array(expected.length),
            expectedDesc,
            foundDesc,
            i;

        for (i = 0; i < expected.length; i++) {
          expectedDescs[i] = expected[i].description;
        }

        expectedDesc = expected.length > 1 ? expectedDescs.slice(0, -1).join(", ") + " or " + expectedDescs[expected.length - 1] : expectedDescs[0];

        foundDesc = found ? "\"" + stringEscape(found) + "\"" : "end of input";

        return "Expected " + expectedDesc + " but " + foundDesc + " found.";
      }

      if (expected !== null) {
        cleanupExpected(expected);
      }

      return new peg$SyntaxError(message !== null ? message : buildMessage(expected, found), expected, found, location);
    }

    function peg$parsestart() {
      var s0;

      s0 = peg$parsemessageFormatPattern();

      return s0;
    }

    function peg$parsemessageFormatPattern() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsemessageFormatElement();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsemessageFormatElement();
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c0(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsemessageFormatElement() {
      var s0;

      s0 = peg$parsemessageTextElement();
      if (s0 === peg$FAILED) {
        s0 = peg$parseargumentElement();
      }

      return s0;
    }

    function peg$parsemessageText() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$currPos;
      s3 = peg$parse_();
      if (s3 !== peg$FAILED) {
        s4 = peg$parsechars();
        if (s4 !== peg$FAILED) {
          s5 = peg$parse_();
          if (s5 !== peg$FAILED) {
            s3 = [s3, s4, s5];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
      } else {
        peg$currPos = s2;
        s2 = peg$FAILED;
      }
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$currPos;
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            s4 = peg$parsechars();
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s3 = [s3, s4, s5];
                s2 = s3;
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c1(s1);
      }
      s0 = s1;
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = peg$parsews();
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parsemessageTextElement() {
      var s0, s1;

      s0 = peg$currPos;
      s1 = peg$parsemessageText();
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c2(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parseargument() {
      var s0, s1, s2;

      s0 = peg$parsenumber();
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        s1 = [];
        if (peg$c3.test(input.charAt(peg$currPos))) {
          s2 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c4);
          }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            if (peg$c3.test(input.charAt(peg$currPos))) {
              s2 = input.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c4);
              }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
      }

      return s0;
    }

    function peg$parseargumentElement() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 123) {
        s1 = peg$c5;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c6);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parseargument();
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$currPos;
              if (input.charCodeAt(peg$currPos) === 44) {
                s6 = peg$c7;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c8);
                }
              }
              if (s6 !== peg$FAILED) {
                s7 = peg$parse_();
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseelementFormat();
                  if (s8 !== peg$FAILED) {
                    s6 = [s6, s7, s8];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              if (s5 === peg$FAILED) {
                s5 = null;
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parse_();
                if (s6 !== peg$FAILED) {
                  if (input.charCodeAt(peg$currPos) === 125) {
                    s7 = peg$c9;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c10);
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c11(s3, s5);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseelementFormat() {
      var s0;

      s0 = peg$parsesimpleFormat();
      if (s0 === peg$FAILED) {
        s0 = peg$parsepluralFormat();
        if (s0 === peg$FAILED) {
          s0 = peg$parseselectOrdinalFormat();
          if (s0 === peg$FAILED) {
            s0 = peg$parseselectFormat();
          }
        }
      }

      return s0;
    }

    function peg$parsesimpleFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c12) {
        s1 = peg$c12;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c13);
        }
      }
      if (s1 === peg$FAILED) {
        if (input.substr(peg$currPos, 4) === peg$c14) {
          s1 = peg$c14;
          peg$currPos += 4;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c15);
          }
        }
        if (s1 === peg$FAILED) {
          if (input.substr(peg$currPos, 4) === peg$c16) {
            s1 = peg$c16;
            peg$currPos += 4;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c17);
            }
          }
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 44) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c8);
            }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parse_();
            if (s5 !== peg$FAILED) {
              s6 = peg$parsechars();
              if (s6 !== peg$FAILED) {
                s4 = [s4, s5, s6];
                s3 = s4;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c18(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c19) {
        s1 = peg$c19;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c20);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c8);
            }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c21(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectOrdinalFormat() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 13) === peg$c22) {
        s1 = peg$c22;
        peg$currPos += 13;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c23);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c8);
            }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = peg$parsepluralStyle();
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c24(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselectFormat() {
      var s0, s1, s2, s3, s4, s5, s6;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 6) === peg$c25) {
        s1 = peg$c25;
        peg$currPos += 6;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c26);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 44) {
            s3 = peg$c7;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c8);
            }
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$parse_();
            if (s4 !== peg$FAILED) {
              s5 = [];
              s6 = peg$parseoptionalFormatPattern();
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseoptionalFormatPattern();
                }
              } else {
                s5 = peg$FAILED;
              }
              if (s5 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c27(s5);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseselector() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      s1 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 61) {
        s2 = peg$c28;
        peg$currPos++;
      } else {
        s2 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c29);
        }
      }
      if (s2 !== peg$FAILED) {
        s3 = peg$parsenumber();
        if (s3 !== peg$FAILED) {
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
      } else {
        peg$currPos = s1;
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      if (s0 === peg$FAILED) {
        s0 = peg$parsechars();
      }

      return s0;
    }

    function peg$parseoptionalFormatPattern() {
      var s0, s1, s2, s3, s4, s5, s6, s7, s8;

      s0 = peg$currPos;
      s1 = peg$parse_();
      if (s1 !== peg$FAILED) {
        s2 = peg$parseselector();
        if (s2 !== peg$FAILED) {
          s3 = peg$parse_();
          if (s3 !== peg$FAILED) {
            if (input.charCodeAt(peg$currPos) === 123) {
              s4 = peg$c5;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c6);
              }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parse_();
              if (s5 !== peg$FAILED) {
                s6 = peg$parsemessageFormatPattern();
                if (s6 !== peg$FAILED) {
                  s7 = peg$parse_();
                  if (s7 !== peg$FAILED) {
                    if (input.charCodeAt(peg$currPos) === 125) {
                      s8 = peg$c9;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c10);
                      }
                    }
                    if (s8 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c30(s2, s6);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parseoffset() {
      var s0, s1, s2, s3;

      s0 = peg$currPos;
      if (input.substr(peg$currPos, 7) === peg$c31) {
        s1 = peg$c31;
        peg$currPos += 7;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c32);
        }
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = peg$parsenumber();
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c33(s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsepluralStyle() {
      var s0, s1, s2, s3, s4;

      s0 = peg$currPos;
      s1 = peg$parseoffset();
      if (s1 === peg$FAILED) {
        s1 = null;
      }
      if (s1 !== peg$FAILED) {
        s2 = peg$parse_();
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = peg$parseoptionalFormatPattern();
          if (s4 !== peg$FAILED) {
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parseoptionalFormatPattern();
            }
          } else {
            s3 = peg$FAILED;
          }
          if (s3 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c34(s1, s3);
            s0 = s1;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
      } else {
        peg$currPos = s0;
        s0 = peg$FAILED;
      }

      return s0;
    }

    function peg$parsews() {
      var s0, s1;

      peg$silentFails++;
      s0 = [];
      if (peg$c36.test(input.charAt(peg$currPos))) {
        s1 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c37);
        }
      }
      if (s1 !== peg$FAILED) {
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          if (peg$c36.test(input.charAt(peg$currPos))) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c37);
            }
          }
        }
      } else {
        s0 = peg$FAILED;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c35);
        }
      }

      return s0;
    }

    function peg$parse_() {
      var s0, s1, s2;

      peg$silentFails++;
      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsews();
      while (s2 !== peg$FAILED) {
        s1.push(s2);
        s2 = peg$parsews();
      }
      if (s1 !== peg$FAILED) {
        s0 = input.substring(s0, peg$currPos);
      } else {
        s0 = s1;
      }
      peg$silentFails--;
      if (s0 === peg$FAILED) {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c38);
        }
      }

      return s0;
    }

    function peg$parsedigit() {
      var s0;

      if (peg$c39.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c40);
        }
      }

      return s0;
    }

    function peg$parsehexDigit() {
      var s0;

      if (peg$c41.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c42);
        }
      }

      return s0;
    }

    function peg$parsenumber() {
      var s0, s1, s2, s3, s4, s5;

      s0 = peg$currPos;
      if (input.charCodeAt(peg$currPos) === 48) {
        s1 = peg$c43;
        peg$currPos++;
      } else {
        s1 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c44);
        }
      }
      if (s1 === peg$FAILED) {
        s1 = peg$currPos;
        s2 = peg$currPos;
        if (peg$c45.test(input.charAt(peg$currPos))) {
          s3 = input.charAt(peg$currPos);
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c46);
          }
        }
        if (s3 !== peg$FAILED) {
          s4 = [];
          s5 = peg$parsedigit();
          while (s5 !== peg$FAILED) {
            s4.push(s5);
            s5 = peg$parsedigit();
          }
          if (s4 !== peg$FAILED) {
            s3 = [s3, s4];
            s2 = s3;
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
        } else {
          peg$currPos = s2;
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c47(s1);
      }
      s0 = s1;

      return s0;
    }

    function peg$parsechar() {
      var s0, s1, s2, s3, s4, s5, s6, s7;

      if (peg$c48.test(input.charAt(peg$currPos))) {
        s0 = input.charAt(peg$currPos);
        peg$currPos++;
      } else {
        s0 = peg$FAILED;
        if (peg$silentFails === 0) {
          peg$fail(peg$c49);
        }
      }
      if (s0 === peg$FAILED) {
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c50) {
          s1 = peg$c50;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$c51);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$c52();
        }
        s0 = s1;
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c53) {
            s1 = peg$c53;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c54);
            }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c55();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input.substr(peg$currPos, 2) === peg$c56) {
              s1 = peg$c56;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c57);
              }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c58();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input.substr(peg$currPos, 2) === peg$c59) {
                s1 = peg$c59;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c60);
                }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c61();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input.substr(peg$currPos, 2) === peg$c62) {
                  s1 = peg$c62;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c63);
                  }
                }
                if (s1 !== peg$FAILED) {
                  s2 = peg$currPos;
                  s3 = peg$currPos;
                  s4 = peg$parsehexDigit();
                  if (s4 !== peg$FAILED) {
                    s5 = peg$parsehexDigit();
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parsehexDigit();
                      if (s6 !== peg$FAILED) {
                        s7 = peg$parsehexDigit();
                        if (s7 !== peg$FAILED) {
                          s4 = [s4, s5, s6, s7];
                          s3 = s4;
                        } else {
                          peg$currPos = s3;
                          s3 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s3;
                        s3 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s3;
                      s3 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                  if (s3 !== peg$FAILED) {
                    s2 = input.substring(s2, peg$currPos);
                  } else {
                    s2 = s3;
                  }
                  if (s2 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c64(s2);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              }
            }
          }
        }
      }

      return s0;
    }

    function peg$parsechars() {
      var s0, s1, s2;

      s0 = peg$currPos;
      s1 = [];
      s2 = peg$parsechar();
      if (s2 !== peg$FAILED) {
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parsechar();
        }
      } else {
        s1 = peg$FAILED;
      }
      if (s1 !== peg$FAILED) {
        peg$savedPos = s0;
        s1 = peg$c65(s1);
      }
      s0 = s1;

      return s0;
    }

    peg$result = peg$startRuleFunction();

    if (peg$result !== peg$FAILED && peg$currPos === input.length) {
      return peg$result;
    } else {
      if (peg$result !== peg$FAILED && peg$currPos < input.length) {
        peg$fail({ type: "end", description: "end of input" });
      }

      throw peg$buildException(null, peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
    }
  }

  return {
    SyntaxError: peg$SyntaxError,
    parse: peg$parse
  };
}();

//# sourceMappingURL=parser.js.map

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE


exports["default"] = { "locale": "en", "pluralRuleFunction": function (n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  } };

//# sourceMappingURL=en.js.map

/***/ }),
/* 459 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* jslint esnext: true */



var src$core$$ = __webpack_require__(461),
    src$en$$ = __webpack_require__(464);

src$core$$["default"].__addLocaleData(src$en$$["default"]);
src$core$$["default"].defaultLocale = 'en';

exports["default"] = src$core$$["default"];

//# sourceMappingURL=main.js.map

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



var intl$messageformat$$ = __webpack_require__(60),
    src$diff$$ = __webpack_require__(462),
    src$es5$$ = __webpack_require__(463);
exports["default"] = RelativeFormat;

// -----------------------------------------------------------------------------

var FIELDS = ['second', 'second-short', 'minute', 'minute-short', 'hour', 'hour-short', 'day', 'day-short', 'month', 'month-short', 'year', 'year-short'];
var STYLES = ['best fit', 'numeric'];

// -- RelativeFormat -----------------------------------------------------------

function RelativeFormat(locales, options) {
    options = options || {};

    // Make a copy of `locales` if it's an array, so that it doesn't change
    // since it's used lazily.
    if (src$es5$$.isArray(locales)) {
        locales = locales.concat();
    }

    src$es5$$.defineProperty(this, '_locale', { value: this._resolveLocale(locales) });
    src$es5$$.defineProperty(this, '_options', { value: {
            style: this._resolveStyle(options.style),
            units: this._isValidUnits(options.units) && options.units
        } });

    src$es5$$.defineProperty(this, '_locales', { value: locales });
    src$es5$$.defineProperty(this, '_fields', { value: this._findFields(this._locale) });
    src$es5$$.defineProperty(this, '_messages', { value: src$es5$$.objCreate(null) });

    // "Bind" `format()` method to `this` so it can be passed by reference like
    // the other `Intl` APIs.
    var relativeFormat = this;
    this.format = function format(date, options) {
        return relativeFormat._format(date, options);
    };
}

// Define internal private properties for dealing with locale data.
src$es5$$.defineProperty(RelativeFormat, '__localeData__', { value: src$es5$$.objCreate(null) });
src$es5$$.defineProperty(RelativeFormat, '__addLocaleData', { value: function (data) {
        if (!(data && data.locale)) {
            throw new Error('Locale data provided to IntlRelativeFormat is missing a ' + '`locale` property value');
        }

        RelativeFormat.__localeData__[data.locale.toLowerCase()] = data;

        // Add data to IntlMessageFormat.
        intl$messageformat$$["default"].__addLocaleData(data);
    } });

// Define public `defaultLocale` property which can be set by the developer, or
// it will be set when the first RelativeFormat instance is created by
// leveraging the resolved locale from `Intl`.
src$es5$$.defineProperty(RelativeFormat, 'defaultLocale', {
    enumerable: true,
    writable: true,
    value: undefined
});

// Define public `thresholds` property which can be set by the developer, and
// defaults to relative time thresholds from moment.js.
src$es5$$.defineProperty(RelativeFormat, 'thresholds', {
    enumerable: true,

    value: {
        second: 45, 'second-short': 45, // seconds to minute
        minute: 45, 'minute-short': 45, // minutes to hour
        hour: 22, 'hour-short': 22, // hours to day
        day: 26, 'day-short': 26, // days to month
        month: 11, 'month-short': 11 // months to year
    }
});

RelativeFormat.prototype.resolvedOptions = function () {
    return {
        locale: this._locale,
        style: this._options.style,
        units: this._options.units
    };
};

RelativeFormat.prototype._compileMessage = function (units) {
    // `this._locales` is the original set of locales the user specified to the
    // constructor, while `this._locale` is the resolved root locale.
    var locales = this._locales;
    var resolvedLocale = this._locale;

    var field = this._fields[units];
    var relativeTime = field.relativeTime;
    var future = '';
    var past = '';
    var i;

    for (i in relativeTime.future) {
        if (relativeTime.future.hasOwnProperty(i)) {
            future += ' ' + i + ' {' + relativeTime.future[i].replace('{0}', '#') + '}';
        }
    }

    for (i in relativeTime.past) {
        if (relativeTime.past.hasOwnProperty(i)) {
            past += ' ' + i + ' {' + relativeTime.past[i].replace('{0}', '#') + '}';
        }
    }

    var message = '{when, select, future {{0, plural, ' + future + '}}' + 'past {{0, plural, ' + past + '}}}';

    // Create the synthetic IntlMessageFormat instance using the original
    // locales value specified by the user when constructing the the parent
    // IntlRelativeFormat instance.
    return new intl$messageformat$$["default"](message, locales);
};

RelativeFormat.prototype._getMessage = function (units) {
    var messages = this._messages;

    // Create a new synthetic message based on the locale data from CLDR.
    if (!messages[units]) {
        messages[units] = this._compileMessage(units);
    }

    return messages[units];
};

RelativeFormat.prototype._getRelativeUnits = function (diff, units) {
    var field = this._fields[units];

    if (field.relative) {
        return field.relative[diff];
    }
};

RelativeFormat.prototype._findFields = function (locale) {
    var localeData = RelativeFormat.__localeData__;
    var data = localeData[locale.toLowerCase()];

    // The locale data is de-duplicated, so we have to traverse the locale's
    // hierarchy until we find `fields` to return.
    while (data) {
        if (data.fields) {
            return data.fields;
        }

        data = data.parentLocale && localeData[data.parentLocale.toLowerCase()];
    }

    throw new Error('Locale data added to IntlRelativeFormat is missing `fields` for :' + locale);
};

RelativeFormat.prototype._format = function (date, options) {
    var now = options && options.now !== undefined ? options.now : src$es5$$.dateNow();

    if (date === undefined) {
        date = now;
    }

    // Determine if the `date` and optional `now` values are valid, and throw a
    // similar error to what `Intl.DateTimeFormat#format()` would throw.
    if (!isFinite(now)) {
        throw new RangeError('The `now` option provided to IntlRelativeFormat#format() is not ' + 'in valid range.');
    }

    if (!isFinite(date)) {
        throw new RangeError('The date value provided to IntlRelativeFormat#format() is not ' + 'in valid range.');
    }

    var diffReport = src$diff$$["default"](now, date);
    var units = this._options.units || this._selectUnits(diffReport);
    var diffInUnits = diffReport[units];

    if (this._options.style !== 'numeric') {
        var relativeUnits = this._getRelativeUnits(diffInUnits, units);
        if (relativeUnits) {
            return relativeUnits;
        }
    }

    return this._getMessage(units).format({
        '0': Math.abs(diffInUnits),
        when: diffInUnits < 0 ? 'past' : 'future'
    });
};

RelativeFormat.prototype._isValidUnits = function (units) {
    if (!units || src$es5$$.arrIndexOf.call(FIELDS, units) >= 0) {
        return true;
    }

    if (typeof units === 'string') {
        var suggestion = /s$/.test(units) && units.substr(0, units.length - 1);
        if (suggestion && src$es5$$.arrIndexOf.call(FIELDS, suggestion) >= 0) {
            throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` ' + 'value, did you mean: ' + suggestion);
        }
    }

    throw new Error('"' + units + '" is not a valid IntlRelativeFormat `units` value, it ' + 'must be one of: "' + FIELDS.join('", "') + '"');
};

RelativeFormat.prototype._resolveLocale = function (locales) {
    if (typeof locales === 'string') {
        locales = [locales];
    }

    // Create a copy of the array so we can push on the default locale.
    locales = (locales || []).concat(RelativeFormat.defaultLocale);

    var localeData = RelativeFormat.__localeData__;
    var i, len, localeParts, data;

    // Using the set of locales + the default locale, we look for the first one
    // which that has been registered. When data does not exist for a locale, we
    // traverse its ancestors to find something that's been registered within
    // its hierarchy of locales. Since we lack the proper `parentLocale` data
    // here, we must take a naive approach to traversal.
    for (i = 0, len = locales.length; i < len; i += 1) {
        localeParts = locales[i].toLowerCase().split('-');

        while (localeParts.length) {
            data = localeData[localeParts.join('-')];
            if (data) {
                // Return the normalized locale string; e.g., we return "en-US",
                // instead of "en-us".
                return data.locale;
            }

            localeParts.pop();
        }
    }

    var defaultLocale = locales.pop();
    throw new Error('No locale data has been added to IntlRelativeFormat for: ' + locales.join(', ') + ', or the default locale: ' + defaultLocale);
};

RelativeFormat.prototype._resolveStyle = function (style) {
    // Default to "best fit" style.
    if (!style) {
        return STYLES[0];
    }

    if (src$es5$$.arrIndexOf.call(STYLES, style) >= 0) {
        return style;
    }

    throw new Error('"' + style + '" is not a valid IntlRelativeFormat `style` value, it ' + 'must be one of: "' + STYLES.join('", "') + '"');
};

RelativeFormat.prototype._selectUnits = function (diffReport) {
    var i, l, units;
    var fields = FIELDS.filter(function (field) {
        return field.indexOf('-short') < 1;
    });

    for (i = 0, l = fields.length; i < l; i += 1) {
        units = fields[i];

        if (Math.abs(diffReport[units]) < RelativeFormat.thresholds[units]) {
            break;
        }
    }

    return units;
};

//# sourceMappingURL=core.js.map

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */



var round = Math.round;

function daysToYears(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    return days * 400 / 146097;
}

exports["default"] = function (from, to) {
    // Convert to ms timestamps.
    from = +from;
    to = +to;

    var millisecond = round(to - from),
        second = round(millisecond / 1000),
        minute = round(second / 60),
        hour = round(minute / 60),
        day = round(hour / 24),
        week = round(day / 7);

    var rawYears = daysToYears(day),
        month = round(rawYears * 12),
        year = round(rawYears);

    return {
        millisecond: millisecond,
        second: second,
        'second-short': second,
        minute: minute,
        'minute-short': minute,
        hour: hour,
        'hour-short': hour,
        day: day,
        'day-short': day,
        week: week,
        'week-short': week,
        month: month,
        'month-short': month,
        year: year,
        'year-short': year
    };
};

//# sourceMappingURL=diff.js.map

/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License



var hop = Object.prototype.hasOwnProperty;
var toString = Object.prototype.toString;

var realDefineProp = function () {
    try {
        return !!Object.defineProperty({}, 'a', {});
    } catch (e) {
        return false;
    }
}();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty : function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

var arrIndexOf = Array.prototype.indexOf || function (search, fromIndex) {
    /*jshint validthis:true */
    var arr = this;
    if (!arr.length) {
        return -1;
    }

    for (var i = fromIndex || 0, max = arr.length; i < max; i++) {
        if (arr[i] === search) {
            return i;
        }
    }

    return -1;
};

var isArray = Array.isArray || function (obj) {
    return toString.call(obj) === '[object Array]';
};

var dateNow = Date.now || function () {
    return new Date().getTime();
};

exports.defineProperty = defineProperty, exports.objCreate = objCreate, exports.arrIndexOf = arrIndexOf, exports.isArray = isArray, exports.dateNow = dateNow;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// GENERATED FILE


exports["default"] = { "locale": "en", "pluralRuleFunction": function (n, ord) {
    var s = String(n).split("."),
        v0 = !s[1],
        t0 = Number(s[0]) == n,
        n10 = t0 && s[0].slice(-1),
        n100 = t0 && s[0].slice(-2);if (ord) return n10 == 1 && n100 != 11 ? "one" : n10 == 2 && n100 != 12 ? "two" : n10 == 3 && n100 != 13 ? "few" : "other";return n == 1 && v0 ? "one" : "other";
  }, "fields": { "year": { "displayName": "year", "relative": { "0": "this year", "1": "next year", "-1": "last year" }, "relativeTime": { "future": { "one": "in {0} year", "other": "in {0} years" }, "past": { "one": "{0} year ago", "other": "{0} years ago" } } }, "year-short": { "displayName": "yr.", "relative": { "0": "this yr.", "1": "next yr.", "-1": "last yr." }, "relativeTime": { "future": { "one": "in {0} yr.", "other": "in {0} yr." }, "past": { "one": "{0} yr. ago", "other": "{0} yr. ago" } } }, "month": { "displayName": "month", "relative": { "0": "this month", "1": "next month", "-1": "last month" }, "relativeTime": { "future": { "one": "in {0} month", "other": "in {0} months" }, "past": { "one": "{0} month ago", "other": "{0} months ago" } } }, "month-short": { "displayName": "mo.", "relative": { "0": "this mo.", "1": "next mo.", "-1": "last mo." }, "relativeTime": { "future": { "one": "in {0} mo.", "other": "in {0} mo." }, "past": { "one": "{0} mo. ago", "other": "{0} mo. ago" } } }, "day": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "day-short": { "displayName": "day", "relative": { "0": "today", "1": "tomorrow", "-1": "yesterday" }, "relativeTime": { "future": { "one": "in {0} day", "other": "in {0} days" }, "past": { "one": "{0} day ago", "other": "{0} days ago" } } }, "hour": { "displayName": "hour", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hour", "other": "in {0} hours" }, "past": { "one": "{0} hour ago", "other": "{0} hours ago" } } }, "hour-short": { "displayName": "hr.", "relative": { "0": "this hour" }, "relativeTime": { "future": { "one": "in {0} hr.", "other": "in {0} hr." }, "past": { "one": "{0} hr. ago", "other": "{0} hr. ago" } } }, "minute": { "displayName": "minute", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} minute", "other": "in {0} minutes" }, "past": { "one": "{0} minute ago", "other": "{0} minutes ago" } } }, "minute-short": { "displayName": "min.", "relative": { "0": "this minute" }, "relativeTime": { "future": { "one": "in {0} min.", "other": "in {0} min." }, "past": { "one": "{0} min. ago", "other": "{0} min. ago" } } }, "second": { "displayName": "second", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} second", "other": "in {0} seconds" }, "past": { "one": "{0} second ago", "other": "{0} seconds ago" } } }, "second-short": { "displayName": "sec.", "relative": { "0": "now" }, "relativeTime": { "future": { "one": "in {0} sec.", "other": "in {0} sec." }, "past": { "one": "{0} sec. ago", "other": "{0} sec. ago" } } } } };

//# sourceMappingURL=en.js.map

/***/ }),
/* 465 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jshint esnext: true */



var src$es5$$ = __webpack_require__(467);
exports["default"] = createFormatCache;

// -----------------------------------------------------------------------------

function createFormatCache(FormatConstructor) {
    var cache = src$es5$$.objCreate(null);

    return function () {
        var args = Array.prototype.slice.call(arguments);
        var cacheId = getCacheId(args);
        var format = cacheId && cache[cacheId];

        if (!format) {
            format = new (src$es5$$.bind.apply(FormatConstructor, [null].concat(args)))();

            if (cacheId) {
                cache[cacheId] = format;
            }
        }

        return format;
    };
}

// -- Utilities ----------------------------------------------------------------

function getCacheId(inputs) {
    // When JSON is not available in the runtime, we will not create a cache id.
    if (typeof JSON === 'undefined') {
        return;
    }

    var cacheId = [];

    var i, len, input;

    for (i = 0, len = inputs.length; i < len; i += 1) {
        input = inputs[i];

        if (input && typeof input === 'object') {
            cacheId.push(orderedProps(input));
        } else {
            cacheId.push(input);
        }
    }

    return JSON.stringify(cacheId);
}

function orderedProps(obj) {
    var props = [],
        keys = [];

    var key, i, len, prop;

    for (key in obj) {
        if (obj.hasOwnProperty(key)) {
            keys.push(key);
        }
    }

    var orderedKeys = keys.sort();

    for (i = 0, len = orderedKeys.length; i < len; i += 1) {
        key = orderedKeys[i];
        prop = {};

        prop[key] = obj[key];
        props[i] = prop;
    }

    return props;
}

//# sourceMappingURL=memoizer.js.map

/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/

/* jslint esnext: true */

// Function.prototype.bind implementation from Mozilla Developer Network:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind#Polyfill



var bind = Function.prototype.bind || function (oThis) {
    if (typeof this !== 'function') {
        // closest thing possible to the ECMAScript 5
        // internal IsCallable function
        throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }

    var aArgs = Array.prototype.slice.call(arguments, 1),
        fToBind = this,
        fNOP = function () {},
        fBound = function () {
        return fToBind.apply(this instanceof fNOP ? this : oThis, aArgs.concat(Array.prototype.slice.call(arguments)));
    };

    if (this.prototype) {
        // native functions don't have a prototype
        fNOP.prototype = this.prototype;
    }
    fBound.prototype = new fNOP();

    return fBound;
};

// Purposely using the same implementation as the Intl.js `Intl` polyfill.
// Copyright 2013 Andy Earnshaw, MIT License

var hop = Object.prototype.hasOwnProperty;

var realDefineProp = function () {
    try {
        return !!Object.defineProperty({}, 'a', {});
    } catch (e) {
        return false;
    }
}();

var es3 = !realDefineProp && !Object.prototype.__defineGetter__;

var defineProperty = realDefineProp ? Object.defineProperty : function (obj, name, desc) {

    if ('get' in desc && obj.__defineGetter__) {
        obj.__defineGetter__(name, desc.get);
    } else if (!hop.call(obj, name) || 'value' in desc) {
        obj[name] = desc.value;
    }
};

var objCreate = Object.create || function (proto, props) {
    var obj, k;

    function F() {}
    F.prototype = proto;
    obj = new F();

    for (k in props) {
        if (hop.call(props, k)) {
            defineProperty(obj, k, props[k]);
        }
    }

    return obj;
};

exports.bind = bind, exports.defineProperty = defineProperty, exports.objCreate = objCreate;

//# sourceMappingURL=es5.js.map

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_exif_js__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_exif_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_exif_js__);


var MAX_IMAGE_DIMENSION = 1280;

var getImageUrl = function getImageUrl(inputFile) {
  return new Promise(function (resolve, reject) {
    if (window.URL && URL.createObjectURL) {
      try {
        resolve(URL.createObjectURL(inputFile));
      } catch (error) {
        reject(error);
      }
      return;
    }

    var reader = new FileReader();
    reader.onerror = function () {
      return reject.apply(undefined, arguments);
    };
    reader.onload = function (_ref) {
      var target = _ref.target;
      return resolve(target.result);
    };

    reader.readAsDataURL(inputFile);
  });
};

var loadImage = function loadImage(inputFile) {
  return new Promise(function (resolve, reject) {
    getImageUrl(inputFile).then(function (url) {
      var img = new Image();

      img.onerror = function () {
        return reject.apply(undefined, arguments);
      };
      img.onload = function () {
        return resolve(img);
      };

      img.src = url;
    }).catch(reject);
  });
};

var getOrientation = function getOrientation(img) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'image/png';
  return new Promise(function (resolve) {
    if (type !== 'image/jpeg') {
      resolve(1);
      return;
    }

    __WEBPACK_IMPORTED_MODULE_0_exif_js___default.a.getData(img, function () {
      var orientation = __WEBPACK_IMPORTED_MODULE_0_exif_js___default.a.getTag(img, 'Orientation');
      resolve(orientation);
    });
  });
};

var processImage = function processImage(img, _ref2) {
  var width = _ref2.width,
      height = _ref2.height,
      orientation = _ref2.orientation,
      _ref2$type = _ref2.type,
      type = _ref2$type === undefined ? 'image/png' : _ref2$type;
  return new Promise(function (resolve) {
    var canvas = document.createElement('canvas');

    if (4 < orientation && orientation < 9) {
      canvas.width = height;
      canvas.height = width;
    } else {
      canvas.width = width;
      canvas.height = height;
    }

    var context = canvas.getContext('2d');

    switch (orientation) {
      case 2:
        context.transform(-1, 0, 0, 1, width, 0);break;
      case 3:
        context.transform(-1, 0, 0, -1, width, height);break;
      case 4:
        context.transform(1, 0, 0, -1, 0, height);break;
      case 5:
        context.transform(0, 1, 1, 0, 0, 0);break;
      case 6:
        context.transform(0, 1, -1, 0, height, 0);break;
      case 7:
        context.transform(0, -1, -1, 0, height, width);break;
      case 8:
        context.transform(0, -1, 1, 0, 0, width);break;
    }

    context.drawImage(img, 0, 0, width, height);

    canvas.toBlob(resolve, type);
  });
};

var resizeImage = function resizeImage(img) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'image/png';
  return new Promise(function (resolve, reject) {
    var width = img.width,
        height = img.height;


    var newWidth = void 0,
        newHeight = void 0;

    if (width > height) {
      newHeight = height * MAX_IMAGE_DIMENSION / width;
      newWidth = MAX_IMAGE_DIMENSION;
    } else if (height > width) {
      newWidth = width * MAX_IMAGE_DIMENSION / height;
      newHeight = MAX_IMAGE_DIMENSION;
    } else {
      newWidth = MAX_IMAGE_DIMENSION;
      newHeight = MAX_IMAGE_DIMENSION;
    }

    getOrientation(img, type).then(function (orientation) {
      return processImage(img, {
        width: newWidth,
        height: newHeight,
        orientation: orientation,
        type: type
      });
    }).then(resolve).catch(reject);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (function (inputFile) {
  return new Promise(function (resolve, reject) {
    if (!inputFile.type.match(/image.*/) || inputFile.type === 'image/gif') {
      resolve(inputFile);
      return;
    }

    loadImage(inputFile).then(function (img) {
      if (img.width < MAX_IMAGE_DIMENSION && img.height < MAX_IMAGE_DIMENSION) {
        resolve(inputFile);
        return;
      }

      resizeImage(img, inputFile.type).then(resolve).catch(function () {
        return resolve(inputFile);
      });
    }).catch(reject);
  });
});

/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function () {

    var debug = false;

    var root = this;

    var EXIF = function (obj) {
        if (obj instanceof EXIF) return obj;
        if (!(this instanceof EXIF)) return new EXIF(obj);
        this.EXIFwrapped = obj;
    };

    if (true) {
        if (typeof module !== 'undefined' && module.exports) {
            exports = module.exports = EXIF;
        }
        exports.EXIF = EXIF;
    } else {
        root.EXIF = EXIF;
    }

    var ExifTags = EXIF.Tags = {

        // version tags
        0x9000: "ExifVersion", // EXIF version
        0xA000: "FlashpixVersion", // Flashpix format version

        // colorspace tags
        0xA001: "ColorSpace", // Color space information tag

        // image configuration
        0xA002: "PixelXDimension", // Valid width of meaningful image
        0xA003: "PixelYDimension", // Valid height of meaningful image
        0x9101: "ComponentsConfiguration", // Information about channels
        0x9102: "CompressedBitsPerPixel", // Compressed bits per pixel

        // user information
        0x927C: "MakerNote", // Any desired information written by the manufacturer
        0x9286: "UserComment", // Comments by user

        // related file
        0xA004: "RelatedSoundFile", // Name of related sound file

        // date and time
        0x9003: "DateTimeOriginal", // Date and time when the original image was generated
        0x9004: "DateTimeDigitized", // Date and time when the image was stored digitally
        0x9290: "SubsecTime", // Fractions of seconds for DateTime
        0x9291: "SubsecTimeOriginal", // Fractions of seconds for DateTimeOriginal
        0x9292: "SubsecTimeDigitized", // Fractions of seconds for DateTimeDigitized

        // picture-taking conditions
        0x829A: "ExposureTime", // Exposure time (in seconds)
        0x829D: "FNumber", // F number
        0x8822: "ExposureProgram", // Exposure program
        0x8824: "SpectralSensitivity", // Spectral sensitivity
        0x8827: "ISOSpeedRatings", // ISO speed rating
        0x8828: "OECF", // Optoelectric conversion factor
        0x9201: "ShutterSpeedValue", // Shutter speed
        0x9202: "ApertureValue", // Lens aperture
        0x9203: "BrightnessValue", // Value of brightness
        0x9204: "ExposureBias", // Exposure bias
        0x9205: "MaxApertureValue", // Smallest F number of lens
        0x9206: "SubjectDistance", // Distance to subject in meters
        0x9207: "MeteringMode", // Metering mode
        0x9208: "LightSource", // Kind of light source
        0x9209: "Flash", // Flash status
        0x9214: "SubjectArea", // Location and area of main subject
        0x920A: "FocalLength", // Focal length of the lens in mm
        0xA20B: "FlashEnergy", // Strobe energy in BCPS
        0xA20C: "SpatialFrequencyResponse", //
        0xA20E: "FocalPlaneXResolution", // Number of pixels in width direction per FocalPlaneResolutionUnit
        0xA20F: "FocalPlaneYResolution", // Number of pixels in height direction per FocalPlaneResolutionUnit
        0xA210: "FocalPlaneResolutionUnit", // Unit for measuring FocalPlaneXResolution and FocalPlaneYResolution
        0xA214: "SubjectLocation", // Location of subject in image
        0xA215: "ExposureIndex", // Exposure index selected on camera
        0xA217: "SensingMethod", // Image sensor type
        0xA300: "FileSource", // Image source (3 == DSC)
        0xA301: "SceneType", // Scene type (1 == directly photographed)
        0xA302: "CFAPattern", // Color filter array geometric pattern
        0xA401: "CustomRendered", // Special processing
        0xA402: "ExposureMode", // Exposure mode
        0xA403: "WhiteBalance", // 1 = auto white balance, 2 = manual
        0xA404: "DigitalZoomRation", // Digital zoom ratio
        0xA405: "FocalLengthIn35mmFilm", // Equivalent foacl length assuming 35mm film camera (in mm)
        0xA406: "SceneCaptureType", // Type of scene
        0xA407: "GainControl", // Degree of overall image gain adjustment
        0xA408: "Contrast", // Direction of contrast processing applied by camera
        0xA409: "Saturation", // Direction of saturation processing applied by camera
        0xA40A: "Sharpness", // Direction of sharpness processing applied by camera
        0xA40B: "DeviceSettingDescription", //
        0xA40C: "SubjectDistanceRange", // Distance to subject

        // other tags
        0xA005: "InteroperabilityIFDPointer",
        0xA420: "ImageUniqueID" // Identifier assigned uniquely to each image
    };

    var TiffTags = EXIF.TiffTags = {
        0x0100: "ImageWidth",
        0x0101: "ImageHeight",
        0x8769: "ExifIFDPointer",
        0x8825: "GPSInfoIFDPointer",
        0xA005: "InteroperabilityIFDPointer",
        0x0102: "BitsPerSample",
        0x0103: "Compression",
        0x0106: "PhotometricInterpretation",
        0x0112: "Orientation",
        0x0115: "SamplesPerPixel",
        0x011C: "PlanarConfiguration",
        0x0212: "YCbCrSubSampling",
        0x0213: "YCbCrPositioning",
        0x011A: "XResolution",
        0x011B: "YResolution",
        0x0128: "ResolutionUnit",
        0x0111: "StripOffsets",
        0x0116: "RowsPerStrip",
        0x0117: "StripByteCounts",
        0x0201: "JPEGInterchangeFormat",
        0x0202: "JPEGInterchangeFormatLength",
        0x012D: "TransferFunction",
        0x013E: "WhitePoint",
        0x013F: "PrimaryChromaticities",
        0x0211: "YCbCrCoefficients",
        0x0214: "ReferenceBlackWhite",
        0x0132: "DateTime",
        0x010E: "ImageDescription",
        0x010F: "Make",
        0x0110: "Model",
        0x0131: "Software",
        0x013B: "Artist",
        0x8298: "Copyright"
    };

    var GPSTags = EXIF.GPSTags = {
        0x0000: "GPSVersionID",
        0x0001: "GPSLatitudeRef",
        0x0002: "GPSLatitude",
        0x0003: "GPSLongitudeRef",
        0x0004: "GPSLongitude",
        0x0005: "GPSAltitudeRef",
        0x0006: "GPSAltitude",
        0x0007: "GPSTimeStamp",
        0x0008: "GPSSatellites",
        0x0009: "GPSStatus",
        0x000A: "GPSMeasureMode",
        0x000B: "GPSDOP",
        0x000C: "GPSSpeedRef",
        0x000D: "GPSSpeed",
        0x000E: "GPSTrackRef",
        0x000F: "GPSTrack",
        0x0010: "GPSImgDirectionRef",
        0x0011: "GPSImgDirection",
        0x0012: "GPSMapDatum",
        0x0013: "GPSDestLatitudeRef",
        0x0014: "GPSDestLatitude",
        0x0015: "GPSDestLongitudeRef",
        0x0016: "GPSDestLongitude",
        0x0017: "GPSDestBearingRef",
        0x0018: "GPSDestBearing",
        0x0019: "GPSDestDistanceRef",
        0x001A: "GPSDestDistance",
        0x001B: "GPSProcessingMethod",
        0x001C: "GPSAreaInformation",
        0x001D: "GPSDateStamp",
        0x001E: "GPSDifferential"
    };

    // EXIF 2.3 Spec
    var IFD1Tags = EXIF.IFD1Tags = {
        0x0100: "ImageWidth",
        0x0101: "ImageHeight",
        0x0102: "BitsPerSample",
        0x0103: "Compression",
        0x0106: "PhotometricInterpretation",
        0x0111: "StripOffsets",
        0x0112: "Orientation",
        0x0115: "SamplesPerPixel",
        0x0116: "RowsPerStrip",
        0x0117: "StripByteCounts",
        0x011A: "XResolution",
        0x011B: "YResolution",
        0x011C: "PlanarConfiguration",
        0x0128: "ResolutionUnit",
        0x0201: "JpegIFOffset", // When image format is JPEG, this value show offset to JPEG data stored.(aka "ThumbnailOffset" or "JPEGInterchangeFormat")
        0x0202: "JpegIFByteCount", // When image format is JPEG, this value shows data size of JPEG image (aka "ThumbnailLength" or "JPEGInterchangeFormatLength")
        0x0211: "YCbCrCoefficients",
        0x0212: "YCbCrSubSampling",
        0x0213: "YCbCrPositioning",
        0x0214: "ReferenceBlackWhite"
    };

    var StringValues = EXIF.StringValues = {
        ExposureProgram: {
            0: "Not defined",
            1: "Manual",
            2: "Normal program",
            3: "Aperture priority",
            4: "Shutter priority",
            5: "Creative program",
            6: "Action program",
            7: "Portrait mode",
            8: "Landscape mode"
        },
        MeteringMode: {
            0: "Unknown",
            1: "Average",
            2: "CenterWeightedAverage",
            3: "Spot",
            4: "MultiSpot",
            5: "Pattern",
            6: "Partial",
            255: "Other"
        },
        LightSource: {
            0: "Unknown",
            1: "Daylight",
            2: "Fluorescent",
            3: "Tungsten (incandescent light)",
            4: "Flash",
            9: "Fine weather",
            10: "Cloudy weather",
            11: "Shade",
            12: "Daylight fluorescent (D 5700 - 7100K)",
            13: "Day white fluorescent (N 4600 - 5400K)",
            14: "Cool white fluorescent (W 3900 - 4500K)",
            15: "White fluorescent (WW 3200 - 3700K)",
            17: "Standard light A",
            18: "Standard light B",
            19: "Standard light C",
            20: "D55",
            21: "D65",
            22: "D75",
            23: "D50",
            24: "ISO studio tungsten",
            255: "Other"
        },
        Flash: {
            0x0000: "Flash did not fire",
            0x0001: "Flash fired",
            0x0005: "Strobe return light not detected",
            0x0007: "Strobe return light detected",
            0x0009: "Flash fired, compulsory flash mode",
            0x000D: "Flash fired, compulsory flash mode, return light not detected",
            0x000F: "Flash fired, compulsory flash mode, return light detected",
            0x0010: "Flash did not fire, compulsory flash mode",
            0x0018: "Flash did not fire, auto mode",
            0x0019: "Flash fired, auto mode",
            0x001D: "Flash fired, auto mode, return light not detected",
            0x001F: "Flash fired, auto mode, return light detected",
            0x0020: "No flash function",
            0x0041: "Flash fired, red-eye reduction mode",
            0x0045: "Flash fired, red-eye reduction mode, return light not detected",
            0x0047: "Flash fired, red-eye reduction mode, return light detected",
            0x0049: "Flash fired, compulsory flash mode, red-eye reduction mode",
            0x004D: "Flash fired, compulsory flash mode, red-eye reduction mode, return light not detected",
            0x004F: "Flash fired, compulsory flash mode, red-eye reduction mode, return light detected",
            0x0059: "Flash fired, auto mode, red-eye reduction mode",
            0x005D: "Flash fired, auto mode, return light not detected, red-eye reduction mode",
            0x005F: "Flash fired, auto mode, return light detected, red-eye reduction mode"
        },
        SensingMethod: {
            1: "Not defined",
            2: "One-chip color area sensor",
            3: "Two-chip color area sensor",
            4: "Three-chip color area sensor",
            5: "Color sequential area sensor",
            7: "Trilinear sensor",
            8: "Color sequential linear sensor"
        },
        SceneCaptureType: {
            0: "Standard",
            1: "Landscape",
            2: "Portrait",
            3: "Night scene"
        },
        SceneType: {
            1: "Directly photographed"
        },
        CustomRendered: {
            0: "Normal process",
            1: "Custom process"
        },
        WhiteBalance: {
            0: "Auto white balance",
            1: "Manual white balance"
        },
        GainControl: {
            0: "None",
            1: "Low gain up",
            2: "High gain up",
            3: "Low gain down",
            4: "High gain down"
        },
        Contrast: {
            0: "Normal",
            1: "Soft",
            2: "Hard"
        },
        Saturation: {
            0: "Normal",
            1: "Low saturation",
            2: "High saturation"
        },
        Sharpness: {
            0: "Normal",
            1: "Soft",
            2: "Hard"
        },
        SubjectDistanceRange: {
            0: "Unknown",
            1: "Macro",
            2: "Close view",
            3: "Distant view"
        },
        FileSource: {
            3: "DSC"
        },

        Components: {
            0: "",
            1: "Y",
            2: "Cb",
            3: "Cr",
            4: "R",
            5: "G",
            6: "B"
        }
    };

    function addEvent(element, event, handler) {
        if (element.addEventListener) {
            element.addEventListener(event, handler, false);
        } else if (element.attachEvent) {
            element.attachEvent("on" + event, handler);
        }
    }

    function imageHasData(img) {
        return !!img.exifdata;
    }

    function base64ToArrayBuffer(base64, contentType) {
        contentType = contentType || base64.match(/^data\:([^\;]+)\;base64,/mi)[1] || ''; // e.g. 'data:image/jpeg;base64,...' => 'image/jpeg'
        base64 = base64.replace(/^data\:([^\;]+)\;base64,/gmi, '');
        var binary = atob(base64);
        var len = binary.length;
        var buffer = new ArrayBuffer(len);
        var view = new Uint8Array(buffer);
        for (var i = 0; i < len; i++) {
            view[i] = binary.charCodeAt(i);
        }
        return buffer;
    }

    function objectURLToBlob(url, callback) {
        var http = new XMLHttpRequest();
        http.open("GET", url, true);
        http.responseType = "blob";
        http.onload = function (e) {
            if (this.status == 200 || this.status === 0) {
                callback(this.response);
            }
        };
        http.send();
    }

    function getImageData(img, callback) {
        function handleBinaryFile(binFile) {
            var data = findEXIFinJPEG(binFile);
            img.exifdata = data || {};
            var iptcdata = findIPTCinJPEG(binFile);
            img.iptcdata = iptcdata || {};
            if (EXIF.isXmpEnabled) {
                var xmpdata = findXMPinJPEG(binFile);
                img.xmpdata = xmpdata || {};
            }
            if (callback) {
                callback.call(img);
            }
        }

        if (img.src) {
            if (/^data\:/i.test(img.src)) {
                // Data URI
                var arrayBuffer = base64ToArrayBuffer(img.src);
                handleBinaryFile(arrayBuffer);
            } else if (/^blob\:/i.test(img.src)) {
                // Object URL
                var fileReader = new FileReader();
                fileReader.onload = function (e) {
                    handleBinaryFile(e.target.result);
                };
                objectURLToBlob(img.src, function (blob) {
                    fileReader.readAsArrayBuffer(blob);
                });
            } else {
                var http = new XMLHttpRequest();
                http.onload = function () {
                    if (this.status == 200 || this.status === 0) {
                        handleBinaryFile(http.response);
                    } else {
                        throw "Could not load image";
                    }
                    http = null;
                };
                http.open("GET", img.src, true);
                http.responseType = "arraybuffer";
                http.send(null);
            }
        } else if (self.FileReader && (img instanceof self.Blob || img instanceof self.File)) {
            var fileReader = new FileReader();
            fileReader.onload = function (e) {
                if (debug) console.log("Got file of length " + e.target.result.byteLength);
                handleBinaryFile(e.target.result);
            };

            fileReader.readAsArrayBuffer(img);
        }
    }

    function findEXIFinJPEG(file) {
        var dataView = new DataView(file);

        if (debug) console.log("Got file of length " + file.byteLength);
        if (dataView.getUint8(0) != 0xFF || dataView.getUint8(1) != 0xD8) {
            if (debug) console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }

        var offset = 2,
            length = file.byteLength,
            marker;

        while (offset < length) {
            if (dataView.getUint8(offset) != 0xFF) {
                if (debug) console.log("Not a valid marker at offset " + offset + ", found: " + dataView.getUint8(offset));
                return false; // not a valid marker, something is wrong
            }

            marker = dataView.getUint8(offset + 1);
            if (debug) console.log(marker);

            // we could implement handling for other markers here,
            // but we're only looking for 0xFFE1 for EXIF data

            if (marker == 225) {
                if (debug) console.log("Found 0xFFE1 marker");

                return readEXIFData(dataView, offset + 4, dataView.getUint16(offset + 2) - 2);

                // offset += 2 + file.getShortAt(offset+2, true);
            } else {
                offset += 2 + dataView.getUint16(offset + 2);
            }
        }
    }

    function findIPTCinJPEG(file) {
        var dataView = new DataView(file);

        if (debug) console.log("Got file of length " + file.byteLength);
        if (dataView.getUint8(0) != 0xFF || dataView.getUint8(1) != 0xD8) {
            if (debug) console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }

        var offset = 2,
            length = file.byteLength;

        var isFieldSegmentStart = function (dataView, offset) {
            return dataView.getUint8(offset) === 0x38 && dataView.getUint8(offset + 1) === 0x42 && dataView.getUint8(offset + 2) === 0x49 && dataView.getUint8(offset + 3) === 0x4D && dataView.getUint8(offset + 4) === 0x04 && dataView.getUint8(offset + 5) === 0x04;
        };

        while (offset < length) {

            if (isFieldSegmentStart(dataView, offset)) {

                // Get the length of the name header (which is padded to an even number of bytes)
                var nameHeaderLength = dataView.getUint8(offset + 7);
                if (nameHeaderLength % 2 !== 0) nameHeaderLength += 1;
                // Check for pre photoshop 6 format
                if (nameHeaderLength === 0) {
                    // Always 4
                    nameHeaderLength = 4;
                }

                var startOffset = offset + 8 + nameHeaderLength;
                var sectionLength = dataView.getUint16(offset + 6 + nameHeaderLength);

                return readIPTCData(file, startOffset, sectionLength);

                break;
            }

            // Not the marker, continue searching
            offset++;
        }
    }
    var IptcFieldMap = {
        0x78: 'caption',
        0x6E: 'credit',
        0x19: 'keywords',
        0x37: 'dateCreated',
        0x50: 'byline',
        0x55: 'bylineTitle',
        0x7A: 'captionWriter',
        0x69: 'headline',
        0x74: 'copyright',
        0x0F: 'category'
    };
    function readIPTCData(file, startOffset, sectionLength) {
        var dataView = new DataView(file);
        var data = {};
        var fieldValue, fieldName, dataSize, segmentType, segmentSize;
        var segmentStartPos = startOffset;
        while (segmentStartPos < startOffset + sectionLength) {
            if (dataView.getUint8(segmentStartPos) === 0x1C && dataView.getUint8(segmentStartPos + 1) === 0x02) {
                segmentType = dataView.getUint8(segmentStartPos + 2);
                if (segmentType in IptcFieldMap) {
                    dataSize = dataView.getInt16(segmentStartPos + 3);
                    segmentSize = dataSize + 5;
                    fieldName = IptcFieldMap[segmentType];
                    fieldValue = getStringFromDB(dataView, segmentStartPos + 5, dataSize);
                    // Check if we already stored a value with this name
                    if (data.hasOwnProperty(fieldName)) {
                        // Value already stored with this name, create multivalue field
                        if (data[fieldName] instanceof Array) {
                            data[fieldName].push(fieldValue);
                        } else {
                            data[fieldName] = [data[fieldName], fieldValue];
                        }
                    } else {
                        data[fieldName] = fieldValue;
                    }
                }
            }
            segmentStartPos++;
        }
        return data;
    }

    function readTags(file, tiffStart, dirStart, strings, bigEnd) {
        var entries = file.getUint16(dirStart, !bigEnd),
            tags = {},
            entryOffset,
            tag,
            i;

        for (i = 0; i < entries; i++) {
            entryOffset = dirStart + i * 12 + 2;
            tag = strings[file.getUint16(entryOffset, !bigEnd)];
            if (!tag && debug) console.log("Unknown tag: " + file.getUint16(entryOffset, !bigEnd));
            tags[tag] = readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd);
        }
        return tags;
    }

    function readTagValue(file, entryOffset, tiffStart, dirStart, bigEnd) {
        var type = file.getUint16(entryOffset + 2, !bigEnd),
            numValues = file.getUint32(entryOffset + 4, !bigEnd),
            valueOffset = file.getUint32(entryOffset + 8, !bigEnd) + tiffStart,
            offset,
            vals,
            val,
            n,
            numerator,
            denominator;

        switch (type) {
            case 1: // byte, 8-bit unsigned int
            case 7:
                // undefined, 8-bit byte, value depending on field
                if (numValues == 1) {
                    return file.getUint8(entryOffset + 8, !bigEnd);
                } else {
                    offset = numValues > 4 ? valueOffset : entryOffset + 8;
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getUint8(offset + n);
                    }
                    return vals;
                }

            case 2:
                // ascii, 8-bit byte
                offset = numValues > 4 ? valueOffset : entryOffset + 8;
                return getStringFromDB(file, offset, numValues - 1);

            case 3:
                // short, 16 bit int
                if (numValues == 1) {
                    return file.getUint16(entryOffset + 8, !bigEnd);
                } else {
                    offset = numValues > 2 ? valueOffset : entryOffset + 8;
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getUint16(offset + 2 * n, !bigEnd);
                    }
                    return vals;
                }

            case 4:
                // long, 32 bit int
                if (numValues == 1) {
                    return file.getUint32(entryOffset + 8, !bigEnd);
                } else {
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getUint32(valueOffset + 4 * n, !bigEnd);
                    }
                    return vals;
                }

            case 5:
                // rational = two long values, first is numerator, second is denominator
                if (numValues == 1) {
                    numerator = file.getUint32(valueOffset, !bigEnd);
                    denominator = file.getUint32(valueOffset + 4, !bigEnd);
                    val = new Number(numerator / denominator);
                    val.numerator = numerator;
                    val.denominator = denominator;
                    return val;
                } else {
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        numerator = file.getUint32(valueOffset + 8 * n, !bigEnd);
                        denominator = file.getUint32(valueOffset + 4 + 8 * n, !bigEnd);
                        vals[n] = new Number(numerator / denominator);
                        vals[n].numerator = numerator;
                        vals[n].denominator = denominator;
                    }
                    return vals;
                }

            case 9:
                // slong, 32 bit signed int
                if (numValues == 1) {
                    return file.getInt32(entryOffset + 8, !bigEnd);
                } else {
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getInt32(valueOffset + 4 * n, !bigEnd);
                    }
                    return vals;
                }

            case 10:
                // signed rational, two slongs, first is numerator, second is denominator
                if (numValues == 1) {
                    return file.getInt32(valueOffset, !bigEnd) / file.getInt32(valueOffset + 4, !bigEnd);
                } else {
                    vals = [];
                    for (n = 0; n < numValues; n++) {
                        vals[n] = file.getInt32(valueOffset + 8 * n, !bigEnd) / file.getInt32(valueOffset + 4 + 8 * n, !bigEnd);
                    }
                    return vals;
                }
        }
    }

    /**
    * Given an IFD (Image File Directory) start offset
    * returns an offset to next IFD or 0 if it's the last IFD.
    */
    function getNextIFDOffset(dataView, dirStart, bigEnd) {
        //the first 2bytes means the number of directory entries contains in this IFD
        var entries = dataView.getUint16(dirStart, !bigEnd);

        // After last directory entry, there is a 4bytes of data,
        // it means an offset to next IFD.
        // If its value is '0x00000000', it means this is the last IFD and there is no linked IFD.

        return dataView.getUint32(dirStart + 2 + entries * 12, !bigEnd); // each entry is 12 bytes long
    }

    function readThumbnailImage(dataView, tiffStart, firstIFDOffset, bigEnd) {
        // get the IFD1 offset
        var IFD1OffsetPointer = getNextIFDOffset(dataView, tiffStart + firstIFDOffset, bigEnd);

        if (!IFD1OffsetPointer) {
            // console.log('******** IFD1Offset is empty, image thumb not found ********');
            return {};
        } else if (IFD1OffsetPointer > dataView.byteLength) {
            // this should not happen
            // console.log('******** IFD1Offset is outside the bounds of the DataView ********');
            return {};
        }
        // console.log('*******  thumbnail IFD offset (IFD1) is: %s', IFD1OffsetPointer);

        var thumbTags = readTags(dataView, tiffStart, tiffStart + IFD1OffsetPointer, IFD1Tags, bigEnd);

        // EXIF 2.3 specification for JPEG format thumbnail

        // If the value of Compression(0x0103) Tag in IFD1 is '6', thumbnail image format is JPEG.
        // Most of Exif image uses JPEG format for thumbnail. In that case, you can get offset of thumbnail
        // by JpegIFOffset(0x0201) Tag in IFD1, size of thumbnail by JpegIFByteCount(0x0202) Tag.
        // Data format is ordinary JPEG format, starts from 0xFFD8 and ends by 0xFFD9. It seems that
        // JPEG format and 160x120pixels of size are recommended thumbnail format for Exif2.1 or later.

        if (thumbTags['Compression']) {
            // console.log('Thumbnail image found!');

            switch (thumbTags['Compression']) {
                case 6:
                    // console.log('Thumbnail image format is JPEG');
                    if (thumbTags.JpegIFOffset && thumbTags.JpegIFByteCount) {
                        // extract the thumbnail
                        var tOffset = tiffStart + thumbTags.JpegIFOffset;
                        var tLength = thumbTags.JpegIFByteCount;
                        thumbTags['blob'] = new Blob([new Uint8Array(dataView.buffer, tOffset, tLength)], {
                            type: 'image/jpeg'
                        });
                    }
                    break;

                case 1:
                    console.log("Thumbnail image format is TIFF, which is not implemented.");
                    break;
                default:
                    console.log("Unknown thumbnail image format '%s'", thumbTags['Compression']);
            }
        } else if (thumbTags['PhotometricInterpretation'] == 2) {
            console.log("Thumbnail image format is RGB, which is not implemented.");
        }
        return thumbTags;
    }

    function getStringFromDB(buffer, start, length) {
        var outstr = "";
        for (n = start; n < start + length; n++) {
            outstr += String.fromCharCode(buffer.getUint8(n));
        }
        return outstr;
    }

    function readEXIFData(file, start) {
        if (getStringFromDB(file, start, 4) != "Exif") {
            if (debug) console.log("Not valid EXIF data! " + getStringFromDB(file, start, 4));
            return false;
        }

        var bigEnd,
            tags,
            tag,
            exifData,
            gpsData,
            tiffOffset = start + 6;

        // test for TIFF validity and endianness
        if (file.getUint16(tiffOffset) == 0x4949) {
            bigEnd = false;
        } else if (file.getUint16(tiffOffset) == 0x4D4D) {
            bigEnd = true;
        } else {
            if (debug) console.log("Not valid TIFF data! (no 0x4949 or 0x4D4D)");
            return false;
        }

        if (file.getUint16(tiffOffset + 2, !bigEnd) != 0x002A) {
            if (debug) console.log("Not valid TIFF data! (no 0x002A)");
            return false;
        }

        var firstIFDOffset = file.getUint32(tiffOffset + 4, !bigEnd);

        if (firstIFDOffset < 0x00000008) {
            if (debug) console.log("Not valid TIFF data! (First offset less than 8)", file.getUint32(tiffOffset + 4, !bigEnd));
            return false;
        }

        tags = readTags(file, tiffOffset, tiffOffset + firstIFDOffset, TiffTags, bigEnd);

        if (tags.ExifIFDPointer) {
            exifData = readTags(file, tiffOffset, tiffOffset + tags.ExifIFDPointer, ExifTags, bigEnd);
            for (tag in exifData) {
                switch (tag) {
                    case "LightSource":
                    case "Flash":
                    case "MeteringMode":
                    case "ExposureProgram":
                    case "SensingMethod":
                    case "SceneCaptureType":
                    case "SceneType":
                    case "CustomRendered":
                    case "WhiteBalance":
                    case "GainControl":
                    case "Contrast":
                    case "Saturation":
                    case "Sharpness":
                    case "SubjectDistanceRange":
                    case "FileSource":
                        exifData[tag] = StringValues[tag][exifData[tag]];
                        break;

                    case "ExifVersion":
                    case "FlashpixVersion":
                        exifData[tag] = String.fromCharCode(exifData[tag][0], exifData[tag][1], exifData[tag][2], exifData[tag][3]);
                        break;

                    case "ComponentsConfiguration":
                        exifData[tag] = StringValues.Components[exifData[tag][0]] + StringValues.Components[exifData[tag][1]] + StringValues.Components[exifData[tag][2]] + StringValues.Components[exifData[tag][3]];
                        break;
                }
                tags[tag] = exifData[tag];
            }
        }

        if (tags.GPSInfoIFDPointer) {
            gpsData = readTags(file, tiffOffset, tiffOffset + tags.GPSInfoIFDPointer, GPSTags, bigEnd);
            for (tag in gpsData) {
                switch (tag) {
                    case "GPSVersionID":
                        gpsData[tag] = gpsData[tag][0] + "." + gpsData[tag][1] + "." + gpsData[tag][2] + "." + gpsData[tag][3];
                        break;
                }
                tags[tag] = gpsData[tag];
            }
        }

        // extract thumbnail
        tags['thumbnail'] = readThumbnailImage(file, tiffOffset, firstIFDOffset, bigEnd);

        return tags;
    }

    function findXMPinJPEG(file) {

        if (!('DOMParser' in self)) {
            // console.warn('XML parsing not supported without DOMParser');
            return;
        }
        var dataView = new DataView(file);

        if (debug) console.log("Got file of length " + file.byteLength);
        if (dataView.getUint8(0) != 0xFF || dataView.getUint8(1) != 0xD8) {
            if (debug) console.log("Not a valid JPEG");
            return false; // not a valid jpeg
        }

        var offset = 2,
            length = file.byteLength,
            dom = new DOMParser();

        while (offset < length - 4) {
            if (getStringFromDB(dataView, offset, 4) == "http") {
                var startOffset = offset - 1;
                var sectionLength = dataView.getUint16(offset - 2) - 1;
                var xmpString = getStringFromDB(dataView, startOffset, sectionLength);
                var xmpEndIndex = xmpString.indexOf('xmpmeta>') + 8;
                xmpString = xmpString.substring(xmpString.indexOf('<x:xmpmeta'), xmpEndIndex);

                var indexOfXmp = xmpString.indexOf('x:xmpmeta') + 10;
                //Many custom written programs embed xmp/xml without any namespace. Following are some of them.
                //Without these namespaces, XML is thought to be invalid by parsers
                xmpString = xmpString.slice(0, indexOfXmp) + 'xmlns:Iptc4xmpCore="http://iptc.org/std/Iptc4xmpCore/1.0/xmlns/" ' + 'xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" ' + 'xmlns:tiff="http://ns.adobe.com/tiff/1.0/" ' + 'xmlns:plus="http://schemas.android.com/apk/lib/com.google.android.gms.plus" ' + 'xmlns:ext="http://www.gettyimages.com/xsltExtension/1.0" ' + 'xmlns:exif="http://ns.adobe.com/exif/1.0/" ' + 'xmlns:stEvt="http://ns.adobe.com/xap/1.0/sType/ResourceEvent#" ' + 'xmlns:stRef="http://ns.adobe.com/xap/1.0/sType/ResourceRef#" ' + 'xmlns:crs="http://ns.adobe.com/camera-raw-settings/1.0/" ' + 'xmlns:xapGImg="http://ns.adobe.com/xap/1.0/g/img/" ' + 'xmlns:Iptc4xmpExt="http://iptc.org/std/Iptc4xmpExt/2008-02-29/" ' + xmpString.slice(indexOfXmp);

                var domDocument = dom.parseFromString(xmpString, 'text/xml');
                return xml2Object(domDocument);
            } else {
                offset++;
            }
        }
    }

    function xml2json(xml) {
        var json = {};

        if (xml.nodeType == 1) {
            // element node
            if (xml.attributes.length > 0) {
                json['@attributes'] = {};
                for (var j = 0; j < xml.attributes.length; j++) {
                    var attribute = xml.attributes.item(j);
                    json['@attributes'][attribute.nodeName] = attribute.nodeValue;
                }
            }
        } else if (xml.nodeType == 3) {
            // text node
            return xml.nodeValue;
        }

        // deal with children
        if (xml.hasChildNodes()) {
            for (var i = 0; i < xml.childNodes.length; i++) {
                var child = xml.childNodes.item(i);
                var nodeName = child.nodeName;
                if (json[nodeName] == null) {
                    json[nodeName] = xml2json(child);
                } else {
                    if (json[nodeName].push == null) {
                        var old = json[nodeName];
                        json[nodeName] = [];
                        json[nodeName].push(old);
                    }
                    json[nodeName].push(xml2json(child));
                }
            }
        }

        return json;
    }

    function xml2Object(xml) {
        try {
            var obj = {};
            if (xml.children.length > 0) {
                for (var i = 0; i < xml.children.length; i++) {
                    var item = xml.children.item(i);
                    var attributes = item.attributes;
                    for (var idx in attributes) {
                        var itemAtt = attributes[idx];
                        var dataKey = itemAtt.nodeName;
                        var dataValue = itemAtt.nodeValue;

                        if (dataKey !== undefined) {
                            obj[dataKey] = dataValue;
                        }
                    }
                    var nodeName = item.nodeName;

                    if (typeof obj[nodeName] == "undefined") {
                        obj[nodeName] = xml2json(item);
                    } else {
                        if (typeof obj[nodeName].push == "undefined") {
                            var old = obj[nodeName];

                            obj[nodeName] = [];
                            obj[nodeName].push(old);
                        }
                        obj[nodeName].push(xml2json(item));
                    }
                }
            } else {
                obj = xml.textContent;
            }
            return obj;
        } catch (e) {
            console.log(e.message);
        }
    }

    EXIF.enableXmp = function () {
        EXIF.isXmpEnabled = true;
    };

    EXIF.disableXmp = function () {
        EXIF.isXmpEnabled = false;
    };

    EXIF.getData = function (img, callback) {
        if ((self.Image && img instanceof self.Image || self.HTMLImageElement && img instanceof self.HTMLImageElement) && !img.complete) return false;

        if (!imageHasData(img)) {
            getImageData(img, callback);
        } else {
            if (callback) {
                callback.call(img);
            }
        }
        return true;
    };

    EXIF.getTag = function (img, tag) {
        if (!imageHasData(img)) return;
        return img.exifdata[tag];
    };

    EXIF.getIptcTag = function (img, tag) {
        if (!imageHasData(img)) return;
        return img.iptcdata[tag];
    };

    EXIF.getAllTags = function (img) {
        if (!imageHasData(img)) return {};
        var a,
            data = img.exifdata,
            tags = {};
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                tags[a] = data[a];
            }
        }
        return tags;
    };

    EXIF.getAllIptcTags = function (img) {
        if (!imageHasData(img)) return {};
        var a,
            data = img.iptcdata,
            tags = {};
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                tags[a] = data[a];
            }
        }
        return tags;
    };

    EXIF.pretty = function (img) {
        if (!imageHasData(img)) return "";
        var a,
            data = img.exifdata,
            strPretty = "";
        for (a in data) {
            if (data.hasOwnProperty(a)) {
                if (typeof data[a] == "object") {
                    if (data[a] instanceof Number) {
                        strPretty += a + " : " + data[a] + " [" + data[a].numerator + "/" + data[a].denominator + "]\r\n";
                    } else {
                        strPretty += a + " : [" + data[a].length + " values]\r\n";
                    }
                } else {
                    strPretty += a + " : " + data[a] + "\r\n";
                }
            }
        }
        return strPretty;
    };

    EXIF.readFromBinaryFile = function (file) {
        return findEXIFinJPEG(file);
    };

    if (true) {
        !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
            return EXIF;
        }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
}).call(this);

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = alerts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);



var initialState = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])([]);

function alerts() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_alerts__["c" /* ALERT_SHOW */]:
      return state.push(Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({
        key: state.size > 0 ? state.last().get('key') + 1 : 0,
        title: action.title,
        message: action.message
      }));
    case __WEBPACK_IMPORTED_MODULE_0__actions_alerts__["b" /* ALERT_DISMISS */]:
      return state.filterNot(function (item) {
        return item.get('key') === action.alert.key;
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_alerts__["a" /* ALERT_CLEAR */]:
      return state.clear();
    default:
      return state;
  }
};

/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

exports.default = loadingBarMiddleware;

var _loading_bar_ducks = __webpack_require__(207);

var defaultTypeSuffixes = ['PENDING', 'FULFILLED', 'REJECTED'];

function loadingBarMiddleware() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var promiseTypeSuffixes = config.promiseTypeSuffixes || defaultTypeSuffixes;

  return function (_ref) {
    var dispatch = _ref.dispatch;
    return function (next) {
      return function (action) {
        if (action.type) {
          var _promiseTypeSuffixes = _slicedToArray(promiseTypeSuffixes, 3),
              PENDING = _promiseTypeSuffixes[0],
              FULFILLED = _promiseTypeSuffixes[1],
              REJECTED = _promiseTypeSuffixes[2];

          var isPending = new RegExp(PENDING + '$', 'g');
          var isFulfilled = new RegExp(FULFILLED + '$', 'g');
          var isRejected = new RegExp(REJECTED + '$', 'g');

          if (action.type.match(isPending)) {
            dispatch((0, _loading_bar_ducks.showLoading)());
          } else if (action.type.match(isFulfilled) || action.type.match(isRejected)) {
            dispatch((0, _loading_bar_ducks.hideLoading)());
          }
        }

        return next(action);
      };
    };
  };
}

/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = __webpack_require__(9);

var _loading_bar = __webpack_require__(206);

var mapImmutableStateToProps = function mapImmutableStateToProps(state) {
  return {
    loading: state.get('loadingBar')
  };
};

exports.default = (0, _reactRedux.connect)(mapImmutableStateToProps)(_loading_bar.LoadingBar);

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = modal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_modal__ = __webpack_require__(26);


var initialState = {
  modalType: null,
  modalProps: {}
};

function modal() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_modal__["b" /* MODAL_OPEN */]:
      return { modalType: action.modalType, modalProps: action.modalProps };
    case __WEBPACK_IMPORTED_MODULE_0__actions_modal__["a" /* MODAL_CLOSE */]:
      return initialState;
    default:
      return state;
  }
};

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = userLists;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_accounts__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_interactions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_blocks__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_mutes__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);






var initialState = Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])({
  followers: Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(),
  following: Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(),
  reblogged_by: Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(),
  favourited_by: Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(),
  follow_requests: Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(),
  blocks: Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])(),
  mutes: Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])()
});

var normalizeList = function normalizeList(state, type, id, accounts, next) {
  return state.setIn([type, id], Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])({
    next: next,
    items: Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])(accounts.map(function (item) {
      return item.id;
    }))
  }));
};

var appendToList = function appendToList(state, type, id, accounts, next) {
  return state.updateIn([type, id], function (map) {
    return map.set('next', next).update('items', function (list) {
      return list.concat(accounts.map(function (item) {
        return item.id;
      }));
    });
  });
};

function userLists() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_accounts__["h" /* FOLLOWERS_FETCH_SUCCESS */]:
      return normalizeList(state, 'followers', action.id, action.accounts, action.next);
    case __WEBPACK_IMPORTED_MODULE_0__actions_accounts__["g" /* FOLLOWERS_EXPAND_SUCCESS */]:
      return appendToList(state, 'followers', action.id, action.accounts, action.next);
    case __WEBPACK_IMPORTED_MODULE_0__actions_accounts__["j" /* FOLLOWING_FETCH_SUCCESS */]:
      return normalizeList(state, 'following', action.id, action.accounts, action.next);
    case __WEBPACK_IMPORTED_MODULE_0__actions_accounts__["i" /* FOLLOWING_EXPAND_SUCCESS */]:
      return appendToList(state, 'following', action.id, action.accounts, action.next);
    case __WEBPACK_IMPORTED_MODULE_1__actions_interactions__["f" /* REBLOGS_FETCH_SUCCESS */]:
      return state.setIn(['reblogged_by', action.id], Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])(action.accounts.map(function (item) {
        return item.id;
      })));
    case __WEBPACK_IMPORTED_MODULE_1__actions_interactions__["a" /* FAVOURITES_FETCH_SUCCESS */]:
      return state.setIn(['favourited_by', action.id], Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])(action.accounts.map(function (item) {
        return item.id;
      })));
    case __WEBPACK_IMPORTED_MODULE_0__actions_accounts__["l" /* FOLLOW_REQUESTS_FETCH_SUCCESS */]:
      return state.setIn(['follow_requests', 'items'], Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])(action.accounts.map(function (item) {
        return item.id;
      }))).setIn(['follow_requests', 'next'], action.next);
    case __WEBPACK_IMPORTED_MODULE_0__actions_accounts__["k" /* FOLLOW_REQUESTS_EXPAND_SUCCESS */]:
      return state.updateIn(['follow_requests', 'items'], function (list) {
        return list.concat(action.accounts.map(function (item) {
          return item.id;
        }));
      }).setIn(['follow_requests', 'next'], action.next);
    case __WEBPACK_IMPORTED_MODULE_0__actions_accounts__["m" /* FOLLOW_REQUEST_AUTHORIZE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_accounts__["n" /* FOLLOW_REQUEST_REJECT_SUCCESS */]:
      return state.updateIn(['follow_requests', 'items'], function (list) {
        return list.filterNot(function (item) {
          return item === action.id;
        });
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_blocks__["b" /* BLOCKS_FETCH_SUCCESS */]:
      return state.setIn(['blocks', 'items'], Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])(action.accounts.map(function (item) {
        return item.id;
      }))).setIn(['blocks', 'next'], action.next);
    case __WEBPACK_IMPORTED_MODULE_2__actions_blocks__["a" /* BLOCKS_EXPAND_SUCCESS */]:
      return state.updateIn(['blocks', 'items'], function (list) {
        return list.concat(action.accounts.map(function (item) {
          return item.id;
        }));
      }).setIn(['blocks', 'next'], action.next);
    case __WEBPACK_IMPORTED_MODULE_3__actions_mutes__["b" /* MUTES_FETCH_SUCCESS */]:
      return state.setIn(['mutes', 'items'], Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])(action.accounts.map(function (item) {
        return item.id;
      }))).setIn(['mutes', 'next'], action.next);
    case __WEBPACK_IMPORTED_MODULE_3__actions_mutes__["a" /* MUTES_EXPAND_SUCCESS */]:
      return state.updateIn(['mutes', 'items'], function (list) {
        return list.concat(action.accounts.map(function (item) {
          return item.id;
        }));
      }).setIn(['mutes', 'next'], action.next);
    default:
      return state;
  }
};

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = domainLists;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_domain_blocks__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);



var initialState = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({
  blocks: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({
    items: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedSet"])()
  })
});

function domainLists() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_domain_blocks__["b" /* DOMAIN_BLOCKS_FETCH_SUCCESS */]:
      return state.setIn(['blocks', 'items'], Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["OrderedSet"])(action.domains)).setIn(['blocks', 'next'], action.next);
    case __WEBPACK_IMPORTED_MODULE_0__actions_domain_blocks__["a" /* DOMAIN_BLOCKS_EXPAND_SUCCESS */]:
      return state.updateIn(['blocks', 'items'], function (set) {
        return set.union(action.domains);
      }).setIn(['blocks', 'next'], action.next);
    case __WEBPACK_IMPORTED_MODULE_0__actions_domain_blocks__["d" /* DOMAIN_UNBLOCK_SUCCESS */]:
      return state.updateIn(['blocks', 'items'], function (set) {
        return set.delete(action.domain);
      });
    default:
      return state;
  }
};

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = accounts;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_importer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);



var initialState = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])();

var normalizeAccount = function normalizeAccount(state, account) {
  account = Object.assign({}, account);

  delete account.followers_count;
  delete account.following_count;
  delete account.statuses_count;

  return state.set(account.id, Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(account));
};

var normalizeAccounts = function normalizeAccounts(state, accounts) {
  accounts.forEach(function (account) {
    state = normalizeAccount(state, account);
  });

  return state;
};

function accounts() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_importer__["b" /* ACCOUNT_IMPORT */]:
      return normalizeAccount(state, action.account);
    case __WEBPACK_IMPORTED_MODULE_0__actions_importer__["a" /* ACCOUNTS_IMPORT */]:
      return normalizeAccounts(state, action.accounts);
    default:
      return state;
  }
};

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = accountsCounters;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_accounts__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_importer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);




var normalizeAccount = function normalizeAccount(state, account) {
  return state.set(account.id, Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])({
    followers_count: account.followers_count,
    following_count: account.following_count,
    statuses_count: account.statuses_count
  }));
};

var normalizeAccounts = function normalizeAccounts(state, accounts) {
  accounts.forEach(function (account) {
    state = normalizeAccount(state, account);
  });

  return state;
};

var initialState = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])();

function accountsCounters() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions_importer__["b" /* ACCOUNT_IMPORT */]:
      return normalizeAccount(state, action.account);
    case __WEBPACK_IMPORTED_MODULE_1__actions_importer__["a" /* ACCOUNTS_IMPORT */]:
      return normalizeAccounts(state, action.accounts);
    case __WEBPACK_IMPORTED_MODULE_0__actions_accounts__["b" /* ACCOUNT_FOLLOW_SUCCESS */]:
      return action.alreadyFollowing ? state : state.updateIn([action.relationship.id, 'followers_count'], function (num) {
        return num + 1;
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_accounts__["e" /* ACCOUNT_UNFOLLOW_SUCCESS */]:
      return state.updateIn([action.relationship.id, 'followers_count'], function (num) {
        return Math.max(0, num - 1);
      });
    default:
      return state;
  }
};

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = statuses;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_interactions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_statuses__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_timelines__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_importer__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);






var importStatus = function importStatus(state, status) {
  return state.set(status.id, Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])(status));
};

var importStatuses = function importStatuses(state, statuses) {
  return state.withMutations(function (mutable) {
    return statuses.forEach(function (status) {
      return importStatus(mutable, status);
    });
  });
};

var deleteStatus = function deleteStatus(state, id, references) {
  references.forEach(function (ref) {
    state = deleteStatus(state, ref[0], []);
  });

  return state.delete(id);
};

var initialState = Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])();

function statuses() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_3__actions_importer__["d" /* STATUS_IMPORT */]:
      return importStatus(state, action.status);
    case __WEBPACK_IMPORTED_MODULE_3__actions_importer__["c" /* STATUSES_IMPORT */]:
      return importStatuses(state, action.statuses);
    case __WEBPACK_IMPORTED_MODULE_0__actions_interactions__["c" /* FAVOURITE_REQUEST */]:
      return state.setIn([action.status.get('id'), 'favourited'], true);
    case __WEBPACK_IMPORTED_MODULE_0__actions_interactions__["b" /* FAVOURITE_FAIL */]:
      return state.setIn([action.status.get('id'), 'favourited'], false);
    case __WEBPACK_IMPORTED_MODULE_0__actions_interactions__["h" /* REBLOG_REQUEST */]:
      return state.setIn([action.status.get('id'), 'reblogged'], true);
    case __WEBPACK_IMPORTED_MODULE_0__actions_interactions__["g" /* REBLOG_FAIL */]:
      return state.setIn([action.status.get('id'), 'reblogged'], false);
    case __WEBPACK_IMPORTED_MODULE_1__actions_statuses__["d" /* STATUS_MUTE_SUCCESS */]:
      return state.setIn([action.id, 'muted'], true);
    case __WEBPACK_IMPORTED_MODULE_1__actions_statuses__["f" /* STATUS_UNMUTE_SUCCESS */]:
      return state.setIn([action.id, 'muted'], false);
    case __WEBPACK_IMPORTED_MODULE_1__actions_statuses__["e" /* STATUS_REVEAL */]:
      return state.withMutations(function (map) {
        action.ids.forEach(function (id) {
          return map.setIn([id, 'hidden'], false);
        });
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions_statuses__["c" /* STATUS_HIDE */]:
      return state.withMutations(function (map) {
        action.ids.forEach(function (id) {
          return map.setIn([id, 'hidden'], true);
        });
      });
    case __WEBPACK_IMPORTED_MODULE_2__actions_timelines__["a" /* TIMELINE_DELETE */]:
      return deleteStatus(state, action.id, action.references);
    default:
      return state;
  }
};

/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export storageFreeable */
/* harmony export (immutable) */ __webpack_exports__["a"] = evictStatus;
/* unused harmony export evictStatuses */
/* unused harmony export putAccounts */
/* unused harmony export putStatuses */
/* unused harmony export freeStorage */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__db__ = __webpack_require__(129);


var accountAssetKeys = ['avatar', 'avatar_static', 'header', 'header_static'];
var storageMargin = 8388608;
var storeLimit = 1024;

// navigator.storage is not present on:
// Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.100 Safari/537.36 Edge/16.16299
// estimate method is not present on Chrome 57.0.2987.98 on Linux.
var storageFreeable = 'storage' in navigator && 'estimate' in navigator.storage;

function openCache() {
  // ServiceWorker and Cache API is not available on iOS 11
  // https://webkit.org/status/#specification-service-workers
  return self.caches ? caches.open('mastodon-system') : Promise.reject();
}

function printErrorIfAvailable(error) {
  if (error) {
    console.warn(error);
  }
}

function put(name, objects, onupdate, oncreate) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__db__["a" /* default */])().then(function (db) {
    return new Promise(function (resolve, reject) {
      var putTransaction = db.transaction(name, 'readwrite');
      var putStore = putTransaction.objectStore(name);
      var putIndex = putStore.index('id');

      objects.forEach(function (object) {
        putIndex.getKey(object.id).onsuccess = function (retrieval) {
          function addObject() {
            putStore.add(object);
          }

          function deleteObject() {
            putStore.delete(retrieval.target.result).onsuccess = addObject;
          }

          if (retrieval.target.result) {
            if (onupdate) {
              onupdate(object, retrieval.target.result, putStore, deleteObject);
            } else {
              deleteObject();
            }
          } else {
            if (oncreate) {
              oncreate(object, addObject);
            } else {
              addObject();
            }
          }
        };
      });

      putTransaction.oncomplete = function () {
        var readTransaction = db.transaction(name, 'readonly');
        var readStore = readTransaction.objectStore(name);
        var count = readStore.count();

        count.onsuccess = function () {
          var excess = count.result - storeLimit;

          if (excess > 0) {
            var retrieval = readStore.getAll(null, excess);

            retrieval.onsuccess = function () {
              return resolve(retrieval.result);
            };
            retrieval.onerror = reject;
          } else {
            resolve([]);
          }
        };

        count.onerror = reject;
      };

      putTransaction.onerror = reject;
    }).then(function (resolved) {
      db.close();
      return resolved;
    }, function (error) {
      db.close();
      throw error;
    });
  });
}

function evictAccountsByRecords(records) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__db__["a" /* default */])().then(function (db) {
    var transaction = db.transaction(['accounts', 'statuses'], 'readwrite');
    var accounts = transaction.objectStore('accounts');
    var accountsIdIndex = accounts.index('id');
    var accountsMovedIndex = accounts.index('moved');
    var statuses = transaction.objectStore('statuses');
    var statusesIndex = statuses.index('account');

    function evict(toEvict) {
      toEvict.forEach(function (record) {
        openCache().then(function (cache) {
          return accountAssetKeys.forEach(function (key) {
            return cache.delete(records[key]);
          });
        }).catch(printErrorIfAvailable);

        accountsMovedIndex.getAll(record.id).onsuccess = function (_ref) {
          var target = _ref.target;
          return evict(target.result);
        };

        statusesIndex.getAll(record.id).onsuccess = function (_ref2) {
          var target = _ref2.target;
          return evictStatusesByRecords(target.result);
        };

        accountsIdIndex.getKey(record.id).onsuccess = function (_ref3) {
          var target = _ref3.target;
          return target.result && accounts.delete(target.result);
        };
      });
    }

    evict(records);

    db.close();
  }).catch(printErrorIfAvailable);
}

function evictStatus(id) {
  evictStatuses([id]);
}

function evictStatuses(ids) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__db__["a" /* default */])().then(function (db) {
    var transaction = db.transaction('statuses', 'readwrite');
    var store = transaction.objectStore('statuses');
    var idIndex = store.index('id');
    var reblogIndex = store.index('reblog');

    ids.forEach(function (id) {
      reblogIndex.getAllKeys(id).onsuccess = function (_ref4) {
        var target = _ref4.target;
        return target.result.forEach(function (reblogKey) {
          return store.delete(reblogKey);
        });
      };

      idIndex.getKey(id).onsuccess = function (_ref5) {
        var target = _ref5.target;
        return target.result && store.delete(target.result);
      };
    });

    db.close();
  }).catch(printErrorIfAvailable);
}

function evictStatusesByRecords(records) {
  return evictStatuses(records.map(function (_ref6) {
    var id = _ref6.id;
    return id;
  }));
}

function putAccounts(records, avatarStatic) {
  var avatarKey = avatarStatic ? 'avatar_static' : 'avatar';
  var newURLs = [];

  put('accounts', records, function (newRecord, oldKey, store, oncomplete) {
    store.get(oldKey).onsuccess = function (_ref7) {
      var target = _ref7.target;

      accountAssetKeys.forEach(function (key) {
        var newURL = newRecord[key];
        var oldURL = target.result[key];

        if (newURL !== oldURL) {
          openCache().then(function (cache) {
            return cache.delete(oldURL);
          }).catch(printErrorIfAvailable);
        }
      });

      var newURL = newRecord[avatarKey];
      var oldURL = target.result[avatarKey];

      if (newURL !== oldURL) {
        newURLs.push(newURL);
      }

      oncomplete();
    };
  }, function (newRecord, oncomplete) {
    newURLs.push(newRecord[avatarKey]);
    oncomplete();
  }).then(function (records) {
    return Promise.all([evictAccountsByRecords(records), openCache().then(function (cache) {
      return cache.addAll(newURLs);
    })]);
  }).then(freeStorage, function (error) {
    freeStorage();
    throw error;
  }).catch(printErrorIfAvailable);
}

function putStatuses(records) {
  put('statuses', records).then(evictStatusesByRecords).catch(printErrorIfAvailable);
}

function freeStorage() {
  return storageFreeable && navigator.storage.estimate().then(function (_ref8) {
    var quota = _ref8.quota,
        usage = _ref8.usage;

    if (usage + storageMargin < quota) {
      return null;
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__db__["a" /* default */])().then(function (db) {
      return new Promise(function (resolve, reject) {
        var retrieval = db.transaction('accounts', 'readonly').objectStore('accounts').getAll(null, 1);

        retrieval.onsuccess = function () {
          if (retrieval.result.length > 0) {
            resolve(evictAccountsByRecords(retrieval.result).then(freeStorage));
          } else {
            resolve(caches.delete('mastodon-system'));
          }
        };

        retrieval.onerror = reject;

        db.close();
      });
    });
  });
}

/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = relationships;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_accounts__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_domain_blocks__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);




var normalizeRelationship = function normalizeRelationship(state, relationship) {
  return state.set(relationship.id, Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(relationship));
};

var normalizeRelationships = function normalizeRelationships(state, relationships) {
  relationships.forEach(function (relationship) {
    state = normalizeRelationship(state, relationship);
  });

  return state;
};

var setDomainBlocking = function setDomainBlocking(state, accounts, blocking) {
  return state.withMutations(function (map) {
    accounts.forEach(function (id) {
      map.setIn([id, 'domain_blocking'], blocking);
    });
  });
};

var initialState = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])();

function relationships() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_accounts__["b" /* ACCOUNT_FOLLOW_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_accounts__["e" /* ACCOUNT_UNFOLLOW_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_accounts__["a" /* ACCOUNT_BLOCK_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_accounts__["d" /* ACCOUNT_UNBLOCK_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_accounts__["c" /* ACCOUNT_MUTE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_accounts__["f" /* ACCOUNT_UNMUTE_SUCCESS */]:
      return normalizeRelationship(state, action.relationship);
    case __WEBPACK_IMPORTED_MODULE_0__actions_accounts__["o" /* RELATIONSHIPS_FETCH_SUCCESS */]:
      return normalizeRelationships(state, action.relationships);
    case __WEBPACK_IMPORTED_MODULE_1__actions_domain_blocks__["c" /* DOMAIN_BLOCK_SUCCESS */]:
      return setDomainBlocking(state, action.accounts, true);
    case __WEBPACK_IMPORTED_MODULE_1__actions_domain_blocks__["d" /* DOMAIN_UNBLOCK_SUCCESS */]:
      return setDomainBlocking(state, action.accounts, false);
    default:
      return state;
  }
};

/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = settings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_settings__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_columns__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_store__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_emojis__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_lists__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__uuid__ = __webpack_require__(209);








var initialState = Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"])({
  saved: true,

  onboarded: false,

  skinTone: 1,

  home: Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"])({
    shows: Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"])({
      reblog: true,
      reply: true
    }),

    regex: Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"])({
      body: ''
    })
  }),

  notifications: Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"])({
    alerts: Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"])({
      follow: true,
      favourite: true,
      reblog: true,
      mention: true
    }),

    shows: Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"])({
      follow: true,
      favourite: true,
      reblog: true,
      mention: true
    }),

    sounds: Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"])({
      follow: true,
      favourite: true,
      reblog: true,
      mention: true
    })
  }),

  community: Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"])({
    regex: Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"])({
      body: ''
    })
  }),

  public: Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"])({
    regex: Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"])({
      body: ''
    })
  }),

  direct: Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"])({
    regex: Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"])({
      body: ''
    })
  }),

  trends: Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"])({
    show: true
  })
});

var defaultColumns = Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["fromJS"])([{ id: 'COMPOSE', uuid: Object(__WEBPACK_IMPORTED_MODULE_6__uuid__["a" /* default */])(), params: {} }, { id: 'HOME', uuid: Object(__WEBPACK_IMPORTED_MODULE_6__uuid__["a" /* default */])(), params: {} }, { id: 'NOTIFICATIONS', uuid: Object(__WEBPACK_IMPORTED_MODULE_6__uuid__["a" /* default */])(), params: {} }]);

var hydrate = function hydrate(state, settings) {
  return state.mergeDeep(settings).update('columns', function () {
    var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultColumns;
    return val;
  });
};

var moveColumn = function moveColumn(state, uuid, direction) {
  var columns = state.get('columns');
  var index = columns.findIndex(function (item) {
    return item.get('uuid') === uuid;
  });
  var newIndex = index + direction;

  var newColumns = void 0;

  newColumns = columns.splice(index, 1);
  newColumns = newColumns.splice(newIndex, 0, columns.get(index));

  return state.set('columns', newColumns).set('saved', false);
};

var changeColumnParams = function changeColumnParams(state, uuid, path, value) {
  var columns = state.get('columns');
  var index = columns.findIndex(function (item) {
    return item.get('uuid') === uuid;
  });

  var newColumns = columns.update(index, function (column) {
    return column.updateIn(['params'].concat(path), function () {
      return value;
    });
  });

  return state.set('columns', newColumns).set('saved', false);
};

var updateFrequentEmojis = function updateFrequentEmojis(state, emoji) {
  return state.update('frequentlyUsedEmojis', Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["Map"])(), function (map) {
    return map.update(emoji.id, 0, function (count) {
      return count + 1;
    });
  }).set('saved', false);
};

var filterDeadListColumns = function filterDeadListColumns(state, listId) {
  return state.update('columns', function (columns) {
    return columns.filterNot(function (column) {
      return column.get('id') === 'LIST' && column.get('params').get('id') === listId;
    });
  });
};

function settings() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__actions_store__["a" /* STORE_HYDRATE */]:
      return hydrate(state, action.state.get('settings'));
    case __WEBPACK_IMPORTED_MODULE_0__actions_settings__["a" /* SETTING_CHANGE */]:
      return state.setIn(action.path, action.value).set('saved', false);
    case __WEBPACK_IMPORTED_MODULE_1__actions_columns__["a" /* COLUMN_ADD */]:
      return state.update('columns', function (list) {
        return list.push(Object(__WEBPACK_IMPORTED_MODULE_5_immutable__["fromJS"])({ id: action.id, uuid: Object(__WEBPACK_IMPORTED_MODULE_6__uuid__["a" /* default */])(), params: action.params }));
      }).set('saved', false);
    case __WEBPACK_IMPORTED_MODULE_1__actions_columns__["d" /* COLUMN_REMOVE */]:
      return state.update('columns', function (list) {
        return list.filterNot(function (item) {
          return item.get('uuid') === action.uuid;
        });
      }).set('saved', false);
    case __WEBPACK_IMPORTED_MODULE_1__actions_columns__["b" /* COLUMN_MOVE */]:
      return moveColumn(state, action.uuid, action.direction);
    case __WEBPACK_IMPORTED_MODULE_1__actions_columns__["c" /* COLUMN_PARAMS_CHANGE */]:
      return changeColumnParams(state, action.uuid, action.path, action.value);
    case __WEBPACK_IMPORTED_MODULE_3__actions_emojis__["a" /* EMOJI_USE */]:
      return updateFrequentEmojis(state, action.emoji);
    case __WEBPACK_IMPORTED_MODULE_0__actions_settings__["b" /* SETTING_SAVE */]:
      return state.set('saved', true);
    case __WEBPACK_IMPORTED_MODULE_4__actions_lists__["q" /* LIST_FETCH_FAIL */]:
      return action.error.response.status === 404 ? filterDeadListColumns(state, action.id) : state;
    case __WEBPACK_IMPORTED_MODULE_4__actions_lists__["h" /* LIST_DELETE_SUCCESS */]:
      return filterDeadListColumns(state, action.id);
    default:
      return state;
  }
};

/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = push_subscriptions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_store__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_push_notifications__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);




var initialState = __WEBPACK_IMPORTED_MODULE_2_immutable___default.a.Map({
  subscription: null,
  alerts: new __WEBPACK_IMPORTED_MODULE_2_immutable___default.a.Map({
    follow: false,
    favourite: false,
    reblog: false,
    mention: false
  }),
  isSubscribed: false,
  browserSupport: false
});

function push_subscriptions() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_store__["a" /* STORE_HYDRATE */]:
      {
        var push_subscription = action.state.get('push_subscription');

        if (push_subscription) {
          return state.set('subscription', new __WEBPACK_IMPORTED_MODULE_2_immutable___default.a.Map({
            id: push_subscription.get('id'),
            endpoint: push_subscription.get('endpoint')
          })).set('alerts', push_subscription.get('alerts') || initialState.get('alerts')).set('isSubscribed', true);
        }

        return state;
      }
    case __WEBPACK_IMPORTED_MODULE_1__actions_push_notifications__["d" /* SET_SUBSCRIPTION */]:
      return state.set('subscription', new __WEBPACK_IMPORTED_MODULE_2_immutable___default.a.Map({
        id: action.subscription.id,
        endpoint: action.subscription.endpoint
      })).set('alerts', new __WEBPACK_IMPORTED_MODULE_2_immutable___default.a.Map(action.subscription.alerts)).set('isSubscribed', true);
    case __WEBPACK_IMPORTED_MODULE_1__actions_push_notifications__["c" /* SET_BROWSER_SUPPORT */]:
      return state.set('browserSupport', action.value);
    case __WEBPACK_IMPORTED_MODULE_1__actions_push_notifications__["a" /* CLEAR_SUBSCRIPTION */]:
      return initialState;
    case __WEBPACK_IMPORTED_MODULE_1__actions_push_notifications__["b" /* SET_ALERTS */]:
      return state.setIn(action.path, action.value);
    default:
      return state;
  }
};

/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* harmony export (immutable) */ __webpack_exports__["b"] = saveSettings;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_base64__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__settings__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__setter__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__initial_state__ = __webpack_require__(14);






// Taken from https://www.npmjs.com/package/web-push
var urlBase64ToUint8Array = function urlBase64ToUint8Array(base64String) {
  var padding = '='.repeat((4 - base64String.length % 4) % 4);
  var base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');

  return Object(__WEBPACK_IMPORTED_MODULE_1__utils_base64__["a" /* decode */])(base64);
};

var getApplicationServerKey = function getApplicationServerKey() {
  return document.querySelector('[name="applicationServerKey"]').getAttribute('content');
};

var getRegistration = function getRegistration() {
  return navigator.serviceWorker.ready;
};

var getPushSubscription = function getPushSubscription(registration) {
  return registration.pushManager.getSubscription().then(function (subscription) {
    return { registration: registration, subscription: subscription };
  });
};

var subscribe = function subscribe(registration) {
  return registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(getApplicationServerKey())
  });
};

var unsubscribe = function unsubscribe(_ref) {
  var registration = _ref.registration,
      subscription = _ref.subscription;
  return subscription ? subscription.unsubscribe().then(function () {
    return registration;
  }) : registration;
};

var sendSubscriptionToBackend = function sendSubscriptionToBackend(subscription) {
  var params = { subscription: subscription };

  if (__WEBPACK_IMPORTED_MODULE_4__initial_state__["g" /* me */]) {
    var data = __WEBPACK_IMPORTED_MODULE_2__settings__["a" /* pushNotificationsSetting */].get(__WEBPACK_IMPORTED_MODULE_4__initial_state__["g" /* me */]);
    if (data) {
      params.data = data;
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])().post('/api/web/push_subscriptions', params).then(function (response) {
    return response.data;
  });
};

// Last one checks for payload support: https://web-push-book.gauntface.com/chapter-06/01-non-standards-browsers/#no-payload
var supportsPushNotifications = 'serviceWorker' in navigator && 'PushManager' in window && 'getKey' in PushSubscription.prototype;

function register() {
  return function (dispatch, getState) {
    dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__setter__["g" /* setBrowserSupport */])(supportsPushNotifications));

    if (supportsPushNotifications) {
      if (!getApplicationServerKey()) {
        console.error('The VAPID public key is not set. You will not be able to receive Web Push Notifications.');
        return;
      }

      getRegistration().then(getPushSubscription).then(function (_ref2) {
        var registration = _ref2.registration,
            subscription = _ref2.subscription;

        if (subscription !== null) {
          // We have a subscription, check if it is still valid
          var currentServerKey = new Uint8Array(subscription.options.applicationServerKey).toString();
          var subscriptionServerKey = urlBase64ToUint8Array(getApplicationServerKey()).toString();
          var serverEndpoint = getState().getIn(['push_notifications', 'subscription', 'endpoint']);

          // If the VAPID public key did not change and the endpoint corresponds
          // to the endpoint saved in the backend, the subscription is valid
          if (subscriptionServerKey === currentServerKey && subscription.endpoint === serverEndpoint) {
            return subscription;
          } else {
            // Something went wrong, try to subscribe again
            return unsubscribe({ registration: registration, subscription: subscription }).then(subscribe).then(function (subscription) {
              return sendSubscriptionToBackend(subscription);
            });
          }
        }

        // No subscription, try to subscribe
        return subscribe(registration).then(function (subscription) {
          return sendSubscriptionToBackend(subscription);
        });
      }).then(function (subscription) {
        // If we got a PushSubscription (and not a subscription object from the backend)
        // it means that the backend subscription is valid (and was set during hydration)
        if (!(subscription instanceof PushSubscription)) {
          dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__setter__["h" /* setSubscription */])(subscription));
          if (__WEBPACK_IMPORTED_MODULE_4__initial_state__["g" /* me */]) {
            __WEBPACK_IMPORTED_MODULE_2__settings__["a" /* pushNotificationsSetting */].set(__WEBPACK_IMPORTED_MODULE_4__initial_state__["g" /* me */], { alerts: subscription.alerts });
          }
        }
      }).catch(function (error) {
        if (error.code === 20 && error.name === 'AbortError') {
          console.warn('Your browser supports Web Push Notifications, but does not seem to implement the VAPID protocol.');
        } else if (error.code === 5 && error.name === 'InvalidCharacterError') {
          console.error('The VAPID public key seems to be invalid:', getApplicationServerKey());
        }

        // Clear alerts and hide UI settings
        dispatch(Object(__WEBPACK_IMPORTED_MODULE_3__setter__["e" /* clearSubscription */])());
        if (__WEBPACK_IMPORTED_MODULE_4__initial_state__["g" /* me */]) {
          __WEBPACK_IMPORTED_MODULE_2__settings__["a" /* pushNotificationsSetting */].remove(__WEBPACK_IMPORTED_MODULE_4__initial_state__["g" /* me */]);
        }

        return getRegistration().then(getPushSubscription).then(unsubscribe);
      }).catch(console.warn);
    } else {
      console.warn('Your browser does not support Web Push Notifications.');
    }
  };
}

function saveSettings() {
  return function (_, getState) {
    var state = getState().get('push_notifications');
    var subscription = state.get('subscription');
    var alerts = state.get('alerts');
    var data = { alerts: alerts };

    Object(__WEBPACK_IMPORTED_MODULE_0__api__["a" /* default */])().put('/api/web/push_subscriptions/' + subscription.get('id'), {
      data: data
    }).then(function () {
      if (__WEBPACK_IMPORTED_MODULE_4__initial_state__["g" /* me */]) {
        __WEBPACK_IMPORTED_MODULE_2__settings__["a" /* pushNotificationsSetting */].set(__WEBPACK_IMPORTED_MODULE_4__initial_state__["g" /* me */], data);
      }
    }).catch(console.warn);
  };
}

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = statusLists;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_favourites__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_pin_statuses__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_interactions__ = __webpack_require__(69);





var initialState = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
  favourites: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
    next: null,
    loaded: false,
    items: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])()
  }),
  pins: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
    next: null,
    loaded: false,
    items: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])()
  })
});

var normalizeList = function normalizeList(state, listType, statuses, next) {
  return state.update(listType, function (listMap) {
    return listMap.withMutations(function (map) {
      map.set('next', next);
      map.set('loaded', true);
      map.set('isLoading', false);
      map.set('items', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(statuses.map(function (item) {
        return item.id;
      })));
    });
  });
};

var appendToList = function appendToList(state, listType, statuses, next) {
  return state.update(listType, function (listMap) {
    return listMap.withMutations(function (map) {
      map.set('next', next);
      map.set('isLoading', false);
      map.set('items', map.get('items').concat(statuses.map(function (item) {
        return item.id;
      })));
    });
  });
};

var prependOneToList = function prependOneToList(state, listType, status) {
  return state.update(listType, function (listMap) {
    return listMap.withMutations(function (map) {
      map.set('items', map.get('items').unshift(status.get('id')));
    });
  });
};

var removeOneFromList = function removeOneFromList(state, listType, status) {
  return state.update(listType, function (listMap) {
    return listMap.withMutations(function (map) {
      map.set('items', map.get('items').filter(function (item) {
        return item !== status.get('id');
      }));
    });
  });
};

function statusLists() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_favourites__["e" /* FAVOURITED_STATUSES_FETCH_REQUEST */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_favourites__["b" /* FAVOURITED_STATUSES_EXPAND_REQUEST */]:
      return state.setIn(['favourites', 'isLoading'], true);
    case __WEBPACK_IMPORTED_MODULE_0__actions_favourites__["d" /* FAVOURITED_STATUSES_FETCH_FAIL */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_favourites__["a" /* FAVOURITED_STATUSES_EXPAND_FAIL */]:
      return state.setIn(['favourites', 'isLoading'], false);
    case __WEBPACK_IMPORTED_MODULE_0__actions_favourites__["f" /* FAVOURITED_STATUSES_FETCH_SUCCESS */]:
      return normalizeList(state, 'favourites', action.statuses, action.next);
    case __WEBPACK_IMPORTED_MODULE_0__actions_favourites__["c" /* FAVOURITED_STATUSES_EXPAND_SUCCESS */]:
      return appendToList(state, 'favourites', action.statuses, action.next);
    case __WEBPACK_IMPORTED_MODULE_3__actions_interactions__["d" /* FAVOURITE_SUCCESS */]:
      return prependOneToList(state, 'favourites', action.status);
    case __WEBPACK_IMPORTED_MODULE_3__actions_interactions__["i" /* UNFAVOURITE_SUCCESS */]:
      return removeOneFromList(state, 'favourites', action.status);
    case __WEBPACK_IMPORTED_MODULE_1__actions_pin_statuses__["a" /* PINNED_STATUSES_FETCH_SUCCESS */]:
      return normalizeList(state, 'pins', action.statuses, action.next);
    case __WEBPACK_IMPORTED_MODULE_3__actions_interactions__["e" /* PIN_SUCCESS */]:
      return prependOneToList(state, 'pins', action.status);
    case __WEBPACK_IMPORTED_MODULE_3__actions_interactions__["j" /* UNPIN_SUCCESS */]:
      return removeOneFromList(state, 'pins', action.status);
    default:
      return state;
  }
};

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cards;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_cards__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);




var initialState = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])();

function cards() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_cards__["a" /* STATUS_CARD_FETCH_SUCCESS */]:
      return state.set(action.id, Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(action.card));
    default:
      return state;
  }
};

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_mutes__ = __webpack_require__(90);




var initialState = __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Map({
  new: __WEBPACK_IMPORTED_MODULE_0_immutable___default.a.Map({
    isSubmitting: false,
    account: null,
    notifications: true
  })
});

function mutes() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions_mutes__["c" /* MUTES_INIT_MODAL */]:
      return state.withMutations(function (state) {
        state.setIn(['new', 'isSubmitting'], false);
        state.setIn(['new', 'account'], action.account);
        state.setIn(['new', 'notifications'], true);
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions_mutes__["d" /* MUTES_TOGGLE_HIDE_NOTIFICATIONS */]:
      return state.updateIn(['new', 'notifications'], function (old) {
        return !old;
      });
    default:
      return state;
  }
}

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = reports;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_reports__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);



var initialState = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({
  new: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({
    isSubmitting: false,
    account_id: null,
    status_ids: Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])(),
    comment: '',
    forward: false
  })
});

function reports() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_reports__["d" /* REPORT_INIT */]:
      return state.withMutations(function (map) {
        map.setIn(['new', 'isSubmitting'], false);
        map.setIn(['new', 'account_id'], action.account.get('id'));

        if (state.getIn(['new', 'account_id']) !== action.account.get('id')) {
          map.setIn(['new', 'status_ids'], action.status ? Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])([action.status.getIn(['reblog', 'id'], action.status.get('id'))]) : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])());
          map.setIn(['new', 'comment'], '');
        } else if (action.status) {
          map.updateIn(['new', 'status_ids'], Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])(), function (set) {
            return set.add(action.status.getIn(['reblog', 'id'], action.status.get('id')));
          });
        }
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_reports__["e" /* REPORT_STATUS_TOGGLE */]:
      return state.updateIn(['new', 'status_ids'], Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])(), function (set) {
        if (action.checked) {
          return set.add(action.statusId);
        }

        return set.remove(action.statusId);
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_reports__["b" /* REPORT_COMMENT_CHANGE */]:
      return state.setIn(['new', 'comment'], action.comment);
    case __WEBPACK_IMPORTED_MODULE_0__actions_reports__["c" /* REPORT_FORWARD_CHANGE */]:
      return state.setIn(['new', 'forward'], action.forward);
    case __WEBPACK_IMPORTED_MODULE_0__actions_reports__["g" /* REPORT_SUBMIT_REQUEST */]:
      return state.setIn(['new', 'isSubmitting'], true);
    case __WEBPACK_IMPORTED_MODULE_0__actions_reports__["f" /* REPORT_SUBMIT_FAIL */]:
      return state.setIn(['new', 'isSubmitting'], false);
    case __WEBPACK_IMPORTED_MODULE_0__actions_reports__["a" /* REPORT_CANCEL */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_reports__["h" /* REPORT_SUBMIT_SUCCESS */]:
      return state.withMutations(function (map) {
        map.setIn(['new', 'account_id'], null);
        map.setIn(['new', 'status_ids'], Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Set"])());
        map.setIn(['new', 'comment'], '');
        map.setIn(['new', 'isSubmitting'], false);
      });
    default:
      return state;
  }
};

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = replies;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_accounts__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_statuses__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_timelines__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compare_id__ = __webpack_require__(130);






var initialState = Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])({
  inReplyTos: Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])(),
  replies: Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])()
});

var normalizeContext = function normalizeContext(immutableState, id, ancestors, descendants) {
  return immutableState.withMutations(function (state) {
    state.update('inReplyTos', function (immutableAncestors) {
      return immutableAncestors.withMutations(function (inReplyTos) {
        state.update('replies', function (immutableDescendants) {
          return immutableDescendants.withMutations(function (replies) {
            function addReply(_ref) {
              var id = _ref.id,
                  in_reply_to_id = _ref.in_reply_to_id;

              if (in_reply_to_id && !inReplyTos.has(id)) {

                replies.update(in_reply_to_id, Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])(), function (siblings) {
                  var index = siblings.findLastIndex(function (sibling) {
                    return Object(__WEBPACK_IMPORTED_MODULE_4__compare_id__["a" /* default */])(sibling, id) < 0;
                  });
                  return siblings.insert(index + 1, id);
                });

                inReplyTos.set(id, in_reply_to_id);
              }
            }

            // We know in_reply_to_id of statuses but `id` itself.
            // So we assume that the status of the id replies to last ancestors.

            ancestors.forEach(addReply);

            if (ancestors[0]) {
              addReply({ id: id, in_reply_to_id: ancestors[ancestors.length - 1].id });
            }

            descendants.forEach(addReply);
          });
        });
      });
    });
  });
};

var deleteFromContexts = function deleteFromContexts(immutableState, ids) {
  return immutableState.withMutations(function (state) {
    state.update('inReplyTos', function (immutableAncestors) {
      return immutableAncestors.withMutations(function (inReplyTos) {
        state.update('replies', function (immutableDescendants) {
          return immutableDescendants.withMutations(function (replies) {
            ids.forEach(function (id) {
              var inReplyToIdOfId = inReplyTos.get(id);
              var repliesOfId = replies.get(id);
              var siblings = replies.get(inReplyToIdOfId);

              if (siblings) {
                replies.set(inReplyToIdOfId, siblings.filterNot(function (sibling) {
                  return sibling === id;
                }));
              }

              if (repliesOfId) {
                repliesOfId.forEach(function (reply) {
                  return inReplyTos.delete(reply);
                });
              }

              inReplyTos.delete(id);
              replies.delete(id);
            });
          });
        });
      });
    });
  });
};

var filterContexts = function filterContexts(state, relationship, statuses) {
  var ownedStatusIds = statuses.filter(function (status) {
    return status.get('account') === relationship.id;
  }).map(function (status) {
    return status.get('id');
  });

  return deleteFromContexts(state, ownedStatusIds);
};

var updateContext = function updateContext(state, status) {
  if (status.in_reply_to_id) {
    return state.withMutations(function (mutable) {
      var replies = mutable.getIn(['replies', status.in_reply_to_id], Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])());

      mutable.setIn(['inReplyTos', status.id], status.in_reply_to_id);

      if (!replies.includes(status.id)) {
        mutable.setIn(['replies', status.in_reply_to_id], replies.push(status.id));
      }
    });
  }

  return state;
};

function replies() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_accounts__["a" /* ACCOUNT_BLOCK_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_accounts__["c" /* ACCOUNT_MUTE_SUCCESS */]:
      return filterContexts(state, action.relationship, action.statuses);
    case __WEBPACK_IMPORTED_MODULE_1__actions_statuses__["a" /* CONTEXT_FETCH_SUCCESS */]:
      return normalizeContext(state, action.id, action.ancestors, action.descendants);
    case __WEBPACK_IMPORTED_MODULE_2__actions_timelines__["a" /* TIMELINE_DELETE */]:
      return deleteFromContexts(state, [action.id]);
    case __WEBPACK_IMPORTED_MODULE_2__actions_timelines__["g" /* TIMELINE_UPDATE */]:
      return updateContext(state, action.status);
    default:
      return state;
  }
};

/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_compose__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_timelines__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_store__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_statuses__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__uuid__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__initial_state__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_html__ = __webpack_require__(127);









var initialState = Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["Map"])({
  mounted: 0,
  sensitive: false,
  spoiler: false,
  spoiler_text: '',
  privacy: null,
  text: '',
  focusDate: null,
  caretPosition: null,
  preselectDate: null,
  in_reply_to: null,
  is_composing: false,
  is_submitting: false,
  is_uploading: false,
  progress: 0,
  media_attachments: Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])(),
  suggestion_token: null,
  suggestions: Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])(),
  default_privacy: 'public',
  default_sensitive: false,
  resetFileKey: Math.floor(Math.random() * 0x10000),
  idempotencyKey: null,
  tagHistory: Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])()
});

function statusToTextMentions(state, status) {
  var set = Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["OrderedSet"])([]);

  if (status.getIn(['account', 'id']) !== __WEBPACK_IMPORTED_MODULE_6__initial_state__["g" /* me */]) {
    set = set.add('@' + status.getIn(['account', 'acct']) + ' ');
  }

  return set.union(status.get('mentions').filterNot(function (mention) {
    return mention.get('id') === __WEBPACK_IMPORTED_MODULE_6__initial_state__["g" /* me */];
  }).map(function (mention) {
    return '@' + mention.get('acct') + ' ';
  })).join('');
};

function clearAll(state) {
  return state.withMutations(function (map) {
    map.set('text', '');
    map.set('spoiler', false);
    map.set('spoiler_text', '');
    map.set('is_submitting', false);
    map.set('in_reply_to', null);
    map.set('privacy', state.get('default_privacy'));
    map.set('sensitive', false);
    map.update('media_attachments', function (list) {
      return list.clear();
    });
    map.set('idempotencyKey', Object(__WEBPACK_IMPORTED_MODULE_5__uuid__["a" /* default */])());
  });
};

function appendMedia(state, media) {
  var prevSize = state.get('media_attachments').size;

  return state.withMutations(function (map) {
    map.update('media_attachments', function (list) {
      return list.push(media);
    });
    map.set('is_uploading', false);
    map.set('resetFileKey', Math.floor(Math.random() * 0x10000));
    map.set('idempotencyKey', Object(__WEBPACK_IMPORTED_MODULE_5__uuid__["a" /* default */])());

    if (prevSize === 0 && (state.get('default_sensitive') || state.get('spoiler'))) {
      map.set('sensitive', true);
    }
  });
};

function removeMedia(state, mediaId) {
  var prevSize = state.get('media_attachments').size;

  return state.withMutations(function (map) {
    map.update('media_attachments', function (list) {
      return list.filterNot(function (item) {
        return item.get('id') === mediaId;
      });
    });
    map.set('idempotencyKey', Object(__WEBPACK_IMPORTED_MODULE_5__uuid__["a" /* default */])());

    if (prevSize === 1) {
      map.set('sensitive', false);
    }
  });
};

var insertSuggestion = function insertSuggestion(state, position, token, completion) {
  return state.withMutations(function (map) {
    map.update('text', function (oldText) {
      return '' + oldText.slice(0, position) + completion + ' ' + oldText.slice(position + token.length);
    });
    map.set('suggestion_token', null);
    map.update('suggestions', Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])(), function (list) {
      return list.clear();
    });
    map.set('focusDate', new Date());
    map.set('caretPosition', position + completion.length + 1);
    map.set('idempotencyKey', Object(__WEBPACK_IMPORTED_MODULE_5__uuid__["a" /* default */])());
  });
};

var updateSuggestionTags = function updateSuggestionTags(state, token) {
  var prefix = token.slice(1);

  return state.merge({
    suggestions: state.get('tagHistory').filter(function (tag) {
      return tag.startsWith(prefix);
    }).slice(0, 4).map(function (tag) {
      return '#' + tag;
    }),
    suggestion_token: token
  });
};

var insertEmoji = function insertEmoji(state, position, emojiData, needsSpace) {
  var oldText = state.get('text');
  var emoji = needsSpace ? ' ' + emojiData.native : emojiData.native;

  return state.merge({
    text: '' + oldText.slice(0, position) + emoji + ' ' + oldText.slice(position),
    focusDate: new Date(),
    caretPosition: position + emoji.length + 1,
    idempotencyKey: Object(__WEBPACK_IMPORTED_MODULE_5__uuid__["a" /* default */])()
  });
};

var privacyPreference = function privacyPreference(a, b) {
  var order = ['public', 'unlisted', 'private', 'direct'];
  return order[Math.max(order.indexOf(a), order.indexOf(b), 0)];
};

var hydrate = function hydrate(state, hydratedState) {
  state = clearAll(state.merge(hydratedState));

  if (hydratedState.has('text')) {
    state = state.set('text', hydratedState.get('text'));
  }

  return state;
};

var domParser = new DOMParser();

var expandMentions = function expandMentions(status) {
  var fragment = domParser.parseFromString(status.get('content'), 'text/html').documentElement;

  status.get('mentions').forEach(function (mention) {
    fragment.querySelector('a[href="' + mention.get('url') + '"]').textContent = '@' + mention.get('acct');
  });

  return fragment.innerHTML;
};

function compose() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_2__actions_store__["a" /* STORE_HYDRATE */]:
      return hydrate(state, action.state.get('compose'));
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["f" /* COMPOSE_MOUNT */]:
      return state.set('mounted', state.get('mounted') + 1);
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["u" /* COMPOSE_UNMOUNT */]:
      return state.set('mounted', Math.max(state.get('mounted') - 1, 0)).set('is_composing', false);
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["j" /* COMPOSE_SENSITIVITY_CHANGE */]:
      return state.withMutations(function (map) {
        if (!state.get('spoiler')) {
          map.set('sensitive', !state.get('sensitive'));
        }

        map.set('idempotencyKey', Object(__WEBPACK_IMPORTED_MODULE_5__uuid__["a" /* default */])());
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["k" /* COMPOSE_SPOILERNESS_CHANGE */]:
      return state.withMutations(function (map) {
        map.set('spoiler_text', '');
        map.set('spoiler', !state.get('spoiler'));
        map.set('idempotencyKey', Object(__WEBPACK_IMPORTED_MODULE_5__uuid__["a" /* default */])());

        if (!state.get('sensitive') && state.get('media_attachments').size >= 1) {
          map.set('sensitive', true);
        }
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["l" /* COMPOSE_SPOILER_TEXT_CHANGE */]:
      return state.set('spoiler_text', action.text).set('idempotencyKey', Object(__WEBPACK_IMPORTED_MODULE_5__uuid__["a" /* default */])());
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["D" /* COMPOSE_VISIBILITY_CHANGE */]:
      return state.set('privacy', action.value).set('idempotencyKey', Object(__WEBPACK_IMPORTED_MODULE_5__uuid__["a" /* default */])());
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["a" /* COMPOSE_CHANGE */]:
      return state.set('text', action.text).set('idempotencyKey', Object(__WEBPACK_IMPORTED_MODULE_5__uuid__["a" /* default */])());
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["b" /* COMPOSE_COMPOSING_CHANGE */]:
      return state.set('is_composing', action.value);
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["g" /* COMPOSE_REPLY */]:
      return state.withMutations(function (map) {
        map.set('in_reply_to', action.status.get('id'));
        map.set('text', statusToTextMentions(state, action.status));
        map.set('privacy', privacyPreference(action.status.get('visibility'), state.get('default_privacy')));
        map.set('focusDate', new Date());
        map.set('caretPosition', null);
        map.set('preselectDate', new Date());
        map.set('idempotencyKey', Object(__WEBPACK_IMPORTED_MODULE_5__uuid__["a" /* default */])());

        if (action.status.get('spoiler_text').length > 0) {
          map.set('spoiler', true);
          map.set('spoiler_text', action.status.get('spoiler_text'));
        } else {
          map.set('spoiler', false);
          map.set('spoiler_text', '');
        }
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["h" /* COMPOSE_REPLY_CANCEL */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["i" /* COMPOSE_RESET */]:
      return state.withMutations(function (map) {
        map.set('in_reply_to', null);
        map.set('text', '');
        map.set('spoiler', false);
        map.set('spoiler_text', '');
        map.set('privacy', state.get('default_privacy'));
        map.set('idempotencyKey', Object(__WEBPACK_IMPORTED_MODULE_5__uuid__["a" /* default */])());
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["n" /* COMPOSE_SUBMIT_REQUEST */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["w" /* COMPOSE_UPLOAD_CHANGE_REQUEST */]:
      return state.set('is_submitting', true);
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["o" /* COMPOSE_SUBMIT_SUCCESS */]:
      return clearAll(state);
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["m" /* COMPOSE_SUBMIT_FAIL */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["v" /* COMPOSE_UPLOAD_CHANGE_FAIL */]:
      return state.set('is_submitting', false);
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["A" /* COMPOSE_UPLOAD_REQUEST */]:
      return state.set('is_uploading', true);
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["B" /* COMPOSE_UPLOAD_SUCCESS */]:
      return appendMedia(state, Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])(action.media));
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["y" /* COMPOSE_UPLOAD_FAIL */]:
      return state.set('is_uploading', false);
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["C" /* COMPOSE_UPLOAD_UNDO */]:
      return removeMedia(state, action.media_id);
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["z" /* COMPOSE_UPLOAD_PROGRESS */]:
      return state.set('progress', Math.round(action.loaded / action.total * 100));
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["e" /* COMPOSE_MENTION */]:
      return state.withMutations(function (map) {
        map.update('text', function (text) {
          return [text.trim(), '@' + action.account.get('acct') + ' '].filter(function (str) {
            return str.length !== 0;
          }).join(' ');
        });
        map.set('focusDate', new Date());
        map.set('caretPosition', null);
        map.set('idempotencyKey', Object(__WEBPACK_IMPORTED_MODULE_5__uuid__["a" /* default */])());
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["c" /* COMPOSE_DIRECT */]:
      return state.withMutations(function (map) {
        map.update('text', function (text) {
          return [text.trim(), '@' + action.account.get('acct') + ' '].filter(function (str) {
            return str.length !== 0;
          }).join(' ');
        });
        map.set('privacy', 'direct');
        map.set('focusDate', new Date());
        map.set('caretPosition', null);
        map.set('idempotencyKey', Object(__WEBPACK_IMPORTED_MODULE_5__uuid__["a" /* default */])());
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["p" /* COMPOSE_SUGGESTIONS_CLEAR */]:
      return state.update('suggestions', Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])(), function (list) {
        return list.clear();
      }).set('suggestion_token', null);
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["q" /* COMPOSE_SUGGESTIONS_READY */]:
      return state.set('suggestions', Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["List"])(action.accounts ? action.accounts.map(function (item) {
        return item.id;
      }) : action.emojis)).set('suggestion_token', action.token);
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["r" /* COMPOSE_SUGGESTION_SELECT */]:
      return insertSuggestion(state, action.position, action.token, action.completion);
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["s" /* COMPOSE_SUGGESTION_TAGS_UPDATE */]:
      return updateSuggestionTags(state, action.token);
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["t" /* COMPOSE_TAG_HISTORY_UPDATE */]:
      return state.set('tagHistory', Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])(action.tags));
    case __WEBPACK_IMPORTED_MODULE_1__actions_timelines__["a" /* TIMELINE_DELETE */]:
      if (action.id === state.get('in_reply_to')) {
        return state.set('in_reply_to', null);
      } else {
        return state;
      }
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["d" /* COMPOSE_EMOJI_INSERT */]:
      return insertEmoji(state, action.position, action.emoji, action.needsSpace);
    case __WEBPACK_IMPORTED_MODULE_0__actions_compose__["x" /* COMPOSE_UPLOAD_CHANGE_SUCCESS */]:
      return state.set('is_submitting', false).update('media_attachments', function (list) {
        return list.map(function (item) {
          if (item.get('id') === action.media.id) {
            return Object(__WEBPACK_IMPORTED_MODULE_4_immutable__["fromJS"])(action.media);
          }

          return item;
        });
      });
    case __WEBPACK_IMPORTED_MODULE_3__actions_statuses__["b" /* REDRAFT */]:
      return state.withMutations(function (map) {
        map.set('text', Object(__WEBPACK_IMPORTED_MODULE_7__utils_html__["a" /* unescapeHTML */])(expandMentions(action.status)));
        map.set('in_reply_to', action.status.get('in_reply_to_id'));
        map.set('privacy', action.status.get('visibility'));
        map.set('media_attachments', action.status.get('media_attachments'));
        map.set('focusDate', new Date());
        map.set('caretPosition', null);
        map.set('idempotencyKey', Object(__WEBPACK_IMPORTED_MODULE_5__uuid__["a" /* default */])());

        if (action.status.get('spoiler_text').length > 0) {
          map.set('spoiler', true);
          map.set('spoiler_text', action.status.get('spoiler_text'));
        } else {
          map.set('spoiler', false);
          map.set('spoiler_text', '');
        }
      });
    default:
      return state;
  }
};

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = search;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_search__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_compose__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_immutable__);




var initialState = Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
  value: '',
  submitted: false,
  hidden: false,
  results: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])()
});

function search() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_search__["a" /* SEARCH_CHANGE */]:
      return state.set('value', action.value);
    case __WEBPACK_IMPORTED_MODULE_0__actions_search__["b" /* SEARCH_CLEAR */]:
      return state.withMutations(function (map) {
        map.set('value', '');
        map.set('results', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])());
        map.set('submitted', false);
        map.set('hidden', false);
      });
    case __WEBPACK_IMPORTED_MODULE_0__actions_search__["d" /* SEARCH_SHOW */]:
      return state.set('hidden', false);
    case __WEBPACK_IMPORTED_MODULE_1__actions_compose__["g" /* COMPOSE_REPLY */]:
    case __WEBPACK_IMPORTED_MODULE_1__actions_compose__["e" /* COMPOSE_MENTION */]:
    case __WEBPACK_IMPORTED_MODULE_1__actions_compose__["c" /* COMPOSE_DIRECT */]:
      return state.set('hidden', true);
    case __WEBPACK_IMPORTED_MODULE_0__actions_search__["c" /* SEARCH_FETCH_SUCCESS */]:
      return state.set('results', Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["Map"])({
        accounts: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(action.results.accounts.map(function (item) {
          return item.id;
        })),
        statuses: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["List"])(action.results.statuses.map(function (item) {
          return item.id;
        })),
        hashtags: Object(__WEBPACK_IMPORTED_MODULE_2_immutable__["fromJS"])(action.results.hashtags)
      })).set('submitted', true);
    default:
      return state;
  }
};

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = meta;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_store__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);



var initialState = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])({
  accept_content_types: []
});

function meta() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_store__["a" /* STORE_HYDRATE */]:
      return state.merge(action.state.get('media_attachments'));
    default:
      return state;
  }
};

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = notifications;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_notifications__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_accounts__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_timelines__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compare_id__ = __webpack_require__(130);






var initialState = Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])({
  items: Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])(),
  hasMore: true,
  top: true,
  unread: 0,
  isLoading: false
});

var notificationToMap = function notificationToMap(notification) {
  return Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["Map"])({
    id: notification.id,
    type: notification.type,
    account: notification.account.id,
    status: notification.status ? notification.status.id : null
  });
};

var normalizeNotification = function normalizeNotification(state, notification) {
  var top = state.get('top');

  if (!top) {
    state = state.update('unread', function (unread) {
      return unread + 1;
    });
  }

  return state.update('items', function (list) {
    if (top && list.size > 40) {
      list = list.take(20);
    }

    return list.unshift(notificationToMap(notification));
  });
};

var expandNormalizedNotifications = function expandNormalizedNotifications(state, notifications, next) {
  var items = Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])();

  notifications.forEach(function (n, i) {
    items = items.set(i, notificationToMap(n));
  });

  return state.withMutations(function (mutable) {
    if (!items.isEmpty()) {
      mutable.update('items', function (list) {
        var lastIndex = 1 + list.findLastIndex(function (item) {
          return item !== null && (Object(__WEBPACK_IMPORTED_MODULE_4__compare_id__["a" /* default */])(item.get('id'), items.last().get('id')) > 0 || item.get('id') === items.last().get('id'));
        });

        var firstIndex = 1 + list.take(lastIndex).findLastIndex(function (item) {
          return item !== null && Object(__WEBPACK_IMPORTED_MODULE_4__compare_id__["a" /* default */])(item.get('id'), items.first().get('id')) > 0;
        });

        return list.take(firstIndex).concat(items, list.skip(lastIndex));
      });
    }

    if (!next) {
      mutable.set('hasMore', true);
    }

    mutable.set('isLoading', false);
  });
};

var filterNotifications = function filterNotifications(state, relationship) {
  return state.update('items', function (list) {
    return list.filterNot(function (item) {
      return item !== null && item.get('account') === relationship.id;
    });
  });
};

var updateTop = function updateTop(state, top) {
  if (top) {
    state = state.set('unread', 0);
  }

  return state.set('top', top);
};

var deleteByStatus = function deleteByStatus(state, statusId) {
  return state.update('items', function (list) {
    return list.filterNot(function (item) {
      return item !== null && item.get('status') === statusId;
    });
  });
};

function notifications() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_notifications__["c" /* NOTIFICATIONS_EXPAND_REQUEST */]:
      return state.set('isLoading', true);
    case __WEBPACK_IMPORTED_MODULE_0__actions_notifications__["b" /* NOTIFICATIONS_EXPAND_FAIL */]:
      return state.set('isLoading', false);
    case __WEBPACK_IMPORTED_MODULE_0__actions_notifications__["e" /* NOTIFICATIONS_SCROLL_TOP */]:
      return updateTop(state, action.top);
    case __WEBPACK_IMPORTED_MODULE_0__actions_notifications__["f" /* NOTIFICATIONS_UPDATE */]:
      return normalizeNotification(state, action.notification);
    case __WEBPACK_IMPORTED_MODULE_0__actions_notifications__["d" /* NOTIFICATIONS_EXPAND_SUCCESS */]:
      return expandNormalizedNotifications(state, action.notifications, action.next);
    case __WEBPACK_IMPORTED_MODULE_1__actions_accounts__["a" /* ACCOUNT_BLOCK_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_1__actions_accounts__["c" /* ACCOUNT_MUTE_SUCCESS */]:
      return action.relationship.muting_notifications ? filterNotifications(state, action.relationship) : state;
    case __WEBPACK_IMPORTED_MODULE_0__actions_notifications__["a" /* NOTIFICATIONS_CLEAR */]:
      return state.set('items', Object(__WEBPACK_IMPORTED_MODULE_3_immutable__["List"])()).set('hasMore', false);
    case __WEBPACK_IMPORTED_MODULE_2__actions_timelines__["a" /* TIMELINE_DELETE */]:
      return deleteByStatus(state, action.id);
    case __WEBPACK_IMPORTED_MODULE_2__actions_timelines__["b" /* TIMELINE_DISCONNECT */]:
      return action.timeline === 'home' ? state.update('items', function (items) {
        return items.first() ? items.unshift(null) : items;
      }) : state;
    default:
      return state;
  }
};

/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = statuses;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_height_cache__ = __webpack_require__(94);



var initialState = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();

var setHeight = function setHeight(state, key, id, height) {
  return state.update(key, Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])(), function (map) {
    return map.set(id, height);
  });
};

var clearHeights = function clearHeights() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])();
};

function statuses() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions_height_cache__["b" /* HEIGHT_CACHE_SET */]:
      return setHeight(state, action.key, action.id, action.height);
    case __WEBPACK_IMPORTED_MODULE_1__actions_height_cache__["a" /* HEIGHT_CACHE_CLEAR */]:
      return clearHeights();
    default:
      return state;
  }
};

/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = custom_emojis;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_custom_emojis__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__features_emoji_emoji_mart_search_light__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__features_emoji_emoji__ = __webpack_require__(74);





var initialState = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])([]);

function custom_emojis() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  if (action.type === __WEBPACK_IMPORTED_MODULE_1__actions_custom_emojis__["a" /* CUSTOM_EMOJIS_FETCH_SUCCESS */]) {
    state = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["fromJS"])(action.custom_emojis);
    Object(__WEBPACK_IMPORTED_MODULE_2__features_emoji_emoji_mart_search_light__["a" /* search */])('', { custom: Object(__WEBPACK_IMPORTED_MODULE_3__features_emoji_emoji__["buildCustomEmojis"])(state) });
  }

  return state;
};

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = lists;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_lists__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);



var initialState = Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["Map"])();

var normalizeList = function normalizeList(state, list) {
  return state.set(list.id, Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(list));
};

var normalizeLists = function normalizeLists(state, lists) {
  lists.forEach(function (list) {
    state = normalizeList(state, list);
  });

  return state;
};

function lists() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_lists__["r" /* LIST_FETCH_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_lists__["g" /* LIST_CREATE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_lists__["u" /* LIST_UPDATE_SUCCESS */]:
      return normalizeList(state, action.list);
    case __WEBPACK_IMPORTED_MODULE_0__actions_lists__["a" /* LISTS_FETCH_SUCCESS */]:
      return normalizeLists(state, action.lists);
    case __WEBPACK_IMPORTED_MODULE_0__actions_lists__["h" /* LIST_DELETE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_0__actions_lists__["q" /* LIST_FETCH_FAIL */]:
      return state.set(action.id, false);
    default:
      return state;
  }
};

/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = listEditorReducer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_immutable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actions_lists__ = __webpack_require__(96);



var initialState = Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
  listId: null,
  isSubmitting: false,
  title: '',

  accounts: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
    items: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(),
    loaded: false,
    isLoading: false
  }),

  suggestions: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["Map"])({
    value: '',
    items: Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])()
  })
});

function listEditorReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_1__actions_lists__["k" /* LIST_EDITOR_RESET */]:
      return initialState;
    case __WEBPACK_IMPORTED_MODULE_1__actions_lists__["l" /* LIST_EDITOR_SETUP */]:
      return state.withMutations(function (map) {
        map.set('listId', action.list.get('id'));
        map.set('title', action.list.get('title'));
        map.set('isSubmitting', false);
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions_lists__["p" /* LIST_EDITOR_TITLE_CHANGE */]:
      return state.set('title', action.value);
    case __WEBPACK_IMPORTED_MODULE_1__actions_lists__["f" /* LIST_CREATE_REQUEST */]:
    case __WEBPACK_IMPORTED_MODULE_1__actions_lists__["t" /* LIST_UPDATE_REQUEST */]:
      return state.set('isSubmitting', true);
    case __WEBPACK_IMPORTED_MODULE_1__actions_lists__["e" /* LIST_CREATE_FAIL */]:
    case __WEBPACK_IMPORTED_MODULE_1__actions_lists__["s" /* LIST_UPDATE_FAIL */]:
      return state.set('isSubmitting', false);
    case __WEBPACK_IMPORTED_MODULE_1__actions_lists__["g" /* LIST_CREATE_SUCCESS */]:
    case __WEBPACK_IMPORTED_MODULE_1__actions_lists__["u" /* LIST_UPDATE_SUCCESS */]:
      return state.withMutations(function (map) {
        map.set('isSubmitting', false);
        map.set('listId', action.list.id);
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions_lists__["c" /* LIST_ACCOUNTS_FETCH_REQUEST */]:
      return state.setIn(['accounts', 'isLoading'], true);
    case __WEBPACK_IMPORTED_MODULE_1__actions_lists__["b" /* LIST_ACCOUNTS_FETCH_FAIL */]:
      return state.setIn(['accounts', 'isLoading'], false);
    case __WEBPACK_IMPORTED_MODULE_1__actions_lists__["d" /* LIST_ACCOUNTS_FETCH_SUCCESS */]:
      return state.update('accounts', function (accounts) {
        return accounts.withMutations(function (map) {
          map.set('isLoading', false);
          map.set('loaded', true);
          map.set('items', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(action.accounts.map(function (item) {
            return item.id;
          })));
        });
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions_lists__["m" /* LIST_EDITOR_SUGGESTIONS_CHANGE */]:
      return state.setIn(['suggestions', 'value'], action.value);
    case __WEBPACK_IMPORTED_MODULE_1__actions_lists__["o" /* LIST_EDITOR_SUGGESTIONS_READY */]:
      return state.setIn(['suggestions', 'items'], Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])(action.accounts.map(function (item) {
        return item.id;
      })));
    case __WEBPACK_IMPORTED_MODULE_1__actions_lists__["n" /* LIST_EDITOR_SUGGESTIONS_CLEAR */]:
      return state.update('suggestions', function (suggestions) {
        return suggestions.withMutations(function (map) {
          map.set('items', Object(__WEBPACK_IMPORTED_MODULE_0_immutable__["List"])());
          map.set('value', '');
        });
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions_lists__["i" /* LIST_EDITOR_ADD_SUCCESS */]:
      return state.updateIn(['accounts', 'items'], function (list) {
        return list.unshift(action.accountId);
      });
    case __WEBPACK_IMPORTED_MODULE_1__actions_lists__["j" /* LIST_EDITOR_REMOVE_SUCCESS */]:
      return state.updateIn(['accounts', 'items'], function (list) {
        return list.filterNot(function (item) {
          return item === action.accountId;
        });
      });
    default:
      return state;
  }
};

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = filters;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_filters__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_immutable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_immutable__);



function filters() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["List"])();
  var action = arguments[1];

  switch (action.type) {
    case __WEBPACK_IMPORTED_MODULE_0__actions_filters__["a" /* FILTERS_FETCH_SUCCESS */]:
      return Object(__WEBPACK_IMPORTED_MODULE_1_immutable__["fromJS"])(action.filters);
    default:
      return state;
  }
};

/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loadingBarMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_loading_bar__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux_loading_bar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_redux_loading_bar__);


var defaultTypeSuffixes = ['PENDING', 'FULFILLED', 'REJECTED'];

function loadingBarMiddleware() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var promiseTypeSuffixes = config.promiseTypeSuffixes || defaultTypeSuffixes;

  return function (_ref) {
    var dispatch = _ref.dispatch;
    return function (next) {
      return function (action) {
        if (action.type && !action.skipLoading) {
          var PENDING = promiseTypeSuffixes[0],
              FULFILLED = promiseTypeSuffixes[1],
              REJECTED = promiseTypeSuffixes[2];


          var isPending = new RegExp(PENDING + '$', 'g');
          var isFulfilled = new RegExp(FULFILLED + '$', 'g');
          var isRejected = new RegExp(REJECTED + '$', 'g');

          if (action.type.match(isPending)) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux_loading_bar__["showLoading"])());
          } else if (action.type.match(isFulfilled) || action.type.match(isRejected)) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_0_react_redux_loading_bar__["hideLoading"])());
          }
        }

        return next(action);
      };
    };
  };
};

/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = errorsMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_alerts__ = __webpack_require__(33);


var defaultFailSuffix = 'FAIL';

function errorsMiddleware() {
  return function (_ref) {
    var dispatch = _ref.dispatch;
    return function (next) {
      return function (action) {
        if (action.type && !action.skipAlert) {
          var isFail = new RegExp(defaultFailSuffix + '$', 'g');

          if (action.type.match(isFail)) {
            dispatch(Object(__WEBPACK_IMPORTED_MODULE_0__actions_alerts__["e" /* showAlertForError */])(action.error));
          }
        }

        return next(action);
      };
    };
  };
};

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = soundsMiddleware;
var createAudio = function createAudio(sources) {
  var audio = new Audio();
  sources.forEach(function (_ref) {
    var type = _ref.type,
        src = _ref.src;

    var source = document.createElement('source');
    source.type = type;
    source.src = src;
    audio.appendChild(source);
  });
  return audio;
};

var play = function play(audio) {
  if (!audio.paused) {
    audio.pause();
    if (typeof audio.fastSeek === 'function') {
      audio.fastSeek(0);
    } else {
      audio.currentTime = 0;
    }
  }

  audio.play();
};

function soundsMiddleware() {
  var soundCache = {
    boop: createAudio([{
      src: '/sounds/boop.ogg',
      type: 'audio/ogg'
    }, {
      src: '/sounds/boop.mp3',
      type: 'audio/mpeg'
    }])
  };

  return function () {
    return function (next) {
      return function (action) {
        if (action.meta && action.meta.sound && soundCache[action.meta.sound]) {
          play(soundCache[action.meta.sound]);
        }

        return next(action);
      };
    };
  };
};

/***/ }),
/* 501 */,
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(503), __esModule: true };

/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(504);
module.exports = __webpack_require__(24).Object.assign;

/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(38);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(505) });

/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)

var getKeys = __webpack_require__(76);
var gOPS = __webpack_require__(119);
var pIE = __webpack_require__(81);
var toObject = __webpack_require__(106);
var IObject = __webpack_require__(174);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(46)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) {
    B[k] = k;
  });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) {
  // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  }return T;
} : $assign;

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StatusActionBar; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__icon_button__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_dropdown_menu_container__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_intl__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_immutable_pure_component__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_immutable_pure_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_immutable_pure_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__initial_state__ = __webpack_require__(14);





var _class, _class2, _temp2;










var messages = Object(__WEBPACK_IMPORTED_MODULE_9_react_intl__["f" /* defineMessages */])({
  delete: {
    'id': 'status.delete',
    'defaultMessage': 'Delete'
  },
  redraft: {
    'id': 'status.redraft',
    'defaultMessage': 'Delete & re-draft'
  },
  direct: {
    'id': 'status.direct',
    'defaultMessage': 'Direct message @{name}'
  },
  mention: {
    'id': 'status.mention',
    'defaultMessage': 'Mention @{name}'
  },
  mute: {
    'id': 'account.mute',
    'defaultMessage': 'Mute @{name}'
  },
  block: {
    'id': 'account.block',
    'defaultMessage': 'Block @{name}'
  },
  reply: {
    'id': 'status.reply',
    'defaultMessage': 'Reply'
  },
  share: {
    'id': 'status.share',
    'defaultMessage': 'Share'
  },
  more: {
    'id': 'status.more',
    'defaultMessage': 'More'
  },
  replyAll: {
    'id': 'status.replyAll',
    'defaultMessage': 'Reply to thread'
  },
  reblog: {
    'id': 'status.reblog',
    'defaultMessage': 'Boost'
  },
  reblog_private: {
    'id': 'status.reblog_private',
    'defaultMessage': 'Boost to original audience'
  },
  cancel_reblog_private: {
    'id': 'status.cancel_reblog_private',
    'defaultMessage': 'Unboost'
  },
  cannot_reblog: {
    'id': 'status.cannot_reblog',
    'defaultMessage': 'This post cannot be boosted'
  },
  favourite: {
    'id': 'status.favourite',
    'defaultMessage': 'Favourite'
  },
  open: {
    'id': 'status.open',
    'defaultMessage': 'Expand this status'
  },
  report: {
    'id': 'status.report',
    'defaultMessage': 'Report @{name}'
  },
  muteConversation: {
    'id': 'status.mute_conversation',
    'defaultMessage': 'Mute conversation'
  },
  unmuteConversation: {
    'id': 'status.unmute_conversation',
    'defaultMessage': 'Unmute conversation'
  },
  pin: {
    'id': 'status.pin',
    'defaultMessage': 'Pin on profile'
  },
  unpin: {
    'id': 'status.unpin',
    'defaultMessage': 'Unpin from profile'
  },
  embed: {
    'id': 'status.embed',
    'defaultMessage': 'Embed'
  }
});

var StatusActionBar = Object(__WEBPACK_IMPORTED_MODULE_9_react_intl__["g" /* injectIntl */])(_class = (_temp2 = _class2 = function (_ImmutablePureCompone) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(StatusActionBar, _ImmutablePureCompone);

  function StatusActionBar() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, StatusActionBar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _ImmutablePureCompone.call.apply(_ImmutablePureCompone, [this].concat(args))), _this), _this.updateOnProps = ['status', 'withDismiss'], _this.handleReplyClick = function () {
      _this.props.onReply(_this.props.status, _this.context.router.history);
    }, _this.handleShareClick = function () {
      navigator.share({
        text: _this.props.status.get('search_index'),
        url: _this.props.status.get('url')
      }).catch(function (e) {
        if (e.name !== 'AbortError') console.error(e);
      });
    }, _this.handleFavouriteClick = function () {
      _this.props.onFavourite(_this.props.status);
    }, _this.handleReblogClick = function (e) {
      _this.props.onReblog(_this.props.status, e);
    }, _this.handleDeleteClick = function () {
      _this.props.onDelete(_this.props.status);
    }, _this.handleRedraftClick = function () {
      _this.props.onDelete(_this.props.status, true);
    }, _this.handlePinClick = function () {
      _this.props.onPin(_this.props.status);
    }, _this.handleMentionClick = function () {
      _this.props.onMention(_this.props.status.get('account'), _this.context.router.history);
    }, _this.handleDirectClick = function () {
      _this.props.onDirect(_this.props.status.get('account'), _this.context.router.history);
    }, _this.handleMuteClick = function () {
      _this.props.onMute(_this.props.status.get('account'));
    }, _this.handleBlockClick = function () {
      _this.props.onBlock(_this.props.status.get('account'));
    }, _this.handleOpen = function () {
      _this.context.router.history.push('/statuses/' + _this.props.status.get('id'));
    }, _this.handleEmbed = function () {
      _this.props.onEmbed(_this.props.status);
    }, _this.handleReport = function () {
      _this.props.onReport(_this.props.status);
    }, _this.handleConversationMuteClick = function () {
      _this.props.onMuteConversation(_this.props.status);
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  // Avoid checking props that are functions (and whose equality will always
  // evaluate to false. See react-immutable-pure-component for usage.


  StatusActionBar.prototype.render = function render() {
    var _props = this.props,
        status = _props.status,
        intl = _props.intl,
        withDismiss = _props.withDismiss;


    var mutingConversation = status.get('muted');
    var anonymousAccess = !__WEBPACK_IMPORTED_MODULE_11__initial_state__["g" /* me */];
    var publicStatus = ['public', 'unlisted'].includes(status.get('visibility'));

    var menu = [];
    var reblogIcon = 'retweet';
    var replyIcon = void 0;
    var replyTitle = void 0;

    menu.push({ text: intl.formatMessage(messages.open), action: this.handleOpen });

    if (publicStatus) {
      menu.push({ text: intl.formatMessage(messages.embed), action: this.handleEmbed });
    }

    menu.push(null);

    if (status.getIn(['account', 'id']) === __WEBPACK_IMPORTED_MODULE_11__initial_state__["g" /* me */] || withDismiss) {
      menu.push({ text: intl.formatMessage(mutingConversation ? messages.unmuteConversation : messages.muteConversation), action: this.handleConversationMuteClick });
      menu.push(null);
    }

    if (status.getIn(['account', 'id']) === __WEBPACK_IMPORTED_MODULE_11__initial_state__["g" /* me */]) {
      if (publicStatus) {
        menu.push({ text: intl.formatMessage(status.get('pinned') ? messages.unpin : messages.pin), action: this.handlePinClick });
      } else {
        if (status.get('visibility') === 'private') {
          menu.push({ text: intl.formatMessage(status.get('reblogged') ? messages.cancel_reblog_private : messages.reblog_private), action: this.handleReblogClick });
        }
      }

      menu.push({ text: intl.formatMessage(messages.delete), action: this.handleDeleteClick });
      menu.push({ text: intl.formatMessage(messages.redraft), action: this.handleRedraftClick });
    } else {
      menu.push({ text: intl.formatMessage(messages.mention, { name: status.getIn(['account', 'username']) }), action: this.handleMentionClick });
      menu.push({ text: intl.formatMessage(messages.direct, { name: status.getIn(['account', 'username']) }), action: this.handleDirectClick });
      menu.push(null);
      menu.push({ text: intl.formatMessage(messages.mute, { name: status.getIn(['account', 'username']) }), action: this.handleMuteClick });
      menu.push({ text: intl.formatMessage(messages.block, { name: status.getIn(['account', 'username']) }), action: this.handleBlockClick });
      menu.push({ text: intl.formatMessage(messages.report, { name: status.getIn(['account', 'username']) }), action: this.handleReport });
    }

    if (status.get('visibility') === 'direct') {
      reblogIcon = 'envelope';
    } else if (status.get('visibility') === 'private') {
      reblogIcon = 'lock';
    }

    if (status.get('in_reply_to_id', null) === null) {
      replyIcon = 'reply';
      replyTitle = intl.formatMessage(messages.reply);
    } else {
      replyIcon = 'reply-all';
      replyTitle = intl.formatMessage(messages.replyAll);
    }

    var shareButton = 'share' in navigator && status.get('visibility') === 'public' && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__icon_button__["a" /* default */], {
      className: 'status__action-bar-button',
      title: intl.formatMessage(messages.share),
      icon: 'share-alt',
      onClick: this.handleShareClick
    });

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'status__action-bar'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__icon_button__["a" /* default */], {
      className: 'status__action-bar-button',
      disabled: anonymousAccess,
      title: replyTitle,
      icon: replyIcon,
      onClick: this.handleReplyClick
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__icon_button__["a" /* default */], {
      className: 'status__action-bar-button',
      disabled: anonymousAccess || !publicStatus,
      active: status.get('reblogged'),
      pressed: status.get('reblogged'),
      title: !publicStatus ? intl.formatMessage(messages.cannot_reblog) : intl.formatMessage(messages.reblog),
      icon: reblogIcon,
      onClick: this.handleReblogClick
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__icon_button__["a" /* default */], {
      className: 'status__action-bar-button star-icon',
      disabled: anonymousAccess,
      animate: true,
      active: status.get('favourited'),
      pressed: status.get('favourited'),
      title: intl.formatMessage(messages.favourite),
      icon: 'star',
      onClick: this.handleFavouriteClick
    }), shareButton, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'status__action-bar-dropdown'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8__containers_dropdown_menu_container__["a" /* default */], {
      disabled: anonymousAccess,
      status: status,
      items: menu,
      icon: 'ellipsis-h',
      size: 18,
      direction: 'right',
      title: intl.formatMessage(messages.more)
    })));
  };

  return StatusActionBar;
}(__WEBPACK_IMPORTED_MODULE_10_react_immutable_pure_component___default.a), _class2.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
}, _class2.propTypes = {
  status: __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.map.isRequired,
  onReply: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onFavourite: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onReblog: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDelete: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onDirect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMention: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMute: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onBlock: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onReport: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onEmbed: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onMuteConversation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onPin: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  withDismiss: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  intl: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired
}, _temp2)) || _class;



/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_motion_lib_Motion__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_motion_lib_Motion___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_motion_lib_Motion__);





// Like react-motion's Motion, but reduces all animations to cross-fades
// for the benefit of users with motion sickness.




var stylesToKeep = ['opacity', 'backgroundOpacity'];

var extractValue = function extractValue(value) {
  // This is either an object with a "val" property or it's a number
  return (typeof value === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_typeof___default()(value)) === 'object' && value && 'val' in value ? value.val : value;
};

var ReducedMotion = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ReducedMotion, _React$Component);

  function ReducedMotion() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ReducedMotion);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.apply(this, arguments));
  }

  ReducedMotion.prototype.render = function render() {
    var _props = this.props,
        style = _props.style,
        defaultStyle = _props.defaultStyle,
        children = _props.children;


    Object.keys(style).forEach(function (key) {
      if (stylesToKeep.includes(key)) {
        return;
      }
      // If it's setting an x or height or scale or some other value, we need
      // to preserve the end-state value without actually animating it
      style[key] = defaultStyle[key] = extractValue(style[key]);
    });

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6_react_motion_lib_Motion___default.a, {
      style: style,
      defaultStyle: defaultStyle
    }, void 0, children);
  };

  return ReducedMotion;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (ReducedMotion);

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// currently used to initiate the velocity style object to 0


exports.__esModule = true;
exports['default'] = mapToZero;

function mapToZero(obj) {
  var ret = {};
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      ret[key] = 0;
    }
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}



exports.__esModule = true;
exports['default'] = stripStyle;

function stripStyle(style) {
  var ret = {};
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }
    ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
  }
  return ret;
}

module.exports = exports['default'];

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the


exports.__esModule = true;
exports["default"] = stepper;

var reusedTuple = [0, 0];

function stepper(secondPerFrame, x, v, destX, k, b, precision) {
  // Spring stiffness, in kg / s^2

  // for animations, destX is really spring length (spring at rest). initial
  // position is considered as the stretched/compressed position of a spring
  var Fspring = -k * (x - destX);

  // Damping, in kg / s
  var Fdamper = -b * v;

  // usually we put mass here, but for animation purposes, specifying mass is a
  // bit redundant. you could simply adjust k and b accordingly
  // let a = (Fspring + Fdamper) / mass;
  var a = Fspring + Fdamper;

  var newV = v + a * secondPerFrame;
  var newX = x + newV * secondPerFrame;

  if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
    reusedTuple[0] = destX;
    reusedTuple[1] = 0;
    return reusedTuple;
  }

  reusedTuple[0] = newX;
  reusedTuple[1] = newV;
  return reusedTuple;
}

module.exports = exports["default"];
// array reference around.

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.7.1
(function () {
  var getNanoSeconds, hrtime, loadTime;

  if (typeof performance !== "undefined" && performance !== null && performance.now) {
    module.exports = function () {
      return performance.now();
    };
  } else if (typeof process !== "undefined" && process !== null && process.hrtime) {
    module.exports = function () {
      return (getNanoSeconds() - loadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function () {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    loadTime = getNanoSeconds();
  } else if (Date.now) {
    module.exports = function () {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function () {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }
}).call(this);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35)))

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(513),
    root = typeof window === 'undefined' ? global : window,
    vendors = ['moz', 'webkit'],
    suffix = 'AnimationFrame',
    raf = root['request' + suffix],
    caf = root['cancel' + suffix] || root['cancelRequest' + suffix];

for (var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix];
  caf = root[vendors[i] + 'Cancel' + suffix] || root[vendors[i] + 'CancelRequest' + suffix];
}

// Some versions of FF have rAF but not cAF
if (!raf || !caf) {
  var last = 0,
      id = 0,
      queue = [],
      frameDuration = 1000 / 60;

  raf = function (callback) {
    if (queue.length === 0) {
      var _now = now(),
          next = Math.max(0, frameDuration - (_now - last));
      last = next + _now;
      setTimeout(function () {
        var cp = queue.slice(0);
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0;
        for (var i = 0; i < cp.length; i++) {
          if (!cp[i].cancelled) {
            try {
              cp[i].callback(last);
            } catch (e) {
              setTimeout(function () {
                throw e;
              }, 0);
            }
          }
        }
      }, Math.round(next));
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    });
    return id;
  };

  caf = function (handle) {
    for (var i = 0; i < queue.length; i++) {
      if (queue[i].handle === handle) {
        queue[i].cancelled = true;
      }
    }
  };
}

module.exports = function (fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn);
};
module.exports.cancel = function () {
  caf.apply(root, arguments);
};
module.exports.polyfill = function (object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf;
  object.cancelAnimationFrame = caf;
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(57)))

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function () {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if (typeof performance !== "undefined" && performance !== null && performance.now) {
    module.exports = function () {
      return performance.now();
    };
  } else if (typeof process !== "undefined" && process !== null && process.hrtime) {
    module.exports = function () {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function () {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function () {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function () {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }
}).call(this);

//# sourceMappingURL=performance-now.js.map
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(35)))

/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)


exports.__esModule = true;
exports['default'] = shouldStopAnimation;

function shouldStopAnimation(currentStyle, style, currentVelocity) {
  for (var key in style) {
    if (!Object.prototype.hasOwnProperty.call(style, key)) {
      continue;
    }

    if (currentVelocity[key] !== 0) {
      return false;
    }

    var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
    // stepper will have already taken care of rounding precision errors, so
    // won't have such thing as 0.9999 !=== 1
    if (currentStyle[key] !== styleValue) {
      return false;
    }
  }

  return true;
}

module.exports = exports['default'];

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = {
  noWobble: { stiffness: 170, damping: 26 }, // the default, if nothing provided
  gentle: { stiffness: 120, damping: 14 },
  wobbly: { stiffness: 180, damping: 12 },
  stiff: { stiffness: 210, damping: 20 }
};
module.exports = exports["default"];

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dropdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icon_button__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_overlays_lib_Overlay__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_overlays_lib_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_overlays_lib_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__features_ui_util_optional_motion__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_motion_lib_spring__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_motion_lib_spring___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_motion_lib_spring__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_detect_passive_events__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_detect_passive_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_detect_passive_events__);





var _class, _temp2, _class2, _temp4;










var listenerOptions = __WEBPACK_IMPORTED_MODULE_10_detect_passive_events___default.a.hasSupport ? { passive: true } : false;
var id = 0;

var DropdownMenu = (_temp2 = _class = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(DropdownMenu, _React$PureComponent);

  function DropdownMenu() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DropdownMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
      mounted: false
    }, _this.handleDocumentClick = function (e) {
      if (_this.node && !_this.node.contains(e.target)) {
        _this.props.onClose();
      }
    }, _this.setRef = function (c) {
      _this.node = c;
    }, _this.setFocusRef = function (c) {
      _this.focusedItem = c;
    }, _this.handleKeyDown = function (e) {
      var items = Array.from(_this.node.getElementsByTagName('a'));
      var index = items.indexOf(e.currentTarget);
      var element = void 0;

      switch (e.key) {
        case 'Enter':
          _this.handleClick(e);
          break;
        case 'ArrowDown':
          element = items[index + 1];
          if (element) {
            element.focus();
          }
          break;
        case 'ArrowUp':
          element = items[index - 1];
          if (element) {
            element.focus();
          }
          break;
        case 'Home':
          element = items[0];
          if (element) {
            element.focus();
          }
          break;
        case 'End':
          element = items[items.length - 1];
          if (element) {
            element.focus();
          }
          break;
      }
    }, _this.handleClick = function (e) {
      var i = Number(e.currentTarget.getAttribute('data-index'));
      var _this$props$items$i = _this.props.items[i],
          action = _this$props$items$i.action,
          to = _this$props$items$i.to;


      _this.props.onClose();

      if (typeof action === 'function') {
        e.preventDefault();
        action(e);
      } else if (to) {
        e.preventDefault();
        _this.context.router.history.push(to);
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  DropdownMenu.prototype.componentDidMount = function componentDidMount() {
    document.addEventListener('click', this.handleDocumentClick, false);
    document.addEventListener('touchend', this.handleDocumentClick, listenerOptions);
    if (this.focusedItem) this.focusedItem.focus();
    this.setState({ mounted: true });
  };

  DropdownMenu.prototype.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('click', this.handleDocumentClick, false);
    document.removeEventListener('touchend', this.handleDocumentClick, listenerOptions);
  };

  DropdownMenu.prototype.renderItem = function renderItem(option, i) {
    if (option === null) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('li', {
        className: 'dropdown-menu__separator'
      }, 'sep-' + i);
    }

    var text = option.text,
        _option$href = option.href,
        href = _option$href === undefined ? '#' : _option$href;


    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('li', {
      className: 'dropdown-menu__item'
    }, text + '-' + i, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'a',
      { href: href, target: '_blank', rel: 'noopener', role: 'button', tabIndex: '0', ref: i === 0 ? this.setFocusRef : null, onClick: this.handleClick, onKeyDown: this.handleKeyDown, 'data-index': i },
      text
    ));
  };

  DropdownMenu.prototype.render = function render() {
    var _this2 = this;

    var _props = this.props,
        items = _props.items,
        style = _props.style,
        placement = _props.placement,
        arrowOffsetLeft = _props.arrowOffsetLeft,
        arrowOffsetTop = _props.arrowOffsetTop;
    var mounted = this.state.mounted;


    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8__features_ui_util_optional_motion__["a" /* default */], {
      defaultStyle: { opacity: 0, scaleX: 0.85, scaleY: 0.75 },
      style: { opacity: __WEBPACK_IMPORTED_MODULE_9_react_motion_lib_spring___default()(1, { damping: 35, stiffness: 400 }), scaleX: __WEBPACK_IMPORTED_MODULE_9_react_motion_lib_spring___default()(1, { damping: 35, stiffness: 400 }), scaleY: __WEBPACK_IMPORTED_MODULE_9_react_motion_lib_spring___default()(1, { damping: 35, stiffness: 400 }) }
    }, void 0, function (_ref) {
      var opacity = _ref.opacity,
          scaleX = _ref.scaleX,
          scaleY = _ref.scaleY;
      return (
        // It should not be transformed when mounting because the resulting
        // size will be used to determine the coordinate of the menu by
        // react-overlays
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          'div',
          { className: 'dropdown-menu', style: Object.assign({}, style, { opacity: opacity, transform: mounted ? 'scale(' + scaleX + ', ' + scaleY + ')' : null }), ref: _this2.setRef },
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
            className: 'dropdown-menu__arrow ' + placement,
            style: { left: arrowOffsetLeft, top: arrowOffsetTop }
          }),
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('ul', {}, void 0, items.map(function (option, i) {
            return _this2.renderItem(option, i);
          }))
        )
      );
    });
  };

  return DropdownMenu;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent), _class.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
}, _class.defaultProps = {
  style: {},
  placement: 'bottom'
}, _temp2);
var Dropdown = (_temp4 = _class2 = function (_React$PureComponent2) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Dropdown, _React$PureComponent2);

  function Dropdown() {
    var _temp3, _this3, _ret2;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Dropdown);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp3 = (_this3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent2.call.apply(_React$PureComponent2, [this].concat(args))), _this3), _this3.state = {
      id: id++
    }, _this3.handleClick = function (_ref2) {
      var target = _ref2.target;

      if (_this3.state.id === _this3.props.openDropdownId) {
        _this3.handleClose();
      } else {
        var _target$getBoundingCl = target.getBoundingClientRect(),
            top = _target$getBoundingCl.top;

        var placement = top * 2 < innerHeight ? 'bottom' : 'top';

        _this3.props.onOpen(_this3.state.id, _this3.handleItemClick, placement);
      }
    }, _this3.handleClose = function () {
      _this3.props.onClose(_this3.state.id);
    }, _this3.handleKeyDown = function (e) {
      switch (e.key) {
        case 'Escape':
          _this3.handleClose();
          break;
      }
    }, _this3.handleItemClick = function (e) {
      var i = Number(e.currentTarget.getAttribute('data-index'));
      var _this3$props$items$i = _this3.props.items[i],
          action = _this3$props$items$i.action,
          to = _this3$props$items$i.to;


      _this3.handleClose();

      if (typeof action === 'function') {
        e.preventDefault();
        action();
      } else if (to) {
        e.preventDefault();
        _this3.context.router.history.push(to);
      }
    }, _this3.setTargetRef = function (c) {
      _this3.target = c;
    }, _this3.findTarget = function () {
      return _this3.target;
    }, _temp3), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this3, _ret2);
  }

  Dropdown.prototype.render = function render() {
    var _props2 = this.props,
        icon = _props2.icon,
        items = _props2.items,
        size = _props2.size,
        title = _props2.title,
        disabled = _props2.disabled,
        dropdownPlacement = _props2.dropdownPlacement,
        openDropdownId = _props2.openDropdownId;

    var open = this.state.id === openDropdownId;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      onKeyDown: this.handleKeyDown
    }, void 0, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__icon_button__["a" /* default */], {
      icon: icon,
      title: title,
      active: open,
      disabled: disabled,
      size: size,
      ref: this.setTargetRef,
      onClick: this.handleClick
    }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7_react_overlays_lib_Overlay___default.a, {
      show: open,
      placement: dropdownPlacement,
      target: this.findTarget
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(DropdownMenu, {
      items: items,
      onClose: this.handleClose
    })));
  };

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent), _class2.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
}, _class2.defaultProps = {
  title: 'Menu'
}, _temp4);


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(213);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  if (propType !== 'function' && propType !== 'string') {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);
module.exports = exports['default'];

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(135);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(136);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(64);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _LegacyPortal = __webpack_require__(519);

var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;

      _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
    }, _this.getMountNode = function () {
      return _this._portalContainerNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this.setContainer();
    this.forceUpdate(this.props.onRendered);
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.container !== this.props.container) {
      this.setContainer(nextProps);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._portalContainerNode = null;
  };

  Portal.prototype.render = function render() {
    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
module.exports = exports['default'];

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(135);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(136);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(64);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
      if (!_this._overlayTarget) {
        _this._overlayTarget = document.createElement('div');
        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
        _this._portalContainerNode.appendChild(_this._overlayTarget);
      }
    }, _this._unmountOverlayTarget = function () {
      if (_this._overlayTarget) {
        _this._portalContainerNode.removeChild(_this._overlayTarget);
        _this._overlayTarget = null;
      }
      _this._portalContainerNode = null;
    }, _this._renderOverlay = function () {
      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);

      // Save reference for future access.
      if (overlay !== null) {
        _this._mountOverlayTarget();

        var initialRender = !_this._overlayInstance;

        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
          if (initialRender && _this.props.onRendered) {
            _this.props.onRendered();
          }
        });
      } else {
        // Unrender if the component is null for transitions to null
        _this._unrenderOverlay();
        _this._unmountOverlayTarget();
      }
    }, _this._unrenderOverlay = function () {
      if (_this._overlayTarget) {
        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
        _this._overlayInstance = null;
      }
    }, _this.getMountNode = function () {
      return _this._overlayTarget;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this._renderOverlay();
  };

  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
    this._renderOverlay();
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this._overlayTarget && nextProps.container !== this.props.container) {
      this._portalContainerNode.removeChild(this._overlayTarget);
      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
      this._portalContainerNode.appendChild(this._overlayTarget);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    this._unrenderOverlay();
    this._unmountOverlayTarget();
  };

  Portal.prototype.render = function render() {
    return null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = Portal;
module.exports = exports['default'];

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(135);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _calculatePosition = __webpack_require__(521);

var _calculatePosition2 = _interopRequireDefault(_calculatePosition);

var _getContainer = __webpack_require__(136);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(64);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

/**
 * The Position component calculates the coordinates for its child, to position
 * it relative to a `target` component or node. Useful for creating callouts
 * and tooltips, the Position component injects a `style` props with `left` and
 * `top` values for positioning your component.
 *
 * It also injects "arrow" `left`, and `top` values for styling callout arrows
 * for giving your components a sense of directionality.
 */
var Position = function (_React$Component) {
  _inherits(Position, _React$Component);

  function Position(props, context) {
    _classCallCheck(this, Position);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.getTarget = function () {
      var target = _this.props.target;

      var targetElement = typeof target === 'function' ? target() : target;
      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
    };

    _this.maybeUpdatePosition = function (placementChanged) {
      var target = _this.getTarget();

      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
        return;
      }

      _this.updatePosition(target);
    };

    _this.state = {
      positionLeft: 0,
      positionTop: 0,
      arrowOffsetLeft: null,
      arrowOffsetTop: null
    };

    _this._needsFlush = false;
    _this._lastTarget = null;
    return _this;
  }

  Position.prototype.componentDidMount = function componentDidMount() {
    this.updatePosition(this.getTarget());
  };

  Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    this._needsFlush = true;
  };

  Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this._needsFlush) {
      this._needsFlush = false;
      this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
    }
  };

  Position.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        props = _objectWithoutProperties(_props, ['children', 'className']);

    var _state = this.state,
        positionLeft = _state.positionLeft,
        positionTop = _state.positionTop,
        arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);

    // These should not be forwarded to the child.


    delete props.target;
    delete props.container;
    delete props.containerPadding;
    delete props.shouldUpdatePosition;

    var child = _react2.default.Children.only(children);
    return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
      // FIXME: Don't forward `positionLeft` and `positionTop` via both props
      // and `props.style`.
      positionLeft: positionLeft,
      positionTop: positionTop,
      className: (0, _classnames2.default)(className, child.props.className),
      style: _extends({}, child.props.style, {
        left: positionLeft,
        top: positionTop
      })
    }));
  };

  Position.prototype.updatePosition = function updatePosition(target) {
    this._lastTarget = target;

    if (!target) {
      this.setState({
        positionLeft: 0,
        positionTop: 0,
        arrowOffsetLeft: null,
        arrowOffsetTop: null
      });

      return;
    }

    var overlay = _reactDom2.default.findDOMNode(this);
    var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);

    this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
  };

  return Position;
}(_react2.default.Component);

Position.propTypes = {
  /**
   * A node, element, or function that returns either. The child will be
   * be positioned next to the `target` specified.
   */
  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * "offsetParent" of the component
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
  /**
   * Minimum spacing in pixels between container border and component border
   */
  containerPadding: _propTypes2.default.number,
  /**
   * How to position the component relative to the target
   */
  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
  /**
   * Whether the position should be changed on each update
   */
  shouldUpdatePosition: _propTypes2.default.bool
};

Position.displayName = 'Position';

Position.defaultProps = {
  containerPadding: 0,
  placement: 'right',
  shouldUpdatePosition: false
};

exports.default = Position;
module.exports = exports['default'];

/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = calculatePosition;

var _offset = __webpack_require__(214);

var _offset2 = _interopRequireDefault(_offset);

var _position = __webpack_require__(522);

var _position2 = _interopRequireDefault(_position);

var _scrollTop = __webpack_require__(139);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _ownerDocument = __webpack_require__(64);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function getContainerDimensions(containerNode) {
  var width = void 0,
      height = void 0,
      scroll = void 0;

  if (containerNode.tagName === 'BODY') {
    width = window.innerWidth;
    height = window.innerHeight;

    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
  } else {
    var _getOffset = (0, _offset2.default)(containerNode);

    width = _getOffset.width;
    height = _getOffset.height;

    scroll = (0, _scrollTop2.default)(containerNode);
  }

  return { width: width, height: height, scroll: scroll };
}

function getTopDelta(top, overlayHeight, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerScroll = containerDimensions.scroll;
  var containerHeight = containerDimensions.height;

  var topEdgeOffset = top - padding - containerScroll;
  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;

  if (topEdgeOffset < 0) {
    return -topEdgeOffset;
  } else if (bottomEdgeOffset > containerHeight) {
    return containerHeight - bottomEdgeOffset;
  } else {
    return 0;
  }
}

function getLeftDelta(left, overlayWidth, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerWidth = containerDimensions.width;

  var leftEdgeOffset = left - padding;
  var rightEdgeOffset = left + padding + overlayWidth;

  if (leftEdgeOffset < 0) {
    return -leftEdgeOffset;
  } else if (rightEdgeOffset > containerWidth) {
    return containerWidth - rightEdgeOffset;
  }

  return 0;
}

function calculatePosition(placement, overlayNode, target, container, padding) {
  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);

  var _getOffset2 = (0, _offset2.default)(overlayNode),
      overlayHeight = _getOffset2.height,
      overlayWidth = _getOffset2.width;

  var positionLeft = void 0,
      positionTop = void 0,
      arrowOffsetLeft = void 0,
      arrowOffsetTop = void 0;

  if (placement === 'left' || placement === 'right') {
    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;

    if (placement === 'left') {
      positionLeft = childOffset.left - overlayWidth;
    } else {
      positionLeft = childOffset.left + childOffset.width;
    }

    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);

    positionTop += topDelta;
    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
    arrowOffsetLeft = void 0;
  } else if (placement === 'top' || placement === 'bottom') {
    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;

    if (placement === 'top') {
      positionTop = childOffset.top - overlayHeight;
    } else {
      positionTop = childOffset.top + childOffset.height;
    }

    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);

    positionLeft += leftDelta;
    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
    arrowOffsetTop = void 0;
  } else {
    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
  }

  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
}
module.exports = exports['default'];

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

exports.default = position;

var _offset = __webpack_require__(214);

var _offset2 = _interopRequireDefault(_offset);

var _offsetParent = __webpack_require__(523);

var _offsetParent2 = _interopRequireDefault(_offsetParent);

var _scrollTop = __webpack_require__(139);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _scrollLeft = __webpack_require__(219);

var _scrollLeft2 = _interopRequireDefault(_scrollLeft);

var _style = __webpack_require__(216);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function position(node, offsetParent) {
  var parentOffset = { top: 0, left: 0 },
      offset;

  // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
  // because it is its only offset parent
  if ((0, _style2.default)(node, 'position') === 'fixed') {
    offset = node.getBoundingClientRect();
  } else {
    offsetParent = offsetParent || (0, _offsetParent2.default)(node);
    offset = (0, _offset2.default)(node);

    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset2.default)(offsetParent);

    parentOffset.top += parseInt((0, _style2.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop2.default)(offsetParent) || 0;
    parentOffset.left += parseInt((0, _style2.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft2.default)(offsetParent) || 0;
  }

  // Subtract parent offsets and node margins
  return _extends({}, offset, {
    top: offset.top - parentOffset.top - (parseInt((0, _style2.default)(node, 'marginTop'), 10) || 0),
    left: offset.left - parentOffset.left - (parseInt((0, _style2.default)(node, 'marginLeft'), 10) || 0)
  });
}
module.exports = exports['default'];

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = offsetParent;

var _ownerDocument = __webpack_require__(137);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _style = __webpack_require__(216);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function offsetParent(node) {
  var doc = (0, _ownerDocument2.default)(node),
      offsetParent = node && node.offsetParent;

  while (offsetParent && nodeName(node) !== 'html' && (0, _style2.default)(offsetParent, 'position') === 'static') {
    offsetParent = offsetParent.offsetParent;
  }

  return offsetParent || doc.documentElement;
}
module.exports = exports['default'];

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}
module.exports = exports["default"];

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateStyleName;

var _hyphenate = __webpack_require__(526);

var _hyphenate2 = _interopRequireDefault(_hyphenate);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var msPattern = /^ms-/; /**
                         * Copyright 2013-2014, Facebook, Inc.
                         * All rights reserved.
                         * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
                         */

function hyphenateStyleName(string) {
  return (0, _hyphenate2.default)(string).replace(msPattern, '-ms-');
}
module.exports = exports['default'];

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenate;

var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}
module.exports = exports['default'];

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _getComputedStyle;

var _camelizeStyle = __webpack_require__(217);

var _camelizeStyle2 = _interopRequireDefault(_camelizeStyle);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;

  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;

      prop = (0, _camelizeStyle2.default)(prop);

      if (prop == 'float') prop = 'styleFloat';

      var current = node.currentStyle[prop] || null;

      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left;

        // Put in the new values to get a computed value out
        if (rsLeft) runStyle.left = node.currentStyle.left;

        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px';

        // Revert the changed values
        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}
module.exports = exports['default'];

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = removeStyle;
function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}
module.exports = exports['default'];

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}
module.exports = exports["default"];

/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _contains = __webpack_require__(215);

var _contains2 = _interopRequireDefault(_contains);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _addEventListener = __webpack_require__(531);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _ownerDocument = __webpack_require__(64);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var escapeKeyCode = 27;

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

/**
 * The `<RootCloseWrapper/>` component registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 */

var RootCloseWrapper = function (_React$Component) {
  _inherits(RootCloseWrapper, _React$Component);

  function RootCloseWrapper(props, context) {
    _classCallCheck(this, RootCloseWrapper);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.addEventListeners = function () {
      var event = _this.props.event;

      var doc = (0, _ownerDocument2.default)(_this);

      // Use capture for this listener so it fires before React's listener, to
      // avoid false positives in the contains() check below if the target DOM
      // element is removed in the React mouse callback.
      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);

      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);

      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
    };

    _this.removeEventListeners = function () {
      if (_this.documentMouseCaptureListener) {
        _this.documentMouseCaptureListener.remove();
      }

      if (_this.documentMouseListener) {
        _this.documentMouseListener.remove();
      }

      if (_this.documentKeyupListener) {
        _this.documentKeyupListener.remove();
      }
    };

    _this.handleMouseCapture = function (e) {
      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
    };

    _this.handleMouse = function (e) {
      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.handleKeyUp = function (e) {
      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.preventMouseRootClose = false;
    return _this;
  }

  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
    if (!this.props.disabled) {
      this.addEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!this.props.disabled && prevProps.disabled) {
      this.addEventListeners();
    } else if (this.props.disabled && !prevProps.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
    if (!this.props.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.render = function render() {
    return this.props.children;
  };

  return RootCloseWrapper;
}(_react2.default.Component);

RootCloseWrapper.displayName = 'RootCloseWrapper';

RootCloseWrapper.propTypes = {
  /**
   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
   */
  onRootClose: _propTypes2.default.func,
  /**
   * Children to render.
   */
  children: _propTypes2.default.element,
  /**
   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Choose which document mouse event to bind to.
   */
  event: _propTypes2.default.oneOf(['click', 'mousedown'])
};

RootCloseWrapper.defaultProps = {
  event: 'click'
};

exports.default = RootCloseWrapper;
module.exports = exports['default'];

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (node, event, handler, capture) {
  (0, _on2.default)(node, event, handler, capture);

  return {
    remove: function remove() {
      (0, _off2.default)(node, event, handler, capture);
    }
  };
};

var _on = __webpack_require__(140);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(141);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

module.exports = exports['default'];

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Borrowed from:
// https://github.com/lodash/lodash/blob/master/lodash.js
// https://github.com/mathiasbynens/regenerate
// https://mathiasbynens.be/notes/javascript-unicode
var astralRange = exports.astralRange = /\ud83c[\udffb-\udfff](?=\ud83c[\udffb-\udfff])|(?:[^\ud800-\udfff][\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]?|[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?(?:\u200d(?:[^\ud800-\udfff]|(?:\ud83c[\udde6-\uddff]){2}|[\ud800-\udbff][\udc00-\udfff])[\ufe0e\ufe0f]?(?:[\u0300-\u036f\ufe20-\ufe23\u20d0-\u20f0]|\ud83c[\udffb-\udfff])?)*/g;

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(143);
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history_createBrowserHistory__["a" /* default */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  var toParts = to && to.split('/') || [];
  var fromParts = from && from.split('/') || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash = void 0;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) {
    fromParts.unshift('..');
  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

function valueEqual(a, b) {
  if (a === b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return valueEqual(item, b[index]);
    });
  }

  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (aType !== bType) return false;

  if (aType === 'object') {
    var aValue = a.valueOf();
    var bValue = b.valueOf();

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    var aKeys = Object.keys(a);
    var bKeys = Object.keys(b);

    if (aKeys.length !== bKeys.length) return false;

    return aKeys.every(function (key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(143);
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history_createHashHistory__["a" /* default */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(538);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(144);
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history_createMemoryHistory__["a" /* default */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(223);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref.ariaCurrent,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        'aria-current': isActive && ariaCurrent
      }, rest));
    }
  });
};

NavLink.defaultProps = {
  activeClassName: 'active',
  ariaCurrent: 'true'
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(541);

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp;
module.exports.parse = parse;
module.exports.compile = compile;
module.exports.tokensToFunction = tokensToFunction;
module.exports.tokensToRegExp = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
// Match escaped characters that would otherwise appear in future matches.
// This allows the user to escape special characters that won't transform.
'(\\\\.)',
// Match Express-style parameters and un-named parameters with a prefix
// and optional suffixes. Matches appear as:
//
// "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
// "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
// "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
'([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse(str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue;
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?'
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens;
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile(str, options) {
  return tokensToFunction(parse(str, options));
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty(str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
  });
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk(str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase();
  });
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction(tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue;
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue;
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined');
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`');
        }

        if (value.length === 0) {
          if (token.optional) {
            continue;
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty');
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`');
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue;
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"');
      }

      path += token.prefix + segment;
    }

    return path;
  };
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString(str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1');
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup(group) {
  return group.replace(/([=!:$\/()])/g, '\\$1');
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys(re, keys) {
  re.keys = keys;
  return re;
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags(options) {
  return options.sensitive ? '' : 'i';
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp(path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys);
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp(path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys);
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp(path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options);
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp(tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */keys || options;
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys);
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp(path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */keys || options;
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */keys);
  }

  if (isarray(path)) {
    return arrayToRegexp( /** @type {!Array} */path, /** @type {!Array} */keys, options);
  }

  return stringToRegexp( /** @type {string} */path, /** @type {!Array} */keys, options);
}

/***/ }),
/* 541 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(543);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, 'You should not use <Prompt> outside a <Router>');

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(545);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(546);
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}







/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Redirect> outside a <Router>');

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["b" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
      return;
    }

    this.perform();
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var _props = this.props,
        push = _props.push,
        to = _props.to;

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBrowserHistory__ = __webpack_require__(220);
/* unused harmony reexport createBrowserHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createHashHistory__ = __webpack_require__(222);
/* unused harmony reexport createHashHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(224);
/* unused harmony reexport createMemoryHistory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LocationUtils__ = __webpack_require__(83);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__LocationUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PathUtils__ = __webpack_require__(52);
/* unused harmony reexport parsePath */
/* unused harmony reexport createPath */










/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(548);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history_PathUtils__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(144);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}








var normalizeLocation = function normalizeLocation(object) {
  var _object$pathname = object.pathname,
      pathname = _object$pathname === undefined ? '/' : _object$pathname,
      _object$search = object.search,
      search = _object$search === undefined ? '' : _object$search,
      _object$hash = object.hash,
      hash = _object$hash === undefined ? '' : _object$hash;

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["a" /* addLeadingSlash */])(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["a" /* addLeadingSlash */])(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createLocation = function createLocation(location) {
  return typeof location === 'string' ? Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["d" /* parsePath */])(location) : normalizeLocation(location);
};

var createURL = function createURL(location) {
  return typeof location === 'string' ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["b" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, 'You cannot %s with <StaticRouter>', methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_history_PathUtils__["a" /* addLeadingSlash */])(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = 'PUSH';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = 'REPLACE';
      context.location = addBasename(basename, createLocation(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);

    var history = {
      createHref: this.createHref,
      action: 'POP',
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler('go'),
      goBack: staticHandler('goBack'),
      goForward: staticHandler('goForward'),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.defaultProps = {
  basename: '',
  location: '/'
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};

/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(550);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(145);
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, 'You should not use <Switch> outside a <Router>');
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) return;

      var _element$props = element.props,
          pathProp = _element$props.path,
          exact = _element$props.exact,
          strict = _element$props.strict,
          sensitive = _element$props.sensitive,
          from = _element$props.from;

      var path = pathProp || from;

      if (match == null) {
        child = element;
        match = path ? Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(145);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(553);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(183);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(226);
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], { render: function render(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
      } });
  };

  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
  C.WrappedComponent = Component;


  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(555);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _reactDom = __webpack_require__(20);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _FocusTrap = __webpack_require__(227);

var _FocusTrap2 = _interopRequireDefault(_FocusTrap);

var _HotKeyMapMixin = __webpack_require__(228);

var _HotKeyMapMixin2 = _interopRequireDefault(_HotKeyMapMixin);

var _isBoolean = __webpack_require__(629);

var _isBoolean2 = _interopRequireDefault(_isBoolean);

var _isArray = __webpack_require__(66);

var _isArray2 = _interopRequireDefault(_isArray);

var _isObject = __webpack_require__(40);

var _isObject2 = _interopRequireDefault(_isObject);

var _forEach = __webpack_require__(630);

var _forEach2 = _interopRequireDefault(_forEach);

var _isEqual = __webpack_require__(239);

var _isEqual2 = _interopRequireDefault(_isEqual);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function getSequencesFromMap(hotKeyMap, hotKeyName) {
  var sequences = hotKeyMap[hotKeyName];

  // If no sequence is found with this name we assume
  // the user is passing a hard-coded sequence as a key
  if (!sequences) {
    return [hotKeyName];
  }

  if ((0, _isArray2.default)(sequences)) {
    return sequences;
  }

  return [sequences];
}

var HotKeys = (0, _createReactClass2.default)({
  displayName: 'HotKeys',
  mixins: [(0, _HotKeyMapMixin2.default)()],

  propTypes: {
    children: _propTypes2.default.node,
    onFocus: _propTypes2.default.func,
    onBlur: _propTypes2.default.func,
    keyMap: _propTypes2.default.object,
    handlers: _propTypes2.default.object,
    focused: _propTypes2.default.bool, // externally controlled focus
    attach: _propTypes2.default.any // dom element to listen for key events
  },

  contextTypes: {
    hotKeyParent: _propTypes2.default.any
  },

  childContextTypes: {
    hotKeyParent: _propTypes2.default.any
  },

  getChildContext: function getChildContext() {
    return {
      hotKeyParent: this
    };
  },
  componentDidMount: function componentDidMount() {
    // import is here to support React's server rendering as Mousetrap immediately
    // calls itself with window and it fails in Node environment
    var Mousetrap = __webpack_require__(638);
    // Not optimal - imagine hundreds of this component. We need a top level
    // delegation point for mousetrap
    this.__mousetrap__ = new Mousetrap(this.props.attach || _reactDom2.default.findDOMNode(this));

    this.updateHotKeys(true);
  },
  componentDidUpdate: function componentDidUpdate(prevProps) {
    this.updateHotKeys(false, prevProps);
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this.context.hotKeyParent) {
      this.context.hotKeyParent.childHandledSequence(null);
    }

    if (this.__mousetrap__) {
      this.__mousetrap__.reset();
    }
  },
  updateHotKeys: function updateHotKeys() {
    var _this = this;

    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var prevProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _props$handlers = this.props.handlers,
        handlers = _props$handlers === undefined ? {} : _props$handlers;
    var _prevProps$handlers = prevProps.handlers,
        prevHandlers = _prevProps$handlers === undefined ? handlers : _prevProps$handlers;

    // Ensure map is up-to-date to begin with
    // We will only bother continuing if the map was actually updated

    if (!force && !this.updateMap() && (0, _isEqual2.default)(handlers, prevHandlers)) {
      return;
    }

    var hotKeyMap = this.getMap();
    var sequenceHandlers = [];
    var mousetrap = this.__mousetrap__;

    // Group all our handlers by sequence
    (0, _forEach2.default)(handlers, function (handler, hotKey) {
      var handlerSequences = getSequencesFromMap(hotKeyMap, hotKey);

      // Could be optimized as every handler will get called across every bound
      // component - imagine making a node a focus point and then having hundreds!
      (0, _forEach2.default)(handlerSequences, function (sequence) {
        var action = void 0;

        var callback = function callback(event, sequence) {
          // Check we are actually in focus and that a child hasn't already handled this sequence
          var isFocused = (0, _isBoolean2.default)(_this.props.focused) ? _this.props.focused : _this.__isFocused__;

          if (isFocused && sequence !== _this.__lastChildSequence__) {
            if (_this.context.hotKeyParent) {
              _this.context.hotKeyParent.childHandledSequence(sequence);
            }

            return handler(event, sequence);
          }
        };

        if ((0, _isObject2.default)(sequence)) {
          action = sequence.action;
          sequence = sequence.sequence;
        }

        sequenceHandlers.push({ callback: callback, action: action, sequence: sequence });
      });
    });

    // Hard reset our handlers (probably could be more efficient)
    mousetrap.reset();
    (0, _forEach2.default)(sequenceHandlers, function (handler) {
      return mousetrap.bind(handler.sequence, handler.callback, handler.action);
    });
  },
  childHandledSequence: function childHandledSequence() {
    var sequence = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

    this.__lastChildSequence__ = sequence;

    // Traverse up any hot key parents so everyone is aware a child has handled a certain sequence
    if (this.context.hotKeyParent) {
      this.context.hotKeyParent.childHandledSequence(sequence);
    }
  },
  onFocus: function onFocus() {
    this.__isFocused__ = true;

    if (this.props.onFocus) {
      var _props;

      (_props = this.props).onFocus.apply(_props, arguments);
    }
  },
  onBlur: function onBlur() {
    this.__isFocused__ = false;

    if (this.props.onBlur) {
      var _props2;

      (_props2 = this.props).onBlur.apply(_props2, arguments);
    }
    if (this.context.hotKeyParent) {
      this.context.hotKeyParent.childHandledSequence(null);
    }
  },
  render: function render() {
    var _props3 = this.props,
        children = _props3.children,
        keyMap = _props3.keyMap,
        handlers = _props3.handlers,
        focused = _props3.focused,
        attach = _props3.attach,
        props = _objectWithoutProperties(_props3, ['children', 'keyMap', 'handlers', 'focused', 'attach']);

    return _react2.default.createElement(_FocusTrap2.default, _extends({}, props, { onFocus: this.onFocus, onBlur: this.onBlur }), children);
  }
});

exports.default = HotKeys;

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(556);

if (typeof React === 'undefined') {
  throw Error('create-react-class could not find the React object. If you are using script tags, ' + 'make sure that React is being loaded before create-react-class.');
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(React.Component, React.isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(105);

var emptyObject = __webpack_require__(122);
var _invariant = __webpack_require__(82);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function (Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function (Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function (Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
    },
    contextTypes: function (Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function (Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function (Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function (Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function () {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName);
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(specPolicy === 'OVERRIDE_BASE', 'ReactClassInterface: You are attempting to override ' + '`%s` from your class specification. Ensure that your method names ' + 'do not overlap with React methods.', name);
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', 'ReactClassInterface: You are attempting to define ' + '`%s` on your component more than once. This conflict may be due ' + 'to a mixin.', name);
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(isMixinValid, "%s: You're attempting to include a mixin that is either null " + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec);
        }
      }

      return;
    }

    _invariant(typeof spec !== 'function', "ReactClass: You're attempting to " + 'use a component class or function as a mixin. Instead, just use a ' + 'regular object.');
    _invariant(!isValidElement(spec), "ReactClass: You're attempting to " + 'use a component as a mixin. Instead, just use a regular object.');

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), 'ReactClass: Unexpected spec policy %s for key %s ' + 'when mixing in component specs.', specPolicy, name);

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }
    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(!isReserved, 'ReactClass: You are attempting to define a reserved ' + 'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' + 'as an instance property instead; it will still be accessible on the ' + 'constructor.', name);

      var isInherited = name in Constructor;
      _invariant(!isInherited, 'ReactClass: You are attempting to define ' + '`%s` on your component more than once. This conflict may be ' + 'due to a mixin.', name);
      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(one && two && typeof one === 'object' && typeof two === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(one[key] === undefined, 'mergeIntoWithNoDuplicateKeys(): ' + 'Tried to merge two objects with the same key: `%s`. This conflict ' + 'may be due to a mixin; in particular, this may be caused by two ' + 'getInitialState() or getDefaultProps() methods returning objects ' + 'with clashing keys.', key);
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function (newThis) {
        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName);
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName);
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function () {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function () {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function (newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function () {
      if (false) {
        warning(this.__didWarnIsMounted, '%s: isMounted is deprecated. Instead, make sure to clean up ' + 'subscriptions and pending requests in componentWillUnmount to ' + 'prevent memory leaks.', this.constructor && this.constructor.displayName || this.name || 'Component');
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function () {};
  _assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function (props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory');
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (initialState === undefined && this.getInitialState._isMockFunction) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(typeof initialState === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');

    if (false) {
      warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component');
      warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component');
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(229),
    copyObject = __webpack_require__(562),
    createAssigner = __webpack_require__(563),
    isArrayLike = __webpack_require__(85),
    isPrototype = __webpack_require__(236),
    keys = __webpack_require__(147);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function (object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(232),
    isMasked = __webpack_require__(559),
    isObject = __webpack_require__(40),
    toSource = __webpack_require__(233);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(560);

/** Used to detect methods masquerading as native. */
var maskSrcKey = function () {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? 'Symbol(src)_1.' + uid : '';
}();

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && maskSrcKey in func;
}

module.exports = isMasked;

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(25);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;

/***/ }),
/* 561 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(229),
    baseAssignValue = __webpack_require__(230);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(564),
    isIterateeCall = __webpack_require__(571);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function (object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(146),
    overRest = __webpack_require__(565),
    setToString = __webpack_require__(567);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(566);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? func.length - 1 : start, 0);
  return function () {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;

/***/ }),
/* 566 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0:
      return func.call(thisArg);
    case 1:
      return func.call(thisArg, args[0]);
    case 2:
      return func.call(thisArg, args[0], args[1]);
    case 3:
      return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(568),
    shortOut = __webpack_require__(570);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(569),
    defineProperty = __webpack_require__(231),
    identity = __webpack_require__(146);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function (func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;

/***/ }),
/* 569 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function () {
    return value;
  };
}

module.exports = constant;

/***/ }),
/* 570 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function () {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(84),
    isArrayLike = __webpack_require__(85),
    isIndex = __webpack_require__(235),
    isObject = __webpack_require__(40);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(573),
    isArguments = __webpack_require__(574),
    isArray = __webpack_require__(66),
    isBuffer = __webpack_require__(237),
    isIndex = __webpack_require__(235),
    isTypedArray = __webpack_require__(238);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
    // Safari 9 has enumerable `arguments.length` in strict mode.
    key == 'length' ||
    // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') ||
    // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
    // Skip index properties.
    isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;

/***/ }),
/* 573 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(575),
    isObjectLike = __webpack_require__(51);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function () {
    return arguments;
}()) ? baseIsArguments : function (value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(50),
    isObjectLike = __webpack_require__(51);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;

/***/ }),
/* 576 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(50),
    isLength = __webpack_require__(234),
    isObjectLike = __webpack_require__(51);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;

/***/ }),
/* 578 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function (value) {
    return func(value);
  };
}

module.exports = baseUnary;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(201);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = function () {
  try {
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}();

module.exports = nodeUtil;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(101)(module)))

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(236),
    nativeKeys = __webpack_require__(581);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(582);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;

/***/ }),
/* 582 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function (arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(584),
    isObjectLike = __webpack_require__(51);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(585),
    equalArrays = __webpack_require__(241),
    equalByTag = __webpack_require__(613),
    equalObjects = __webpack_require__(617),
    getTag = __webpack_require__(624),
    isArray = __webpack_require__(66),
    isBuffer = __webpack_require__(237),
    isTypedArray = __webpack_require__(238);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack());
    return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack());
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack());
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(86),
    stackClear = __webpack_require__(591),
    stackDelete = __webpack_require__(592),
    stackGet = __webpack_require__(593),
    stackHas = __webpack_require__(594),
    stackSet = __webpack_require__(595);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;

/***/ }),
/* 586 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(87);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(87);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(87);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(87);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(86);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache();
  this.size = 0;
}

module.exports = stackClear;

/***/ }),
/* 592 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;

/***/ }),
/* 593 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;

/***/ }),
/* 594 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(86),
    Map = __webpack_require__(148),
    MapCache = __webpack_require__(240);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(597),
    ListCache = __webpack_require__(86),
    Map = __webpack_require__(148);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash(),
    'map': new (Map || ListCache)(),
    'string': new Hash()
  };
}

module.exports = mapCacheClear;

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(598),
    hashDelete = __webpack_require__(599),
    hashGet = __webpack_require__(600),
    hashHas = __webpack_require__(601),
    hashSet = __webpack_require__(602);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
    var index = -1,
        length = entries == null ? 0 : entries.length;

    this.clear();
    while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(88);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;

/***/ }),
/* 599 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;

/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(88);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(88);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

module.exports = hashHas;

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(88);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(89);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;

/***/ }),
/* 604 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}

module.exports = isKeyable;

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(89);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(89);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(89);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(240),
    setCacheAdd = __webpack_require__(609),
    setCacheHas = __webpack_require__(610);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
    var index = -1,
        length = values == null ? 0 : values.length;

    this.__data__ = new MapCache();
    while (++index < length) {
        this.add(values[index]);
    }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;

/***/ }),
/* 609 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;

/***/ }),
/* 610 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;

/***/ }),
/* 611 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;

/***/ }),
/* 612 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(131),
    Uint8Array = __webpack_require__(614),
    eq = __webpack_require__(84),
    equalArrays = __webpack_require__(241),
    mapToArray = __webpack_require__(615),
    setToArray = __webpack_require__(616);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == other + '';

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(25);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;

/***/ }),
/* 615 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function (value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;

/***/ }),
/* 616 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function (value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(618);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(619),
    getSymbols = __webpack_require__(621),
    keys = __webpack_require__(147);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(620),
    isArray = __webpack_require__(66);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;

/***/ }),
/* 620 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(622),
    stubArray = __webpack_require__(623);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function (symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;

/***/ }),
/* 622 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;

/***/ }),
/* 623 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(625),
    Map = __webpack_require__(148),
    Promise = __webpack_require__(626),
    Set = __webpack_require__(627),
    WeakMap = __webpack_require__(628),
    baseGetTag = __webpack_require__(50),
    toSource = __webpack_require__(233);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
    getTag = function (value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
            switch (ctorString) {
                case dataViewCtorString:
                    return dataViewTag;
                case mapCtorString:
                    return mapTag;
                case promiseCtorString:
                    return promiseTag;
                case setCtorString:
                    return setTag;
                case weakMapCtorString:
                    return weakMapTag;
            }
        }
        return result;
    };
}

module.exports = getTag;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41),
    root = __webpack_require__(25);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41),
    root = __webpack_require__(25);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41),
    root = __webpack_require__(25);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(41),
    root = __webpack_require__(25);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(50),
    isObjectLike = __webpack_require__(51);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
    return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
}

module.exports = isBoolean;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(631),
    baseEach = __webpack_require__(632),
    castFunction = __webpack_require__(637),
    isArray = __webpack_require__(66);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;

/***/ }),
/* 631 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(633),
    createBaseEach = __webpack_require__(636);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(634),
    keys = __webpack_require__(147);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(635);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;

/***/ }),
/* 635 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function (object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(85);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function (collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while (fromRight ? index-- : ++index < length) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(146);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*global define:false */
/**
 * Copyright 2012-2017 Craig Campbell
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Mousetrap is a simple keyboard shortcut library for Javascript with
 * no external dependencies
 *
 * @version 1.6.1
 * @url craig.is/killing/mice
 */
(function (window, document, undefined) {

    // Check if mousetrap is used inside browser, if not, return
    if (!window) {
        return;
    }

    /**
     * mapping of special keycodes to their corresponding keys
     *
     * everything in this dictionary cannot use keypress events
     * so it has to be here to map to the correct keycodes for
     * keyup/keydown events
     *
     * @type {Object}
     */
    var _MAP = {
        8: 'backspace',
        9: 'tab',
        13: 'enter',
        16: 'shift',
        17: 'ctrl',
        18: 'alt',
        20: 'capslock',
        27: 'esc',
        32: 'space',
        33: 'pageup',
        34: 'pagedown',
        35: 'end',
        36: 'home',
        37: 'left',
        38: 'up',
        39: 'right',
        40: 'down',
        45: 'ins',
        46: 'del',
        91: 'meta',
        93: 'meta',
        224: 'meta'
    };

    /**
     * mapping for special characters so they can support
     *
     * this dictionary is only used incase you want to bind a
     * keyup or keydown event to one of these keys
     *
     * @type {Object}
     */
    var _KEYCODE_MAP = {
        106: '*',
        107: '+',
        109: '-',
        110: '.',
        111: '/',
        186: ';',
        187: '=',
        188: ',',
        189: '-',
        190: '.',
        191: '/',
        192: '`',
        219: '[',
        220: '\\',
        221: ']',
        222: '\''
    };

    /**
     * this is a mapping of keys that require shift on a US keypad
     * back to the non shift equivelents
     *
     * this is so you can use keyup events with these keys
     *
     * note that this will only work reliably on US keyboards
     *
     * @type {Object}
     */
    var _SHIFT_MAP = {
        '~': '`',
        '!': '1',
        '@': '2',
        '#': '3',
        '$': '4',
        '%': '5',
        '^': '6',
        '&': '7',
        '*': '8',
        '(': '9',
        ')': '0',
        '_': '-',
        '+': '=',
        ':': ';',
        '\"': '\'',
        '<': ',',
        '>': '.',
        '?': '/',
        '|': '\\'
    };

    /**
     * this is a list of special strings you can use to map
     * to modifier keys when you specify your keyboard shortcuts
     *
     * @type {Object}
     */
    var _SPECIAL_ALIASES = {
        'option': 'alt',
        'command': 'meta',
        'return': 'enter',
        'escape': 'esc',
        'plus': '+',
        'mod': /Mac|iPod|iPhone|iPad/.test(navigator.platform) ? 'meta' : 'ctrl'
    };

    /**
     * variable to store the flipped version of _MAP from above
     * needed to check if we should use keypress or not when no action
     * is specified
     *
     * @type {Object|undefined}
     */
    var _REVERSE_MAP;

    /**
     * loop through the f keys, f1 to f19 and add them to the map
     * programatically
     */
    for (var i = 1; i < 20; ++i) {
        _MAP[111 + i] = 'f' + i;
    }

    /**
     * loop through to map numbers on the numeric keypad
     */
    for (i = 0; i <= 9; ++i) {

        // This needs to use a string cause otherwise since 0 is falsey
        // mousetrap will never fire for numpad 0 pressed as part of a keydown
        // event.
        //
        // @see https://github.com/ccampbell/mousetrap/pull/258
        _MAP[i + 96] = i.toString();
    }

    /**
     * cross browser add event method
     *
     * @param {Element|HTMLDocument} object
     * @param {string} type
     * @param {Function} callback
     * @returns void
     */
    function _addEvent(object, type, callback) {
        if (object.addEventListener) {
            object.addEventListener(type, callback, false);
            return;
        }

        object.attachEvent('on' + type, callback);
    }

    /**
     * takes the event and returns the key character
     *
     * @param {Event} e
     * @return {string}
     */
    function _characterFromEvent(e) {

        // for keypress events we should return the character as is
        if (e.type == 'keypress') {
            var character = String.fromCharCode(e.which);

            // if the shift key is not pressed then it is safe to assume
            // that we want the character to be lowercase.  this means if
            // you accidentally have caps lock on then your key bindings
            // will continue to work
            //
            // the only side effect that might not be desired is if you
            // bind something like 'A' cause you want to trigger an
            // event when capital A is pressed caps lock will no longer
            // trigger the event.  shift+a will though.
            if (!e.shiftKey) {
                character = character.toLowerCase();
            }

            return character;
        }

        // for non keypress events the special maps are needed
        if (_MAP[e.which]) {
            return _MAP[e.which];
        }

        if (_KEYCODE_MAP[e.which]) {
            return _KEYCODE_MAP[e.which];
        }

        // if it is not in the special map

        // with keydown and keyup events the character seems to always
        // come in as an uppercase character whether you are pressing shift
        // or not.  we should make sure it is always lowercase for comparisons
        return String.fromCharCode(e.which).toLowerCase();
    }

    /**
     * checks if two arrays are equal
     *
     * @param {Array} modifiers1
     * @param {Array} modifiers2
     * @returns {boolean}
     */
    function _modifiersMatch(modifiers1, modifiers2) {
        return modifiers1.sort().join(',') === modifiers2.sort().join(',');
    }

    /**
     * takes a key event and figures out what the modifiers are
     *
     * @param {Event} e
     * @returns {Array}
     */
    function _eventModifiers(e) {
        var modifiers = [];

        if (e.shiftKey) {
            modifiers.push('shift');
        }

        if (e.altKey) {
            modifiers.push('alt');
        }

        if (e.ctrlKey) {
            modifiers.push('ctrl');
        }

        if (e.metaKey) {
            modifiers.push('meta');
        }

        return modifiers;
    }

    /**
     * prevents default for this event
     *
     * @param {Event} e
     * @returns void
     */
    function _preventDefault(e) {
        if (e.preventDefault) {
            e.preventDefault();
            return;
        }

        e.returnValue = false;
    }

    /**
     * stops propogation for this event
     *
     * @param {Event} e
     * @returns void
     */
    function _stopPropagation(e) {
        if (e.stopPropagation) {
            e.stopPropagation();
            return;
        }

        e.cancelBubble = true;
    }

    /**
     * determines if the keycode specified is a modifier key or not
     *
     * @param {string} key
     * @returns {boolean}
     */
    function _isModifier(key) {
        return key == 'shift' || key == 'ctrl' || key == 'alt' || key == 'meta';
    }

    /**
     * reverses the map lookup so that we can look for specific keys
     * to see what can and can't use keypress
     *
     * @return {Object}
     */
    function _getReverseMap() {
        if (!_REVERSE_MAP) {
            _REVERSE_MAP = {};
            for (var key in _MAP) {

                // pull out the numeric keypad from here cause keypress should
                // be able to detect the keys from the character
                if (key > 95 && key < 112) {
                    continue;
                }

                if (_MAP.hasOwnProperty(key)) {
                    _REVERSE_MAP[_MAP[key]] = key;
                }
            }
        }
        return _REVERSE_MAP;
    }

    /**
     * picks the best action based on the key combination
     *
     * @param {string} key - character for key
     * @param {Array} modifiers
     * @param {string=} action passed in
     */
    function _pickBestAction(key, modifiers, action) {

        // if no action was picked in we should try to pick the one
        // that we think would work best for this key
        if (!action) {
            action = _getReverseMap()[key] ? 'keydown' : 'keypress';
        }

        // modifier keys don't work as expected with keypress,
        // switch to keydown
        if (action == 'keypress' && modifiers.length) {
            action = 'keydown';
        }

        return action;
    }

    /**
     * Converts from a string key combination to an array
     *
     * @param  {string} combination like "command+shift+l"
     * @return {Array}
     */
    function _keysFromString(combination) {
        if (combination === '+') {
            return ['+'];
        }

        combination = combination.replace(/\+{2}/g, '+plus');
        return combination.split('+');
    }

    /**
     * Gets info for a specific key combination
     *
     * @param  {string} combination key combination ("command+s" or "a" or "*")
     * @param  {string=} action
     * @returns {Object}
     */
    function _getKeyInfo(combination, action) {
        var keys;
        var key;
        var i;
        var modifiers = [];

        // take the keys from this pattern and figure out what the actual
        // pattern is all about
        keys = _keysFromString(combination);

        for (i = 0; i < keys.length; ++i) {
            key = keys[i];

            // normalize key names
            if (_SPECIAL_ALIASES[key]) {
                key = _SPECIAL_ALIASES[key];
            }

            // if this is not a keypress event then we should
            // be smart about using shift keys
            // this will only work for US keyboards however
            if (action && action != 'keypress' && _SHIFT_MAP[key]) {
                key = _SHIFT_MAP[key];
                modifiers.push('shift');
            }

            // if this key is a modifier then add it to the list of modifiers
            if (_isModifier(key)) {
                modifiers.push(key);
            }
        }

        // depending on what the key combination is
        // we will try to pick the best event for it
        action = _pickBestAction(key, modifiers, action);

        return {
            key: key,
            modifiers: modifiers,
            action: action
        };
    }

    function _belongsTo(element, ancestor) {
        if (element === null || element === document) {
            return false;
        }

        if (element === ancestor) {
            return true;
        }

        return _belongsTo(element.parentNode, ancestor);
    }

    function Mousetrap(targetElement) {
        var self = this;

        targetElement = targetElement || document;

        if (!(self instanceof Mousetrap)) {
            return new Mousetrap(targetElement);
        }

        /**
         * element to attach key events to
         *
         * @type {Element}
         */
        self.target = targetElement;

        /**
         * a list of all the callbacks setup via Mousetrap.bind()
         *
         * @type {Object}
         */
        self._callbacks = {};

        /**
         * direct map of string combinations to callbacks used for trigger()
         *
         * @type {Object}
         */
        self._directMap = {};

        /**
         * keeps track of what level each sequence is at since multiple
         * sequences can start out with the same sequence
         *
         * @type {Object}
         */
        var _sequenceLevels = {};

        /**
         * variable to store the setTimeout call
         *
         * @type {null|number}
         */
        var _resetTimer;

        /**
         * temporary state where we will ignore the next keyup
         *
         * @type {boolean|string}
         */
        var _ignoreNextKeyup = false;

        /**
         * temporary state where we will ignore the next keypress
         *
         * @type {boolean}
         */
        var _ignoreNextKeypress = false;

        /**
         * are we currently inside of a sequence?
         * type of action ("keyup" or "keydown" or "keypress") or false
         *
         * @type {boolean|string}
         */
        var _nextExpectedAction = false;

        /**
         * resets all sequence counters except for the ones passed in
         *
         * @param {Object} doNotReset
         * @returns void
         */
        function _resetSequences(doNotReset) {
            doNotReset = doNotReset || {};

            var activeSequences = false,
                key;

            for (key in _sequenceLevels) {
                if (doNotReset[key]) {
                    activeSequences = true;
                    continue;
                }
                _sequenceLevels[key] = 0;
            }

            if (!activeSequences) {
                _nextExpectedAction = false;
            }
        }

        /**
         * finds all callbacks that match based on the keycode, modifiers,
         * and action
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event|Object} e
         * @param {string=} sequenceName - name of the sequence we are looking for
         * @param {string=} combination
         * @param {number=} level
         * @returns {Array}
         */
        function _getMatches(character, modifiers, e, sequenceName, combination, level) {
            var i;
            var callback;
            var matches = [];
            var action = e.type;

            // if there are no events related to this keycode
            if (!self._callbacks[character]) {
                return [];
            }

            // if a modifier key is coming up on its own we should allow it
            if (action == 'keyup' && _isModifier(character)) {
                modifiers = [character];
            }

            // loop through all callbacks for the key that was pressed
            // and see if any of them match
            for (i = 0; i < self._callbacks[character].length; ++i) {
                callback = self._callbacks[character][i];

                // if a sequence name is not specified, but this is a sequence at
                // the wrong level then move onto the next match
                if (!sequenceName && callback.seq && _sequenceLevels[callback.seq] != callback.level) {
                    continue;
                }

                // if the action we are looking for doesn't match the action we got
                // then we should keep going
                if (action != callback.action) {
                    continue;
                }

                // if this is a keypress event and the meta key and control key
                // are not pressed that means that we need to only look at the
                // character, otherwise check the modifiers as well
                //
                // chrome will not fire a keypress if meta or control is down
                // safari will fire a keypress if meta or meta+shift is down
                // firefox will fire a keypress if meta or control is down
                if (action == 'keypress' && !e.metaKey && !e.ctrlKey || _modifiersMatch(modifiers, callback.modifiers)) {

                    // when you bind a combination or sequence a second time it
                    // should overwrite the first one.  if a sequenceName or
                    // combination is specified in this call it does just that
                    //
                    // @todo make deleting its own method?
                    var deleteCombo = !sequenceName && callback.combo == combination;
                    var deleteSequence = sequenceName && callback.seq == sequenceName && callback.level == level;
                    if (deleteCombo || deleteSequence) {
                        self._callbacks[character].splice(i, 1);
                    }

                    matches.push(callback);
                }
            }

            return matches;
        }

        /**
         * actually calls the callback function
         *
         * if your callback function returns false this will use the jquery
         * convention - prevent default and stop propogation on the event
         *
         * @param {Function} callback
         * @param {Event} e
         * @returns void
         */
        function _fireCallback(callback, e, combo, sequence) {

            // if this event should not happen stop here
            if (self.stopCallback(e, e.target || e.srcElement, combo, sequence)) {
                return;
            }

            if (callback(e, combo) === false) {
                _preventDefault(e);
                _stopPropagation(e);
            }
        }

        /**
         * handles a character key event
         *
         * @param {string} character
         * @param {Array} modifiers
         * @param {Event} e
         * @returns void
         */
        self._handleKey = function (character, modifiers, e) {
            var callbacks = _getMatches(character, modifiers, e);
            var i;
            var doNotReset = {};
            var maxLevel = 0;
            var processedSequenceCallback = false;

            // Calculate the maxLevel for sequences so we can only execute the longest callback sequence
            for (i = 0; i < callbacks.length; ++i) {
                if (callbacks[i].seq) {
                    maxLevel = Math.max(maxLevel, callbacks[i].level);
                }
            }

            // loop through matching callbacks for this key event
            for (i = 0; i < callbacks.length; ++i) {

                // fire for all sequence callbacks
                // this is because if for example you have multiple sequences
                // bound such as "g i" and "g t" they both need to fire the
                // callback for matching g cause otherwise you can only ever
                // match the first one
                if (callbacks[i].seq) {

                    // only fire callbacks for the maxLevel to prevent
                    // subsequences from also firing
                    //
                    // for example 'a option b' should not cause 'option b' to fire
                    // even though 'option b' is part of the other sequence
                    //
                    // any sequences that do not match here will be discarded
                    // below by the _resetSequences call
                    if (callbacks[i].level != maxLevel) {
                        continue;
                    }

                    processedSequenceCallback = true;

                    // keep a list of which sequences were matches for later
                    doNotReset[callbacks[i].seq] = 1;
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo, callbacks[i].seq);
                    continue;
                }

                // if there were no sequence matches but we are still here
                // that means this is a regular match so we should fire that
                if (!processedSequenceCallback) {
                    _fireCallback(callbacks[i].callback, e, callbacks[i].combo);
                }
            }

            // if the key you pressed matches the type of sequence without
            // being a modifier (ie "keyup" or "keypress") then we should
            // reset all sequences that were not matched by this event
            //
            // this is so, for example, if you have the sequence "h a t" and you
            // type "h e a r t" it does not match.  in this case the "e" will
            // cause the sequence to reset
            //
            // modifier keys are ignored because you can have a sequence
            // that contains modifiers such as "enter ctrl+space" and in most
            // cases the modifier key will be pressed before the next key
            //
            // also if you have a sequence such as "ctrl+b a" then pressing the
            // "b" key will trigger a "keypress" and a "keydown"
            //
            // the "keydown" is expected when there is a modifier, but the
            // "keypress" ends up matching the _nextExpectedAction since it occurs
            // after and that causes the sequence to reset
            //
            // we ignore keypresses in a sequence that directly follow a keydown
            // for the same character
            var ignoreThisKeypress = e.type == 'keypress' && _ignoreNextKeypress;
            if (e.type == _nextExpectedAction && !_isModifier(character) && !ignoreThisKeypress) {
                _resetSequences(doNotReset);
            }

            _ignoreNextKeypress = processedSequenceCallback && e.type == 'keydown';
        };

        /**
         * handles a keydown event
         *
         * @param {Event} e
         * @returns void
         */
        function _handleKeyEvent(e) {

            // normalize e.which for key events
            // @see http://stackoverflow.com/questions/4285627/javascript-keycode-vs-charcode-utter-confusion
            if (typeof e.which !== 'number') {
                e.which = e.keyCode;
            }

            var character = _characterFromEvent(e);

            // no character found then stop
            if (!character) {
                return;
            }

            // need to use === for the character check because the character can be 0
            if (e.type == 'keyup' && _ignoreNextKeyup === character) {
                _ignoreNextKeyup = false;
                return;
            }

            self.handleKey(character, _eventModifiers(e), e);
        }

        /**
         * called to set a 1 second timeout on the specified sequence
         *
         * this is so after each key press in the sequence you have 1 second
         * to press the next key before you have to start over
         *
         * @returns void
         */
        function _resetSequenceTimer() {
            clearTimeout(_resetTimer);
            _resetTimer = setTimeout(_resetSequences, 1000);
        }

        /**
         * binds a key sequence to an event
         *
         * @param {string} combo - combo specified in bind call
         * @param {Array} keys
         * @param {Function} callback
         * @param {string=} action
         * @returns void
         */
        function _bindSequence(combo, keys, callback, action) {

            // start off by adding a sequence level record for this combination
            // and setting the level to 0
            _sequenceLevels[combo] = 0;

            /**
             * callback to increase the sequence level for this sequence and reset
             * all other sequences that were active
             *
             * @param {string} nextAction
             * @returns {Function}
             */
            function _increaseSequence(nextAction) {
                return function () {
                    _nextExpectedAction = nextAction;
                    ++_sequenceLevels[combo];
                    _resetSequenceTimer();
                };
            }

            /**
             * wraps the specified callback inside of another function in order
             * to reset all sequence counters as soon as this sequence is done
             *
             * @param {Event} e
             * @returns void
             */
            function _callbackAndReset(e) {
                _fireCallback(callback, e, combo);

                // we should ignore the next key up if the action is key down
                // or keypress.  this is so if you finish a sequence and
                // release the key the final key will not trigger a keyup
                if (action !== 'keyup') {
                    _ignoreNextKeyup = _characterFromEvent(e);
                }

                // weird race condition if a sequence ends with the key
                // another sequence begins with
                setTimeout(_resetSequences, 10);
            }

            // loop through keys one at a time and bind the appropriate callback
            // function.  for any key leading up to the final one it should
            // increase the sequence. after the final, it should reset all sequences
            //
            // if an action is specified in the original bind call then that will
            // be used throughout.  otherwise we will pass the action that the
            // next key in the sequence should match.  this allows a sequence
            // to mix and match keypress and keydown events depending on which
            // ones are better suited to the key provided
            for (var i = 0; i < keys.length; ++i) {
                var isFinal = i + 1 === keys.length;
                var wrappedCallback = isFinal ? _callbackAndReset : _increaseSequence(action || _getKeyInfo(keys[i + 1]).action);
                _bindSingle(keys[i], wrappedCallback, action, combo, i);
            }
        }

        /**
         * binds a single keyboard combination
         *
         * @param {string} combination
         * @param {Function} callback
         * @param {string=} action
         * @param {string=} sequenceName - name of sequence if part of sequence
         * @param {number=} level - what part of the sequence the command is
         * @returns void
         */
        function _bindSingle(combination, callback, action, sequenceName, level) {

            // store a direct mapped reference for use with Mousetrap.trigger
            self._directMap[combination + ':' + action] = callback;

            // make sure multiple spaces in a row become a single space
            combination = combination.replace(/\s+/g, ' ');

            var sequence = combination.split(' ');
            var info;

            // if this pattern is a sequence of keys then run through this method
            // to reprocess each pattern one key at a time
            if (sequence.length > 1) {
                _bindSequence(combination, sequence, callback, action);
                return;
            }

            info = _getKeyInfo(combination, action);

            // make sure to initialize array if this is the first time
            // a callback is added for this key
            self._callbacks[info.key] = self._callbacks[info.key] || [];

            // remove an existing match if there is one
            _getMatches(info.key, info.modifiers, { type: info.action }, sequenceName, combination, level);

            // add this call back to the array
            // if it is a sequence put it at the beginning
            // if not put it at the end
            //
            // this is important because the way these are processed expects
            // the sequence ones to come first
            self._callbacks[info.key][sequenceName ? 'unshift' : 'push']({
                callback: callback,
                modifiers: info.modifiers,
                action: info.action,
                seq: sequenceName,
                level: level,
                combo: combination
            });
        }

        /**
         * binds multiple combinations to the same callback
         *
         * @param {Array} combinations
         * @param {Function} callback
         * @param {string|undefined} action
         * @returns void
         */
        self._bindMultiple = function (combinations, callback, action) {
            for (var i = 0; i < combinations.length; ++i) {
                _bindSingle(combinations[i], callback, action);
            }
        };

        // start!
        _addEvent(targetElement, 'keypress', _handleKeyEvent);
        _addEvent(targetElement, 'keydown', _handleKeyEvent);
        _addEvent(targetElement, 'keyup', _handleKeyEvent);
    }

    /**
     * binds an event to mousetrap
     *
     * can be a single key, a combination of keys separated with +,
     * an array of keys, or a sequence of keys separated by spaces
     *
     * be sure to list the modifier keys first to make sure that the
     * correct key ends up getting bound (the last key in the pattern)
     *
     * @param {string|Array} keys
     * @param {Function} callback
     * @param {string=} action - 'keypress', 'keydown', or 'keyup'
     * @returns void
     */
    Mousetrap.prototype.bind = function (keys, callback, action) {
        var self = this;
        keys = keys instanceof Array ? keys : [keys];
        self._bindMultiple.call(self, keys, callback, action);
        return self;
    };

    /**
     * unbinds an event to mousetrap
     *
     * the unbinding sets the callback function of the specified key combo
     * to an empty function and deletes the corresponding key in the
     * _directMap dict.
     *
     * TODO: actually remove this from the _callbacks dictionary instead
     * of binding an empty function
     *
     * the keycombo+action has to be exactly the same as
     * it was defined in the bind method
     *
     * @param {string|Array} keys
     * @param {string} action
     * @returns void
     */
    Mousetrap.prototype.unbind = function (keys, action) {
        var self = this;
        return self.bind.call(self, keys, function () {}, action);
    };

    /**
     * triggers an event that has already been bound
     *
     * @param {string} keys
     * @param {string=} action
     * @returns void
     */
    Mousetrap.prototype.trigger = function (keys, action) {
        var self = this;
        if (self._directMap[keys + ':' + action]) {
            self._directMap[keys + ':' + action]({}, keys);
        }
        return self;
    };

    /**
     * resets the library back to its initial state.  this is useful
     * if you want to clear out the current keyboard shortcuts and bind
     * new ones - for example if you switch to another page
     *
     * @returns void
     */
    Mousetrap.prototype.reset = function () {
        var self = this;
        self._callbacks = {};
        self._directMap = {};
        return self;
    };

    /**
     * should we stop this event before firing off callbacks
     *
     * @param {Event} e
     * @param {Element} element
     * @return {boolean}
     */
    Mousetrap.prototype.stopCallback = function (e, element) {
        var self = this;

        // if the element has the class "mousetrap" then no need to stop
        if ((' ' + element.className + ' ').indexOf(' mousetrap ') > -1) {
            return false;
        }

        if (_belongsTo(element, self.target)) {
            return false;
        }

        // stop for input, select, and textarea
        return element.tagName == 'INPUT' || element.tagName == 'SELECT' || element.tagName == 'TEXTAREA' || element.isContentEditable;
    };

    /**
     * exposes _handleKey publicly so it can be overwritten by extensions
     */
    Mousetrap.prototype.handleKey = function () {
        var self = this;
        return self._handleKey.apply(self, arguments);
    };

    /**
     * allow custom key mappings
     */
    Mousetrap.addKeycodes = function (object) {
        for (var key in object) {
            if (object.hasOwnProperty(key)) {
                _MAP[key] = object[key];
            }
        }
        _REVERSE_MAP = null;
    };

    /**
     * Init the global mousetrap functions
     *
     * This method is needed to allow the global mousetrap functions to work
     * now that mousetrap is a constructor function.
     */
    Mousetrap.init = function () {
        var documentMousetrap = Mousetrap(document);
        for (var method in documentMousetrap) {
            if (method.charAt(0) !== '_') {
                Mousetrap[method] = function (method) {
                    return function () {
                        return documentMousetrap[method].apply(documentMousetrap, arguments);
                    };
                }(method);
            }
        }
    };

    Mousetrap.init();

    // expose mousetrap to the global object
    window.Mousetrap = Mousetrap;

    // expose as a common js module
    if (typeof module !== 'undefined' && module.exports) {
        module.exports = Mousetrap;
    }

    // expose mousetrap as an AMD module
    if (true) {
        !(__WEBPACK_AMD_DEFINE_RESULT__ = (function () {
            return Mousetrap;
        }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    }
})(typeof window !== 'undefined' ? window : null, typeof window !== 'undefined' ? document : null);

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _off = __webpack_require__(141);

var _off2 = _interopRequireDefault(_off);

var _on = __webpack_require__(140);

var _on2 = _interopRequireDefault(_on);

var _scrollLeft = __webpack_require__(219);

var _scrollLeft2 = _interopRequireDefault(_scrollLeft);

var _scrollTop = __webpack_require__(139);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _requestAnimationFrame = __webpack_require__(640);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _invariant = __webpack_require__(18);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
} /* eslint-disable no-underscore-dangle */

// Try at most this many times to scroll, to avoid getting stuck.
var MAX_SCROLL_ATTEMPTS = 2;

var ScrollBehavior = function () {
  function ScrollBehavior(_ref) {
    var _this = this;

    var addTransitionHook = _ref.addTransitionHook,
        stateStorage = _ref.stateStorage,
        getCurrentLocation = _ref.getCurrentLocation,
        shouldUpdateScroll = _ref.shouldUpdateScroll;

    _classCallCheck(this, ScrollBehavior);

    this._onWindowScroll = function () {
      // It's possible that this scroll operation was triggered by what will be a
      // `POP` transition. Instead of updating the saved location immediately, we
      // have to enqueue the update, then potentially cancel it if we observe a
      // location update.
      if (!_this._saveWindowPositionHandle) {
        _this._saveWindowPositionHandle = (0, _requestAnimationFrame2.default)(_this._saveWindowPosition);
      }

      if (_this._windowScrollTarget) {
        var _windowScrollTarget = _this._windowScrollTarget,
            xTarget = _windowScrollTarget[0],
            yTarget = _windowScrollTarget[1];

        var x = (0, _scrollLeft2.default)(window);
        var y = (0, _scrollTop2.default)(window);

        if (x === xTarget && y === yTarget) {
          _this._windowScrollTarget = null;
          _this._cancelCheckWindowScroll();
        }
      }
    };

    this._saveWindowPosition = function () {
      _this._saveWindowPositionHandle = null;

      _this._savePosition(null, window);
    };

    this._checkWindowScrollPosition = function () {
      _this._checkWindowScrollHandle = null;

      // We can only get here if scrollTarget is set. Every code path that unsets
      // scroll target also cancels the handle to avoid calling this handler.
      // Still, check anyway just in case.
      /* istanbul ignore if: paranoid guard */
      if (!_this._windowScrollTarget) {
        return;
      }

      _this.scrollToTarget(window, _this._windowScrollTarget);

      ++_this._numWindowScrollAttempts;

      /* istanbul ignore if: paranoid guard */
      if (_this._numWindowScrollAttempts >= MAX_SCROLL_ATTEMPTS) {
        _this._windowScrollTarget = null;
        return;
      }

      _this._checkWindowScrollHandle = (0, _requestAnimationFrame2.default)(_this._checkWindowScrollPosition);
    };

    this._stateStorage = stateStorage;
    this._getCurrentLocation = getCurrentLocation;
    this._shouldUpdateScroll = shouldUpdateScroll;

    // This helps avoid some jankiness in fighting against the browser's
    // default scroll behavior on `POP` transitions.
    /* istanbul ignore else: Travis browsers all support this */
    if ('scrollRestoration' in window.history) {
      this._oldScrollRestoration = window.history.scrollRestoration;
      window.history.scrollRestoration = 'manual';
    } else {
      this._oldScrollRestoration = null;
    }

    this._saveWindowPositionHandle = null;
    this._checkWindowScrollHandle = null;
    this._windowScrollTarget = null;
    this._numWindowScrollAttempts = 0;

    this._scrollElements = {};

    // We have to listen to each window scroll update rather than to just
    // location updates, because some browsers will update scroll position
    // before emitting the location change.
    (0, _on2.default)(window, 'scroll', this._onWindowScroll);

    this._removeTransitionHook = addTransitionHook(function () {
      _requestAnimationFrame2.default.cancel(_this._saveWindowPositionHandle);
      _this._saveWindowPositionHandle = null;

      Object.keys(_this._scrollElements).forEach(function (key) {
        var scrollElement = _this._scrollElements[key];
        _requestAnimationFrame2.default.cancel(scrollElement.savePositionHandle);
        scrollElement.savePositionHandle = null;

        // It's fine to save element scroll positions here, though; the browser
        // won't modify them.
        _this._saveElementPosition(key);
      });
    });
  }

  ScrollBehavior.prototype.registerElement = function registerElement(key, element, shouldUpdateScroll, context) {
    var _this2 = this;

    !!this._scrollElements[key] ?  false ? (0, _invariant2.default)(false, 'ScrollBehavior: There is already an element registered for `%s`.', key) : (0, _invariant2.default)(false) : void 0;

    var saveElementPosition = function saveElementPosition() {
      _this2._saveElementPosition(key);
    };

    var scrollElement = {
      element: element,
      shouldUpdateScroll: shouldUpdateScroll,
      savePositionHandle: null,

      onScroll: function onScroll() {
        if (!scrollElement.savePositionHandle) {
          scrollElement.savePositionHandle = (0, _requestAnimationFrame2.default)(saveElementPosition);
        }
      }
    };

    this._scrollElements[key] = scrollElement;
    (0, _on2.default)(element, 'scroll', scrollElement.onScroll);

    this._updateElementScroll(key, null, context);
  };

  ScrollBehavior.prototype.unregisterElement = function unregisterElement(key) {
    !this._scrollElements[key] ?  false ? (0, _invariant2.default)(false, 'ScrollBehavior: There is no element registered for `%s`.', key) : (0, _invariant2.default)(false) : void 0;

    var _scrollElements$key = this._scrollElements[key],
        element = _scrollElements$key.element,
        onScroll = _scrollElements$key.onScroll,
        savePositionHandle = _scrollElements$key.savePositionHandle;

    (0, _off2.default)(element, 'scroll', onScroll);
    _requestAnimationFrame2.default.cancel(savePositionHandle);

    delete this._scrollElements[key];
  };

  ScrollBehavior.prototype.updateScroll = function updateScroll(prevContext, context) {
    var _this3 = this;

    this._updateWindowScroll(prevContext, context);

    Object.keys(this._scrollElements).forEach(function (key) {
      _this3._updateElementScroll(key, prevContext, context);
    });
  };

  ScrollBehavior.prototype.stop = function stop() {
    /* istanbul ignore if: not supported by any browsers on Travis */
    if (this._oldScrollRestoration) {
      window.history.scrollRestoration = this._oldScrollRestoration;
    }

    (0, _off2.default)(window, 'scroll', this._onWindowScroll);
    this._cancelCheckWindowScroll();

    this._removeTransitionHook();
  };

  ScrollBehavior.prototype._cancelCheckWindowScroll = function _cancelCheckWindowScroll() {
    _requestAnimationFrame2.default.cancel(this._checkWindowScrollHandle);
    this._checkWindowScrollHandle = null;
  };

  ScrollBehavior.prototype._saveElementPosition = function _saveElementPosition(key) {
    var scrollElement = this._scrollElements[key];
    scrollElement.savePositionHandle = null;

    this._savePosition(key, scrollElement.element);
  };

  ScrollBehavior.prototype._savePosition = function _savePosition(key, element) {
    this._stateStorage.save(this._getCurrentLocation(), key, [(0, _scrollLeft2.default)(element), (0, _scrollTop2.default)(element)]);
  };

  ScrollBehavior.prototype._updateWindowScroll = function _updateWindowScroll(prevContext, context) {
    // Whatever we were doing before isn't relevant any more.
    this._cancelCheckWindowScroll();

    this._windowScrollTarget = this._getScrollTarget(null, this._shouldUpdateScroll, prevContext, context);

    // Updating the window scroll position is really flaky. Just trying to
    // scroll it isn't enough. Instead, try to scroll a few times until it
    // works.
    this._numWindowScrollAttempts = 0;
    this._checkWindowScrollPosition();
  };

  ScrollBehavior.prototype._updateElementScroll = function _updateElementScroll(key, prevContext, context) {
    var _scrollElements$key2 = this._scrollElements[key],
        element = _scrollElements$key2.element,
        shouldUpdateScroll = _scrollElements$key2.shouldUpdateScroll;

    var scrollTarget = this._getScrollTarget(key, shouldUpdateScroll, prevContext, context);
    if (!scrollTarget) {
      return;
    }

    // Unlike with the window, there shouldn't be any flakiness to deal with
    // here.
    this.scrollToTarget(element, scrollTarget);
  };

  ScrollBehavior.prototype._getDefaultScrollTarget = function _getDefaultScrollTarget(location) {
    var hash = location.hash;
    if (hash && hash !== '#') {
      return hash.charAt(0) === '#' ? hash.slice(1) : hash;
    }
    return [0, 0];
  };

  ScrollBehavior.prototype._getScrollTarget = function _getScrollTarget(key, shouldUpdateScroll, prevContext, context) {
    var scrollTarget = shouldUpdateScroll ? shouldUpdateScroll.call(this, prevContext, context) : true;

    if (!scrollTarget || Array.isArray(scrollTarget) || typeof scrollTarget === 'string') {
      return scrollTarget;
    }

    var location = this._getCurrentLocation();

    return this._getSavedScrollTarget(key, location) || this._getDefaultScrollTarget(location);
  };

  ScrollBehavior.prototype._getSavedScrollTarget = function _getSavedScrollTarget(key, location) {
    if (location.action === 'PUSH') {
      return null;
    }

    return this._stateStorage.read(location, key);
  };

  ScrollBehavior.prototype.scrollToTarget = function scrollToTarget(element, target) {
    if (typeof target === 'string') {
      var targetElement = document.getElementById(target) || document.getElementsByName(target)[0];
      if (targetElement) {
        targetElement.scrollIntoView();
        return;
      }

      // Fallback to scrolling to top when target fragment doesn't exist.
      target = [0, 0]; // eslint-disable-line no-param-reassign
    }

    var _target = target,
        left = _target[0],
        top = _target[1];

    (0, _scrollLeft2.default)(element, left);
    (0, _scrollTop2.default)(element, top);
  };

  return ScrollBehavior;
}();

exports.default = ScrollBehavior;
module.exports = exports['default'];

/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inDOM = __webpack_require__(65);

var _inDOM2 = _interopRequireDefault(_inDOM);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf = void 0;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM2.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}

/* https://github.com/component/raf */
var prev = new Date().getTime();
function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);

  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};
compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};
exports.default = compatRaf;
module.exports = exports['default'];

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectStream;
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_websocket_js__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_websocket_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_websocket_js__);


var randomIntUpTo = function randomIntUpTo(max) {
  return Math.floor(Math.random() * Math.floor(max));
};

function connectStream(path) {
  var pollingRefresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var callbacks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {
    return {
      onDisconnect: function onDisconnect() {},
      onReceive: function onReceive() {}
    };
  };

  return function (dispatch, getState) {
    var streamingAPIBaseURL = getState().getIn(['meta', 'streaming_api_base_url']);
    var accessToken = getState().getIn(['meta', 'access_token']);

    var _callbacks = callbacks(dispatch, getState),
        onDisconnect = _callbacks.onDisconnect,
        onReceive = _callbacks.onReceive;

    var polling = null;

    var setupPolling = function setupPolling() {
      pollingRefresh(dispatch, function () {
        polling = setTimeout(function () {
          return setupPolling();
        }, 20000 + randomIntUpTo(20000));
      });
    };

    var clearPolling = function clearPolling() {
      if (polling) {
        clearTimeout(polling);
        polling = null;
      }
    };

    var subscription = getStream(streamingAPIBaseURL, accessToken, path, {
      connected: function connected() {
        if (pollingRefresh) {
          clearPolling();
        }
      },
      disconnected: function disconnected() {
        if (pollingRefresh) {
          polling = setTimeout(function () {
            return setupPolling();
          }, randomIntUpTo(40000));
        }

        onDisconnect();
      },
      received: function received(data) {
        onReceive(data);
      },
      reconnected: function reconnected() {
        if (pollingRefresh) {
          clearPolling();
          pollingRefresh(dispatch);
        }
      }
    });

    var disconnect = function disconnect() {
      if (subscription) {
        subscription.close();
      }

      clearPolling();
    };

    return disconnect;
  };
}

function getStream(streamingAPIBaseURL, accessToken, stream, _ref) {
  var connected = _ref.connected,
      received = _ref.received,
      disconnected = _ref.disconnected,
      reconnected = _ref.reconnected;

  var params = ['stream=' + stream];

  if (accessToken !== null) {
    params.push('access_token=' + accessToken);
  }

  var ws = new __WEBPACK_IMPORTED_MODULE_0_websocket_js___default.a(streamingAPIBaseURL + '/api/v1/streaming/?' + params.join('&'));

  ws.onopen = connected;
  ws.onmessage = function (e) {
    return received(JSON.parse(e.data));
  };
  ws.onclose = disconnected;
  ws.onreconnect = reconnected;

  return ws;
};

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });var _createClass = function () {
   function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
         var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
      }
   }return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
   };
}();function _classCallCheck(instance, Constructor) {
   if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
   }
}var backoff = __webpack_require__(643);var WebSocketClient = function () {
   /**
   * @param url DOMString The URL to which to connect; this should be the URL to which the WebSocket server will respond.
   * @param protocols DOMString|DOMString[] Either a single protocol string or an array of protocol strings. These strings are used to indicate sub-protocols, so that a single server can implement multiple WebSocket sub-protocols (for example, you might want one server to be able to handle different types of interactions depending on the specified protocol). If you don't specify a protocol string, an empty string is assumed.
   */function WebSocketClient(url, protocols) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};_classCallCheck(this, WebSocketClient);this.url = url;this.protocols = protocols;this.reconnectEnabled = true;this.listeners = {};this.backoff = backoff[options.backoff || 'fibonacci'](options);this.backoff.on('backoff', this.onBackoffStart.bind(this));this.backoff.on('ready', this.onBackoffReady.bind(this));this.backoff.on('fail', this.onBackoffFail.bind(this));this.open();
   }_createClass(WebSocketClient, [{ key: 'open', value: function open() {
         var reconnect = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;this.isReconnect = reconnect;this.ws = new WebSocket(this.url, this.protocols);this.ws.onclose = this.onCloseCallback.bind(this);this.ws.onerror = this.onErrorCallback.bind(this);this.ws.onmessage = this.onMessageCallback.bind(this);this.ws.onopen = this.onOpenCallback.bind(this);
      } /**
        * @ignore
        */ }, { key: 'onBackoffStart', value: function onBackoffStart(number, delay) {} /**
                                                                                        * @ignore
                                                                                        */ }, { key: 'onBackoffReady', value: function onBackoffReady(number, delay) {
         // console.log("onBackoffReady", number + ' ' + delay + 'ms');
         this.open(true);
      } /**
        * @ignore
        */ }, { key: 'onBackoffFail', value: function onBackoffFail() {} /**
                                                                         * @ignore
                                                                         */ }, { key: 'onCloseCallback', value: function onCloseCallback() {
         if (!this.isReconnect && this.listeners['onclose']) this.listeners['onclose'].apply(null, arguments);if (this.reconnectEnabled) {
            this.backoff.backoff();
         }
      } /**
        * @ignore
        */ }, { key: 'onErrorCallback', value: function onErrorCallback() {
         if (this.listeners['onerror']) this.listeners['onerror'].apply(null, arguments);
      } /**
        * @ignore
        */ }, { key: 'onMessageCallback', value: function onMessageCallback() {
         if (this.listeners['onmessage']) this.listeners['onmessage'].apply(null, arguments);
      } /**
        * @ignore
        */ }, { key: 'onOpenCallback', value: function onOpenCallback() {
         if (this.listeners['onopen']) this.listeners['onopen'].apply(null, arguments);if (this.isReconnect && this.listeners['onreconnect']) this.listeners['onreconnect'].apply(null, arguments);this.isReconnect = false;
      } /**
        * The number of bytes of data that have been queued using calls to send()
        * but not yet transmitted to the network. This value does not reset to zero
        * when the connection is closed; if you keep calling send(), this will
        * continue to climb.
        *
        * @type unsigned long
        * @readonly
        */ }, { key: 'close', /**
                              * Closes the WebSocket connection or connection attempt, if any. If the
                              * connection is already CLOSED, this method does nothing.
                              *
                              * @param code A numeric value indicating the status code explaining why the connection is being closed. If this parameter is not specified, a default value of 1000 (indicating a normal "transaction complete" closure) is assumed. See the list of status codes on the CloseEvent page for permitted values.
                              * @param reason A human-readable string explaining why the connection is closing. This string must be no longer than 123 bytes of UTF-8 text (not characters).
                              *
                              * @return void
                              */value: function close(code, reason) {
         if (typeof code == 'undefined') {
            code = 1000;
         }this.reconnectEnabled = false;this.ws.close(code, reason);
      } /**
        * Transmits data to the server over the WebSocket connection.
        * @param data DOMString|ArrayBuffer|Blob
        * @return void
        */ }, { key: 'send', value: function send(data) {
         this.ws.send(data);
      } /**
        * An event listener to be called when the WebSocket connection's readyState changes to CLOSED. The listener receives a CloseEvent named "close".
        * @param listener EventListener
        */ }, { key: 'bufferedAmount', get: function get() {
         return this.ws.bufferedAmount;
      } /**
        * The current state of the connection; this is one of the Ready state constants.
        * @type unsigned short
        * @readonly
        */ }, { key: 'readyState', get: function get() {
         return this.ws.readyState;
      } /**
        * A string indicating the type of binary data being transmitted by the
        * connection. This should be either "blob" if DOM Blob objects are being
        * used or "arraybuffer" if ArrayBuffer objects are being used.
        * @type DOMString
        */ }, { key: 'binaryType', get: function get() {
         return this.ws.binaryType;
      }, set: function set(binaryType) {
         this.ws.binaryType = binaryType;
      } /**
        * The extensions selected by the server. This is currently only the empty
        * string or a list of extensions as negotiated by the connection.
        * @type DOMString
        */ }, { key: 'extensions', get: function get() {
         return this.ws.extensions;
      }, set: function set(extensions) {
         this.ws.extensions = extensions;
      } /**
        * A string indicating the name of the sub-protocol the server selected;
        * this will be one of the strings specified in the protocols parameter when
        * creating the WebSocket object.
        * @type DOMString
        */ }, { key: 'protocol', get: function get() {
         return this.ws.protocol;
      }, set: function set(protocol) {
         this.ws.protocol = protocol;
      } }, { key: 'onclose', set: function set(listener) {
         this.listeners['onclose'] = listener;
      }, get: function get() {
         return this.listeners['onclose'];
      } /**
        * An event listener to be called when an error occurs. This is a simple event named "error".
        * @param listener EventListener
        */ }, { key: 'onerror', set: function set(listener) {
         this.listeners['onerror'] = listener;
      }, get: function get() {
         return this.listeners['onerror'];
      } /**
        * An event listener to be called when a message is received from the server. The listener receives a MessageEvent named "message".
        * @param listener EventListener
        */ }, { key: 'onmessage', set: function set(listener) {
         this.listeners['onmessage'] = listener;
      }, get: function get() {
         return this.listeners['onmessage'];
      } /**
        * An event listener to be called when the WebSocket connection's readyState changes to OPEN; this indicates that the connection is ready to send and receive data. The event is a simple one with the name "open".
        * @param listener EventListener
        */ }, { key: 'onopen', set: function set(listener) {
         this.listeners['onopen'] = listener;
      }, get: function get() {
         return this.listeners['onopen'];
      } /**
        * @param listener EventListener
        */ }, { key: 'onreconnect', set: function set(listener) {
         this.listeners['onreconnect'] = listener;
      }, get: function get() {
         return this.listeners['onreconnect'];
      } }]);return WebSocketClient;
}(); /**
     * The connection is not yet open.
     */WebSocketClient.CONNECTING = WebSocket.CONNECTING; /**
                                                          * The connection is open and ready to communicate.
                                                          */WebSocketClient.OPEN = WebSocket.OPEN; /**
                                                                                                   * The connection is in the process of closing.
                                                                                                   */WebSocketClient.CLOSING = WebSocket.CLOSING; /**
                                                                                                                                                  * The connection is closed or couldn't be opened.
                                                                                                                                                  */WebSocketClient.CLOSED = WebSocket.CLOSED;exports.default = WebSocketClient;

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

//      Copyright (c) 2012 Mathieu Turcotte
//      Licensed under the MIT license.

var Backoff = __webpack_require__(242);
var ExponentialBackoffStrategy = __webpack_require__(648);
var FibonacciBackoffStrategy = __webpack_require__(244);
var FunctionCall = __webpack_require__(649);

module.exports.Backoff = Backoff;
module.exports.FunctionCall = FunctionCall;
module.exports.FibonacciStrategy = FibonacciBackoffStrategy;
module.exports.ExponentialStrategy = ExponentialBackoffStrategy;

// Constructs a Fibonacci backoff.
module.exports.fibonacci = function (options) {
    return new Backoff(new FibonacciBackoffStrategy(options));
};

// Constructs an exponential backoff.
module.exports.exponential = function (options) {
    return new Backoff(new ExponentialBackoffStrategy(options));
};

// Constructs a FunctionCall for the given function and arguments.
module.exports.call = function (fn, vargs, callback) {
    var args = Array.prototype.slice.call(arguments);
    fn = args[0];
    vargs = args.slice(1, args.length - 1);
    callback = args[args.length - 1];
    return new FunctionCall(fn, vargs, callback);
};

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * Copyright (c) 2012 Mathieu Turcotte
 * Licensed under the MIT license.
 */

var util = __webpack_require__(42);

var errors = module.exports = __webpack_require__(647);

function failCheck(ExceptionConstructor, callee, messageFormat, formatArgs) {
    messageFormat = messageFormat || '';
    var message = util.format.apply(this, [messageFormat].concat(formatArgs));
    var error = new ExceptionConstructor(message);
    Error.captureStackTrace(error, callee);
    throw error;
}

function failArgumentCheck(callee, message, formatArgs) {
    failCheck(errors.IllegalArgumentError, callee, message, formatArgs);
}

function failStateCheck(callee, message, formatArgs) {
    failCheck(errors.IllegalStateError, callee, message, formatArgs);
}

module.exports.checkArgument = function (value, message) {
    if (!value) {
        failArgumentCheck(arguments.callee, message, Array.prototype.slice.call(arguments, 2));
    }
};

module.exports.checkState = function (value, message) {
    if (!value) {
        failStateCheck(arguments.callee, message, Array.prototype.slice.call(arguments, 2));
    }
};

module.exports.checkIsDef = function (value, message) {
    if (value !== undefined) {
        return value;
    }

    failArgumentCheck(arguments.callee, message || 'Expected value to be defined but was undefined.', Array.prototype.slice.call(arguments, 2));
};

module.exports.checkIsDefAndNotNull = function (value, message) {
    // Note that undefined == null.
    if (value != null) {
        return value;
    }

    failArgumentCheck(arguments.callee, message || 'Expected value to be defined and not null but got "' + typeOf(value) + '".', Array.prototype.slice.call(arguments, 2));
};

// Fixed version of the typeOf operator which returns 'null' for null values
// and 'array' for arrays.
function typeOf(value) {
    var s = typeof value;
    if (s == 'object') {
        if (!value) {
            return 'null';
        } else if (value instanceof Array) {
            return 'array';
        }
    }
    return s;
}

function typeCheck(expect) {
    return function (value, message) {
        var type = typeOf(value);

        if (type == expect) {
            return value;
        }

        failArgumentCheck(arguments.callee, message || 'Expected "' + expect + '" but got "' + type + '".', Array.prototype.slice.call(arguments, 2));
    };
}

module.exports.checkIsString = typeCheck('string');
module.exports.checkIsArray = typeCheck('array');
module.exports.checkIsNumber = typeCheck('number');
module.exports.checkIsBoolean = typeCheck('boolean');
module.exports.checkIsFunction = typeCheck('function');
module.exports.checkIsObject = typeCheck('object');

/***/ }),
/* 645 */
/***/ (function(module, exports) {

module.exports = function isBuffer(arg) {
  return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

/***/ }),
/* 646 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
      constructor: {
        value: ctor,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  };
}

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * Copyright (c) 2012 Mathieu Turcotte
 * Licensed under the MIT license.
 */

var util = __webpack_require__(42);

function IllegalArgumentError(message) {
    Error.call(this, message);
    this.message = message;
}
util.inherits(IllegalArgumentError, Error);

IllegalArgumentError.prototype.name = 'IllegalArgumentError';

function IllegalStateError(message) {
    Error.call(this, message);
    this.message = message;
}
util.inherits(IllegalStateError, Error);

IllegalStateError.prototype.name = 'IllegalStateError';

module.exports.IllegalStateError = IllegalStateError;
module.exports.IllegalArgumentError = IllegalArgumentError;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

//      Copyright (c) 2012 Mathieu Turcotte
//      Licensed under the MIT license.

var util = __webpack_require__(42);
var precond = __webpack_require__(150);

var BackoffStrategy = __webpack_require__(243);

// Exponential backoff strategy.
function ExponentialBackoffStrategy(options) {
    BackoffStrategy.call(this, options);
    this.backoffDelay_ = 0;
    this.nextBackoffDelay_ = this.getInitialDelay();
    this.factor_ = ExponentialBackoffStrategy.DEFAULT_FACTOR;

    if (options && options.factor !== undefined) {
        precond.checkArgument(options.factor > 1, 'Exponential factor should be greater than 1 but got %s.', options.factor);
        this.factor_ = options.factor;
    }
}
util.inherits(ExponentialBackoffStrategy, BackoffStrategy);

// Default multiplication factor used to compute the next backoff delay from
// the current one. The value can be overridden by passing a custom factor as
// part of the options.
ExponentialBackoffStrategy.DEFAULT_FACTOR = 2;

ExponentialBackoffStrategy.prototype.next_ = function () {
    this.backoffDelay_ = Math.min(this.nextBackoffDelay_, this.getMaxDelay());
    this.nextBackoffDelay_ = this.backoffDelay_ * this.factor_;
    return this.backoffDelay_;
};

ExponentialBackoffStrategy.prototype.reset_ = function () {
    this.backoffDelay_ = 0;
    this.nextBackoffDelay_ = this.getInitialDelay();
};

module.exports = ExponentialBackoffStrategy;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

//      Copyright (c) 2012 Mathieu Turcotte
//      Licensed under the MIT license.

var events = __webpack_require__(149);
var precond = __webpack_require__(150);
var util = __webpack_require__(42);

var Backoff = __webpack_require__(242);
var FibonacciBackoffStrategy = __webpack_require__(244);

// Wraps a function to be called in a backoff loop.
function FunctionCall(fn, args, callback) {
    events.EventEmitter.call(this);

    precond.checkIsFunction(fn, 'Expected fn to be a function.');
    precond.checkIsArray(args, 'Expected args to be an array.');
    precond.checkIsFunction(callback, 'Expected callback to be a function.');

    this.function_ = fn;
    this.arguments_ = args;
    this.callback_ = callback;
    this.lastResult_ = [];
    this.numRetries_ = 0;

    this.backoff_ = null;
    this.strategy_ = null;
    this.failAfter_ = -1;
    this.retryPredicate_ = FunctionCall.DEFAULT_RETRY_PREDICATE_;

    this.state_ = FunctionCall.State_.PENDING;
}
util.inherits(FunctionCall, events.EventEmitter);

// States in which the call can be.
FunctionCall.State_ = {
    // Call isn't started yet.
    PENDING: 0,
    // Call is in progress.
    RUNNING: 1,
    // Call completed successfully which means that either the wrapped function
    // returned successfully or the maximal number of backoffs was reached.
    COMPLETED: 2,
    // The call was aborted.
    ABORTED: 3
};

// The default retry predicate which considers any error as retriable.
FunctionCall.DEFAULT_RETRY_PREDICATE_ = function (err) {
    return true;
};

// Checks whether the call is pending.
FunctionCall.prototype.isPending = function () {
    return this.state_ == FunctionCall.State_.PENDING;
};

// Checks whether the call is in progress.
FunctionCall.prototype.isRunning = function () {
    return this.state_ == FunctionCall.State_.RUNNING;
};

// Checks whether the call is completed.
FunctionCall.prototype.isCompleted = function () {
    return this.state_ == FunctionCall.State_.COMPLETED;
};

// Checks whether the call is aborted.
FunctionCall.prototype.isAborted = function () {
    return this.state_ == FunctionCall.State_.ABORTED;
};

// Sets the backoff strategy to use. Can only be called before the call is
// started otherwise an exception will be thrown.
FunctionCall.prototype.setStrategy = function (strategy) {
    precond.checkState(this.isPending(), 'FunctionCall in progress.');
    this.strategy_ = strategy;
    return this; // Return this for chaining.
};

// Sets the predicate which will be used to determine whether the errors
// returned from the wrapped function should be retried or not, e.g. a
// network error would be retriable while a type error would stop the
// function call.
FunctionCall.prototype.retryIf = function (retryPredicate) {
    precond.checkState(this.isPending(), 'FunctionCall in progress.');
    this.retryPredicate_ = retryPredicate;
    return this;
};

// Returns all intermediary results returned by the wrapped function since
// the initial call.
FunctionCall.prototype.getLastResult = function () {
    return this.lastResult_.concat();
};

// Returns the number of times the wrapped function call was retried.
FunctionCall.prototype.getNumRetries = function () {
    return this.numRetries_;
};

// Sets the backoff limit.
FunctionCall.prototype.failAfter = function (maxNumberOfRetry) {
    precond.checkState(this.isPending(), 'FunctionCall in progress.');
    this.failAfter_ = maxNumberOfRetry;
    return this; // Return this for chaining.
};

// Aborts the call.
FunctionCall.prototype.abort = function () {
    if (this.isCompleted() || this.isAborted()) {
        return;
    }

    if (this.isRunning()) {
        this.backoff_.reset();
    }

    this.state_ = FunctionCall.State_.ABORTED;
    this.lastResult_ = [new Error('Backoff aborted.')];
    this.emit('abort');
    this.doCallback_();
};

// Initiates the call to the wrapped function. Accepts an optional factory
// function used to create the backoff instance; used when testing.
FunctionCall.prototype.start = function (backoffFactory) {
    precond.checkState(!this.isAborted(), 'FunctionCall is aborted.');
    precond.checkState(this.isPending(), 'FunctionCall already started.');

    var strategy = this.strategy_ || new FibonacciBackoffStrategy();

    this.backoff_ = backoffFactory ? backoffFactory(strategy) : new Backoff(strategy);

    this.backoff_.on('ready', this.doCall_.bind(this, true /* isRetry */));
    this.backoff_.on('fail', this.doCallback_.bind(this));
    this.backoff_.on('backoff', this.handleBackoff_.bind(this));

    if (this.failAfter_ > 0) {
        this.backoff_.failAfter(this.failAfter_);
    }

    this.state_ = FunctionCall.State_.RUNNING;
    this.doCall_(false /* isRetry */);
};

// Calls the wrapped function.
FunctionCall.prototype.doCall_ = function (isRetry) {
    if (isRetry) {
        this.numRetries_++;
    }
    var eventArgs = ['call'].concat(this.arguments_);
    events.EventEmitter.prototype.emit.apply(this, eventArgs);
    var callback = this.handleFunctionCallback_.bind(this);
    this.function_.apply(null, this.arguments_.concat(callback));
};

// Calls the wrapped function's callback with the last result returned by the
// wrapped function.
FunctionCall.prototype.doCallback_ = function () {
    this.callback_.apply(null, this.lastResult_);
};

// Handles wrapped function's completion. This method acts as a replacement
// for the original callback function.
FunctionCall.prototype.handleFunctionCallback_ = function () {
    if (this.isAborted()) {
        return;
    }

    var args = Array.prototype.slice.call(arguments);
    this.lastResult_ = args; // Save last callback arguments.
    events.EventEmitter.prototype.emit.apply(this, ['callback'].concat(args));

    var err = args[0];
    if (err && this.retryPredicate_(err)) {
        this.backoff_.backoff(err);
    } else {
        this.state_ = FunctionCall.State_.COMPLETED;
        this.doCallback_();
    }
};

// Handles the backoff event by reemitting it.
FunctionCall.prototype.handleBackoff_ = function (number, delay, err) {
    this.emit('backoff', number, delay, err);
};

module.exports = FunctionCall;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(34);

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = __webpack_require__(56);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = __webpack_require__(651);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(1);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(245);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(3);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(4);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.getDomTreeShapes = getDomTreeShapes;
exports.findNativeHandler = findNativeHandler;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(16);

var _warning2 = _interopRequireDefault(_warning);

var _properties = __webpack_require__(218);

var _properties2 = _interopRequireDefault(_properties);

var _on = __webpack_require__(140);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(141);

var _off2 = _interopRequireDefault(_off);

var _reactSwipeableViewsCore = __webpack_require__(657);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function addEventListenerEnhanced(node, event, handler, options) {
  (0, _on2.default)(node, event, handler, options);
  return {
    remove: function remove() {
      (0, _off2.default)(node, event, handler, options);
    }
  };
}

var styleInjected = false;

// Support old version of iOS and IE 10.
// To be deleted in 2019.
function injectStyle() {
  // Inject once for all the instances
  if (!styleInjected) {
    var style = document.createElement('style');
    style.innerHTML = '\n      .react-swipeable-view-container {\n        display: -webkit-box;\n        display: -ms-flexbox;\n      }\n      .react-swipeable-view-container > div {\n        -ms-flex-negative: 0;\n      }\n    ';

    if (document.body) {
      document.body.appendChild(style);
    }
    styleInjected = true;
  }
}

var styles = {
  container: {
    direction: 'ltr',
    display: 'flex',
    willChange: 'transform'
  },
  slide: {
    width: '100%',
    WebkitFlexShrink: 0,
    flexShrink: 0,
    overflow: 'auto'
  }
};

var axisProperties = {
  root: {
    x: {
      overflowX: 'hidden'
    },
    'x-reverse': {
      overflowX: 'hidden'
    },
    y: {
      overflowY: 'hidden'
    },
    'y-reverse': {
      overflowY: 'hidden'
    }
  },
  flexDirection: {
    x: 'row',
    'x-reverse': 'row-reverse',
    y: 'column',
    'y-reverse': 'column-reverse'
  },
  transform: {
    x: function x(translate) {
      return 'translate(' + -translate + '%, 0)';
    },
    'x-reverse': function xReverse(translate) {
      return 'translate(' + translate + '%, 0)';
    },
    y: function y(translate) {
      return 'translate(0, ' + -translate + '%)';
    },
    'y-reverse': function yReverse(translate) {
      return 'translate(0, ' + translate + '%)';
    }
  },
  length: {
    x: 'width',
    'x-reverse': 'width',
    y: 'height',
    'y-reverse': 'height'
  },
  rotationMatrix: {
    x: {
      x: [1, 0],
      y: [0, 1]
    },
    'x-reverse': {
      x: [-1, 0],
      y: [0, 1]
    },
    y: {
      x: [0, 1],
      y: [1, 0]
    },
    'y-reverse': {
      x: [0, -1],
      y: [1, 0]
    }
  },
  scrollPosition: {
    x: 'scrollLeft',
    'x-reverse': 'scrollLeft',
    y: 'scrollTop',
    'y-reverse': 'scrollTop'
  },
  scrollLength: {
    x: 'scrollWidth',
    'x-reverse': 'scrollWidth',
    y: 'scrollHeight',
    'y-reverse': 'scrollHeight'
  },
  clientLength: {
    x: 'clientWidth',
    'x-reverse': 'clientWidth',
    y: 'clientHeight',
    'y-reverse': 'clientHeight'
  }
};

function createTransition(property, options) {
  var duration = options.duration,
      easeFunction = options.easeFunction,
      delay = options.delay;

  return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
}

// We are using a 2x2 rotation matrix.
function applyRotationMatrix(touch, axis) {
  var rotationMatrix = axisProperties.rotationMatrix[axis];

  return {
    pageX: rotationMatrix.x[0] * touch.pageX + rotationMatrix.x[1] * touch.pageY,
    pageY: rotationMatrix.y[0] * touch.pageX + rotationMatrix.y[1] * touch.pageY
  };
}

function adaptMouse(event) {
  event.touches = [{ pageX: event.pageX, pageY: event.pageY }];
  return event;
}

function getDomTreeShapes(element, rootNode) {
  var domTreeShapes = [];

  while (element && element !== rootNode) {
    // We reach a Swipeable View, no need to look higher in the dom tree.
    if (element.hasAttribute('data-swipeable')) {
      break;
    }

    var style = window.getComputedStyle(element);

    if (
    // Ignore the scroll children if the element is absolute positioned.
    style.getPropertyValue('position') === 'absolute' ||
    // Ignore the scroll children if the element has an overflowX hidden
    style.getPropertyValue('overflow-x') === 'hidden') {
      domTreeShapes = [];
    } else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) {
      // Ignore the nodes that have no width.
      // Keep elements with a scroll
      domTreeShapes.push({
        element: element,
        scrollWidth: element.scrollWidth,
        scrollHeight: element.scrollHeight,
        clientWidth: element.clientWidth,
        clientHeight: element.clientHeight,
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
      });
    }

    element = element.parentNode;
  }

  return domTreeShapes;
}

// We can only have one node at the time claiming ownership for handling the swipe.
// Otherwise, the UX would be confusing.
// That's why we use a singleton here.
var nodeHowClaimedTheScroll = null;

function findNativeHandler(params) {
  var domTreeShapes = params.domTreeShapes,
      pageX = params.pageX,
      startX = params.startX,
      axis = params.axis;

  return domTreeShapes.some(function (shape) {
    // Determine if we are going backward or forward.
    var goingForward = pageX >= startX;
    if (axis === 'x' || axis === 'y') {
      goingForward = !goingForward;
    }

    var scrollPosition = shape[axisProperties.scrollPosition[axis]];

    var areNotAtStart = scrollPosition > 0;
    var areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];

    if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) {
      nodeHowClaimedTheScroll = shape.element;
      return true;
    }

    return false;
  });
}

var SwipeableViews = function (_Component) {
  (0, _inherits3.default)(SwipeableViews, _Component);

  function SwipeableViews() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, SwipeableViews);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SwipeableViews.__proto__ || (0, _getPrototypeOf2.default)(SwipeableViews)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      indexLatest: null,
      // Set to true as soon as the component is swiping.
      // It's the state counter part of this.isSwiping.
      isDragging: false,
      // Help with SSR logic and lazy loading logic.
      isFirstRender: true,
      heightLatest: 0,
      // Let the render method that we are going to display the same slide than previously.
      displaySameSlide: true
    }, _this.rootNode = null, _this.containerNode = null, _this.ignoreNextScrollEvents = false, _this.viewLength = 0, _this.startX = 0, _this.lastX = 0, _this.vx = 0, _this.startY = 0, _this.isSwiping = undefined, _this.started = false, _this.startIndex = 0, _this.transitionListener = null, _this.touchMoveListener = null, _this.activeSlide = null, _this.indexCurrent = null, _this.handleSwipeStart = function (event) {
      var axis = _this.props.axis;

      // Latency and rapid rerenders on some devices can leave
      // a period where rootNode briefly equals null.

      if (_this.rootNode === null) {
        return;
      }

      var touch = applyRotationMatrix(event.touches[0], axis);

      _this.viewLength = _this.rootNode.getBoundingClientRect()[axisProperties.length[axis]];
      _this.startX = touch.pageX;
      _this.lastX = touch.pageX;
      _this.vx = 0;
      _this.startY = touch.pageY;
      _this.isSwiping = undefined;
      _this.started = true;

      var computedStyle = window.getComputedStyle(_this.containerNode);
      var transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');

      if (transform && transform !== 'none') {
        var transformValues = transform.split('(')[1].split(')')[0].split(',');
        var rootStyle = window.getComputedStyle(_this.rootNode);

        var tranformNormalized = applyRotationMatrix({
          pageX: parseInt(transformValues[4], 10),
          pageY: parseInt(transformValues[5], 10)
        }, axis);

        _this.startIndex = -tranformNormalized.pageX / (_this.viewLength - parseInt(rootStyle.paddingLeft, 10) - parseInt(rootStyle.paddingRight, 10));
      }
    }, _this.handleSwipeMove = function (event) {
      // The touch start event can be cancel.
      // Makes sure we set a starting point.
      if (!_this.started) {
        _this.handleTouchStart(event);
        return;
      }

      // Latency and rapid rerenders on some devices
      // can leave a period where rootNode briefly equals null.
      if (_this.rootNode === null) {
        return;
      }

      // We are not supposed to hanlde this touch move.
      if (nodeHowClaimedTheScroll !== null && nodeHowClaimedTheScroll !== _this.rootNode) {
        return;
      }

      var _this$props = _this.props,
          axis = _this$props.axis,
          children = _this$props.children,
          ignoreNativeScroll = _this$props.ignoreNativeScroll,
          onSwitching = _this$props.onSwitching,
          resistance = _this$props.resistance;

      var touch = applyRotationMatrix(event.touches[0], axis);

      // We don't know yet.
      if (_this.isSwiping === undefined) {
        var dx = Math.abs(_this.startX - touch.pageX);
        var dy = Math.abs(_this.startY - touch.pageY);

        var isSwiping = dx > dy && dx > _reactSwipeableViewsCore.constant.UNCERTAINTY_THRESHOLD;

        // We let the parent handle the scroll.
        if (!resistance && (axis === 'y' || axis === 'y-reverse') && (_this.indexCurrent === 0 && _this.startX < touch.pageX || _this.indexCurrent === _react.Children.count(_this.props.children) - 1 && _this.startX > touch.pageX)) {
          _this.isSwiping = false;
          return;
        }

        // We are likely to be swiping, let's prevent the scroll event.
        if (dx > dy) {
          event.preventDefault();
        }

        if (isSwiping === true || dy > _reactSwipeableViewsCore.constant.UNCERTAINTY_THRESHOLD) {
          _this.isSwiping = isSwiping;
          _this.startX = touch.pageX; // Shift the starting point.

          return; // Let's wait the next touch event to move something.
        }
      }

      if (_this.isSwiping !== true) {
        return;
      }

      // We are swiping, let's prevent the scroll event.
      event.preventDefault();

      // Low Pass filter.
      _this.vx = _this.vx * 0.5 + (touch.pageX - _this.lastX) * 0.5;
      _this.lastX = touch.pageX;

      var _computeIndex = (0, _reactSwipeableViewsCore.computeIndex)({
        children: children,
        resistance: resistance,
        pageX: touch.pageX,
        startIndex: _this.startIndex,
        startX: _this.startX,
        viewLength: _this.viewLength
      }),
          index = _computeIndex.index,
          startX = _computeIndex.startX;

      // Add support for native scroll elements.


      if (nodeHowClaimedTheScroll === null && !ignoreNativeScroll) {
        var domTreeShapes = getDomTreeShapes(event.target, _this.rootNode);
        var hasFoundNativeHandler = findNativeHandler({
          domTreeShapes: domTreeShapes,
          startX: _this.startX,
          pageX: touch.pageX,
          axis: axis
        });

        // We abort the touch move handler.
        if (hasFoundNativeHandler) {
          return;
        }
      }

      // We are moving toward the edges.
      if (startX) {
        _this.startX = startX;
      } else if (nodeHowClaimedTheScroll === null) {
        nodeHowClaimedTheScroll = _this.rootNode;
      }

      _this.setIndexCurrent(index);

      var callback = function callback() {
        if (onSwitching) {
          onSwitching(index, 'move');
        }
      };

      if (_this.state.displaySameSlide || !_this.state.isDragging) {
        _this.setState({
          displaySameSlide: false,
          isDragging: true
        }, callback);
      }

      callback();
    }, _this.handleSwipeEnd = function () {
      nodeHowClaimedTheScroll = null;

      // The touch start event can be cancel.
      // Makes sure that a starting point is set.
      if (!_this.started) {
        return;
      }

      _this.started = false;

      if (_this.isSwiping !== true) {
        return;
      }

      var indexLatest = _this.state.indexLatest;
      var indexCurrent = _this.indexCurrent;
      var delta = indexLatest - indexCurrent;

      var indexNew = void 0;

      // Quick movement
      if (Math.abs(_this.vx) > _this.props.threshold) {
        if (_this.vx > 0) {
          indexNew = Math.floor(indexCurrent);
        } else {
          indexNew = Math.ceil(indexCurrent);
        }
      } else if (Math.abs(delta) > _this.props.hysteresis) {
        // Some hysteresis with indexLatest.
        indexNew = delta > 0 ? Math.floor(indexCurrent) : Math.ceil(indexCurrent);
      } else {
        indexNew = indexLatest;
      }

      var indexMax = _react.Children.count(_this.props.children) - 1;

      if (indexNew < 0) {
        indexNew = 0;
      } else if (indexNew > indexMax) {
        indexNew = indexMax;
      }

      _this.setIndexCurrent(indexNew);
      _this.setState({
        indexLatest: indexNew,
        isDragging: false
      }, function () {
        if (_this.props.onSwitching) {
          _this.props.onSwitching(indexNew, 'end');
        }

        if (_this.props.onChangeIndex && indexNew !== indexLatest) {
          _this.props.onChangeIndex(indexNew, indexLatest, {
            reason: 'swipe'
          });
        }

        // Manually calling handleTransitionEnd in that case as isn't otherwise.
        if (indexCurrent === indexLatest) {
          _this.handleTransitionEnd();
        }
      });
    }, _this.handleTouchStart = function (event) {
      if (_this.props.onTouchStart) {
        _this.props.onTouchStart(event);
      }
      _this.handleSwipeStart(event);
    }, _this.handleTouchEnd = function (event) {
      if (_this.props.onTouchEnd) {
        _this.props.onTouchEnd(event);
      }
      _this.handleSwipeEnd(event);
    }, _this.handleMouseDown = function (event) {
      if (_this.props.onMouseDown) {
        _this.props.onMouseDown(event);
      }
      event.persist();
      _this.handleSwipeStart(adaptMouse(event));
    }, _this.handleMouseUp = function (event) {
      if (_this.props.onMouseUp) {
        _this.props.onMouseUp(event);
      }
      _this.handleSwipeEnd(adaptMouse(event));
    }, _this.handleMouseLeave = function (event) {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      }

      // Filter out events
      if (_this.started) {
        _this.handleSwipeEnd(adaptMouse(event));
      }
    }, _this.handleMouseMove = function (event) {
      if (_this.props.onMouseMove) {
        _this.props.onMouseMove(event);
      }

      // Filter out events
      if (_this.started) {
        _this.handleSwipeMove(adaptMouse(event));
      }
    }, _this.handleScroll = function (event) {
      if (_this.props.onScroll) {
        _this.props.onScroll(event);
      }

      // Ignore events bubbling up.
      if (event.target !== _this.rootNode) {
        return;
      }

      if (_this.ignoreNextScrollEvents) {
        _this.ignoreNextScrollEvents = false;
        return;
      }

      var indexLatest = _this.state.indexLatest;
      var indexNew = Math.ceil(event.target.scrollLeft / event.target.clientWidth) + indexLatest;

      _this.ignoreNextScrollEvents = true;
      // Reset the scroll position.
      event.target.scrollLeft = 0;

      if (_this.props.onChangeIndex && indexNew !== indexLatest) {
        _this.props.onChangeIndex(indexNew, indexLatest, {
          reason: 'focus'
        });
      }
    }, _this.updateHeight = function () {
      if (_this.activeSlide !== null) {
        var child = _this.activeSlide.children[0];
        if (child !== undefined && child.offsetHeight !== undefined && _this.state.heightLatest !== child.offsetHeight) {
          _this.setState({
            heightLatest: child.offsetHeight
          });
        }
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(SwipeableViews, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _this2 = this;

      return {
        swipeableViews: {
          slideUpdateHeight: function slideUpdateHeight() {
            _this2.updateHeight();
          }
        }
      };
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (false) {
        (0, _reactSwipeableViewsCore.checkIndexBounds)(this.props);
      }

      this.setIndexCurrent(this.props.index);
      this.setState({
        indexLatest: this.props.index
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      // Subscribe to transition end events.
      this.transitionListener = addEventListenerEnhanced(this.containerNode, _properties2.default.end, function (event) {
        if (event.target !== _this3.containerNode) {
          return;
        }

        _this3.handleTransitionEnd();
      });

      // Block the thread to handle that event.
      this.touchMoveListener = addEventListenerEnhanced(this.rootNode, 'touchmove', function (event) {
        // Handling touch events is disabled.
        if (_this3.props.disabled) {
          return;
        }
        _this3.handleSwipeMove(event);
      }, {
        passive: false
      });

      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        isFirstRender: false
      });

      injectStyle();

      // Send all functions in an object if action param is set.
      if (this.props.action) {
        this.props.action({
          updateHeight: this.updateHeight
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var index = nextProps.index;

      if (typeof index === 'number' && index !== this.props.index) {
        if (false) {
          (0, _reactSwipeableViewsCore.checkIndexBounds)(nextProps);
        }

        this.setIndexCurrent(index);
        this.setState({
          // If true, we are going to change the children. We shoudn't animate it.
          displaySameSlide: (0, _reactSwipeableViewsCore.getDisplaySameSlide)(this.props, nextProps),
          indexLatest: index
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.transitionListener.remove();
      this.touchMoveListener.remove();
    }
  }, {
    key: 'setIndexCurrent',
    value: function setIndexCurrent(indexCurrent) {
      if (!this.props.animateTransitions && this.indexCurrent !== indexCurrent) {
        this.handleTransitionEnd();
      }

      this.indexCurrent = indexCurrent;

      if (this.containerNode) {
        var axis = this.props.axis;

        var transform = axisProperties.transform[axis](indexCurrent * 100);
        this.containerNode.style.WebkitTransform = transform;
        this.containerNode.style.transform = transform;
      }
    }
  }, {
    key: 'handleTransitionEnd',
    value: function handleTransitionEnd() {
      if (!this.props.onTransitionEnd) {
        return;
      }

      // Filters out when changing the children
      if (this.state.displaySameSlide) {
        return;
      }

      // The rest callback is triggered when swiping. It's just noise.
      // We filter it out.
      if (!this.state.isDragging) {
        this.props.onTransitionEnd();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          action = _props.action,
          animateHeight = _props.animateHeight,
          animateTransitions = _props.animateTransitions,
          axis = _props.axis,
          children = _props.children,
          containerStyleProp = _props.containerStyle,
          disabled = _props.disabled,
          disableLazyLoading = _props.disableLazyLoading,
          enableMouseEvents = _props.enableMouseEvents,
          hysteresis = _props.hysteresis,
          ignoreNativeScroll = _props.ignoreNativeScroll,
          index = _props.index,
          onChangeIndex = _props.onChangeIndex,
          onSwitching = _props.onSwitching,
          onTransitionEnd = _props.onTransitionEnd,
          resistance = _props.resistance,
          slideStyleProp = _props.slideStyle,
          slideClassName = _props.slideClassName,
          springConfig = _props.springConfig,
          style = _props.style,
          threshold = _props.threshold,
          other = (0, _objectWithoutProperties3.default)(_props, ['action', 'animateHeight', 'animateTransitions', 'axis', 'children', 'containerStyle', 'disabled', 'disableLazyLoading', 'enableMouseEvents', 'hysteresis', 'ignoreNativeScroll', 'index', 'onChangeIndex', 'onSwitching', 'onTransitionEnd', 'resistance', 'slideStyle', 'slideClassName', 'springConfig', 'style', 'threshold']);
      var _state = this.state,
          displaySameSlide = _state.displaySameSlide,
          heightLatest = _state.heightLatest,
          isDragging = _state.isDragging,
          isFirstRender = _state.isFirstRender,
          indexLatest = _state.indexLatest;

      var touchEvents = !disabled ? {
        onTouchStart: this.handleTouchStart,
        onTouchEnd: this.handleTouchEnd
      } : {};
      var mouseEvents = !disabled && enableMouseEvents ? {
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp,
        onMouseLeave: this.handleMouseLeave,
        onMouseMove: this.handleMouseMove
      } : {};

      // There is no point to animate if we are already providing a height.
       false ? (0, _warning2.default)(!animateHeight || !containerStyleProp || !containerStyleProp.height, 'react-swipeable-view: You are setting animateHeight to true but you are\nalso providing a custom height.\nThe custom height has a higher priority than the animateHeight property.\nSo animateHeight is most likely having no effect at all.') : void 0;

      var slideStyle = (0, _extends3.default)({}, styles.slide, slideStyleProp);

      var transition = void 0;
      var WebkitTransition = void 0;

      if (isDragging || !animateTransitions || displaySameSlide) {
        transition = 'all 0s ease 0s';
        WebkitTransition = 'all 0s ease 0s';
      } else {
        transition = createTransition('transform', springConfig);
        WebkitTransition = createTransition('-webkit-transform', springConfig);

        if (heightLatest !== 0) {
          var additionalTranstion = ', ' + createTransition('height', springConfig);
          transition += additionalTranstion;
          WebkitTransition += additionalTranstion;
        }
      }

      var containerStyle = {
        height: null,
        WebkitFlexDirection: axisProperties.flexDirection[axis],
        flexDirection: axisProperties.flexDirection[axis],
        WebkitTransition: WebkitTransition,
        transition: transition
      };

      // Apply the styles for SSR considerations
      if (disableLazyLoading || !isFirstRender) {
        var transform = axisProperties.transform[axis](this.indexCurrent * 100);
        containerStyle.WebkitTransform = transform;
        containerStyle.transform = transform;
      }

      if (animateHeight) {
        containerStyle.height = heightLatest;
      }

      return _react2.default.createElement('div', (0, _extends3.default)({
        ref: function ref(node) {
          _this4.rootNode = node;
        },
        style: (0, _extends3.default)({}, axisProperties.root[axis], style)
      }, other, touchEvents, mouseEvents, {
        onScroll: this.handleScroll
      }), _react2.default.createElement('div', {
        ref: function ref(node) {
          _this4.containerNode = node;
        },
        style: (0, _extends3.default)({}, containerStyle, styles.container, containerStyleProp),
        className: 'react-swipeable-view-container'
      }, _react.Children.map(children, function (child, indexChild) {
        if (!disableLazyLoading && isFirstRender && indexChild !== indexLatest) {
          return null;
        }

         false ? (0, _warning2.default)((0, _react.isValidElement)(child), 'react-swipeable-view: one of the children provided is invalid: ' + child + '.\nWe are expecting a valid React Element') : void 0;

        var ref = void 0;
        var hidden = true;

        if (indexChild === indexLatest) {
          hidden = false;

          if (animateHeight) {
            ref = function ref(node) {
              _this4.activeSlide = node;
              _this4.updateHeight();
            };
            slideStyle.overflowY = 'hidden';
          }
        }

        return _react2.default.createElement('div', {
          ref: ref,
          style: slideStyle,
          className: slideClassName,
          'aria-hidden': hidden,
          'data-swipeable': 'true'
        }, child);
      })));
    }
  }]);
  return SwipeableViews;
}(_react.Component);

// Added as an ads for people using the React dev tools in production.
// So they know, the tool used to build the awesome UI they
// are looking at/retro engineering.


SwipeableViews.displayName = 'ReactSwipableView';

SwipeableViews.propTypes =  false ? {
  /**
   * This is callback property. It's called by the component on mount.
   * This is useful when you want to trigger an action programmatically.
   * It currently only supports updateHeight() action.
   *
   * @param {object} actions This object contains all posible actions
   * that can be triggered programmatically.
   */
  action: _propTypes2.default.func,
  /**
   * If `true`, the height of the container will be animated to match the current slide height.
   * Animating another style property has a negative impact regarding performance.
   */
  animateHeight: _propTypes2.default.bool,
  /**
   * If `false`, changes to the index prop will not cause an animated transition.
   */
  animateTransitions: _propTypes2.default.bool,
  /**
   * The axis on which the slides will slide.
   */
  axis: _propTypes2.default.oneOf(['x', 'x-reverse', 'y', 'y-reverse']),
  /**
   * Use this property to provide your slides.
   */
  children: _propTypes2.default.node.isRequired,
  /**
   * This is the inlined style that will be applied
   * to each slide container.
   */
  containerStyle: _propTypes2.default.object,
  /**
   * If `true`, it will disable touch events.
   * This is useful when you want to prohibit the user from changing slides.
   */
  disabled: _propTypes2.default.bool,
  /**
   * This is the config used to disable lazyloding,
   * if `true` will render all the views in first rendering.
   */
  disableLazyLoading: _propTypes2.default.bool,
  /**
   * If `true`, it will enable mouse events.
   * This will allow the user to perform the relevant swipe actions with a mouse.
   */
  enableMouseEvents: _propTypes2.default.bool,
  /**
   * Configure hysteresis between slides. This value determines how far
   * should user swipe to switch slide.
   */
  hysteresis: _propTypes2.default.number,
  /**
   * If `true`, it will ignore native scroll container.
   * It can be used to filter out false positive that blocks the swipe.
   */
  ignoreNativeScroll: _propTypes2.default.bool,
  /**
   * This is the index of the slide to show.
   * This is useful when you want to change the default slide shown.
   * Or when you have tabs linked to each slide.
   */
  index: _propTypes2.default.number,
  /**
   * This is callback prop. It's call by the
   * component when the shown slide change after a swipe made by the user.
   * This is useful when you have tabs linked to each slide.
   *
   * @param {integer} index This is the current index of the slide.
   * @param {integer} indexLatest This is the oldest index of the slide.
   * @param {object} meta Meta data containing more information about the event.
   */
  onChangeIndex: _propTypes2.default.func,
  /**
   * @ignore
   */
  onMouseDown: _propTypes2.default.func,
  /**
   * @ignore
   */
  onMouseLeave: _propTypes2.default.func,
  /**
   * @ignore
   */
  onMouseMove: _propTypes2.default.func,
  /**
   * @ignore
   */
  onMouseUp: _propTypes2.default.func,
  /**
   * @ignore
   */
  onScroll: _propTypes2.default.func,
  /**
   * This is callback prop. It's called by the
   * component when the slide switching.
   * This is useful when you want to implement something corresponding
   * to the current slide position.
   *
   * @param {integer} index This is the current index of the slide.
   * @param {string} type Can be either `move` or `end`.
   */
  onSwitching: _propTypes2.default.func,
  /**
   * @ignore
   */
  onTouchEnd: _propTypes2.default.func,
  /**
   * @ignore
   */
  onTouchMove: _propTypes2.default.func,
  /**
   * @ignore
   */
  onTouchStart: _propTypes2.default.func,
  /**
   * The callback that fires when the animation comes to a rest.
   * This is useful to defer CPU intensive task.
   */
  onTransitionEnd: _propTypes2.default.func,
  /**
   * If `true`, it will add bounds effect on the edges.
   */
  resistance: _propTypes2.default.bool,
  /**
   * This is the className that will be applied
   * on the slide component.
   */
  slideClassName: _propTypes2.default.string,
  /**
   * This is the inlined style that will be applied
   * on the slide component.
   */
  slideStyle: _propTypes2.default.object,
  /**
   * This is the config used to create CSS transitions.
   * This is useful to change the dynamic of the transition.
   */
  springConfig: _propTypes2.default.shape({
    duration: _propTypes2.default.string,
    easeFunction: _propTypes2.default.string,
    delay: _propTypes2.default.string
  }),
  /**
   * This is the inlined style that will be applied
   * on the root component.
   */
  style: _propTypes2.default.object,
  /**
   * This is the threshold used for detecting a quick swipe.
   * If the computed speed is above this value, the index change.
   */
  threshold: _propTypes2.default.number
} : {};

SwipeableViews.defaultProps = {
  animateHeight: false,
  animateTransitions: true,
  axis: 'x',
  disabled: false,
  disableLazyLoading: false,
  enableMouseEvents: false,
  hysteresis: 0.6,
  ignoreNativeScroll: false,
  index: 0,
  threshold: 5,
  springConfig: {
    duration: '0.35s',
    easeFunction: 'cubic-bezier(0.15, 0.3, 0.25, 1)',
    delay: '0s'
  },
  resistance: false
};

SwipeableViews.childContextTypes = {
  swipeableViews: _propTypes2.default.shape({
    slideUpdateHeight: _propTypes2.default.func
  })
};

exports.default = SwipeableViews;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(652), __esModule: true };

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(653);
module.exports = __webpack_require__(24).Object.getPrototypeOf;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(106);
var $getPrototypeOf = __webpack_require__(180);

__webpack_require__(338)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(655), __esModule: true };

/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(656);
var $Object = __webpack_require__(24).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};

/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(38);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(37), 'Object', { defineProperty: __webpack_require__(39).f });

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _checkIndexBounds = __webpack_require__(658);

Object.defineProperty(exports, 'checkIndexBounds', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_checkIndexBounds).default;
  }
});

var _computeIndex = __webpack_require__(659);

Object.defineProperty(exports, 'computeIndex', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_computeIndex).default;
  }
});

var _constant = __webpack_require__(246);

Object.defineProperty(exports, 'constant', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_constant).default;
  }
});

var _getDisplaySameSlide = __webpack_require__(660);

Object.defineProperty(exports, 'getDisplaySameSlide', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_getDisplaySameSlide).default;
  }
});

var _mod = __webpack_require__(661);

Object.defineProperty(exports, 'mod', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_mod).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _warning = __webpack_require__(16);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var checkIndexBounds = function checkIndexBounds(props) {
  var index = props.index,
      children = props.children;

  var childrenCount = _react.Children.count(children);

   false ? (0, _warning2.default)(index >= 0 && index <= childrenCount, 'react-swipeable-view: the new index: ' + index + ' is out of bounds: [0-' + childrenCount + '].') : void 0;
};

exports.default = checkIndexBounds;

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = computeIndex;

var _react = __webpack_require__(0);

var _constant = __webpack_require__(246);

var _constant2 = _interopRequireDefault(_constant);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function computeIndex(params) {
  var children = params.children,
      startIndex = params.startIndex,
      startX = params.startX,
      pageX = params.pageX,
      viewLength = params.viewLength,
      resistance = params.resistance;

  var indexMax = _react.Children.count(children) - 1;
  var index = startIndex + (startX - pageX) / viewLength;
  var newStartX = void 0;

  if (!resistance) {
    // Reset the starting point
    if (index < 0) {
      index = 0;
      newStartX = (index - startIndex) * viewLength + pageX;
    } else if (index > indexMax) {
      index = indexMax;
      newStartX = (index - startIndex) * viewLength + pageX;
    }
  } else if (index < 0) {
    index = Math.exp(index * _constant2.default.RESISTANCE_COEF) - 1;
  } else if (index > indexMax) {
    index = indexMax + 1 - Math.exp((indexMax - index) * _constant2.default.RESISTANCE_COEF);
  }

  return {
    index: index,
    startX: newStartX
  };
}

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var getDisplaySameSlide = function getDisplaySameSlide(props, nextProps) {
  var displaySameSlide = false;

  if (props.children.length && nextProps.children.length) {
    var oldChildren = props.children[props.index];
    var oldKey = oldChildren ? oldChildren.key : 'empty';

    if (oldKey !== null) {
      var newChildren = nextProps.children[nextProps.index];
      var newKey = newChildren ? newChildren.key : 'empty';

      if (oldKey === newKey) {
        displaySameSlide = true;
      }
    }
  }

  return displaySameSlide;
};

exports.default = getDisplaySameSlide;

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Extended version of % with negative integer support.
function mod(n, m) {
  var q = n % m;
  return q < 0 ? q + m : q;
}

exports.default = mod;

/***/ }),
/* 662 */,
/* 663 */,
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalRoot; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_modal_root__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_bundle_container__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__bundle_modal_error__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modal_loading__ = __webpack_require__(667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_modal__ = __webpack_require__(668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__media_modal__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__video_modal__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__boost_modal__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__confirmation_modal__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__focal_point_modal__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__features_ui_util_async_components__ = __webpack_require__(59);



















var MODAL_COMPONENTS = {
  'MEDIA': function MEDIA() {
    return Promise.resolve({ default: __WEBPACK_IMPORTED_MODULE_11__media_modal__["a" /* default */] });
  },
  'ONBOARDING': __WEBPACK_IMPORTED_MODULE_16__features_ui_util_async_components__["A" /* OnboardingModal */],
  'VIDEO': function VIDEO() {
    return Promise.resolve({ default: __WEBPACK_IMPORTED_MODULE_12__video_modal__["a" /* default */] });
  },
  'BOOST': function BOOST() {
    return Promise.resolve({ default: __WEBPACK_IMPORTED_MODULE_13__boost_modal__["a" /* default */] });
  },
  'CONFIRM': function CONFIRM() {
    return Promise.resolve({ default: __WEBPACK_IMPORTED_MODULE_14__confirmation_modal__["a" /* default */] });
  },
  'MUTE': __WEBPACK_IMPORTED_MODULE_16__features_ui_util_async_components__["x" /* MuteModal */],
  'REPORT': __WEBPACK_IMPORTED_MODULE_16__features_ui_util_async_components__["E" /* ReportModal */],
  'ACTIONS': function ACTIONS() {
    return Promise.resolve({ default: __WEBPACK_IMPORTED_MODULE_10__actions_modal__["a" /* default */] });
  },
  'EMBED': __WEBPACK_IMPORTED_MODULE_16__features_ui_util_async_components__["h" /* EmbedModal */],
  'LIST_EDITOR': __WEBPACK_IMPORTED_MODULE_16__features_ui_util_async_components__["t" /* ListEditor */],
  'FOCAL_POINT': function FOCAL_POINT() {
    return Promise.resolve({ default: __WEBPACK_IMPORTED_MODULE_15__focal_point_modal__["a" /* default */] });
  }
};

var ModalRoot = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ModalRoot, _React$PureComponent);

  function ModalRoot() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ModalRoot);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.renderLoading = function (modalId) {
      return function () {
        return ['MEDIA', 'VIDEO', 'BOOST', 'CONFIRM', 'ACTIONS'].indexOf(modalId) === -1 ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__modal_loading__["a" /* default */], {}) : null;
      };
    }, _this.renderError = function (props) {
      var onClose = _this.props.onClose;


      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__bundle_modal_error__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { onClose: onClose }));
    }, _temp), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  ModalRoot.prototype.getSnapshotBeforeUpdate = function getSnapshotBeforeUpdate() {
    var visible = !!this.props.type;
    return {
      overflowY: visible ? 'hidden' : null
    };
  };

  ModalRoot.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, _ref) {
    var overflowY = _ref.overflowY;

    document.body.style.overflowY = overflowY;
  };

  ModalRoot.prototype.render = function render() {
    var _props = this.props,
        type = _props.type,
        props = _props.props,
        onClose = _props.onClose;

    var visible = !!type;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6__components_modal_root__["a" /* default */], {
      onClose: onClose
    }, void 0, visible && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__containers_bundle_container__["a" /* default */], {
      fetchComponent: MODAL_COMPONENTS[type],
      loading: this.renderLoading(type),
      error: this.renderError,
      renderDelay: 200
    }, void 0, function (SpecificComponent) {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(SpecificComponent, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, { onClose: onClose }));
    }));
  };

  return ModalRoot;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.PureComponent);



/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BUNDLE_FETCH_REQUEST */
/* unused harmony export BUNDLE_FETCH_SUCCESS */
/* unused harmony export BUNDLE_FETCH_FAIL */
/* harmony export (immutable) */ __webpack_exports__["b"] = fetchBundleRequest;
/* harmony export (immutable) */ __webpack_exports__["c"] = fetchBundleSuccess;
/* harmony export (immutable) */ __webpack_exports__["a"] = fetchBundleFail;
var BUNDLE_FETCH_REQUEST = 'BUNDLE_FETCH_REQUEST';
var BUNDLE_FETCH_SUCCESS = 'BUNDLE_FETCH_SUCCESS';
var BUNDLE_FETCH_FAIL = 'BUNDLE_FETCH_FAIL';

function fetchBundleRequest(skipLoading) {
  return {
    type: BUNDLE_FETCH_REQUEST,
    skipLoading: skipLoading
  };
}

function fetchBundleSuccess(skipLoading) {
  return {
    type: BUNDLE_FETCH_SUCCESS,
    skipLoading: skipLoading
  };
}

function fetchBundleFail(error, skipLoading) {
  return {
    type: BUNDLE_FETCH_FAIL,
    error: error,
    skipLoading: skipLoading
  };
}

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icon_button__ = __webpack_require__(23);










var messages = Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["f" /* defineMessages */])({
  error: {
    'id': 'bundle_modal_error.message',
    'defaultMessage': 'Something went wrong while loading this component.'
  },
  retry: {
    'id': 'bundle_modal_error.retry',
    'defaultMessage': 'Try again'
  },
  close: {
    'id': 'bundle_modal_error.close',
    'defaultMessage': 'Close'
  }
});

var BundleModalError = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(BundleModalError, _React$PureComponent);

  function BundleModalError() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, BundleModalError);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.handleRetry = function () {
      _this.props.onRetry();
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  BundleModalError.prototype.render = function render() {
    var _props = this.props,
        onClose = _props.onClose,
        formatMessage = _props.intl.formatMessage;

    // Keep the markup in sync with <ModalLoading />
    // (make sure they have the same dimensions)

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'modal-root__modal error-modal'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'error-modal__body'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6__components_icon_button__["a" /* default */], {
      title: formatMessage(messages.retry),
      icon: 'refresh',
      onClick: this.handleRetry,
      size: 64
    }), formatMessage(messages.error)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'error-modal__footer'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {}, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
      onClick: onClose,
      className: 'error-modal__nav onboarding-modal__skip'
    }, void 0, formatMessage(messages.close)))));
  };

  return BundleModalError;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["g" /* injectIntl */])(BundleModalError));

/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_loading_indicator__ = __webpack_require__(299);





// Keep the markup in sync with <BundleModalError />
// (make sure they have the same dimensions)
var ModalLoading = function ModalLoading() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
    className: 'modal-root__modal error-modal'
  }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
    className: 'error-modal__body'
  }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_2__components_loading_indicator__["a" /* default */], {})), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
    className: 'error-modal__footer'
  }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {}, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('button', {
    className: 'error-modal__nav onboarding-modal__skip'
  }))));
};

/* harmony default export */ __webpack_exports__["a"] = (ModalLoading);

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionsModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_immutable_proptypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_immutable_pure_component__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_immutable_pure_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_immutable_pure_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_status_content__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_avatar__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_relative_timestamp__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_display_name__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_icon_button__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_classnames__);





var _class, _temp2;












var ActionsModal = (_temp2 = _class = function (_ImmutablePureCompone) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ActionsModal, _ImmutablePureCompone);

  function ActionsModal() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ActionsModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _ImmutablePureCompone.call.apply(_ImmutablePureCompone, [this].concat(args))), _this), _this.renderAction = function (action, i) {
      if (action === null) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('li', {
          className: 'dropdown-menu__separator'
        }, 'sep-' + i);
      }

      var _action$icon = action.icon,
          icon = _action$icon === undefined ? null : _action$icon,
          text = action.text,
          _action$meta = action.meta,
          meta = _action$meta === undefined ? null : _action$meta,
          _action$active = action.active,
          active = _action$active === undefined ? false : _action$active,
          _action$href = action.href,
          href = _action$href === undefined ? '#' : _action$href;


      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('li', {}, text + '-' + i, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('a', {
        href: href,
        target: '_blank',
        rel: 'noopener',
        onClick: _this.props.onClick,
        'data-index': i,
        className: __WEBPACK_IMPORTED_MODULE_13_classnames___default()({ active: active })
      }, void 0, icon && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__components_icon_button__["a" /* default */], {
        title: text,
        icon: icon,
        role: 'presentation',
        tabIndex: '-1',
        inverted: true
      }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {}, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
        className: __WEBPACK_IMPORTED_MODULE_13_classnames___default()({ 'actions-modal__item-label': !!meta })
      }, void 0, text), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {}, void 0, meta))));
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  ActionsModal.prototype.render = function render() {
    var status = this.props.status && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'status light'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'boost-modal__status-header'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'boost-modal__status-time'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('a', {
      href: this.props.status.get('url'),
      className: 'status__relative-time',
      target: '_blank',
      rel: 'noopener'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__components_relative_timestamp__["a" /* default */], {
      timestamp: this.props.status.get('created_at')
    }))), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('a', {
      href: this.props.status.getIn(['account', 'url']),
      className: 'status__display-name'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'status__avatar'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__components_avatar__["a" /* default */], {
      account: this.props.status.get('account'),
      size: 48
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__components_display_name__["a" /* default */], {
      account: this.props.status.get('account')
    }))), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8__components_status_content__["a" /* default */], {
      status: this.props.status
    }));

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'modal-root__modal actions-modal'
    }, void 0, status, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('ul', {}, void 0, this.props.actions.map(this.renderAction)));
  };

  return ActionsModal;
}(__WEBPACK_IMPORTED_MODULE_7_react_immutable_pure_component___default.a), _class.propTypes = {
  status: __WEBPACK_IMPORTED_MODULE_6_react_immutable_proptypes___default.a.map,
  actions: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.array,
  onClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
}, _temp2);


/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExtendedVideoPlayer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);






var ExtendedVideoPlayer = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ExtendedVideoPlayer, _React$PureComponent);

  function ExtendedVideoPlayer() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ExtendedVideoPlayer);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.handleLoadedData = function () {
      if (_this.props.time) {
        _this.video.currentTime = _this.props.time;
      }
    }, _this.setRef = function (c) {
      _this.video = c;
    }, _this.handleClick = function (e) {
      e.stopPropagation();
      var handler = _this.props.onClick;
      if (handler) handler();
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  ExtendedVideoPlayer.prototype.componentDidMount = function componentDidMount() {
    this.video.addEventListener('loadeddata', this.handleLoadedData);
  };

  ExtendedVideoPlayer.prototype.componentWillUnmount = function componentWillUnmount() {
    this.video.removeEventListener('loadeddata', this.handleLoadedData);
  };

  ExtendedVideoPlayer.prototype.render = function render() {
    var _props = this.props,
        src = _props.src,
        muted = _props.muted,
        controls = _props.controls,
        alt = _props.alt;


    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'extended-video-player'
    }, void 0, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('video', {
      ref: this.setRef,
      src: src,
      autoPlay: true,
      role: 'button',
      tabIndex: '0',
      'aria-label': alt,
      muted: muted,
      controls: controls,
      loop: !controls,
      onClick: this.handleClick
    }));
  };

  return ExtendedVideoPlayer;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent);



/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ZoomableImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);




var _class, _temp2;




var MIN_SCALE = 1;
var MAX_SCALE = 4;

var getMidpoint = function getMidpoint(p1, p2) {
  return {
    x: (p1.clientX + p2.clientX) / 2,
    y: (p1.clientY + p2.clientY) / 2
  };
};

var getDistance = function getDistance(p1, p2) {
  return Math.sqrt(Math.pow(p1.clientX - p2.clientX, 2) + Math.pow(p1.clientY - p2.clientY, 2));
};

var clamp = function clamp(min, max, value) {
  return Math.min(max, Math.max(min, value));
};

var ZoomableImage = (_temp2 = _class = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ZoomableImage, _React$PureComponent);

  function ZoomableImage() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ZoomableImage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
      scale: MIN_SCALE
    }, _this.removers = [], _this.container = null, _this.image = null, _this.lastTouchEndTime = 0, _this.lastDistance = 0, _this.handleTouchStart = function (e) {
      if (e.touches.length !== 2) return;

      _this.lastDistance = getDistance.apply(undefined, e.touches);
    }, _this.handleTouchMove = function (e) {
      var _this$container = _this.container,
          scrollTop = _this$container.scrollTop,
          scrollHeight = _this$container.scrollHeight,
          clientHeight = _this$container.clientHeight;

      if (e.touches.length === 1 && scrollTop !== scrollHeight - clientHeight) {
        // prevent propagating event to MediaModal
        e.stopPropagation();
        return;
      }
      if (e.touches.length !== 2) return;

      e.preventDefault();
      e.stopPropagation();

      var distance = getDistance.apply(undefined, e.touches);
      var midpoint = getMidpoint.apply(undefined, e.touches);
      var scale = clamp(MIN_SCALE, MAX_SCALE, _this.state.scale * distance / _this.lastDistance);

      _this.zoom(scale, midpoint);

      _this.lastMidpoint = midpoint;
      _this.lastDistance = distance;
    }, _this.handleClick = function (e) {
      // don't propagate event to MediaModal
      e.stopPropagation();
      var handler = _this.props.onClick;
      if (handler) handler();
    }, _this.setContainerRef = function (c) {
      _this.container = c;
    }, _this.setImageRef = function (c) {
      _this.image = c;
    }, _temp), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  ZoomableImage.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var handler = this.handleTouchStart;
    this.container.addEventListener('touchstart', handler);
    this.removers.push(function () {
      return _this2.container.removeEventListener('touchstart', handler);
    });
    handler = this.handleTouchMove;
    // on Chrome 56+, touch event listeners will default to passive
    // https://www.chromestatus.com/features/5093566007214080
    this.container.addEventListener('touchmove', handler, { passive: false });
    this.removers.push(function () {
      return _this2.container.removeEventListener('touchend', handler);
    });
  };

  ZoomableImage.prototype.componentWillUnmount = function componentWillUnmount() {
    this.removeEventListeners();
  };

  ZoomableImage.prototype.removeEventListeners = function removeEventListeners() {
    this.removers.forEach(function (listeners) {
      return listeners();
    });
    this.removers = [];
  };

  ZoomableImage.prototype.zoom = function zoom(nextScale, midpoint) {
    var _this3 = this;

    var scale = this.state.scale;
    var _container = this.container,
        scrollLeft = _container.scrollLeft,
        scrollTop = _container.scrollTop;

    // math memo:
    // x = (scrollLeft + midpoint.x) / scrollWidth
    // x' = (nextScrollLeft + midpoint.x) / nextScrollWidth
    // scrollWidth = clientWidth * scale
    // scrollWidth' = clientWidth * nextScale
    // Solve x = x' for nextScrollLeft

    var nextScrollLeft = (scrollLeft + midpoint.x) * nextScale / scale - midpoint.x;
    var nextScrollTop = (scrollTop + midpoint.y) * nextScale / scale - midpoint.y;

    this.setState({ scale: nextScale }, function () {
      _this3.container.scrollLeft = nextScrollLeft;
      _this3.container.scrollTop = nextScrollTop;
    });
  };

  ZoomableImage.prototype.render = function render() {
    var _props = this.props,
        alt = _props.alt,
        src = _props.src;
    var scale = this.state.scale;

    var overflow = scale === 1 ? 'hidden' : 'scroll';

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      {
        className: 'zoomable-image',
        ref: this.setContainerRef,
        style: { overflow: overflow }
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img', {
        role: 'presentation',
        ref: this.setImageRef,
        alt: alt,
        src: src,
        style: {
          transform: 'scale(' + scale + ')',
          transformOrigin: '0 0'
        },
        onClick: this.handleClick
      })
    );
  };

  return ZoomableImage;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.PureComponent), _class.defaultProps = {
  alt: '',
  width: null,
  height: null
}, _temp2);


/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VideoModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__video__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_immutable_pure_component__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_immutable_pure_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_immutable_pure_component__);





var _class, _temp;







var VideoModal = (_temp = _class = function (_ImmutablePureCompone) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(VideoModal, _ImmutablePureCompone);

  function VideoModal() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, VideoModal);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _ImmutablePureCompone.apply(this, arguments));
  }

  VideoModal.prototype.render = function render() {
    var _props = this.props,
        media = _props.media,
        time = _props.time,
        onClose = _props.onClose;


    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'modal-root__modal video-modal'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {}, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7__video__["default"], {
      preview: media.get('preview_url'),
      src: media.get('url'),
      startTime: time,
      onCloseVideo: onClose,
      detailed: true,
      description: media.get('description')
    })));
  };

  return VideoModal;
}(__WEBPACK_IMPORTED_MODULE_8_react_immutable_pure_component___default.a), _class.propTypes = {
  media: __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.map.isRequired,
  time: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  onClose: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired
}, _temp);


/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BoostModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_intl__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_button__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_status_content__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_avatar__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_relative_timestamp__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_display_name__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_immutable_pure_component__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_immutable_pure_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_immutable_pure_component__);





var _class, _class2, _temp2;












var messages = Object(__WEBPACK_IMPORTED_MODULE_7_react_intl__["f" /* defineMessages */])({
  reblog: {
    'id': 'status.reblog',
    'defaultMessage': 'Boost'
  }
});

var BoostModal = Object(__WEBPACK_IMPORTED_MODULE_7_react_intl__["g" /* injectIntl */])(_class = (_temp2 = _class2 = function (_ImmutablePureCompone) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(BoostModal, _ImmutablePureCompone);

  function BoostModal() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, BoostModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _ImmutablePureCompone.call.apply(_ImmutablePureCompone, [this].concat(args))), _this), _this.handleReblog = function () {
      _this.props.onReblog(_this.props.status);
      _this.props.onClose();
    }, _this.handleAccountClick = function (e) {
      if (e.button === 0) {
        e.preventDefault();
        _this.props.onClose();
        _this.context.router.history.push('/accounts/' + _this.props.status.getIn(['account', 'id']));
      }
    }, _this.setRef = function (c) {
      _this.button = c;
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  BoostModal.prototype.componentDidMount = function componentDidMount() {
    this.button.focus();
  };

  BoostModal.prototype.render = function render() {
    var _props = this.props,
        status = _props.status,
        intl = _props.intl;


    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'modal-root__modal boost-modal'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'boost-modal__container'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'status light'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'boost-modal__status-header'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'boost-modal__status-time'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('a', {
      href: status.get('url'),
      className: 'status__relative-time',
      target: '_blank',
      rel: 'noopener'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_11__components_relative_timestamp__["a" /* default */], {
      timestamp: status.get('created_at')
    }))), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('a', {
      onClick: this.handleAccountClick,
      href: status.getIn(['account', 'url']),
      className: 'status__display-name'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'status__avatar'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_10__components_avatar__["a" /* default */], {
      account: status.get('account'),
      size: 48
    })), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_12__components_display_name__["a" /* default */], {
      account: status.get('account')
    }))), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_9__components_status_content__["a" /* default */], {
      status: status
    }))), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'boost-modal__action-bar'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {}, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_7_react_intl__["b" /* FormattedMessage */], {
      id: 'boost_modal.combo',
      defaultMessage: 'You can press {combo} to skip this next time',
      values: { combo: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('span', {}, void 0, 'Shift + ', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('i', {
          className: 'fa fa-retweet'
        })) }
    })), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_button__["a" /* default */], { text: intl.formatMessage(messages.reblog), onClick: this.handleReblog, ref: this.setRef })));
  };

  return BoostModal;
}(__WEBPACK_IMPORTED_MODULE_13_react_immutable_pure_component___default.a), _class2.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object
}, _class2.propTypes = {
  status: __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.map.isRequired,
  onReblog: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  onClose: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
  intl: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object.isRequired
}, _temp2)) || _class;



/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConfirmationModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_intl__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_button__ = __webpack_require__(100);





var _class;






var ConfirmationModal = Object(__WEBPACK_IMPORTED_MODULE_5_react_intl__["g" /* injectIntl */])(_class = function (_React$PureComponent) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(ConfirmationModal, _React$PureComponent);

  function ConfirmationModal() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ConfirmationModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.handleClick = function () {
      _this.props.onClose();
      _this.props.onConfirm();
    }, _this.handleCancel = function () {
      _this.props.onClose();
    }, _this.setRef = function (c) {
      _this.button = c;
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  ConfirmationModal.prototype.componentDidMount = function componentDidMount() {
    this.button.focus();
  };

  ConfirmationModal.prototype.render = function render() {
    var _props = this.props,
        message = _props.message,
        confirm = _props.confirm;


    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'modal-root__modal confirmation-modal'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'confirmation-modal__container'
    }, void 0, message), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'confirmation-modal__action-bar'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_6__components_button__["a" /* default */], {
      onClick: this.handleCancel,
      className: 'confirmation-modal__cancel-button'
    }, void 0, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_5_react_intl__["b" /* FormattedMessage */], {
      id: 'confirmation_modal.cancel',
      defaultMessage: 'Cancel'
    })), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_button__["a" /* default */], { text: confirm, onClick: this.handleClick, ref: this.setRef })));
  };

  return ConfirmationModal;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.PureComponent)) || _class;



/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FocalPointModal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_immutable_pure_component__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_immutable_pure_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_immutable_pure_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_redux__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__image_loader__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_compose__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__video__ = __webpack_require__(75);





var _dec, _class, _class2, _temp2;










var mapStateToProps = function mapStateToProps(state, _ref) {
  var id = _ref.id;
  return {
    media: state.getIn(['compose', 'media_attachments']).find(function (item) {
      return item.get('id') === id;
    })
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, _ref2) {
  var id = _ref2.id;
  return {

    onSave: function onSave(x, y) {
      dispatch(Object(__WEBPACK_IMPORTED_MODULE_10__actions_compose__["L" /* changeUploadCompose */])(id, { focus: x.toFixed(2) + ',' + y.toFixed(2) }));
    }

  };
};

var FocalPointModal = (_dec = Object(__WEBPACK_IMPORTED_MODULE_7_react_redux__["connect"])(mapStateToProps, mapDispatchToProps), _dec(_class = (_temp2 = _class2 = function (_ImmutablePureCompone) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(FocalPointModal, _ImmutablePureCompone);

  function FocalPointModal() {
    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, FocalPointModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _ImmutablePureCompone.call.apply(_ImmutablePureCompone, [this].concat(args))), _this), _this.state = {
      x: 0,
      y: 0,
      focusX: 0,
      focusY: 0,
      dragging: false
    }, _this.handleMouseDown = function (e) {
      document.addEventListener('mousemove', _this.handleMouseMove);
      document.addEventListener('mouseup', _this.handleMouseUp);

      _this.updatePosition(e);
      _this.setState({ dragging: true });
    }, _this.handleMouseMove = function (e) {
      _this.updatePosition(e);
    }, _this.handleMouseUp = function () {
      document.removeEventListener('mousemove', _this.handleMouseMove);
      document.removeEventListener('mouseup', _this.handleMouseUp);

      _this.setState({ dragging: false });
      _this.props.onSave(_this.state.focusX, _this.state.focusY);
    }, _this.updatePosition = function (e) {
      var _getPointerPosition = Object(__WEBPACK_IMPORTED_MODULE_11__video__["getPointerPosition"])(_this.node, e),
          x = _getPointerPosition.x,
          y = _getPointerPosition.y;

      var focusX = (x - .5) * 2;
      var focusY = (y - .5) * -2;

      _this.setState({ x: x, y: y, focusX: focusX, focusY: focusY });
    }, _this.updatePositionFromMedia = function (media) {
      var focusX = media.getIn(['meta', 'focus', 'x']);
      var focusY = media.getIn(['meta', 'focus', 'y']);

      if (focusX && focusY) {
        var x = focusX / 2 + .5;
        var y = focusY / -2 + .5;

        _this.setState({ x: x, y: y, focusX: focusX, focusY: focusY });
      } else {
        _this.setState({ x: 0.5, y: 0.5, focusX: 0, focusY: 0 });
      }
    }, _this.setRef = function (c) {
      _this.node = c;
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  FocalPointModal.prototype.componentWillMount = function componentWillMount() {
    this.updatePositionFromMedia(this.props.media);
  };

  FocalPointModal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.media.get('id') !== nextProps.media.get('id')) {
      this.updatePositionFromMedia(nextProps.media);
    }
  };

  FocalPointModal.prototype.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('mousemove', this.handleMouseMove);
    document.removeEventListener('mouseup', this.handleMouseUp);
  };

  FocalPointModal.prototype.render = function render() {
    var media = this.props.media;
    var _state = this.state,
        x = _state.x,
        y = _state.y,
        dragging = _state.dragging;


    var width = media.getIn(['meta', 'original', 'width']) || null;
    var height = media.getIn(['meta', 'original', 'height']) || null;

    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
      className: 'modal-root__modal video-modal focal-point-modal'
    }, void 0, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      { className: __WEBPACK_IMPORTED_MODULE_9_classnames___default()('focal-point', { dragging: dragging }), ref: this.setRef },
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()(__WEBPACK_IMPORTED_MODULE_8__image_loader__["a" /* default */], {
        previewSrc: media.get('preview_url'),
        src: media.get('url'),
        width: width,
        height: height
      }),
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
        className: 'focal-point__reticle',
        style: { top: y * 100 + '%', left: x * 100 + '%' }
      }),
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_jsx___default()('div', {
        className: 'focal-point__overlay',
        onMouseDown: this.handleMouseDown
      })
    ));
  };

  return FocalPointModal;
}(__WEBPACK_IMPORTED_MODULE_6_react_immutable_pure_component___default.a), _class2.propTypes = {
  media: __WEBPACK_IMPORTED_MODULE_5_react_immutable_proptypes___default.a.map.isRequired
}, _temp2)) || _class);


/***/ }),
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _notification = __webpack_require__(249);

Object.defineProperty(exports, 'Notification', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_notification).default;
  }
});

var _notificationStack = __webpack_require__(682);

Object.defineProperty(exports, 'NotificationStack', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_notificationStack).default;
  }
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
}; /* eslint-disable react/jsx-no-bind */

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(5);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _stackedNotification = __webpack_require__(683);

var _stackedNotification2 = _interopRequireDefault(_stackedNotification);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function defaultBarStyleFactory(index, style) {
  return _extends({}, style, { bottom: 2 + index * 4 + 'rem' });
}

function defaultActionStyleFactory(index, style) {
  return _extends({}, style, {});
}

/**
* The notification list does not have any state, so use a
* pure function here. It just needs to return the stacked array
* of notification components.
*/
var NotificationStack = function NotificationStack(props) {
  return _react2.default.createElement('div', { className: 'notification-list' }, props.notifications.map(function (notification, index) {
    var isLast = index === 0 && props.notifications.length === 1;
    var dismissNow = isLast || !props.dismissInOrder;

    // Handle styles
    var barStyle = props.barStyleFactory(index, notification.barStyle, notification);
    var actionStyle = props.actionStyleFactory(index, notification.actionStyle, notification);
    var activeBarStyle = props.activeBarStyleFactory(index, notification.activeBarStyle, notification);

    // Allow onClick from notification stack or individual notifications
    var onClick = notification.onClick || props.onClick;
    var onDismiss = props.onDismiss;

    var dismissAfter = notification.dismissAfter;

    if (dismissAfter !== false) {
      if (dismissAfter == null) dismissAfter = props.dismissAfter;
      if (!dismissNow) dismissAfter += index * 1000;
    }

    return _react2.default.createElement(_stackedNotification2.default, _extends({}, notification, {
      key: notification.key,
      isLast: isLast,
      action: notification.action || props.action,
      dismissAfter: dismissAfter,
      onDismiss: onDismiss.bind(undefined, notification),
      onClick: onClick.bind(undefined, notification),
      activeBarStyle: activeBarStyle,
      barStyle: barStyle,
      actionStyle: actionStyle
    }));
  }));
};

/* eslint-disable react/no-unused-prop-types, react/forbid-prop-types */
NotificationStack.propTypes = {
  activeBarStyleFactory: _propTypes2.default.func,
  barStyleFactory: _propTypes2.default.func,
  actionStyleFactory: _propTypes2.default.func,
  dismissInOrder: _propTypes2.default.bool,
  notifications: _propTypes2.default.array.isRequired,
  onDismiss: _propTypes2.default.func.isRequired,
  onClick: _propTypes2.default.func,
  action: _propTypes2.default.string
};

NotificationStack.defaultProps = {
  activeBarStyleFactory: defaultBarStyleFactory,
  barStyleFactory: defaultBarStyleFactory,
  actionStyleFactory: defaultActionStyleFactory,
  dismissInOrder: true,
  dismissAfter: 1000,
  onClick: function onClick() {}
};
/* eslint-enable no-alert, no-console */

exports.default = NotificationStack;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _defaultPropTypes = __webpack_require__(250);

var _defaultPropTypes2 = _interopRequireDefault(_defaultPropTypes);

var _notification = __webpack_require__(249);

var _notification2 = _interopRequireDefault(_notification);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var StackedNotification = function (_Component) {
  _inherits(StackedNotification, _Component);

  function StackedNotification(props) {
    _classCallCheck(this, StackedNotification);

    var _this = _possibleConstructorReturn(this, (StackedNotification.__proto__ || Object.getPrototypeOf(StackedNotification)).call(this, props));

    _this.state = {
      isActive: false
    };

    _this.handleClick = _this.handleClick.bind(_this);
    return _this;
  }

  _createClass(StackedNotification, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.activeTimeout = setTimeout(this.setState.bind(this, {
        isActive: true
      }), 1);

      this.dismiss(this.props.dismissAfter);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.dismissAfter !== this.props.dismissAfter) {
        this.dismiss(nextProps.dismissAfter);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.activeTimeout);
      clearTimeout(this.dismissTimeout);
    }
  }, {
    key: 'dismiss',
    value: function dismiss(dismissAfter) {
      if (dismissAfter === false) return;

      this.dismissTimeout = setTimeout(this.setState.bind(this, {
        isActive: false
      }), dismissAfter);
    }

    /*
    * @function handleClick
    * @description Bind deactivate Notification function to Notification click handler
    */

  }, {
    key: 'handleClick',
    value: function handleClick() {
      if (this.props.onClick && typeof this.props.onClick === 'function') {
        return this.props.onClick(this.setState.bind(this, { isActive: false }));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(_notification2.default, _extends({}, this.props, {
        onClick: this.handleClick,
        onDismiss: function onDismiss() {
          return setTimeout(_this2.props.onDismiss, 300);
        },
        isActive: this.state.isActive
      }));
    }
  }]);

  return StackedNotification;
}(_react.Component);

StackedNotification.propTypes = _defaultPropTypes2.default;

exports.default = StackedNotification;

/***/ }),
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rails_ujs__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rails_ujs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_rails_ujs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_font_awesome_css_font_awesome_css__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_font_awesome_css_font_awesome_css__);



__webpack_require__(693);

Object(__WEBPACK_IMPORTED_MODULE_0_rails_ujs__["start"])();

/***/ }),
/* 692 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./elephant-fren": 255,
	"./elephant-fren.png": 255,
	"./elephant_ui_disappointed": 256,
	"./elephant_ui_disappointed.svg": 256,
	"./elephant_ui_greeting": 257,
	"./elephant_ui_greeting.svg": 257,
	"./elephant_ui_plane": 165,
	"./elephant_ui_plane.svg": 165,
	"./elephant_ui_working": 258,
	"./elephant_ui_working.svg": 258,
	"./icon_cached": 259,
	"./icon_cached.svg": 259,
	"./icon_done": 260,
	"./icon_done.svg": 260,
	"./icon_email": 261,
	"./icon_email.svg": 261,
	"./icon_file_download": 262,
	"./icon_file_download.svg": 262,
	"./icon_grade": 263,
	"./icon_grade.svg": 263,
	"./icon_lock_open": 264,
	"./icon_lock_open.svg": 264,
	"./icon_person_add": 265,
	"./icon_person_add.svg": 265,
	"./icon_reply": 266,
	"./icon_reply.svg": 266,
	"./logo": 267,
	"./logo.svg": 267,
	"./logo_alt": 268,
	"./logo_alt.svg": 268,
	"./logo_full": 269,
	"./logo_full.svg": 269,
	"./logo_transparent": 270,
	"./logo_transparent.svg": 270,
	"./mailer/icon_cached": 271,
	"./mailer/icon_cached.png": 271,
	"./mailer/icon_done": 272,
	"./mailer/icon_done.png": 272,
	"./mailer/icon_email": 273,
	"./mailer/icon_email.png": 273,
	"./mailer/icon_file_download": 274,
	"./mailer/icon_file_download.png": 274,
	"./mailer/icon_grade": 275,
	"./mailer/icon_grade.png": 275,
	"./mailer/icon_lock_open": 276,
	"./mailer/icon_lock_open.png": 276,
	"./mailer/icon_person_add": 277,
	"./mailer/icon_person_add.png": 277,
	"./mailer/icon_reply": 278,
	"./mailer/icon_reply.png": 278,
	"./mailer/logo_full": 279,
	"./mailer/logo_full.png": 279,
	"./mailer/logo_transparent": 280,
	"./mailer/logo_transparent.png": 280,
	"./preview": 281,
	"./preview.jpg": 281,
	"./reticle": 282,
	"./reticle.png": 282,
	"./void": 283,
	"./void.png": 283
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 693;

/***/ }),
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roboto-italic-webfont-50efdad8c62f5f279e3f4f1f63a4f9bc.woff2";

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roboto-italic-webfont-927fdbf83b347742d39f0b00f3cfa99a.woff";

/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roboto-italic-webfont-4c71bd4a88468ea62f92e55cb4e33aef.ttf";

/***/ }),
/* 863 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roboto-italic-webfont-d88a9e8476fabedea3b87fd0ba2df3b3.svg";

/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roboto-bold-webfont-f633cb5c651ba4d50791e1adf55d3c18.woff2";

/***/ }),
/* 865 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roboto-bold-webfont-df0f5fd966b99c0f503ae50c064fbba8.woff";

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roboto-bold-webfont-5bacc29257521cc73732f2597cc19c4b.ttf";

/***/ }),
/* 867 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roboto-bold-webfont-4cbd1966fc397282fa35d69070782b80.svg";

/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roboto-medium-webfont-69c55fc2fe77d38934ea98dc31642ce6.woff2";

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roboto-medium-webfont-6484794cd05bbf97f3f0c730cec21665.woff";

/***/ }),
/* 870 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roboto-medium-webfont-7f0e4c7727a4bc5f37d95d804c6e0348.ttf";

/***/ }),
/* 871 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roboto-medium-webfont-f407ec033f15172c3c4acf75608dd11d.svg";

/***/ }),
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roboto-regular-webfont-3ec24f953ed5e859a6402cb3c030ea8b.woff2";

/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roboto-regular-webfont-b06ad091cf548c38401f3e5883cb36a2.woff";

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roboto-regular-webfont-42a434b9f3c8c7a57b83488483b2d08e.ttf";

/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "roboto-regular-webfont-77dc6a0145954a963b95d30773543105.svg";

/***/ }),
/* 876 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "robotomono-regular-webfont-6c1ce30b90ee993b22618ec489585594.woff2";

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "robotomono-regular-webfont-09e0ef66c9dee2fa2689f6e5f2437670.woff";

/***/ }),
/* 878 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "robotomono-regular-webfont-0ba95b3b2370e6bf1dcdb20aa3a54ff2.ttf";

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "robotomono-regular-webfont-51e9ccf8c829f4894a7e5a0883e864fc.svg";

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Montserrat-Regular-080422d4c1328f3407818d25c86cce51.woff2";

/***/ }),
/* 881 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Montserrat-Regular-b0322f2faed575161a052b5af953251a.woff";

/***/ }),
/* 882 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Montserrat-Regular-6a18f75e59e23e7f23b8a4ef70d748cd.ttf";

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "Montserrat-Medium-5f797490f806b3b229299f0a66de89c9.ttf";

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// common-a9a4957a52f15d56468f.js